/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		7: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"app","1":"widget","2":"modal"}[chunkId]||chunkId) + ".chunk.min.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withTranslate;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactI18next = __webpack_require__(34);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _createHocName = __webpack_require__(41);

var _createHocName2 = _interopRequireDefault(_createHocName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAME = 'WithTranslate';

function withTranslate(WrappedComponent) {
  var WithTranslate = function (_Component) {
    _inherits(WithTranslate, _Component);

    function WithTranslate() {
      _classCallCheck(this, WithTranslate);

      return _possibleConstructorReturn(this, (WithTranslate.__proto__ || Object.getPrototypeOf(WithTranslate)).apply(this, arguments));
    }

    _createClass(WithTranslate, [{
      key: 'render',
      value: function render() {
        var props = _lodash2.default.omit(this.props, ['i18nLoadedAt', 'i18n']);
        return _react2.default.createElement(WrappedComponent, props);
      }
    }]);

    return WithTranslate;
  }(_react.Component);

  WithTranslate.displayName = (0, _createHocName2.default)(NAME, WrappedComponent);


  (0, _hoistNonReactStatics2.default)(WithTranslate, WrappedComponent);

  return (0, _reactI18next.translate)(['translation'])(WithTranslate);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(381);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(382);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/lodash-es/_freeGlobal.js
var _freeGlobal = __webpack_require__(378);

// CONCATENATED MODULE: ../node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

// CONCATENATED MODULE: ../node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (Symbol);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ../node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ../node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ../node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ../node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ../node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ../node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// EXTERNAL MODULE: ../node_modules/redux/node_modules/symbol-observable/index.js
var symbol_observable = __webpack_require__(297);
var symbol_observable_default = /*#__PURE__*/__webpack_require__.n(symbol_observable);

// CONCATENATED MODULE: ../node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!lodash_es_isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[symbol_observable_default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[symbol_observable_default.a] = observable, _ref2;
}
// CONCATENATED MODULE: ../node_modules/redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning_warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ../node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!lodash_es_isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ../node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
// CONCATENATED MODULE: ../node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ../node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createAction = __webpack_require__(443);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _createAction2.default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instanceId = undefined;

var _isInWix = __webpack_require__(77);

var wixInstanceId = '33750584-5cda-44e1-8738-62a9139347b3';

var WixPolyfill = {
  addEventListener: function addEventListener() {},
  isApplicationInstalled: function isApplicationInstalled(appId, cb) {
    return cb(false);
  },
  removeEventListener: function removeEventListener() {},
  currentMember: function currentMember(cb) {
    return cb(null);
  },
  requestLogin: function requestLogin() {},
  logOutCurrentMember: function logOutCurrentMember() {},
  replaceSectionState: function replaceSectionState() {},
  closeWindow: function closeWindow() {},
  setHeight: function setHeight() {},
  resizeComponent: function resizeComponent() {},
  WindowOrigin: {},
  WindowPlacement: {},
  getCurrentPageId: function getCurrentPageId(cb) {
    return cb('pageId');
  },
  getSitePages: function getSitePages() {
    return [{ id: '/' }];
  },
  getSiteInfo: function getSiteInfo() {},
  navigateToPage: function navigateToPage() {},
  scrollTo: function scrollTo() {},
  setPageMetadata: function setPageMetadata() {},
  getSiteMap: function getSiteMap(cb) {
    return cb([]);
  },
  getPublicAPI: function getPublicAPI() {},
  getSiteTextPresets: function getSiteTextPresets() {},
  Events: {},
  PubSub: {
    publish: function publish() {},
    subscribe: function subscribe() {}
  },
  openPopup: function openPopup() {},
  Utils: {
    getUid: function getUid() {
      return '00000000-0000-0000-0000-000000000001';
    },
    getSectionUrl: function getSectionUrl() {
      return window.location.protocol + '//' + window.location.host + '/';
    },
    getInstanceId: function getInstanceId() {
      return wixInstanceId;
    },
    getInstanceValue: function getInstanceValue() {
      return '00000000-0000-0000-0000-000000000000';
    },
    getViewMode: function getViewMode() {
      return '';
    },
    navigateToSection: function navigateToSection() {}
  },
  Performance: {
    applicationLoaded: function applicationLoaded() {},
    applicationLoadingStep: function applicationLoadingStep() {}
  },
  Theme: {
    BARE: 0
  },
  Styles: {
    getSiteTextPresets: function getSiteTextPresets() {}
  }
};

var instanceId = exports.instanceId = wixInstanceId;

exports.default = typeof window !== 'undefined' ? (0, _isInWix.isInWix)() ? window.Wix || WixPolyfill : WixPolyfill : WixPolyfill;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alertIcon = __webpack_require__(461);

Object.keys(_alertIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _alertIcon[key];
    }
  });
});

var _arrowBackIcon = __webpack_require__(462);

Object.keys(_arrowBackIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _arrowBackIcon[key];
    }
  });
});

var _arrowBreadCrumbsLeftIcon = __webpack_require__(463);

Object.keys(_arrowBreadCrumbsLeftIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _arrowBreadCrumbsLeftIcon[key];
    }
  });
});

var _arrowBreadCrumbsRightIcon = __webpack_require__(464);

Object.keys(_arrowBreadCrumbsRightIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _arrowBreadCrumbsRightIcon[key];
    }
  });
});

var _arrowDownIcon = __webpack_require__(465);

Object.keys(_arrowDownIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _arrowDownIcon[key];
    }
  });
});

var _arrowLeftIcon = __webpack_require__(466);

Object.keys(_arrowLeftIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _arrowLeftIcon[key];
    }
  });
});

var _arrowRightIcon = __webpack_require__(467);

Object.keys(_arrowRightIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _arrowRightIcon[key];
    }
  });
});

var _arrowUpIcon = __webpack_require__(468);

Object.keys(_arrowUpIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _arrowUpIcon[key];
    }
  });
});

var _blockIcon = __webpack_require__(469);

Object.keys(_blockIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _blockIcon[key];
    }
  });
});

var _cameraIcon = __webpack_require__(470);

Object.keys(_cameraIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cameraIcon[key];
    }
  });
});

var _checkMarkIcon = __webpack_require__(471);

Object.keys(_checkMarkIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkMarkIcon[key];
    }
  });
});

var _commentIcon = __webpack_require__(472);

Object.keys(_commentIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _commentIcon[key];
    }
  });
});

var _crownIcon = __webpack_require__(473);

Object.keys(_crownIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _crownIcon[key];
    }
  });
});

var _deleteIcon = __webpack_require__(474);

Object.keys(_deleteIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _deleteIcon[key];
    }
  });
});

var _discardIcon = __webpack_require__(475);

Object.keys(_discardIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _discardIcon[key];
    }
  });
});

var _dragIcon = __webpack_require__(476);

Object.keys(_dragIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dragIcon[key];
    }
  });
});

var _editIcon = __webpack_require__(477);

Object.keys(_editIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _editIcon[key];
    }
  });
});

var _emojiIcon = __webpack_require__(478);

Object.keys(_emojiIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _emojiIcon[key];
    }
  });
});

var _eyeIcon = __webpack_require__(479);

Object.keys(_eyeIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _eyeIcon[key];
    }
  });
});

var _facebookIcon = __webpack_require__(480);

Object.keys(_facebookIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _facebookIcon[key];
    }
  });
});

var _followMemberIcon = __webpack_require__(481);

Object.keys(_followMemberIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _followMemberIcon[key];
    }
  });
});

var _followingIcon = __webpack_require__(482);

Object.keys(_followingIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _followingIcon[key];
    }
  });
});

var _fontIcon = __webpack_require__(483);

Object.keys(_fontIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fontIcon[key];
    }
  });
});

var _gPlusIcon = __webpack_require__(484);

Object.keys(_gPlusIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gPlusIcon[key];
    }
  });
});

var _homeIcon = __webpack_require__(485);

Object.keys(_homeIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _homeIcon[key];
    }
  });
});

var _likeHollowIcon = __webpack_require__(486);

Object.keys(_likeHollowIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _likeHollowIcon[key];
    }
  });
});

var _likeIcon = __webpack_require__(487);

Object.keys(_likeIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _likeIcon[key];
    }
  });
});

var _linkIcon = __webpack_require__(488);

Object.keys(_linkIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _linkIcon[key];
    }
  });
});

var _lockIcon = __webpack_require__(489);

Object.keys(_lockIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lockIcon[key];
    }
  });
});

var _logoutIcon = __webpack_require__(490);

Object.keys(_logoutIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _logoutIcon[key];
    }
  });
});

var _memberIcon = __webpack_require__(491);

Object.keys(_memberIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _memberIcon[key];
    }
  });
});

var _menuIcon = __webpack_require__(492);

Object.keys(_menuIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _menuIcon[key];
    }
  });
});

var _minusIcon = __webpack_require__(493);

Object.keys(_minusIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _minusIcon[key];
    }
  });
});

var _moderatorIcon = __webpack_require__(494);

Object.keys(_moderatorIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _moderatorIcon[key];
    }
  });
});

var _moderatorSmallIcon = __webpack_require__(495);

Object.keys(_moderatorSmallIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _moderatorSmallIcon[key];
    }
  });
});

var _moreIcon = __webpack_require__(496);

Object.keys(_moreIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _moreIcon[key];
    }
  });
});

var _moveIcon = __webpack_require__(497);

Object.keys(_moveIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _moveIcon[key];
    }
  });
});

var _notificationIcon = __webpack_require__(498);

Object.keys(_notificationIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _notificationIcon[key];
    }
  });
});

var _ownerSmallIcon = __webpack_require__(499);

Object.keys(_ownerSmallIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ownerSmallIcon[key];
    }
  });
});

var _pinIcon = __webpack_require__(500);

Object.keys(_pinIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pinIcon[key];
    }
  });
});

var _playArrow = __webpack_require__(501);

Object.keys(_playArrow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _playArrow[key];
    }
  });
});

var _playIcon = __webpack_require__(502);

Object.keys(_playIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _playIcon[key];
    }
  });
});

var _profileIcon = __webpack_require__(503);

Object.keys(_profileIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _profileIcon[key];
    }
  });
});

var _reportIcon = __webpack_require__(504);

Object.keys(_reportIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _reportIcon[key];
    }
  });
});

var _searchIcon = __webpack_require__(505);

Object.keys(_searchIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _searchIcon[key];
    }
  });
});

var _secondaryEditIcon = __webpack_require__(506);

Object.keys(_secondaryEditIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _secondaryEditIcon[key];
    }
  });
});

var _settingsIcon = __webpack_require__(507);

Object.keys(_settingsIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _settingsIcon[key];
    }
  });
});

var _shareIcon = __webpack_require__(508);

Object.keys(_shareIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _shareIcon[key];
    }
  });
});

var _sortIcon = __webpack_require__(509);

Object.keys(_sortIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sortIcon[key];
    }
  });
});

var _subscribeIcon = __webpack_require__(510);

Object.keys(_subscribeIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _subscribeIcon[key];
    }
  });
});

var _topCommentIcon = __webpack_require__(511);

Object.keys(_topCommentIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _topCommentIcon[key];
    }
  });
});

var _twitterIcon = __webpack_require__(512);

Object.keys(_twitterIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _twitterIcon[key];
    }
  });
});

var _videoIcon = __webpack_require__(513);

Object.keys(_videoIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _videoIcon[key];
    }
  });
});

var _viewCountIcon = __webpack_require__(514);

Object.keys(_viewCountIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _viewCountIcon[key];
    }
  });
});

var _xLarge = __webpack_require__(515);

Object.keys(_xLarge).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _xLarge[key];
    }
  });
});

var _xSmall = __webpack_require__(516);

Object.keys(_xSmall).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _xSmall[key];
    }
  });
});

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withFontClassName;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _wixParams = __webpack_require__(24);

var params = _interopRequireWildcard(_wixParams);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _getDisplayName = __webpack_require__(48);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _getLayoutName = __webpack_require__(223);

var _getLayoutName2 = _interopRequireDefault(_getLayoutName);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withFontClassName(WrappedComponent) {
  var _class, _temp;

  var Wrapper = (_temp = _class = function (_Component) {
    _inherits(Wrapper, _Component);

    function Wrapper() {
      _classCallCheck(this, Wrapper);

      return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
    }

    _createClass(Wrapper, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            layoutType = _props.layoutType,
            cardSize = _props.cardSize,
            siteColors = _props.siteColors,
            otherProps = _objectWithoutProperties(_props, ['layoutType', 'cardSize', 'siteColors']);

        var layoutName = (0, _getLayoutName2.default)(layoutType, cardSize);
        var fontClassNames = {
          titleFontClassName: 'forum-title-' + layoutName + '-font',
          contentFontClassName: 'forum-content-' + layoutName + '-font'
        };

        return _react2.default.createElement(WrappedComponent, _extends({}, otherProps, fontClassNames));
      }
    }]);

    return Wrapper;
  }(_react.Component), _class.displayName = 'WithFontClassNames(' + (0, _getDisplayName2.default)(WrappedComponent) + ')', _class.propTypes = {
    layoutType: _propTypes2.default.number,
    cardSize: _propTypes2.default.number,
    siteColors: _propTypes2.default.object
  }, _temp);

  (0, _hoistNonReactStatics2.default)(Wrapper, WrappedComponent);

  return (0, _withAppSettings2.default)({
    layoutType: params.LAYOUT_TYPE_PATH,
    cardSize: params.CARD_SIZE_PATH
  })(Wrapper);
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = undefined;

var _wixSdkUtils = __webpack_require__(21);

var _hideModal = __webpack_require__(152);

var _closeWixModal = __webpack_require__(635);

var _isInWix = __webpack_require__(77);

var closeModal = exports.closeModal = function closeModal(payload) {
  return function (dispatch) {
    var action = (0, _hideModal.hideModal)(payload);

    if (!(0, _wixSdkUtils.isMobile)() && (0, _isInWix.isInWix)()) {
      action = (0, _closeWixModal.closeWixModal)(action);
    }

    dispatch(action);
  };
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _modal = __webpack_require__(622);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _modal2.default;

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this._output('log', args);
  },
  warn: function warn(args) {
    this._output('warn', args);
  },
  error: function error(args) {
    this._output('error', args);
  },
  _output: function _output(type, args) {
    if (console && console[type]) console[type].apply(console, Array.prototype.slice.call(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.subs = [];
    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug === false ? false : true;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
    this.subs.forEach(function (sub) {
      sub.setDebug(bool);
    });
  };

  Logger.prototype.log = function log() {
    this.forward(arguments, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    this.forward(arguments, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    this.forward(arguments, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    this.forward(arguments, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return;
    if (typeof args[0] === 'string') args[0] = prefix + this.prefix + ' ' + args[0];
    this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    var sub = new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
    this.subs.push(sub);

    return sub;
  };

  // createInstance(options = {}) {
  //   return new Logger(options, callback);
  // }

  return Logger;
}();

;

exports.default = new Logger();

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _separator = __webpack_require__(649);

Object.defineProperty(exports, 'HorizontalSeparator', {
  enumerable: true,
  get: function get() {
    return _separator.HorizontalSeparator;
  }
});
Object.defineProperty(exports, 'VerticalSeparator', {
  enumerable: true,
  get: function get() {
    return _separator.VerticalSeparator;
  }
});
Object.defineProperty(exports, 'BulletSeparator', {
  enumerable: true,
  get: function get() {
    return _separator.BulletSeparator;
  }
});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.0
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */
(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory(__webpack_require__(257), __webpack_require__(258), __webpack_require__(259));
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(257), __webpack_require__(258), __webpack_require__(259)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
  }
}(this, function (punycode, IPv6, SLD, root) {
  'use strict';
  /*global location, escape, unescape */
  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
  /*jshint camelcase: false */

  // save current URI variable, if any
  var _URI = root && root.URI;

  function URI(url, base) {
    var _urlSupplied = arguments.length >= 1;
    var _baseSupplied = arguments.length >= 2;

    // Allow instantiation without the 'new' keyword
    if (!(this instanceof URI)) {
      if (_urlSupplied) {
        if (_baseSupplied) {
          return new URI(url, base);
        }

        return new URI(url);
      }

      return new URI();
    }

    if (url === undefined) {
      if (_urlSupplied) {
        throw new TypeError('undefined is not a valid argument for URI');
      }

      if (typeof location !== 'undefined') {
        url = location.href + '';
      } else {
        url = '';
      }
    }

    if (url === null) {
      if (_urlSupplied) {
        throw new TypeError('null is not a valid argument for URI');
      }
    }

    this.href(url);

    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
    if (base !== undefined) {
      return this.absoluteTo(base);
    }

    return this;
  }

  function isInteger(value) {
    return /^[0-9]+$/.test(value);
  }

  URI.version = '1.19.0';

  var p = URI.prototype;
  var hasOwn = Object.prototype.hasOwnProperty;

  function escapeRegEx(string) {
    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }

  function getType(value) {
    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
    if (value === undefined) {
      return 'Undefined';
    }

    return String(Object.prototype.toString.call(value)).slice(8, -1);
  }

  function isArray(obj) {
    return getType(obj) === 'Array';
  }

  function filterArrayValues(data, value) {
    var lookup = {};
    var i, length;

    if (getType(value) === 'RegExp') {
      lookup = null;
    } else if (isArray(value)) {
      for (i = 0, length = value.length; i < length; i++) {
        lookup[value[i]] = true;
      }
    } else {
      lookup[value] = true;
    }

    for (i = 0, length = data.length; i < length; i++) {
      /*jshint laxbreak: true */
      var _match = lookup && lookup[data[i]] !== undefined
        || !lookup && value.test(data[i]);
      /*jshint laxbreak: false */
      if (_match) {
        data.splice(i, 1);
        length--;
        i--;
      }
    }

    return data;
  }

  function arrayContains(list, value) {
    var i, length;

    // value may be string, number, array, regexp
    if (isArray(value)) {
      // Note: this can be optimized to O(n) (instead of current O(m * n))
      for (i = 0, length = value.length; i < length; i++) {
        if (!arrayContains(list, value[i])) {
          return false;
        }
      }

      return true;
    }

    var _type = getType(value);
    for (i = 0, length = list.length; i < length; i++) {
      if (_type === 'RegExp') {
        if (typeof list[i] === 'string' && list[i].match(value)) {
          return true;
        }
      } else if (list[i] === value) {
        return true;
      }
    }

    return false;
  }

  function arraysEqual(one, two) {
    if (!isArray(one) || !isArray(two)) {
      return false;
    }

    // arrays can't be equal if they have different amount of content
    if (one.length !== two.length) {
      return false;
    }

    one.sort();
    two.sort();

    for (var i = 0, l = one.length; i < l; i++) {
      if (one[i] !== two[i]) {
        return false;
      }
    }

    return true;
  }

  function trimSlashes(text) {
    var trim_expression = /^\/+|\/+$/g;
    return text.replace(trim_expression, '');
  }

  URI._parts = function() {
    return {
      protocol: null,
      username: null,
      password: null,
      hostname: null,
      urn: null,
      port: null,
      path: null,
      query: null,
      fragment: null,
      // state
      preventInvalidHostname: URI.preventInvalidHostname,
      duplicateQueryParameters: URI.duplicateQueryParameters,
      escapeQuerySpace: URI.escapeQuerySpace
    };
  };
  // state: throw on invalid hostname
  // see https://github.com/medialize/URI.js/pull/345
  // and https://github.com/medialize/URI.js/issues/354
  URI.preventInvalidHostname = false;
  // state: allow duplicate query parameters (a=1&a=1)
  URI.duplicateQueryParameters = false;
  // state: replaces + with %20 (space in query strings)
  URI.escapeQuerySpace = true;
  // static properties
  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
  URI.idn_expression = /[^a-z0-9\._-]/i;
  URI.punycode_expression = /(xn--)/i;
  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  // credits to Rich Brown
  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
  // specification: http://www.ietf.org/rfc/rfc4291.txt
  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  // expression used is "gruber revised" (@gruber v2) determined to be the
  // best solution in a regex-golf we did a couple of ages ago at
  // * http://mathiasbynens.be/demo/url-regex
  // * http://rodneyrehm.de/t/url-regex.html
  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
  URI.findUri = {
    // valid "scheme://" or "www."
    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
  };
  // http://www.iana.org/assignments/uri-schemes.html
  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
  URI.defaultPorts = {
    http: '80',
    https: '443',
    ftp: '21',
    gopher: '70',
    ws: '80',
    wss: '443'
  };
  // list of protocols which always require a hostname
  URI.hostProtocols = [
    'http',
    'https'
  ];

  // allowed hostname characters according to RFC 3986
  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
  // map DOM Elements to their URI attribute
  URI.domAttributes = {
    'a': 'href',
    'blockquote': 'cite',
    'link': 'href',
    'base': 'href',
    'script': 'src',
    'form': 'action',
    'img': 'src',
    'area': 'href',
    'iframe': 'src',
    'embed': 'src',
    'source': 'src',
    'track': 'src',
    'input': 'src', // but only if type="image"
    'audio': 'src',
    'video': 'src'
  };
  URI.getDomAttribute = function(node) {
    if (!node || !node.nodeName) {
      return undefined;
    }

    var nodeName = node.nodeName.toLowerCase();
    // <input> should only expose src for type="image"
    if (nodeName === 'input' && node.type !== 'image') {
      return undefined;
    }

    return URI.domAttributes[nodeName];
  };

  function escapeForDumbFirefox36(value) {
    // https://github.com/medialize/URI.js/issues/91
    return escape(value);
  }

  // encoding / decoding according to RFC3986
  function strictEncodeURIComponent(string) {
    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
    return encodeURIComponent(string)
      .replace(/[!'()*]/g, escapeForDumbFirefox36)
      .replace(/\*/g, '%2A');
  }
  URI.encode = strictEncodeURIComponent;
  URI.decode = decodeURIComponent;
  URI.iso8859 = function() {
    URI.encode = escape;
    URI.decode = unescape;
  };
  URI.unicode = function() {
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
  };
  URI.characters = {
    pathname: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
        map: {
          // -._~!'()*
          '%24': '$',
          '%26': '&',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%3A': ':',
          '%40': '@'
        }
      },
      decode: {
        expression: /[\/\?#]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23'
        }
      }
    },
    reserved: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
        map: {
          // gen-delims
          '%3A': ':',
          '%2F': '/',
          '%3F': '?',
          '%23': '#',
          '%5B': '[',
          '%5D': ']',
          '%40': '@',
          // sub-delims
          '%21': '!',
          '%24': '$',
          '%26': '&',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '='
        }
      }
    },
    urnpath: {
      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
      // note that the colon character is not featured in the encoding map; this is because URI.js
      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
      // should not appear unencoded in a segment itself.
      // See also the note above about RFC3986 and capitalalized hex digits.
      encode: {
        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
        map: {
          '%21': '!',
          '%24': '$',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%40': '@'
        }
      },
      // These characters are the characters called out by RFC2141 as "reserved" characters that
      // should never appear in a URN, plus the colon character (see note above).
      decode: {
        expression: /[\/\?#:]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23',
          ':': '%3A'
        }
      }
    }
  };
  URI.encodeQuery = function(string, escapeQuerySpace) {
    var escaped = URI.encode(string + '');
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
  };
  URI.decodeQuery = function(string, escapeQuerySpace) {
    string += '';
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    try {
      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
    } catch(e) {
      // we're not going to mess with weird encodings,
      // give up and return the undecoded original string
      // see https://github.com/medialize/URI.js/issues/87
      // see https://github.com/medialize/URI.js/issues/92
      return string;
    }
  };
  // generate encode/decode path functions
  var _parts = {'encode':'encode', 'decode':'decode'};
  var _part;
  var generateAccessor = function(_group, _part) {
    return function(string) {
      try {
        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
          return URI.characters[_group][_part].map[c];
        });
      } catch (e) {
        // we're not going to mess with weird encodings,
        // give up and return the undecoded original string
        // see https://github.com/medialize/URI.js/issues/87
        // see https://github.com/medialize/URI.js/issues/92
        return string;
      }
    };
  };

  for (_part in _parts) {
    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
  }

  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
    return function(string) {
      // Why pass in names of functions, rather than the function objects themselves? The
      // definitions of some functions (but in particular, URI.decode) will occasionally change due
      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
      // that the functions we use here are "fresh".
      var actualCodingFunc;
      if (!_innerCodingFuncName) {
        actualCodingFunc = URI[_codingFuncName];
      } else {
        actualCodingFunc = function(string) {
          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
        };
      }

      var segments = (string + '').split(_sep);

      for (var i = 0, length = segments.length; i < length; i++) {
        segments[i] = actualCodingFunc(segments[i]);
      }

      return segments.join(_sep);
    };
  };

  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');

  URI.encodeReserved = generateAccessor('reserved', 'encode');

  URI.parse = function(string, parts) {
    var pos;
    if (!parts) {
      parts = {
        preventInvalidHostname: URI.preventInvalidHostname
      };
    }
    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

    // extract fragment
    pos = string.indexOf('#');
    if (pos > -1) {
      // escaping?
      parts.fragment = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract query
    pos = string.indexOf('?');
    if (pos > -1) {
      // escaping?
      parts.query = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract protocol
    if (string.substring(0, 2) === '//') {
      // relative-scheme
      parts.protocol = null;
      string = string.substring(2);
      // extract "user:pass@host:port"
      string = URI.parseAuthority(string, parts);
    } else {
      pos = string.indexOf(':');
      if (pos > -1) {
        parts.protocol = string.substring(0, pos) || null;
        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
          // : may be within the path
          parts.protocol = undefined;
        } else if (string.substring(pos + 1, pos + 3) === '//') {
          string = string.substring(pos + 3);

          // extract "user:pass@host:port"
          string = URI.parseAuthority(string, parts);
        } else {
          string = string.substring(pos + 1);
          parts.urn = true;
        }
      }
    }

    // what's left must be the path
    parts.path = string;

    // and we're done
    return parts;
  };
  URI.parseHost = function(string, parts) {
    if (!string) {
      string = '';
    }

    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    // https://github.com/medialize/URI.js/pull/233
    string = string.replace(/\\/g, '/');

    // extract host:port
    var pos = string.indexOf('/');
    var bracketPos;
    var t;

    if (pos === -1) {
      pos = string.length;
    }

    if (string.charAt(0) === '[') {
      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
      bracketPos = string.indexOf(']');
      parts.hostname = string.substring(1, bracketPos) || null;
      parts.port = string.substring(bracketPos + 2, pos) || null;
      if (parts.port === '/') {
        parts.port = null;
      }
    } else {
      var firstColon = string.indexOf(':');
      var firstSlash = string.indexOf('/');
      var nextColon = string.indexOf(':', firstColon + 1);
      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
        // IPv6 host contains multiple colons - but no port
        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
        parts.hostname = string.substring(0, pos) || null;
        parts.port = null;
      } else {
        t = string.substring(0, pos).split(':');
        parts.hostname = t[0] || null;
        parts.port = t[1] || null;
      }
    }

    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
      pos++;
      string = '/' + string;
    }

    if (parts.preventInvalidHostname) {
      URI.ensureValidHostname(parts.hostname, parts.protocol);
    }

    if (parts.port) {
      URI.ensureValidPort(parts.port);
    }

    return string.substring(pos) || '/';
  };
  URI.parseAuthority = function(string, parts) {
    string = URI.parseUserinfo(string, parts);
    return URI.parseHost(string, parts);
  };
  URI.parseUserinfo = function(string, parts) {
    // extract username:password
    var firstSlash = string.indexOf('/');
    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
    var t;

    // authority@ must come before /path
    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
      t = string.substring(0, pos).split(':');
      parts.username = t[0] ? URI.decode(t[0]) : null;
      t.shift();
      parts.password = t[0] ? URI.decode(t.join(':')) : null;
      string = string.substring(pos + 1);
    } else {
      parts.username = null;
      parts.password = null;
    }

    return string;
  };
  URI.parseQuery = function(string, escapeQuerySpace) {
    if (!string) {
      return {};
    }

    // throw out the funky business - "?"[name"="value"&"]+
    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');

    if (!string) {
      return {};
    }

    var items = {};
    var splits = string.split('&');
    var length = splits.length;
    var v, name, value;

    for (var i = 0; i < length; i++) {
      v = splits[i].split('=');
      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;

      if (hasOwn.call(items, name)) {
        if (typeof items[name] === 'string' || items[name] === null) {
          items[name] = [items[name]];
        }

        items[name].push(value);
      } else {
        items[name] = value;
      }
    }

    return items;
  };

  URI.build = function(parts) {
    var t = '';

    if (parts.protocol) {
      t += parts.protocol + ':';
    }

    if (!parts.urn && (t || parts.hostname)) {
      t += '//';
    }

    t += (URI.buildAuthority(parts) || '');

    if (typeof parts.path === 'string') {
      if (parts.path.charAt(0) !== '/' && typeof parts.hostname === 'string') {
        t += '/';
      }

      t += parts.path;
    }

    if (typeof parts.query === 'string' && parts.query) {
      t += '?' + parts.query;
    }

    if (typeof parts.fragment === 'string' && parts.fragment) {
      t += '#' + parts.fragment;
    }
    return t;
  };
  URI.buildHost = function(parts) {
    var t = '';

    if (!parts.hostname) {
      return '';
    } else if (URI.ip6_expression.test(parts.hostname)) {
      t += '[' + parts.hostname + ']';
    } else {
      t += parts.hostname;
    }

    if (parts.port) {
      t += ':' + parts.port;
    }

    return t;
  };
  URI.buildAuthority = function(parts) {
    return URI.buildUserinfo(parts) + URI.buildHost(parts);
  };
  URI.buildUserinfo = function(parts) {
    var t = '';

    if (parts.username) {
      t += URI.encode(parts.username);
    }

    if (parts.password) {
      t += ':' + URI.encode(parts.password);
    }

    if (t) {
      t += '@';
    }

    return t;
  };
  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
    // URI.js treats the query string as being application/x-www-form-urlencoded
    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

    var t = '';
    var unique, key, i, length;
    for (key in data) {
      if (hasOwn.call(data, key) && key) {
        if (isArray(data[key])) {
          unique = {};
          for (i = 0, length = data[key].length; i < length; i++) {
            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
              if (duplicateQueryParameters !== true) {
                unique[data[key][i] + ''] = true;
              }
            }
          }
        } else if (data[key] !== undefined) {
          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
        }
      }
    }

    return t.substring(1);
  };
  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
  };

  URI.addQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.addQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (data[name] === undefined) {
        data[name] = value;
        return;
      } else if (typeof data[name] === 'string') {
        data[name] = [data[name]];
      }

      if (!isArray(value)) {
        value = [value];
      }

      data[name] = (data[name] || []).concat(value);
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }
  };

  URI.setQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.setQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      data[name] = value === undefined ? null : value;
    } else {
      throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
    }
  };

  URI.removeQuery = function(data, name, value) {
    var i, length, key;

    if (isArray(name)) {
      for (i = 0, length = name.length; i < length; i++) {
        data[name[i]] = undefined;
      }
    } else if (getType(name) === 'RegExp') {
      for (key in data) {
        if (name.test(key)) {
          data[key] = undefined;
        }
      }
    } else if (typeof name === 'object') {
      for (key in name) {
        if (hasOwn.call(name, key)) {
          URI.removeQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (value !== undefined) {
        if (getType(value) === 'RegExp') {
          if (!isArray(data[name]) && value.test(data[name])) {
            data[name] = undefined;
          } else {
            data[name] = filterArrayValues(data[name], value);
          }
        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
          data[name] = undefined;
        } else if (isArray(data[name])) {
          data[name] = filterArrayValues(data[name], value);
        }
      } else {
        data[name] = undefined;
      }
    } else {
      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    }
  };
  URI.hasQuery = function(data, name, value, withinArray) {
    switch (getType(name)) {
      case 'String':
        // Nothing to do here
        break;

      case 'RegExp':
        for (var key in data) {
          if (hasOwn.call(data, key)) {
            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
              return true;
            }
          }
        }

        return false;

      case 'Object':
        for (var _key in name) {
          if (hasOwn.call(name, _key)) {
            if (!URI.hasQuery(data, _key, name[_key])) {
              return false;
            }
          }
        }

        return true;

      default:
        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
    }

    switch (getType(value)) {
      case 'Undefined':
        // true if exists (but may be empty)
        return name in data; // data[name] !== undefined;

      case 'Boolean':
        // true if exists and non-empty
        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
        return value === _booly;

      case 'Function':
        // allow complex comparison
        return !!value(data[name], name, data);

      case 'Array':
        if (!isArray(data[name])) {
          return false;
        }

        var op = withinArray ? arrayContains : arraysEqual;
        return op(data[name], value);

      case 'RegExp':
        if (!isArray(data[name])) {
          return Boolean(data[name] && data[name].match(value));
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      case 'Number':
        value = String(value);
        /* falls through */
      case 'String':
        if (!isArray(data[name])) {
          return data[name] === value;
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      default:
        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
    }
  };


  URI.joinPaths = function() {
    var input = [];
    var segments = [];
    var nonEmptySegments = 0;

    for (var i = 0; i < arguments.length; i++) {
      var url = new URI(arguments[i]);
      input.push(url);
      var _segments = url.segment();
      for (var s = 0; s < _segments.length; s++) {
        if (typeof _segments[s] === 'string') {
          segments.push(_segments[s]);
        }

        if (_segments[s]) {
          nonEmptySegments++;
        }
      }
    }

    if (!segments.length || !nonEmptySegments) {
      return new URI('');
    }

    var uri = new URI('').segment(segments);

    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
      uri.path('/' + uri.path());
    }

    return uri.normalize();
  };

  URI.commonPath = function(one, two) {
    var length = Math.min(one.length, two.length);
    var pos;

    // find first non-matching character
    for (pos = 0; pos < length; pos++) {
      if (one.charAt(pos) !== two.charAt(pos)) {
        pos--;
        break;
      }
    }

    if (pos < 1) {
      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
    }

    // revert to last /
    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
      pos = one.substring(0, pos).lastIndexOf('/');
    }

    return one.substring(0, pos + 1);
  };

  URI.withinString = function(string, callback, options) {
    options || (options = {});
    var _start = options.start || URI.findUri.start;
    var _end = options.end || URI.findUri.end;
    var _trim = options.trim || URI.findUri.trim;
    var _parens = options.parens || URI.findUri.parens;
    var _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
      var match = _start.exec(string);
      if (!match) {
        break;
      }

      var start = match.index;
      if (options.ignoreHtml) {
        // attribut(e=["']?$)
        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
          continue;
        }
      }

      var end = start + string.slice(start).search(_end);
      var slice = string.slice(start, end);
      // make sure we include well balanced parens
      var parensEnd = -1;
      while (true) {
        var parensMatch = _parens.exec(slice);
        if (!parensMatch) {
          break;
        }

        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
        parensEnd = Math.max(parensEnd, parensMatchEnd);
      }

      if (parensEnd > -1) {
        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
      } else {
        slice = slice.replace(_trim, '');
      }

      if (slice.length <= match[0].length) {
        // the extract only contains the starting marker of a URI,
        // e.g. "www" or "http://"
        continue;
      }

      if (options.ignore && options.ignore.test(slice)) {
        continue;
      }

      end = start + slice.length;
      var result = callback(slice, start, end, string);
      if (result === undefined) {
        _start.lastIndex = end;
        continue;
      }

      result = String(result);
      string = string.slice(0, start) + result + string.slice(end);
      _start.lastIndex = start + result.length;
    }

    _start.lastIndex = 0;
    return string;
  };

  URI.ensureValidHostname = function(v, protocol) {
    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
    // they are not part of DNS and therefore ignored by URI.js

    var hasHostname = !!v; // not null and not an empty string
    var hasProtocol = !!protocol;
    var rejectEmptyHostname = false;

    if (hasProtocol) {
      rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
    }

    if (rejectEmptyHostname && !hasHostname) {
      throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
    } else if (v && v.match(URI.invalid_hostname_characters)) {
      // test punycode
      if (!punycode) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
      }
      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
      }
    }
  };

  URI.ensureValidPort = function (v) {
    if (!v) {
      return;
    }

    var port = Number(v);
    if (isInteger(port) && (port > 0) && (port < 65536)) {
      return;
    }

    throw new TypeError('Port "' + v + '" is not a valid port');
  };

  // noConflict
  URI.noConflict = function(removeAll) {
    if (removeAll) {
      var unconflicted = {
        URI: this.noConflict()
      };

      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
        unconflicted.URITemplate = root.URITemplate.noConflict();
      }

      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
        unconflicted.IPv6 = root.IPv6.noConflict();
      }

      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
      }

      return unconflicted;
    } else if (root.URI === this) {
      root.URI = _URI;
    }

    return this;
  };

  p.build = function(deferBuild) {
    if (deferBuild === true) {
      this._deferred_build = true;
    } else if (deferBuild === undefined || this._deferred_build) {
      this._string = URI.build(this._parts);
      this._deferred_build = false;
    }

    return this;
  };

  p.clone = function() {
    return new URI(this);
  };

  p.valueOf = p.toString = function() {
    return this.build(false)._string;
  };


  function generateSimpleAccessor(_part){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        this._parts[_part] = v || null;
        this.build(!build);
        return this;
      }
    };
  }

  function generatePrefixAccessor(_part, _key){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        if (v !== null) {
          v = v + '';
          if (v.charAt(0) === _key) {
            v = v.substring(1);
          }
        }

        this._parts[_part] = v;
        this.build(!build);
        return this;
      }
    };
  }

  p.protocol = generateSimpleAccessor('protocol');
  p.username = generateSimpleAccessor('username');
  p.password = generateSimpleAccessor('password');
  p.hostname = generateSimpleAccessor('hostname');
  p.port = generateSimpleAccessor('port');
  p.query = generatePrefixAccessor('query', '?');
  p.fragment = generatePrefixAccessor('fragment', '#');

  p.search = function(v, build) {
    var t = this.query(v, build);
    return typeof t === 'string' && t.length ? ('?' + t) : t;
  };
  p.hash = function(v, build) {
    var t = this.fragment(v, build);
    return typeof t === 'string' && t.length ? ('#' + t) : t;
  };

  p.pathname = function(v, build) {
    if (v === undefined || v === true) {
      var res = this._parts.path || (this._parts.hostname ? '/' : '');
      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
    } else {
      if (this._parts.urn) {
        this._parts.path = v ? URI.recodeUrnPath(v) : '';
      } else {
        this._parts.path = v ? URI.recodePath(v) : '/';
      }
      this.build(!build);
      return this;
    }
  };
  p.path = p.pathname;
  p.href = function(href, build) {
    var key;

    if (href === undefined) {
      return this.toString();
    }

    this._string = '';
    this._parts = URI._parts();

    var _URI = href instanceof URI;
    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
    if (href.nodeName) {
      var attribute = URI.getDomAttribute(href);
      href = href[attribute] || '';
      _object = false;
    }

    // window.location is reported to be an object, but it's not the sort
    // of object we're looking for:
    // * location.protocol ends with a colon
    // * location.query != object.search
    // * location.hash != object.fragment
    // simply serializing the unknown object should do the trick
    // (for location, not for everything...)
    if (!_URI && _object && href.pathname !== undefined) {
      href = href.toString();
    }

    if (typeof href === 'string' || href instanceof String) {
      this._parts = URI.parse(String(href), this._parts);
    } else if (_URI || _object) {
      var src = _URI ? href._parts : href;
      for (key in src) {
        if (hasOwn.call(this._parts, key)) {
          this._parts[key] = src[key];
        }
      }
    } else {
      throw new TypeError('invalid input');
    }

    this.build(!build);
    return this;
  };

  // identification accessors
  p.is = function(what) {
    var ip = false;
    var ip4 = false;
    var ip6 = false;
    var name = false;
    var sld = false;
    var idn = false;
    var punycode = false;
    var relative = !this._parts.urn;

    if (this._parts.hostname) {
      relative = false;
      ip4 = URI.ip4_expression.test(this._parts.hostname);
      ip6 = URI.ip6_expression.test(this._parts.hostname);
      ip = ip4 || ip6;
      name = !ip;
      sld = name && SLD && SLD.has(this._parts.hostname);
      idn = name && URI.idn_expression.test(this._parts.hostname);
      punycode = name && URI.punycode_expression.test(this._parts.hostname);
    }

    switch (what.toLowerCase()) {
      case 'relative':
        return relative;

      case 'absolute':
        return !relative;

      // hostname identification
      case 'domain':
      case 'name':
        return name;

      case 'sld':
        return sld;

      case 'ip':
        return ip;

      case 'ip4':
      case 'ipv4':
      case 'inet4':
        return ip4;

      case 'ip6':
      case 'ipv6':
      case 'inet6':
        return ip6;

      case 'idn':
        return idn;

      case 'url':
        return !this._parts.urn;

      case 'urn':
        return !!this._parts.urn;

      case 'punycode':
        return punycode;
    }

    return null;
  };

  // component specific input validation
  var _protocol = p.protocol;
  var _port = p.port;
  var _hostname = p.hostname;

  p.protocol = function(v, build) {
    if (v) {
      // accept trailing ://
      v = v.replace(/:(\/\/)?$/, '');

      if (!v.match(URI.protocol_expression)) {
        throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
      }
    }

    return _protocol.call(this, v, build);
  };
  p.scheme = p.protocol;
  p.port = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      if (v === 0) {
        v = null;
      }

      if (v) {
        v += '';
        if (v.charAt(0) === ':') {
          v = v.substring(1);
        }

        URI.ensureValidPort(v);
      }
    }
    return _port.call(this, v, build);
  };
  p.hostname = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      var x = { preventInvalidHostname: this._parts.preventInvalidHostname };
      var res = URI.parseHost(v, x);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      v = x.hostname;
      if (this._parts.preventInvalidHostname) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }
    }

    return _hostname.call(this, v, build);
  };

  // compound accessors
  p.origin = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var protocol = this.protocol();
      var authority = this.authority();
      if (!authority) {
        return '';
      }

      return (protocol ? protocol + '://' : '') + this.authority();
    } else {
      var origin = URI(v);
      this
        .protocol(origin.protocol())
        .authority(origin.authority())
        .build(!build);
      return this;
    }
  };
  p.host = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildHost(this._parts) : '';
    } else {
      var res = URI.parseHost(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.authority = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
    } else {
      var res = URI.parseAuthority(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.userinfo = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var t = URI.buildUserinfo(this._parts);
      return t ? t.substring(0, t.length -1) : t;
    } else {
      if (v[v.length-1] !== '@') {
        v += '@';
      }

      URI.parseUserinfo(v, this._parts);
      this.build(!build);
      return this;
    }
  };
  p.resource = function(v, build) {
    var parts;

    if (v === undefined) {
      return this.path() + this.search() + this.hash();
    }

    parts = URI.parse(v);
    this._parts.path = parts.path;
    this._parts.query = parts.query;
    this._parts.fragment = parts.fragment;
    this.build(!build);
    return this;
  };

  // fraction accessors
  p.subdomain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    // convenience, return "www" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // grab domain and add another segment
      var end = this._parts.hostname.length - this.domain().length - 1;
      return this._parts.hostname.substring(0, end) || '';
    } else {
      var e = this._parts.hostname.length - this.domain().length;
      var sub = this._parts.hostname.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(sub));

      if (v && v.charAt(v.length - 1) !== '.') {
        v += '.';
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      if (v) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }

      this._parts.hostname = this._parts.hostname.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.domain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // convenience, return "example.org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // if hostname consists of 1 or 2 segments, it must be the domain
      var t = this._parts.hostname.match(/\./g);
      if (t && t.length < 2) {
        return this._parts.hostname;
      }

      // grab tld and add another segment
      var end = this._parts.hostname.length - this.tld(build).length - 1;
      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
      return this._parts.hostname.substring(end) || '';
    } else {
      if (!v) {
        throw new TypeError('cannot set domain empty');
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      URI.ensureValidHostname(v, this._parts.protocol);

      if (!this._parts.hostname || this.is('IP')) {
        this._parts.hostname = v;
      } else {
        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.tld = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // return "org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      var pos = this._parts.hostname.lastIndexOf('.');
      var tld = this._parts.hostname.substring(pos + 1);

      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
        return SLD.get(this._parts.hostname) || tld;
      }

      return tld;
    } else {
      var replace;

      if (!v) {
        throw new TypeError('cannot set TLD empty');
      } else if (v.match(/[^a-zA-Z0-9-]/)) {
        if (SLD && SLD.is(v)) {
          replace = new RegExp(escapeRegEx(this.tld()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        } else {
          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
        }
      } else if (!this._parts.hostname || this.is('IP')) {
        throw new ReferenceError('cannot set TLD on non-domain host');
      } else {
        replace = new RegExp(escapeRegEx(this.tld()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.directory = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path && !this._parts.hostname) {
        return '';
      }

      if (this._parts.path === '/') {
        return '/';
      }

      var end = this._parts.path.length - this.filename().length - 1;
      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');

      return v ? URI.decodePath(res) : res;

    } else {
      var e = this._parts.path.length - this.filename().length;
      var directory = this._parts.path.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(directory));

      // fully qualifier directories begin with a slash
      if (!this.is('relative')) {
        if (!v) {
          v = '/';
        }

        if (v.charAt(0) !== '/') {
          v = '/' + v;
        }
      }

      // directories always end with a slash
      if (v && v.charAt(v.length - 1) !== '/') {
        v += '/';
      }

      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.filename = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v !== 'string') {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var pos = this._parts.path.lastIndexOf('/');
      var res = this._parts.path.substring(pos+1);

      return v ? URI.decodePathSegment(res) : res;
    } else {
      var mutatedDirectory = false;

      if (v.charAt(0) === '/') {
        v = v.substring(1);
      }

      if (v.match(/\.?\//)) {
        mutatedDirectory = true;
      }

      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);

      if (mutatedDirectory) {
        this.normalizePath(build);
      } else {
        this.build(!build);
      }

      return this;
    }
  };
  p.suffix = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var filename = this.filename();
      var pos = filename.lastIndexOf('.');
      var s, res;

      if (pos === -1) {
        return '';
      }

      // suffix may only contain alnum characters (yup, I made this up.)
      s = filename.substring(pos+1);
      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
      return v ? URI.decodePathSegment(res) : res;
    } else {
      if (v.charAt(0) === '.') {
        v = v.substring(1);
      }

      var suffix = this.suffix();
      var replace;

      if (!suffix) {
        if (!v) {
          return this;
        }

        this._parts.path += '.' + URI.recodePath(v);
      } else if (!v) {
        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
      } else {
        replace = new RegExp(escapeRegEx(suffix) + '$');
      }

      if (replace) {
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.segment = function(segment, v, build) {
    var separator = this._parts.urn ? ':' : '/';
    var path = this.path();
    var absolute = path.substring(0, 1) === '/';
    var segments = path.split(separator);

    if (segment !== undefined && typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (segment !== undefined && typeof segment !== 'number') {
      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
    }

    if (absolute) {
      segments.shift();
    }

    if (segment < 0) {
      // allow negative indexes to address from the end
      segment = Math.max(segments.length + segment, 0);
    }

    if (v === undefined) {
      /*jshint laxbreak: true */
      return segment === undefined
        ? segments
        : segments[segment];
      /*jshint laxbreak: false */
    } else if (segment === null || segments[segment] === undefined) {
      if (isArray(v)) {
        segments = [];
        // collapse empty elements within array
        for (var i=0, l=v.length; i < l; i++) {
          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
            continue;
          }

          if (segments.length && !segments[segments.length -1].length) {
            segments.pop();
          }

          segments.push(trimSlashes(v[i]));
        }
      } else if (v || typeof v === 'string') {
        v = trimSlashes(v);
        if (segments[segments.length -1] === '') {
          // empty trailing elements have to be overwritten
          // to prevent results such as /foo//bar
          segments[segments.length -1] = v;
        } else {
          segments.push(v);
        }
      }
    } else {
      if (v) {
        segments[segment] = trimSlashes(v);
      } else {
        segments.splice(segment, 1);
      }
    }

    if (absolute) {
      segments.unshift('');
    }

    return this.path(segments.join(separator), build);
  };
  p.segmentCoded = function(segment, v, build) {
    var segments, i, l;

    if (typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (v === undefined) {
      segments = this.segment(segment, v, build);
      if (!isArray(segments)) {
        segments = segments !== undefined ? URI.decode(segments) : undefined;
      } else {
        for (i = 0, l = segments.length; i < l; i++) {
          segments[i] = URI.decode(segments[i]);
        }
      }

      return segments;
    }

    if (!isArray(v)) {
      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
    } else {
      for (i = 0, l = v.length; i < l; i++) {
        v[i] = URI.encode(v[i]);
      }
    }

    return this.segment(segment, v, build);
  };

  // mutating query string
  var q = p.query;
  p.query = function(v, build) {
    if (v === true) {
      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    } else if (typeof v === 'function') {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      var result = v.call(this, data);
      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else if (v !== undefined && typeof v !== 'string') {
      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else {
      return q.call(this, v, build);
    }
  };
  p.setQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);

    if (typeof name === 'string' || name instanceof String) {
      data[name] = value !== undefined ? value : null;
    } else if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          data[key] = name[key];
        }
      }
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }

    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.addQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.addQuery(data, name, value === undefined ? null : value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.removeQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.removeQuery(data, name, value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.hasQuery = function(name, value, withinArray) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    return URI.hasQuery(data, name, value, withinArray);
  };
  p.setSearch = p.setQuery;
  p.addSearch = p.addQuery;
  p.removeSearch = p.removeQuery;
  p.hasSearch = p.hasQuery;

  // sanitizing URLs
  p.normalize = function() {
    if (this._parts.urn) {
      return this
        .normalizeProtocol(false)
        .normalizePath(false)
        .normalizeQuery(false)
        .normalizeFragment(false)
        .build();
    }

    return this
      .normalizeProtocol(false)
      .normalizeHostname(false)
      .normalizePort(false)
      .normalizePath(false)
      .normalizeQuery(false)
      .normalizeFragment(false)
      .build();
  };
  p.normalizeProtocol = function(build) {
    if (typeof this._parts.protocol === 'string') {
      this._parts.protocol = this._parts.protocol.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizeHostname = function(build) {
    if (this._parts.hostname) {
      if (this.is('IDN') && punycode) {
        this._parts.hostname = punycode.toASCII(this._parts.hostname);
      } else if (this.is('IPv6') && IPv6) {
        this._parts.hostname = IPv6.best(this._parts.hostname);
      }

      this._parts.hostname = this._parts.hostname.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizePort = function(build) {
    // remove port of it's the protocol's default
    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
      this._parts.port = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizePath = function(build) {
    var _path = this._parts.path;
    if (!_path) {
      return this;
    }

    if (this._parts.urn) {
      this._parts.path = URI.recodeUrnPath(this._parts.path);
      this.build(!build);
      return this;
    }

    if (this._parts.path === '/') {
      return this;
    }

    _path = URI.recodePath(_path);

    var _was_relative;
    var _leadingParents = '';
    var _parent, _pos;

    // handle relative paths
    if (_path.charAt(0) !== '/') {
      _was_relative = true;
      _path = '/' + _path;
    }

    // handle relative files (as opposed to directories)
    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
      _path += '/';
    }

    // resolve simples
    _path = _path
      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
      .replace(/\/{2,}/g, '/');

    // remember leading parents
    if (_was_relative) {
      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
      if (_leadingParents) {
        _leadingParents = _leadingParents[0];
      }
    }

    // resolve parents
    while (true) {
      _parent = _path.search(/\/\.\.(\/|$)/);
      if (_parent === -1) {
        // no more ../ to resolve
        break;
      } else if (_parent === 0) {
        // top level cannot be relative, skip it
        _path = _path.substring(3);
        continue;
      }

      _pos = _path.substring(0, _parent).lastIndexOf('/');
      if (_pos === -1) {
        _pos = _parent;
      }
      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
    }

    // revert to relative
    if (_was_relative && this.is('relative')) {
      _path = _leadingParents + _path.substring(1);
    }

    this._parts.path = _path;
    this.build(!build);
    return this;
  };
  p.normalizePathname = p.normalizePath;
  p.normalizeQuery = function(build) {
    if (typeof this._parts.query === 'string') {
      if (!this._parts.query.length) {
        this._parts.query = null;
      } else {
        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
      }

      this.build(!build);
    }

    return this;
  };
  p.normalizeFragment = function(build) {
    if (!this._parts.fragment) {
      this._parts.fragment = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizeSearch = p.normalizeQuery;
  p.normalizeHash = p.normalizeFragment;

  p.iso8859 = function() {
    // expect unicode input, iso8859 output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = escape;
    URI.decode = decodeURIComponent;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.unicode = function() {
    // expect iso8859 input, unicode output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = strictEncodeURIComponent;
    URI.decode = unescape;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.readable = function() {
    var uri = this.clone();
    // removing username, password, because they shouldn't be displayed according to RFC 3986
    uri.username('').password('').normalize();
    var t = '';
    if (uri._parts.protocol) {
      t += uri._parts.protocol + '://';
    }

    if (uri._parts.hostname) {
      if (uri.is('punycode') && punycode) {
        t += punycode.toUnicode(uri._parts.hostname);
        if (uri._parts.port) {
          t += ':' + uri._parts.port;
        }
      } else {
        t += uri.host();
      }
    }

    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
      t += '/';
    }

    t += uri.path(true);
    if (uri._parts.query) {
      var q = '';
      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
        var kv = (qp[i] || '').split('=');
        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
          .replace(/&/g, '%26');

        if (kv[1] !== undefined) {
          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
            .replace(/&/g, '%26');
        }
      }
      t += '?' + q.substring(1);
    }

    t += URI.decodeQuery(uri.hash(), true);
    return t;
  };

  // resolving relative and absolute URLs
  p.absoluteTo = function(base) {
    var resolved = this.clone();
    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
    var basedir, i, p;

    if (this._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    if (!(base instanceof URI)) {
      base = new URI(base);
    }

    if (resolved._parts.protocol) {
      // Directly returns even if this._parts.hostname is empty.
      return resolved;
    } else {
      resolved._parts.protocol = base._parts.protocol;
    }

    if (this._parts.hostname) {
      return resolved;
    }

    for (i = 0; (p = properties[i]); i++) {
      resolved._parts[p] = base._parts[p];
    }

    if (!resolved._parts.path) {
      resolved._parts.path = base._parts.path;
      if (!resolved._parts.query) {
        resolved._parts.query = base._parts.query;
      }
    } else {
      if (resolved._parts.path.substring(-2) === '..') {
        resolved._parts.path += '/';
      }

      if (resolved.path().charAt(0) !== '/') {
        basedir = base.directory();
        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
        resolved.normalizePath();
      }
    }

    resolved.build();
    return resolved;
  };
  p.relativeTo = function(base) {
    var relative = this.clone().normalize();
    var relativeParts, baseParts, common, relativePath, basePath;

    if (relative._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    base = new URI(base).normalize();
    relativeParts = relative._parts;
    baseParts = base._parts;
    relativePath = relative.path();
    basePath = base.path();

    if (relativePath.charAt(0) !== '/') {
      throw new Error('URI is already relative');
    }

    if (basePath.charAt(0) !== '/') {
      throw new Error('Cannot calculate a URI relative to another relative URI');
    }

    if (relativeParts.protocol === baseParts.protocol) {
      relativeParts.protocol = null;
    }

    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
      return relative.build();
    }

    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
      return relative.build();
    }

    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
      relativeParts.hostname = null;
      relativeParts.port = null;
    } else {
      return relative.build();
    }

    if (relativePath === basePath) {
      relativeParts.path = '';
      return relative.build();
    }

    // determine common sub path
    common = URI.commonPath(relativePath, basePath);

    // If the paths have nothing in common, return a relative URL with the absolute path.
    if (!common) {
      return relative.build();
    }

    var parents = baseParts.path
      .substring(common.length)
      .replace(/[^\/]*$/, '')
      .replace(/.*?\//g, '../');

    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';

    return relative.build();
  };

  // comparing URIs
  p.equals = function(uri) {
    var one = this.clone();
    var two = new URI(uri);
    var one_map = {};
    var two_map = {};
    var checked = {};
    var one_query, two_query, key;

    one.normalize();
    two.normalize();

    // exact match
    if (one.toString() === two.toString()) {
      return true;
    }

    // extract query string
    one_query = one.query();
    two_query = two.query();
    one.query('');
    two.query('');

    // definitely not equal if not even non-query parts match
    if (one.toString() !== two.toString()) {
      return false;
    }

    // query parameters have the same length, even if they're permuted
    if (one_query.length !== two_query.length) {
      return false;
    }

    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);

    for (key in one_map) {
      if (hasOwn.call(one_map, key)) {
        if (!isArray(one_map[key])) {
          if (one_map[key] !== two_map[key]) {
            return false;
          }
        } else if (!arraysEqual(one_map[key], two_map[key])) {
          return false;
        }

        checked[key] = true;
      }
    }

    for (key in two_map) {
      if (hasOwn.call(two_map, key)) {
        if (!checked[key]) {
          // two contains a parameter not present in one
          return false;
        }
      }
    }

    return true;
  };

  // state
  p.preventInvalidHostname = function(v) {
    this._parts.preventInvalidHostname = !!v;
    return this;
  };

  p.duplicateQueryParameters = function(v) {
    this._parts.duplicateQueryParameters = !!v;
    return this;
  };

  p.escapeQuerySpace = function(v) {
    this._parts.escapeQuerySpace = !!v;
    return this;
  };

  return URI;
}));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withDeviceType;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _createHocName = __webpack_require__(41);

var _createHocName2 = _interopRequireDefault(_createHocName);

var _wixSdkUtils = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAME = 'WithDeviceType';

function withDeviceType(WrappedComponent) {
  var WithDeviceType = function (_Component) {
    _inherits(WithDeviceType, _Component);

    function WithDeviceType() {
      _classCallCheck(this, WithDeviceType);

      return _possibleConstructorReturn(this, (WithDeviceType.__proto__ || Object.getPrototypeOf(WithDeviceType)).apply(this, arguments));
    }

    _createClass(WithDeviceType, [{
      key: 'render',
      value: function render() {
        var isMobileVal = (0, _wixSdkUtils.isMobile)();
        return _react2.default.createElement(WrappedComponent, _extends({ isMobile: isMobileVal, isDesktop: !isMobileVal }, this.props));
      }
    }]);

    return WithDeviceType;
  }(_react.Component);

  WithDeviceType.displayName = (0, _createHocName2.default)(NAME, WrappedComponent);


  (0, _hoistNonReactStatics2.default)(WithDeviceType, WrappedComponent);

  return WithDeviceType;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocale = exports.getExternalId = exports.getViewMode = exports.getCompId = exports.getOuterUrl = exports.isSite = exports.isSeoViewMode = exports.isPreview = exports.isEditor = exports.getWidth = exports.getScreenWidth = exports.isLandscape = exports.isMobile = exports.isUserAgentMobile = exports.isWixMobile = exports.getInstance = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _parseGetParam = __webpack_require__(175);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInstance = exports.getInstance = function getInstance() {
  return (0, _parseGetParam.parseGetParam)('instance');
};

var isWixMobile = exports.isWixMobile = function isWixMobile() {
  var deviceType = (0, _parseGetParam.parseGetParam)('deviceType');
  if (deviceType && deviceType !== '') {
    return String(deviceType).indexOf('mobile') >= 0;
  } else {
    return undefined;
  }
};

//this is a heavy regexp, avoid from calling it if not needed
//TODO: call this once, save it on the window or other global and use the global var instead
// prettier-ignore
var isUserAgentMobile = exports.isUserAgentMobile = function isUserAgentMobile() {
  var result = false;
  try {
    (function (a) {
      /* eslint-disable no-useless-escape */
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
        /* eslint-enable no-useless-escape */
        result = true;
      }
    })(navigator.userAgent || navigator.vendor || window.opera);
  } catch (e) {
    //navigator not defined on test env
  }
  return result;
};

var isMobile = exports.isMobile = function isMobile() {
  var wixMobile = isWixMobile();
  return _lodash2.default.isUndefined(wixMobile) ? isUserAgentMobile() : wixMobile;
};

var isLandscape = exports.isLandscape = function isLandscape() {
  var isLandscape = false;
  if (!isMobile()) {
    isLandscape = false;
  }
  if (!_lodash2.default.isUndefined(window.orientation)) {
    isLandscape = window.orientation === 90 || window.orientation === -90;
  } else {
    var mql = window.matchMedia('(orientation: landscape)');
    if (mql && mql.matches === true) {
      isLandscape = true;
    } else {
      isLandscape = false;
    }
  }
  return isLandscape;
};

var getScreenWidth = exports.getScreenWidth = function getScreenWidth() {
  if (isLandscape()) {
    return Math.max(window.screen.width, window.screen.height);
  } else {
    return window.screen.width;
  }
};

var getWidth = exports.getWidth = function getWidth() {
  return (0, _parseGetParam.parseGetParam)('width');
};

var isEditor = exports.isEditor = function isEditor() {
  return (0, _parseGetParam.parseGetParam)('viewMode') === 'editor';
};

var isPreview = exports.isPreview = function isPreview() {
  return (0, _parseGetParam.parseGetParam)('viewMode') === 'preview';
};

var isSeoViewMode = exports.isSeoViewMode = function isSeoViewMode() {
  return (0, _parseGetParam.parseGetParam)('viewMode') === 'viewer-seo';
};

var isSite = exports.isSite = function isSite() {
  return !isEditor() && !isPreview();
};

var getOuterUrl = exports.getOuterUrl = function getOuterUrl(path) {
  return '' + _wixSdkPolyfill2.default.Utils.getSectionUrl() + path;
};

//example for url in wix:
//http://localhost:4000/?
// cacheKiller=1476285364360
// &compId=TPASection_iu7270jb
// &deviceType=desktop
// &instance=nfD1PM20vEXqfHStvJjMGauBkBPw_dxEW4W8JPZm02Q.eyJpbnN0YW5jZUlkIjoiNWMzZWIwYjYtZWE2OS00OTQ0LWI0YjUtNTMwN2I5YjJkNTQ5Iiwic2lnbkRhdGUiOiIyMDE2LTEwLTEyVDE1OjE2OjEzLjcwMloiLCJ1aWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUiLCJwZXJtaXNzaW9ucyI6Ik9XTkVSIiwiaXBBbmRQb3J0IjoiNDYuMTE2Ljk2LjUvMzUxNDciLCJ2ZW5kb3JQcm9kdWN0SWQiOm51bGwsImRlbW9Nb2RlIjpmYWxzZSwic2l0ZU93bmVySWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUifQ
// &locale=en
// &section-url=http%3A%2F%2Flocalhost%3A4000%2F
// &target=_self
// &viewMode=editor
// &width

//example for the settings url:
//http://localhost:4000/app-settings.html
// ?compId=tpaSettings
// &endpointType=settings
// &instance=nfD1PM20vEXqfHStvJjMGauBkBPw_dxEW4W8JPZm02Q.eyJpbnN0YW5jZUlkIjoiNWMzZWIwYjYtZWE2OS00OTQ0LWI0YjUtNTMwN2I5YjJkNTQ5Iiwic2lnbkRhdGUiOiIyMDE2LTEwLTEyVDE1OjE2OjEzLjcwMloiLCJ1aWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUiLCJwZXJtaXNzaW9ucyI6Ik9XTkVSIiwiaXBBbmRQb3J0IjoiNDYuMTE2Ljk2LjUvMzUxNDciLCJ2ZW5kb3JQcm9kdWN0SWQiOm51bGwsImRlbW9Nb2RlIjpmYWxzZSwic2l0ZU93bmVySWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUifQ
// &locale=en
// &origCompId=TPASection_iu7270jb
// &viewMode=editor
// &width=404

//example for url of the widget
// https://forums.wix.com/widget?
// cacheKiller=1477743410718
// &compId=comp-iusrvptg
// &deviceType=desktop
// &instance=-9rk9pM4lPRwaF0OmD2QPFfH4OnpQ9TqDWzLqco8l3U.eyJpbnN0YW5jZUlkIjoiMTZiOGUzNTQtYzFmOS00OWZkLThiYjktY2RkYjIwZDE3MmVkIiwic2lnbkRhdGUiOiIyMDE2LTEwLTI5VDEyOjE2OjQ4Ljc1M1oiLCJ1aWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUiLCJwZXJtaXNzaW9ucyI6Ik9XTkVSIiwiaXBBbmRQb3J0IjoiODkuMTM5LjE4My44NC81NTE3MCIsInZlbmRvclByb2R1Y3RJZCI6bnVsbCwiZGVtb01vZGUiOmZhbHNlLCJhaWQiOiI4MWMxOGRkNC01MjRlLTRkNzgtOGRmYy05OWVkY2JjYjU0NWYiLCJiaVRva2VuIjoiZGRlMWVkZWUtNWI5OS0wN2FjLTI0YmMtNTg3MDFhNjNmZDNlIiwic2l0ZU93bmVySWQiOiI4NWEzZTQ1YS02ZDlhLTRjNjctYmFhMS0yMTcxMTRjZjQzMmUifQ
// &locale=en
// &viewMode=site
// &width=100

var getCompId = exports.getCompId = function getCompId(search) {
  return (0, _parseGetParam.parseGetParam)('origCompId', search) || (0, _parseGetParam.parseGetParam)('compId', search);
};

var getViewMode = exports.getViewMode = function getViewMode(search) {
  return (0, _parseGetParam.parseGetParam)('viewMode', search);
};

var getExternalId = exports.getExternalId = function getExternalId(search) {
  return (0, _parseGetParam.parseGetParam)('externalId', search);
};

var getLocale = exports.getLocale = function getLocale(search) {
  return (0, _parseGetParam.parseGetParam)('locale', search) || 'en';
};

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withAuth;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactRedux = __webpack_require__(5);

var _wrapDisplayName = __webpack_require__(598);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _lodash = __webpack_require__(2);

var _joinCommunityPopupService = __webpack_require__(539);

var _currentUserSelectors = __webpack_require__(67);

var _memberAreaSelectors = __webpack_require__(270);

var _viewModeSelectors = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAME = 'withAuth';

function withAuth(WrappedComponent) {
  var WithAuth = function (_Component) {
    _inherits(WithAuth, _Component);

    function WithAuth() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WithAuth);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithAuth.__proto__ || Object.getPrototypeOf(WithAuth)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WithAuth, [{
      key: 'render',
      value: function render() {
        var props = (0, _lodash.omit)(_extends({ forPublicUser: this.forPublicUser }, this.props), ['__isMemberAreaActive', '__isSite']);
        return _react2.default.createElement(WrappedComponent, props);
      }
    }]);

    return WithAuth;
  }(_react.Component);

  WithAuth.displayName = (0, _wrapDisplayName2.default)(WrappedComponent, NAME);
  WithAuth.propTypes = {
    isPrivate: _propTypes2.default.bool,
    isAuthenticated: _propTypes2.default.bool,
    __isMemberAreaActive: _propTypes2.default.bool,
    __isSite: _propTypes2.default.bool
  };

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.forPublicUser = function (fn, options) {
      if (!_this2.props.__isMemberAreaActive || !_this2.props.__isSite) {
        return fn;
      }
      return _this2.decorateWithPrivacyChecker(fn, options);
    };

    this.decorateWithPrivacyChecker = function (fn) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$preventDefault = _ref2.preventDefault,
          preventDefault = _ref2$preventDefault === undefined ? false : _ref2$preventDefault;

      var isPrivate = function isPrivate() {
        return _this2.props.isPrivate;
      };
      var isAuthenticated = function isAuthenticated() {
        return _this2.props.isAuthenticated;
      };

      return function () {
        var _this3 = this;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (preventDefault) {
          var event = args[0];
          event.preventDefault && event.preventDefault();
        }

        if (isAuthenticated() && isPrivate()) {
          (0, _joinCommunityPopupService.showJoinCommunityPopup)(function (hasJoined) {
            return hasJoined && fn.apply(_this3, args);
          });
        } else {
          return fn.apply(this, args);
        }
      };
    };
  };

  (0, _hoistNonReactStatics2.default)(WithAuth, WrappedComponent);

  return (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps))(WithAuth);
}

function mapStateToProps(state) {
  return {
    currentUser: (0, _currentUserSelectors.getCurrentUser)(state),
    isAuthenticated: state.auth.isAuthenticated,
    isBlocked: (0, _currentUserSelectors.isBlocked)(state),
    isOwner: (0, _currentUserSelectors.isOwner)(state),
    isPrivate: (0, _currentUserSelectors.isPrivate)(state),
    __isMemberAreaActive: (0, _memberAreaSelectors.isMemberAreaActive)(state),
    __isSite: (0, _viewModeSelectors.isSite)(state)
  };
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Layout params

var LAYOUT_TYPE = exports.LAYOUT_TYPE = 'layout-type';
var LAYOUT_TYPE_PATH = exports.LAYOUT_TYPE_PATH = 'style.numbers.' + LAYOUT_TYPE;

var CARD_SIZE = exports.CARD_SIZE = 'layout-cardSize';
var CARD_SIZE_PATH = exports.CARD_SIZE_PATH = 'style.numbers.' + CARD_SIZE;

var CATEGORY_TEXT_ALIGNMENT = exports.CATEGORY_TEXT_ALIGNMENT = 'layout-tagTextAlignment';
var CATEGORY_TEXT_ALIGNMENT_PATH = exports.CATEGORY_TEXT_ALIGNMENT_PATH = 'style.numbers.' + CATEGORY_TEXT_ALIGNMENT;

var IS_HEADER_ENABLED = exports.IS_HEADER_ENABLED = 'layout-isHeaderEnabled';
var IS_HEADER_ENABLED_PATH = exports.IS_HEADER_ENABLED_PATH = 'style.booleans.' + IS_HEADER_ENABLED;

// Post design params

var APP_TEXT_COLOR = exports.APP_TEXT_COLOR = 'post-textColor';
var APP_TEXT_COLOR_PATH = exports.APP_TEXT_COLOR_PATH = 'style.colors.' + APP_TEXT_COLOR;

var BORDER_WIDTH_SMALL = exports.BORDER_WIDTH_SMALL = 'post-borderWidthSmall';
var BORDER_WIDTH_SMALL_PATH = exports.BORDER_WIDTH_SMALL_PATH = 'style.numbers.' + BORDER_WIDTH_SMALL;

var BORDER_WIDTH_MEDIUM = exports.BORDER_WIDTH_MEDIUM = 'post-borderWidthMedium';
var BORDER_WIDTH_MEDIUM_PATH = exports.BORDER_WIDTH_MEDIUM_PATH = 'style.numbers.' + BORDER_WIDTH_MEDIUM;

var BORDER_WIDTH_LARGE = exports.BORDER_WIDTH_LARGE = 'post-borderWidthLarge';
var BORDER_WIDTH_LARGE_PATH = exports.BORDER_WIDTH_LARGE_PATH = 'style.numbers.' + BORDER_WIDTH_LARGE;

var BORDER_WIDTH_CLASSIC = exports.BORDER_WIDTH_CLASSIC = 'post-borderWidthClassic';
var BORDER_WIDTH_CLASSIC_PATH = exports.BORDER_WIDTH_CLASSIC_PATH = 'style.numbers.' + BORDER_WIDTH_CLASSIC;

var CARD_BACKGROUND_COLOR = exports.CARD_BACKGROUND_COLOR = 'post-cardBackgroundColor';
var CARD_BACKGROUND_COLOR_PATH = exports.CARD_BACKGROUND_COLOR_PATH = 'style.colors.' + CARD_BACKGROUND_COLOR;

var APP_BACKGROUND_COLOR = exports.APP_BACKGROUND_COLOR = 'post-appBackgroundColor';
var APP_BACKGROUND_COLOR_PATH = exports.APP_BACKGROUND_COLOR_PATH = 'style.colors.' + APP_BACKGROUND_COLOR;

// Button design params

var BUTTON_COLOR = exports.BUTTON_COLOR = 'button-color';
var BUTTON_COLOR_PATH = exports.BUTTON_COLOR_PATH = 'style.colors.' + BUTTON_COLOR;

var SECONDARY_ICON_COLOR = exports.SECONDARY_ICON_COLOR = 'icon-secondaryColor';
var SECONDARY_ICON_COLOR_PATH = exports.SECONDARY_ICON_COLOR_PATH = 'style.colors.' + SECONDARY_ICON_COLOR;

// Widget params

var WIDGET_SIGN_UP_BUTTON_TYPE = exports.WIDGET_SIGN_UP_BUTTON_TYPE = 'widget-signUpButtonType';
var WIDGET_SIGN_UP_BUTTON_TYPE_PATH = exports.WIDGET_SIGN_UP_BUTTON_TYPE_PATH = 'style.numbers.' + WIDGET_SIGN_UP_BUTTON_TYPE;

var WIDGET_SIGN_UP_BUTTON_BORDER_COLOR = exports.WIDGET_SIGN_UP_BUTTON_BORDER_COLOR = 'widget-signUpButtonBorderColor';
var WIDGET_SIGN_UP_BUTTON_BORDER_COLOR_PATH = exports.WIDGET_SIGN_UP_BUTTON_BORDER_COLOR_PATH = 'style.colors.' + WIDGET_SIGN_UP_BUTTON_BORDER_COLOR;

var WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR = exports.WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR = 'widget-signUpButtonBackgroundColor';
var WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR_PATH = exports.WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR_PATH = 'style.colors.' + WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR;

var WIDGET_SIGN_UP_BUTTON_FONT = exports.WIDGET_SIGN_UP_BUTTON_FONT = 'widget-signUpButtonFont';
var WIDGET_SIGN_UP_BUTTON_FONT_PATH = exports.WIDGET_SIGN_UP_BUTTON_FONT_PATH = 'style.fonts.' + WIDGET_SIGN_UP_BUTTON_FONT;

var WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR = exports.WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR = 'widget-signUpButtonPrimaryColor';
var WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR_PATH = exports.WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR_PATH = 'style.fonts.' + WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR;

var WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR = exports.WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR = 'widget-signUpButtonSecondaryColor';
var WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR_PATH = exports.WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR_PATH = 'style.fonts.' + WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR;

var WIDGET_NOTIFICATION_ICON_COLOR = exports.WIDGET_NOTIFICATION_ICON_COLOR = 'widget-notificationIconColor';
var WIDGET_NOTIFICATION_ICON_COLOR_PATH = exports.WIDGET_NOTIFICATION_ICON_COLOR_PATH = 'style.colors.' + WIDGET_NOTIFICATION_ICON_COLOR;

var WIDGET_NOTIFICATION_BUBBLE_COLOR = exports.WIDGET_NOTIFICATION_BUBBLE_COLOR = 'widget-notificationBubbleColor';
var WIDGET_NOTIFICATION_BUBBLE_COLOR_PATH = exports.WIDGET_NOTIFICATION_BUBBLE_COLOR_PATH = 'style.colors.' + WIDGET_NOTIFICATION_BUBBLE_COLOR;

var WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR = exports.WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR = 'widget-notificationBubbleTextColor';
var WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR_PATH = exports.WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR_PATH = 'style.colors.' + WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR;

var WIDGET_AVATAR_BORDER_COLOR = exports.WIDGET_AVATAR_BORDER_COLOR = 'widget-avatarBorderColor';
var WIDGET_AVATAR_BORDER_COLOR_PATH = exports.WIDGET_AVATAR_BORDER_COLOR_PATH = 'style.colors.' + WIDGET_AVATAR_BORDER_COLOR;

// Forum widget params

var IS_LOGIN_WIDGET_ENABLED = exports.IS_LOGIN_WIDGET_ENABLED = 'widget-isLoginButtonEnabled';
var IS_LOGIN_WIDGET_ENABLED_PATH = exports.IS_LOGIN_WIDGET_ENABLED_PATH = 'style.booleans.' + IS_LOGIN_WIDGET_ENABLED;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(447);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MODAL_TYPE_CREATE_POST = exports.MODAL_TYPE_CREATE_POST = 'create-post';
var MODAL_TYPE_DISCARD_POST = exports.MODAL_TYPE_DISCARD_POST = 'discard-post';
var MODAL_TYPE_CHANGE_CATEGORY = exports.MODAL_TYPE_CHANGE_CATEGORY = 'change-category';
var MODAL_TYPE_DELETE_COMMENT = exports.MODAL_TYPE_DELETE_COMMENT = 'delete-comment';
var MODAL_TYPE_DELETE_POST = exports.MODAL_TYPE_DELETE_POST = 'delete-post';
var MODAL_TYPE_DELETE_CATEGORY = exports.MODAL_TYPE_DELETE_CATEGORY = 'delete-category';
var MODAL_TYPE_PROFILE_ACTIONS = exports.MODAL_TYPE_PROFILE_ACTIONS = 'profile-actions';
var MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART = exports.MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART = 'profile-actions-upper-part';
var MODAL_TYPE_MOVE_POST = exports.MODAL_TYPE_MOVE_POST = 'move-post';
var MODAL_TYPE_REPORT_COMMENT = exports.MODAL_TYPE_REPORT_COMMENT = 'report-comment';
var MODAL_TYPE_REPORT_POST = exports.MODAL_TYPE_REPORT_POST = 'report-post';
var MODAL_TYPE_REPORT_MEMBER = exports.MODAL_TYPE_REPORT_MEMBER = 'report-member';
var MODAL_TYPE_PROMOTE_MODERATOR = exports.MODAL_TYPE_PROMOTE_MODERATOR = 'promote-member';
var MODAL_TYPE_DEMOTE_MODERATOR = exports.MODAL_TYPE_DEMOTE_MODERATOR = 'demote-member';
var MODAL_TYPE_UNFOLLOW_MEMBER = exports.MODAL_TYPE_UNFOLLOW_MEMBER = 'unfollow-member';
var MODAL_TYPE_BLOCK_MEMBER = exports.MODAL_TYPE_BLOCK_MEMBER = 'block-member';
var MODAL_TYPE_UNBLOCK_MEMBER = exports.MODAL_TYPE_UNBLOCK_MEMBER = 'unblock-member';
var MODAL_TYPE_SHARE_POST = exports.MODAL_TYPE_SHARE_POST = 'share-post';
var MODAL_TYPE_SHARE_LINK = exports.MODAL_TYPE_SHARE_LINK = 'share-link';
var MODAL_TYPE_SHARE_COMMENT = exports.MODAL_TYPE_SHARE_COMMENT = 'share-comment';
var MODAL_TYPE_LOGIN = exports.MODAL_TYPE_LOGIN = 'login';
var MODAL_TYPE_TEXT_EDITOR_LINK = exports.MODAL_TYPE_TEXT_EDITOR_LINK = 'text-editor-link';
var MODAL_TYPE_TEXT_EDITOR_VIDEO_EMBED = exports.MODAL_TYPE_TEXT_EDITOR_VIDEO_EMBED = 'text-editor-video-embed';
var MODAL_TYPE_DEMO_MODE = exports.MODAL_TYPE_DEMO_MODE = 'demo-mode';

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
	function EventEmitter() {
		_classCallCheck(this, EventEmitter);

		this.observers = {};
	}

	EventEmitter.prototype.on = function on(events, listener) {
		var _this = this;

		events.split(' ').forEach(function (event) {
			_this.observers[event] = _this.observers[event] || [];
			_this.observers[event].push(listener);
		});
	};

	EventEmitter.prototype.off = function off(event, listener) {
		var _this2 = this;

		if (!this.observers[event]) {
			return;
		}

		this.observers[event].forEach(function () {
			if (!listener) {
				delete _this2.observers[event];
			} else {
				var index = _this2.observers[event].indexOf(listener);
				if (index > -1) {
					_this2.observers[event].splice(index, 1);
				}
			}
		});
	};

	EventEmitter.prototype.emit = function emit(event) {
		for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			args[_key - 1] = arguments[_key];
		}

		if (this.observers[event]) {
			this.observers[event].forEach(function (observer) {
				observer.apply(undefined, args);
			});
		}

		if (this.observers['*']) {
			this.observers['*'].forEach(function (observer) {
				var _ref;

				observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
			});
		}
	};

	return EventEmitter;
}();

exports.default = EventEmitter;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeString = makeString;
exports.copy = copy;
exports.setPath = setPath;
exports.pushPath = pushPath;
exports.getPath = getPath;
exports.deepExtend = deepExtend;
exports.regexEscape = regexEscape;
exports.escape = escape;
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (!object) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (!object) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }return target;
}

function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  } else {
    return data;
  }
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = {};

var setConfig = exports.setConfig = function setConfig() {
  var newConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  config = newConfig;
};

var getConfig = exports.getConfig = function getConfig() {
  return config;
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _createHocName = __webpack_require__(41);

var _createHocName2 = _interopRequireDefault(_createHocName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAME = 'WithEnvironment';

exports.default = function (config) {
  return function (WrappedComponent) {
    var WithEnvironment = function (_Component) {
      _inherits(WithEnvironment, _Component);

      function WithEnvironment() {
        _classCallCheck(this, WithEnvironment);

        return _possibleConstructorReturn(this, (WithEnvironment.__proto__ || Object.getPrototypeOf(WithEnvironment)).apply(this, arguments));
      }

      _createClass(WithEnvironment, [{
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = _lodash2.default.mapValues(config, function (path) {
            return _lodash2.default.get(_this2.context.environment, path);
          });

          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, props));
        }
      }]);

      return WithEnvironment;
    }(_react.Component);

    WithEnvironment.displayName = (0, _createHocName2.default)(NAME, WrappedComponent);


    WithEnvironment.contextTypes = {
      environment: _propTypes2.default.object.isRequired
    };

    (0, _hoistNonReactStatics2.default)(WithEnvironment, WrappedComponent);

    return WithEnvironment;
  };
};

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EXPERIMENT_NEW_LANGUAGES = exports.EXPERIMENT_NEW_LANGUAGES = 'specs.wixForum.NewLanguages';
var EXPERIMENT_DISABLE_ASDK = exports.EXPERIMENT_DISABLE_ASDK = 'specs.wixForum.DisableASDK';
var EXPERIMENT_DISABLE_FIX_VIEWPORT = exports.EXPERIMENT_DISABLE_FIX_VIEWPORT = 'specs.wixForum.DisableFixViewport';
var EXPERIMENT_CODE_BLOCK = exports.EXPERIMENT_CODE_BLOCK = 'specs.wixForum.CodeBlock';
var EXPERIMENT_HASHTAGS = exports.EXPERIMENT_HASHTAGS = 'specs.wixForum.Hashtags';
var EXPERIMENT_USE_NAVIGATE_TO_SECTION = exports.EXPERIMENT_USE_NAVIGATE_TO_SECTION = 'specs.wixForum.UseNavigateToSection';
var EXPERIMENT_INSTALL_MEMBERS = exports.EXPERIMENT_INSTALL_MEMBERS = 'specs.wixForum.InstallMembersApp';
var EXPERIMENT_SWITCH_NOTIFICATIONS_SERVICE = exports.EXPERIMENT_SWITCH_NOTIFICATIONS_SERVICE = 'specs.wixForum.SwitchNotificationsService';
var EXPERIMENT_UPGRADE_WITH_AUTOSAVE = exports.EXPERIMENT_UPGRADE_WITH_AUTOSAVE = 'specs.wixForum.UpgradeWithAutosave';
var EXPERIMENT_MEMBERS_AREA = exports.EXPERIMENT_MEMBERS_AREA = 'specs.wixForum.MembersArea';
var EXPERIMENT_HEADER_TOGGLE = exports.EXPERIMENT_HEADER_TOGGLE = 'specs.wixForum.HeaderToggle';
var EXPERIMENT_TOP_COMMENT = exports.EXPERIMENT_TOP_COMMENT = 'specs.wixForum.TopComment';

/***/ }),
/* 33 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nextProvider = exports.Interpolate = exports.translate = exports.loadNamespaces = undefined;

var _translate = __webpack_require__(218);

var _translate2 = _interopRequireDefault(_translate);

var _interpolate = __webpack_require__(219);

var _interpolate2 = _interopRequireDefault(_interpolate);

var _I18nextProvider = __webpack_require__(220);

var _I18nextProvider2 = _interopRequireDefault(_I18nextProvider);

var _loadNamespaces = __webpack_require__(221);

var _loadNamespaces2 = _interopRequireDefault(_loadNamespaces);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.loadNamespaces = _loadNamespaces2.default;
exports.translate = _translate2.default;
exports.Interpolate = _interpolate2.default;
exports.I18nextProvider = _I18nextProvider2.default;

/***/ }),
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openModal = undefined;

var _wixSdkUtils = __webpack_require__(21);

var _showModal = __webpack_require__(288);

var _openWixModal = __webpack_require__(651);

var _isInWix = __webpack_require__(77);

var openModal = exports.openModal = function openModal(type, props, focusOnCloseId) {
  return function (dispatch) {
    dispatch((0, _showModal.showModal)(type, props, { focusOnCloseId: focusOnCloseId }));

    if (!(0, _wixSdkUtils.isMobile)() && (0, _isInWix.isInWix)()) {
      dispatch((0, _openWixModal.openWixModal)(type, props));
    }
  };
};

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollParent;

var _app = __webpack_require__(455);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollParent() {
  return typeof window !== 'undefined' ? window.document.getElementsByClassName(_app2.default.scrollable)[0] || window.document.body : null;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wixParams = __webpack_require__(24);

var _withSettingsColor = __webpack_require__(68);

var _withSettingsColor2 = _interopRequireDefault(_withSettingsColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withSettingsColor2.default)(_wixParams.CARD_BACKGROUND_COLOR_PATH, 'cardBackgroundColor');

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _createAll2 = __webpack_require__(558);

var _createAll3 = _interopRequireDefault(_createAll2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);

var actionTypes = _createAll.actionTypes,
    addArrayValue = _createAll.addArrayValue,
    autofill = _createAll.autofill,
    autofillWithKey = _createAll.autofillWithKey,
    blur = _createAll.blur,
    change = _createAll.change,
    changeWithKey = _createAll.changeWithKey,
    destroy = _createAll.destroy,
    focus = _createAll.focus,
    reducer = _createAll.reducer,
    reduxForm = _createAll.reduxForm,
    removeArrayValue = _createAll.removeArrayValue,
    getValues = _createAll.getValues,
    initialize = _createAll.initialize,
    initializeWithKey = _createAll.initializeWithKey,
    propTypes = _createAll.propTypes,
    reset = _createAll.reset,
    startAsyncValidation = _createAll.startAsyncValidation,
    startSubmit = _createAll.startSubmit,
    stopAsyncValidation = _createAll.stopAsyncValidation,
    stopSubmit = _createAll.stopSubmit,
    swapArrayValues = _createAll.swapArrayValues,
    touch = _createAll.touch,
    touchWithKey = _createAll.touchWithKey,
    untouch = _createAll.untouch,
    untouchWithKey = _createAll.untouchWithKey;
exports.actionTypes = actionTypes;
exports.addArrayValue = addArrayValue;
exports.autofill = autofill;
exports.autofillWithKey = autofillWithKey;
exports.blur = blur;
exports.change = change;
exports.changeWithKey = changeWithKey;
exports.destroy = destroy;
exports.focus = focus;
exports.reducer = reducer;
exports.reduxForm = reduxForm;
exports.removeArrayValue = removeArrayValue;
exports.getValues = getValues;
exports.initialize = initialize;
exports.initializeWithKey = initializeWithKey;
exports.propTypes = propTypes;
exports.reset = reset;
exports.startAsyncValidation = startAsyncValidation;
exports.startSubmit = startSubmit;
exports.stopAsyncValidation = stopAsyncValidation;
exports.stopSubmit = stopSubmit;
exports.swapArrayValues = swapArrayValues;
exports.touch = touch;
exports.touchWithKey = touchWithKey;
exports.untouch = untouch;
exports.untouchWithKey = untouchWithKey;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createHocName;

var _getDisplayName = __webpack_require__(48);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createHocName(hocComponentName, WrappedComponent) {
  return hocComponentName + '(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextEditorButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOverlays = __webpack_require__(154);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _textEditorButton = __webpack_require__(700);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

var _tooltip = __webpack_require__(339);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditorButton = exports.TextEditorButton = function (_Component) {
  _inherits(TextEditorButton, _Component);

  function TextEditorButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextEditorButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextEditorButton.__proto__ || Object.getPrototypeOf(TextEditorButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isTooltipVisible: false
    }, _this.handleMouseDown = function (event) {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onClick = _this$props.onClick;


      event.preventDefault();
      _this.handleMouseLeave();
      if (onClick && !isDisabled) {
        onClick();
      }
    }, _this.handleMouseEnter = function () {
      _this.timeout = setTimeout(function () {
        _this.setState({
          isTooltipVisible: true
        });
      }, 500);
    }, _this.handleMouseLeave = function () {
      clearTimeout(_this.timeout);
      _this.setState({
        isTooltipVisible: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextEditorButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleMouseLeave();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props = this.props,
          className = _props.className,
          isActive = _props.isActive,
          isDisabled = _props.isDisabled,
          handleKeyUp = _props.onKeyUp,
          children = _props.children,
          tooltipText = _props.tooltipText,
          Icon = _props.icon,
          t = _props.t,
          theme = _props.theme;

      var isHighlighted = isActive && !isDisabled;
      var containerClassName = (0, _classnames2.default)(_textEditorButton2.default.button, className, 'text-editor-button', _defineProperty({}, _textEditorButton2.default.isHighlighted, isHighlighted));
      var iconClassName = (0, _classnames2.default)(_textEditorButton2.default.icon, (_classNames2 = {}, _defineProperty(_classNames2, (0, _lodash.get)(theme, 'icon.normal'), !isHighlighted), _defineProperty(_classNames2, (0, _lodash.get)(theme, 'icon.highlighted'), isHighlighted), _classNames2));
      var iconHoverClassName = (0, _classnames2.default)(_textEditorButton2.default.icon, _textEditorButton2.default.iconHover, (0, _lodash.get)(theme, 'icon.hover'));

      return _react2.default.createElement(
        'div',
        {
          className: containerClassName,
          onKeyUp: handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          disabled: isDisabled,
          'aria-label': t(tooltipText),
          tabIndex: '0'
        },
        _react2.default.createElement(Icon, { className: iconClassName }),
        _react2.default.createElement(Icon, { className: iconHoverClassName }),
        children,
        _react2.default.createElement(
          _reactOverlays.Overlay,
          {
            show: this.state.isTooltipVisible,
            placement: 'top',
            container: (0, _scrollParent2.default)(),
            target: this,
            onHide: this.handleMouseLeave,
            rootClose: true
          },
          _react2.default.createElement(
            _tooltip2.default,
            { theme: (0, _lodash.get)(theme, 'tooltip') },
            t(tooltipText)
          )
        )
      );
    }
  }]);

  return TextEditorButton;
}(_react.Component);

TextEditorButton.propTypes = {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func,
  isActive: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  onKeyUp: _propTypes2.default.func,
  children: _propTypes2.default.node,
  tooltipText: _propTypes2.default.string,
  t: _propTypes2.default.func,
  theme: _propTypes2.default.object
};
exports.default = (0, _withTranslate2.default)(TextEditorButton);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withCardBorderWidth;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _wixParams = __webpack_require__(24);

var params = _interopRequireWildcard(_wixParams);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _getDisplayName = __webpack_require__(48);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _getLayoutName = __webpack_require__(223);

var _getLayoutName2 = _interopRequireDefault(_getLayoutName);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_WIDTH = 1;

function withCardBorderWidth(WrappedComponent) {
  var _class, _temp;

  var Wrapper = (_temp = _class = function (_Component) {
    _inherits(Wrapper, _Component);

    function Wrapper() {
      _classCallCheck(this, Wrapper);

      return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
    }

    _createClass(Wrapper, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            layoutType = _props.layoutType,
            cardSize = _props.cardSize,
            borderWidthClassic = _props.borderWidthClassic,
            borderWidthSmall = _props.borderWidthSmall,
            borderWidthMedium = _props.borderWidthMedium,
            borderWidthLarge = _props.borderWidthLarge,
            otherProps = _objectWithoutProperties(_props, ['layoutType', 'cardSize', 'borderWidthClassic', 'borderWidthSmall', 'borderWidthMedium', 'borderWidthLarge']);

        var layoutName = (0, _getLayoutName2.default)(layoutType, cardSize);
        var borderWidth = void 0;

        switch (layoutName) {
          case 'classic':
            borderWidth = borderWidthClassic;
            break;
          case 'small':
            borderWidth = borderWidthSmall;
            break;
          case 'medium':
            borderWidth = borderWidthMedium;
            break;
          case 'large':
            borderWidth = borderWidthLarge;
            break;
          default:
            borderWidth = DEFAULT_WIDTH;
        }

        return _react2.default.createElement(WrappedComponent, _extends({ borderWidth: _lodash2.default.isNumber(borderWidth) ? borderWidth : DEFAULT_WIDTH }, otherProps));
      }
    }]);

    return Wrapper;
  }(_react.Component), _class.displayName = 'WithCardBorderWidth(' + (0, _getDisplayName2.default)(WrappedComponent) + ')', _class.propTypes = {
    layoutType: _propTypes2.default.number,
    cardSize: _propTypes2.default.number,
    borderWidthClassic: _propTypes2.default.number,
    borderWidthSmall: _propTypes2.default.number,
    borderWidthMedium: _propTypes2.default.number,
    borderWidthLarge: _propTypes2.default.number
  }, _temp);

  (0, _hoistNonReactStatics2.default)(Wrapper, WrappedComponent);

  return (0, _withAppSettings2.default)({
    layoutType: params.LAYOUT_TYPE_PATH,
    cardSize: params.CARD_SIZE_PATH,
    borderWidthClassic: params.BORDER_WIDTH_CLASSIC_PATH,
    borderWidthSmall: params.BORDER_WIDTH_SMALL_PATH,
    borderWidthMedium: params.BORDER_WIDTH_MEDIUM_PATH,
    borderWidthLarge: params.BORDER_WIDTH_LARGE_PATH
  })(Wrapper);
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(251);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(252);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(440);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(441);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var buildPaginationRequestParams = exports.buildPaginationRequestParams = function buildPaginationRequestParams(page, pageSize) {
  if (page !== undefined) {
    return {
      offset: (page - 1) * pageSize,
      size: pageSize
    };
  }
  return {};
};

var getLastPage = exports.getLastPage = function getLastPage(entityCount, pageSize) {
  return Math.ceil(entityCount / pageSize);
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSectionUrlByPageUrl = exports.getAppDefinitionIdByPageUrl = exports.getApplicationConfig = exports.getCommunitiesContext = undefined;

var _lodash = __webpack_require__(2);

var getCommunitiesContext = exports.getCommunitiesContext = function getCommunitiesContext(state) {
  return state.communitiesContext;
};

var getApplicationConfig = exports.getApplicationConfig = function getApplicationConfig(state, appDefinitionId) {
  return (0, _lodash.get)(getCommunitiesContext(state), appDefinitionId, {});
};

var getAppDefinitionIdByPageUrl = exports.getAppDefinitionIdByPageUrl = function getAppDefinitionIdByPageUrl(state, url) {
  return (0, _lodash.findKey)(getCommunitiesContext(state), function (_ref) {
    var sectionUrl = _ref.sectionUrl;
    return url.indexOf(sectionUrl) === 0;
  });
};

var getSectionUrlByPageUrl = exports.getSectionUrlByPageUrl = function getSectionUrlByPageUrl(state, url) {
  return (0, _lodash.get)((0, _lodash.find)(getCommunitiesContext(state), function (_ref2) {
    var sectionUrl = _ref2.sectionUrl;
    return url.indexOf(sectionUrl) === 0;
  }), 'sectionUrl');
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var handleKeyUp = exports.handleKeyUp = function handleKeyUp(keyCode, handler) {
  return function (event) {
    event.keyCode === keyCode && handler(event);
  };
};

var handleKeysUp = function handleKeysUp(keyCodes, handler) {
  return function (event) {
    keyCodes.includes(event.keyCode) && handler(event);
  };
};

var handleEnterKeyUp = exports.handleEnterKeyUp = function handleEnterKeyUp(handler) {
  return function (event) {
    return handleKeyUp(13, handler)(event);
  };
};
var handleEscapeKeyUp = exports.handleEscapeKeyUp = function handleEscapeKeyUp(handler) {
  return function (event) {
    return handleKeyUp(27, handler)(event);
  };
};
var handleTabKeyUp = exports.handleTabKeyUp = function handleTabKeyUp(handler) {
  return function (event) {
    return handleKeyUp(9, handler)(event);
  };
};
var handleEnterAndSpaceKeyUp = exports.handleEnterAndSpaceKeyUp = function handleEnterAndSpaceKeyUp(handler) {
  return function (event) {
    return handleKeysUp([13, 32], handler)(event);
  };
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _buttonGroup = __webpack_require__(628);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _buttonGroup2.default;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

/* eslint-disable space-before-keywords */

exports.default = function (EmbeddedComponent, props) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(EmbeddedComponent, _extends({}, this.props, props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = 'Decorated(' + getDisplayName(EmbeddedComponent) + ')', _temp;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUTTON_BOLD = exports.BUTTON_BOLD = 'bold';
var BUTTON_ITALIC = exports.BUTTON_ITALIC = 'italic';
var BUTTON_TITLE = exports.BUTTON_TITLE = 'header-one';
var BUTTON_SUBTITLE = exports.BUTTON_SUBTITLE = 'header-two';
var BUTTON_NUMBERING = exports.BUTTON_NUMBERING = 'ordered-list-item';
var BUTTON_BULLETS = exports.BUTTON_BULLETS = 'unordered-list-item';
var BUTTON_BLOCKQUOTE = exports.BUTTON_BLOCKQUOTE = 'blockquote';
var BUTTON_CODE_BLOCK = exports.BUTTON_CODE_BLOCK = 'code-block';
var BUTTON_LINK = exports.BUTTON_LINK = 'link';

var BUTTON_ALIGN_LEFT = exports.BUTTON_ALIGN_LEFT = 'left';
var BUTTON_ALIGN_RIGHT = exports.BUTTON_ALIGN_RIGHT = 'right';
var BUTTON_ALIGN_CENTER = exports.BUTTON_ALIGN_CENTER = 'center';
var BUTTON_ALIGN_JUSTIFY = exports.BUTTON_ALIGN_JUSTIFY = 'justify';

var BUTTON_HEADER_DROPDOWN = exports.BUTTON_HEADER_DROPDOWN = 'header-dropdown';
var BUTTON_LIST_DROPDOWN = exports.BUTTON_LIST_DROPDOWN = 'list-dropdown';
var BUTTON_ALIGN_TEXT_DROPDOWN = exports.BUTTON_ALIGN_TEXT_DROPDOWN = 'align-text-dropdown';

var BUTTON_IMAGE = exports.BUTTON_IMAGE = 'image';
var BUTTON_IMAGE_MEDIA_DIALOG = exports.BUTTON_IMAGE_MEDIA_DIALOG = 'imageMediaDialog';
var BUTTON_VIDEO = exports.BUTTON_VIDEO = 'video';

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(65);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replace = exports.push = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _reactRouterRedux = __webpack_require__(44);

var _sdkQueryParams = __webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appendSdkQueryParams = function appendSdkQueryParams(to) {
  if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object') {
    return _extends({}, to, { query: _extends({}, (0, _sdkQueryParams.getQueryParams)(), to.query) });
  } else {
    var url = new _urijs2.default(to);
    url.search(_extends({}, (0, _sdkQueryParams.getQueryParams)(), url.search(true)));
    return url.toString();
  }
};

var push = exports.push = function push(to) {
  return (0, _reactRouterRedux.push)(appendSdkQueryParams(to));
};
var replace = exports.replace = function replace(to) {
  return (0, _reactRouterRedux.replace)(appendSdkQueryParams(to));
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withExperiment;

var _reactRedux = __webpack_require__(5);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _experimentsSelectors = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(config) {
  return function (state) {
    return _lodash2.default.mapValues(config, function (path) {
      return (0, _experimentsSelectors.isExperimentEnabled)(state, path);
    });
  };
};

function withExperiment(config) {
  return function (WrappedComponent) {
    return (0, _reactRedux.connect)(mapStateToProps(config), {})(WrappedComponent);
  };
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUTTON_CLICKED = exports.BUTTON_CLICKED = 'app/BUTTON_CLICKED';

var buttonClicked = exports.buttonClicked = function buttonClicked(payload) {
  return {
    type: BUTTON_CLICKED,
    payload: payload
  };
};

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeFailure = exports.subscribeSuccess = exports.subscribeRequest = exports.SUBSCRIBE_FAILURE = exports.SUBSCRIBE_SUCCESS = exports.SUBSCRIBE_REQUEST = undefined;
exports.subscribe = subscribe;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUBSCRIBE_REQUEST = exports.SUBSCRIBE_REQUEST = 'subscribe/REQUEST';
var SUBSCRIBE_SUCCESS = exports.SUBSCRIBE_SUCCESS = 'subscribe/SUCCESS';
var SUBSCRIBE_FAILURE = exports.SUBSCRIBE_FAILURE = 'subscribe/FAILURE';

var subscribeRequest = exports.subscribeRequest = (0, _createAction2.default)(SUBSCRIBE_REQUEST);
var subscribeSuccess = exports.subscribeSuccess = (0, _createAction2.default)(SUBSCRIBE_SUCCESS);
var subscribeFailure = exports.subscribeFailure = (0, _createAction2.default)(SUBSCRIBE_FAILURE);

function subscribe() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(subscribeRequest(entity));

    var promise = request.post('/_api/subscriptions/subscribe', entity);

    return promise.then(function () {
      return dispatch(subscribeSuccess(entity));
    }).catch(function () {
      return dispatch(subscribeFailure(entity));
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribeFailure = exports.unsubscribeSuccess = exports.unsubscribeRequest = exports.UNSUBSCRIBE_FAILURE = exports.UNSUBSCRIBE_SUCCESS = exports.UNSUBSCRIBE_REQUEST = undefined;
exports.unsubscribe = unsubscribe;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNSUBSCRIBE_REQUEST = exports.UNSUBSCRIBE_REQUEST = 'unsubscribe/REQUEST';
var UNSUBSCRIBE_SUCCESS = exports.UNSUBSCRIBE_SUCCESS = 'unsubscribe/SUCCESS';
var UNSUBSCRIBE_FAILURE = exports.UNSUBSCRIBE_FAILURE = 'unsubscribe/FAILURE';

var unsubscribeRequest = exports.unsubscribeRequest = (0, _createAction2.default)(UNSUBSCRIBE_REQUEST);
var unsubscribeSuccess = exports.unsubscribeSuccess = (0, _createAction2.default)(UNSUBSCRIBE_SUCCESS);
var unsubscribeFailure = exports.unsubscribeFailure = (0, _createAction2.default)(UNSUBSCRIBE_FAILURE);

function unsubscribe() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(unsubscribeRequest(entity));

    var promise = request.post('/_api/subscriptions/unsubscribe', entity);

    return promise.then(function () {
      return dispatch(unsubscribeSuccess(entity));
    }).catch(function () {
      return dispatch(unsubscribeFailure(entity));
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.makeFieldValue = makeFieldValue;
exports.isFieldValue = isFieldValue;
var flag = '_isFieldValue';
var isObject = function isObject(object) {
  return typeof object === 'object';
};

function makeFieldValue(object) {
  if (object && isObject(object)) {
    // This flag has to be enumerable, because otherwise it is not possible
    // to serialize object with this field.
    // The consequence is you lose information that particular field is
    // field or nested group of fields, so you're not able to fetch
    // field value from state when it has been affected in some way
    // by serializing/using immutable and so on.
    // @fixme marking field as leaf should be made in other way
    Object.defineProperty(object, flag, { value: true, enumerable: true });
  }
  return object;
}

function isFieldValue(object) {
  return !!(object && isObject(object) && object[flag]);
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _config = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (path, sectionUrl) {
  var url = new _urijs2.default(sectionUrl || (0, _config.getConfig)().sectionUrl || '');
  url.pathname(_lodash2.default.trimEnd(url.pathname(), '/') + path);
  return url.toString();
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _confirmation = __webpack_require__(627);

var _confirmation2 = _interopRequireDefault(_confirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _confirmation2.default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFocusableContainerId = exports.isAtomicBlockFocused = exports.cleanUpContent = exports.removeBlock = exports.removeEntity = exports.createEditorState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.insertLink = insertLink;
exports.hasLinksInSelection = hasLinksInSelection;
exports.removeLinksInSelection = removeLinksInSelection;

var _draftJs = __webpack_require__(10);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function insertLink(editorState, url) {
  var selection = getSelection(editorState);
  var contentStateWithEntity = editorState.getCurrentContent().createEntity('LINK', 'MUTABLE', { url: url });
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();

  var newSelection = selection;
  var newEditorState = void 0;

  if (!selection.isCollapsed()) {
    newEditorState = _draftJs.RichUtils.toggleLink(editorState, selection, entityKey);
  } else {
    var offset = selection.getStartOffset();
    var focusOffset = offset + url.length;
    var blockKey = selection.getStartKey();
    var linkRange = new _draftJs.SelectionState({
      anchorOffset: offset,
      anchorKey: blockKey,
      focusOffset: focusOffset,
      focusKey: blockKey
    });

    var content = editorState.getCurrentContent();
    var newContent = _draftJs.Modifier.insertText(content, selection, url);
    newEditorState = _draftJs.RichUtils.toggleLink(_draftJs.EditorState.push(editorState, newContent, 'insert-characters'), linkRange, entityKey);

    newSelection = new _draftJs.SelectionState({
      anchorOffset: focusOffset,
      anchorKey: blockKey,
      focusOffset: focusOffset,
      focusKey: blockKey
    });
  }

  return _draftJs.EditorState.forceSelection(newEditorState, newSelection);
}

function hasLinksInSelection(editorState) {
  return !!getSelectedLinks(editorState).length;
}

function removeLinksInSelection(editorState) {
  return getSelectedLinks(editorState).reduce(function (prevState, _ref) {
    var key = _ref.key,
        range = _ref.range;
    return removeLink(prevState, key, range);
  }, editorState);
}

function getSelectedLinks(editorState) {
  return (0, _lodash2.default)(getSelectedBlocks(editorState)).flatMap(function (block) {
    return getSelectedLinksInBlock(block, editorState);
  }).value();
}

function getSelectedBlocks(editorState) {
  var blocks = editorState.getCurrentContent().getBlocksAsArray();
  var selection = getSelection(editorState);
  var firstIndex = _lodash2.default.findIndex(blocks, function (block) {
    return block.getKey() === selection.getAnchorKey();
  });
  var lastIndex = _lodash2.default.findLastIndex(blocks, function (block) {
    return block.getKey() === selection.getFocusKey();
  });

  return blocks.slice(firstIndex, lastIndex + 1);
}

function getSelectedLinksInBlock(block, editorState) {
  var selectionRange = getSelectionRange(editorState, block);

  return getLinkRangesInBlock(block, editorState.getCurrentContent()).filter(function (linkRange) {
    return isInSelectionRange(selectionRange, linkRange);
  }).map(function (linkRange) {
    return {
      key: block.getKey(),
      range: linkRange
    };
  });
}

function getSelectionRange(editorState, block) {
  var selection = getSelection(editorState);
  var blockKey = block.getKey();
  var anchorKey = selection.getAnchorKey();
  var focusKey = selection.getFocusKey();
  var anchorOffset = selection.getAnchorOffset();
  var focusOffset = selection.getFocusOffset();
  var range = void 0;

  if (anchorKey === blockKey && focusKey === blockKey) {
    range = [anchorOffset, focusOffset];
  } else if (anchorKey === blockKey) {
    range = [anchorOffset, block.getLength()];
  } else if (focusKey === blockKey) {
    range = [0, focusOffset];
  } else {
    range = [0, block.getLength()];
  }

  return range;
}

function getLinkRangesInBlock(block, contentState) {
  var ranges = [];
  block.findEntityRanges(function (value) {
    var key = value.getEntity();
    return key && contentState.getEntity(key).type === 'LINK';
  }, function (start, end) {
    return ranges.push([start, end]);
  });

  return ranges;
}

function isInSelectionRange(_ref2, range) {
  var _ref3 = _slicedToArray(_ref2, 2),
      start = _ref3[0],
      end = _ref3[1];

  return !(start <= range[0] && end <= range[0]) && !(start >= range[1] && end >= range[1]);
}

function removeLink(editorState, blockKey, _ref4) {
  var _ref5 = _slicedToArray(_ref4, 2),
      start = _ref5[0],
      end = _ref5[1];

  var selection = _draftJs.SelectionState.createEmpty(blockKey);
  selection = selection.set('anchorOffset', start);
  selection = selection.set('focusOffset', end);

  return _draftJs.RichUtils.toggleLink(editorState, selection, null);
}

function getSelection(editorState) {
  var selection = editorState.getSelection();

  if (selection.getIsBackward()) {
    selection = new _draftJs.SelectionState({
      anchorKey: selection.getFocusKey(),
      anchorOffset: selection.getFocusOffset(),
      focusKey: selection.getAnchorKey(),
      focusOffset: selection.getAnchorOffset()
    });
  }

  return selection;
}

var createEditorState = exports.createEditorState = function createEditorState(contentState, decorator) {
  return contentState ? _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(contentState), decorator) : _draftJs.EditorState.createEmpty(decorator);
};

var removeEntity = exports.removeEntity = function removeEntity(editorState, blockKey, entityKey) {
  var blocksToRemove = [blockKey];
  var raw = (0, _draftJs.convertToRaw)(editorState.getCurrentContent());

  var blockIndex = _lodash2.default.findIndex(raw.blocks, function (block) {
    return block.key === blockKey;
  });
  var nextBlockIndex = blockIndex + 1;
  if (raw.blocks[nextBlockIndex]) {
    var nextBlock = raw.blocks[nextBlockIndex];
    if (nextBlock.type === 'unstyled' && !nextBlock.text.length) {
      blocksToRemove.push(nextBlock.key);
    }
  }

  var previousBlockIndex = blockIndex - 1;
  var blockToSelect = raw.blocks[previousBlockIndex] || raw.blocks[0];

  raw.blocks = _lodash2.default.filter(raw.blocks, function (block) {
    return blocksToRemove.indexOf(block.key) === -1;
  });
  delete raw.entityMap[entityKey];

  var currentSelection = _draftJs.SelectionState.createEmpty(blockToSelect.key);
  var nextState = createEditorState(raw);

  return _draftJs.EditorState.forceSelection(nextState, currentSelection);
};

var removeBlock = exports.removeBlock = function removeBlock(editorState, blockKey) {
  var contentState = editorState.getCurrentContent();
  var block = contentState.getBlockForKey(blockKey);
  var previousBlock = contentState.getBlockBefore(blockKey);
  var selectionRange = new _draftJs.SelectionState({
    anchorOffset: previousBlock.text.length,
    anchorKey: previousBlock.key,
    focusOffset: block.text.length,
    focusKey: blockKey
  });
  var newContentState = _draftJs.Modifier.removeRange(contentState, selectionRange, 'forward');
  return _draftJs.EditorState.push(editorState, newContentState, 'remove-range');
};

var cleanUpContent = exports.cleanUpContent = function cleanUpContent(content) {
  var isBlockEmpty = function isBlockEmpty(block) {
    return block.type === 'unstyled' && !block.text;
  };
  var createPredicate = function createPredicate(indexPredicate) {
    return function (block, index, blocks) {
      return !isBlockEmpty(block) || indexPredicate(index, blocks.length) || blocks.length < 2;
    };
  };

  var blocks = (0, _lodash2.default)(content.blocks).filter(function (_ref6) {
    var type = _ref6.type,
        entityRanges = _ref6.entityRanges;
    return type !== 'atomic' || entityRanges.length;
  }).filter(createPredicate(_lodash2.default.identity)).filter(createPredicate(function (index, blockCount) {
    return index !== blockCount - 1;
  })).value();

  return _extends({}, content, {
    blocks: blocks
  });
};

var isAtomicBlockFocused = exports.isAtomicBlockFocused = function isAtomicBlockFocused(editorState) {
  var _editorState$getSelec = editorState.getSelection(),
      anchorKey = _editorState$getSelec.anchorKey,
      focusKey = _editorState$getSelec.focusKey;

  var block = editorState.getCurrentContent().getBlockForKey(anchorKey).type;
  return anchorKey === focusKey && block === 'atomic';
};

var getFocusableContainerId = exports.getFocusableContainerId = function getFocusableContainerId(identifier) {
  return 'text-editor-container-' + identifier;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPrivate = exports.isBlocked = exports.isOwner = exports.getCurrentUserCounters = exports.getCurrentUserSlug = exports.getCurrentUserId = exports.getCurrentUserSettings = exports.getCurrentUser = undefined;

var _reselect = __webpack_require__(46);

var _userPrivacyStatus = __webpack_require__(290);

var getCurrentUser = exports.getCurrentUser = function getCurrentUser(state) {
  return state.auth.currentUser;
};

var getCurrentUserSettings = exports.getCurrentUserSettings = function getCurrentUserSettings(state) {
  return state.auth.currentUserSettings;
};

var getCurrentUserId = exports.getCurrentUserId = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser._id;
});

var getCurrentUserSlug = exports.getCurrentUserSlug = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser.slug;
});

var getCurrentUserCounters = exports.getCurrentUserCounters = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser.counters;
});

var isOwner = exports.isOwner = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return Boolean(currentUser && currentUser.isOwner);
});

var isBlocked = exports.isBlocked = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return Boolean(currentUser && currentUser.isBlocked);
});

var isPrivate = exports.isPrivate = (0, _reselect.createSelector)([getCurrentUser], function (currentUser) {
  return currentUser && currentUser.privacyStatus === _userPrivacyStatus.USER_PRIVACY_STATUS_PRIVATE;
});

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withSettingsColor;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _tinycolor = __webpack_require__(623);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

var _withAppSettings = __webpack_require__(71);

var _withAppSettings2 = _interopRequireDefault(_withAppSettings);

var _getDisplayName = __webpack_require__(48);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSettingsColor(path, propName, fallback) {
  var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  return function (WrappedComponent) {
    var Wrapper = function (_Component) {
      _inherits(Wrapper, _Component);

      function Wrapper() {
        _classCallCheck(this, Wrapper);

        return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
      }

      _createClass(Wrapper, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
              _props$color = _props.color,
              color = _props$color === undefined ? {} : _props$color,
              siteColors = _props.siteColors,
              otherProps = _objectWithoutProperties(_props, ['color', 'siteColors']);

          var colorCode = color.value || siteColors[fallback];
          var props = _extends(_defineProperty({}, propName, colorCode ? (0, _tinycolor2.default)(colorCode).setAlpha(alpha).toRgbString() : ''), otherProps);

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return Wrapper;
    }(_react.Component);

    Wrapper.displayName = 'withSettingsColor(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
    Wrapper.propTypes = {
      color: _propTypes2.default.object,
      siteColors: _propTypes2.default.object
    };


    (0, _hoistNonReactStatics2.default)(Wrapper, WrappedComponent);

    return (0, _withAppSettings2.default)({ color: path })(Wrapper);
  };
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserBySlug = exports.getUsersByIdList = exports.getUserById = exports.getUserMap = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserMap = exports.getUserMap = function getUserMap(state) {
  return state.users;
};

var getUserSlug = function getUserSlug(state, slug) {
  return slug;
};

var getUserById = exports.getUserById = function getUserById(state, userId) {
  return state.users[userId];
};

var getIdList = function getIdList(state, idList) {
  return idList;
};

var getUsersByIdList = exports.getUsersByIdList = (0, _reselect.createSelector)([getUserMap, getIdList], function (users, idList) {
  return _lodash2.default.map(idList, function (id) {
    return users[id];
  });
});

var getUserBySlug = exports.getUserBySlug = (0, _reselect.createSelector)([getUserMap, getUserSlug], function (users, slug) {
  return _lodash2.default.find(users, ['slug', slug]);
});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUser = exports.updateUserFailure = exports.updateUserSuccess = exports.updateUserRequest = exports.UPDATE_USER_FAILURE = exports.UPDATE_USER_SUCCESS = exports.UPDATE_USER_REQUEST = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_USER_REQUEST = exports.UPDATE_USER_REQUEST = 'user/UPDATE_REQUEST';
var UPDATE_USER_SUCCESS = exports.UPDATE_USER_SUCCESS = 'user/UPDATE_SUCCESS';
var UPDATE_USER_FAILURE = exports.UPDATE_USER_FAILURE = 'user/UPDATE_FAILURE';

var updateUserRequest = exports.updateUserRequest = function updateUserRequest(payload) {
  return { type: UPDATE_USER_REQUEST, payload: payload };
};
var updateUserSuccess = exports.updateUserSuccess = function updateUserSuccess(payload) {
  return { type: UPDATE_USER_SUCCESS, payload: payload };
};
var updateUserFailure = exports.updateUserFailure = function updateUserFailure() {
  return { type: UPDATE_USER_FAILURE };
};

var updateUser = exports.updateUser = function updateUser(userId, data) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(updateUserRequest({ _id: userId, data: data }));

    var promise = request.patch('/_api/users/' + userId, _lodash2.default.omit(data, '_id'));
    return promise.then(function (user) {
      return dispatch(updateUserSuccess(user));
    }).catch(function () {
      return dispatch(updateUserFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withAppSettings;

var _reactRedux = __webpack_require__(5);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _appSettingsSelectors = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSettings = function getSettings(state, config) {
  return _lodash2.default.mapValues(config, function (path, prop) {
    return _lodash2.default.get((0, _appSettingsSelectors.getAppSettings)(state), path || prop);
  });
};

var mapStateToProps = function mapStateToProps(config) {
  return function (state) {
    return _extends({}, getSettings(state, config), {
      siteColors: (0, _appSettingsSelectors.getSiteColors)(state)
    });
  };
};

function withAppSettings(config) {
  return function (WrappedComponent) {
    return (0, _reactRedux.connect)(mapStateToProps(config), {})(WrappedComponent);
  };
}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _button = __webpack_require__(629);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _button2.default;

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isInWix = exports.isInWix = function isInWix() {
  return typeof window !== 'undefined' && window.top !== window.self;
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCKET_USER_UPDATED = exports.setUserPermissions = exports.SOCKET_USER_PERMISSIONS_CHANGED = exports.USER_SET_PERMISSIONS = exports.newNotification = exports.SOCKET_NEW_NOTIFICATION = exports.NEW_NOTIFICATION = undefined;
exports.emitUserConnected = emitUserConnected;

var _wsActions = __webpack_require__(128);

var _wsChannel = __webpack_require__(151);

function emitUserConnected(user) {
  return (0, _wsActions.joinChannel)((0, _wsChannel.getChannel)({ type: 'user', _id: user._id }));
}

var NEW_NOTIFICATION = exports.NEW_NOTIFICATION = 'user/NEW_NOTIFICATION';
var SOCKET_NEW_NOTIFICATION = exports.SOCKET_NEW_NOTIFICATION = 'new notification';
var newNotification = exports.newNotification = function newNotification(payload) {
  return {
    type: NEW_NOTIFICATION,
    payload: payload
  };
};

var USER_SET_PERMISSIONS = exports.USER_SET_PERMISSIONS = 'user/SET_PERMISSIONS';
var SOCKET_USER_PERMISSIONS_CHANGED = exports.SOCKET_USER_PERMISSIONS_CHANGED = 'user permissions changed';
var setUserPermissions = exports.setUserPermissions = function setUserPermissions(payload) {
  return {
    type: USER_SET_PERMISSIONS,
    payload: payload
  };
};

var SOCKET_USER_UPDATED = exports.SOCKET_USER_UPDATED = 'user updated';

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUserFailure = exports.createUserSuccess = exports.createUserRequest = exports.CREATE_USER_FAILURE = exports.CREATE_USER_SUCCESS = exports.CREATE_USER_REQUEST = undefined;
exports.createUser = createUser;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CREATE_USER_REQUEST = exports.CREATE_USER_REQUEST = 'user/CREATE_REQUEST';
var CREATE_USER_SUCCESS = exports.CREATE_USER_SUCCESS = 'user/CREATE_SUCCESS';
var CREATE_USER_FAILURE = exports.CREATE_USER_FAILURE = 'user/CREATE_FAILURE';

var createUserRequest = exports.createUserRequest = function createUserRequest() {
  return { type: CREATE_USER_REQUEST };
};
var createUserSuccess = exports.createUserSuccess = function createUserSuccess(payload) {
  return { type: CREATE_USER_SUCCESS, payload: payload };
};
var createUserFailure = exports.createUserFailure = function createUserFailure() {
  return { type: CREATE_USER_FAILURE };
};

function createUser(user) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(createUserRequest());

    var data = _lodash2.default.omitBy(user, function (value) {
      return value === null;
    });
    var promise = request.post('/_api/users/', data);
    return promise.then(function (user) {
      return dispatch(createUserSuccess(user));
    }).catch(function () {
      return dispatch(createUserFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_CURRENT_USER = exports.SET_CURRENT_USER = 'user/SET_CURRENT';

var setCurrentUser = exports.setCurrentUser = function setCurrentUser(payload) {
  return function (dispatch) {
    dispatch({ type: SET_CURRENT_USER, payload: payload });
    return Promise.resolve();
  };
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertAPIOptions = convertAPIOptions;
exports.convertJSONOptions = convertJSONOptions;
exports.convertTOptions = convertTOptions;
exports.appendBackwardsAPI = appendBackwardsAPI;

var _logger = __webpack_require__(17);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertInterpolation(options) {

  options.interpolation = {
    unescapeSuffix: 'HTML'
  };

  options.interpolation.prefix = options.interpolationPrefix || '__';
  options.interpolation.suffix = options.interpolationSuffix || '__';
  options.interpolation.escapeValue = options.escapeInterpolation || false;

  options.interpolation.nestingPrefix = options.reusePrefix || '$t(';
  options.interpolation.nestingSuffix = options.reuseSuffix || ')';

  return options;
}

function convertAPIOptions(options) {
  if (options.resStore) options.resources = options.resStore;

  if (options.ns && options.ns.defaultNs) {
    options.defaultNS = options.ns.defaultNs;
    options.ns = options.ns.namespaces;
  } else {
    options.defaultNS = options.ns || 'translation';
  }

  if (options.fallbackToDefaultNS && options.defaultNS) options.fallbackNS = options.defaultNS;

  options.saveMissing = options.sendMissing;
  options.saveMissingTo = options.sendMissingTo || 'current';
  options.returnNull = options.fallbackOnNull ? false : true;
  options.returnEmptyString = options.fallbackOnEmpty ? false : true;
  options.returnObjects = options.returnObjectTrees;
  options.joinArrays = '\n';

  options.returnedObjectHandler = options.objectTreeKeyHandler;
  options.parseMissingKeyHandler = options.parseMissingKey;
  options.appendNamespaceToMissingKey = true;

  options.nsSeparator = options.nsseparator;
  options.keySeparator = options.keyseparator;

  if (options.shortcutFunction === 'sprintf') {
    options.overloadTranslationOptionHandler = function (args) {
      var values = [];

      for (var i = 1; i < args.length; i++) {
        values.push(args[i]);
      }

      return {
        postProcess: 'sprintf',
        sprintf: values
      };
    };
  }

  options.whitelist = options.lngWhitelist;
  options.preload = options.preload;
  if (options.load === 'current') options.load = 'currentOnly';
  if (options.load === 'unspecific') options.load = 'languageOnly';

  // backend
  options.backend = options.backend || {};
  options.backend.loadPath = options.resGetPath || 'locales/__lng__/__ns__.json';
  options.backend.addPath = options.resPostPath || 'locales/add/__lng__/__ns__';
  options.backend.allowMultiLoading = options.dynamicLoad;

  // cache
  options.cache = options.cache || {};
  options.cache.prefix = 'res_';
  options.cache.expirationTime = 7 * 24 * 60 * 60 * 1000;
  options.cache.enabled = options.useLocalStorage ? true : false;

  options = convertInterpolation(options);
  if (options.defaultVariables) options.interpolation.defaultVariables = options.defaultVariables;

  // TODO: deprecation
  // if (options.getAsync === false) throw deprecation error

  return options;
}

function convertJSONOptions(options) {
  options = convertInterpolation(options);
  options.joinArrays = '\n';

  return options;
}

function convertTOptions(options) {
  if (options.interpolationPrefix || options.interpolationSuffix || options.escapeInterpolation) {
    options = convertInterpolation(options);
  }

  options.nsSeparator = options.nsseparator;
  options.keySeparator = options.keyseparator;

  options.returnObjects = options.returnObjectTrees;

  return options;
}

function appendBackwardsAPI(i18n) {
  i18n.lng = function () {
    _logger2.default.deprecate('i18next.lng() can be replaced by i18next.language for detected language or i18next.languages for languages ordered by translation lookup.');
    return i18n.services.languageUtils.toResolveHierarchy(i18n.language)[0];
  };

  i18n.preload = function (lngs, cb) {
    _logger2.default.deprecate('i18next.preload() can be replaced with i18next.loadLanguages()');
    i18n.loadLanguages(lngs, cb);
  };

  i18n.setLng = function (lng, options, callback) {
    _logger2.default.deprecate('i18next.setLng() can be replaced with i18next.changeLanguage() or i18next.getFixedT() to get a translation function with fixed language or namespace.');
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.fixLng === true) {
      if (callback) return callback(null, i18n.getFixedT(lng));
    }

    i18n.changeLanguage(lng, callback);
  };

  i18n.addPostProcessor = function (name, fc) {
    _logger2.default.deprecate('i18next.addPostProcessor() can be replaced by i18next.use({ type: \'postProcessor\', name: \'name\', process: fc })');
    i18n.use({
      type: 'postProcessor',
      name: name,
      process: fc
    });
  };
}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : belgium-dutch (be-nl)
 * author : Dieter Luypaert : https://github.com/moeriki
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : ' mln',
            billion  : ' mld',
            trillion : ' bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;
            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€ '
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('be-nl', language);
    }
}());

/***/ }),
/* 84 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : simplified chinese
 * author : badplum : https://github.com/badplum
 */
(function () {
    var language = {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十亿',
            trillion: '兆'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '¥'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('chs', language);
    }
}());


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/*! @preserve
 * numeral.js language configuration
 * language : czech (cs)
 * author : Anatoli Papirovski : https://github.com/apapirovski
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'Kč'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('cs', language);
    }
}());


/***/ }),
/* 86 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : danish denmark (dk)
 * author : Michael Storgaard : https://github.com/mstorgaard
 */
(function () {
    var language = {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mio',
            billion: 'mia',
            trillion: 'b'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'DKK'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('da-dk', language);
    }
}());

/***/ }),
/* 87 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : German (de) – generally useful in Germany, Austria, Luxembourg, Belgium
 * author : Marco Krage : https://github.com/sinky
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('de', language);
    }
}());

/***/ }),
/* 88 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : German in Switzerland (de-ch)
 * author : Michael Piefel : https://github.com/piefel (based on work from Marco Krage : https://github.com/sinky)
 */ 
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'CHF'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('de-ch', language);
    }
}());

/***/ }),
/* 89 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : english united kingdom (uk)
 * author : Dan Ristic : https://github.com/dristic
 */
(function () {
    var language = {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '£'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('en-gb', language);
    }
}());

/***/ }),
/* 90 */
/***/ (function(module, exports) {

/*!
 * numeral.js language configuration
 * language : english south africa (uk)
 * author : Etienne Boshoff : etienne@zailab.com
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                    (b === 2) ? 'nd' :
                        (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: 'R'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('en-za', language);
    }
}());

/***/ }),
/* 91 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : spanish
 * author : Hernan Garcia : https://github.com/hgarcia
 */
(function () {
    var language = {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                (b === 7 || b === 0) ? 'mo' : 
		(b === 8) ? 'vo' :
		(b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('es', language);
    }
}());


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/*! @preserve
 * numeral.js language configuration
 * language : spanish Spain
 * author : Hernan Garcia : https://github.com/hgarcia
 */
(function () {
    var language = {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('es-ES', language);
    }
}());


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : Estonian
 * author : Illimar Tambek : https://github.com/ragulka
 *
 * Note: in Estonian, abbreviations are always separated
 * from numbers with a space
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tuh',
            million: ' mln',
            billion: ' mld',
            trillion: ' trl'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('et', language);
    }
}());


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : Finnish
 * author : Sami Saada : https://github.com/samitheberber
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('fi', language);
    }
}());


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : french (fr)
 * author : Adam Draper : https://github.com/adamwdraper
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('fr', language);
    }
}());

/***/ }),
/* 96 */
/***/ (function(module, exports) {

/*! @preserve
 * numeral.js language configuration
 * language : french (Canada) (fr-CA)
 * author : Léo Renaud-Allaire : https://github.com/renaudleo
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: '$'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('fr-CA', language);
    }
}());

/***/ }),
/* 97 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : french (fr-ch)
 * author : Adam Draper : https://github.com/adamwdraper
 */
(function () {
    var language = {
        delimiters: {
            thousands: '\'',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: 'CHF'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('fr-ch', language);
    }
}());


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/*! @preserve
 * numeral.js language configuration
 * language : Hungarian (hu)
 * author : Peter Bakondy : https://github.com/pbakondy
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'E',  // ezer
            million: 'M',   // millió
            billion: 'Mrd', // milliárd
            trillion: 'T'   // trillió
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: ' Ft'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('hu', language);
    }
}());

/***/ }),
/* 99 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : italian Italy (it)
 * author : Giacomo Trombi : http://cinquepunti.it
 */
(function () {
    var language = {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mila',
            million: 'mil',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('it', language);
    }
}());

/***/ }),
/* 100 */
/***/ (function(module, exports) {

/*! @preserve
 * numeral.js language configuration
 * language : japanese
 * author : teppeis : https://github.com/teppeis
 */
(function () {
    var language = {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十億',
            trillion: '兆'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '¥'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('ja', language);
    }
}());


/***/ }),
/* 101 */
/***/ (function(module, exports) {

/*! @preserve
 * numeral.js language configuration
 * language : Latvian (lv)
 * author : Lauris Bukšis-Haberkorns : https://github.com/Lafriks
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tūkst.',
            million: ' milj.',
            billion: ' mljrd.',
            trillion: ' trilj.'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    };
    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('lv', language);
    }
}());


/***/ }),
/* 102 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : netherlands-dutch (nl-nl)
 * author : Dave Clayton : https://github.com/davedx
 */
(function () {
    var language = {
        delimiters: {
            thousands: '.',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : 'mln',
            billion  : 'mrd',
            trillion : 'bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;
            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€ '
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('nl-nl', language);
    }
}());

/***/ }),
/* 103 */
/***/ (function(module, exports) {

/*! 
 * numeral.js language configuration
 * language : norwegian (bokmål)
 * author : Ove Andersen : https://github.com/azzlack
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'kr'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('nb-no', language);
        this.numeral.language('nn-no', language);
        this.numeral.language('no', language);
        this.numeral.language('nb', language);
        this.numeral.language('nn', language);
    }
}());

/***/ }),
/* 104 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : polish (pl)
 * author : Dominik Bulaj : https://github.com/dominikbulaj
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tys.',
            million: 'mln',
            billion: 'mld',
            trillion: 'bln'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'PLN'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('pl', language);
    }
}());

/***/ }),
/* 105 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : portuguese brazil (pt-br)
 * author : Ramiro Varandas Jr : https://github.com/ramirovjr
 */
(function () {
    var language = {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mil',
            million: 'milhões',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: 'R$'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('pt-br', language);
    }
}());

/***/ }),
/* 106 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : portuguese (pt-pt)
 * author : Diogo Resende : https://github.com/dresende
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('pt-pt', language);
    }
}());


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/*! @preserve
 * numeral.js language configuration
 * language : russian (ru)
 * author : Anatoli Papirovski : https://github.com/apapirovski
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн.',
            billion: 'млрд.',
            trillion: 'трлн.'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: 'руб.'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('ru', language);
    }
}());


/***/ }),
/* 108 */
/***/ (function(module, exports) {

// numeral.js language configuration
// language : Russian for the Ukraine (ru-UA)
// author : Anatoli Papirovski : https://github.com/apapirovski
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on 
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.'; 
        },
        currency: {
            symbol: '\u20B4'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('ru-UA', language);
    }
}());


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/*! @preserve
 * numeral.js language configuration
 * language : slovak (sk)
 * author : Ahmed Al Hafoudh : http://www.freevision.sk
 */
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('sk', language);
    }
}());


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : thai (th)
 * author : Sathit Jittanupat : https://github.com/jojosati
 */
(function () {
    var language = {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'พัน',
            million: 'ล้าน',
            billion: 'พันล้าน',
            trillion: 'ล้านล้าน'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '฿'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('th', language);
    }
}());


/***/ }),
/* 111 */
/***/ (function(module, exports) {

/*! @preserve 
 * numeral.js language configuration
 * language : turkish (tr)
 * author : Ecmel Ercan : https://github.com/ecmel, Erhan Gundogan : https://github.com/erhangundogan, Burak Yiğit Kaya: https://github.com/BYK
 */
(function () {
    var suffixes = {
            1: '\'inci',
            5: '\'inci',
            8: '\'inci',
            70: '\'inci',
            80: '\'inci',

            2: '\'nci',
            7: '\'nci',
            20: '\'nci',
            50: '\'nci',

            3: '\'üncü',
            4: '\'üncü',
            100: '\'üncü',

            6: '\'ncı',

            9: '\'uncu',
            10: '\'uncu',
            30: '\'uncu',

            60: '\'ıncı',
            90: '\'ıncı'
        },
        language = {
            delimiters: {
                thousands: '.',
                decimal: ','
            },
            abbreviations: {
                thousand: 'bin',
                million: 'milyon',
                billion: 'milyar',
                trillion: 'trilyon'
            },
            ordinal: function (number) {
                if (number === 0) {  // special case for zero
                    return '\'ıncı';
                }

                var a = number % 10,
                    b = number % 100 - a,
                    c = number >= 100 ? 100 : null;

              return suffixes[a] || suffixes[b] || suffixes[c];
            },
            currency: {
                symbol: '\u20BA'
            }
        };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('tr', language);
    }
}());


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// numeral.js language configuration
// language : Ukrainian for the Ukraine (uk-UA)
// author : Michael Piefel : https://github.com/piefel (with help from Tetyana Kuzmenko)
(function () {
    var language = {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тис.',
            million: 'млн',
            billion: 'млрд',
            trillion: 'блн'
        },
        ordinal: function () {
            // not ideal, but since in Ukrainian it can taken on 
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return ''; 
        },
        currency: {
            symbol: '\u20B4'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && this.numeral && this.numeral.language) {
        this.numeral.language('uk-UA', language);
    }
}());


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(225);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(232);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(115);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(65);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _userAvatarImage = __webpack_require__(824);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _userAvatarImage2.default;

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getExperiments = function getExperiments(state) {
  return state.experiments;
};

var isExperimentEnabled = exports.isExperimentEnabled = function isExperimentEnabled(state, name) {
  return getExperiments(state)[name] === 'true';
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(612);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(318);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withPermissions;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _createHocName = __webpack_require__(41);

var _createHocName2 = _interopRequireDefault(_createHocName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAME = 'WithPermissions';

/*
Which permissions checker should I use?

* can - use when you only care about if user can do action or not - using this carries a message
  that action is visible only when user can actually do it.
* canSee - use it when you want to show that user could do an action, even
  if he currently can't. For example - like a post as logged in, but private member.
  Using this should be accompanied by decorating for user to login or become a public member.
* canRender - use it everywhere where you render UI based on permissions. It checks
  both can and canSee.*/

var createPermissionsChecker = function createPermissionsChecker(permissions, isSee) {
  return function (permission, resource, obj) {
    return isSee ? permissions.canSee(permissions.resourcify(obj, resource), permission) : permissions.can(permissions.resourcify(obj, resource), permission);
  };
};

var createPermissionsRenderHelper = function createPermissionsRenderHelper(canSeeChecker, canChecker) {
  return function (permission, resource, obj, render) {
    var renderFunc = render ? render : obj;

    var can = canChecker(permission, resource, obj);
    var canSee = canSeeChecker(permission, resource, obj);
    return can || canSee ? renderFunc(can, canSee) : null;
  };
};

function withPermissions(WrappedComponent) {
  var WithPermissions = function (_Component) {
    _inherits(WithPermissions, _Component);

    function WithPermissions() {
      _classCallCheck(this, WithPermissions);

      return _possibleConstructorReturn(this, (WithPermissions.__proto__ || Object.getPrototypeOf(WithPermissions)).apply(this, arguments));
    }

    _createClass(WithPermissions, [{
      key: 'render',
      value: function render() {
        var canSeePermissionsHelper = createPermissionsChecker(this.context.permissions, true);
        var canPermissionsHelper = createPermissionsChecker(this.context.permissions, false);
        var permissionsRenderHelper = createPermissionsRenderHelper(canSeePermissionsHelper, canPermissionsHelper);
        return _react2.default.createElement(WrappedComponent, _extends({
          permissions: this.context.permissions,
          can: canPermissionsHelper,
          canSee: canSeePermissionsHelper,
          canRender: permissionsRenderHelper
        }, this.props));
      }
    }]);

    return WithPermissions;
  }(_react.Component);

  WithPermissions.displayName = (0, _createHocName2.default)(NAME, WrappedComponent);


  WithPermissions.contextTypes = {
    permissions: _propTypes2.default.object.isRequired
  };

  (0, _hoistNonReactStatics2.default)(WithPermissions, WrappedComponent);

  return WithPermissions;
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = sanitizeContent;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function sanitizeContent(_ref) {
  var content = _ref.content,
      rest = _objectWithoutProperties(_ref, ['content']);

  var blocks = _lodash2.default.map(content.blocks, removeRedundantTextAlignment);
  return _extends({}, rest, {
    content: _extends({}, content, {
      blocks: blocks
    })
  });
}

/*
 Removes text alignment from atomic blocks, because when atomic block is in selection range it's possible to set it's data.textAlignment prop.
 Removes left text alignment from text blocks, because it's a default value.
 */
function removeRedundantTextAlignment(block) {
  return block.type === 'atomic' ? omitTextAlignment(block) : omitLeftTextAlignment(block);
}

function omitLeftTextAlignment(block) {
  return block.data.textAlignment === 'left' ? omitTextAlignment(block) : block;
}

function omitTextAlignment(block) {
  return _lodash2.default.omit(block, 'data.textAlignment');
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTextEditorEntityData = exports.SET_TEXT_EDITOR_ENTITY_DATA = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_TEXT_EDITOR_ENTITY_DATA = exports.SET_TEXT_EDITOR_ENTITY_DATA = 'textEditor/SET_ENTITY_DATA';

var setTextEditorEntityData = exports.setTextEditorEntityData = (0, _createAction2.default)(SET_TEXT_EDITOR_ENTITY_DATA);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _config = __webpack_require__(29);

var _getInnerUrl = __webpack_require__(600);

var _getInnerUrl2 = _interopRequireDefault(_getInnerUrl);

var _getOuterUrl = __webpack_require__(63);

var _getOuterUrl2 = _interopRequireDefault(_getOuterUrl);

var _routerUtils = __webpack_require__(55);

var _wixSdkUtils = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

var InternalLink = function InternalLink(_ref) {
  var push = _ref.push,
      to = _ref.to,
      onClick = _ref.onClick,
      children = _ref.children,
      renderInSeo = _ref.renderInSeo,
      fullUrl = _ref.fullUrl,
      sectionUrl = _ref.sectionUrl,
      props = _objectWithoutProperties(_ref, ['push', 'to', 'onClick', 'children', 'renderInSeo', 'fullUrl', 'sectionUrl']);

  var linkProps = (0, _lodash.omit)(props, 'dispatch');

  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }
    if (event.defaultPrevented) {
      return;
    }

    if (!isModifiedEvent(event)) {
      event.preventDefault();
      event.stopPropagation();
      push(fullUrl ? (0, _getInnerUrl2.default)(to, sectionUrl) : to);
    }
  };

  var location = void 0;
  if (fullUrl) {
    location = new _urijs2.default(to);
  } else if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object') {
    location = new _urijs2.default((0, _getOuterUrl2.default)(to.pathname, sectionUrl));
    location.search(to.search);
    location.hash(to.hash);
  } else {
    location = new _urijs2.default((0, _getOuterUrl2.default)(to, sectionUrl));
  }

  if ((0, _wixSdkUtils.isSeoViewMode)() && !renderInSeo) {
    return _react2.default.createElement(
      'div',
      linkProps,
      children
    );
  }
  return _react2.default.createElement(
    'a',
    _extends({ target: '_top', href: location.toString(), onClick: handleClick }, linkProps),
    children
  );
};

InternalLink.propTypes = {
  push: _propTypes2.default.func,
  to: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node,
  renderInSeo: _propTypes2.default.bool,
  fullUrl: _propTypes2.default.bool,
  sectionUrl: _propTypes2.default.string
};

InternalLink.defaultProps = {
  renderInSeo: true
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var sectionUrl = _ref2.sectionUrl;
  return {
    sectionUrl: sectionUrl || (0, _config.getConfig)().sectionUrl
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
  var pushFn = _ref3.push;
  return (0, _redux.bindActionCreators)({ push: pushFn || _routerUtils.push }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InternalLink);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _moreButton = __webpack_require__(837);

var _moreButton2 = _interopRequireDefault(_moreButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _moreButton2.default;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emitMessage = emitMessage;
exports.joinChannel = joinChannel;
exports.leaveChannel = leaveChannel;
function emitMessage(eventName, channel, message) {
  return {
    type: 'WS_EMIT',
    payload: { eventName: eventName, channel: channel, message: message }
  };
}

function joinChannel(channel) {
  return {
    type: 'WS_JOIN',
    payload: { channel: channel }
  };
}

function leaveChannel(channel) {
  return {
    type: 'WS_LEAVE',
    payload: { channel: channel }
  };
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoutMember = exports.LOGOUT_MEMBER_SUCCESS = undefined;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGOUT_MEMBER_SUCCESS = exports.LOGOUT_MEMBER_SUCCESS = 'member/LOGOUT_SUCCESS';

var logoutMember = exports.logoutMember = function logoutMember() {
  _wixSdkPolyfill2.default.logOutCurrentMember();
  return {
    type: LOGOUT_MEMBER_SUCCESS
  };
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProfilePostsFailure = exports.fetchProfilePostsSuccess = exports.fetchProfilePostsRequest = exports.FETCH_USER_POSTS_FAILURE = exports.FETCH_USER_POSTS_SUCCESS = exports.FETCH_USER_POSTS_REQUEST = undefined;
exports.default = fetchPostsByOwnerId;

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _createThunk = __webpack_require__(255);

var _pagination = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_USER_POSTS_REQUEST = exports.FETCH_USER_POSTS_REQUEST = 'userPosts/FETCH_REQUEST';
var FETCH_USER_POSTS_SUCCESS = exports.FETCH_USER_POSTS_SUCCESS = 'userPosts/FETCH_SUCCESS';
var FETCH_USER_POSTS_FAILURE = exports.FETCH_USER_POSTS_FAILURE = 'userPosts/FETCH_FAILURE';

var fetchProfilePostsRequest = exports.fetchProfilePostsRequest = (0, _createAction2.default)(FETCH_USER_POSTS_REQUEST);
var fetchProfilePostsSuccess = exports.fetchProfilePostsSuccess = (0, _createAction2.default)(FETCH_USER_POSTS_SUCCESS, function (payload) {
  return payload;
}, function (payload, meta) {
  return meta;
});
var fetchProfilePostsFailure = exports.fetchProfilePostsFailure = (0, _createAction2.default)(FETCH_USER_POSTS_FAILURE);

function fetchPostsByOwnerId(_ref) {
  var ownerId = _ref.ownerId,
      page = _ref.page,
      pageSize = _ref.pageSize;

  return (0, _createThunk.createThunk)(function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(fetchProfilePostsRequest({ ownerId: ownerId }));

    var params = (0, _pagination.buildPaginationRequestParams)(page, pageSize);
    return request((0, _urijs2.default)('/_api/posts/owner/' + ownerId).query(params), { parseHeaders: true }).then(function (_ref3) {
      var _ref3$body = _ref3.body,
          body = _ref3$body === undefined ? [] : _ref3$body,
          _ref3$headers = _ref3.headers,
          headers = _ref3$headers === undefined ? {} : _ref3$headers;
      return dispatch(fetchProfilePostsSuccess(body, {
        page: page,
        entityCount: parseInt(headers.get('Wix-Forum-TotalResults'), 10)
      }));
    }).catch(function () {
      return dispatch(fetchProfilePostsFailure({ ownerId: ownerId }));
    });
  });
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSearchFailure = exports.fetchSearchSuccess = exports.fetchSearchRequest = exports.FETCH_SEARCH_DEBOUNCED = exports.FETCH_SEARCH_FAILURE = exports.FETCH_SEARCH_SUCCESS = exports.FETCH_SEARCH_REQUEST = undefined;
exports.default = fetchSearch;
exports.fetchSearchDebounced = fetchSearchDebounced;
exports.fetchSearchWithCancel = fetchSearchWithCancel;

var _reduxDebounce = __webpack_require__(287);

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_SEARCH_REQUEST = exports.FETCH_SEARCH_REQUEST = 'search/FETCH_REQUEST';
var FETCH_SEARCH_SUCCESS = exports.FETCH_SEARCH_SUCCESS = 'search/FETCH_SUCCESS';
var FETCH_SEARCH_FAILURE = exports.FETCH_SEARCH_FAILURE = 'search/FETCH_FAILURE';
var FETCH_SEARCH_DEBOUNCED = exports.FETCH_SEARCH_DEBOUNCED = 'search/FETCH_DEBOUNCED';

var fetchSearchRequest = exports.fetchSearchRequest = (0, _createAction2.default)(FETCH_SEARCH_REQUEST);
var fetchSearchSuccess = exports.fetchSearchSuccess = (0, _createAction2.default)(FETCH_SEARCH_SUCCESS);
var fetchSearchFailure = exports.fetchSearchFailure = (0, _createAction2.default)(FETCH_SEARCH_FAILURE);

function fetchSearch(query) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchSearchRequest());

    var promise = request('/_api/search?q=' + query);

    return promise.then(function (results) {
      return dispatch(fetchSearchSuccess(results));
    }).catch(function () {
      return dispatch(fetchSearchFailure());
    }).then(function () {
      return promise;
    });
  };
}

function fetchSearchDebounced(query) {
  var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var action = fetchSearch(query);
  action.type = FETCH_SEARCH_DEBOUNCED;
  action.meta = { debounce: debounce };
  return action;
}

function fetchSearchWithCancel(query) {
  var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var minQueryLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (query.length >= minQueryLength) {
    return fetchSearchDebounced(query, debounce);
  }
  return {
    type: _reduxDebounce.CANCEL,
    payload: {
      type: FETCH_SEARCH_DEBOUNCED
    }
  };
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletePost = deletePost;
var DELETE_POST_REQUEST = exports.DELETE_POST_REQUEST = 'post/DELETE_REQUEST';
var DELETE_POST_SUCCESS = exports.DELETE_POST_SUCCESS = 'post/DELETE_SUCCESS';
var DELETE_POST_FAILURE = exports.DELETE_POST_FAILURE = 'post/DELETE_FAILURE';

function deletePost(postId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: DELETE_POST_REQUEST
    });

    var promise = request.delete('/_api/posts/' + postId);

    return promise.then(function () {
      return dispatch({
        type: DELETE_POST_SUCCESS,
        payload: postId
      });
    }).catch(function () {
      return dispatch({
        type: DELETE_POST_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getLanguage = exports.getLanguage = function getLanguage() {
  return getInitialI18n().lang || 'en';
};
var getTranslations = exports.getTranslations = function getTranslations() {
  return getInitialI18n().localeData;
};

function getInitialI18n() {
  return window.__INITIAL_I18N__ || {};
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isValid;
function isValid(error) {
  if (Array.isArray(error)) {
    return error.reduce(function (valid, errorValue) {
      return valid && isValid(errorValue);
    }, true);
  }
  if (error && typeof error === 'object') {
    return Object.keys(error).reduce(function (valid, key) {
      return valid && isValid(error[key]);
    }, true);
  }
  return !error;
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UPDATE_APP_SETTINGS_REQUEST = exports.UPDATE_APP_SETTINGS_REQUEST = 'appSettings/UPDATE_REQUEST';
var UPDATE_APP_SETTINGS_SUCCESS = exports.UPDATE_APP_SETTINGS_SUCCESS = 'appSettings/UPDATE_SUCCESS';
var UPDATE_APP_SETTINGS_FAILURE = exports.UPDATE_APP_SETTINGS_FAILURE = 'appSettings/UPDATE_FAILURE';
var UPDATE_APP_SETTINGS_ON_STORE = exports.UPDATE_APP_SETTINGS_ON_STORE = 'appSettings/UPDATE_ON_STORE';

var updateAppSettingsRequest = exports.updateAppSettingsRequest = function updateAppSettingsRequest(payload, externalId) {
  return {
    type: UPDATE_APP_SETTINGS_REQUEST,
    payload: payload,
    meta: {
      bi: {
        externalId: externalId
      }
    }
  };
};
var updateAppSettingsSuccess = exports.updateAppSettingsSuccess = function updateAppSettingsSuccess(payload) {
  return {
    type: UPDATE_APP_SETTINGS_SUCCESS,
    payload: payload
  };
};
var updateAppSettingsFailure = exports.updateAppSettingsFailure = function updateAppSettingsFailure() {
  return {
    type: UPDATE_APP_SETTINGS_FAILURE
  };
};

// eslint-disable-next-line max-params
var updateAppSettings = exports.updateAppSettings = function updateAppSettings(compId, externalId, viewMode, settings) {
  var isMainPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(updateAppSettingsRequest(settings, externalId));
    var newSettings = getState().appSettings;

    return request.post('/_api/settings?compId=' + compId + '&externalId=' + externalId + '&viewMode=' + viewMode + '&isMainPage=' + isMainPage, newSettings).then(function (responseData) {
      return dispatch(updateAppSettingsSuccess(responseData));
    }).catch(function () {
      return dispatch(updateAppSettingsFailure());
    });
  };
};

//onlly perform update localy - do not change the settings on server - this is used in wix change style in the editor (before save/publish)
var updateAppSettingsOnStore = exports.updateAppSettingsOnStore = function updateAppSettingsOnStore(payload) {
  return {
    type: UPDATE_APP_SETTINGS_ON_STORE,
    payload: payload
  };
};

var updateBooleanValueOnStore = exports.updateBooleanValueOnStore = function updateBooleanValueOnStore(key, value) {
  return updateAppSettingsOnStore({
    style: {
      booleans: _defineProperty({}, key, value)
    }
  });
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchComments = exports.fetchCommentsFailure = exports.fetchCommentsSuccess = exports.fetchCommentsRequest = exports.FETCH_COMMENTS_FAILURE = exports.FETCH_COMMENTS_SUCCESS = exports.FETCH_COMMENTS_REQUEST = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _pagination = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_COMMENTS_REQUEST = exports.FETCH_COMMENTS_REQUEST = 'comments/FETCH_REQUEST';
var FETCH_COMMENTS_SUCCESS = exports.FETCH_COMMENTS_SUCCESS = 'comments/FETCH_SUCCESS';
var FETCH_COMMENTS_FAILURE = exports.FETCH_COMMENTS_FAILURE = 'comments/FETCH_FAILURE';

var fetchCommentsRequest = exports.fetchCommentsRequest = (0, _createAction2.default)(FETCH_COMMENTS_REQUEST);
var fetchCommentsSuccess = exports.fetchCommentsSuccess = (0, _createAction2.default)(FETCH_COMMENTS_SUCCESS, function (payload) {
  return payload;
}, function (payload, meta) {
  return meta;
});
var fetchCommentsFailure = exports.fetchCommentsFailure = (0, _createAction2.default)(FETCH_COMMENTS_FAILURE);

var fetchComments = exports.fetchComments = function fetchComments(_ref) {
  var postId = _ref.postId,
      postSlug = _ref.postSlug,
      page = _ref.page,
      pageSize = _ref.pageSize;

  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(fetchCommentsRequest({ postId: postId, postSlug: postSlug }));

    var params = (0, _pagination.buildPaginationRequestParams)(page, pageSize);
    var promise = request((0, _urijs2.default)('/_api/posts/' + postId + '/comments').query(params), { parseHeaders: true });
    return promise.then(function (_ref3) {
      var _ref3$body = _ref3.body,
          body = _ref3$body === undefined ? [] : _ref3$body,
          _ref3$headers = _ref3.headers,
          headers = _ref3$headers === undefined ? {} : _ref3$headers;

      var payload = {
        comments: body,
        postId: postId,
        postSlug: postSlug
      };
      var meta = {
        page: page,
        entityCount: parseInt(headers.get('Wix-Forum-TotalResults'), 10)
      };
      var action = fetchCommentsSuccess(payload, meta);
      return dispatch(action);
    }).catch(function () {
      return dispatch(fetchCommentsFailure({ postSlug: postSlug }));
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCommentFailure = exports.deleteCommentSuccess = exports.deleteCommentRequest = exports.DELETE_COMMENT_FAILURE = exports.DELETE_COMMENT_SUCCESS = exports.DELETE_COMMENT_REQUEST = undefined;
exports.deleteComment = deleteComment;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELETE_COMMENT_REQUEST = exports.DELETE_COMMENT_REQUEST = 'comment/DELETE_REQUEST';
var DELETE_COMMENT_SUCCESS = exports.DELETE_COMMENT_SUCCESS = 'comment/DELETE_SUCCESS';
var DELETE_COMMENT_FAILURE = exports.DELETE_COMMENT_FAILURE = 'comment/DELETE_FAILURE';

var deleteCommentRequest = exports.deleteCommentRequest = (0, _createAction2.default)(DELETE_COMMENT_REQUEST);
var deleteCommentSuccess = exports.deleteCommentSuccess = (0, _createAction2.default)(DELETE_COMMENT_SUCCESS);
var deleteCommentFailure = exports.deleteCommentFailure = (0, _createAction2.default)(DELETE_COMMENT_FAILURE);

function deleteComment(_ref) {
  var postId = _ref.postId,
      commentId = _ref.commentId;

  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(deleteCommentRequest());

    var promise = request.delete('/_api/posts/' + postId + '/comments/' + commentId);

    return promise.then(function () {
      return dispatch(deleteCommentSuccess({ _id: commentId, postId: postId }));
    }).catch(function () {
      return dispatch(deleteCommentFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPostsFailure = exports.fetchPostsSuccess = exports.fetchPostsRequest = exports.FETCH_POSTS_FAILURE = exports.FETCH_POSTS_SUCCESS = exports.FETCH_POSTS_REQUEST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = fetchPosts;

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _pagination = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_POSTS_REQUEST = exports.FETCH_POSTS_REQUEST = 'posts/FETCH_REQUEST';
var FETCH_POSTS_SUCCESS = exports.FETCH_POSTS_SUCCESS = 'posts/FETCH_SUCCESS';
var FETCH_POSTS_FAILURE = exports.FETCH_POSTS_FAILURE = 'posts/FETCH_FAILURE';

var fetchPostsRequest = exports.fetchPostsRequest = (0, _createAction2.default)(FETCH_POSTS_REQUEST, function (payload) {
  return payload;
}, function (payload, meta) {
  return meta;
});
var fetchPostsSuccess = exports.fetchPostsSuccess = (0, _createAction2.default)(FETCH_POSTS_SUCCESS, function (payload) {
  return payload;
}, function (payload, meta) {
  return meta;
});
var fetchPostsFailure = exports.fetchPostsFailure = (0, _createAction2.default)(FETCH_POSTS_FAILURE, function (payload) {
  return payload;
}, function (payload, meta) {
  return meta;
});

function fetchPosts(_ref) {
  var categoryId = _ref.categoryId,
      page = _ref.page,
      pageSize = _ref.pageSize;

  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(fetchPostsRequest(undefined, { categoryId: categoryId }));

    var params = (0, _pagination.buildPaginationRequestParams)(page, pageSize);

    var promise = request((0, _urijs2.default)('/_api/posts').query(_extends({ categoryId: categoryId }, params)), { parseHeaders: true });

    return promise.then(function (_ref3) {
      var _ref3$body = _ref3.body,
          body = _ref3$body === undefined ? [] : _ref3$body,
          _ref3$headers = _ref3.headers,
          headers = _ref3$headers === undefined ? {} : _ref3$headers;
      return dispatch(fetchPostsSuccess(body, {
        categoryId: categoryId,
        page: page,
        entityCount: parseInt(headers.get('Wix-Forum-TotalResults'), 10)
      }));
    }).catch(function () {
      return dispatch(fetchPostsFailure(undefined, { categoryId: categoryId }));
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROMOTE_MODERATOR_REQUEST = exports.PROMOTE_MODERATOR_REQUEST = 'user/PROMOTE_MODERATOR_REQUEST';
var PROMOTE_MODERATOR_SUCCESS = exports.PROMOTE_MODERATOR_SUCCESS = 'user/PROMOTE_MODERATOR_SUCCESS';
var PROMOTE_MODERATOR_FAILURE = exports.PROMOTE_MODERATOR_FAILURE = 'user/PROMOTE_MODERATOR_FAILURE';

var promoteModeratorRequest = exports.promoteModeratorRequest = function promoteModeratorRequest() {
  return { type: PROMOTE_MODERATOR_REQUEST };
};
var promoteModeratorSuccess = exports.promoteModeratorSuccess = function promoteModeratorSuccess(payload) {
  return { type: PROMOTE_MODERATOR_SUCCESS, payload: payload };
};
var promoteModeratorFailure = exports.promoteModeratorFailure = function promoteModeratorFailure() {
  return { type: PROMOTE_MODERATOR_FAILURE };
};

var promoteModerator = exports.promoteModerator = function promoteModerator(userId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(promoteModeratorRequest());
    var promise = request.patch('/_api/users/' + userId + '/permissions', {
      role: 'moderator',
      moderate: ['all']
    });
    return promise.then(function (user) {
      return dispatch(promoteModeratorSuccess(user));
    }).catch(function () {
      return dispatch(promoteModeratorFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEMOTE_MODERATOR_REQUEST = exports.DEMOTE_MODERATOR_REQUEST = 'user/DEMOTE_MODERATOR_REQUEST';
var DEMOTE_MODERATOR_SUCCESS = exports.DEMOTE_MODERATOR_SUCCESS = 'user/DEMOTE_MODERATOR_SUCCESS';
var DEMOTE_MODERATOR_FAILURE = exports.DEMOTE_MODERATOR_FAILURE = 'user/DEMOTE_MODERATOR_FAILURE';

var demoteModeratorRequest = exports.demoteModeratorRequest = function demoteModeratorRequest() {
  return { type: DEMOTE_MODERATOR_REQUEST };
};
var demoteModeratorSuccess = exports.demoteModeratorSuccess = function demoteModeratorSuccess(payload) {
  return { type: DEMOTE_MODERATOR_SUCCESS, payload: payload };
};
var demoteModeratorFailure = exports.demoteModeratorFailure = function demoteModeratorFailure() {
  return { type: DEMOTE_MODERATOR_FAILURE };
};

var demoteModerator = exports.demoteModerator = function demoteModerator(userId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(demoteModeratorRequest());
    var promise = request.delete('/_api/users/' + userId + '/permissions');
    return promise.then(function (user) {
      return dispatch(demoteModeratorSuccess(user));
    }).catch(function () {
      return dispatch(demoteModeratorFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GatewayRegistry = function () {
  function GatewayRegistry() {
    _classCallCheck(this, GatewayRegistry);

    this._containers = {};
    this._children = {};

    // Unique key for children of a gateway
    this._currentId = 0;
  }

  GatewayRegistry.prototype._renderContainer = function _renderContainer(name) {
    var _this = this;

    if (!this._containers[name] || !this._children[name]) {
      return;
    }

    this._containers[name].setState({
      children: Object.keys(this._children[name]).sort().map(function (id) {
        return _this._children[name][id];
      })
    });
  };

  GatewayRegistry.prototype.addContainer = function addContainer(name, container) {
    this._containers[name] = container;
    this._renderContainer(name);
  };

  GatewayRegistry.prototype.removeContainer = function removeContainer(name) {
    this._containers[name] = null;
  };

  GatewayRegistry.prototype.addChild = function addChild(name, gatewayId, child) {
    this._children[name][gatewayId] = child;
    this._renderContainer(name);
  };

  GatewayRegistry.prototype.clearChild = function clearChild(name, gatewayId) {
    delete this._children[name][gatewayId];
  };

  GatewayRegistry.prototype.register = function register(name, child) {
    this._children[name] = this._children[name] || {};

    var gatewayId = name + "_" + this._currentId;
    this._children[name][gatewayId] = child;
    this._currentId += 1;

    return gatewayId;
  };

  GatewayRegistry.prototype.unregister = function unregister(name, gatewayId) {
    this.clearChild(name, gatewayId);
    this._renderContainer(name);
  };

  return GatewayRegistry;
}();

exports.default = GatewayRegistry;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(334);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(683);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getContainer;

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _props2 = __webpack_require__(239);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Base = function (_Component) {
  _inherits(Base, _Component);

  function Base() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Base);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Base.__proto__ || Object.getPrototypeOf(Base)).call.apply(_ref, [this].concat(args))), _this), _this.isReady = false, _this.startOnPlay = true, _this.durationOnPlay = false, _this.seekOnPlay = null, _this.onPlay = function () {
      var _this$props = _this.props,
          volume = _this$props.volume,
          onStart = _this$props.onStart,
          onPlay = _this$props.onPlay,
          onDuration = _this$props.onDuration,
          playbackRate = _this$props.playbackRate;

      if (_this.startOnPlay) {
        _this.setPlaybackRate(playbackRate);
        _this.setVolume(volume);
        onStart();
        _this.startOnPlay = false;
      }
      onPlay();
      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);
        _this.seekOnPlay = null;
      }
      if (_this.durationOnPlay) {
        onDuration(_this.getDuration());
        _this.durationOnPlay = false;
      }
    }, _this.onReady = function () {
      var _this$props2 = _this.props,
          onReady = _this$props2.onReady,
          playing = _this$props2.playing,
          onDuration = _this$props2.onDuration;

      _this.isReady = true;
      onReady();
      if (playing || _this.preloading) {
        _this.preloading = false;
        if (_this.loadOnReady) {
          _this.load(_this.loadOnReady);
          _this.loadOnReady = null;
        } else {
          _this.play();
        }
      }
      var duration = _this.getDuration();
      if (duration) {
        onDuration(duration);
      } else {
        _this.durationOnPlay = true;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Base, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var url = this.props.url;

      this.mounted = true;
      if (url) {
        this.load(url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          url = _props.url,
          playing = _props.playing,
          volume = _props.volume,
          playbackRate = _props.playbackRate;
      // Invoke player methods based on incoming props

      if (url !== nextProps.url && nextProps.url) {
        this.seekOnPlay = null;
        this.startOnPlay = true;
        this.load(nextProps.url);
      } else if (url && !nextProps.url) {
        this.stop();
        clearTimeout(this.updateTimeout);
      } else if (!playing && nextProps.playing) {
        this.play();
      } else if (playing && !nextProps.playing) {
        this.pause();
      } else if (volume !== nextProps.volume) {
        this.setVolume(nextProps.volume);
      } else if (playbackRate !== nextProps.playbackRate) {
        this.setPlaybackRate(nextProps.playbackRate);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.url !== nextProps.url;
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      var _this2 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && fraction !== 0) {
        this.seekOnPlay = fraction;
        setTimeout(function () {
          _this2.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
      }
    }
  }]);

  return Base;
}(_react.Component);

Base.propTypes = _props2.propTypes;
Base.defaultProps = _props2.defaultProps;
exports['default'] = Base;
module.exports = exports['default'];

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Base2 = __webpack_require__(144);

var _Base3 = _interopRequireDefault(_Base2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;

var FilePlayer = function (_Base) {
  _inherits(FilePlayer, _Base);

  function FilePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onPause = _props.onPause,
          onEnded = _props.onEnded,
          onError = _props.onError;

      this.player.addEventListener('canplay', this.onReady);
      this.player.addEventListener('play', this.onPlay);
      this.player.addEventListener('pause', function () {
        if (_this2.mounted) {
          onPause();
        }
      });
      this.player.addEventListener('ended', onEnded);
      this.player.addEventListener('error', onError);
      this.player.setAttribute('webkit-playsinline', '');
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props2 = this.props,
          onPause = _props2.onPause,
          onEnded = _props2.onEnded,
          onError = _props2.onError;

      this.player.removeEventListener('canplay', this.onReady);
      this.player.removeEventListener('play', this.onPlay);
      this.player.removeEventListener('pause', onPause);
      this.player.removeEventListener('ended', onEnded);
      this.player.removeEventListener('error', onError);
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'load',
    value: function load(url) {
      this.player.src = url;
    }
  }, {
    key: 'play',
    value: function play() {
      this.player.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.player.removeAttribute('src');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
      this.player.currentTime = this.getDuration() * fraction;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.duration;
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      if (!this.isReady) return null;
      return this.player.currentTime / this.getDuration();
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      if (!this.isReady || this.player.buffered.length === 0) return null;
      return this.player.buffered.end(0) / this.getDuration();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          url = _props3.url,
          loop = _props3.loop,
          controls = _props3.controls,
          fileConfig = _props3.fileConfig;

      var Media = AUDIO_EXTENSIONS.test(url) ? 'audio' : 'video';
      var style = {
        width: '100%',
        height: '100%',
        display: url ? 'block' : 'none'
      };
      return _react2['default'].createElement(Media, _extends({
        ref: this.ref,
        style: style,
        preload: 'auto',
        controls: controls,
        loop: loop
      }, fileConfig.attributes));
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return true;
    }
  }]);

  return FilePlayer;
}(_Base3['default']);

FilePlayer.displayName = 'FilePlayer';
exports['default'] = FilePlayer;
module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = exports.buildEmbedUrl = exports.isSupported = exports.getProvider = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YOUTUBE_PATTERNS = [function () {
  return (/https:\/\/www\.youtube\.com\/embed\/([a-z\-_\d]+)/gi
  );
}, function () {
  return (/https:\/\/www\.youtube\.com\/watch\?v=([a-z\-_\d]+)/gi
  );
}, function () {
  return (/https:\/\/m\.youtube\.com\/watch\?v=([a-z\-_\d]+)/gi
  );
}, function () {
  return (/https:\/\/youtu\.be\/([a-z\-_\d]+)/gi
  );
}];
var VIMEO_PATTERNS = [function () {
  return (/https:\/\/vimeo\.com\/(\d+)/gi
  );
}, function () {
  return (/https:\/\/player\.vimeo\.com\/video\/(\d+)/gi
  );
}];

var _isSupported = function _isSupported(patterns, url) {
  var result = false;
  patterns.map(function (fn) {
    return fn();
  }).forEach(function (pattern) {
    result = result || Boolean(pattern.exec(url));
  });
  return result;
};

var extractVideoId = function extractVideoId(patterns, url) {
  var result = void 0;
  patterns.map(function (fn) {
    return fn();
  }).forEach(function (pattern) {
    var matches = pattern.exec(url);
    if (matches) {
      result = matches[1];
    }
  });
  return result;
};

var PROVIDERS = [{
  isSupported: function isSupported(url) {
    return _isSupported(YOUTUBE_PATTERNS, url);
  },
  buildEmbedUrl: function buildEmbedUrl(url) {
    var videoId = extractVideoId(YOUTUBE_PATTERNS, url);
    return 'https://www.youtube.com/embed/' + videoId + '?enablejsapi=1';
  },
  buildUrl: function buildUrl(url) {
    var videoId = extractVideoId(YOUTUBE_PATTERNS, url);
    return 'https://youtu.be/' + videoId;
  }
}, {
  isSupported: function isSupported(url) {
    return _isSupported(VIMEO_PATTERNS, url);
  },
  buildEmbedUrl: function buildEmbedUrl(url) {
    var videoId = extractVideoId(VIMEO_PATTERNS, url);
    return 'https://player.vimeo.com/video/' + videoId + '?api=1';
  },
  buildUrl: function buildUrl(url) {
    var videoId = extractVideoId(VIMEO_PATTERNS, url);
    return 'https://vimeo.com/' + videoId;
  }
}];

var getProvider = exports.getProvider = function getProvider(url) {
  return _lodash2.default.find(PROVIDERS, function (provider) {
    return provider.isSupported(url);
  });
};

var isSupported = exports.isSupported = function isSupported(url) {
  return _lodash2.default.some(PROVIDERS, function (provider) {
    return provider.isSupported(url);
  });
};

var buildEmbedUrl = exports.buildEmbedUrl = function buildEmbedUrl(url) {
  return _lodash2.default.invoke(getProvider(url), 'buildEmbedUrl', url);
};

var buildUrl = exports.buildUrl = function buildUrl(url) {
  return _lodash2.default.invoke(getProvider(url), 'buildUrl', url);
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var detectNewline = __webpack_require__(778);

var DEFAULT = '\n';

/**
 * Detect the dominant newline character of a string
 * @param {String} text
 * @return {String}
 */
function getNewLine(text) {
  return detectNewline(text) || DEFAULT;
}

module.exports = getNewLine;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserById = undefined;

var _reselect = __webpack_require__(46);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUsers = function getUsers(state) {
  return state.search.members;
};

var getUserId = function getUserId(state, id) {
  return id;
};

var getUserById = exports.getUserById = (0, _reselect.createSelector)([getUsers, getUserId], function (users, id) {
  return _lodash2.default.find(users, ['_id', id]);
});

/***/ }),
/* 149 */,
/* 150 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChannel = getChannel;
exports.getForumChannel = getForumChannel;
function getChannel(entity) {
  return entity.type + '-' + entity._id;
}

function getForumChannel() {
  return 'forum';
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HIDE_MODAL = exports.HIDE_MODAL = 'modal/HIDE';

var hideModal = exports.hideModal = function hideModal(payload) {
  return {
    type: HIDE_MODAL,
    payload: payload
  };
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSite = exports.isPreview = exports.isEditor = exports.getViewMode = undefined;

var _viewModes = __webpack_require__(161);

var getViewMode = exports.getViewMode = function getViewMode(state) {
  return state.viewMode;
};

var isEditor = exports.isEditor = function isEditor(state) {
  return getViewMode(state) === _viewModes.VIEW_MODE_EDITOR;
};
var isPreview = exports.isPreview = function isPreview(state) {
  return getViewMode(state) === _viewModes.VIEW_MODE_PREVIEW;
};
var isSite = exports.isSite = function isSite(state) {
  return getViewMode(state) === _viewModes.VIEW_MODE_SITE;
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootCloseWrapper = exports.Transition = exports.Position = exports.Portal = exports.Overlay = exports.Modal = exports.AutoAffix = exports.Affix = undefined;

var _Affix2 = __webpack_require__(331);

var _Affix3 = _interopRequireDefault(_Affix2);

var _AutoAffix2 = __webpack_require__(685);

var _AutoAffix3 = _interopRequireDefault(_AutoAffix2);

var _Modal2 = __webpack_require__(686);

var _Modal3 = _interopRequireDefault(_Modal2);

var _Overlay2 = __webpack_require__(695);

var _Overlay3 = _interopRequireDefault(_Overlay2);

var _Portal2 = __webpack_require__(235);

var _Portal3 = _interopRequireDefault(_Portal2);

var _Position2 = __webpack_require__(337);

var _Position3 = _interopRequireDefault(_Position2);

var _Transition2 = __webpack_require__(699);

var _Transition3 = _interopRequireDefault(_Transition2);

var _RootCloseWrapper2 = __webpack_require__(338);

var _RootCloseWrapper3 = _interopRequireDefault(_RootCloseWrapper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Affix = _Affix3.default;
exports.AutoAffix = _AutoAffix3.default;
exports.Modal = _Modal3.default;
exports.Overlay = _Overlay3.default;
exports.Portal = _Portal3.default;
exports.Position = _Position3.default;
exports.Transition = _Transition3.default;
exports.RootCloseWrapper = _RootCloseWrapper3.default;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _imageLoader = __webpack_require__(740);

var _imageLoader2 = _interopRequireDefault(_imageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _imageLoader2.default;

/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_EXPERIMENTS = exports.SET_EXPERIMENTS = 'experiments/SET';

var setExperiments = exports.setExperiments = function setExperiments(payload) {
  return function (dispatch) {
    dispatch({ type: SET_EXPERIMENTS, payload: payload });
    return Promise.resolve();
  };
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchNotifications = exports.fetchNotificationsFailure = exports.fetchNotificationsSuccess = exports.fetchNotificationsRequest = exports.FETCH_NOTIFICATIONS_FAILURE = exports.FETCH_NOTIFICATIONS_SUCCESS = exports.FETCH_NOTIFICATIONS_REQUEST = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_NOTIFICATIONS_REQUEST = exports.FETCH_NOTIFICATIONS_REQUEST = 'notifications/REQUEST';
var FETCH_NOTIFICATIONS_SUCCESS = exports.FETCH_NOTIFICATIONS_SUCCESS = 'notifications/SUCCESS';
var FETCH_NOTIFICATIONS_FAILURE = exports.FETCH_NOTIFICATIONS_FAILURE = 'notifications/FAILURE';

var fetchNotificationsRequest = exports.fetchNotificationsRequest = (0, _createAction2.default)(FETCH_NOTIFICATIONS_REQUEST);
var fetchNotificationsSuccess = exports.fetchNotificationsSuccess = (0, _createAction2.default)(FETCH_NOTIFICATIONS_SUCCESS);
var fetchNotificationsFailure = exports.fetchNotificationsFailure = (0, _createAction2.default)(FETCH_NOTIFICATIONS_FAILURE);

var fetchNotifications = exports.fetchNotifications = function fetchNotifications() {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchNotificationsRequest());

    var promise = request('/_api/notifications');

    return promise.then(function (notifications) {
      return dispatch(fetchNotificationsSuccess(notifications));
    }).catch(function () {
      return dispatch(fetchNotificationsFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showMessage = exports.SHOW_MESSAGE = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_MESSAGE = exports.SHOW_MESSAGE = 'message/SHOW';
var showMessage = exports.showMessage = (0, _createAction2.default)(SHOW_MESSAGE, function (content) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
  return { content: content, type: type };
});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.incrementPostLikeCount = incrementPostLikeCount;
var INCREMENT_POST_LIKE_COUNT_REQUEST = exports.INCREMENT_POST_LIKE_COUNT_REQUEST = 'post/INCREMENT_LIKE_COUNT_REQUEST';
var INCREMENT_POST_LIKE_COUNT_SUCCESS = exports.INCREMENT_POST_LIKE_COUNT_SUCCESS = 'post/INCREMENT_LIKE_COUNT_SUCCESS';
var INCREMENT_POST_LIKE_COUNT_FAILURE = exports.INCREMENT_POST_LIKE_COUNT_FAILURE = 'post/INCREMENT_LIKE_COUNT_FAILURE';

var incrementPostLikeCountRequest = exports.incrementPostLikeCountRequest = function incrementPostLikeCountRequest(postId) {
  return {
    type: INCREMENT_POST_LIKE_COUNT_REQUEST,
    payload: { _id: postId }
  };
};

var incrementPostLikeCountFailure = exports.incrementPostLikeCountFailure = function incrementPostLikeCountFailure(postId) {
  return {
    type: INCREMENT_POST_LIKE_COUNT_FAILURE,
    payload: { _id: postId }
  };
};

var incrementPostLikeCountSuccess = exports.incrementPostLikeCountSuccess = function incrementPostLikeCountSuccess(postId, _ref) {
  var count = _ref.count,
      isLiked = _ref.isLiked;
  return {
    type: INCREMENT_POST_LIKE_COUNT_SUCCESS,
    payload: { _id: postId, likeCount: count, isLiked: isLiked }
  };
};

function incrementPostLikeCount(postId) {
  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(incrementPostLikeCountRequest(postId));
    var promise = request.post('/_api/posts/' + postId + '/likes');
    return promise.then(function (data) {
      return dispatch(incrementPostLikeCountSuccess(postId, data));
    }).catch(function () {
      return dispatch(incrementPostLikeCountFailure(postId));
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIEW_MODE_EDITOR = exports.VIEW_MODE_EDITOR = 'editor';
var VIEW_MODE_PREVIEW = exports.VIEW_MODE_PREVIEW = 'preview';
var VIEW_MODE_SITE = exports.VIEW_MODE_SITE = 'site';
var VIEW_MODE_DASHBOARD = exports.VIEW_MODE_DASHBOARD = 'dashboard';

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentLocationOuterUrl = exports.getPreviousLocation = exports.getCurrentLocation = exports.isInitialLocation = exports.getCount = undefined;

var _lodash = __webpack_require__(2);

var _reselect = __webpack_require__(46);

var _getOuterUrl = __webpack_require__(63);

var _getOuterUrl2 = _interopRequireDefault(_getOuterUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getItems = function getItems(state) {
  return (0, _lodash.get)(state, 'locationHistory.items');
};
var getCount = exports.getCount = function getCount(state) {
  return (0, _lodash.get)(getItems(state), 'count', 0);
};
var isInitialLocation = exports.isInitialLocation = function isInitialLocation(state) {
  return getCount(state) === 1;
};
var getCurrentLocation = exports.getCurrentLocation = (0, _reselect.createSelector)(getItems, function (items) {
  return items && items[items.length - 1];
});
var getPreviousLocation = exports.getPreviousLocation = (0, _reselect.createSelector)(getItems, function (items) {
  return items && items[items.length - 2];
});
var getCurrentLocationOuterUrl = exports.getCurrentLocationOuterUrl = function getCurrentLocationOuterUrl(state) {
  return getCurrentLocation(state) && (0, _getOuterUrl2.default)(getCurrentLocation(state).pathname);
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(164),
    getRawTag = __webpack_require__(385),
    objectToString = __webpack_require__(386);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(253);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPostFailure = exports.fetchPostSuccess = exports.fetchPostRequest = exports.FETCH_POST_FAILURE = exports.FETCH_POST_SUCCESS = exports.FETCH_POST_REQUEST = undefined;
exports.fetchPost = fetchPost;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_POST_REQUEST = exports.FETCH_POST_REQUEST = 'post/FETCH_REQUEST';
var FETCH_POST_SUCCESS = exports.FETCH_POST_SUCCESS = 'post/FETCH_SUCCESS';
var FETCH_POST_FAILURE = exports.FETCH_POST_FAILURE = 'post/FETCH_FAILURE';

var fetchPostRequest = exports.fetchPostRequest = (0, _createAction2.default)(FETCH_POST_REQUEST);
var fetchPostSuccess = exports.fetchPostSuccess = (0, _createAction2.default)(FETCH_POST_SUCCESS);
var fetchPostFailure = exports.fetchPostFailure = (0, _createAction2.default)(FETCH_POST_FAILURE);

function fetchPost(postSlug) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchPostRequest({ postSlug: postSlug }));

    var promise = request('/_api/posts/' + postSlug);

    return promise.then(function (post) {
      return dispatch(fetchPostSuccess({
        post: post,
        postSlug: postSlug
      }));
    }).catch(function () {
      return dispatch(fetchPostFailure({ postSlug: postSlug }));
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMMENTS_PER_PAGE = exports.COMMENTS_PER_PAGE = 20;
var POSTS_PER_PAGE = exports.POSTS_PER_PAGE = 20;
var LIKES_PER_PAGE = exports.LIKES_PER_PAGE = 20;
var MEMBERS_PER_PAGE = exports.MEMBERS_PER_PAGE = 18;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertTextEditorEntity = exports.INSERT_TEXT_EDITOR_ENTITY = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INSERT_TEXT_EDITOR_ENTITY = exports.INSERT_TEXT_EDITOR_ENTITY = 'textEditor/INSERT_ENTITY';

var insertTextEditorEntity = exports.insertTextEditorEntity = (0, _createAction2.default)(INSERT_TEXT_EDITOR_ENTITY);

/***/ }),
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserRole = exports.getUserRoleByApp = undefined;

var _lodash = __webpack_require__(2);

var _applications = __webpack_require__(25);

var getUserRoleByApp = exports.getUserRoleByApp = function getUserRoleByApp(user, appDefinitionId) {
  return (0, _lodash.get)(user, 'appStore[' + appDefinitionId + '].permissions.role');
};
var getUserRole = exports.getUserRole = function getUserRole(user) {
  return getUserRoleByApp(user, _applications.FORUM_APP_ID) || (0, _lodash.get)(user, 'permissions.role');
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appLoaded = exports.appLoadedBeforeImages = exports.appIsLoading = exports.APP_LOADED_BEFORE_IMAGES_STEP = exports.APP_LOADING_IN_PROGRESS_STEP = exports.APP_LOADED = exports.APP_LOADED_BEFORE_IMAGES = exports.APP_LOADING_IN_PROGRESS = exports.LOADING_SCRIPTS = exports.APP_LIFECYCLE_STATUS = undefined;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APP_LIFECYCLE_STATUS = exports.APP_LIFECYCLE_STATUS = '__APP_LIFECYCLE_STATUS__';

var LOADING_SCRIPTS = exports.LOADING_SCRIPTS = 'LOADING_SCRIPTS'; // eslint-disable-line no-unused-vars
var APP_LOADING_IN_PROGRESS = exports.APP_LOADING_IN_PROGRESS = 'APP_LOADING_IN_PROGRESS';
var APP_LOADED_BEFORE_IMAGES = exports.APP_LOADED_BEFORE_IMAGES = 'APP_LOADED_BEFORE_IMAGES';
var APP_LOADED = exports.APP_LOADED = 'APP_LOADED';

var APP_LOADING_IN_PROGRESS_STEP = exports.APP_LOADING_IN_PROGRESS_STEP = 0;
var APP_LOADED_BEFORE_IMAGES_STEP = exports.APP_LOADED_BEFORE_IMAGES_STEP = 1;

var createSetStatus = function createSetStatus(status, step) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$logInSdk = _ref.logInSdk,
        logInSdk = _ref$logInSdk === undefined ? false : _ref$logInSdk;

    (window || {})[APP_LIFECYCLE_STATUS] = status;

    if (status === APP_LOADED && logInSdk) {
      _wixSdkPolyfill2.default.Performance.applicationLoaded();
    }

    if (step !== undefined && logInSdk) {
      _wixSdkPolyfill2.default.Performance.applicationLoadingStep(step, status);
    }
  };
};

var appIsLoading = exports.appIsLoading = createSetStatus(APP_LOADING_IN_PROGRESS, APP_LOADING_IN_PROGRESS_STEP);
var appLoadedBeforeImages = exports.appLoadedBeforeImages = createSetStatus(APP_LOADED_BEFORE_IMAGES, APP_LOADED_BEFORE_IMAGES_STEP);
var appLoaded = exports.appLoaded = createSetStatus(APP_LOADED);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _requestCredentials = __webpack_require__(326);

Object.defineProperty(exports, 'TYPE_IMAGE', {
  enumerable: true,
  get: function get() {
    return _requestCredentials.TYPE_IMAGE;
  }
});
Object.defineProperty(exports, 'TYPE_VIDEO', {
  enumerable: true,
  get: function get() {
    return _requestCredentials.TYPE_VIDEO;
  }
});
var UPLOAD = exports.UPLOAD = 'fileUpload/UPLOAD';
var upload = exports.upload = function upload(file, type, onSuccess) {
  return {
    type: UPLOAD,
    payload: {
      file: file,
      type: type,
      onSuccess: onSuccess
    }
  };
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _propTypes2["default"].shape({
  subscribe: _propTypes2["default"].func.isRequired,
  dispatch: _propTypes2["default"].func.isRequired,
  getState: _propTypes2["default"].func.isRequired
});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(163),
    getPrototype = __webpack_require__(387),
    isObjectLike = __webpack_require__(254);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseGetParam = exports.setLocation = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var location = null;
if (typeof window !== 'undefined') {
  location = _lodash2.default.pick(window.location, ['search', 'pathname']);
}

var setLocation = exports.setLocation = function setLocation(newLocation) {
  location = newLocation;
};

var parseGetParam = exports.parseGetParam = function parseGetParam(val, search) {
  var result = '';
  var tmp = [];

  (search || location.search).substr(1).split('&').forEach(function (item) {
    tmp = item.split('=');
    if (tmp[0] === val) {
      result = decodeURIComponent(tmp[1]);
    }
  });

  if (!result) {
    var query = decodeURIComponent(location.pathname).split('?')[1];
    if (!query) {
      return '';
    }

    query.split('&').forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === val) {
        result = decodeURIComponent(tmp[1]);
      }
    });
  }

  return result;
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCommentFailure = exports.createCommentSuccess = exports.createCommentRequest = exports.CREATE_COMMENT_FAILURE = exports.CREATE_COMMENT_SUCCESS = exports.CREATE_COMMENT_REQUEST = undefined;
exports.createComment = createComment;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _sanitizeContent = __webpack_require__(124);

var _sanitizeContent2 = _interopRequireDefault(_sanitizeContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CREATE_COMMENT_REQUEST = exports.CREATE_COMMENT_REQUEST = 'comment/CREATE_REQUEST';
var CREATE_COMMENT_SUCCESS = exports.CREATE_COMMENT_SUCCESS = 'comment/CREATE_SUCCESS';
var CREATE_COMMENT_FAILURE = exports.CREATE_COMMENT_FAILURE = 'comment/CREATE_FAILURE';

var createCommentRequest = exports.createCommentRequest = (0, _createAction2.default)(CREATE_COMMENT_REQUEST);
var createCommentSuccess = exports.createCommentSuccess = (0, _createAction2.default)(CREATE_COMMENT_SUCCESS);
var createCommentFailure = exports.createCommentFailure = (0, _createAction2.default)(CREATE_COMMENT_FAILURE);

function createComment(postId) {
  var comment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(createCommentRequest());

    var promise = request.post('/_api/posts/' + postId + '/comments', (0, _sanitizeContent2.default)(comment));

    return promise.then(function (data) {
      return dispatch(createCommentSuccess(data));
    }).catch(function () {
      return dispatch(createCommentFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.movePost = movePost;
var MOVE_POST_REQUEST = exports.MOVE_POST_REQUEST = 'post/MOVE_REQUEST';
var MOVE_POST_SUCCESS = exports.MOVE_POST_SUCCESS = 'post/MOVE_SUCCESS';
var MOVE_POST_FAILURE = exports.MOVE_POST_FAILURE = 'post/MOVE_FAILURE';

function movePost(id, categoryId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: MOVE_POST_REQUEST
    });

    var promise = request.post('/_api/posts/' + id + '/move', { categoryId: categoryId });

    return promise.then(function (post) {
      return dispatch({
        type: MOVE_POST_SUCCESS,
        payload: post
      });
    }).catch(function () {
      return dispatch({
        type: MOVE_POST_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BLOCK_USER_REQUEST = exports.BLOCK_USER_REQUEST = 'user/BLOCK_REQUEST';
var BLOCK_USER_SUCCESS = exports.BLOCK_USER_SUCCESS = 'user/BLOCK_SUCCESS';
var BLOCK_USER_FAILURE = exports.BLOCK_USER_FAILURE = 'user/BLOCK_FAILURE';

var blockUserRequest = exports.blockUserRequest = function blockUserRequest() {
  return { type: BLOCK_USER_REQUEST };
};
var blockUserSuccess = exports.blockUserSuccess = function blockUserSuccess(payload) {
  return { type: BLOCK_USER_SUCCESS, payload: payload };
};
var blockUserFailure = exports.blockUserFailure = function blockUserFailure() {
  return { type: BLOCK_USER_FAILURE };
};

var blockUser = exports.blockUser = function blockUser(userId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(blockUserRequest());
    var promise = request.post('/_api/users/block/' + userId);
    return promise.then(function (user) {
      return dispatch(blockUserSuccess(user));
    }).catch(function () {
      return dispatch(blockUserFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNBLOCK_USER_REQUEST = exports.UNBLOCK_USER_REQUEST = 'user/UNBLOCK_REQUEST';
var UNBLOCK_USER_SUCCESS = exports.UNBLOCK_USER_SUCCESS = 'user/UNBLOCK_SUCCESS';
var UNBLOCK_USER_FAILURE = exports.UNBLOCK_USER_FAILURE = 'user/UNBLOCK_FAILURE';

var unblockUserRequest = exports.unblockUserRequest = function unblockUserRequest() {
  return { type: UNBLOCK_USER_REQUEST };
};
var unblockUserSuccess = exports.unblockUserSuccess = function unblockUserSuccess(payload) {
  return { type: UNBLOCK_USER_SUCCESS, payload: payload };
};
var unblockUserFailure = exports.unblockUserFailure = function unblockUserFailure() {
  return { type: UNBLOCK_USER_FAILURE };
};

var unblockUser = exports.unblockUser = function unblockUser(userId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(unblockUserRequest());
    var promise = request.post('/_api/users/unblock/' + userId);
    return request.post('/_api/users/unblock/' + userId).then(function (user) {
      return dispatch(unblockUserSuccess(user));
    }).catch(function () {
      return dispatch(unblockUserFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCategory = deleteCategory;
var DELETE_CATEGORY_REQUEST = exports.DELETE_CATEGORY_REQUEST = 'category/DELETE_REQUEST';
var DELETE_CATEGORY_SUCCESS = exports.DELETE_CATEGORY_SUCCESS = 'category/DELETE_SUCCESS';
var DELETE_CATEGORY_FAILURE = exports.DELETE_CATEGORY_FAILURE = 'category/DELETE_FAILURE';

var deleteCategoryRequest = function deleteCategoryRequest() {
  return { type: DELETE_CATEGORY_REQUEST };
};
var deleteCategorySuccess = function deleteCategorySuccess(payload) {
  return { type: DELETE_CATEGORY_SUCCESS, payload: payload };
};
var deleteCategoryFailure = function deleteCategoryFailure() {
  return { type: DELETE_CATEGORY_FAILURE };
};

function deleteCategory(categoryId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(deleteCategoryRequest());

    var promise = request.delete('/_api/categories/' + categoryId);

    return promise.then(function () {
      return dispatch(deleteCategorySuccess(categoryId));
    }).catch(function () {
      return dispatch(deleteCategoryFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['cs', 'da', 'de', 'en', 'es', 'fr', 'hi', 'it', 'ja', 'ko', 'nl', 'no', 'pl', 'pt', 'ru', 'sv', 'tr'];
var newForumLanguages = exports.newForumLanguages = ['bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'fr', 'hi', 'hu', 'id', 'it', 'ja', 'ko', 'ms', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sv', 'th', 'tl', 'tr', 'zh'];

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var forDevice = function forDevice(ComponentMobile, ComponentDesktop) {
  return (0, _withDeviceType2.default)(function (_ref) {
    var isMobile = _ref.isMobile,
        props = _objectWithoutProperties(_ref, ['isMobile']);

    var Component = isMobile ? ComponentMobile : ComponentDesktop;
    return _react2.default.createElement(Component, props);
  });
};

exports.default = forDevice;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_QUALITY = exports.RESIZE_COVER = exports.RESIZE_FIT = undefined;

var _RESIZE;

var _config = __webpack_require__(29);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RESIZE_FIT = exports.RESIZE_FIT = 'fit';
var RESIZE_COVER = exports.RESIZE_COVER = 'cover';
var DEFAULT_QUALITY = exports.DEFAULT_QUALITY = 80;

var DEFAULT_SIZE = 1000;

var RESIZE = (_RESIZE = {}, _defineProperty(_RESIZE, RESIZE_COVER, function (w, h, rw, rh) {
  if (rw > w || rh > h) {
    return {
      width: w,
      height: h
    };
  }

  var wRatio = rw / w;
  var hRatio = rh / h;
  var ratio = Math.max(wRatio, hRatio);
  return {
    width: Math.ceil(w * ratio),
    height: Math.ceil(h * ratio)
  };
}), _defineProperty(_RESIZE, RESIZE_FIT, function (w, h, rw, rh) {
  if (rw > w && rh > h) {
    return {
      width: w,
      height: h
    };
  }

  return {
    width: rw,
    height: rh
  };
}), _RESIZE);

// eslint-disable-next-line max-params

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fileName = _ref.file_name,
      w = _ref.width,
      h = _ref.height;

  var rw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SIZE;
  var rh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_SIZE;
  var quality = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_QUALITY;
  var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : RESIZE_FIT;

  if (fileName) {
    var _RESIZE$type = RESIZE[type](w, h, rw, rh),
        width = _RESIZE$type.width,
        height = _RESIZE$type.height;

    return 'https://' + (0, _config.getConfig)().imageHost + '/media/' + fileName + '/v1/fit/w_' + width + ',h_' + height + ',al_c,q_' + quality + '/file.jpg';
  }
  return '';
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMUNITIES_POPUP_BUTTON_CLICKED = exports.COMMUNITIES_POPUP_LOADED = exports.COMMUNITIES_POPUP_TOGGLED = exports.COMMUNITIES_POPUP_HIDE = exports.COMMUNITIES_POPUP_SHOW = undefined;
exports.initPopup = initPopup;
exports.showPopup = showPopup;
exports.hidePopup = hidePopup;
exports.popupLoaded = popupLoaded;
exports.popupToggled = popupToggled;
exports.sendButtonClicked = sendButtonClicked;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _modalTypes = __webpack_require__(26);

var _config = __webpack_require__(29);

var _viewMode = __webpack_require__(423);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMMUNITIES_POPUP_SHOW = exports.COMMUNITIES_POPUP_SHOW = 'COMMUNITIES_POPUP_SHOW';
var COMMUNITIES_POPUP_HIDE = exports.COMMUNITIES_POPUP_HIDE = 'COMMUNITIES_POPUP_HIDE';
var COMMUNITIES_POPUP_TOGGLED = exports.COMMUNITIES_POPUP_TOGGLED = 'COMMUNITIES_POPUP_TOGGLED';
var COMMUNITIES_POPUP_LOADED = exports.COMMUNITIES_POPUP_LOADED = 'COMMUNITIES_POPUP_LOADED';
var COMMUNITIES_POPUP_BUTTON_CLICKED = exports.COMMUNITIES_POPUP_BUTTON_CLICKED = 'COMMUNITIES_POPUP_BUTTON_CLICKED';

var openPopup = function openPopup(data, position) {
  var _window$location = window.location,
      protocol = _window$location.protocol,
      host = _window$location.host;

  var url = protocol + '//' + host + '/modal';
  _wixSdkPolyfill2.default.openPopup(url + '?data=' + data + '&section-url=' + (0, _config.getConfig)().sectionUrl, '1000%', 0, position, function () {}, _wixSdkPolyfill2.default.Theme.BARE);
};

var initPopupLowerPart = function initPopupLowerPart() {
  var position = {
    origin: _wixSdkPolyfill2.default.WindowOrigin.ABSOLUTE,
    placement: _wixSdkPolyfill2.default.WindowPlacement.BOTTOM_LEFT,
    x: 0,
    y: 0
  };

  var data = JSON.stringify({ type: _modalTypes.MODAL_TYPE_PROFILE_ACTIONS, props: {} });
  openPopup(data, position);
};

var initPopupUpperPart = function initPopupUpperPart() {
  var position = {
    origin: _wixSdkPolyfill2.default.WindowOrigin.ABSOLUTE,
    placement: _wixSdkPolyfill2.default.WindowPlacement.TOP_LEFT,
    x: 0,
    y: 0
  };

  var data = JSON.stringify({ type: _modalTypes.MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART, props: {} });
  openPopup(data, position);
};

function initPopup() {
  if ((0, _viewMode.isInEditor)()) {
    return;
  }
  initPopupUpperPart();
  initPopupLowerPart();
}

function showPopup(rect) {
  _wixSdkPolyfill2.default.getBoundingRectAndOffsets(function (data) {
    _wixSdkPolyfill2.default.PubSub.publish(COMMUNITIES_POPUP_SHOW, { x: data.offsets.x + rect.left + rect.width / 2, y: rect.bottom });
  });
}

function hidePopup() {
  _wixSdkPolyfill2.default.PubSub.publish(COMMUNITIES_POPUP_HIDE);
}

function popupLoaded() {
  _wixSdkPolyfill2.default.PubSub.publish(COMMUNITIES_POPUP_LOADED);
}

function popupToggled() {
  _wixSdkPolyfill2.default.PubSub.publish(COMMUNITIES_POPUP_TOGGLED);
}

function sendButtonClicked(_ref) {
  var type = _ref.type;

  _wixSdkPolyfill2.default.PubSub.publish(COMMUNITIES_POPUP_BUTTON_CLICKED, { type: type });
}

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(556);
var isArguments = __webpack_require__(557);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.initialState = exports.globalErrorKey = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _initialState, _behaviors;

var _actionTypes = __webpack_require__(191);

var _mapValues = __webpack_require__(192);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _read = __webpack_require__(299);

var _read2 = _interopRequireDefault(_read);

var _write = __webpack_require__(300);

var _write2 = _interopRequireDefault(_write);

var _getValuesFromState = __webpack_require__(301);

var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);

var _initializeState = __webpack_require__(302);

var _initializeState2 = _interopRequireDefault(_initializeState);

var _resetState = __webpack_require__(559);

var _resetState2 = _interopRequireDefault(_resetState);

var _setErrors = __webpack_require__(560);

var _setErrors2 = _interopRequireDefault(_setErrors);

var _fieldValue = __webpack_require__(62);

var _normalizeFields = __webpack_require__(561);

var _normalizeFields2 = _interopRequireDefault(_normalizeFields);

var _createInitialState = __webpack_require__(303);

var _createInitialState2 = _interopRequireDefault(_createInitialState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var globalErrorKey = exports.globalErrorKey = '_error';

var initialState = exports.initialState = (_initialState = {
  _active: undefined,
  _asyncValidating: false
}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);

var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
  var path = _ref.path,
      index = _ref.index,
      value = _ref.value,
      fields = _ref.fields;

  var array = (0, _read2.default)(path, state);
  var stateCopy = _extends({}, state);
  var arrayCopy = array ? [].concat(array) : [];
  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
  if (index === undefined) {
    arrayCopy.push(newValue);
  } else {
    arrayCopy.splice(index, 0, newValue);
  }
  return (0, _write2.default)(path, arrayCopy, stateCopy);
}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
  var field = _ref2.field,
      value = _ref2.value;

  return (0, _write2.default)(field, function (previous) {
    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true }),
        asyncError = _previous$value$autof.asyncError,
        submitError = _previous$value$autof.submitError,
        result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);

    return (0, _fieldValue.makeFieldValue)(result);
  }, state);
}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
  var field = _ref3.field,
      value = _ref3.value,
      touch = _ref3.touch;

  var _active = state._active,
      stateCopy = _objectWithoutProperties(state, ['_active']);

  if (_active && _active !== field) {
    // remove _active from state
    stateCopy._active = _active;
  }
  return (0, _write2.default)(field, function (previous) {
    var result = _extends({}, previous);
    if (value !== undefined) {
      result.value = value;
    }
    if (touch) {
      result.touched = true;
    }
    return (0, _fieldValue.makeFieldValue)(result);
  }, stateCopy);
}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
  var field = _ref4.field,
      value = _ref4.value,
      touch = _ref4.touch;

  return (0, _write2.default)(field, function (previous) {
    var _previous$value = _extends({}, previous, { value: value }),
        asyncError = _previous$value.asyncError,
        submitError = _previous$value.submitError,
        autofilled = _previous$value.autofilled,
        result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);

    if (touch) {
      result.touched = true;
    }
    return (0, _fieldValue.makeFieldValue)(result);
  }, state);
}, _behaviors[_actionTypes.DESTROY] = function () {
  return undefined;
}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
  var field = _ref5.field;

  var stateCopy = (0, _write2.default)(field, function (previous) {
    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
  }, state);
  stateCopy._active = field;
  return stateCopy;
}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
  var data = _ref6.data,
      fields = _ref6.fields,
      overwriteValues = _ref6.overwriteValues;

  return (0, _createInitialState2.default)(data, fields, state, overwriteValues);
}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
  var path = _ref7.path,
      index = _ref7.index;

  var array = (0, _read2.default)(path, state);
  var stateCopy = _extends({}, state);
  var arrayCopy = array ? [].concat(array) : [];
  if (index === undefined) {
    arrayCopy.pop();
  } else if (isNaN(index)) {
    delete arrayCopy[index];
  } else {
    arrayCopy.splice(index, 1);
  }
  return (0, _write2.default)(path, arrayCopy, stateCopy);
}, _behaviors[_actionTypes.RESET] = function (state) {
  var _extends2;

  return _extends({}, (0, _resetState2.default)(state), (_extends2 = {
    _active: undefined,
    _asyncValidating: false
  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = state._initialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
  var field = _ref8.field;

  return _extends({}, state, {
    _asyncValidating: field || true
  });
}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
  return _extends({}, state, {
    _submitting: true
  });
}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
  var _extends3;

  var errors = _ref9.errors;

  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends3 = {
    _asyncValidating: false
  }, _extends3[globalErrorKey] = errors && errors[globalErrorKey], _extends3));
}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
  var _extends4;

  var errors = _ref10.errors;

  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends4 = {}, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4._submitting = false, _extends4._submitFailed = !!(errors && Object.keys(errors).length), _extends4));
}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
  return _extends({}, state, {
    _submitFailed: true
  });
}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
  var path = _ref11.path,
      indexA = _ref11.indexA,
      indexB = _ref11.indexB;

  var array = (0, _read2.default)(path, state);
  var arrayLength = array.length;
  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
    return state; // do nothing
  }
  var stateCopy = _extends({}, state);
  var arrayCopy = [].concat(array);
  arrayCopy[indexA] = array[indexB];
  arrayCopy[indexB] = array[indexA];
  return (0, _write2.default)(path, arrayCopy, stateCopy);
}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
  var fields = _ref12.fields;

  return _extends({}, state, fields.reduce(function (accumulator, field) {
    return (0, _write2.default)(field, function (value) {
      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
    }, accumulator);
  }, state));
}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
  var fields = _ref13.fields;

  return _extends({}, state, fields.reduce(function (accumulator, field) {
    return (0, _write2.default)(field, function (value) {
      if (value) {
        var touched = value.touched,
            rest = _objectWithoutProperties(value, ['touched']);

        return (0, _fieldValue.makeFieldValue)(rest);
      }
      return (0, _fieldValue.makeFieldValue)(value);
    }, accumulator);
  }, state));
}, _behaviors);

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var behavior = behaviors[action.type];
  return behavior ? behavior(state, action) : state;
};

function formReducer() {
  var _extends10;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var form = action.form,
      key = action.key,
      rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare


  if (!form) {
    return state;
  }
  if (key) {
    var _extends7, _extends8;

    if (action.type === _actionTypes.DESTROY) {
      var _extends6;

      return _extends({}, state, (_extends6 = {}, _extends6[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
        var _extends5;

        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[stateKey] = state[form][stateKey], _extends5));
      }, {}), _extends6));
    }
    return _extends({}, state, (_extends8 = {}, _extends8[form] = _extends({}, state[form], (_extends7 = {}, _extends7[key] = reducer((state[form] || {})[key], rest), _extends7)), _extends8));
  }
  if (action.type === _actionTypes.DESTROY) {
    return Object.keys(state).reduce(function (accumulator, formName) {
      var _extends9;

      return formName === form ? accumulator : _extends({}, accumulator, (_extends9 = {}, _extends9[formName] = state[formName], _extends9));
    }, {});
  }
  return _extends({}, state, (_extends10 = {}, _extends10[form] = reducer(state[form], rest), _extends10));
}

/**
 * Adds additional functionality to the reducer
 */
function decorate(target) {
  target.plugin = function plugin(reducers) {
    var _this = this;

    // use 'function' keyword to enable 'this'
    return decorate(function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var result = _this(state, action);
      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
        return pluginReducer(result[key] || initialState, action);
      }));
    });
  };

  target.normalize = function normalize(normalizers) {
    var _this2 = this;

    // use 'function' keyword to enable 'this'
    return decorate(function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var result = _this2(state, action);
      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
        var runNormalize = function runNormalize(previous, currentResult) {
          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
          var formResult = _extends({}, initialState, currentResult);
          var values = (0, _getValuesFromState2.default)(formResult);
          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
        };
        if (action.key) {
          var _extends11;

          return _extends({}, result[form], (_extends11 = {}, _extends11[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends11));
        }
        return runNormalize(state[form], result[form]);
      }));
    });
  };

  return target;
}

exports.default = decorate(formReducer);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
var BLUR = exports.BLUR = 'redux-form/BLUR';
var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
var RESET = exports.RESET = 'redux-form/RESET';
var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = mapValues;
/**
 * Maps all the values in the given object through the given function and saves them, by key, to a result object
 */
function mapValues(obj, fn) {
  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
    var _extends2;

    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
  }, {}) : obj;
}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAppSettingsFailure = exports.fetchAppSettingsSuccess = exports.fetchAppSettingsRequest = exports.FETCH_APP_SETTINGS_FAILURE = exports.FETCH_APP_SETTINGS_SUCCESS = exports.FETCH_APP_SETTINGS_REQUEST = undefined;
exports.fetchAppSettings = fetchAppSettings;
exports.fetchPageAppSettings = fetchPageAppSettings;

var _createThunk = __webpack_require__(255);

var _wixSdkUtils = __webpack_require__(21);

var FETCH_APP_SETTINGS_REQUEST = exports.FETCH_APP_SETTINGS_REQUEST = 'appSettings/FETCH_REQUEST';
var FETCH_APP_SETTINGS_SUCCESS = exports.FETCH_APP_SETTINGS_SUCCESS = 'appSettings/FETCH_SUCCESS';
var FETCH_APP_SETTINGS_FAILURE = exports.FETCH_APP_SETTINGS_FAILURE = 'appSettings/FETCH_FAILURE';

var fetchAppSettingsRequest = exports.fetchAppSettingsRequest = function fetchAppSettingsRequest() {
  return {
    type: FETCH_APP_SETTINGS_REQUEST
  };
};
var fetchAppSettingsSuccess = exports.fetchAppSettingsSuccess = function fetchAppSettingsSuccess(payload) {
  return {
    type: FETCH_APP_SETTINGS_SUCCESS,
    payload: payload
  };
};
var fetchAppSettingsFailure = exports.fetchAppSettingsFailure = function fetchAppSettingsFailure() {
  return {
    type: FETCH_APP_SETTINGS_FAILURE
  };
};

function fetchAppSettings(search) {
  return (0, _createThunk.createThunk)(function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchAppSettingsRequest());

    var compId = (0, _wixSdkUtils.getCompId)(search);
    compId = compId === '' ? 'default' : compId;

    var viewMode = (0, _wixSdkUtils.getViewMode)(search);
    viewMode = viewMode === '' ? 'site' : viewMode;

    return request('/_api/settings?compId=' + compId + '&externalId=' + (0, _wixSdkUtils.getExternalId)(search) + '&viewMode=' + viewMode).then(function (settings) {
      return dispatch(fetchAppSettingsSuccess(settings));
    }).catch(function () {
      return dispatch(fetchAppSettingsFailure());
    });
  });
}

function fetchPageAppSettings(search) {
  return (0, _createThunk.createThunk)(function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(fetchAppSettingsRequest());

    var viewMode = (0, _wixSdkUtils.getViewMode)(search);
    viewMode = viewMode === '' ? 'site' : viewMode;

    return request('/_api/settings/page?viewMode=' + viewMode).then(function (settings) {
      return dispatch(fetchAppSettingsSuccess(settings));
    }).catch(function () {
      return dispatch(fetchAppSettingsFailure());
    });
  });
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFollowersFailure = exports.fetchFollowersSuccess = exports.fetchFollowersRequest = exports.FETCH_FOLLOWERS_FAILURE = exports.FETCH_FOLLOWERS_SUCCESS = exports.FETCH_FOLLOWERS_REQUEST = undefined;
exports.fetchFollowers = fetchFollowers;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _pagination = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_FOLLOWERS_REQUEST = exports.FETCH_FOLLOWERS_REQUEST = 'followers/FETCH_REQUEST';
var FETCH_FOLLOWERS_SUCCESS = exports.FETCH_FOLLOWERS_SUCCESS = 'followers/FETCH_SUCCESS';
var FETCH_FOLLOWERS_FAILURE = exports.FETCH_FOLLOWERS_FAILURE = 'followers/FETCH_FAILURE';

var fetchFollowersRequest = exports.fetchFollowersRequest = (0, _createAction2.default)(FETCH_FOLLOWERS_REQUEST);
var fetchFollowersSuccess = exports.fetchFollowersSuccess = (0, _createAction2.default)(FETCH_FOLLOWERS_SUCCESS, _lodash2.default.identity, function (payload, meta) {
  return meta;
});
var fetchFollowersFailure = exports.fetchFollowersFailure = (0, _createAction2.default)(FETCH_FOLLOWERS_FAILURE);

function fetchFollowers(_ref) {
  var userId = _ref.userId,
      page = _ref.page,
      pageSize = _ref.pageSize;

  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(fetchFollowersRequest());

    var query = (0, _pagination.buildPaginationRequestParams)(page, pageSize);
    var promise = request((0, _urijs2.default)('/_api/users/' + userId + '/followers').query(query), { parseHeaders: true });
    return promise.then(function (_ref3) {
      var _ref3$body = _ref3.body,
          body = _ref3$body === undefined ? [] : _ref3$body,
          _ref3$headers = _ref3.headers,
          headers = _ref3$headers === undefined ? {} : _ref3$headers;

      var payload = { followers: body };
      var meta = { count: parseInt(headers.get('Wix-Forum-TotalResults'), 10) };
      return dispatch(fetchFollowersSuccess(payload, meta));
    }).catch(function () {
      return dispatch(fetchFollowersFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFollowingFailure = exports.fetchFollowingSuccess = exports.fetchFollowingRequest = exports.FETCH_FOLLOWING_FAILURE = exports.FETCH_FOLLOWING_SUCCESS = exports.FETCH_FOLLOWING_REQUEST = undefined;
exports.fetchFollowing = fetchFollowing;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _pagination = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_FOLLOWING_REQUEST = exports.FETCH_FOLLOWING_REQUEST = 'following/FETCH_REQUEST';
var FETCH_FOLLOWING_SUCCESS = exports.FETCH_FOLLOWING_SUCCESS = 'following/FETCH_SUCCESS';
var FETCH_FOLLOWING_FAILURE = exports.FETCH_FOLLOWING_FAILURE = 'following/FETCH_FAILURE';

var fetchFollowingRequest = exports.fetchFollowingRequest = (0, _createAction2.default)(FETCH_FOLLOWING_REQUEST);
var fetchFollowingSuccess = exports.fetchFollowingSuccess = (0, _createAction2.default)(FETCH_FOLLOWING_SUCCESS, _lodash2.default.identity, function (payload, meta) {
  return meta;
});
var fetchFollowingFailure = exports.fetchFollowingFailure = (0, _createAction2.default)(FETCH_FOLLOWING_FAILURE);

function fetchFollowing(_ref) {
  var userId = _ref.userId,
      page = _ref.page,
      pageSize = _ref.pageSize;

  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(fetchFollowingRequest());

    var query = (0, _pagination.buildPaginationRequestParams)(page, pageSize);
    var promise = request((0, _urijs2.default)('/_api/users/' + userId + '/following').query(query), { parseHeaders: true });
    return promise.then(function (_ref3) {
      var _ref3$body = _ref3.body,
          body = _ref3$body === undefined ? [] : _ref3$body,
          _ref3$headers = _ref3.headers,
          headers = _ref3$headers === undefined ? {} : _ref3$headers;

      var payload = { following: body };
      var meta = { count: parseInt(headers.get('Wix-Forum-TotalResults'), 10) };
      return dispatch(fetchFollowingSuccess(payload, meta));
    }).catch(function () {
      return dispatch(fetchFollowingFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchForumData = fetchForumData;
var FETCH_FORUM_DATA_REQUEST = exports.FETCH_FORUM_DATA_REQUEST = 'forumData/FETCH_REQUEST';
var FETCH_FORUM_DATA_SUCCESS = exports.FETCH_FORUM_DATA_SUCCESS = 'forumData/FETCH_SUCCESS';
var FETCH_FORUM_DATA_FAILURE = exports.FETCH_FORUM_DATA_FAILURE = 'forumData/FETCH_FAILURE';

var fetchForumDataRequest = exports.fetchForumDataRequest = function fetchForumDataRequest() {
  return { type: FETCH_FORUM_DATA_REQUEST };
};
var fetchForumDataSuccess = exports.fetchForumDataSuccess = function fetchForumDataSuccess(payload) {
  return { type: FETCH_FORUM_DATA_SUCCESS, payload: payload };
};
var fetchForumDataFailure = exports.fetchForumDataFailure = function fetchForumDataFailure() {
  return { type: FETCH_FORUM_DATA_FAILURE };
};

function fetchForumData(promise) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchForumDataRequest());

    promise = promise || request('/_api/forums/this');
    return promise.then(function (forumData) {
      return dispatch(fetchForumDataSuccess(forumData));
    }).catch(function () {
      return dispatch(fetchForumDataFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIsLoaded = exports.SET_IS_LOADED = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_IS_LOADED = exports.SET_IS_LOADED = 'isLoaded/SET';

var setIsLoaded = exports.setIsLoaded = (0, _createAction2.default)(SET_IS_LOADED, function (entity, id, isLoaded) {
  return {
    entity: entity,
    id: id,
    isLoaded: isLoaded
  };
});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMembersWithFakeLoading = exports.fetchMembersDebounced = exports.fetchMembersFailure = exports.fetchMembersSuccess = exports.fetchMembersRequest = exports.FETCH_MEMBERS_DEBOUNCED = exports.FETCH_MEMBERS_FAILURE = exports.FETCH_MEMBERS_SUCCESS = exports.FETCH_MEMBERS_REQUEST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchMembers = fetchMembers;

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _pagination = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FETCH_MEMBERS_REQUEST = exports.FETCH_MEMBERS_REQUEST = 'members/FETCH_REQUEST';
var FETCH_MEMBERS_SUCCESS = exports.FETCH_MEMBERS_SUCCESS = 'members/FETCH_SUCCESS';
var FETCH_MEMBERS_FAILURE = exports.FETCH_MEMBERS_FAILURE = 'members/FETCH_FAILURE';
var FETCH_MEMBERS_DEBOUNCED = exports.FETCH_MEMBERS_DEBOUNCED = 'members/FETCH_DEBOUNCED';

var fetchMembersRequest = exports.fetchMembersRequest = (0, _createAction2.default)(FETCH_MEMBERS_REQUEST);
var fetchMembersSuccess = exports.fetchMembersSuccess = (0, _createAction2.default)(FETCH_MEMBERS_SUCCESS, function (payload) {
  return payload;
}, function (payload, meta) {
  return meta;
});
var fetchMembersFailure = exports.fetchMembersFailure = (0, _createAction2.default)(FETCH_MEMBERS_FAILURE);

function fetchMembers(_ref) {
  var page = _ref.page,
      pageSize = _ref.pageSize,
      params = _objectWithoutProperties(_ref, ['page', 'pageSize']);

  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(fetchMembersRequest());
    var url = (0, _urijs2.default)('/_api/members').query(_extends({
      sort: 'postCount'
    }, params, (0, _pagination.buildPaginationRequestParams)(page, pageSize)));
    var promise = request(url, {
      parseHeaders: true
    });

    return promise.then(function (_ref3) {
      var body = _ref3.body,
          headers = _ref3.headers;
      return dispatch(fetchMembersSuccess(body, {
        count: parseInt(headers.get('Wix-Forum-TotalResults'), 10),
        page: page
      }));
    }).catch(function () {
      return dispatch(fetchMembersFailure());
    }).then(function () {
      return promise;
    });
  };
}

var fetchMembersDebounced = exports.fetchMembersDebounced = function fetchMembersDebounced(params) {
  var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var action = fetchMembers(params);
  action.type = FETCH_MEMBERS_DEBOUNCED;
  action.meta = { debounce: debounce };
  return action;
};

var fetchMembersWithFakeLoading = exports.fetchMembersWithFakeLoading = function fetchMembersWithFakeLoading(params) {
  var debounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  return function (dispatch) {
    dispatch(fetchMembersRequest());
    dispatch(fetchMembersDebounced(params, debounce));
  };
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATE_POST_FAILURE = exports.CREATE_POST_SUCCESS = exports.CREATE_POST_REQUEST = undefined;
exports.createPost = createPost;

var _sanitizeContent = __webpack_require__(124);

var _sanitizeContent2 = _interopRequireDefault(_sanitizeContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CREATE_POST_REQUEST = exports.CREATE_POST_REQUEST = 'post/CREATE_REQUEST';
var CREATE_POST_SUCCESS = exports.CREATE_POST_SUCCESS = 'post/CREATE_SUCCESS';
var CREATE_POST_FAILURE = exports.CREATE_POST_FAILURE = 'post/CREATE_FAILURE';

function createPost() {
  var post = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: CREATE_POST_REQUEST
    });

    var promise = request.post('/_api/posts/', (0, _sanitizeContent2.default)(post));

    return promise.then(function (post) {
      return dispatch({
        type: CREATE_POST_SUCCESS,
        payload: post
      });
    }).catch(function () {
      return dispatch({
        type: CREATE_POST_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_I18N_NS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.initI18n = initI18n;

var _i18next = __webpack_require__(202);

var _i18next2 = _interopRequireDefault(_i18next);

var _createI18nConfig = __webpack_require__(213);

var _createI18nConfig2 = _interopRequireDefault(_createI18nConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_I18N_NS = exports.DEFAULT_I18N_NS = 'translation';

function initI18n(lng, localeData) {
  _i18next2.default.init(_extends({}, (0, _createI18nConfig2.default)(), {
    resources: _defineProperty({}, lng, _defineProperty({}, DEFAULT_I18N_NS, localeData)),
    lng: lng
  }));
  return _i18next2.default;
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(203).default;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = __webpack_require__(204);

var _i18next2 = _interopRequireDefault(_i18next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _i18next2.default;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _logger = __webpack_require__(17);

var _logger2 = _interopRequireDefault(_logger);

var _EventEmitter2 = __webpack_require__(27);

var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);

var _ResourceStore = __webpack_require__(205);

var _ResourceStore2 = _interopRequireDefault(_ResourceStore);

var _Translator = __webpack_require__(206);

var _Translator2 = _interopRequireDefault(_Translator);

var _LanguageUtils = __webpack_require__(207);

var _LanguageUtils2 = _interopRequireDefault(_LanguageUtils);

var _PluralResolver = __webpack_require__(208);

var _PluralResolver2 = _interopRequireDefault(_PluralResolver);

var _Interpolator = __webpack_require__(209);

var _Interpolator2 = _interopRequireDefault(_Interpolator);

var _BackendConnector = __webpack_require__(210);

var _BackendConnector2 = _interopRequireDefault(_BackendConnector);

var _CacheConnector = __webpack_require__(211);

var _CacheConnector2 = _interopRequireDefault(_CacheConnector);

var _defaults2 = __webpack_require__(212);

var _postProcessor = __webpack_require__(81);

var _postProcessor2 = _interopRequireDefault(_postProcessor);

var _v = __webpack_require__(82);

var compat = _interopRequireWildcard(_v);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = (0, _defaults2.transformOptions)(options);
    _this.services = {};
    _this.logger = _logger2.default;
    _this.modules = {};

    if (callback && !_this.isInitialized) _this.init(options, callback);
    return _this;
  }

  I18n.prototype.init = function init(options, callback) {
    var _this2 = this;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.compatibilityAPI === 'v1') {
      this.options = _extends({}, (0, _defaults2.get)(), (0, _defaults2.transformOptions)(compat.convertAPIOptions(options)), {});
    } else if (options.compatibilityJSON === 'v1') {
      this.options = _extends({}, (0, _defaults2.get)(), (0, _defaults2.transformOptions)(compat.convertJSONOptions(options)), {});
    } else {
      this.options = _extends({}, (0, _defaults2.get)(), this.options, (0, _defaults2.transformOptions)(options));
    }
    if (!callback) callback = function callback() {};

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        _logger2.default.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        _logger2.default.init(null, this.options);
      }

      var lu = new _LanguageUtils2.default(this.options);
      this.store = new _ResourceStore2.default(this.options.resources, this.options);

      var s = this.services;
      s.logger = _logger2.default;
      s.resourceStore = this.store;
      s.resourceStore.on('added removed', function (lng, ns) {
        s.cacheConnector.save();
      });
      s.languageUtils = lu;
      s.pluralResolver = new _PluralResolver2.default(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON });
      s.interpolator = new _Interpolator2.default(this.options);

      s.backendConnector = new _BackendConnector2.default(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      s.backendConnector.on('loaded', function (loaded) {
        s.cacheConnector.save();
      });

      s.cacheConnector = new _CacheConnector2.default(createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.cacheConnector.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      this.translator = new _Translator2.default(this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        return this.store[fcName].apply(this.store, arguments);
      };
    });

    // TODO: COMPATIBILITY remove this
    if (this.options.compatibilityAPI === 'v1') compat.appendBackwardsAPI(this);

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.emit('initialized', _this2.options);
        _this2.logger.log('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  I18n.prototype.loadResources = function loadResources(callback) {
    var _this3 = this;

    if (!callback) callback = function callback() {};

    if (!this.options.resources) {
      var _ret = function () {
        if (_this3.language && _this3.language.toLowerCase() === 'cimode') return {
            v: callback()
          }; // avoid loading resources for cimode

        var toLoad = [];

        var append = function append(lng) {
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        append(_this3.language);

        if (_this3.options.preload) {
          _this3.options.preload.forEach(function (l) {
            append(l);
          });
        }

        _this3.services.cacheConnector.load(toLoad, _this3.options.ns, function () {
          _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
        });
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'cache') {
      this.modules.cache = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.warn) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'postProcessor') {
      _postProcessor2.default.addPostProcessor(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err) {
      if (lng) {
        _this4.emit('languageChanged', lng);
        _this4.logger.log('languageChanged', lng);
      }

      if (callback) callback(err, function () {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return _this4.t.apply(_this4, args);
      });
    };

    if (!lng && this.services.languageDetector) lng = this.services.languageDetector.detect();

    if (lng) {
      this.language = lng;
      this.languages = this.services.languageUtils.toResolveHierarchy(lng);

      this.translator.changeLanguage(lng);

      if (this.services.languageDetector) this.services.languageDetector.cacheUserLanguage(lng);
    }

    this.loadResources(function (err) {
      done(err);
    });
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, options) {
      options = options || {};
      options.lng = options.lng || fixedT.lng;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    fixedT.lng = lng;
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    return this.translator && this.translator.translate.apply(this.translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    return this.translator && this.translator.exists.apply(this.translator, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    var clone = new I18n(_extends({}, options, this.options, { isClone: true }), callback);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new _Translator2.default(clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      clone.emit.apply(clone, [event].concat(args));
    });

    return clone;
  };

  return I18n;
}(_EventEmitter3.default);

exports.default = new I18n();

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _EventEmitter2 = __webpack_require__(27);

var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);

var _utils = __webpack_require__(28);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data;
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return utils.getPath(this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    utils.setPath(this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = utils.getPath(this.data, path) || {};

    if (deep) {
      utils.deepExtend(pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    utils.setPath(this.data, path, pack);

    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // TODO: COMPATIBILITY remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(_EventEmitter3.default);

exports.default = ResourceStore;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _logger = __webpack_require__(17);

var _logger2 = _interopRequireDefault(_logger);

var _EventEmitter2 = __webpack_require__(27);

var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);

var _postProcessor = __webpack_require__(81);

var _postProcessor2 = _interopRequireDefault(_postProcessor);

var _v = __webpack_require__(82);

var compat = _interopRequireWildcard(_v);

var _utils = __webpack_require__(28);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    utils.copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);

    _this.options = options;
    _this.logger = _logger2.default.create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    if (this.options.compatibilityAPI === 'v1') {
      options = compat.convertTOptions(options);
    }

    return this.resolve(key, options) !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      namespaces = parts[0];
      key = parts[1];
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      options = this.options.overloadTranslationOptionHandler(arguments);
    } else if (this.options.compatibilityAPI === 'v1') {
      options = compat.convertTOptions(options);
    }

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // return key on CIMode
    var lng = options.lng || this.language;
    if (lng && lng.toLowerCase() === 'cimode') return keys[keys.length - 1];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // resolve from store
    var res = this.resolve(keys, options);

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    if (res && typeof res !== 'string' && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(key, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

      for (var m in res) {
        copy[m] = this.translate('' + key + keySeparator + m, _extends({ joinArrays: false, ns: namespaces }, options));
      }
      res = copy;
    }
    // array special treatment
    else if (joinArrays && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, key, options);
      }
      // string, empty or null
      else {
          var usedDefault = false,
              usedKey = false;

          // fallback value
          if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
            usedDefault = true;
            res = options.defaultValue;
          }
          if (!this.isValidLookup(res)) {
            usedKey = true;
            res = key;
          }

          // save missing
          if (usedKey || usedDefault) {
            this.logger.log('missingKey', lng, namespace, key, res);

            var lngs = [];
            var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
            if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
              for (var i = 0; i < fallbackLngs.length; i++) {
                lngs.push(fallbackLngs[i]);
              }
            } else if (this.options.saveMissingTo === 'all') {
              lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
            } else {
              //(this.options.saveMissingTo === 'current' || (this.options.saveMissingTo === 'fallback' && this.options.fallbackLng[0] === false) ) {
              lngs.push(options.lng || this.language);
            }

            if (this.options.saveMissing) {
              if (this.options.missingKeyHandler) {
                this.options.missingKeyHandler(lngs, namespace, key, res);
              } else if (this.backendConnector && this.backendConnector.saveMissing) {
                this.backendConnector.saveMissing(lngs, namespace, key, res);
              }
            }

            this.emit('missingKey', lngs, namespace, key, res);
          }

          // extend
          res = this.extendTranslation(res, key, options);

          // append namespace if still key
          if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

          // parseMissingKeyHandler
          if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
        }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
    var _this2 = this;

    if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

    // interpolate
    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
    if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
    res = this.interpolator.interpolate(res, data, this.language);

    // nesting
    res = this.interpolator.nest(res, function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _this2.translate.apply(_this2, args);
    }, options);

    if (options.interpolation) this.interpolator.reset();

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = _postProcessor2.default.handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this3 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this3.isValidLookup(found)) return;

      var _extractFromKey2 = _this3.extractFromKey(k, options),
          key = _extractFromKey2.key,
          namespaces = _extractFromKey2.namespaces;

      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);

      namespaces.forEach(function (ns) {
        if (_this3.isValidLookup(found)) return;

        codes.forEach(function (code) {
          if (_this3.isValidLookup(found)) return;

          var finalKey = key;
          var finalKeys = [finalKey];

          var pluralSuffix = void 0;
          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);

          // fallback for plural if context not found
          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

          // get key for context if needed
          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);

          // get key for plural if needed
          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          while (possibleKey = finalKeys.pop()) {
            if (_this3.isValidLookup(found)) continue;
            found = _this3.getResource(code, ns, possibleKey, options);
          }
        });
      });
    });

    return found;
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(_EventEmitter3.default);

exports.default = Translator;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__(17);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = _logger2.default.create('languageUtils');
  }

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (code.indexOf('-') < 0) return code;

    var specialCases = ['NB-NO', 'NN-NO', 'nb-NO', 'nn-NO', 'nb-no', 'nn-no'];
    var p = code.split('-');
    return this.formatLanguageCode(specialCases.indexOf(code) > -1 ? p[1].toLowerCase() : p[0]);
  };

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (code.indexOf('-') < 0) return code;

    var specialCases = ['NB-NO', 'NN-NO', 'nb-NO', 'nn-NO', 'nb-no', 'nn-no'];
    var p = code.split('-');
    return this.formatLanguageCode(specialCases.indexOf(code) > -1 ? p[1].toLowerCase() : p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    } else {
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code, exactMatch) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist && !exactMatch) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1 ? true : false;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(code) {
      var exactMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!code) return;
      if (_this.isWhitelisted(code, exactMatch)) {
        codes.push(code);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + code);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code), true);
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code), true);
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

;

exports.default = LanguageUtil;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _logger = __webpack_require__(17);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'es_ar', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt', 'pt_br', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var l,
      rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      return rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = _logger2.default.create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length <= 1 ? false : true;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this = this;

    var rule = this.getRule(code);

    if (rule) {
      var _ret = function () {
        if (rule.numbers.length === 1) return {
            v: ''
          }; // only singular

        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        // special treatment for lngs only having singular and plural
        if (rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
        };

        // COMPATIBILITY JSON
        // v1
        if (_this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return {
              v: ''
            };
          if (typeof suffix === 'number') return {
              v: '_plural_' + suffix.toString()
            };
          return {
            v: returnSuffix()
          };
        }
        // v2
        else if (_this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
            return {
              v: returnSuffix()
            };
          }
          // v3 - gettext index
          else if (rule.numbers.length === 2 && rule.numbers[0] === 1) {
              return {
                v: returnSuffix()
              };
            }
        return {
          v: _this.options.prepend && idx.toString() ? _this.options.prepend + idx.toString() : idx.toString()
        };
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    } else {
      this.logger.warn('no plural rule found for: ' + code);
      return '';
    }
  };

  return PluralResolver;
}();

;

exports.default = PluralResolver;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(28);

var utils = _interopRequireWildcard(_utils);

var _logger = __webpack_require__(17);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = _logger2.default.create('interpolator');

    this.init(options, true);
  }

  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? utils.regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? utils.regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
    this.formatSeparator = iOpts.formatSeparator ? utils.regexEscape(iOpts.formatSeparator) : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? utils.regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || utils.regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? utils.regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || utils.regexEscape(')');

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0,
        value = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return utils.getPath(data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(utils.getPath(data, k), f, lng);
    };

    this.resetRegExp();

    // unescape if has unescapePrefix/Suffix
    while (match = this.regexpUnescape.exec(str)) {
      var _value = handleFormat(match[1].trim());
      str = str.replace(match[0], _value);
      this.regexpUnescape.lastIndex = 0;
    }

    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (typeof value !== 'string') value = utils.makeString(value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0,
        value = void 0;

    var clonedOptions = JSON.parse(JSON.stringify(options));
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);

      try {
        clonedOptions = JSON.parse(optionsString);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);
      if (typeof value !== 'string') value = utils.makeString(value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

exports.default = Interpolator;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _utils = __webpack_require__(28);

var utils = _interopRequireWildcard(_utils);

var _logger = __webpack_require__(17);

var _logger2 = _interopRequireDefault(_logger);

var _EventEmitter2 = __webpack_require__(27);

var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = _logger2.default.create('backendConnector');

    _this.state = {};
    _this.queue = [];

    _this.backend && _this.backend.init && _this.backend.init(services, options.backend, options);
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [],
        pending = [],
        toLoadLanguages = [],
        toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;
    // callback if ready
    this.queue.forEach(function (q) {
      utils.pushPath(q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        q.errors.length ? q.callback(q.errors) : q.callback();
        _this3.emit('loaded', q.loaded);
        q.done = true;
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName, tried, wait, callback) {
    var _this4 = this;

    if (!tried) tried = 0;
    if (!wait) wait = 250;

    if (!lng.length) return callback(null, {}); // noting to load

    this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, ++tried, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return; // pendings will trigger callback
    }

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this5.logger.log('loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);

        toLoad.toLoad.forEach(function (name) {
          var _name$split3 = name.split('|'),
              _name$split4 = _slicedToArray(_name$split3, 2),
              l = _name$split4[0],
              n = _name$split4[1];

          var bundle = utils.getPath(data, [l, n]);
          if (bundle) {
            _this5.loaded(name, err, bundle);
          } else {
            var _err = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
            _this5.loaded(name, _err);
            _this5.logger.error(_err);
          }
        });
      });
    }

    // load one by one
    else {
        (function () {
          var readOne = function readOne(name) {
            var _this6 = this;

            var _name$split5 = name.split('|'),
                _name$split6 = _slicedToArray(_name$split5, 2),
                lng = _name$split6[0],
                ns = _name$split6[1];

            this.read(lng, ns, 'read', null, null, function (err, data) {
              if (err) _this6.logger.warn('loading namespace ' + ns + ' for language ' + lng + ' failed', err);
              if (!err && data) _this6.logger.log('loaded namespace ' + ns + ' for language ' + lng, data);

              _this6.loaded(name, err, data);
            });
          };

          ;

          toLoad.toLoad.forEach(function (name) {
            readOne.call(_this5, name);
          });
        })();
      }
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this7 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this7.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this7.logger.log('reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);

        languages.forEach(function (l) {
          namespaces.forEach(function (n) {
            var bundle = utils.getPath(data, [l, n]);
            if (bundle) {
              _this7.loaded(l + '|' + n, err, bundle);
            } else {
              var _err2 = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
              _this7.loaded(l + '|' + n, _err2);
              _this7.logger.error(_err2);
            }
          });
        });
      });
    }

    // load one by one
    else {
        (function () {
          var readOne = function readOne(name) {
            var _this8 = this;

            var _name$split7 = name.split('|'),
                _name$split8 = _slicedToArray(_name$split7, 2),
                lng = _name$split8[0],
                ns = _name$split8[1];

            this.read(lng, ns, 'read', null, null, function (err, data) {
              if (err) _this8.logger.warn('reloading namespace ' + ns + ' for language ' + lng + ' failed', err);
              if (!err && data) _this8.logger.log('reloaded namespace ' + ns + ' for language ' + lng, data);

              _this8.loaded(name, err, data);
            });
          };

          ;

          languages.forEach(function (l) {
            namespaces.forEach(function (n) {
              readOne.call(_this7, l + '|' + n);
            });
          });
        })();
      }
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue) {
    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue);

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(_EventEmitter3.default);

exports.default = Connector;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(28);

var utils = _interopRequireWildcard(_utils);

var _logger = __webpack_require__(17);

var _logger2 = _interopRequireDefault(_logger);

var _EventEmitter2 = __webpack_require__(27);

var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(cache, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.cache = cache;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = _logger2.default.create('cacheConnector');

    _this.cache && _this.cache.init && _this.cache.init(services, options.cache, options);
    return _this;
  }

  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this2 = this;

    if (!this.cache) return callback && callback();
    var options = _extends({}, this.cache.options, this.options.cache);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    if (options.enabled) {
      this.cache.load(languages, function (err, data) {
        if (err) _this2.logger.error('loading languages ' + languages.join(', ') + ' from cache failed', err);
        if (data) {
          for (var l in data) {
            for (var n in data[l]) {
              if (n === 'i18nStamp') continue;
              var bundle = data[l][n];
              if (bundle) _this2.store.addResourceBundle(l, n, bundle);
            }
          }
        }
        if (callback) callback();
      });
    } else {
      if (callback) callback();
    }
  };

  Connector.prototype.save = function save() {
    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
  };

  return Connector;
}(_EventEmitter3.default);

exports.default = Connector;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.transformOptions = transformOptions;
function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    saveMissingTo: 'fallback', // 'current' || 'all'
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
      return { defaultValue: args[1] };
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
    }
  };
}

function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');

  return options;
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _moment = __webpack_require__(168);

var _moment2 = _interopRequireDefault(_moment);

var _time = __webpack_require__(214);

var _createFormatNumber = __webpack_require__(215);

var _createFormatNumber2 = _interopRequireDefault(_createFormatNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var I18N_NESTING_KEY_SEPARATOR = '$';

function createI18nConfig() {
  return {
    keySeparator: I18N_NESTING_KEY_SEPARATOR,
    interpolation: {
      escapeValue: false,
      format: function format(value, _format, lng) {
        switch (_format) {
          case 'uppercase':
            return value.toUpperCase();
          case 'number':
            return (0, _createFormatNumber2.default)(lng)(value);
          case 'timeRelative':
            return (0, _moment2.default)(value).locale(_time.MOMENT_LOCALES[lng]).fromNow();
          case 'date':
            return (0, _moment2.default)(value).locale(_time.MOMENT_LOCALES[lng]).format(_time.DATE_FORMATS[lng]);
          case 'fullDate':
            return (0, _moment2.default)(value).locale(_time.MOMENT_LOCALES[lng]).format('ll');
          default:
            return value;
        }
      }
    }
  };
}
exports.default = createI18nConfig;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_FORMATS = exports.MOMENT_LOCALES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _forumLanguages = __webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MOMENT_LOCALES = exports.MOMENT_LOCALES = _extends({}, _lodash2.default.zipObject(_forumLanguages.newForumLanguages, _forumLanguages.newForumLanguages), {
  tl: 'tl-ph',
  zh: 'zh-cn',
  no: 'nb'
});

var DEFAULT_DATE_FORMAT = 'MMM D';
var DATE_FORMATS = exports.DATE_FORMATS = _extends({}, _lodash2.default.reduce(_forumLanguages.newForumLanguages, function (acc, value) {
  return _extends({}, acc, _defineProperty({}, value, DEFAULT_DATE_FORMAT));
}, {}), {
  ko: 'MMM Do',
  ja: 'MMMDo'
});

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createFormatNumber;

var _numeral = __webpack_require__(216);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_LANG = 'en';
var FILE_NAMES = {
  cs: 'cs',
  da: 'da-dk',
  de: 'de',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  ja: 'ja',
  nl: 'nl-nl',
  no: 'no',
  pl: 'pl',
  pt: 'pt-pt',
  ru: 'ru',
  th: 'th',
  tr: 'tr'
};

function createFormatNumber(lang) {
  var numeralData = void 0;
  try {
    numeralData = __webpack_require__(217)("./" + FILE_NAMES[lang]);
  } catch (e) {}

  if (lang !== DEFAULT_LANG && !numeralData) {
    return function (value) {
      return value;
    };
  }

  _numeral2.default.language(lang, numeralData);
  return function (value) {
    return (0, _numeral2.default)(value).format();
  };
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 1.5.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function() {

    /************************************
        Variables
    ************************************/

    var numeral,
        VERSION = '1.5.6',
        // internal storage for language config files
        languages = {},
        defaults = {
            currentLanguage: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0'
        },
        options = {
            currentLanguage: defaults.currentLanguage,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat
        },
        byteSuffixes = {
            bytes: ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            iec: ['B','KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };


    /************************************
        Constructors
    ************************************/


    // Numeral prototype object
    function Numeral(number) {
        this._value = number;
    }

    /**
     * Implementation of toFixed() that treats floats more like decimals
     *
     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
     * problems for accounting- and finance-related software.
     */
    function toFixed (value, maxDecimals, roundingFunction, optionals) {
        var splitValue = value.toString().split('.'),
            minDecimals = maxDecimals - (optionals || 0),
            boundedPrecision,
            optionalsRegExp,
            power,
            output;

        // Use the smallest precision value possible to avoid errors from floating point representation
        if (splitValue.length === 2) {
          boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
        } else {
          boundedPrecision = minDecimals;
        }

        power = Math.pow(10, boundedPrecision);

        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
        // Multiply up by precision, round accurately, then divide and use native toFixed():
        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);

        if (optionals > maxDecimals - boundedPrecision) {
            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
            output = output.replace(optionalsRegExp, '');
        }

        return output;
    }

    /************************************
        Formatting
    ************************************/

    // determine what type of formatting we need to do
    function formatNumeral(n, format, roundingFunction) {
        var output;

        if (n._value === 0 && options.zeroFormat !== null) {
            output = options.zeroFormat;
        } else if (n._value === null && options.nullFormat !== null) {
            output = options.nullFormat;
        } else {
            // figure out what kind of format we are dealing with
            if (format.indexOf('$') > -1) {
                output = formatCurrency(n, format, roundingFunction);
            } else if (format.indexOf('%') > -1) {
                output = formatPercentage(n, format, roundingFunction);
            } else if (format.indexOf(':') > -1) {
                output = formatTime(n, format);
            } else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) {
                output = formatBytes(n, format, roundingFunction);
            } else if (format.indexOf('o') > -1) {
                output = formatOrdinal(n, format, roundingFunction);
            } else {
                output = formatNumber(n._value, format, roundingFunction);
            }
        }

        return output;
    }

    function formatCurrency(n, format, roundingFunction) {
        var symbolIndex = format.indexOf('$'),
            openParenIndex = format.indexOf('('),
            minusSignIndex = format.indexOf('-'),
            space = '',
            spliceIndex,
            output;

        // check for space before or after currency
        if (format.indexOf(' $') > -1) {
            space = ' ';
            format = format.replace(' $', '');
        } else if (format.indexOf('$ ') > -1) {
            space = ' ';
            format = format.replace('$ ', '');
        } else {
            format = format.replace('$', '');
        }

        // format the number
        output = formatNumber(n._value, format, roundingFunction, false);

        // position the symbol
        if (symbolIndex <= 1) {
            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
                output = output.split('');
                spliceIndex = 1;
                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) {
                    // the symbol appears before the "(" or "-"
                    spliceIndex = 0;
                }
                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
                output = output.join('');
            } else {
                output = languages[options.currentLanguage].currency.symbol + space + output;
            }
        } else {
            if (output.indexOf(')') > -1) {
                output = output.split('');
                output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
                output = output.join('');
            } else {
                output = output + space + languages[options.currentLanguage].currency.symbol;
            }
        }

        return output;
    }

    function formatPercentage(n, format, roundingFunction) {
        var space = '',
            output,
            value = n._value * 100;

        // check for space before %
        if (format.indexOf(' %') > -1) {
            space = ' ';
            format = format.replace(' %', '');
        } else {
            format = format.replace('%', '');
        }

        output = formatNumber(value, format, roundingFunction);

        if (output.indexOf(')') > -1) {
            output = output.split('');
            output.splice(-1, 0, space + '%');
            output = output.join('');
        } else {
            output = output + space + '%';
        }

        return output;
    }

    function formatBytes(n, format, roundingFunction) {
        var output,
            suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes,
            value = n._value,
            suffix = '',
            power,
            min,
            max;

        // check for space before
        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
            suffix = ' ';
            format = format.replace(' ib', '').replace(' b', '');
        } else {
            format = format.replace('ib', '').replace('b', '');
        }

        for (power = 0; power <= suffixes.length; power++) {
            min = Math.pow(1024, power);
            max = Math.pow(1024, power + 1);

            if (value === null || value === 0 || value >= min && value < max) {
                suffix += suffixes[power];

                if (min > 0) {
                    value = value / min;
                }

                break;
            }
        }

        output = formatNumber(value, format, roundingFunction);

        return output + suffix;
    }

    function formatOrdinal(n, format, roundingFunction) {
        var output,
            ordinal = '';

        // check for space before
        if (format.indexOf(' o') > -1) {
            ordinal = ' ';
            format = format.replace(' o', '');
        } else {
            format = format.replace('o', '');
        }

        ordinal += languages[options.currentLanguage].ordinal(n._value);

        output = formatNumber(n._value, format, roundingFunction);

        return output + ordinal;
    }

    function formatTime(n) {
        var hours = Math.floor(n._value / 60 / 60),
            minutes = Math.floor((n._value - (hours * 60 * 60)) / 60),
            seconds = Math.round(n._value - (hours * 60 * 60) - (minutes * 60));

        return hours + ':' + ((minutes < 10) ? '0' + minutes : minutes) + ':' + ((seconds < 10) ? '0' + seconds : seconds);
    }

    function formatNumber(value, format, roundingFunction) {
        var negP = false,
            signed = false,
            optDec = false,
            abbr = '',
            abbrK = false, // force abbreviation to thousands
            abbrM = false, // force abbreviation to millions
            abbrB = false, // force abbreviation to billions
            abbrT = false, // force abbreviation to trillions
            abbrForce = false, // force abbreviation
            abs,
            min,
            max,
            power,
            w,
            precision,
            thousands,
            d = '',
            neg = false;

        if (value === null) {
            value = 0;
        }

        abs = Math.abs(value);

        // see if we should use parentheses for negative number or if we should prefix with a sign
        // if both are present we default to parentheses
        if (format.indexOf('(') > -1) {
            negP = true;
            format = format.slice(1, -1);
        } else if (format.indexOf('+') > -1) {
            signed = true;
            format = format.replace(/\+/g, '');
        }

        // see if abbreviation is wanted
        if (format.indexOf('a') > -1) {
            // check if abbreviation is specified
            abbrK = format.indexOf('aK') >= 0;
            abbrM = format.indexOf('aM') >= 0;
            abbrB = format.indexOf('aB') >= 0;
            abbrT = format.indexOf('aT') >= 0;
            abbrForce = abbrK || abbrM || abbrB || abbrT;

            // check for space before abbreviation
            if (format.indexOf(' a') > -1) {
                abbr = ' ';
            }

            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');

            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
                // trillion
                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
                value = value / Math.pow(10, 12);
            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
                // billion
                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
                value = value / Math.pow(10, 9);
            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
                // million
                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
                value = value / Math.pow(10, 6);
            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
                // thousand
                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
                value = value / Math.pow(10, 3);
            }
        }


        if (format.indexOf('[.]') > -1) {
            optDec = true;
            format = format.replace('[.]', '.');
        }

        w = value.toString().split('.')[0];
        precision = format.split('.')[1];
        thousands = format.indexOf(',');

        if (precision) {
            if (precision.indexOf('[') > -1) {
                precision = precision.replace(']', '');
                precision = precision.split('[');
                d = toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
            } else {
                d = toFixed(value, precision.length, roundingFunction);
            }

            w = d.split('.')[0];

            if (d.indexOf('.') > -1) {
                d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
            } else {
                d = '';
            }

            if (optDec && Number(d.slice(1)) === 0) {
                d = '';
            }
        } else {
            w = toFixed(value, null, roundingFunction);
        }

        // format number
        if (w.indexOf('-') > -1) {
            w = w.slice(1);
            neg = true;
        }

        if (thousands > -1) {
            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
        }

        if (format.indexOf('.') === 0) {
            w = '';
        }

        return ((negP && neg) ? '(' : '') + ((!negP && neg) ? '-' : '') + ((!neg && signed) ? '+' : '') + w + d + ((abbr) ? abbr : '') + ((negP && neg) ? ')' : '');
    }


    /************************************
        Unformatting
    ************************************/

    // revert to number
    function unformatNumeral(n, string) {
        var stringOriginal = string,
            thousandRegExp,
            millionRegExp,
            billionRegExp,
            trillionRegExp,
            bytesMultiplier = false,
            power,
            value;

        if (string.indexOf(':') > -1) {
            value = unformatTime(string);
        } else {
            if (string === options.zeroFormat || string === options.nullFormat) {
                value = 0;
            } else {
                if (languages[options.currentLanguage].delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
                }

                // see if abbreviations are there so that we can multiply to the correct number
                thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
                millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
                billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
                trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');

                // see if bytes are there so that we can multiply to the correct number
                for (power = 1; power <= byteSuffixes.bytes.length; power++) {
                    bytesMultiplier = ((string.indexOf(byteSuffixes.bytes[power]) > -1) || (string.indexOf(byteSuffixes.iec[power]) > -1))? Math.pow(1024, power) : false;

                    if (bytesMultiplier) {
                        break;
                    }
                }

                // do some math to create our number
                value = bytesMultiplier ? bytesMultiplier : 1;
                value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
                value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
                value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
                value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
                // check for percentage
                value *= string.indexOf('%') > -1 ? 0.01 : 1;
                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                value *= Number(string.replace(/[^0-9\.]+/g, ''));
                // round if we are talking about bytes
                value = bytesMultiplier ? Math.ceil(value) : value;
            }
        }

        n._value = value;

        return n._value;
    }
    function unformatTime(string) {
        var timeArray = string.split(':'),
            seconds = 0;
        // turn hours and minutes into seconds and add them all up
        if (timeArray.length === 3) {
            // hours
            seconds = seconds + (Number(timeArray[0]) * 60 * 60);
            // minutes
            seconds = seconds + (Number(timeArray[1]) * 60);
            // seconds
            seconds = seconds + Number(timeArray[2]);
        } else if (timeArray.length === 2) {
            // minutes
            seconds = seconds + (Number(timeArray[0]) * 60);
            // seconds
            seconds = seconds + Number(timeArray[1]);
        }
        return Number(seconds);
    }


    /************************************
        Top Level Functions
    ************************************/

    numeral = function(input) {
        if (numeral.isNumeral(input)) {
            input = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            input = 0;
        } else if (input === null) {
            input = null;
        } else if (!Number(input)) {
            input = numeral.fn.unformat(input);
        } else {
            input = Number(input);
        }

        return new Numeral(input);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };


    // This function will load languages and then set the global language.  If
    // no arguments are passed in, it will simply return the current global
    // language key.
    numeral.language = function(key, values) {
        if (!key) {
            return options.currentLanguage;
        }

        key = key.toLowerCase();

        if (key && !values) {
            if (!languages[key]) {
                throw new Error('Unknown language : ' + key);
            }

            options.currentLanguage = key;
        }

        if (values || !languages[key]) {
            loadLanguage(key, values);
        }

        return numeral;
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    // This function provides access to the loaded language data.  If
    // no arguments are passed in, it will simply return the current
    // global language object.
    numeral.languageData = function(key) {
        if (!key) {
            return languages[options.currentLanguage];
        }

        if (!languages[key]) {
            throw new Error('Unknown language : ' + key);
        }

        return languages[key];
    };

    numeral.language('en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            languageData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';
            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if ( !! val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.languageData
        try {
            //check if the culture is understood by numeral. if not, default it to current language
            languageData = numeral.languageData(culture);
        } catch (e) {
            languageData = numeral.languageData(numeral.language());
        }

        //setup the delimiters and currency symbol based on culture/language
        _currSymbol = languageData.currency.symbol;
        _abbrObj = languageData.abbreviations;
        _decimalSep = languageData.delimiters.decimal;
        if (languageData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = languageData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };

    /************************************
        Helpers
    ************************************/

    function loadLanguage(key, values) {
        languages[key] = values;
    }

    /************************************
        Floating-point helpers
    ************************************/

    // The floating-point helper functions and implementation
    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/

    // Production steps of ECMA-262, Edition 5, 15.4.4.21
    // Reference: http://es5.github.io/#x15.4.4.21
    if (!Array.prototype.reduce) {
        Array.prototype.reduce = function(callback /*, initialValue*/) {
            'use strict';
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(this), len = t.length >>> 0, k = 0, value;

            if (arguments.length === 2) {
                value = arguments[1];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        };
    }

    /**
     * Computes the multiplier necessary to make x >= 1,
     * effectively eliminating miscalculations caused by
     * finite precision.
     */
    function multiplier(x) {
        var parts = x.toString().split('.');
        if (parts.length < 2) {
            return 1;
        }
        return Math.pow(10, parts[1].length);
    }

    /**
     * Given a variable number of arguments, returns the maximum
     * multiplier that must be used to normalize an operation involving
     * all of them.
     */
    function correctionFactor() {
        var args = Array.prototype.slice.call(arguments);
        return args.reduce(function(prev, next) {
            var mp = multiplier(prev),
                mn = multiplier(next);
            return mp > mn ? mp : mn;
        }, -Infinity);
    }


    /************************************
        Numeral Prototype
    ************************************/


    numeral.fn = Numeral.prototype = {

        clone: function() {
            return numeral(this);
        },

        format: function (inputString, roundingFunction) {
            return formatNumeral(this,
                inputString ? inputString : options.defaultFormat,
                roundingFunction !== undefined ? roundingFunction : Math.round
            );
        },

        unformat: function (inputString) {
            if (Object.prototype.toString.call(inputString) === '[object Number]') {
                return inputString;
            }

            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
        },

        value: function() {
            return this._value;
        },

        valueOf: function() {
            return this._value;
        },

        set: function(value) {
            this._value = Number(value);
            return this;
        },

        add: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + corrFactor * curr;
            }
            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
            return this;
        },

        subtract: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - corrFactor * curr;
            }
            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
            return this;
        },

        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = correctionFactor(accum, curr);
                return (accum * corrFactor) * (curr * corrFactor) /
                    (corrFactor * corrFactor);
            }
            this._value = [this._value, value].reduce(cback, 1);
            return this;
        },

        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = correctionFactor(accum, curr);
                return (accum * corrFactor) / (curr * corrFactor);
            }
            this._value = [this._value, value].reduce(cback);
            return this;
        },

        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }

    };

    /************************************
        Exposing Numeral
    ************************************/

    // CommonJS module is defined
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = numeral;
    }

    /*global ender:false */
    if (typeof ender === 'undefined') {
        // here, `this` means `window` in the browser, or `global` on the server
        // add `numeral` as a global object via a string identifier,
        // for Closure Compiler 'advanced' mode
        this['numeral'] = numeral;
    }

    /*global define:false */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            return numeral;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}).call(this);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./be-nl": 83,
	"./be-nl.js": 83,
	"./chs": 84,
	"./chs.js": 84,
	"./cs": 85,
	"./cs.js": 85,
	"./da-dk": 86,
	"./da-dk.js": 86,
	"./de": 87,
	"./de-ch": 88,
	"./de-ch.js": 88,
	"./de.js": 87,
	"./en-gb": 89,
	"./en-gb.js": 89,
	"./en-za": 90,
	"./en-za.js": 90,
	"./es": 91,
	"./es-ES": 92,
	"./es-ES.js": 92,
	"./es.js": 91,
	"./et": 93,
	"./et.js": 93,
	"./fi": 94,
	"./fi.js": 94,
	"./fr": 95,
	"./fr-CA": 96,
	"./fr-CA.js": 96,
	"./fr-ch": 97,
	"./fr-ch.js": 97,
	"./fr.js": 95,
	"./hu": 98,
	"./hu.js": 98,
	"./it": 99,
	"./it.js": 99,
	"./ja": 100,
	"./ja.js": 100,
	"./lv": 101,
	"./lv.js": 101,
	"./nl-nl": 102,
	"./nl-nl.js": 102,
	"./no": 103,
	"./no.js": 103,
	"./pl": 104,
	"./pl.js": 104,
	"./pt-br": 105,
	"./pt-br.js": 105,
	"./pt-pt": 106,
	"./pt-pt.js": 106,
	"./ru": 107,
	"./ru-UA": 108,
	"./ru-UA.js": 108,
	"./ru.js": 107,
	"./sk": 109,
	"./sk.js": 109,
	"./th": 110,
	"./th.js": 110,
	"./tr": 111,
	"./tr.js": 111,
	"./uk-UA": 112,
	"./uk-UA.js": 112
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = translate;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function translate(namespaces) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var _options$withRef = options.withRef;
  var withRef = _options$withRef === undefined ? false : _options$withRef;
  var _options$wait = options.wait;
  var wait = _options$wait === undefined ? false : _options$wait;
  var _options$bindI18n = options.bindI18n;
  var bindI18n = _options$bindI18n === undefined ? 'languageChanged loaded' : _options$bindI18n;
  var _options$bindStore = options.bindStore;
  var bindStore = _options$bindStore === undefined ? 'added removed' : _options$bindStore;
  var _options$translateFun = options.translateFuncName;
  var translateFuncName = _options$translateFun === undefined ? 't' : _options$translateFun;


  return function Wrapper(WrappedComponent) {
    var Translate = function (_Component) {
      _inherits(Translate, _Component);

      function Translate(props, context) {
        _classCallCheck(this, Translate);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Translate).call(this, props, context));

        _this.i18n = context.i18n || props.i18n;
        namespaces = namespaces || _this.i18n.options.defaultNS;

        _this.state = {
          i18nLoadedAt: null,
          ready: false
        };

        _this.onI18nChanged = _this.onI18nChanged.bind(_this);
        return _this;
      }

      _createClass(Translate, [{
        key: 'getChildContext',
        value: function getChildContext() {
          return _defineProperty({}, translateFuncName, this[translateFuncName]);
        }
      }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
          this[translateFuncName] = this.i18n.getFixedT(null, namespaces);
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          var bind = function bind() {
            bindI18n && _this2.i18n.on(bindI18n, _this2.onI18nChanged);
            bindStore && _this2.i18n.store && _this2.i18n.store.on(bindStore, _this2.onI18nChanged);
          };

          this.mounted = true;
          this.i18n.loadNamespaces(namespaces, function () {
            if (_this2.mounted) _this2.setState({ ready: true });
            if (wait && _this2.mounted) bind();
          });
          if (!wait) bind();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.mounted = false;
          if (this.onI18nChanged) {
            this.i18n.off('languageChanged', this.onI18nChanged);
            this.i18n.off('loaded', this.onI18nChanged);
            this.i18n.store.off('added', this.onI18nChanged);
            this.i18n.store.off('removed', this.onI18nChanged);
          }
        }
      }, {
        key: 'onI18nChanged',
        value: function onI18nChanged() {
          if (!this.mounted) return;

          this.setState({ i18nLoadedAt: new Date() });
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          return this.refs.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _state = this.state;
          var i18nLoadedAt = _state.i18nLoadedAt;
          var ready = _state.ready;

          var extraProps = _defineProperty({ i18nLoadedAt: i18nLoadedAt }, translateFuncName, this[translateFuncName]);

          if (withRef) {
            extraProps.ref = 'wrappedInstance';
          }

          if (!ready && wait) return null;

          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, extraProps));
        }
      }]);

      return Translate;
    }(_react.Component);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: _react.PropTypes.object
    };

    Translate.childContextTypes = _defineProperty({}, translateFuncName, _react.PropTypes.func.isRequired);

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaces;

    return (0, _hoistNonReactStatics2.default)(Translate, WrappedComponent);
  };
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Interpolate = function (_Component) {
  _inherits(Interpolate, _Component);

  function Interpolate(props, context) {
    _classCallCheck(this, Interpolate);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Interpolate).call(this, props, context));

    _this.i18n = context.i18n;
    _this.t = context.t;
    return _this;
  }

  _createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props;
      var className = _props.className;
      var style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return _react2.default.createElement('noscript', null);

      var children = [];

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = _react2.default.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = _this2.props[match];
          if (!_this2.props[match]) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + match + ' for interpolating ' + format);
        }

        memo.push(child);
        return memo;
      }, children);

      return _react2.default.createElement.apply(this, [parent, { className: className, style: style }].concat(children));
    }
  }]);

  return Interpolate;
}(_react.Component);

Interpolate.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};

Interpolate.contextTypes = {
  i18n: _react.PropTypes.object.isRequired,
  t: _react.PropTypes.func.isRequired
};

exports.default = Interpolate;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var I18nextProvider = function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    _classCallCheck(this, I18nextProvider);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(I18nextProvider).call(this, props, context));

    _this.i18n = props.i18n;
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { i18n: this.i18n };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react.Children.only(children);
    }
  }]);

  return I18nextProvider;
}(_react.Component);

I18nextProvider.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  children: _react.PropTypes.element.isRequired
};

I18nextProvider.childContextTypes = {
  i18n: _react.PropTypes.object.isRequired
};

exports.default = I18nextProvider;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = loadNamespaces;
// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (_typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2);

          var key = _step$value[0];
          var value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components;
  var i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsHeaderEnabled = exports.getSiteColors = exports.getForumData = exports.getStyleSetting = exports.getStyle = exports.getAppSettingsValue = exports.getAppSettings = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _wixParams = __webpack_require__(24);

var _experiments = __webpack_require__(32);

var _experimentsSelectors = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAppSettings = exports.getAppSettings = function getAppSettings(state) {
  return state.appSettings;
};

var getAppSettingsValue = exports.getAppSettingsValue = function getAppSettingsValue(_ref) {
  var state = _ref.state,
      key = _ref.key,
      fallback = _ref.fallback;
  return _lodash2.default.get(getAppSettings(state), key, fallback);
};

var getStyle = exports.getStyle = function getStyle(state) {
  return _lodash2.default.get(getAppSettings(state), 'style', {});
};
var getStyleSetting = exports.getStyleSetting = function getStyleSetting(state, path) {
  return _lodash2.default.get(getAppSettings(state), path);
};

var getForumData = exports.getForumData = function getForumData(state) {
  return _lodash2.default.get(getAppSettings(state), 'data.forum', {});
};

var getSiteColors = exports.getSiteColors = function getSiteColors(state) {
  return _lodash2.default.reduce(getAppSettings(state).colorPresets, function (acc, _ref2) {
    var reference = _ref2.reference,
        value = _ref2.value;

    acc[reference] = value;
    return acc;
  }, {});
};

var isHeaderToggleExperimentEnabled = function isHeaderToggleExperimentEnabled(state) {
  return (0, _experimentsSelectors.isExperimentEnabled)(state, _experiments.EXPERIMENT_HEADER_TOGGLE);
};

var getIsHeaderEnabled = exports.getIsHeaderEnabled = function getIsHeaderEnabled(state) {
  if (!isHeaderToggleExperimentEnabled(state)) {
    return true;
  }
  return getAppSettingsValue({ state: state, key: _wixParams.IS_HEADER_ENABLED_PATH, fallback: true });
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLayoutName;

var _layoutTypes = __webpack_require__(263);

var _cardSizes = __webpack_require__(224);

function getLayoutName() {
  var layoutType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _layoutTypes.LAYOUT_TYPE_PINBOARD;
  var cardSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _cardSizes.CARD_SIZE_MEDIUM;

  if (layoutType === _layoutTypes.LAYOUT_TYPE_CLASSIC) {
    return 'classic';
  }

  switch (cardSize) {
    case _cardSizes.CARD_SIZE_SMALL:
      return 'small';
    case _cardSizes.CARD_SIZE_MEDIUM:
      return 'medium';
    case _cardSizes.CARD_SIZE_LARGE:
      return 'large';
    default:
      return 'small';
  }
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CARD_SIZE_SMALL = exports.CARD_SIZE_SMALL = 0;
var CARD_SIZE_MEDIUM = exports.CARD_SIZE_MEDIUM = 1;
var CARD_SIZE_LARGE = exports.CARD_SIZE_LARGE = 2;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(225);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(52);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(52);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _buttons = __webpack_require__(53);

var _modalTypes = __webpack_require__(26);

var _draftJs = __webpack_require__(10);

var _reactRedux = __webpack_require__(5);

var _cancelUploads = __webpack_require__(422);

var _insertTextEditorEntity = __webpack_require__(167);

var _openModal = __webpack_require__(36);

var _setTextEditorEntityData = __webpack_require__(125);

var _updateTextEditor = __webpack_require__(261);

var _upload = __webpack_require__(171);

var _uploadEnded = __webpack_require__(230);

var _uploadStarted = __webpack_require__(231);

var _textEditorUtils = __webpack_require__(66);

var _blockTypeModifiers = __webpack_require__(327);

var blockModifiers = _interopRequireWildcard(_blockTypeModifiers);

var _linkModifiers = __webpack_require__(328);

var linkModifiers = _interopRequireWildcard(_linkModifiers);

var _textAlignmentModifiers = __webpack_require__(329);

var textAlignmentModifiers = _interopRequireWildcard(_textAlignmentModifiers);

var _buttons2 = __webpack_require__(330);

var _buttons3 = _interopRequireDefault(_buttons2);

var _textEditorSelectors = __webpack_require__(236);

var _viewModeSelectors = __webpack_require__(153);

var _accessibility = __webpack_require__(49);

var _resizeImage = __webpack_require__(271);

var _resizeImage2 = _interopRequireDefault(_resizeImage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditorButtonGroup = function (_Component) {
  _inherits(TextEditorButtonGroup, _Component);

  function TextEditorButtonGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextEditorButtonGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextEditorButtonGroup.__proto__ || Object.getPrototypeOf(TextEditorButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.hasInlineStyle = function (inlineStyle) {
      return _this.props.editorState.getCurrentInlineStyle().has(inlineStyle);
    }, _this.setInlineStyle = function (inlineStyle) {
      return _this.setEditorState(_draftJs.RichUtils.toggleInlineStyle(_this.props.editorState, inlineStyle));
    }, _this.hasBlockType = function (blockType) {
      return blockModifiers.hasBlockType(blockType, _this.props.editorState);
    }, _this.toggleBlockType = function (blockType) {
      return _this.setEditorState(blockModifiers.toggleBlockType(blockType, _this.props.editorState));
    }, _this.toggleBlockStyleAndEnsureSpaces = function (blockType) {
      return _this.setEditorState(blockModifiers.toggleBlockTypeAndEnsureSpaces(blockType, _this.props.editorState));
    }, _this.handleLinkButtonClick = function () {
      var _this$props = _this.props,
          editorState = _this$props.editorState,
          identifier = _this$props.identifier,
          openModal = _this$props.openModal;

      var newState = linkModifiers.toggleLink({ editorState: editorState, identifier: identifier, openModal: openModal });
      if (newState) {
        _this.setEditorState(newState);
      }
    }, _this.isLinkButtonActive = function () {
      return (0, _textEditorUtils.hasLinksInSelection)(_this.props.editorState);
    }, _this.hasTextAlignment = function (textAlignment) {
      var editorState = _this.props.editorState;

      var currentTextAlignment = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getData().get('textAlignment');

      return currentTextAlignment === textAlignment && currentTextAlignment !== 'left';
    }, _this.setTextAlignment = function (textAlignment) {
      var newEditorState = textAlignmentModifiers.setTextAlignment(textAlignment, _this.props.editorState);
      _this.setEditorState(newEditorState);
    }, _this.handleFileSelect = function (imageData) {
      var _this$props2 = _this.props,
          insertTextEditorEntity = _this$props2.insertTextEditorEntity,
          editorState = _this$props2.editorState,
          identifier = _this$props2.identifier;

      var props = { src: imageData };
      var entityKey = editorState.getCurrentContent().createEntity('IMAGE', 'IMMUTABLE', props).getLastCreatedEntityKey();

      insertTextEditorEntity({
        entityKey: entityKey,
        identifier: identifier
      });
    }, _this.handleUploadImage = function (event) {
      var file = event.target.files[0];
      _this.props.uploadStarted({ type: _upload.TYPE_IMAGE });
      return (0, _resizeImage2.default)(file).then(function (imageData) {
        var _this$props3 = _this.props,
            insertTextEditorEntity = _this$props3.insertTextEditorEntity,
            editorState = _this$props3.editorState,
            upload = _this$props3.upload,
            identifier = _this$props3.identifier,
            uploadEnded = _this$props3.uploadEnded;

        var props = {
          src: imageData,
          isLoading: true
        };
        var entityKey = editorState.getCurrentContent().createEntity('IMAGE', 'IMMUTABLE', props).getLastCreatedEntityKey();

        insertTextEditorEntity({
          entityKey: entityKey,
          identifier: identifier
        });

        var shouldUploadDataUrl = file.type !== 'image/gif';
        upload(shouldUploadDataUrl ? imageData.dataUrl : file, _upload.TYPE_IMAGE, function (file) {
          uploadEnded({ type: _upload.TYPE_IMAGE });
          return (0, _setTextEditorEntityData.setTextEditorEntityData)({
            entityData: {
              src: file,
              isLoading: false
            },
            entityKey: entityKey,
            identifier: identifier
          });
        });
      });
    }, _this.handleVideoEmbed = function () {
      var identifier = _this.props.identifier;

      _this.props.openModal(_modalTypes.MODAL_TYPE_TEXT_EDITOR_VIDEO_EMBED, { identifier: identifier }, (0, _textEditorUtils.getFocusableContainerId)(identifier));
    }, _this.setEditorState = function (editorState) {
      return _this.props.updateTextEditor({
        identifier: _this.props.identifier,
        editorState: editorState
      });
    }, _this.getButtonProps = function (type) {
      switch (type) {
        case _buttons.BUTTON_BOLD:
        case _buttons.BUTTON_ITALIC:
          return {
            hasInlineStyle: _this.hasInlineStyle,
            setInlineStyle: _this.setInlineStyle
          };
        case _buttons.BUTTON_TITLE:
        case _buttons.BUTTON_SUBTITLE:
        case _buttons.BUTTON_NUMBERING:
        case _buttons.BUTTON_BULLETS:
        case _buttons.BUTTON_BLOCKQUOTE:
          return {
            isBlockType: _this.hasBlockType,
            toggleBlockType: _this.toggleBlockType
          };

        case _buttons.BUTTON_CODE_BLOCK:
          return {
            isBlockType: _this.hasBlockType,
            toggleBlockType: _this.toggleBlockStyleAndEnsureSpaces
          };

        case _buttons.BUTTON_HEADER_DROPDOWN:
        case _buttons.BUTTON_LIST_DROPDOWN:
          return {
            isActive: _this.hasBlockType,
            onClick: _this.toggleBlockType
          };

        case _buttons.BUTTON_ALIGN_TEXT_DROPDOWN:
          return {
            isActive: _this.hasTextAlignment,
            onClick: _this.setTextAlignment
          };

        case _buttons.BUTTON_LINK:
          return {
            isActive: _this.isLinkButtonActive(),
            onClick: _this.handleLinkButtonClick
          };

        case _buttons.BUTTON_IMAGE:
          return {
            onFileChange: _this.handleUploadImage
          };

        case _buttons.BUTTON_IMAGE_MEDIA_DIALOG:
          return {
            onFileSelect: _this.handleFileSelect
          };

        case _buttons.BUTTON_VIDEO:
          return {
            onClick: _this.handleVideoEmbed,
            onKeyUp: (0, _accessibility.handleEnterKeyUp)(_this.handleVideoEmbed)
          };

        default:
          return {};
      }
    }, _this.renderButton = function (type, key) {
      var _this$props4 = _this.props,
          isInverted = _this$props4.isInverted,
          disableOnBlur = _this$props4.disableOnBlur,
          editorState = _this$props4.editorState,
          isEditor = _this$props4.isEditor,
          theme = _this$props4.theme;


      if (isEditor && type === _buttons.BUTTON_IMAGE) {
        type = _buttons.BUTTON_IMAGE_MEDIA_DIALOG;
      }

      var Component = _buttons3.default[type];
      var props = _extends({}, _this.getButtonProps(type), {
        isInverted: isInverted,
        isDisabled: disableOnBlur && !editorState.getSelection().getHasFocus()
      });
      return _react2.default.createElement(
        'div',
        { className: _this.props.buttonClassName, key: key },
        _react2.default.createElement(Component, _extends({}, props, { theme: theme }))
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextEditorButtonGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          containerClassName = _props.containerClassName,
          buttons = _props.buttons;

      return _react2.default.createElement(
        'div',
        { className: containerClassName },
        _lodash2.default.map(buttons, function (button, index) {
          return _this2.renderButton(button, index);
        })
      );
    }
  }]);

  return TextEditorButtonGroup;
}(_react.Component);

TextEditorButtonGroup.propTypes = {
  editorState: _propTypes2.default.object,
  buttons: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(Object.keys(_buttons3.default))),
  containerClassName: _propTypes2.default.string,
  buttonClassName: _propTypes2.default.string,
  identifier: _propTypes2.default.string,
  isInverted: _propTypes2.default.bool,
  openModal: _propTypes2.default.func,
  upload: _propTypes2.default.func,
  cancelUploads: _propTypes2.default.func,
  uploadStarted: _propTypes2.default.func,
  uploadEnded: _propTypes2.default.func,
  updateTextEditor: _propTypes2.default.func,
  setTextEditorEntityData: _propTypes2.default.func,
  insertTextEditorEntity: _propTypes2.default.func,
  disableOnBlur: _propTypes2.default.bool,
  isEditor: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};

TextEditorButtonGroup.defaultProps = {
  buttons: []
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    editorState: (0, _textEditorSelectors.getTextEditorStateByKey)(state, ownProps.identifier),
    isEditor: (0, _viewModeSelectors.isEditor)(state)
  };
};

var mapDispatchToProps = {
  openModal: _openModal.openModal,
  upload: _upload.upload,
  cancelUploads: _cancelUploads.cancelUploads,
  uploadStarted: _uploadStarted.uploadStarted,
  uploadEnded: _uploadEnded.uploadEnded,
  updateTextEditor: _updateTextEditor.updateTextEditor,
  setTextEditorEntityData: _setTextEditorEntityData.setTextEditorEntityData,
  insertTextEditorEntity: _insertTextEditorEntity.insertTextEditorEntity
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TextEditorButtonGroup);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPLOAD_ENDED = exports.UPLOAD_ENDED = 'app/UPLOAD_ENDED';

var uploadEnded = exports.uploadEnded = function uploadEnded(payload) {
  return {
    type: UPLOAD_ENDED,
    payload: payload
  };
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPLOAD_STARTED = exports.UPLOAD_STARTED = 'app/UPLOAD_STARTED';

var uploadStarted = exports.uploadStarted = function uploadStarted(payload) {
  return {
    type: UPLOAD_STARTED,
    payload: payload
  };
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(52);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(333);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(678);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(680);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(681);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(228);

var _isTransform = __webpack_require__(682);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(115);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _componentOrElement = __webpack_require__(113);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _ownerDocument = __webpack_require__(54);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _getContainer = __webpack_require__(143);

var _getContainer2 = _interopRequireDefault(_getContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = _react2.default.createClass({

  displayName: 'Portal',

  propTypes: {
    /**
     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
     * appended to it.
     */
    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
  },

  componentDidMount: function componentDidMount() {
    this._renderOverlay();
  },
  componentDidUpdate: function componentDidUpdate() {
    this._renderOverlay();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  },
  _mountOverlayTarget: function _mountOverlayTarget() {
    if (!this._overlayTarget) {
      this._overlayTarget = document.createElement('div');
      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  },
  _unmountOverlayTarget: function _unmountOverlayTarget() {
    if (this._overlayTarget) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._overlayTarget = null;
    }
    this._portalContainerNode = null;
  },
  _renderOverlay: function _renderOverlay() {

    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);

    // Save reference for future access.
    if (overlay !== null) {
      this._mountOverlayTarget();
      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
    } else {
      // Unrender if the component is null for transitions to null
      this._unrenderOverlay();
      this._unmountOverlayTarget();
    }
  },
  _unrenderOverlay: function _unrenderOverlay() {
    if (this._overlayTarget) {
      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
      this._overlayInstance = null;
    }
  },
  render: function render() {
    return null;
  },
  getMountNode: function getMountNode() {
    return this._overlayTarget;
  },
  getOverlayDOMNode: function getOverlayDOMNode() {
    if (!this.isMounted()) {
      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
    }

    if (this._overlayInstance) {
      return _reactDom2.default.findDOMNode(this._overlayInstance);
    }

    return null;
  }
});

exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextEditorStateByKey = exports.getTextEditor = undefined;

var _draftJs = __webpack_require__(10);

var getTextEditor = exports.getTextEditor = function getTextEditor(state) {
  return state.textEditor;
};
var getTextEditorStateByKey = exports.getTextEditorStateByKey = function getTextEditorStateByKey(state, key) {
  return getTextEditor(state)[key] || _draftJs.EditorState.createEmpty();
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _externalLink = __webpack_require__(742);

var _externalLink2 = _interopRequireDefault(_externalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _externalLink2.default;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatUrl;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _linkifyIt = __webpack_require__(344);

var _linkifyIt2 = _interopRequireDefault(_linkifyIt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkify = (0, _linkifyIt2.default)();

function formatUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return _lodash2.default.get(linkify.match(url), '[0].url', ('http://' + url).replace(/http:\/\/$/, ''));
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _react = __webpack_require__(0);

var string = _react.PropTypes.string,
    bool = _react.PropTypes.bool,
    number = _react.PropTypes.number,
    oneOfType = _react.PropTypes.oneOfType,
    shape = _react.PropTypes.shape,
    object = _react.PropTypes.object,
    func = _react.PropTypes.func;
var propTypes = exports.propTypes = {
  url: string,
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  hidden: bool,
  className: string,
  style: object,
  progressFrequency: number,
  soundcloudConfig: shape({
    clientId: string,
    showArtwork: bool
  }),
  youtubeConfig: shape({
    playerVars: object,
    preload: bool
  }),
  vimeoConfig: shape({
    iframeParams: object,
    preload: bool
  }),
  fileConfig: shape({
    attributes: object
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onProgress: func
};

var defaultProps = exports.defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: 0.8,
  playbackRate: 1,
  width: 640,
  height: 360,
  hidden: false,
  progressFrequency: 1000,
  soundcloudConfig: {
    clientId: 'e8b6f84fbcad14c301ca1355cae1dea2',
    showArtwork: true
  },
  youtubeConfig: {
    playerVars: {},
    preload: false
  },
  vimeoConfig: {
    iframeParams: {},
    preload: false
  },
  fileConfig: {
    attributes: {}
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {},
  onProgress: function onProgress() {}
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractHashtags = undefined;

var _extractHashtags = __webpack_require__(359);

Object.defineProperty(exports, 'extractHashtags', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_extractHashtags).default;
  }
});
exports.default = HashtagPlugin;

var _hashtagStrategy = __webpack_require__(792);

var _hashtagStrategy2 = _interopRequireDefault(_hashtagStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HashtagPlugin(_ref) {
  var Hashtag = _ref.Hashtag;

  return {
    decorators: [{
      component: Hashtag,
      strategy: _hashtagStrategy2.default
    }]
  };
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _deleteConfirmation = __webpack_require__(857);

var _deleteConfirmation2 = _interopRequireDefault(_deleteConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _deleteConfirmation2.default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _reportAbuseForm = __webpack_require__(549);

var _reportAbuseForm2 = _interopRequireDefault(_reportAbuseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reportAbuseForm2.default;

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_AUTH = exports.SET_AUTH = 'auth/SET';

var setAuth = exports.setAuth = function setAuth(payload) {
  return {
    type: SET_AUTH,
    payload: payload
  };
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.incrementCommentLikeCount = incrementCommentLikeCount;
var INCREMENT_COMMENT_LIKE_COUNT_REQUEST = exports.INCREMENT_COMMENT_LIKE_COUNT_REQUEST = 'comment/INCREMENT_LIKE_COUNT_REQUEST';
var INCREMENT_COMMENT_LIKE_COUNT_SUCCESS = exports.INCREMENT_COMMENT_LIKE_COUNT_SUCCESS = 'comment/INCREMENT_LIKE_COUNT_SUCCESS';
var INCREMENT_COMMENT_LIKE_COUNT_FAILURE = exports.INCREMENT_COMMENT_LIKE_COUNT_FAILURE = 'comment/INCREMENT_LIKE_COUNT_FAILURE';

var incrementCommentLikeCountRequest = exports.incrementCommentLikeCountRequest = function incrementCommentLikeCountRequest(_ref) {
  var commentId = _ref.commentId,
      postId = _ref.postId;
  return {
    type: INCREMENT_COMMENT_LIKE_COUNT_REQUEST,
    payload: { _id: commentId, postId: postId }
  };
};
var incrementCommentLikeCountFailure = exports.incrementCommentLikeCountFailure = function incrementCommentLikeCountFailure(_ref2) {
  var commentId = _ref2.commentId,
      postId = _ref2.postId;
  return {
    type: INCREMENT_COMMENT_LIKE_COUNT_FAILURE,
    payload: { _id: commentId, postId: postId }
  };
};
var incrementCommentLikeCountSuccess = exports.incrementCommentLikeCountSuccess = function incrementCommentLikeCountSuccess(_ref3) {
  var commentId = _ref3.commentId,
      postId = _ref3.postId,
      count = _ref3.count,
      isLiked = _ref3.isLiked;
  return {
    type: INCREMENT_COMMENT_LIKE_COUNT_SUCCESS,
    payload: { _id: commentId, postId: postId, likeCount: count, isLiked: isLiked }
  };
};

function incrementCommentLikeCount(_ref4) {
  var commentId = _ref4.commentId,
      postId = _ref4.postId;

  return function (dispatch, getState, _ref5) {
    var request = _ref5.request;

    dispatch(incrementCommentLikeCountRequest({ commentId: commentId, postId: postId }));

    var promise = request.post('/_api/posts/' + postId + '/comments/' + commentId + '/likes');
    return promise.then(function (data) {
      return dispatch(incrementCommentLikeCountSuccess(_extends({ commentId: commentId, postId: postId }, data)));
    }).catch(function () {
      return dispatch(incrementCommentLikeCountFailure({ commentId: commentId, postId: postId }));
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_COMMUNITIES_CONTEXT = exports.SET_COMMUNITIES_CONTEXT = 'communitiesContext/SET';

var setCommunitiesContext = exports.setCommunitiesContext = function setCommunitiesContext(payload) {
  return function (dispatch) {
    dispatch({ type: SET_COMMUNITIES_CONTEXT, payload: payload });
    return Promise.resolve();
  };
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_CATEGORIES_REQUEST = exports.FETCH_CATEGORIES_REQUEST = 'categories/FETCH_REQUEST';
var FETCH_CATEGORIES_SUCCESS = exports.FETCH_CATEGORIES_SUCCESS = 'categories/FETCH_SUCCESS';
var FETCH_CATEGORIES_FAILURE = exports.FETCH_CATEGORIES_FAILURE = 'categories/FETCH_FAILURE';

exports.default = function () {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: FETCH_CATEGORIES_REQUEST
    });

    return request('/_api/categories').then(function (categories) {
      return dispatch({
        type: FETCH_CATEGORIES_SUCCESS,
        payload: categories
      });
    }).catch(function () {
      return dispatch({
        type: FETCH_CATEGORIES_FAILURE
      });
    });
  };
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveUserImage;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _getImageUrl = __webpack_require__(183);

var _getImageUrl2 = _interopRequireDefault(_getImageUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line max-params
function resolveUserImage(image, type, width, height, quality) {
  return _lodash2.default.isObject(image) ? (0, _getImageUrl2.default)(image, width, height, quality, type) : image;
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _actionButton = __webpack_require__(930);

var _actionButton2 = _interopRequireDefault(_actionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _actionButton2.default;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(298);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 254 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createThunk = undefined;

var _handlerError = __webpack_require__(442);

var createThunk = exports.createThunk = function createThunk(thunk) {
  return function (dispatch, getState, args) {
    return thunk((0, _handlerError.handleError)(dispatch), getState, args);
  };
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_VIEW_MODE = exports.SET_VIEW_MODE = 'view-mode/SET';

var setViewMode = exports.setViewMode = function setViewMode(payload) {
  return { type: SET_VIEW_MODE, payload: payload };
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(150)(module), __webpack_require__(33)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.0
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.IPv6 = factory(root);
  }
}(this, function (root) {
  'use strict';

  /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */

  // save current IPv6 variable, if any
  var _IPv6 = root && root.IPv6;

  function bestPresentation(address) {
    // based on:
    // Javascript to test an IPv6 address for proper format, and to
    // present the "best text representation" according to IETF Draft RFC at
    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
    // 8 Feb 2010 Rich Brown, Dartware, LLC
    // Please feel free to use this code as long as you provide a link to
    // http://www.intermapper.com
    // http://intermapper.com/support/tools/IPV6-Validator.aspx
    // http://download.dartware.com/thirdparty/ipv6validator.js

    var _address = address.toLowerCase();
    var segments = _address.split(':');
    var length = segments.length;
    var total = 8;

    // trim colons (:: or ::a:b:c… or …a:b:c::)
    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
      // must have been ::
      // remove first two items
      segments.shift();
      segments.shift();
    } else if (segments[0] === '' && segments[1] === '') {
      // must have been ::xxxx
      // remove the first item
      segments.shift();
    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
      // must have been xxxx::
      segments.pop();
    }

    length = segments.length;

    // adjust total segments for IPv4 trailer
    if (segments[length - 1].indexOf('.') !== -1) {
      // found a "." which means IPv4
      total = 7;
    }

    // fill empty segments them with "0000"
    var pos;
    for (pos = 0; pos < length; pos++) {
      if (segments[pos] === '') {
        break;
      }
    }

    if (pos < total) {
      segments.splice(pos, 1, '0000');
      while (segments.length < total) {
        segments.splice(pos, 0, '0000');
      }
    }

    // strip leading zeros
    var _segments;
    for (var i = 0; i < total; i++) {
      _segments = segments[i].split('');
      for (var j = 0; j < 3 ; j++) {
        if (_segments[0] === '0' && _segments.length > 1) {
          _segments.splice(0,1);
        } else {
          break;
        }
      }

      segments[i] = _segments.join('');
    }

    // find longest sequence of zeroes and coalesce them into one segment
    var best = -1;
    var _best = 0;
    var _current = 0;
    var current = -1;
    var inzeroes = false;
    // i; already declared

    for (i = 0; i < total; i++) {
      if (inzeroes) {
        if (segments[i] === '0') {
          _current += 1;
        } else {
          inzeroes = false;
          if (_current > _best) {
            best = current;
            _best = _current;
          }
        }
      } else {
        if (segments[i] === '0') {
          inzeroes = true;
          current = i;
          _current = 1;
        }
      }
    }

    if (_current > _best) {
      best = current;
      _best = _current;
    }

    if (_best > 1) {
      segments.splice(best, _best, '');
    }

    length = segments.length;

    // assemble remaining segments
    var result = '';
    if (segments[0] === '')  {
      result = ':';
    }

    for (i = 0; i < length; i++) {
      result += segments[i];
      if (i === length - 1) {
        break;
      }

      result += ':';
    }

    if (segments[length - 1] === '') {
      result += ':';
    }

    return result;
  }

  function noConflict() {
    /*jshint validthis: true */
    if (root.IPv6 === this) {
      root.IPv6 = _IPv6;
    }

    return this;
  }

  return {
    best: bestPresentation,
    noConflict: noConflict
  };
}));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.0
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
  }
}(this, function (root) {
  'use strict';

  // save current SecondLevelDomains variable, if any
  var _SecondLevelDomains = root && root.SecondLevelDomains;

  var SLD = {
    // list of known Second Level Domains
    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
    // ----
    // publicsuffix.org is more current and actually used by a couple of browsers internally.
    // downside is it also contains domains like "dyndns.org" - which is fine for the security
    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
    // ----
    list: {
      'ac':' com gov mil net org ',
      'ae':' ac co gov mil name net org pro sch ',
      'af':' com edu gov net org ',
      'al':' com edu gov mil net org ',
      'ao':' co ed gv it og pb ',
      'ar':' com edu gob gov int mil net org tur ',
      'at':' ac co gv or ',
      'au':' asn com csiro edu gov id net org ',
      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
      'bb':' biz co com edu gov info net org store tv ',
      'bh':' biz cc com edu gov info net org ',
      'bn':' com edu gov net org ',
      'bo':' com edu gob gov int mil net org tv ',
      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
      'bs':' com edu gov net org ',
      'bz':' du et om ov rg ',
      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
      'ck':' biz co edu gen gov info net org ',
      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
      'co':' com edu gov mil net nom org ',
      'cr':' ac c co ed fi go or sa ',
      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
      'do':' art com edu gob gov mil net org sld web ',
      'dz':' art asso com edu gov net org pol ',
      'ec':' com edu fin gov info med mil net org pro ',
      'eg':' com edu eun gov mil name net org sci ',
      'er':' com edu gov ind mil net org rochest w ',
      'es':' com edu gob nom org ',
      'et':' biz com edu gov info name net org ',
      'fj':' ac biz com info mil name net org pro ',
      'fk':' ac co gov net nom org ',
      'fr':' asso com f gouv nom prd presse tm ',
      'gg':' co net org ',
      'gh':' com edu gov mil org ',
      'gn':' ac com gov net org ',
      'gr':' com edu gov mil net org ',
      'gt':' com edu gob ind mil net org ',
      'gu':' com edu gov net org ',
      'hk':' com edu gov idv net org ',
      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
      'id':' ac co go mil net or sch web ',
      'il':' ac co gov idf k12 muni net org ',
      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
      'iq':' com edu gov i mil net org ',
      'ir':' ac co dnssec gov i id net org sch ',
      'it':' edu gov ',
      'je':' co net org ',
      'jo':' com edu gov mil name net org sch ',
      'jp':' ac ad co ed go gr lg ne or ',
      'ke':' ac co go info me mobi ne or sc ',
      'kh':' com edu gov mil net org per ',
      'ki':' biz com de edu gov info mob net org tel ',
      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
      'kn':' edu gov net org ',
      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
      'kw':' com edu gov net org ',
      'ky':' com edu gov net org ',
      'kz':' com edu gov mil net org ',
      'lb':' com edu gov net org ',
      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
      'lr':' com edu gov net org ',
      'lv':' asn com conf edu gov id mil net org ',
      'ly':' com edu gov id med net org plc sch ',
      'ma':' ac co gov m net org press ',
      'mc':' asso tm ',
      'me':' ac co edu gov its net org priv ',
      'mg':' com edu gov mil nom org prd tm ',
      'mk':' com edu gov inf name net org pro ',
      'ml':' com edu gov net org presse ',
      'mn':' edu gov org ',
      'mo':' com edu gov net org ',
      'mt':' com edu gov net org ',
      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
      'mw':' ac co com coop edu gov int museum net org ',
      'mx':' com edu gob net org ',
      'my':' com edu gov mil name net org sch ',
      'nf':' arts com firm info net other per rec store web ',
      'ng':' biz com edu gov mil mobi name net org sch ',
      'ni':' ac co com edu gob mil net nom org ',
      'np':' com edu gov mil net org ',
      'nr':' biz com edu gov info net org ',
      'om':' ac biz co com edu gov med mil museum net org pro sch ',
      'pe':' com edu gob mil net nom org sld ',
      'ph':' com edu gov i mil net ngo org ',
      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
      'pr':' ac biz com edu est gov info isla name net org pro prof ',
      'ps':' com edu gov net org plo sec ',
      'pw':' belau co ed go ne or ',
      'ro':' arts com firm info nom nt org rec store tm www ',
      'rs':' ac co edu gov in org ',
      'sb':' com edu gov net org ',
      'sc':' com edu gov net org ',
      'sh':' co com edu gov net nom org ',
      'sl':' com edu gov net org ',
      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
      'sv':' com edu gob org red ',
      'sz':' ac co org ',
      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
      'tw':' club com ebiz edu game gov idv mil net org ',
      'mu':' ac co com gov net or org ',
      'mz':' ac co edu gov org ',
      'na':' co com ',
      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
      'pa':' abo ac com edu gob ing med net nom org sld ',
      'pt':' com edu gov int net nome org publ ',
      'py':' com edu gov mil net org ',
      'qa':' com edu gov mil net org ',
      're':' asso com nom ',
      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
      'rw':' ac co com edu gouv gov int mil net ',
      'sa':' com edu gov med net org pub sch ',
      'sd':' com edu gov info med net org tv ',
      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
      'sg':' com edu gov idn net org per ',
      'sn':' art com edu gouv org perso univ ',
      'sy':' com edu gov mil net news org ',
      'th':' ac co go in mi net or ',
      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
      'tz':' ac co go ne or ',
      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
      'ug':' ac co go ne or org sc ',
      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
      'us':' dni fed isa kids nsn ',
      'uy':' com edu gub mil net org ',
      've':' co com edu gob info mil net org web ',
      'vi':' co com k12 net org ',
      'vn':' ac biz com edu gov health info int name net org pro ',
      'ye':' co com gov ltd me net org plc ',
      'yu':' ac co edu gov org ',
      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
      'zm':' ac co com edu gov net org sch ',
      // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
      'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
      'net': 'gb jp se uk ',
      'org': 'ae',
      'de': 'com '
    },
    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
    // in both performance and memory footprint. No initialization required.
    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
    // Following methods use lastIndexOf() rather than array.split() in order
    // to avoid any memory allocations.
    has: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
    },
    is: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset >= 0) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
    },
    get: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return null;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return null;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return null;
      }
      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
        return null;
      }
      return domain.slice(sldOffset+1);
    },
    noConflict: function(){
      if (root.SecondLevelDomains === this) {
        root.SecondLevelDomains = _SecondLevelDomains;
      }
      return this;
    }
  };

  return SLD;
}));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCategoryCounters = exports.updatePostCounters = exports.newPost = exports.SOCKET_UPDATE_CATEGORY_COUNTERS = exports.UPDATE_CATEGORY_COUNTERS = exports.SOCKET_UPDATE_POST_COUNTERS = exports.UPDATE_POST_COUNTERS = exports.SOCKET_NEW_POST = exports.NEW_POST = exports.emitOpenCategory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _wsActions = __webpack_require__(128);

var _wsChannel = __webpack_require__(151);

var _showNewPostMessage = __webpack_require__(396);

var emitOpenCategory = exports.emitOpenCategory = function emitOpenCategory(category) {
  return (0, _wsActions.joinChannel)((0, _wsChannel.getChannel)(_extends({ type: 'category' }, category)));
};

var NEW_POST = exports.NEW_POST = 'post/NEW';
var SOCKET_NEW_POST = exports.SOCKET_NEW_POST = 'new post';
var UPDATE_POST_COUNTERS = exports.UPDATE_POST_COUNTERS = 'post/UPDATE_POST_COUNTERS';
var SOCKET_UPDATE_POST_COUNTERS = exports.SOCKET_UPDATE_POST_COUNTERS = 'update post counters';

var UPDATE_CATEGORY_COUNTERS = exports.UPDATE_CATEGORY_COUNTERS = 'category/UPDATE_CATEGORY_COUNTERS';
var SOCKET_UPDATE_CATEGORY_COUNTERS = exports.SOCKET_UPDATE_CATEGORY_COUNTERS = 'update category counters';

var newPost = exports.newPost = function newPost(payload) {
  return function (dispatch) {
    dispatch({
      type: NEW_POST,
      payload: payload
    });
    dispatch((0, _showNewPostMessage.showNewPostMessageDebounced)(payload._id));
  };
};

var updatePostCounters = exports.updatePostCounters = function updatePostCounters(payload) {
  return function (dispatch) {
    return dispatch({
      type: UPDATE_POST_COUNTERS,
      payload: payload
    });
  };
};

var updateCategoryCounters = exports.updateCategoryCounters = function updateCategoryCounters(payload) {
  return function (dispatch) {
    return dispatch({
      type: UPDATE_CATEGORY_COUNTERS,
      payload: payload
    });
  };
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTextEditor = exports.UPDATE_TEXT_EDITOR = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_TEXT_EDITOR = exports.UPDATE_TEXT_EDITOR = 'textEditor/UPDATE';

var updateTextEditor = exports.updateTextEditor = (0, _createAction2.default)(UPDATE_TEXT_EDITOR);

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _appLoaded = __webpack_require__(1389);

var _appLoaded2 = _interopRequireDefault(_appLoaded);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _appLoaded2.default;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LAYOUT_TYPE_PINBOARD = exports.LAYOUT_TYPE_PINBOARD = 0;
var LAYOUT_TYPE_CLASSIC = exports.LAYOUT_TYPE_CLASSIC = 1;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginMember = undefined;

var _memberUserMapper = __webpack_require__(602);

var _memberUserMapper2 = _interopRequireDefault(_memberUserMapper);

var _createUser = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginMember = exports.loginMember = function loginMember(member) {
  return (0, _createUser.createUser)((0, _memberUserMapper2.default)(member));
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//TODO: this needs to read from the settings in the DB. this will ensure that the forum will be out of wix like it is in wix
var getMainColor = exports.getMainColor = function getMainColor() {
  return '#27a456';
};

var getSecondaryColor = exports.getSecondaryColor = function getSecondaryColor() {
  return '#faad4d';
};

var getSecondaryColorNumbers = exports.getSecondaryColorNumbers = function getSecondaryColorNumbers() {
  var color = getSecondaryColor();
  var matches = color.match(/#([\da-f]{2})([\da-f]{2})([\da-f]{2})/i);
  var numbers = matches.slice(1).map(function (number) {
    return parseInt(number, 16);
  });
  return numbers;
};

var getDisabledColor = exports.getDisabledColor = function getDisabledColor() {
  return '#f0f0f0';
};

/***/ }),
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_CATEGORIES = exports.SET_CATEGORIES = 'categories/SET';

var setCategories = exports.setCategories = function setCategories(payload) {
  return {
    type: SET_CATEGORIES,
    payload: payload
  };
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERMISSIONS_ALL = exports.RESOURCE_MEMBER = exports.RESOURCE_COMMENT = exports.RESOURCE_POST = exports.RESOURCE_CATEGORY = exports.RESOURCE_FORUM = exports.ROLE_OWNER = exports.ROLE_ADMIN = exports.ROLE_MODERATOR = exports.ROLE_USER = exports.ROLE_GUEST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.permissionsChecker = permissionsChecker;
exports.resourcify = resourcify;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _jsAcl = __webpack_require__(597);

var _jsAcl2 = _interopRequireDefault(_jsAcl);

var _userPrivacyStatus = __webpack_require__(290);

var _userRole = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROLE_GUEST = exports.ROLE_GUEST = 'guest';
var ROLE_USER = exports.ROLE_USER = 'user';
var ROLE_MODERATOR = exports.ROLE_MODERATOR = 'moderator';
var ROLE_ADMIN = exports.ROLE_ADMIN = 'admin';
var ROLE_OWNER = exports.ROLE_OWNER = 'owner';

var RESOURCE_FORUM = exports.RESOURCE_FORUM = 'forum';
var RESOURCE_CATEGORY = exports.RESOURCE_CATEGORY = 'category';
var RESOURCE_POST = exports.RESOURCE_POST = 'post';
var RESOURCE_COMMENT = exports.RESOURCE_COMMENT = 'comment';
var RESOURCE_MEMBER = exports.RESOURCE_MEMBER = 'member';

var PERMISSIONS_ALL = exports.PERMISSIONS_ALL = 'all';

/*
* PermissionsChecker provides 2 types of checks:
* - can: this checks if a role can do an action on resource
* - canSee: this checks if a role can see an action on resource (know that there is an ability to do such action)
*
* They are mostly identical, but for some resources action they differ. For example,
* everyone can see like on post, but only logged in, non blocked, non private can like.
*
* If a role can do an action on resource, this means he can also see.*/
function permissionsChecker() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isMemberAreaInst = _ref.isMemberAreaInstalled,
      isMemberAreaInstalled = _ref$isMemberAreaInst === undefined ? false : _ref$isMemberAreaInst,
      _ref$isMemberAreaEnab = _ref.isMemberAreaEnabled,
      isMemberAreaEnabled = _ref$isMemberAreaEnab === undefined ? false : _ref$isMemberAreaEnab,
      _ref$isTopCommentExpe = _ref.isTopCommentExperimentEnabled,
      isTopCommentExperimentEnabled = _ref$isTopCommentExpe === undefined ? false : _ref$isTopCommentExpe;

  var user = arguments[1];
  var resolve = arguments[2];

  var setupAcl = function setupAcl(acl, isSee) {
    // Roles
    acl.addRole('guest');
    acl.addRole('user', 'guest');
    acl.addRole('moderator', 'user');
    acl.addRole('admin', 'user');
    acl.addRole('owner', 'admin');

    // Resources
    acl.addResource('forum');
    acl.addResource('category');
    acl.addResource('post', 'category');
    acl.addResource('comment', 'post');
    acl.addResource('member');

    // Guest
    acl.allow('guest', 'category', ['read', 'share'], and(not(resourceIsPrivate), not(resourceIsReadProtected)));

    if (isSee) {
      acl.allow('guest', 'post', 'like', and(not(resourceIsPrivate), not(resourceIsReadProtected)));
    }

    // User
    acl.allow('user', 'category', 'read', and(or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')), or(not(resourceIsPrivate), and(resourceIsPrivate, not(userIsPrivate)))));

    acl.allow('user', 'category', 'subscribe', isSee ? or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')) : and(or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')), not(userIsPrivate)));
    acl.allow('user', 'category', 'create-post', or(not(resourceIsWriteProtected), userHasPermission('write')));
    acl.allow('user', 'post', 'like', isSee ? or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')) : and(or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')), not(userIsPrivate)));
    acl.allow('user', 'post', 'edit', isSee ? userIsResourceOwner : and(userIsResourceOwner, not(userIsPrivate)));
    acl.allow('user', 'post', 'delete', userIsResourceOwner);
    acl.allow('user', 'post', 'create-comment', and(not(resourceHasCommentsDisabled), or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write'))));

    acl.allow('user', 'post', ['add-top-comment', 'remove-top-comment'], userIsResourceOwner);

    var hasMembersFunctions = !isMemberAreaEnabled || isMemberAreaEnabled && isMemberAreaInstalled;

    if (hasMembersFunctions) {
      acl.allow('user', 'post', 'report', isSee ? and(not(userIsResourceOwner), not(resourceOwnerHasRoles('owner'))) : and(not(userIsResourceOwner), not(resourceOwnerHasRoles('owner')), not(userIsPrivate)));
      acl.allow('user', 'post', 'subscribe', isSee ? or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')) : and(or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')), not(userIsPrivate)));
    } else {
      acl.deny('user', 'post', 'subscribe');
    }

    if (hasMembersFunctions) {
      acl.allow('user', 'comment', 'report', isSee ? and(not(userIsResourceOwner), not(resourceOwnerHasRoles('owner')), not(resourceIsReadProtected)) : and(not(userIsResourceOwner), not(resourceOwnerHasRoles('owner')), not(userIsPrivate)));
    }

    acl.allow('user', 'comment', 'like', isSee ? or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')) : and(or(not(resourceIsReadProtected), userHasPermission('read'), userHasPermission('write')), not(userIsPrivate)));

    acl.allow('user', 'comment', 'edit', userIsResourceOwner);
    acl.allow('user', 'comment', 'delete', userIsResourceOwner);

    if (hasMembersFunctions) {
      acl.allow('user', 'member', 'subscribe', and(not(userIsResource), not(userIsPrivate)));
      acl.allow('user', 'member', 'list', not(userIsPrivate));
      acl.allow('user', 'member', 'report', and(and(not(userIsResource), not(resourceHasRoles('owner'))), not(userIsPrivate)));
    }

    acl.allow('user', 'member', 'edit', userIsResource);
    acl.allow('user', 'member', 'delete', and(userIsResource, not(resourceHasRoles('owner'))));

    // Moderator
    acl.allow('moderator', 'category', ['read', 'create-post', 'edit', 'subscribe'], userHasPermission('moderate'));
    acl.allow('moderator', 'post', ['pin', 'toggle-comments', 'move', 'create-comment', 'add-top-comment', 'remove-top-comment'], userHasPermission('moderate'));
    acl.allow('moderator', 'post', 'delete', and(userHasPermission('moderate'), not(resourceOwnerHasRoles('admin', 'owner'))));
    acl.allow('moderator', 'post', 'create-comment', and(not(resourceHasCommentsDisabled), userHasPermission('moderate')));
    acl.deny('moderator', 'post', 'edit', not(userIsResourceOwner));
    acl.deny('moderator', 'post', 'report', userHasPermission('moderate'));
    acl.deny('moderator', 'comment', 'report', userHasPermission('moderate'));

    // Admin
    acl.allow('admin', 'forum', 'reorder-categories');
    acl.allow('admin', 'category', ['read', 'subscribe', 'create', 'create-post', 'edit', 'delete']);
    acl.allow('admin', 'post', ['pin', 'toggle-comments', 'move', 'create-comment', 'delete', 'add-top-comment', 'remove-top-comment']);
    acl.allow('admin', 'post', 'create-comment', not(resourceHasCommentsDisabled));
    acl.allow('admin', 'comment', 'delete');
    acl.allow('admin', 'member', 'block', and(not(resourceHasRoles('admin', 'owner')), not(userIsResource)));
    acl.allow('admin', 'member', 'delete', not(resourceHasRoles('admin', 'owner')));
    acl.allow('admin', 'member', 'promote-moderator', and(not(resourceIsBlocked), not(resourceHasRoles('admin', 'owner')), not(userIsResource)));

    acl.deny('admin', 'post', 'edit', not(userIsResourceOwner));
    acl.deny('admin', 'post', 'report');
    acl.deny('admin', 'comment', 'report');

    // Owner
    acl.allow('owner', 'forum', 'edit');
    acl.allow('owner', 'member', 'block', not(resourceHasRoles('owner')));
    acl.allow('owner', 'member', 'delete', not(resourceHasRoles('owner')));
    acl.allow('owner', 'member', 'promote', and(not(resourceIsBlocked), not(resourceHasRoles('owner'))));
    acl.deny('owner', 'member', 'report');

    if (!isTopCommentExperimentEnabled) {
      acl.deny('user', 'post', ['add-top-comment', 'remove-top-comment']);
      acl.deny('moderator', 'post', ['add-top-comment', 'remove-top-comment']);
      acl.deny('admin', 'post', ['add-top-comment', 'remove-top-comment']);
    }

    return acl;
  };

  var acl = setupAcl(new _jsAcl2.default());
  var aclSee = setupAcl(new _jsAcl2.default(), isMemberAreaInstalled);

  var wrapped = {
    ROLE_GUEST: ROLE_GUEST,
    ROLE_USER: ROLE_USER,
    ROLE_MODERATOR: ROLE_MODERATOR,
    ROLE_ADMIN: ROLE_ADMIN,
    ROLE_OWNER: ROLE_OWNER,
    RESOURCE_FORUM: RESOURCE_FORUM,
    RESOURCE_CATEGORY: RESOURCE_CATEGORY,
    RESOURCE_POST: RESOURCE_POST,
    RESOURCE_COMMENT: RESOURCE_COMMENT,
    RESOURCE_MEMBER: RESOURCE_MEMBER,
    PERMISSIONS_ALL: PERMISSIONS_ALL,

    resourcify: resourcify,
    setUserIdentity: function setUserIdentity(user) {
      var identity = _extends({}, user);
      var role = (0, _userRole.getUserRole)(identity);
      if (_lodash2.default.isEmpty(identity)) {
        role = 'guest';
      }
      if (_lodash2.default.isEmpty(role)) {
        role = identity.isOwner ? 'owner' : 'user';
      }
      if (_lodash2.default.get(identity, 'isBlocked')) {
        role = 'guest';
      }
      // when member area not installed, we don't care about user being private.
      if (!isMemberAreaInstalled) {
        identity.privacyStatus = _userPrivacyStatus.USER_PRIVACY_STATUS_PUBLIC;
      }
      acl.setUserIdentity(rolify(identity, role));
      aclSee.setUserIdentity(rolify(identity, role));
    },
    can: function can(resource, permission) {
      return acl.can(resource, permission);
    },
    canSee: function canSee(resource, permission) {
      return aclSee.can(resource, permission);
    }
  };
  wrapped.setUserIdentity(user);
  return wrapped;

  function not(fn) {
    var _this = this;

    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return !fn.apply(_this, args);
    };
  }

  function and() {
    var _this2 = this;

    for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      fns[_key2] = arguments[_key2];
    }

    return function () {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _lodash2.default.every(fns, function (fn) {
        return fn.apply(_this2, args);
      });
    };
  }

  function or() {
    var _this3 = this;

    for (var _len4 = arguments.length, fns = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      fns[_key4] = arguments[_key4];
    }

    return function () {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _lodash2.default.some(fns, function (fn) {
        return fn.apply(_this3, args);
      });
    };
  }

  function userHasPermission(permission) {
    return function (user, resource) {
      var permissions = _lodash2.default.get(user, 'permissions.' + permission, []);
      return _lodash2.default.includes(permissions, PERMISSIONS_ALL) || _lodash2.default.includes(permissions, resolve(resource)._id);
    };
  }

  function userIsResource(user, resource) {
    return user._id === resource._id;
  }

  function userIsResourceOwner(user, resource) {
    return user._id === resource.ownerId;
  }

  function userIsPrivate(user) {
    return user.privacyStatus === _userPrivacyStatus.USER_PRIVACY_STATUS_PRIVATE;
  }

  function resourceHasCommentsDisabled(user, resource) {
    return resource.isCommentsDisabled;
  }

  function resourceHasRoles() {
    for (var _len6 = arguments.length, roles = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      roles[_key6] = arguments[_key6];
    }

    return function (user, resource) {
      return _lodash2.default.includes(roles, (0, _userRole.getUserRole)(resource));
    };
  }

  function resourceOwnerHasRoles() {
    for (var _len7 = arguments.length, roles = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      roles[_key7] = arguments[_key7];
    }

    return function (user, resource) {
      return _lodash2.default.includes(roles, (0, _userRole.getUserRole)(_lodash2.default.get(resource, 'owner')));
    };
  }

  function resourceIsPrivate(user, resource) {
    return resolve(resource).isPrivate;
  }

  function resourceIsReadProtected(user, resource) {
    return resolve(resource).isReadProtected;
  }

  function resourceIsWriteProtected(user, resource) {
    return resolve(resource).isWriteProtected;
  }

  function resourceIsBlocked(user, resource) {
    return resource.isBlocked;
  }

  function rolify(obj, role) {
    return _extends({}, obj, { getRoles: function getRoles() {
        return [role];
      } });
  }
}

function resourcify(obj, resource) {
  return obj ? _extends({}, obj, { getResourceId: function getResourceId() {
      return resource;
    } }) : resource;
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMemberAreaActive = undefined;

var _applications = __webpack_require__(25);

var _communitiesContextSelectors = __webpack_require__(47);

var isMemberAreaActive = exports.isMemberAreaActive = function isMemberAreaActive(state) {
  return (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.SANTA_MEMBERS_APP_ID).isInstalled;
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readImage = undefined;
exports.default = resizeImage;

var _pica = __webpack_require__(716);

var _pica2 = _interopRequireDefault(_pica);

var _fixOrientation = __webpack_require__(717);

var _fixOrientation2 = _interopRequireDefault(_fixOrientation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_WIDTH = 1920;
var MAX_HEIGHT = MAX_WIDTH * 4;
var OPTIONS = {
  alpha: true,
  quality: 3
};

function resizeImage(file) {
  var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_WIDTH;
  var maxHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_HEIGHT;

  var canvas = document.createElement('canvas');
  var img = document.createElement('img');
  var reader = new FileReader();
  var resolveFn = void 0;

  reader.onload = function (event) {
    return (0, _fixOrientation2.default)(event.target.result, function (fixed) {
      img.src = fixed;
    });
  };

  img.onload = function () {
    var width = img.width;
    var height = img.height;

    if (width > height && width > maxWidth) {
      height = Math.round(height * maxWidth / width);
      width = maxWidth;
    } else if (height > maxHeight) {
      width = Math.round(width * maxHeight / height);
      height = maxHeight;
    }

    canvas.width = width;
    canvas.height = height;

    _pica2.default.resizeCanvas(img, canvas, OPTIONS, function () {
      resolveFn({
        dataUrl: canvas.toDataURL(file.type),
        width: width,
        height: height
      });
    });
  };

  reader.readAsDataURL(file);

  return new Promise(function (resolve) {
    resolveFn = resolve;
  });
}

var readImage = exports.readImage = function readImage(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();

    reader.onload = function (event) {
      return resolve(event.target.result);
    };
    reader.readAsDataURL(file);
  });
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _userBadge = __webpack_require__(829);

var _userBadge2 = _interopRequireDefault(_userBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _userBadge2.default;

/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createRequest;

var _lodash = __webpack_require__(2);

function createRequest() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === undefined ? '' : _ref$baseUrl,
      _ref$instance = _ref.instance,
      instance = _ref$instance === undefined ? '' : _ref$instance,
      _ref$locale = _ref.locale,
      locale = _ref$locale === undefined ? 'en' : _ref$locale,
      cookie = _ref.cookie;

  var request = function request(path) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var url = '' + (0, _lodash.trimEnd)(baseUrl, '/') + path;
    var shouldParseHeaders = config.parseHeaders;

    delete config.parseHeaders;

    var headers = _extends({}, config.headers, {
      instance: instance,
      locale: locale
    });
    if (cookie) {
      headers.cookie = cookie;
    }

    (0, _lodash.extend)(config, {
      headers: headers,
      credentials: 'same-origin'
    });

    var promise = fetch(url, config).then(handleSuccess);

    return promise.then(shouldParseHeaders ? parseHeadersAndBody : parseBody);
  };

  request.post = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request.put = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request.patch = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request.delete = function (path, config) {
    return request(path, (0, _lodash.extend)({}, config, {
      method: 'DELETE'
    }));
  };

  request.uploadFile = function (file, credentials) {
    var formData = new FormData();

    formData.append('file', file);
    formData.append('media_type', 'picture');
    formData.append('upload_token', credentials.uploadToken);
    formData.append('parent_folder_id', credentials.folderId);

    var config = {
      method: 'POST',
      body: formData
    };

    return fetch(credentials.uploadUrl, config).then(handleSuccess).then(parseBody);
  };

  return request;
}

function handleSuccess(response) {
  var status = response.status;

  if (status < 400) {
    return response;
  }

  return Promise.reject(response);
}

function parseBody(response) {
  return response.json().catch(function () {
    return Promise.resolve();
  });
}

function parseHeadersAndBody(response) {
  return response.json().then(function (data) {
    return {
      body: data,
      headers: response.headers
    };
  }).catch(function () {
    return Promise.resolve();
  });
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(375);

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 286 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLUSH = exports.CANCEL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = middleware;

var _lodash = __webpack_require__(296);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CANCEL = exports.CANCEL = 'redux-debounce/CANCEL';
var FLUSH = exports.FLUSH = 'redux-debounce/FLUSH';

function map(debounced, action, method) {
  if (action.payload && action.payload.type) {
    var _ret = function () {
      var types = action.payload.type;
      if (!Array.isArray(types)) {
        types = [types];
      }
      Object.keys(debounced).filter(function (t) {
        return types.includes(t);
      }).forEach(function (t) {
        return debounced[t][method]();
      });
      return {
        v: void 0
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
  Object.keys(debounced).forEach(function (t) {
    return debounced[t][method]();
  });
  return;
}

function middleware() {
  var defaultWait = arguments.length <= 0 || arguments[0] === undefined ? 300 : arguments[0];
  var defaultThrottleOption = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var debounced = {};
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === CANCEL) {
          map(debounced, action, 'cancel');
          return next(action);
        }

        if (action.type === FLUSH) {
          map(debounced, action, 'flush');
          return next(action);
        }

        var shouldDebounce = (action.meta || {}).debounce;

        // check if we don't need to debounce the action
        if (!shouldDebounce) {
          return next(action);
        }

        if (debounced[action.type]) {
          // if it's a action which was throttled already
          return debounced[action.type](action);
        }

        var wait = defaultWait;
        var options = defaultThrottleOption;

        if (!isNaN(shouldDebounce) && shouldDebounce !== true) {
          wait = shouldDebounce;
        } else if ((typeof shouldDebounce === 'undefined' ? 'undefined' : _typeof(shouldDebounce)) === 'object') {
          wait = shouldDebounce.wait || defaultWait;
          options = _extends({}, defaultThrottleOption, shouldDebounce);
        }

        debounced[action.type] = (0, _lodash2.default)(next, wait, options);

        return debounced[action.type](action);
      };
    };
  };
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_MODAL = exports.SHOW_MODAL = 'modal/SHOW';
var showModal = exports.showModal = function showModal(type, props, meta) {
  return {
    type: SHOW_MODAL,
    payload: { type: type, props: props },
    meta: meta
  };
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatedCounters = exports.decrement = exports.increment = exports.getFollowingCount = exports.getFollowersCount = exports.getPostsCount = exports.getCounter = undefined;

var _lodash = __webpack_require__(2);

var _applications = __webpack_require__(25);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getCounter = exports.getCounter = function getCounter(user, appDefinitionId, counter) {
  return (0, _lodash.get)(user, 'counters[' + appDefinitionId + '][' + counter + ']', 0);
};

var getPostsCount = exports.getPostsCount = function getPostsCount(user) {
  return getCounter(user, _applications.FORUM_APP_ID, 'postsCount');
};
var getFollowersCount = exports.getFollowersCount = function getFollowersCount(user) {
  return getCounter(user, _applications.MEMBERS_APP_ID, 'followerCount');
};
var getFollowingCount = exports.getFollowingCount = function getFollowingCount(user) {
  return getCounter(user, _applications.MEMBERS_APP_ID, 'followingCount');
};

var increment = exports.increment = function increment(count) {
  return count + 1;
};
var decrement = exports.decrement = function decrement(count) {
  return count - 1;
};

var updatedCounters = exports.updatedCounters = function updatedCounters(user, field, updateFn) {
  return {
    counters: _defineProperty({}, _applications.MEMBERS_APP_ID, _defineProperty({}, field, updateFn((0, _lodash.get)(user.counters, [_applications.MEMBERS_APP_ID, field], 0))))
  };
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_PRIVACY_STATUS_PRIVATE = exports.USER_PRIVACY_STATUS_PRIVATE = 'PRIVATE';
var USER_PRIVACY_STATUS_PUBLIC = exports.USER_PRIVACY_STATUS_PUBLIC = 'PUBLIC';

/***/ }),
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextEditorMobileToolbar = exports.TextEditorMediaButtons = exports.DraftRenderer = exports.TextEditor = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _mapProps = __webpack_require__(518);

var _mapProps2 = _interopRequireDefault(_mapProps);

var _textEditor = __webpack_require__(647);

var _textEditor2 = _interopRequireDefault(_textEditor);

var _experiments = __webpack_require__(32);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _getTheme = __webpack_require__(817);

var _getTheme2 = _interopRequireDefault(_getTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var config = {
  mediaBlock: {
    minContentImageWidth: 740
  }
};

var withTheme = function withTheme(WrappedComponent, path, props) {
  return (0, _lodash.flowRight)(_withCardBackgroundColor2.default, _withFontClassName2.default, (0, _mapProps2.default)(function (_ref) {
    var cardBackgroundColor = _ref.cardBackgroundColor,
        titleFontClassName = _ref.titleFontClassName,
        contentFontClassName = _ref.contentFontClassName,
        rest = _objectWithoutProperties(_ref, ['cardBackgroundColor', 'titleFontClassName', 'contentFontClassName']);

    var themeConfig = { cardBackgroundColor: cardBackgroundColor, titleFontClassName: titleFontClassName, contentFontClassName: contentFontClassName };
    return _extends({}, rest, props, {
      theme: path ? (0, _lodash.get)((0, _getTheme2.default)(themeConfig), path) : (0, _getTheme2.default)(themeConfig)
    });
  }))(WrappedComponent);
};

var withHashtag = (0, _withExperiment2.default)({
  enableHashtags: _experiments.EXPERIMENT_HASHTAGS
});

var TextEditor = exports.TextEditor = withTheme(withHashtag(_textEditor2.default), undefined, { config: config });
var DraftRenderer = exports.DraftRenderer = withTheme(withHashtag(_textEditor.DraftRenderer), undefined, { config: config });
var TextEditorMediaButtons = exports.TextEditorMediaButtons = withTheme(_textEditor.TextEditorMediaButtons, 'button');
var TextEditorMobileToolbar = exports.TextEditorMobileToolbar = withTheme(_textEditor.TextEditorMobileToolbar, 'toolbar');

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(413);
} else {
  module.exports = require('./configureStore.dev');
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(379);


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Reads any potentially deep value from an object using dot and array syntax
 */
var read = function read(path, object) {
  if (!path || !object) {
    return object;
  }
  var dotIndex = path.indexOf('.');
  if (dotIndex === 0) {
    return read(path.substring(1), object);
  }
  var openIndex = path.indexOf('[');
  var closeIndex = path.indexOf(']');
  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
    // iterate down object tree
    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
  }
  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    if (closeIndex < 0) {
      throw new Error('found [ but no ]');
    }
    var key = path.substring(0, openIndex);
    var index = path.substring(openIndex + 1, closeIndex);
    if (!index.length) {
      return object[key];
    }
    if (openIndex === 0) {
      return read(path.substring(closeIndex + 1), object[index]);
    }
    if (!object[key]) {
      return undefined;
    }
    return read(path.substring(closeIndex + 1), object[key][index]);
  }
  return object[path];
};

exports.default = read;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Writes any potentially deep value from an object using dot and array syntax,
 * and returns a new copy of the object.
 */
var write = function write(path, value, object) {
  var _extends7;

  var dotIndex = path.indexOf('.');
  if (dotIndex === 0) {
    return write(path.substring(1), value, object);
  }
  var openIndex = path.indexOf('[');
  var closeIndex = path.indexOf(']');
  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
    var _extends2;

    // is dot notation
    var key = path.substring(0, dotIndex);
    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
  }
  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    var _extends6;

    // is array notation
    if (closeIndex < 0) {
      throw new Error('found [ but no ]');
    }
    var _key = path.substring(0, openIndex);
    var index = path.substring(openIndex + 1, closeIndex);
    var array = object[_key] || [];
    var rest = path.substring(closeIndex + 1);
    if (index) {
      var _extends4;

      // indexed array
      if (rest.length) {
        var _extends3;

        // need to keep recursing
        var dest = array[index] || {};
        var arrayCopy = [].concat(array);
        arrayCopy[index] = write(rest, value, dest);
        return _extends({}, object || {}, (_extends3 = {}, _extends3[_key] = arrayCopy, _extends3));
      }
      var copy = [].concat(array);
      copy[index] = typeof value === 'function' ? value(copy[index]) : value;
      return _extends({}, object || {}, (_extends4 = {}, _extends4[_key] = copy, _extends4));
    }
    // indexless array
    if (rest.length) {
      var _extends5;

      // need to keep recursing
      if ((!array || !array.length) && typeof value === 'function') {
        return object; // don't even set a value under [key]
      }
      var _arrayCopy = array.map(function (dest) {
        return write(rest, value, dest);
      });
      return _extends({}, object || {}, (_extends5 = {}, _extends5[_key] = _arrayCopy, _extends5));
    }
    var result = void 0;
    if (Array.isArray(value)) {
      result = value;
    } else if (object[_key]) {
      result = array.map(function (dest) {
        return typeof value === 'function' ? value(dest) : value;
      });
    } else if (typeof value === 'function') {
      return object; // don't even set a value under [key]
    } else {
      result = value;
    }
    return _extends({}, object || {}, (_extends6 = {}, _extends6[_key] = result, _extends6));
  }
  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
};

exports.default = write;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _fieldValue = __webpack_require__(62);

/**
 * A different version of getValues() that does not need the fields array
 */
var getValuesFromState = function getValuesFromState(state) {
  if (!state) {
    return state;
  }
  var keys = Object.keys(state);
  if (!keys.length) {
    return undefined;
  }
  return keys.reduce(function (accumulator, key) {
    var field = state[key];
    if (field) {
      if ((0, _fieldValue.isFieldValue)(field)) {
        if (field.value !== undefined) {
          accumulator[key] = field.value;
        }
      } else if (Array.isArray(field)) {
        accumulator[key] = field.map(function (arrayField) {
          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
        });
      } else if (typeof field === 'object') {
        var result = getValuesFromState(field);

        if (result && Object.keys(result).length > 0) {
          accumulator[key] = result;
        }
      }
    }
    return accumulator;
  }, {});
};

exports.default = getValuesFromState;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fieldValue = __webpack_require__(62);

var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
  if (value === undefined && previousValue === undefined) return (0, _fieldValue.makeFieldValue)({});
  return (0, _fieldValue.makeFieldValue)({
    initial: value,
    value: overwriteValues ? value : previousValue
  });
};

/**
 * Sets the initial values into the state and returns a new copy of the state
 */
var initializeState = function initializeState(values, fields) {
  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!fields) {
    throw new Error('fields must be passed when initializing state');
  }
  if (!values || !fields.length) {
    return state;
  }
  var initializeField = function initializeField(path, src, dest) {
    var dotIndex = path.indexOf('.');
    if (dotIndex === 0) {
      return initializeField(path.substring(1), src, dest);
    }
    var openIndex = path.indexOf('[');
    var closeIndex = path.indexOf(']');
    var result = _extends({}, dest) || {};
    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
      // is dot notation
      var key = path.substring(0, dotIndex);
      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
      // is array notation
      if (closeIndex < 0) {
        throw new Error('found \'[\' but no \']\': \'' + path + '\'');
      }
      var _key = path.substring(0, openIndex);
      var srcArray = src[_key];
      var destArray = result[_key];
      var rest = path.substring(closeIndex + 1);
      if (Array.isArray(srcArray)) {
        if (rest.length) {
          // need to keep recursing
          result[_key] = srcArray.map(function (srcValue, srcIndex) {
            return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
          });
        } else {
          result[_key] = srcArray.map(function (srcValue, srcIndex) {
            return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
          });
        }
      } else {
        result[_key] = [];
      }
    } else {
      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
    }
    return result;
  };
  return fields.reduce(function (accumulator, field) {
    return initializeField(field, values, accumulator);
  }, _extends({}, state));
};

exports.default = initializeState;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reducer = __webpack_require__(190);

var _initializeState = __webpack_require__(302);

var _initializeState2 = _interopRequireDefault(_initializeState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createInitialState = function createInitialState(data, fields, state) {
  var _extends2;

  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var markInitialized = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
    _asyncValidating: false,
    _active: undefined
  }, _extends2[_reducer.globalErrorKey] = undefined, _extends2._initialized = markInitialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
};

exports.default = createInitialState;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getDisplayName;
function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;

var _actionTypes = __webpack_require__(191);

var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
};

var autofill = exports.autofill = function autofill(field, value) {
  return { type: _actionTypes.AUTOFILL, field: field, value: value };
};

var blur = exports.blur = function blur(field, value) {
  return { type: _actionTypes.BLUR, field: field, value: value };
};

var change = exports.change = function change(field, value) {
  return { type: _actionTypes.CHANGE, field: field, value: value };
};

var destroy = exports.destroy = function destroy() {
  return { type: _actionTypes.DESTROY };
};

var focus = exports.focus = function focus(field) {
  return { type: _actionTypes.FOCUS, field: field };
};

var initialize = exports.initialize = function initialize(data, fields) {
  var overwriteValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!Array.isArray(fields)) {
    throw new Error('must provide fields array to initialize() action creator');
  }
  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
};

var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, index) {
  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index };
};

var reset = exports.reset = function reset() {
  return { type: _actionTypes.RESET };
};

var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
};

var startSubmit = exports.startSubmit = function startSubmit() {
  return { type: _actionTypes.START_SUBMIT };
};

var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
};

var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
};

var submitFailed = exports.submitFailed = function submitFailed() {
  return { type: _actionTypes.SUBMIT_FAILED };
};

var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
};

var touch = exports.touch = function touch() {
  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
    fields[_key] = arguments[_key];
  }

  return { type: _actionTypes.TOUCH, fields: fields };
};

var untouch = exports.untouch = function untouch() {
  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fields[_key2] = arguments[_key2];
  }

  return { type: _actionTypes.UNTOUCH, fields: fields };
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = bindActionData;

var _mapValues = __webpack_require__(192);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Adds additional properties to the results of the function or map of functions passed
 */
function bindActionData(action, data) {
  if (typeof action === 'function') {
    return function () {
      return _extends({}, action.apply(undefined, arguments), data);
    };
  }
  if (typeof action === 'object') {
    return (0, _mapValues2.default)(action, function (value) {
      return bindActionData(value, data);
    });
  }
  return action;
}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Given a state[field], get the value.
 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
 *  See {@link https://github.com/erikras/redux-form/issues/621}.
 */
var itemToValue = function itemToValue(_ref) {
  var value = _ref.value,
      initialValue = _ref.initialValue;
  return typeof value !== 'undefined' ? value : initialValue;
};

var getValue = function getValue(field, state, dest) {
  var dotIndex = field.indexOf('.');
  var openIndex = field.indexOf('[');
  var closeIndex = field.indexOf(']');
  if (openIndex > 0 && closeIndex !== openIndex + 1) {
    throw new Error('found [ not followed by ]');
  }
  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    // array field
    var key = field.substring(0, openIndex);
    var rest = field.substring(closeIndex + 1);
    if (rest[0] === '.') {
      rest = rest.substring(1);
    }
    var array = state && state[key] || [];
    if (rest) {
      if (!dest[key]) {
        dest[key] = [];
      }
      array.forEach(function (item, index) {
        if (!dest[key][index]) {
          dest[key][index] = {};
        }
        getValue(rest, item, dest[key][index]);
      });
    } else {
      dest[key] = array.map(itemToValue);
    }
  } else if (dotIndex > 0) {
    // subobject field
    var _key = field.substring(0, dotIndex);
    var _rest = field.substring(dotIndex + 1);
    if (!dest[_key]) {
      dest[_key] = {};
    }
    getValue(_rest, state && state[_key] || {}, dest[_key]);
  } else {
    dest[field] = state[field] && itemToValue(state[field]);
  }
};

var getValues = function getValues(fields, state) {
  return fields.reduce(function (accumulator, field) {
    getValue(field, state, accumulator);
    return accumulator;
  }, {});
};

exports.default = getValues;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isEvent = __webpack_require__(309);

var _isEvent2 = _interopRequireDefault(_isEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if ((0, _isEvent2.default)(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var _event$target = event.target,
        type = _event$target.type,
        value = _event$target.value,
        checked = _event$target.checked,
        files = _event$target.files,
        dataTransfer = event.dataTransfer;

    if (type === 'checkbox') {
      return checked;
    }
    if (type === 'radio') {
      return checked ? value : '';
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    if (value !== '' && (type === 'number' || type === 'range')) {
      return parseFloat(value);
    }
    return value;
  }
  // not an event, so must be either our value or an object containing our value in the 'value' key
  return event && typeof event === 'object' && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
  event;
};

exports.default = getValue;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

exports.default = isEvent;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var dataKey = exports.dataKey = 'value';
var createOnDragStart = function createOnDragStart(name, getValue) {
  return function (event) {
    event.dataTransfer.setData(dataKey, getValue());
  };
};

exports.default = createOnDragStart;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isChecked = function isChecked(value) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    var lower = value.toLowerCase();
    if (lower === 'true') {
      return true;
    }
    if (lower === 'false') {
      return false;
    }
  }
  return undefined;
};

exports.default = isChecked;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isEvent = __webpack_require__(309);

var _isEvent2 = _interopRequireDefault(_isEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var silenceEvent = function silenceEvent(event) {
  var is = (0, _isEvent2.default)(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

exports.default = silenceEvent;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchComment = exports.fetchCommentFailure = exports.fetchCommentSuccess = exports.fetchCommentRequest = exports.FETCH_COMMENT_FAILURE = exports.FETCH_COMMENT_SUCCESS = exports.FETCH_COMMENT_REQUEST = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_COMMENT_REQUEST = exports.FETCH_COMMENT_REQUEST = 'comment/FETCH_REQUEST';
var FETCH_COMMENT_SUCCESS = exports.FETCH_COMMENT_SUCCESS = 'comment/FETCH_SUCCESS';
var FETCH_COMMENT_FAILURE = exports.FETCH_COMMENT_FAILURE = 'comment/FETCH_FAILURE';

var fetchCommentRequest = exports.fetchCommentRequest = (0, _createAction2.default)(FETCH_COMMENT_REQUEST);
var fetchCommentSuccess = exports.fetchCommentSuccess = (0, _createAction2.default)(FETCH_COMMENT_SUCCESS);
var fetchCommentFailure = exports.fetchCommentFailure = (0, _createAction2.default)(FETCH_COMMENT_FAILURE);

var fetchComment = exports.fetchComment = function fetchComment(_ref) {
  var postId = _ref.postId,
      commentId = _ref.commentId;

  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;

    dispatch(fetchCommentRequest({ postId: postId }));

    var promise = request((0, _urijs2.default)('/_api/posts/' + postId + '/comments/' + commentId));
    return promise.then(function (comment) {
      return dispatch(fetchCommentSuccess({ comment: comment, postId: postId }));
    }).catch(function () {
      return dispatch(fetchCommentFailure({ postId: postId }));
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newComment = exports.SOCKET_NEW_COMMENT = exports.NEW_COMMENT = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEW_COMMENT = exports.NEW_COMMENT = 'comment/NEW';
var SOCKET_NEW_COMMENT = exports.SOCKET_NEW_COMMENT = 'new comment';

var newComment = exports.newComment = (0, _createAction2.default)(NEW_COMMENT);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = experiments;

var _setExperiments = __webpack_require__(157);

function experiments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _setExperiments.SET_EXPERIMENTS:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateForumDataFailure = exports.updateForumDataSuccess = exports.updateForumDataRequest = exports.UPDATE_FORUM_DATA_FAILURE = exports.UPDATE_FORUM_DATA_SUCCESS = exports.UPDATE_FORUM_DATA_REQUEST = undefined;
exports.updateForumData = updateForumData;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_FORUM_DATA_REQUEST = exports.UPDATE_FORUM_DATA_REQUEST = 'forumData/UPDATE_REQUEST';
var UPDATE_FORUM_DATA_SUCCESS = exports.UPDATE_FORUM_DATA_SUCCESS = 'forumData/UPDATE_SUCCESS';
var UPDATE_FORUM_DATA_FAILURE = exports.UPDATE_FORUM_DATA_FAILURE = 'forumData/UPDATE_FAILURE';

var updateForumDataRequest = exports.updateForumDataRequest = function updateForumDataRequest() {
  return { type: UPDATE_FORUM_DATA_REQUEST };
};
var updateForumDataSuccess = exports.updateForumDataSuccess = function updateForumDataSuccess(payload) {
  return { type: UPDATE_FORUM_DATA_SUCCESS, payload: payload };
};
var updateForumDataFailure = exports.updateForumDataFailure = function updateForumDataFailure() {
  return { type: UPDATE_FORUM_DATA_FAILURE };
};

function updateForumData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(updateForumDataRequest());
    var promise = request.patch('/_api/forums/this', _lodash2.default.omit(data, ['_id', 'communityId']));

    return promise.then(function (post) {
      return dispatch(updateForumDataSuccess(post));
    }).catch(function () {
      return dispatch(updateForumDataFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_DEMO_MODE = exports.SET_DEMO_MODE = 'demo-mode/SET';

var setDemoMode = exports.setDemoMode = function setDemoMode(payload) {
  return function (dispatch) {
    dispatch({ type: SET_DEMO_MODE, payload: payload });
    return Promise.resolve();
  };
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(613);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(614);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(615);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(320);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 323 */,
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _accessibilityListener = __webpack_require__(625);

var _accessibilityListener2 = _interopRequireDefault(_accessibilityListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _accessibilityListener2.default;

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_2ftM2","secondary":"_3Hath","isMuted":"KjQok","wrapper":"_2G3w-"};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestCredentials;
var TYPE_IMAGE = exports.TYPE_IMAGE = 'picture';
var TYPE_VIDEO = exports.TYPE_VIDEO = 'video';

function requestCredentials(request, type) {
  return request('/_api/media/credentials/' + type);
}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleBlockTypeAndEnsureSpaces = exports.toggleBlockType = exports.hasBlockType = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _draftJs = __webpack_require__(10);

var _immutable = __webpack_require__(31);

var hasBlockType = exports.hasBlockType = function hasBlockType(blockType, editorState) {
  var currentBlockType = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getType();

  return blockType === currentBlockType;
};

var toggleBlockType = exports.toggleBlockType = function toggleBlockType(blockType, editorState) {
  return _draftJs.RichUtils.toggleBlockType(editorState, blockType);
};

var toggleBlockTypeAndEnsureSpaces = exports.toggleBlockTypeAndEnsureSpaces = function toggleBlockTypeAndEnsureSpaces(blockType, editorState) {
  if (hasBlockType(blockType, editorState)) {
    return toggleBlockType(blockType, editorState);
  }

  var initialSelection = editorState.getSelection();
  var initialContentState = editorState.getCurrentContent();

  var allBlocks = initialContentState.getBlockMap();

  var _initialSelection$toJ = initialSelection.toJSON(),
      anchorKey = _initialSelection$toJ.anchorKey,
      focusKey = _initialSelection$toJ.focusKey,
      isBackward = _initialSelection$toJ.isBackward;

  var _ref = isBackward ? [focusKey, anchorKey] : [anchorKey, focusKey],
      _ref2 = _slicedToArray(_ref, 2),
      firstKey = _ref2[0],
      lastKey = _ref2[1];

  var selectedBlocks = getBlockRange(firstKey, lastKey, allBlocks);
  var newContentState = setBlockTypeAndMerge(blockType, selectedBlocks, initialContentState);

  return _draftJs.EditorState.push(editorState, newContentState, 'insert-fragment');
};

function getBlockRange(firstKey, lastKey, blocks) {
  return blocks.skipUntil(function (block) {
    return firstKey === block.getKey();
  }).reverse().skipUntil(function (block) {
    return lastKey === block.getKey();
  }).reverse();
}

function setBlockTypeAndMerge(blockType, blocks, contentState) {
  if (!blocks.count()) {
    return contentState;
  }

  var blockGroup = blocks.skipWhile(isAtomic).takeWhile(isNotAtomic);

  if (blockGroup.count()) {
    var firstKey = blockGroup.first().getKey();
    var lastKey = blockGroup.last().getKey();
    var afterMove = moveTextToFirstBlock(blockGroup, contentState);
    var afterTypeChange = setBlockType(firstKey, blockType, afterMove);
    contentState = replaceSelectedBlocksWithCodeBlock(firstKey, lastKey, afterTypeChange);
  }

  blocks = blocks.skipWhile(isAtomic).skipWhile(isNotAtomic);

  return setBlockTypeAndMerge(blockType, blocks, contentState);
}

function moveTextToFirstBlock(blocks, contentState) {
  var firstKey = blocks.first().getKey();
  return blocks.rest().reduce(function (contentState, block, key) {
    var targetLength = contentState.getBlockForKey(firstKey).getLength();
    var newLineTarget = _draftJs.SelectionState.createEmpty(firstKey).set('anchorOffset', targetLength).set('focusOffset', targetLength);

    var withNewLine = _draftJs.Modifier.insertText(contentState, newLineTarget, '\n');

    var sourceRange = _draftJs.SelectionState.createEmpty(key).set('anchorOffset', 0).set('focusOffset', block.getLength());
    var textTarget = newLineTarget.set('anchorOffset', targetLength + 1).set('focusOffset', targetLength + 1);

    return _draftJs.Modifier.moveText(withNewLine, sourceRange, textTarget);
  }, contentState);
}

function isAtomic(block) {
  return block.getType() === 'atomic';
}

function isNotAtomic(block) {
  return !isAtomic(block);
}

function setBlockType(key, blockType, contentState) {
  var targetRange = _draftJs.SelectionState.createEmpty(key);
  return _draftJs.Modifier.setBlockType(contentState, targetRange, blockType);
}

function replaceSelectedBlocksWithCodeBlock(firstKey, lastKey, contentState) {
  var fragment = _draftJs.BlockMapBuilder.createFromArray([createEmptyBlock(), contentState.getBlockForKey(firstKey), createEmptyBlock()]);

  var target = new _draftJs.SelectionState({
    anchorKey: firstKey,
    anchorOffset: 0,
    focusKey: lastKey,
    focusOffset: contentState.getBlockForKey(lastKey).getLength()
  });

  return _draftJs.Modifier.replaceWithFragment(contentState, target, fragment);
}

function createEmptyBlock() {
  return new _draftJs.ContentBlock({
    key: (0, _draftJs.genKey)(),
    type: 'unstyled',
    text: '',
    characterList: (0, _immutable.List)() // eslint-disable-line new-cap
  });
}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleLink = undefined;

var _draftJs = __webpack_require__(10);

var _modalTypes = __webpack_require__(26);

var _textEditorUtils = __webpack_require__(66);

var removeLinks = function removeLinks(editorState) {
  var selection = editorState.getSelection();
  var newEditorState = (0, _textEditorUtils.removeLinksInSelection)(editorState);

  return _draftJs.EditorState.acceptSelection(newEditorState, selection);
};

var toggleLink = exports.toggleLink = function toggleLink(_ref) {
  var editorState = _ref.editorState,
      identifier = _ref.identifier,
      openModal = _ref.openModal;

  if ((0, _textEditorUtils.hasLinksInSelection)(editorState)) {
    return removeLinks(editorState);
  } else {
    openModal(_modalTypes.MODAL_TYPE_TEXT_EDITOR_LINK, { identifier: identifier }, (0, _textEditorUtils.getFocusableContainerId)(identifier));
    return null;
  }
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTextAlignment = undefined;

var _draftJs = __webpack_require__(10);

var setTextAlignment = exports.setTextAlignment = function setTextAlignment(textAlignment, editorState) {
  var contentState = _draftJs.Modifier.mergeBlockData(editorState.getCurrentContent(), editorState.getSelection(), {
    textAlignment: textAlignment
  });

  return _draftJs.EditorState.push(editorState, contentState, 'change-block-data');
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteButton = exports.LinkButton = exports.ChangeButton = exports.ReuploadMediaDialogButton = exports.ReuploadButton = exports.SizeOriginalButton = exports.SizeFullWidthButton = exports.SizeContentButton = exports.SizeTextButton = exports.AlignRightButton = exports.AlignLeftButton = exports.AlignTextDropdownButton = exports.VideoButton = exports.ImageMediaDialogButton = exports.ImageButton = exports.CodeBlockButton = exports.QuoteButton = exports.UnorderedListButton = exports.OrderedListButton = exports.ListDropdownButton = exports.HeaderTwoButton = exports.HeaderOneButton = exports.HeaderDropdownButton = exports.ItalicButton = exports.BoldButton = undefined;

var _BUTTON_BOLD$BUTTON_I;

var _decorateComponentWithProps = __webpack_require__(51);

var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);

var _buttons = __webpack_require__(53);

var _alignLeftIcon = __webpack_require__(652);

var _alignLeftIcon2 = _interopRequireDefault(_alignLeftIcon);

var _alignRightIcon = __webpack_require__(653);

var _alignRightIcon2 = _interopRequireDefault(_alignRightIcon);

var _alignTextCenterIcon = __webpack_require__(654);

var _alignTextCenterIcon2 = _interopRequireDefault(_alignTextCenterIcon);

var _alignTextJustifyIcon = __webpack_require__(655);

var _alignTextJustifyIcon2 = _interopRequireDefault(_alignTextJustifyIcon);

var _alignTextLeftIcon = __webpack_require__(656);

var _alignTextLeftIcon2 = _interopRequireDefault(_alignTextLeftIcon);

var _alignTextRightIcon = __webpack_require__(657);

var _alignTextRightIcon2 = _interopRequireDefault(_alignTextRightIcon);

var _boldIcon = __webpack_require__(658);

var _boldIcon2 = _interopRequireDefault(_boldIcon);

var _cameraIcon = __webpack_require__(659);

var _cameraIcon2 = _interopRequireDefault(_cameraIcon);

var _deleteIcon = __webpack_require__(660);

var _deleteIcon2 = _interopRequireDefault(_deleteIcon);

var _fitToPageIcon = __webpack_require__(661);

var _fitToPageIcon2 = _interopRequireDefault(_fitToPageIcon);

var _fullWidthIcon = __webpack_require__(662);

var _fullWidthIcon2 = _interopRequireDefault(_fullWidthIcon);

var _headerIcon = __webpack_require__(663);

var _headerIcon2 = _interopRequireDefault(_headerIcon);

var _headerSmallIcon = __webpack_require__(664);

var _headerSmallIcon2 = _interopRequireDefault(_headerSmallIcon);

var _italicIcon = __webpack_require__(665);

var _italicIcon2 = _interopRequireDefault(_italicIcon);

var _linkIcon = __webpack_require__(666);

var _linkIcon2 = _interopRequireDefault(_linkIcon);

var _orderedListIcon = __webpack_require__(667);

var _orderedListIcon2 = _interopRequireDefault(_orderedListIcon);

var _originalSizeIcon = __webpack_require__(668);

var _originalSizeIcon2 = _interopRequireDefault(_originalSizeIcon);

var _quoteIcon = __webpack_require__(669);

var _quoteIcon2 = _interopRequireDefault(_quoteIcon);

var _codeIcon = __webpack_require__(670);

var _codeIcon2 = _interopRequireDefault(_codeIcon);

var _replaceIcon = __webpack_require__(671);

var _replaceIcon2 = _interopRequireDefault(_replaceIcon);

var _smallCenterIcon = __webpack_require__(672);

var _smallCenterIcon2 = _interopRequireDefault(_smallCenterIcon);

var _unorderedListIcon = __webpack_require__(673);

var _unorderedListIcon2 = _interopRequireDefault(_unorderedListIcon);

var _videoIcon = __webpack_require__(674);

var _videoIcon2 = _interopRequireDefault(_videoIcon);

var _createAlignmentButton = __webpack_require__(675);

var _createAlignmentButton2 = _interopRequireDefault(_createAlignmentButton);

var _createBlockTypeButton = __webpack_require__(702);

var _createBlockTypeButton2 = _interopRequireDefault(_createBlockTypeButton);

var _createButton = __webpack_require__(703);

var _createButton2 = _interopRequireDefault(_createButton);

var _createDropdownButton = __webpack_require__(704);

var _createDropdownButton2 = _interopRequireDefault(_createDropdownButton);

var _createInlineStyleButton = __webpack_require__(709);

var _createInlineStyleButton2 = _interopRequireDefault(_createInlineStyleButton);

var _createSizeButton = __webpack_require__(710);

var _createSizeButton2 = _interopRequireDefault(_createSizeButton);

var _createUploadButton = __webpack_require__(711);

var _createUploadButton2 = _interopRequireDefault(_createUploadButton);

var _createMediaDialogButton = __webpack_require__(714);

var _createMediaDialogButton2 = _interopRequireDefault(_createMediaDialogButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BoldButton = exports.BoldButton = (0, _createInlineStyleButton2.default)({
  inlineStyle: 'BOLD',
  content: (0, _decorateComponentWithProps2.default)(_boldIcon2.default, {
    width: 12
  }),
  tooltipText: 'text-editor.tooltip-bold'
});

var ItalicButton = exports.ItalicButton = (0, _createInlineStyleButton2.default)({
  inlineStyle: 'ITALIC',
  content: (0, _decorateComponentWithProps2.default)(_italicIcon2.default, {
    width: 10
  }),
  tooltipText: 'text-editor.tooltip-italic'
});

var HeaderDropdownButton = exports.HeaderDropdownButton = (0, _createDropdownButton2.default)({
  className: 'text-editor__header-dropdown-button',
  buttons: [{
    value: _buttons.BUTTON_TITLE,
    icon: (0, _decorateComponentWithProps2.default)(_headerIcon2.default, {
      width: 11
    }),
    tooltipText: 'text-editor.tooltip-header-one',
    className: 'text-editor__header-one-button'
  }, {
    value: _buttons.BUTTON_SUBTITLE,
    icon: (0, _decorateComponentWithProps2.default)(_headerSmallIcon2.default, {
      width: 10,
      style: {
        paddingTop: 2
      }
    }),
    tooltipText: 'text-editor.tooltip-header-two',
    className: 'text-editor__header-two-button'
  }]
});

var HeaderOneButton = exports.HeaderOneButton = (0, _createBlockTypeButton2.default)({
  blockType: 'header-one',
  content: (0, _decorateComponentWithProps2.default)(_headerIcon2.default, {
    width: 11
  }),
  tooltipText: 'text-editor.tooltip-header-one'
});

var HeaderTwoButton = exports.HeaderTwoButton = (0, _createBlockTypeButton2.default)({
  blockType: 'header-two',
  content: (0, _decorateComponentWithProps2.default)(_headerSmallIcon2.default, {
    width: 10,
    style: {
      paddingTop: 2
    }
  }),
  tooltipText: 'text-editor.tooltip-header-two'
});

var ListDropdownButton = exports.ListDropdownButton = (0, _createDropdownButton2.default)({
  className: 'text-editor__list-dropdown-button',
  buttons: [{
    value: _buttons.BUTTON_NUMBERING,
    icon: (0, _decorateComponentWithProps2.default)(_orderedListIcon2.default, {
      width: 16
    }),
    className: 'text-editor__ordered-list-item-button'
  }, {
    value: _buttons.BUTTON_BULLETS,
    icon: (0, _decorateComponentWithProps2.default)(_unorderedListIcon2.default, {
      width: 16
    }),
    className: 'text-editor__unordered-list-item-button'
  }]
});

var OrderedListButton = exports.OrderedListButton = (0, _createBlockTypeButton2.default)({
  blockType: 'ordered-list-item',
  content: (0, _decorateComponentWithProps2.default)(_orderedListIcon2.default, {
    width: 16
  }),
  tooltipText: 'text-editor.tooltip-ordered-list-item'
});

var UnorderedListButton = exports.UnorderedListButton = (0, _createBlockTypeButton2.default)({
  blockType: 'unordered-list-item',
  content: (0, _decorateComponentWithProps2.default)(_unorderedListIcon2.default, {
    width: 16
  }),
  tooltipText: 'text-editor.tooltip-unordered-list-item'
});

var QuoteButton = exports.QuoteButton = (0, _createBlockTypeButton2.default)({
  blockType: 'blockquote',
  content: (0, _decorateComponentWithProps2.default)(_quoteIcon2.default, {
    width: 15
  }),
  tooltipText: 'text-editor.tooltip-blockquote'
});

var CodeBlockButton = exports.CodeBlockButton = (0, _createBlockTypeButton2.default)({
  blockType: 'code-block',
  content: (0, _decorateComponentWithProps2.default)(_codeIcon2.default, {
    width: 17
  }),
  tooltipText: 'text-editor.tooltip-code-block'
});

var ImageButton = exports.ImageButton = (0, _createUploadButton2.default)({
  className: 'text-editor__upload-image-button',
  content: (0, _decorateComponentWithProps2.default)(_cameraIcon2.default, {
    width: 20
  }),
  tooltipText: 'text-editor.tooltip-image-upload'
});

var ImageMediaDialogButton = exports.ImageMediaDialogButton = (0, _createMediaDialogButton2.default)({
  className: 'text-editor__upload-image-button',
  content: (0, _decorateComponentWithProps2.default)(_cameraIcon2.default, {
    width: 20
  }),
  tooltipText: 'text-editor.tooltip-image-upload'
});

var VideoButton = exports.VideoButton = (0, _createButton2.default)({
  className: 'text-editor__add-video-button',
  content: (0, _decorateComponentWithProps2.default)(_videoIcon2.default, {
    width: 20
  }),
  tooltipText: 'text-editor.tooltip-video'
});

var AlignTextDropdownButton = exports.AlignTextDropdownButton = (0, _createDropdownButton2.default)({
  className: 'text-editor__text-alignment-dropdown-button',
  buttons: [{
    value: _buttons.BUTTON_ALIGN_LEFT,
    icon: (0, _decorateComponentWithProps2.default)(_alignTextLeftIcon2.default, {
      width: 16
    }),
    tooltipText: 'text-editor.tooltip-align-text-left',
    className: 'text-editor__text-alignment-left-button'
  }, {
    value: _buttons.BUTTON_ALIGN_RIGHT,
    icon: (0, _decorateComponentWithProps2.default)(_alignTextRightIcon2.default, {
      width: 16
    }),
    tooltipText: 'text-editor.tooltip-align-text-right',
    className: 'text-editor__text-alignment-right-button'
  }, {
    value: _buttons.BUTTON_ALIGN_CENTER,
    icon: (0, _decorateComponentWithProps2.default)(_alignTextCenterIcon2.default, {
      width: 16
    }),
    tooltipText: 'text-editor.tooltip-align-text-center',
    className: 'text-editor__text-alignment-center-button'
  }, {
    value: _buttons.BUTTON_ALIGN_JUSTIFY,
    icon: (0, _decorateComponentWithProps2.default)(_alignTextJustifyIcon2.default, {
      width: 16
    }),
    tooltipText: 'text-editor.tooltip-align-text-justify',
    className: 'text-editor__text-alignment-justify-button'
  }]
});

var AlignLeftButton = exports.AlignLeftButton = (0, _createAlignmentButton2.default)({
  alignment: 'left',
  content: (0, _decorateComponentWithProps2.default)(_alignLeftIcon2.default, {
    width: 20
  }),
  tooltipText: 'text-editor.tooltip-align-left'
});

var AlignRightButton = exports.AlignRightButton = (0, _createAlignmentButton2.default)({
  alignment: 'right',
  content: (0, _decorateComponentWithProps2.default)(_alignRightIcon2.default, {
    width: 20
  }),
  tooltipText: 'text-editor.tooltip-align-right'
});

var SizeTextButton = exports.SizeTextButton = (0, _createSizeButton2.default)({
  size: 'smallCenter',
  content: (0, _decorateComponentWithProps2.default)(_smallCenterIcon2.default, {
    width: 14
  }),
  tooltipText: 'text-editor.tooltip-small-center'
});

var SizeContentButton = exports.SizeContentButton = (0, _createSizeButton2.default)({
  size: 'content',
  content: (0, _decorateComponentWithProps2.default)(_fitToPageIcon2.default, {
    width: 14
  }),
  tooltipText: 'text-editor.tooltip-fit-to-page'
});

var SizeFullWidthButton = exports.SizeFullWidthButton = (0, _createSizeButton2.default)({
  size: 'fullWidth',
  content: (0, _decorateComponentWithProps2.default)(_fullWidthIcon2.default, {
    width: 20
  }),
  tooltipText: 'text-editor.tooltip-full-width'
});

var SizeOriginalButton = exports.SizeOriginalButton = (0, _createSizeButton2.default)({
  size: 'original',
  content: (0, _decorateComponentWithProps2.default)(_originalSizeIcon2.default, {
    width: 20,
    style: {
      stroke: 'none'
    }
  }),
  tooltipText: 'text-editor.tooltip-original-size'
});

var ReuploadButton = exports.ReuploadButton = (0, _createUploadButton2.default)({
  className: 'text-editor__reupload-image-button',
  content: (0, _decorateComponentWithProps2.default)(_replaceIcon2.default, {
    width: 16
  }),
  tooltipText: 'text-editor.tooltip-change'
});

var ReuploadMediaDialogButton = exports.ReuploadMediaDialogButton = (0, _createMediaDialogButton2.default)({
  className: 'text-editor__reupload-image-button',
  content: (0, _decorateComponentWithProps2.default)(_replaceIcon2.default, {
    width: 16
  }),
  tooltipText: 'text-editor.tooltip-change'
});

var ChangeButton = exports.ChangeButton = (0, _createButton2.default)({
  displayName: 'ChangeButton',
  className: 'text-editor__change-video',
  content: (0, _decorateComponentWithProps2.default)(_replaceIcon2.default, {
    width: 16
  }),
  tooltipText: 'text-editor.tooltip-change'
});

var LinkButton = exports.LinkButton = (0, _createButton2.default)({
  displayName: 'LinkButton',
  className: 'text-editor__add-link-button',
  content: (0, _decorateComponentWithProps2.default)(_linkIcon2.default, {
    width: 16
  }),
  tooltipText: 'text-editor.tooltip-link'
});

var DeleteButton = exports.DeleteButton = (0, _createButton2.default)({
  displayName: 'DeleteButton',
  className: 'text-editor__delete-button',
  content: (0, _decorateComponentWithProps2.default)(_deleteIcon2.default, {
    width: 13
  }),
  tooltipText: 'text-editor.tooltip-delete'
});

exports.default = (_BUTTON_BOLD$BUTTON_I = {}, _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_BOLD, BoldButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_ITALIC, ItalicButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_TITLE, HeaderOneButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_SUBTITLE, HeaderTwoButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_HEADER_DROPDOWN, HeaderDropdownButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_LIST_DROPDOWN, ListDropdownButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_NUMBERING, OrderedListButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_BULLETS, UnorderedListButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_BLOCKQUOTE, QuoteButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_CODE_BLOCK, CodeBlockButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_ALIGN_TEXT_DROPDOWN, AlignTextDropdownButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_LINK, LinkButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_IMAGE, ImageButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_IMAGE_MEDIA_DIALOG, ImageMediaDialogButton), _defineProperty(_BUTTON_BOLD$BUTTON_I, _buttons.BUTTON_VIDEO, VideoButton), _BUTTON_BOLD$BUTTON_I);

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _height = __webpack_require__(676);

var _height2 = _interopRequireDefault(_height);

var _offset = __webpack_require__(114);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(332);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(234);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _requestAnimationFrame = __webpack_require__(227);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(142);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _getDocumentHeight = __webpack_require__(335);

var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);

var _ownerDocument = __webpack_require__(54);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(336);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Affix/>` component toggles `position: fixed;` on and off, emulating
 * the effect found with `position: sticky;`.
 */
var Affix = function (_React$Component) {
  _inherits(Affix, _React$Component);

  function Affix(props, context) {
    _classCallCheck(this, Affix);

    var _this = _possibleConstructorReturn(this, (Affix.__proto__ || Object.getPrototypeOf(Affix)).call(this, props, context));

    _this.state = {
      affixed: 'top',
      position: null,
      top: null
    };

    _this._needPositionUpdate = false;
    return _this;
  }

  _createClass(Affix, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;

      this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
        return _this2.onWindowScroll();
      });
      this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
        return _this2.onDocumentClick();
      });

      this.onUpdate();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this._needPositionUpdate = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this._needPositionUpdate) {
        this._needPositionUpdate = false;
        this.onUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      if (this._windowScrollListener) {
        this._windowScrollListener.remove();
      }
      if (this._documentClickListener) {
        this._documentClickListener.remove();
      }
    }
  }, {
    key: 'onWindowScroll',
    value: function onWindowScroll() {
      this.onUpdate();
    }
  }, {
    key: 'onDocumentClick',
    value: function onDocumentClick() {
      var _this3 = this;

      (0, _requestAnimationFrame2.default)(function () {
        return _this3.onUpdate();
      });
    }
  }, {
    key: 'onUpdate',
    value: function onUpdate() {
      var _this4 = this;

      if (!this._isMounted) {
        return;
      }

      var _props = this.props,
          offsetTop = _props.offsetTop,
          viewportOffsetTop = _props.viewportOffsetTop;

      var scrollTop = (0, _scrollTop2.default)((0, _ownerWindow2.default)(this));
      var positionTopMin = scrollTop + (viewportOffsetTop || 0);

      if (positionTopMin <= offsetTop) {
        this.updateState('top', null, null);
        return;
      }

      if (positionTopMin > this.getPositionTopMax()) {
        if (this.state.affixed === 'bottom') {
          this.updateStateAtBottom();
        } else {
          // Setting position away from `fixed` can change the offset parent of
          // the affix, so we can't calculate the correct position until after
          // we've updated its position.
          this.setState({
            affixed: 'bottom',
            position: 'absolute',
            top: null
          }, function () {
            if (!_this4._isMounted) {
              return;
            }

            _this4.updateStateAtBottom();
          });
        }
        return;
      }

      this.updateState('affix', 'fixed', viewportOffsetTop);
    }
  }, {
    key: 'getPositionTopMax',
    value: function getPositionTopMax() {
      var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(this));
      var height = (0, _height2.default)(_reactDom2.default.findDOMNode(this));

      return documentHeight - height - this.props.offsetBottom;
    }
  }, {
    key: 'updateState',
    value: function updateState(affixed, position, top) {
      var _this5 = this;

      if (affixed === this.state.affixed && position === this.state.position && top === this.state.top) {
        return;
      }

      var upperName = affixed === 'affix' ? '' : affixed.charAt(0).toUpperCase() + affixed.substr(1);

      if (this.props['onAffix' + upperName]) {
        this.props['onAffix' + upperName]();
      }

      this.setState({ affixed: affixed, position: position, top: top }, function () {
        if (_this5.props['onAffixed' + upperName]) {
          _this5.props['onAffixed' + upperName]();
        }
      });
    }
  }, {
    key: 'updateStateAtBottom',
    value: function updateStateAtBottom() {
      var positionTopMax = this.getPositionTopMax();
      var offsetParent = (0, _offsetParent2.default)(_reactDom2.default.findDOMNode(this));
      var parentTop = (0, _offset2.default)(offsetParent).top;

      this.updateState('bottom', 'absolute', positionTopMax - parentTop);
    }
  }, {
    key: 'render',
    value: function render() {
      var child = _react2.default.Children.only(this.props.children);
      var _child$props = child.props,
          className = _child$props.className,
          style = _child$props.style;
      var _state = this.state,
          affixed = _state.affixed,
          position = _state.position,
          top = _state.top;

      var positionStyle = { position: position, top: top };

      var affixClassName = void 0;
      var affixStyle = void 0;
      if (affixed === 'top') {
        affixClassName = this.props.topClassName;
        affixStyle = this.props.topStyle;
      } else if (affixed === 'bottom') {
        affixClassName = this.props.bottomClassName;
        affixStyle = this.props.bottomStyle;
      } else {
        affixClassName = this.props.affixClassName;
        affixStyle = this.props.affixStyle;
      }

      return _react2.default.cloneElement(child, {
        className: (0, _classnames2.default)(affixClassName, className),
        style: _extends({}, positionStyle, affixStyle, style)
      });
    }
  }]);

  return Affix;
}(_react2.default.Component);

Affix.propTypes = {
  /**
   * Pixels to offset from top of screen when calculating position
   */
  offsetTop: _react2.default.PropTypes.number,

  /**
   * When affixed, pixels to offset from top of viewport
   */
  viewportOffsetTop: _react2.default.PropTypes.number,

  /**
   * Pixels to offset from bottom of screen when calculating position
   */
  offsetBottom: _react2.default.PropTypes.number,

  /**
   * CSS class or classes to apply when at top
   */
  topClassName: _react2.default.PropTypes.string,

  /**
   * Style to apply when at top
   */
  topStyle: _react2.default.PropTypes.object,

  /**
   * CSS class or classes to apply when affixed
   */
  affixClassName: _react2.default.PropTypes.string,
  /**
   * Style to apply when affixed
   */
  affixStyle: _react2.default.PropTypes.object,

  /**
   * CSS class or classes to apply when at bottom
   */
  bottomClassName: _react2.default.PropTypes.string,

  /**
   * Style to apply when at bottom
   */
  bottomStyle: _react2.default.PropTypes.object,

  /**
   * Callback fired when the right before the `affixStyle` and `affixStyle` props are rendered
   */
  onAffix: _react2.default.PropTypes.func,
  /**
   * Callback fired after the component `affixStyle` and `affixClassName` props have been rendered.
   */
  onAffixed: _react2.default.PropTypes.func,

  /**
   * Callback fired when the right before the `topStyle` and `topClassName` props are rendered
   */
  onAffixTop: _react2.default.PropTypes.func,

  /**
   * Callback fired after the component `topStyle` and `topClassName` props have been rendered.
   */
  onAffixedTop: _react2.default.PropTypes.func,

  /**
   * Callback fired when the right before the `bottomStyle` and `bottomClassName` props are rendered
   */
  onAffixBottom: _react2.default.PropTypes.func,

  /**
   * Callback fired after the component `bottomStyle` and `bottomClassName` props have been rendered.
   */
  onAffixedBottom: _react2.default.PropTypes.func
};

Affix.defaultProps = {
  offsetTop: 0,
  viewportOffsetTop: null,
  offsetBottom: 0
};

exports.default = Affix;
module.exports = exports['default'];

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(65);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(233);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(677);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(52);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (doc) {
  return Math.max(doc.documentElement.offsetHeight || 0, doc.height || 0, doc.body.scrollHeight || 0, doc.body.offsetHeight || 0);
};

module.exports = exports["default"]; /**
                                      * Get the height of the document
                                      *
                                      * @returns {documentHeight: number}
                                      */

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (componentOrElement) {
  return (0, _ownerWindow2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerWindow = __webpack_require__(684);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _componentOrElement = __webpack_require__(113);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _calculatePosition = __webpack_require__(696);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(143);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(54);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  _createClass(Position, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updatePosition(this.getTarget());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this._needsFlush = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this._needsFlush) {
        this._needsFlush = false;
        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['children', 'className']);

      var _state = this.state,
          positionLeft = _state.positionLeft,
          positionTop = _state.positionTop,
          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

      // These should not be forwarded to the child.


      delete props.target;
      delete props.container;
      delete props.containerPadding;
      delete props.shouldUpdatePosition;

      var child = _react2.default.Children.only(children);
      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
        // and `props.style`.
        positionLeft: positionLeft,
        positionTop: positionTop,
        className: (0, _classnames2.default)(className, child.props.className),
        style: _extends({}, child.props.style, {
          left: positionLeft,
          top: positionTop
        })
      }));
    }
  }, {
    key: 'getTarget',
    value: function getTarget() {
      var target = this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    }
  }, {
    key: 'maybeUpdatePosition',
    value: function maybeUpdatePosition(placementChanged) {
      var target = this.getTarget();

      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
        return;
      }

      this.updatePosition(target);
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition(target) {
      this._lastTarget = target;

      if (!target) {
        this.setState({
          positionLeft: 0,
          positionTop: 0,
          arrowOffsetLeft: null,
          arrowOffsetTop: null
        });

        return;
      }

      var overlay = _reactDom2.default.findDOMNode(this);
      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
    }
  }]);

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),

  /**
   * "offsetParent" of the component
   */
  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _react2.default.PropTypes.number,
  /**
   * How to position the component relative to the target
   */
  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _react2.default.PropTypes.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contains = __webpack_require__(232);

var _contains2 = _interopRequireDefault(_contains);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(142);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(54);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  _createClass(RootCloseWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.disabled) {
        this.addEventListeners();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!this.props.disabled && prevProps.disabled) {
        this.addEventListeners();
      } else if (this.props.disabled && !prevProps.disabled) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.props.disabled) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      var event = this.props.event;

      var doc = (0, _ownerDocument2.default)(this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);

      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);

      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners() {
      if (this.documentMouseCaptureListener) {
        this.documentMouseCaptureListener.remove();
      }

      if (this.documentMouseListener) {
        this.documentMouseListener.remove();
      }

      if (this.documentKeyupListener) {
        this.documentKeyupListener.remove();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _react2.default.PropTypes.func,
  /**
   * Children to render.
   */
  children: _react2.default.PropTypes.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _react2.default.PropTypes.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _tooltip = __webpack_require__(701);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      style = _ref.style,
      placement = _ref.placement,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? {} : _ref$theme;

  var containerClassName = (0, _classnames2.default)(_tooltip2.default.container, theme.container, _defineProperty({}, _tooltip2.default[placement], placement));
  var containerStyle = _extends({}, style, theme.containerStyle);

  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: containerStyle },
    _react2.default.createElement(
      'div',
      { className: _tooltip2.default.content },
      children
    ),
    _react2.default.createElement(
      'div',
      { className: _tooltip2.default.triangleWrapper },
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_tooltip2.default.triangle, theme.triangle) })
    )
  );
};

Tooltip.propTypes = {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  placement: _propTypes2.default.string,
  theme: _propTypes2.default.object
};

exports.default = Tooltip;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeDecorators = exports.createEditorStateWithText = exports.default = undefined;

var _createEditorStateWithText = __webpack_require__(728);

var _createEditorStateWithText2 = _interopRequireDefault(_createEditorStateWithText);

var _composeDecorators = __webpack_require__(729);

var _composeDecorators2 = _interopRequireDefault(_composeDecorators);

var _Editor = __webpack_require__(730);

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Editor2.default;

// eslint-disable-next-line import/no-named-as-default

var createEditorStateWithText = exports.createEditorStateWithText = _createEditorStateWithText2.default;
var composeDecorators = exports.composeDecorators = _composeDecorators2.default;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleDrop = __webpack_require__(736);

var _handleDrop2 = _interopRequireDefault(_handleDrop);

var _createDecorator = __webpack_require__(739);

var _createDecorator2 = _interopRequireDefault(_createDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createBlockDndPlugin = function createBlockDndPlugin() {
  var store = {
    getReadOnly: undefined
  };
  return {
    initialize: function initialize(_ref) {
      var getReadOnly = _ref.getReadOnly;

      store.getReadOnly = getReadOnly;
    },
    decorator: (0, _createDecorator2.default)({ store: store }),
    // Handle blocks dragged and dropped across the editor
    handleDrop: _handleDrop2.default
  };
};

exports.default = createBlockDndPlugin;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DRAFTJS_BLOCK_KEY = exports.DRAFTJS_BLOCK_KEY = 'DRAFTJS_BLOCK_KEY';
var DRAFTJS_BLOCK_TYPE = exports.DRAFTJS_BLOCK_TYPE = 'DRAFTJS_BLOCK_TYPE';

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextEditorImage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(5);

var _imageLoader = __webpack_require__(155);

var _imageLoader2 = _interopRequireDefault(_imageLoader);

var _externalLink = __webpack_require__(237);

var _externalLink2 = _interopRequireDefault(_externalLink);

var _locationHistorySelectors = __webpack_require__(162);

var _getImageUrl = __webpack_require__(183);

var _getImageUrl2 = _interopRequireDefault(_getImageUrl);

var _formatUrl = __webpack_require__(238);

var _formatUrl2 = _interopRequireDefault(_formatUrl);

var _textEditorImage = __webpack_require__(748);

var _textEditorImage2 = _interopRequireDefault(_textEditorImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditorImage = exports.TextEditorImage = function (_Component) {
  _inherits(TextEditorImage, _Component);

  function TextEditorImage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextEditorImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextEditorImage.__proto__ || Object.getPrototypeOf(TextEditorImage)).call.apply(_ref, [this].concat(args))), _this), _this.renderLoader = function (isLoading) {
      if (!isLoading) {
        return null;
      }
      return _react2.default.createElement(_imageLoader2.default, null);
    }, _this.render = function () {
      var _this$props = _this.props,
          block = _this$props.block,
          contentState = _this$props.contentState,
          className = _this$props.className,
          isPublic = _this$props.isPublic,
          url = _this$props.url;

      var entity = contentState.getEntity(block.getEntityAt(0));

      var _entity$getData = entity.getData(),
          src = _entity$getData.src,
          isLoading = _entity$getData.isLoading,
          href = _entity$getData.href;

      var link = (0, _formatUrl2.default)(href);
      var ContainerComponent = link ? _externalLink2.default : 'div';
      var containerProps = _extends({}, getElementProps(_this.props), link ? { href: link } : {});
      var imageSrc = src.dataUrl;

      if (!imageSrc) {
        imageSrc = (0, _getImageUrl2.default)(src);
      }

      var containerClassName = (0, _classnames2.default)(className, _textEditorImage2.default.container, 'text-editor-image', _defineProperty({}, _textEditorImage2.default.isLoading, isLoading));
      var imgProps = isPublic && url ? { 'data-pin-url': url } : { 'data-pin-nopin': true };
      return _react2.default.createElement(
        ContainerComponent,
        _extends({}, containerProps, { className: containerClassName, draggable: true, 'data-hook': 'image' }),
        _react2.default.createElement('img', _extends({ className: _textEditorImage2.default.image, src: imageSrc }, imgProps)),
        _this.renderLoader(isLoading)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return TextEditorImage;
}(_react.Component);

function getElementProps(props) {
  return _lodash2.default.omit(props, ['block', 'blockProps', 'contentState', 'customStyleMap', 'customStyleFn', 'decorator', 'forceSelection', 'offsetKey', 'tree', 'theme', 'direction', 'selection', 'url', 'dispatch', 'isPublic']);
}

TextEditorImage.propTypes = {
  block: _propTypes2.default.object.isRequired,
  blockProps: _propTypes2.default.object.isRequired,
  contentState: _propTypes2.default.object,
  className: _propTypes2.default.string,
  url: _propTypes2.default.string,
  isPublic: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    url: (0, _locationHistorySelectors.getCurrentLocationOuterUrl)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TextEditorImage);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = __webpack_require__(743)(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  self.onCompile();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }

  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest       = RegExp(
                            '(' + self.re.schema_test.source + ')|' +
                            '(' + self.re.host_fuzzy_test.source + ')|' +
                            '@',
                            'i');

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt.prototype.onCompile = function onCompile() {
};


module.exports = LinkifyIt;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _imageLoader = __webpack_require__(155);

var _imageLoader2 = _interopRequireDefault(_imageLoader);

var _videoEmbed = __webpack_require__(407);

var _videoEmbed2 = _interopRequireDefault(_videoEmbed);

var _textEditorVideoEmbed = __webpack_require__(763);

var _textEditorVideoEmbed2 = _interopRequireDefault(_textEditorVideoEmbed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditorVideoEmbed = function (_Component) {
  _inherits(TextEditorVideoEmbed, _Component);

  function TextEditorVideoEmbed() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextEditorVideoEmbed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextEditorVideoEmbed.__proto__ || Object.getPrototypeOf(TextEditorVideoEmbed)).call.apply(_ref, [this].concat(args))), _this), _this.renderLoader = function (isLoading) {
      return isLoading && _react2.default.createElement(_imageLoader2.default, { className: _textEditorVideoEmbed2.default.loader });
    }, _this.renderVideoPlayer = function (oembed) {
      return oembed && _react2.default.createElement(_videoEmbed2.default, { oembed: oembed, isPlayDisabled: !_this.props.blockProps.readOnly });
    }, _this.render = function () {
      var _this$props = _this.props,
          block = _this$props.block,
          contentState = _this$props.contentState,
          className = _this$props.className;

      var entity = contentState.getEntity(block.getEntityAt(0));

      var _entity$getData = entity.getData(),
          oembed = _entity$getData.oembed,
          isLoading = _entity$getData.isLoading;

      var containerClassName = (0, _classnames2.default)(_textEditorVideoEmbed2.default.container, className, 'text-editor-video-embed', _defineProperty({}, _textEditorVideoEmbed2.default.isLoading, isLoading));

      return _react2.default.createElement(
        'div',
        _extends({}, getElementProps(_this.props), { className: containerClassName, draggable: true }),
        _this.renderLoader(isLoading),
        _this.renderVideoPlayer(oembed)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return TextEditorVideoEmbed;
}(_react.Component);

function getElementProps(props) {
  return _lodash2.default.omit(props, ['block', 'blockProps', 'contentState', 'customStyleMap', 'customStyleFn', 'decorator', 'forceSelection', 'offsetKey', 'tree', 'theme', 'direction', 'selection', 'readOnly']);
}

TextEditorVideoEmbed.propTypes = {
  block: _propTypes2.default.object.isRequired,
  blockProps: _propTypes2.default.object.isRequired,
  contentState: _propTypes2.default.object,
  className: _propTypes2.default.string
};

exports.default = TextEditorVideoEmbed;

/***/ }),
/* 346 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _textEditorHashtag = __webpack_require__(764);

var _textEditorHashtag2 = _interopRequireDefault(_textEditorHashtag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hashtag = function Hashtag(_ref) {
  var children = _ref.children,
      decoratedText = _ref.decoratedText,
      createHref = _ref.createHref,
      theme = _ref.theme;

  var to = createHref(decoratedText.slice(1));
  var Component = to ? _internalLink2.default : 'span';
  var props = to ? { className: (0, _classnames2.default)(theme, _textEditorHashtag2.default.hover), to: to } : { className: theme };

  return _react2.default.createElement(
    Component,
    props,
    children
  );
};

Hashtag.propTypes = {
  children: _propTypes2.default.node,
  decoratedText: _propTypes2.default.string,
  createHref: _propTypes2.default.func,
  theme: _propTypes2.default.string
};

Hashtag.defaultProps = {
  createHref: function createHref() {}
};

exports.default = Hashtag;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ImagePlugin;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ImagePlugin(_ref) {
  var _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === undefined ? _lodash2.default.identity : _ref$decorator,
      Image = _ref.Image;

  var DecoratedImage = decorator(Image);
  return {
    blockRendererFn: function blockRendererFn(block, _ref2) {
      var getEditorState = _ref2.getEditorState;

      if (block.getType() === 'atomic') {
        var contentState = getEditorState().getCurrentContent();
        var entityKey = block.getEntityAt(0);
        if (entityKey && contentState.getEntity(entityKey).getType() === 'IMAGE') {
          return {
            component: DecoratedImage,
            editable: false
          };
        }
      }
    }
  };
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoEmbedPlugin;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VideoEmbedPlugin(_ref) {
  var _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === undefined ? _lodash2.default.identity : _ref$decorator,
      VideoEmbed = _ref.VideoEmbed;

  var DecoratedVideoEmbed = decorator(VideoEmbed);
  return {
    blockRendererFn: function blockRendererFn(block, _ref2) {
      var getEditorState = _ref2.getEditorState,
          getReadOnly = _ref2.getReadOnly;

      if (block.getType() === 'atomic') {
        var contentState = getEditorState().getCurrentContent();
        var entityKey = block.getEntityAt(0);
        if (entityKey && contentState.getEntity(entityKey).getType() === 'VIDEO-EMBED') {
          return {
            component: DecoratedVideoEmbed,
            editable: false,
            props: {
              readOnly: Boolean(getReadOnly())
            }
          };
        }
      }
    }
  };
}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AtomicBlockPlugin;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _decorateComponentWithProps = __webpack_require__(51);

var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);

var _draftJs = __webpack_require__(10);

var _reactDom = __webpack_require__(14);

var _textEditorUtils = __webpack_require__(66);

var _createStore = __webpack_require__(765);

var _createStore2 = _interopRequireDefault(_createStore);

var _createDecorator = __webpack_require__(766);

var _createDecorator2 = _interopRequireDefault(_createDecorator);

var _mediaBlockEditor = __webpack_require__(767);

var _mediaBlockEditor2 = _interopRequireDefault(_mediaBlockEditor);

var _setSelectionToBlock = __webpack_require__(352);

var _setSelectionToBlock2 = _interopRequireDefault(_setSelectionToBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MIN_CONTENT_IMAGE_WIDTH = 740;

function AtomicBlockPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      theme = _ref.theme,
      onUpload = _ref.onUpload,
      onFileSelect = _ref.onFileSelect,
      onVideoEmbedChange = _ref.onVideoEmbedChange,
      isDesktop = _ref.isDesktop,
      getEditorRef = _ref.getEditorRef,
      _ref$minContentImageW = _ref.minContentImageWidth,
      minContentImageWidth = _ref$minContentImageW === undefined ? DEFAULT_MIN_CONTENT_IMAGE_WIDTH : _ref$minContentImageW;

  var store = (0, _createStore2.default)();
  return {
    initialize: function initialize(_ref2) {
      var getReadOnly = _ref2.getReadOnly,
          getEditorState = _ref2.getEditorState,
          setEditorState = _ref2.setEditorState,
          getEditorRef = _ref2.getEditorRef;

      store.updateItem('getReadOnly', getReadOnly);
      store.updateItem('getEditorState', getEditorState);
      store.updateItem('setEditorState', setEditorState);
      store.updateItem('getEditorRef', getEditorRef);
      store.updateItem('selectBlock', function (block) {
        return (0, _setSelectionToBlock2.default)(getEditorState, setEditorState, block);
      });
    },

    decorator: (0, _createDecorator2.default)({ store: store, theme: theme }),
    handleKeyCommand: function handleKeyCommand(command, editorState, _ref3) {
      var setEditorState = _ref3.setEditorState;

      if ((0, _textEditorUtils.isAtomicBlockFocused)(editorState) && command === 'backspace') {
        setEditorState((0, _textEditorUtils.removeBlock)(editorState, editorState.getSelection().getAnchorKey()));
        return 'handled';
      }

      return 'not-handled';
    },

    blockRendererFn: function blockRendererFn(contentBlock, _ref4) {
      var getEditorState = _ref4.getEditorState,
          setEditorState = _ref4.setEditorState;

      var entityKey = contentBlock.getEntityAt(0);
      if (contentBlock.type !== 'atomic' || !entityKey) {
        return null;
      }

      var entity = getEditorState().getCurrentContent().getEntity(entityKey);
      var entityData = entity.data;
      var alignment = entityData.alignment,
          size = entityData.size;

      var editorRef = getEditorRef && getEditorRef();
      var editorElement = editorRef && (0, _reactDom.findDOMNode)(editorRef);
      return {
        props: {
          deleteBlock: createDeleteEntity(contentBlock, { getEditorState: getEditorState, setEditorState: setEditorState }),
          size: !size && !alignment ? getInitialSize(minContentImageWidth, entity) : size,
          setSize: createSetSize(contentBlock, { getEditorState: getEditorState, setEditorState: setEditorState }),
          alignment: alignment,
          setAlignment: createSetAlignment(contentBlock, { getEditorState: getEditorState, setEditorState: setEditorState }),
          setHref: createSetHref(contentBlock, { getEditorState: getEditorState, setEditorState: setEditorState }),
          editorFocus: editorElement && isEditorFocused(editorElement)
        }
      };
    },
    MediaBlockEditor: (0, _decorateComponentWithProps2.default)(_mediaBlockEditor2.default, {
      pluginData: store,
      buttons: isDesktop ? getButtonsDesktop(minContentImageWidth) : getButtonsMobile,
      onUpload: onUpload,
      onVideoEmbedChange: onVideoEmbedChange,
      onFileSelect: onFileSelect
    })
  };
}

function createDeleteEntity(contentBlock, _ref5) {
  var getEditorState = _ref5.getEditorState,
      setEditorState = _ref5.setEditorState;

  return function () {
    return setEditorState((0, _textEditorUtils.removeBlock)(getEditorState(), contentBlock.getKey()));
  };
}

function createSetAlignment(contentBlock, _ref6) {
  var getEditorState = _ref6.getEditorState,
      setEditorState = _ref6.setEditorState;

  return function (alignment) {
    return updateEntityData(contentBlock, { getEditorState: getEditorState, setEditorState: setEditorState }, function (entityData) {
      var result = _extends({}, entityData, {
        alignment: alignment
      });
      delete result.size;
      return result;
    });
  };
}

function createSetSize(contentBlock, _ref7) {
  var getEditorState = _ref7.getEditorState,
      setEditorState = _ref7.setEditorState;

  return function (size) {
    return updateEntityData(contentBlock, { getEditorState: getEditorState, setEditorState: setEditorState }, function (entityData) {
      var result = _extends({}, entityData, {
        size: size
      });
      delete result.alignment;
      return result;
    });
  };
}

function createSetHref(contentBlock, _ref8) {
  var getEditorState = _ref8.getEditorState,
      setEditorState = _ref8.setEditorState;

  return function (href) {
    return updateEntityData(contentBlock, { getEditorState: getEditorState, setEditorState: setEditorState }, function (entityData) {
      return _extends({}, entityData, {
        href: href
      });
    });
  };
}

function updateEntityData(contentBlock, _ref9, getNewData) {
  var getEditorState = _ref9.getEditorState,
      setEditorState = _ref9.setEditorState;

  var entityKey = contentBlock.getEntityAt(0);
  if (entityKey) {
    var editorState = getEditorState();
    var contentState = editorState.getCurrentContent();
    var entityData = contentState.getEntity(entityKey).getData();
    var data = getNewData(entityData);
    contentState.replaceEntityData(entityKey, data);
    var newSelection = new _draftJs.SelectionState({
      anchorKey: contentBlock.key,
      anchorOffset: 0,
      focusKey: contentBlock.key,
      focusOffset: 0
    });
    setEditorState(_draftJs.EditorState.forceSelection(editorState, newSelection));
  }
}

function getInitialSize(minContentImageWidth, _ref10) {
  var type = _ref10.type,
      data = _ref10.data;

  if (isImage(type)) {
    return getImageWidth(data) >= minContentImageWidth ? 'content' : 'original';
  }

  return 'content';
}

function getImageWidth(entityData) {
  return _lodash2.default.get(entityData, 'src.width', 0);
}

function getButtonsMobile(_ref11) {
  var type = _ref11.type;

  return [isImage(type) ? 'reupload' : null, 'delete'];
}

function getButtonsDesktop(minContentImageWidth) {
  return function (_ref12) {
    var type = _ref12.type,
        data = _ref12.data;
    return [isImage(type) && isSmallImage(minContentImageWidth, data) ? 'sizeOriginal' : null, 'sizeText', 'sizeContent', 'sizeFullWidth', '-', 'alignLeft', 'alignRight', '-', isImage(type) ? 'reupload' : null, 'delete'];
  };
}

function isImage(type) {
  return type === 'IMAGE';
}

function isSmallImage(minContentImageWidth, entityData) {
  return getImageWidth(entityData) < minContentImageWidth;
}

function isEditorFocused(editorElement) {
  if (typeof window === 'undefined') {
    return false;
  }

  var activeElement = document.activeElement;
  return activeElement && isFocused(activeElement, editorElement);
}

function isFocused(activeElement, editor) {
  if (activeElement === editor) {
    return true;
  }

  if (!activeElement.parentNode) {
    return false;
  }

  return isFocused(activeElement.parentNode, editor);
}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getInlineToolbarPosition;

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GAP_SIZE = 32;
var GAP_TOP_SIZE = 6;

function getInlineToolbarPosition(editorRect, targetRect, toolbarRect) {
  var parentRect = (0, _scrollParent2.default)().getBoundingClientRect();
  var minLeft = GAP_SIZE - editorRect.left;
  var maxLeft = parentRect.width - editorRect.left - toolbarRect.width - GAP_SIZE;

  var left = targetRect.left - editorRect.left + targetRect.width / 2 - toolbarRect.width / 2;
  var top = targetRect.top - editorRect.top - toolbarRect.height - GAP_TOP_SIZE;

  return {
    left: Math.min(Math.max(left, minLeft), maxLeft),
    top: top
  };
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(10);

var _DraftOffsetKey = __webpack_require__(353);

var _DraftOffsetKey2 = _interopRequireDefault(_DraftOffsetKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Set selection of editor to next/previous block
exports.default = function (getEditorState, setEditorState, newActiveBlock) {
  var editorState = getEditorState();

  // TODO verify that always a key-0-0 exists
  var offsetKey = _DraftOffsetKey2.default.encode(newActiveBlock.getKey(), 0, 0);
  var node = document.querySelectorAll('[data-offset-key="' + offsetKey + '"]')[0];
  // set the native selection to the node so the caret is not in the text and
  // the selectionState matches the native selection
  var selection = window.getSelection();
  var range = document.createRange();
  range.setStart(node, 0);
  range.setEnd(node, 0);
  selection.removeAllRanges();
  selection.addRange(range);

  setEditorState(_draftJs.EditorState.forceSelection(editorState, new _draftJs.SelectionState({
    anchorKey: newActiveBlock.getKey(),
    anchorOffset: 0,
    focusKey: newActiveBlock.getKey(),
    focusOffset: 0,
    isBackward: false
  })));
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * @format
 * 
 */



var KEY_DELIMITER = '-';

var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },

  decode: function decode(offsetKey) {
    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
        blockKey = _offsetKey$split[0],
        decoratorKey = _offsetKey$split[1],
        leafKey = _offsetKey$split[2];

    return {
      blockKey: blockKey,
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};

module.exports = DraftOffsetKey;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CodeBlockPlugin;

var _draftJsCode = __webpack_require__(772);

var _draftJsCode2 = _interopRequireDefault(_draftJsCode);

var _highlightingDecorator = __webpack_require__(786);

var _highlightingDecorator2 = _interopRequireDefault(_highlightingDecorator);

var _textEditorCodeBlock = __webpack_require__(789);

var _textEditorCodeBlock2 = _interopRequireDefault(_textEditorCodeBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CodeBlockPlugin(_ref) {
  var backgroundColor = _ref.backgroundColor;

  return {
    keyBindingFn: function keyBindingFn(event, _ref2) {
      var getEditorState = _ref2.getEditorState;

      if (_draftJsCode2.default.hasSelectionInBlock(getEditorState())) {
        return _draftJsCode2.default.getKeyBinding(event);
      }
    },

    handleKeyCommand: function handleKeyCommand(command, editorState, _ref3) {
      var setEditorState = _ref3.setEditorState;

      var newState = _draftJsCode2.default.hasSelectionInBlock(editorState) ? _draftJsCode2.default.handleKeyCommand(editorState, command) : null;

      if (newState) {
        setEditorState(newState);
        return 'handled';
      }

      return 'not-handled';
    },

    handleReturn: function handleReturn(event, editorState, _ref4) {
      var setEditorState = _ref4.setEditorState;

      if (!_draftJsCode2.default.hasSelectionInBlock(editorState)) {
        return 'not-handled';
      }

      setEditorState(_draftJsCode2.default.handleReturn(event, editorState));
      return 'handled';
    },

    onTab: function onTab(event, _ref5) {
      var getEditorState = _ref5.getEditorState,
          setEditorState = _ref5.setEditorState;

      var editorState = getEditorState();
      if (_draftJsCode2.default.hasSelectionInBlock(editorState)) {
        return setEditorState(_draftJsCode2.default.handleTab(event, editorState));
      }
    },

    decorators: [new _highlightingDecorator2.default()],

    blockRendererFn: function blockRendererFn(block, _ref6) {
      var getReadOnly = _ref6.getReadOnly;

      if (block.getType() === 'code-block') {
        return {
          props: { backgroundColor: backgroundColor },
          component: _textEditorCodeBlock2.default,
          editable: !getReadOnly()
        };
      }
    },
    customStyleMap: {
      CODE: {
        display: 'inline-block',
        padding: '0.18em 0.375em',
        fontFamily: 'monospace',
        backgroundColor: backgroundColor
      }
    }
  };
}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var detectIndent = __webpack_require__(356);

var DEFAULT_INDENTATION = '    ';

/**
 * Detect indentation in a text
 * @param {String} text
 * @return {String}
 */
function getIndentation(text) {
  var result = detectIndent(text);
  return result.indent || DEFAULT_INDENTATION;
}

module.exports = getIndentation;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable guard-for-in */

var repeating = __webpack_require__(779);

// detect either spaces or tabs but not both to properly handle tabs
// for indentation and spaces for alignment
var INDENT_RE = /^(?:( )+|\t+)/;

function getMostUsed(indents) {
	var result = 0;
	var maxUsed = 0;
	var maxWeight = 0;

	for (var n in indents) {
		var indent = indents[n];
		var u = indent[0];
		var w = indent[1];

		if (u > maxUsed || u === maxUsed && w > maxWeight) {
			maxUsed = u;
			maxWeight = w;
			result = Number(n);
		}
	}

	return result;
}

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	// used to see if tabs or spaces are the most used
	var tabs = 0;
	var spaces = 0;

	// remember the size of previous line's indentation
	var prev = 0;

	// remember how many indents/unindents as occurred for a given size
	// and how much lines follow a given indentation
	//
	// indents = {
	//    3: [1, 0],
	//    4: [1, 5],
	//    5: [1, 0],
	//   12: [1, 0],
	// }
	var indents = {};

	// pointer to the array of last used indent
	var current;

	// whether the last action was an indent (opposed to an unindent)
	var isIndent;

	str.split(/\n/g).forEach(function (line) {
		if (!line) {
			// ignore empty lines
			return;
		}

		var indent;
		var matches = line.match(INDENT_RE);

		if (!matches) {
			indent = 0;
		} else {
			indent = matches[0].length;

			if (matches[1]) {
				spaces++;
			} else {
				tabs++;
			}
		}

		var diff = indent - prev;
		prev = indent;

		if (diff) {
			// an indent or unindent has been detected

			isIndent = diff > 0;

			current = indents[isIndent ? diff : -diff];

			if (current) {
				current[0]++;
			} else {
				current = indents[diff] = [1, 0];
			}
		} else if (current) {
			// if the last action was an indent, increment the weight
			current[1] += Number(isIndent);
		}
	});

	var amount = getMostUsed(indents);

	var type;
	var actual;
	if (!amount) {
		type = null;
		actual = '';
	} else if (spaces >= tabs) {
		type = 'space';
		actual = repeating(' ', amount);
	} else {
		type = 'tab';
		actual = repeating('\t', amount);
	}

	return {
		amount: amount,
		type: type,
		indent: actual
	};
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var Immutable = __webpack_require__(31);
var getNewLine = __webpack_require__(147);

/**
 * Return a list of line in this text
 * @param {String} text
 * @param {String} sep (optional)
 * @return {List<String>}
 */
function getLines(text, sep) {
  sep = sep || getNewLine(text);
  return Immutable.List(text.split(sep));
}

module.exports = getLines;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Immutable = __webpack_require__(31);
var getNewLine = __webpack_require__(147);

var LineAnchor = Immutable.Record({
  // Index of the current line
  line: Number(0),

  // Offset in current line
  offset: Number(0)
});

LineAnchor.prototype.getLine = function() {
  return this.get('line');
};

LineAnchor.prototype.getOffset = function() {
  return this.get('offset');
};

/**
 * Return an anchor of a cursor in a block as a {line,offset} object
 *
 * @param {String} text
 * @param {Number} offset
 * @param {String} sep (optional)
 * @return {LineAnchor}
 */
function getLineAnchorForOffset(text, offset, sep) {
  sep = sep || getNewLine(text);

  var lineIndex = 0;
  var nextLineIndex = 0;
  var lastLineIndex = 0;

  while (nextLineIndex >= 0 && nextLineIndex < offset) {
    lineIndex++;

    lastLineIndex = nextLineIndex;
    nextLineIndex = text.indexOf(sep, nextLineIndex + sep.length);
  }

  return new LineAnchor({
    line: lineIndex - 1,
    offset: offset - lastLineIndex
  });
}

module.exports = getLineAnchorForOffset;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = extractHashtags;

var _hashtagRegexes = __webpack_require__(791);

var _hashtagRegexes2 = _interopRequireDefault(_hashtagRegexes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extractHashtags(text) {
  if (!text || !text.match(_hashtagRegexes2.default.hashSigns)) {
    return [];
  }

  var tags = [];

  //eslint-disable-next-line max-params
  text.replace(_hashtagRegexes2.default.validHashtag, function (match, before, hash, hashText, offset, chunk) {
    var after = chunk.slice(offset + match.length);
    if (after.match(_hashtagRegexes2.default.endHashtagMatch)) {
      return;
    }
    var startPosition = offset + before.length;
    var endPosition = startPosition + hashText.length + 1;
    tags.push({
      hashtag: hashText,
      indices: [startPosition, endPosition]
    });
  });

  return tags;
}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTextEditorDecorator;

var _draftJs = __webpack_require__(10);

var _createLinkDecorator = __webpack_require__(793);

var _createLinkDecorator2 = _interopRequireDefault(_createLinkDecorator);

var _createLinkEntityDecorator = __webpack_require__(796);

var _createLinkEntityDecorator2 = _interopRequireDefault(_createLinkEntityDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ignoredBlockTypes = ['code-block'];

function createTextEditorDecorator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? {} : _ref$theme,
      followLinks = _ref.followLinks;

  var linkTheme = theme.link;
  return new _draftJs.CompositeDecorator([(0, _createLinkDecorator2.default)({
    ignoredBlockTypes: ignoredBlockTypes,
    theme: linkTheme,
    followLinks: followLinks
  }), (0, _createLinkEntityDecorator2.default)({ theme: linkTheme, followLinks: followLinks })]);
}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBlockRenderMap;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(31);

var _textEditorTitleWrapper = __webpack_require__(799);

var _textEditorTitleWrapper2 = _interopRequireDefault(_textEditorTitleWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createBlockRenderMap(_ref) {
  var titleTheme = _ref.titleTheme;

  // eslint-disable-next-line new-cap
  return (0, _immutable.Map)({
    'header-one': {
      element: 'h2',
      wrapper: _react2.default.createElement(_textEditorTitleWrapper2.default, { theme: titleTheme })
    },
    'header-two': {
      element: 'h3',
      wrapper: _react2.default.createElement(_textEditorTitleWrapper2.default, { theme: titleTheme })
    },
    'code-block': {
      element: 'div'
    }
  });
}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (contentState, startKey, endKey) {
  var blockMapKeys = contentState.getBlockMap().keySeq();
  return blockMapKeys.skipUntil(function (key) {
    return key === startKey;
  }).takeUntil(function (key) {
    return key === endKey;
  }).concat([endKey]);
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_OEMBED_REQUEST = exports.FETCH_OEMBED_REQUEST = 'oembed/REQUEST';
var FETCH_OEMBED_SUCCESS = exports.FETCH_OEMBED_SUCCESS = 'oembed/SUCCESS';
var FETCH_OEMBED_FAILURE = exports.FETCH_OEMBED_FAILURE = 'oembed/FAILURE';

var fetchOembedRequest = exports.fetchOembedRequest = function fetchOembedRequest() {
  return { type: FETCH_OEMBED_REQUEST };
};
var fetchOembedSuccess = exports.fetchOembedSuccess = function fetchOembedSuccess(payload) {
  return { type: FETCH_OEMBED_SUCCESS, payload: payload };
};
var fetchOembedFailure = exports.fetchOembedFailure = function fetchOembedFailure() {
  return { type: FETCH_OEMBED_FAILURE };
};

var fetchOembed = exports.fetchOembed = function fetchOembed(url) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchOembedRequest());

    var promise = request('/_api/oembed?url=' + url);

    return promise.then(function (details) {
      return dispatch(fetchOembedSuccess(details));
    }).catch(function () {
      return dispatch(fetchOembedFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _moveToCategory = __webpack_require__(846);

var _moveToCategory2 = _interopRequireDefault(_moveToCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _moveToCategory2.default;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _shareForm = __webpack_require__(874);

var _shareForm2 = _interopRequireDefault(_shareForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shareForm2.default;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _shareLink = __webpack_require__(878);

var _shareLink2 = _interopRequireDefault(_shareLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shareLink2.default;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promoteUserDetails = __webpack_require__(905);

var _promoteUserDetails2 = _interopRequireDefault(_promoteUserDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _promoteUserDetails2.default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _blockConfirmation = __webpack_require__(920);

var _blockConfirmation2 = _interopRequireDefault(_blockConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _blockConfirmation2.default;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestLogin;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _i18nUtils = __webpack_require__(133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function requestLogin(cb) {
  return _wixSdkPolyfill2.default.requestLogin({
    language: (0, _i18nUtils.getLanguage)(),
    checkCommunityCheckbox: true
  }, function (member) {
    if (member && member.authResponse) {
      member = member.data;
    }
    cb(member);
  });
}

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(376);
module.exports = self.fetch.bind(self);


/***/ }),
/* 376 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(380);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33), __webpack_require__(150)(module)))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _storeShape = __webpack_require__(172);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(173);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _propTypes2["default"].element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__(0);

var _storeShape = __webpack_require__(172);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(383);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(384);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(173);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(174);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(6);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(164);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(388);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserPrivacyStatus = exports.UPDATE_USER_PRIVACY_STATUS = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_USER_PRIVACY_STATUS = exports.UPDATE_USER_PRIVACY_STATUS = 'user/UPDATE_USER_PRIVACY_STATUS';

var updateUserPrivacyStatus = exports.updateUserPrivacyStatus = (0, _createAction2.default)(UPDATE_USER_PRIVACY_STATUS);

/***/ }),
/* 390 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(163),
    isObject = __webpack_require__(286);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPLICATION_ADDED = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPLICATION_ADDED = exports.APPLICATION_ADDED = 'application/ADDED';

exports.default = (0, _createAction2.default)(APPLICATION_ADDED);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPLICATION_DELETED = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPLICATION_DELETED = exports.APPLICATION_DELETED = 'application/DELETED';

exports.default = (0, _createAction2.default)(APPLICATION_DELETED);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSearchResults = exports.MIN_QUERY_LENGTH = exports.SEARCH_CLEAR_RESULTS = exports.SEARCH_QUERY_SEND = exports.SEARCH = undefined;
exports.default = search;

var _fetchSearch = __webpack_require__(131);

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { addRecentSearchWithCancel } from './search-history';

// import nodeUuid from 'node-uuid';
// import { emitSearch } from './search-socket';
var SEARCH = exports.SEARCH = 'search/SEARCH';
var SEARCH_QUERY_SEND = exports.SEARCH_QUERY_SEND = 'search/QUERY_SEND';
var SEARCH_CLEAR_RESULTS = exports.SEARCH_CLEAR_RESULTS = 'search/CLEAR_RESULTS';

var MIN_QUERY_LENGTH = exports.MIN_QUERY_LENGTH = 2;

var clearSearchResults = exports.clearSearchResults = (0, _createAction2.default)(SEARCH_CLEAR_RESULTS);

function search(query) {
  var minQueryLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MIN_QUERY_LENGTH;

  return function (dispatch) {
    dispatch({
      type: SEARCH,
      payload: query
    });

    // dispatch(addRecentSearchWithCancel(query));

    // if (getState().socket.connected) {
    //   const uuid = nodeUuid.v1();
    //   dispatch({
    //     type: SEARCH_QUERY_SEND,
    //     payload: {
    //       query,
    //       uuid
    //     }
    //   });
    //   dispatch(emitSearch(query, uuid));
    //   return;
    // }

    dispatch((0, _fetchSearch.fetchSearchWithCancel)(query, 300, minQueryLength));
    if (query.length < minQueryLength) {
      dispatch(clearSearchResults());
    }
  };
}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HIDE_MESSAGE = exports.HIDE_MESSAGE = 'message/HIDE';

var hideMessage = exports.hideMessage = function hideMessage() {
  return { type: HIDE_MESSAGE };
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_NEW_POST_MESSAGE = exports.SHOW_NEW_POST_MESSAGE = 'newPostMessage/SHOW';
var SHOW_NEW_POST_MESSAGE_DEBOUNCED = exports.SHOW_NEW_POST_MESSAGE_DEBOUNCED = 'newPostMessage/SHOW_DEBOUNCED';

var showNewPostMessage = exports.showNewPostMessage = function showNewPostMessage(payload) {
  return function (debounce) {
    return debounce({
      type: SHOW_NEW_POST_MESSAGE,
      payload: payload
    });
  };
};

var showNewPostMessageDebounced = exports.showNewPostMessageDebounced = function showNewPostMessageDebounced(payload) {
  var action = showNewPostMessage(payload);
  action.type = SHOW_NEW_POST_MESSAGE_DEBOUNCED;
  action.meta = {
    debounce: 0
  };
  return action;
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_POST_FAILURE = exports.UPDATE_POST_SUCCESS = exports.UPDATE_POST_REQUEST = undefined;
exports.updatePost = updatePost;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _sanitizeContent = __webpack_require__(124);

var _sanitizeContent2 = _interopRequireDefault(_sanitizeContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_POST_REQUEST = exports.UPDATE_POST_REQUEST = 'post/UPDATE_REQUEST';
var UPDATE_POST_SUCCESS = exports.UPDATE_POST_SUCCESS = 'post/UPDATE_SUCCESS';
var UPDATE_POST_FAILURE = exports.UPDATE_POST_FAILURE = 'post/UPDATE_FAILURE';

var PROPS = ['title', 'content'];

function updatePost() {
  var post = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: UPDATE_POST_REQUEST
    });

    var promise = request.patch('/_api/posts/' + post._id, (0, _sanitizeContent2.default)(_lodash2.default.pick(post, PROPS)));

    return promise.then(function (updatedPost) {
      return dispatch({
        type: UPDATE_POST_SUCCESS,
        payload: updatedPost
      });
    }).catch(function () {
      return dispatch({
        type: UPDATE_POST_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinPost = pinPost;
var PIN_POST_REQUEST = exports.PIN_POST_REQUEST = 'post/PIN_REQUEST';
var PIN_POST_SUCCESS = exports.PIN_POST_SUCCESS = 'post/PIN_SUCCESS';
var PIN_POST_FAILURE = exports.PIN_POST_FAILURE = 'post/PIN_FAILURE';

function pinPost(id) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: PIN_POST_REQUEST
    });

    var promise = request.post('/_api/posts/' + id + '/pin');

    return promise.then(function (post) {
      return dispatch({
        type: PIN_POST_SUCCESS,
        payload: post
      });
    }).catch(function () {
      return dispatch({
        type: PIN_POST_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unpinPost = unpinPost;
var UNPIN_POST_REQUEST = exports.UNPIN_POST_REQUEST = 'post/UNPIN_REQUEST';
var UNPIN_POST_SUCCESS = exports.UNPIN_POST_SUCCESS = 'post/UNPIN_SUCCESS';
var UNPIN_POST_FAILURE = exports.UNPIN_POST_FAILURE = 'post/UNPIN_FAILURE';

function unpinPost(id) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: UNPIN_POST_REQUEST
    });

    var promise = request.post('/_api/posts/' + id + '/unpin');

    return promise.then(function (post) {
      return dispatch({
        type: UNPIN_POST_SUCCESS,
        payload: post
      });
    }).catch(function () {
      return dispatch({
        type: UNPIN_POST_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enablePostComments = enablePostComments;
var ENABLE_POST_COMMENTS_REQUEST = exports.ENABLE_POST_COMMENTS_REQUEST = 'post/ENABLE_COMMENTS_REQUEST';
var ENABLE_POST_COMMENTS_SUCCESS = exports.ENABLE_POST_COMMENTS_SUCCESS = 'post/ENABLE_COMMENTS_SUCCESS';
var ENABLE_POST_COMMENTS_FAILURE = exports.ENABLE_POST_COMMENTS_FAILURE = 'post/ENABLE_COMMENTS_FAILURE';

function enablePostComments(id) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: ENABLE_POST_COMMENTS_REQUEST
    });

    var promise = request.post('/_api/posts/' + id + '/enableComments');

    return promise.then(function (post) {
      return dispatch({
        type: ENABLE_POST_COMMENTS_SUCCESS,
        payload: post
      });
    }).catch(function () {
      return dispatch({
        type: ENABLE_POST_COMMENTS_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disablePostComments = disablePostComments;
var DISABLE_POST_COMMENTS_REQUEST = exports.DISABLE_POST_COMMENTS_REQUEST = 'post/DISABLE_COMMENTS_REQUEST';
var DISABLE_POST_COMMENTS_SUCCESS = exports.DISABLE_POST_COMMENTS_SUCCESS = 'post/DISABLE_COMMENTS_SUCCESS';
var DISABLE_POST_COMMENTS_FAILURE = exports.DISABLE_POST_COMMENTS_FAILURE = 'post/DISABLE_COMMENTS_FAILURE';

function disablePostComments(id) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: DISABLE_POST_COMMENTS_REQUEST
    });

    var promise = request.post('/_api/posts/' + id + '/disableComments');

    return promise.then(function (post) {
      return dispatch({
        type: DISABLE_POST_COMMENTS_SUCCESS,
        payload: post
      });
    }).catch(function () {
      return dispatch({
        type: DISABLE_POST_COMMENTS_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCategory = createCategory;
var CREATE_CATEGORY_REQUEST = exports.CREATE_CATEGORY_REQUEST = 'category/CREATE_REQUEST';
var CREATE_CATEGORY_SUCCESS = exports.CREATE_CATEGORY_SUCCESS = 'category/CREATE_SUCCESS';
var CREATE_CATEGORY_FAILURE = exports.CREATE_CATEGORY_FAILURE = 'category/CREATE_FAILURE';

function createCategory() {
  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: CREATE_CATEGORY_REQUEST
    });

    var promise = request.post('/_api/categories/', category);

    return promise.then(function (category) {
      return dispatch({
        type: CREATE_CATEGORY_SUCCESS,
        payload: category
      });
    }).catch(function () {
      return dispatch({
        type: CREATE_CATEGORY_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCategoryFailure = exports.updateCategorySuccess = exports.updateCategoryRequest = exports.UPDATE_CATEGORY_FAILURE = exports.UPDATE_CATEGORY_SUCCESS = exports.UPDATE_CATEGORY_REQUEST = undefined;
exports.updateCategory = updateCategory;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OMIT_FIELDS = ['_id', 'instanceId', 'totalPosts', 'totalViews', 'isSubscribed', 'slug'];

var UPDATE_CATEGORY_REQUEST = exports.UPDATE_CATEGORY_REQUEST = 'category/UPDATE_REQUEST';
var UPDATE_CATEGORY_SUCCESS = exports.UPDATE_CATEGORY_SUCCESS = 'category/UPDATE_SUCCESS';
var UPDATE_CATEGORY_FAILURE = exports.UPDATE_CATEGORY_FAILURE = 'category/UPDATE_FAILURE';

var updateCategoryRequest = exports.updateCategoryRequest = function updateCategoryRequest() {
  return { type: UPDATE_CATEGORY_REQUEST };
};
var updateCategorySuccess = exports.updateCategorySuccess = function updateCategorySuccess(payload) {
  return { type: UPDATE_CATEGORY_SUCCESS, payload: payload };
};
var updateCategoryFailure = exports.updateCategoryFailure = function updateCategoryFailure() {
  return { type: UPDATE_CATEGORY_FAILURE };
};

function updateCategory(categoryId, data) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(updateCategoryRequest());

    var promise = request.patch('/_api/categories/' + categoryId, _lodash2.default.omit(data, OMIT_FIELDS));
    return promise.then(function (updatedCategory) {
      return dispatch(updateCategorySuccess(updatedCategory));
    }).catch(function () {
      return dispatch(updateCategoryFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BLOG_PAGE_ID = exports.BLOG_PAGE_ID = 'blog';
var FORUM_PAGE_ID = exports.FORUM_PAGE_ID = 'forum';
var FORUM_WIDGET_ID = exports.FORUM_WIDGET_ID = 'forum_header_widget';
var MEMBERS_PAGE_ID = exports.MEMBERS_PAGE_ID = 'members';

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.GatewayRegistry = exports.GatewayProvider = exports.GatewayDest = exports.Gateway = undefined;

var _Gateway2 = __webpack_require__(604);

var _Gateway3 = _interopRequireDefault(_Gateway2);

var _GatewayDest2 = __webpack_require__(605);

var _GatewayDest3 = _interopRequireDefault(_GatewayDest2);

var _GatewayProvider2 = __webpack_require__(611);

var _GatewayProvider3 = _interopRequireDefault(_GatewayProvider2);

var _GatewayRegistry2 = __webpack_require__(141);

var _GatewayRegistry3 = _interopRequireDefault(_GatewayRegistry2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Gateway = _Gateway3.default;
exports.GatewayDest = _GatewayDest3.default;
exports.GatewayProvider = _GatewayProvider3.default;
exports.GatewayRegistry = _GatewayRegistry3.default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTemplate = isTemplate;

var _config = __webpack_require__(29);

function isTemplate() {
  return (0, _config.getConfig)().sectionUrl.indexOf('//www.wix.com/') > -1;
}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _videoEmbed = __webpack_require__(749);

var _videoEmbed2 = _interopRequireDefault(_videoEmbed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _videoEmbed2.default;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INLINE_TOOLBAR_SHOW = exports.INLINE_TOOLBAR_SHOW = 'textEditor/INLINE_TOOLBAR_SHOW';

var inlineToolbarShown = exports.inlineToolbarShown = function inlineToolbarShown(payload) {
  return {
    type: INLINE_TOOLBAR_SHOW,
    payload: payload
  };
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _avatar = __webpack_require__(823);

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _avatar2.default;

/***/ }),
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(6);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function configureStore(initialState) {
  var middlewares = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var reducer = arguments[2];

  var enhancer = _redux.applyMiddleware.apply(undefined, _toConsumableArray(middlewares));
  return (0, _redux.createStore)(reducer, initialState, enhancer);
}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _updateAppSettings = __webpack_require__(135);

var _fetchAppSettings = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _updateAppSettings.UPDATE_APP_SETTINGS_REQUEST:
    case _updateAppSettings.UPDATE_APP_SETTINGS_SUCCESS:
    case _updateAppSettings.UPDATE_APP_SETTINGS_ON_STORE:
    case _fetchAppSettings.FETCH_APP_SETTINGS_SUCCESS:
      return _lodash2.default.merge({}, state, action.payload);
    default:
      return state;
  }
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = experiments;

var _setCommunitiesContext = __webpack_require__(247);

var _applicationAdded = __webpack_require__(392);

var _applicationDeleted = __webpack_require__(393);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function experiments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _setCommunitiesContext.SET_COMMUNITIES_CONTEXT:
      return action.payload;
    case _applicationAdded.APPLICATION_ADDED:
      {
        var _action$payload = action.payload,
            appDefinitionId = _action$payload.appDefinitionId,
            instanceId = _action$payload.instanceId;

        return _extends({}, state, _defineProperty({}, appDefinitionId, _extends({}, state[appDefinitionId], { isInstalled: true, instanceId: instanceId })));
      }
    case _applicationDeleted.APPLICATION_DELETED:
      {
        var _appDefinitionId = action.payload.appDefinitionId;

        return _extends({}, state, _defineProperty({}, _appDefinitionId, _extends({}, state[_appDefinitionId], { isInstalled: false, instanceId: null })));
      }
    default:
      return state;
  }
}

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = forumData;

var _fetchForumData = __webpack_require__(197);

var _updateForumData = __webpack_require__(316);

var _setForumData = __webpack_require__(417);

function forumData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _fetchForumData.FETCH_FORUM_DATA_SUCCESS:
    case _updateForumData.UPDATE_FORUM_DATA_SUCCESS:
    case _setForumData.SET_FORUM_DATA:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_FORUM_DATA = exports.SET_FORUM_DATA = 'forumData/SET';

var setForumData = exports.setForumData = function setForumData(payload) {
  return {
    type: SET_FORUM_DATA,
    payload: payload
  };
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIsLoading = exports.SET_IS_LOADING = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_IS_LOADING = exports.SET_IS_LOADING = 'isLoading/SET';

var setIsLoading = exports.setIsLoading = (0, _createAction2.default)(SET_IS_LOADING, function (entity, id, isLoading) {
  return {
    entity: entity,
    id: id,
    isLoading: isLoading
  };
});

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHANGE_CATEGORY_RANK = exports.CHANGE_CATEGORY_RANK = 'category/CHANGE_RANK';

var changeCategoryRank = exports.changeCategoryRank = function changeCategoryRank(categoryId, rank) {
  return {
    type: CHANGE_CATEGORY_RANK,
    payload: {
      categoryId: categoryId,
      rank: rank
    }
  };
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_USER_REQUEST = exports.FETCH_USER_REQUEST = 'user/FETCH_REQUEST';
var FETCH_USER_SUCCESS = exports.FETCH_USER_SUCCESS = 'user/FETCH_SUCCESS';
var FETCH_USER_FAILURE = exports.FETCH_USER_FAILURE = 'user/FETCH_FAILURE';

var fetchUserRequest = exports.fetchUserRequest = function fetchUserRequest() {
  return { type: FETCH_USER_REQUEST };
};
var fetchUserSuccess = exports.fetchUserSuccess = function fetchUserSuccess(payload) {
  return { type: FETCH_USER_SUCCESS, payload: payload };
};
var fetchUserFailure = exports.fetchUserFailure = function fetchUserFailure() {
  return { type: FETCH_USER_FAILURE };
};

var fetchUser = exports.fetchUser = function fetchUser(userId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchUserRequest());

    var promise = request('/_api/users/' + userId);

    return promise.then(function (user) {
      return dispatch(fetchUserSuccess(user));
    }).catch(function () {
      return dispatch(fetchUserFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToMembers = exports.navigateToForum = exports.navigateToBlog = undefined;

var _lodash = __webpack_require__(2);

var _applications = __webpack_require__(25);

var _componentIds = __webpack_require__(404);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navigateToBlog = exports.navigateToBlog = function navigateToBlog(location) {
  return _wixSdkPolyfill2.default.Utils.navigateToSection({
    appDefinitionId: _applications.BLOG_APP_ID,
    sectionId: _componentIds.BLOG_PAGE_ID,
    shouldRefreshIframe: false
  }, (0, _lodash.trimStart)(location, '/'), console.error);
};

var navigateToForum = exports.navigateToForum = function navigateToForum(location) {
  return _wixSdkPolyfill2.default.Utils.navigateToSection({
    appDefinitionId: _applications.FORUM_APP_ID,
    sectionId: _componentIds.FORUM_PAGE_ID,
    shouldRefreshIframe: false
  }, (0, _lodash.trimStart)(location, '/'), console.error);
};

var navigateToMembers = exports.navigateToMembers = function navigateToMembers(location) {
  return _wixSdkPolyfill2.default.Utils.navigateToSection({
    appDefinitionId: _applications.MEMBERS_APP_ID,
    sectionId: _componentIds.MEMBERS_PAGE_ID,
    shouldRefreshIframe: false
  }, (0, _lodash.trimStart)(location, '/'), console.error);
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CANCEL_UPLOADS = exports.CANCEL_UPLOADS = 'fileUpload/CANCEL';

var cancelUploads = exports.cancelUploads = function cancelUploads() {
  return { type: CANCEL_UPLOADS };
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInDashboard = exports.isInPreview = exports.isInEditor = exports.isInSite = undefined;

var _viewModes = __webpack_require__(161);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getViewMode = function getViewMode() {
  return _wixSdkPolyfill2.default.Utils.getViewMode();
};

var isInSite = exports.isInSite = function isInSite() {
  return getViewMode() === _viewModes.VIEW_MODE_SITE;
};
var isInEditor = exports.isInEditor = function isInEditor() {
  return getViewMode() === _viewModes.VIEW_MODE_EDITOR;
};
var isInPreview = exports.isInPreview = function isInPreview() {
  return getViewMode() === _viewModes.VIEW_MODE_PREVIEW;
};
var isInDashboard = exports.isInDashboard = function isInDashboard() {
  return getViewMode() === _viewModes.VIEW_MODE_DASHBOARD;
};

/***/ }),
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(251);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(252);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var handleError = exports.handleError = function handleError(closure) {
  return function () {
    try {
      return closure.apply(undefined, arguments);
    } catch (error) {
      console.error(error);
    }
  };
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAction;

var _identity = __webpack_require__(390);

var _identity2 = _interopRequireDefault(_identity);

var _isFunction = __webpack_require__(391);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isUndefined = __webpack_require__(444);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isNull = __webpack_require__(445);

var _isNull2 = _interopRequireDefault(_isNull);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAction(type) {
  var payloadCreator = arguments.length <= 1 || arguments[1] === undefined ? _identity2.default : arguments[1];
  var metaCreator = arguments[2];

  (0, _invariant2.default)((0, _isFunction2.default)(payloadCreator) || (0, _isNull2.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = (0, _isNull2.default)(payloadCreator) ? _identity2.default : payloadCreator;

  var actionCreator = function actionCreator() {
    var hasError = (arguments.length <= 0 ? undefined : arguments[0]) instanceof Error;

    var action = {
      type: type
    };

    var payload = hasError ? arguments.length <= 0 ? undefined : arguments[0] : finalPayloadCreator.apply(undefined, arguments);
    if (!(0, _isUndefined2.default)(payload)) {
      action.payload = payload;
    }

    if (hasError || payload instanceof Error) {
      // Handle FSA errors where the payload is an Error object. Set error.
      action.error = true;
    }

    if ((0, _isFunction2.default)(metaCreator)) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return type.toString();
  };

  return actionCreator;
}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCommentFailure = exports.updateCommentSuccess = exports.updateCommentRequest = exports.UPDATE_COMMENT_FAILURE = exports.UPDATE_COMMENT_SUCCESS = exports.UPDATE_COMMENT_REQUEST = undefined;
exports.updateComment = updateComment;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

var _sanitizeContent = __webpack_require__(124);

var _sanitizeContent2 = _interopRequireDefault(_sanitizeContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_COMMENT_REQUEST = exports.UPDATE_COMMENT_REQUEST = 'comment/UPDATE_REQUEST';
var UPDATE_COMMENT_SUCCESS = exports.UPDATE_COMMENT_SUCCESS = 'comment/UPDATE_SUCCESS';
var UPDATE_COMMENT_FAILURE = exports.UPDATE_COMMENT_FAILURE = 'comment/UPDATE_FAILURE';

var updateCommentRequest = exports.updateCommentRequest = (0, _createAction2.default)(UPDATE_COMMENT_REQUEST);
var updateCommentSuccess = exports.updateCommentSuccess = (0, _createAction2.default)(UPDATE_COMMENT_SUCCESS);
var updateCommentFailure = exports.updateCommentFailure = (0, _createAction2.default)(UPDATE_COMMENT_FAILURE);

function updateComment(comment) {
  var commentId = comment._id,
      postId = comment.postId,
      content = comment.content;

  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(updateCommentRequest());

    var promise = request.patch('/_api/posts/' + postId + '/comments/' + commentId, (0, _sanitizeContent2.default)({ content: content }));

    return promise.then(function (comment) {
      return dispatch(updateCommentSuccess(comment));
    }).catch(function () {
      return dispatch(updateCommentFailure());
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(448);
} else {
  module.exports = require('./appsConfig.dev');
}


/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = {
  BLOG_APP_ID: '14bcded7-0066-7c35-14d7-466cb3f09103',
  MEMBERS_APP_ID: '14ad9202-3dd3-128a-57bd-e5675fd7e313',
  FORUM_APP_ID: '14724f35-6794-cd1a-0244-25fd138f9242',
  SANTA_MEMBERS_APP_ID: '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9',
  NOTIFICATIONS_APP_ID: '14f25924-5664-31b2-9568-f9c5ed98c9b1',
  NOTIFICATIONS_SETTING_APP_ID: '14f25dc5-6af3-5420-9568-f9c5ed98c9b1',
  MEMBER_INFO_APP_ID: '14cffd81-5215-0a7f-22f8-074b0e2401fb',
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTopComment = addTopComment;
var ADD_TOP_COMMENT_REQUEST = exports.ADD_TOP_COMMENT_REQUEST = 'post/ADD_TOP_COMMENT_REQUEST';
var ADD_TOP_COMMENT_SUCCESS = exports.ADD_TOP_COMMENT_SUCCESS = 'post/ADD_TOP_COMMENT_SUCCESS';
var ADD_TOP_COMMENT_FAILURE = exports.ADD_TOP_COMMENT_FAILURE = 'post/ADD_TOP_COMMENT_FAILURE';

function addTopComment(postId, commentId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: ADD_TOP_COMMENT_REQUEST
    });

    var promise = request.post('/_api/posts/' + postId + '/top-comment', { commentId: commentId });

    return promise.then(function (post) {
      return dispatch({
        type: ADD_TOP_COMMENT_SUCCESS,
        payload: post
      });
    }).catch(function () {
      return dispatch({
        type: ADD_TOP_COMMENT_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTopComment = removeTopComment;
var REMOVE_TOP_COMMENT_REQUEST = exports.REMOVE_TOP_COMMENT_REQUEST = 'post/REMOVE_TOP_COMMENT_REQUEST';
var REMOVE_TOP_COMMENT_SUCCESS = exports.REMOVE_TOP_COMMENT_SUCCESS = 'post/REMOVE_TOP_COMMENT_SUCCESS';
var REMOVE_TOP_COMMENT_FAILURE = exports.REMOVE_TOP_COMMENT_FAILURE = 'post/REMOVE_TOP_COMMENT_FAILURE';

function removeTopComment(postId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch({
      type: REMOVE_TOP_COMMENT_REQUEST
    });

    var promise = request.delete('/_api/posts/' + postId + '/top-comment');

    return promise.then(function (post) {
      return dispatch({
        type: REMOVE_TOP_COMMENT_SUCCESS,
        payload: post
      });
    }).catch(function () {
      return dispatch({
        type: REMOVE_TOP_COMMENT_FAILURE
      });
    }).then(function () {
      return promise;
    });
  };
}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INCREMENT_FOLLOWING_COUNT = exports.INCREMENT_FOLLOWING_COUNT = 'currentUser/INCREMENT_FOLLOWING_COUNT';
var DECREMENT_FOLLOWING_COUNT = exports.DECREMENT_FOLLOWING_COUNT = 'currentUser/DECREMENT_FOLLOWING_COUNT';

var incrementFollowingCount = exports.incrementFollowingCount = function incrementFollowingCount(currentUserId) {
  return { type: INCREMENT_FOLLOWING_COUNT, payload: currentUserId };
};
var decrementFollowingCount = exports.decrementFollowingCount = function decrementFollowingCount(currentUserId) {
  return { type: DECREMENT_FOLLOWING_COUNT, payload: currentUserId };
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_SITE_INFO = exports.SET_SITE_INFO = 'site/SET_SITE_INFO';

var setSiteInfo = exports.setSiteInfo = function setSiteInfo(payload) {
  return { type: SET_SITE_INFO, payload: payload };
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _fetchCategories = __webpack_require__(248);

var _createCategory = __webpack_require__(402);

var _deleteCategory = __webpack_require__(180);

var _updateCategory = __webpack_require__(403);

var _changeCategoryRank = __webpack_require__(419);

var _setCategories = __webpack_require__(268);

var _categorySocket = __webpack_require__(260);

var _subscribe = __webpack_require__(59);

var _unsubscribe = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = [];
var SORT_BY = 'rank';

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _fetchCategories.FETCH_CATEGORIES_SUCCESS:
      return _lodash2.default.sortBy(payload, SORT_BY);
    case _createCategory.CREATE_CATEGORY_SUCCESS:
      return _lodash2.default.sortBy([].concat(_toConsumableArray(state), [payload]), SORT_BY);
    case _categorySocket.UPDATE_CATEGORY_COUNTERS:
    case _updateCategory.UPDATE_CATEGORY_SUCCESS:
      {
        var categoryIndex = _lodash2.default.findIndex(state, function (category) {
          return category._id === payload._id;
        });
        var category = state[categoryIndex];
        return _lodash2.default.sortBy([].concat(_toConsumableArray(state.slice(0, categoryIndex)), [_extends({}, category, payload)], _toConsumableArray(state.slice(categoryIndex + 1, state.length))), SORT_BY);
      }
    case _changeCategoryRank.CHANGE_CATEGORY_RANK:
      {
        var rank = payload.rank,
            categoryId = payload.categoryId;

        var _category = _lodash2.default.find(state, function (category) {
          return category._id === categoryId;
        });
        var tempState = _lodash2.default.filter(state, function (category) {
          return category._id !== categoryId;
        });

        tempState.splice(rank, 0, _category);
        return (0, _lodash2.default)(tempState).map(function (category, rank) {
          return _extends({}, category, {
            rank: rank
          });
        }).sortBy(SORT_BY).value();
      }
    case _deleteCategory.DELETE_CATEGORY_SUCCESS:
      return state.filter(function (category) {
        return category._id !== payload;
      });
    case _setCategories.SET_CATEGORIES:
      return [].concat(_toConsumableArray(payload));
    case _subscribe.SUBSCRIBE_REQUEST:
      return setIsSubscribed(state, payload, true);

    case _subscribe.SUBSCRIBE_FAILURE:
      return setIsSubscribed(state, payload, false);

    case _unsubscribe.UNSUBSCRIBE_REQUEST:
      return setIsSubscribed(state, payload, false);

    case _unsubscribe.UNSUBSCRIBE_FAILURE:
      return setIsSubscribed(state, payload, true);

    default:
      return state;
  }
};

function setIsSubscribed(state, _ref2, isSubscribed) {
  var type = _ref2.type,
      _id = _ref2._id;

  if (type !== 'category') {
    return state;
  }

  var index = _lodash2.default.findIndex(state, function (category) {
    return category._id === _id;
  });
  return [].concat(_toConsumableArray(state.slice(0, index)), [_extends({}, state[index], {
    isSubscribed: isSubscribed
  })], _toConsumableArray(state.slice(index + 1)));
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INSERT_TEXT_EDITOR_LINK = exports.INSERT_TEXT_EDITOR_LINK = 'textEditor/INSERT_LINK';

var insertTextEditorLink = exports.insertTextEditorLink = function insertTextEditorLink(payload) {
  return function (dispatch) {
    dispatch({
      type: INSERT_TEXT_EDITOR_LINK,
      payload: payload
    });

    return Promise.resolve();
  };
};

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"app":"_2noTc","scrollable":"_1sH-E"};

/***/ }),
/* 456 */,
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getForumData = exports.getForumData = function getForumData(state) {
  return state.forumData;
};
var getCommunityId = exports.getCommunityId = function getCommunityId(state) {
  return getForumData(state).communityId;
};
var getForumTitle = exports.getForumTitle = function getForumTitle(state) {
  return getForumData(state).label;
};

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _modalRoot = __webpack_require__(618);

var _modalRoot2 = _interopRequireDefault(_modalRoot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _modalRoot2.default;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertIcon = exports.AlertIcon = function AlertIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "15",
      viewBox: "0 0 17 15",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-733.000000, -3384.000000)", fill: "#008FED" },
        _react2.default.createElement(
          "g",
          { transform: "translate(595.000000, 3136.000000)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(138.000000, 246.000000)" },
            _react2.default.createElement("path", { d: "M12.309,9.627 C13.4444444,8.92660641 14.1350028,7.68708438 14.133,6.353 C14.1320904,4.8782692 13.2899179,3.53328428 11.963641,2.88844223 C10.6373641,2.24360018 9.0594193,2.41191276 7.899,3.322 C7.292,2.458 6.249,2 5.274,2 C3.373,2 1.827,3.547 1.827,5.4 C1.827,6.586 2.433,7.708 3.43,8.32 L3.428,8.34 C1.111,9.212 0,11.088 0,14 C0,14.276 0.062,15 0.5,15 L4.069,15 C4.02489477,15.3315407 4.00184857,15.6655436 4,16 C4,16.276 4.062,17 4.5,17 L16.5,17 C17.021,17 17,16 17,16 C17,12.88 14.874,10.621 12.309,9.627 L12.309,9.627 Z M1,14 C1,11.604 2.112,9.771 4.058,9.182 C4.26412581,9.11962597 4.40715562,8.93227706 4.413,8.717 C4.417,8.557 4.434,8.236 4.448,8.084 C4.46847067,7.87542283 4.35668948,7.67621276 4.168,7.585 C3.341,7.185 2.827,6.316 2.827,5.4 C2.827,4.099 3.925,3 5.274,3 C5.977,3 6.771,3.333 7.193,4.033 C6.68102348,4.69817869 6.40265299,5.51360741 6.401,6.353 C6.401,7.701 7.122,8.92 8.254,9.627 C6.277,10.393 4.831,11.916 4.267,14 L1,14 Z M5,16 C5,13.312 6.663,11.115 8.895,10.44 C9.10181106,10.3773947 9.24500695,10.1890215 9.25,9.973 C9.254,9.789 9.262,9.607 9.279,9.433 C9.29917151,9.22448568 9.18747994,9.02543534 8.999,8.934 C8.00199832,8.46141967 7.36685817,7.45633278 7.368,6.353 C7.368,4.766 8.659,3.5 10.246,3.5 C11.833,3.5 13.124,4.766 13.124,6.353 C13.1251418,7.45633278 12.4900017,8.46141967 11.493,8.934 C11.3043604,9.02578823 11.1926898,9.2251999 11.213,9.434 C11.231,9.608 11.238,9.789 11.242,9.972 C11.2465656,10.1883935 11.389845,10.3772801 11.597,10.44 C13.829,11.115 16,13.292 16,16 L5,16 Z" })
          )
        )
      )
    )
  );
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowBackIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowBackIcon = exports.ArrowBackIcon = function ArrowBackIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "9",
      viewBox: "0 0 12 9",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M206,861H195.716l3.29,3.29-0.716.716L194.284,861H194v-0.284l-0.006-.006L194,860.7V860.3l-0.006-.006,0.006-.006V860h0.284l4.006-4.006,0.716,0.716-3.29,3.29H206v1Z",
      transform: "translate(-194 -856)"
    })
  );
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowBreadCrumbsLeftIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowBreadCrumbsLeftIcon = exports.ArrowBreadCrumbsLeftIcon = function ArrowBreadCrumbsLeftIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "6",
      height: "11",
      viewBox: "0 0 6 11",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M983.992,700.757l5.156,5.251,0.859-.876-4.548-4.632,4.548-4.632-0.859-.876-5.156,5.252,0.252,0.256Z",
      transform: "translate(-984 -695)"
    })
  );
};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowBreadCrumbsRightIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowBreadCrumbsRightIcon = exports.ArrowBreadCrumbsRightIcon = function ArrowBreadCrumbsRightIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "6",
      height: "11",
      viewBox: "0 0 6 11",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M1016.01,700.757l-5.16,5.251-0.86-.876,4.55-4.632-4.55-4.632,0.86-.876,5.16,5.252-0.25.256Z",
      transform: "translate(-1010 -695)"
    })
  );
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowDownIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowDownIcon = exports.ArrowDownIcon = function ArrowDownIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "11",
      height: "6",
      viewBox: "0 0 11 6",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M846.007,697.852l-5.251,5.156-0.256-.252-0.256.252-5.252-5.156,0.876-.859,4.632,4.548,4.632-4.548Z",
      transform: "translate(-835 -697)"
    })
  );
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowLeftIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeftIcon = exports.ArrowLeftIcon = function ArrowLeftIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "6",
      height: "11",
      viewBox: "0 0 6 11",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M983.993,700.757l5.155,5.251,0.859-.876-4.548-4.632,4.548-4.632-0.859-.876-5.155,5.252L984,700Z",
      transform: "translate(-984 -695)"
    })
  );
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowRightIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowRightIcon = exports.ArrowRightIcon = function ArrowRightIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "6",
      height: "11",
      viewBox: "0 0 6 11",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M1016.01,700.757l-5.16,5.251-0.86-.876,4.55-4.632-4.55-4.632,0.86-.876,5.16,5.252L1016,700Z",
      transform: "translate(-1010 -695)"
    })
  );
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowUpIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowUpIcon = exports.ArrowUpIcon = function ArrowUpIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "10",
      height: "6.031",
      viewBox: "0 0 10 6.031",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M7647.49,711.217l-4.32,4.552a0.781,0.781,0,0,0,0,1.049,0.685,0.685,0,0,0,1,0l3.81-4.028,3.82,4.028a0.674,0.674,0,0,0,.99,0,0.76,0.76,0,0,0,0-1.049l-4.31-4.552a0.692,0.692,0,0,0-.5-0.217A0.655,0.655,0,0,0,7647.49,711.217Z",
      transform: "translate(-7643 -711)"
    })
  );
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockIcon = exports.BlockIcon = function BlockIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16.594",
      height: "17.594",
      viewBox: "0 0 16.594 17.594",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M367.4,704.6a4.2,4.2,0,1,1,4.2-4.2A4.2,4.2,0,0,1,367.4,704.6Zm2.1-4.6h-4a0.5,0.5,0,0,0,0,1h4A0.5,0.5,0,0,0,369.5,700Zm-2.373-4.912A5.912,5.912,0,0,0,362.366,703L357,703c-1.663,0-2-.633-2-2,0-3.29,1.985-5.061,4.645-6.344a4.571,4.571,0,1,1,6.712,0A8.583,8.583,0,0,1,367.127,695.088Z",
      transform: "translate(-355 -687)"
    })
  );
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CameraIcon = exports.CameraIcon = function CameraIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "19",
      height: "16",
      viewBox: "0 0 19 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M528,388H513a2,2,0,0,1-2-2V376a2,2,0,0,1,2-2h3a2,2,0,0,1,2-2h5a2,2,0,0,1,2,2h3a2,2,0,0,1,2,2v10A2,2,0,0,1,528,388Zm-7.5-11a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,520.5,377Zm0,6a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,520.5,383Z",
      transform: "translate(-511 -372)"
    })
  );
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckMarkIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckMarkIcon = exports.CheckMarkIcon = function CheckMarkIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "6",
      viewBox: "0 0 8 6",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M168.152,92.718a0.836,0.836,0,0,0,.335.555l2.8,2.038a0.871,0.871,0,0,0,1.2-.165l3.533-4.556a0.827,0.827,0,0,0-.166-1.176,0.87,0.87,0,0,0-1.2.161l-3.017,3.892-2.115-1.539a0.869,0.869,0,0,0-1.2.17A0.818,0.818,0,0,0,168.152,92.718Z",
      transform: "translate(-168.156 -89.219)"
    })
  );
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CommentIcon = function CommentIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ['title']);

  return _react2.default.createElement(
    'svg',
    _extends({ xmlns: 'http://www.w3.org/2000/svg', width: '17', height: '15', viewBox: '0 0 17 15', fill: 'none', role: 'img' }, props),
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement('path', {
      d: 'M9.48,11.45l-4,2.88a0.84,0.84,0,0,1-1.34-.65V11.45H2.22A1.7,1.7,0,0,1,.5,9.79V2.17A1.7,1.7,0,0,1,2.22.5H14.78A1.7,1.7,0,0,1,16.5,2.17V9.79a1.7,1.7,0,0,1-1.72,1.67H9.48Z',
      transform: 'translate(0 0)'
    })
  );
};

exports.CommentIcon = CommentIcon;
CommentIcon.propTypes = {
  title: _propTypes2.default.string
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CrownIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CrownIcon = exports.CrownIcon = function CrownIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M619.07,810.985H560.931c-5.613,0-8.944-2.913-8.944-9.2V760.472c0-4.707,1.577-5.947,5.049-.367,2.943,4.733,6.972,11.356,11.141,18.25,6.179-7.158,13.244-15.31,19.587-22.549,1.064-1.212,3.629-.962,4.47,0,5.464,6.222,12.843,14.741,19.484,22.445,4.108-6.776,8.134-13.317,11.249-18.146,3.559-5.517,5.047-4.34,5.047.367v41.316C628.014,807.6,624.685,810.985,619.07,810.985Z",
      transform: "translate(-550 -743)"
    })
  );
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteIcon = exports.DeleteIcon = function DeleteIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "15",
      viewBox: "0 0 13 15",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M526,537v9a2,2,0,0,1-2,2h-7a2,2,0,0,1-2-2v-9a1,1,0,0,1,0-2h3v-2h5v2h3A1,1,0,0,1,526,537Zm-4-3h-3v1h3v-1Zm-4.5,4a0.5,0.5,0,0,1,.5.5v6a0.5,0.5,0,0,1-1,0v-6A0.5,0.5,0,0,1,517.5,538Zm3,0a0.5,0.5,0,0,1,.5.5v6a0.5,0.5,0,0,1-1,0v-6A0.5,0.5,0,0,1,520.5,538Zm3,0a0.5,0.5,0,0,1,.5.5v6a0.5,0.5,0,0,1-1,0v-6A0.5,0.5,0,0,1,523.5,538Z",
      transform: "translate(-514 -533)"
    })
  );
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscardIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscardIcon = exports.DiscardIcon = function DiscardIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      viewBox: "0 0 16 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", { d: "M11.23,0H4.68L0,4.71v6.67L4.68,16h6.63L16,11.29V4.71Zm.59,10.75L10.57,12,8,9.38,5.35,12,4.1,10.75,6.71,8.13,4.1,5.52,5.35,4.27,8,6.88l2.61-2.61,1.25,1.25L9.21,8.13Z" })
  );
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DragIcon = exports.DragIcon = function DragIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "11",
      viewBox: "0 0 8 11",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("rect", { width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { x: "3", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { x: "6.01", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { y: "3", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { x: "3", y: "3", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { x: "6.01", y: "3", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { y: "6", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { x: "3", y: "6", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { x: "6.01", y: "6", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { y: "9.01", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { x: "3", y: "9.01", width: "1.99", height: "1.99", fill: "#6595ce" }),
    _react2.default.createElement("rect", { x: "6.01", y: "9.01", width: "1.99", height: "1.99", fill: "#6595ce" })
  );
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditIcon = exports.EditIcon = function EditIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "15.969",
      viewBox: "0 0 16 15.969",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M847.669,535.445l-1.553,1.546L843,533.87l1.553-1.546a1.1,1.1,0,0,1,1.561,0l1.56,1.561A1.1,1.1,0,0,1,847.669,535.445ZM835,548h-3v-3l10-10,3,3Z",
      transform: "translate(-832 -532.031)"
    })
  );
};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmojiIcon = exports.EmojiIcon = function EmojiIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "17",
      viewBox: "0 0 17 17",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M680.5,389a8.5,8.5,0,1,1,8.5-8.5A8.5,8.5,0,0,1,680.5,389Zm0-15.937a7.437,7.437,0,1,0,7.437,7.437A7.437,7.437,0,0,0,680.5,373.063ZM681,386h-1a3,3,0,0,1-3-3v-1h7v1A3,3,0,0,1,681,386Zm-3-3a2,2,0,0,0,2,2h1c1.727,0,2-2,2-2h-5Zm4.5-3a0.5,0.5,0,0,1-.5-0.5v-2a0.5,0.5,0,0,1,1,0v2A0.5,0.5,0,0,1,682.5,380Zm-4,0a0.5,0.5,0,0,1-.5-0.5v-2a0.5,0.5,0,0,1,1,0v2A0.5,0.5,0,0,1,678.5,380Z",
      transform: "translate(-672 -372)"
    })
  );
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EyeIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EyeIcon = exports.EyeIcon = function EyeIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "18px",
      height: "15px",
      viewBox: "0 0 18 15",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement(
      "g",
      { transform: "translate(-134.000000, -16.000000)", stroke: "none", strokeWidth: "1", fillRule: "evenodd", fill: "#345572" },
      _react2.default.createElement(
        "g",
        null,
        _react2.default.createElement(
          "g",
          null,
          _react2.default.createElement(
            "g",
            { transform: "translate(133.000000, 16.000000)" },
            _react2.default.createElement(
              "g",
              null,
              _react2.default.createElement("path", { d: "M18,7.75 L18.08,7.56 L18,7.37 C17.9,7.12 15.36,1.29 9.54,1.29 C8.0431704,1.2821901 6.57417316,1.69447942 5.3,2.48 L2.82,0 L2.25,0.57 L4.61,2.93 C3.08829914,4.09783171 1.87339776,5.61817439 1.07,7.36 L0.99,7.55 L1.07,7.74 C1.17,7.99 3.71,13.82 9.53,13.82 C11.1628819,13.8256458 12.7593463,13.3376436 14.11,12.42 L16.25,14.56 L16.82,13.99 L14.77,11.94 C16.1484163,10.8043497 17.2525505,9.37205188 18,7.75 L18,7.75 Z M9.54,12.83 C4.95,12.83 2.54,8.53 2.09,7.56 C2.85191213,6.02273622 3.96533126,4.68663327 5.34,3.66 L7.28,5.6 C6.35068816,6.79425986 6.45629256,8.49367141 7.52631058,9.56368942 C8.59632859,10.6337074 10.2957401,10.7393118 11.49,9.81 L13.37,11.69 C12.2300025,12.4314377 10.899896,12.8273441 9.54,12.83 L9.54,12.83 Z M11.3,8.48 L8.61,5.79 C8.89291588,5.63720948 9.20849962,5.55488329 9.53,5.55 C10.6345695,5.55 11.53,6.4454305 11.53,7.55 C11.5298084,7.87405532 11.4508774,8.19321105 11.3,8.48 L11.3,8.48 Z M10.79,9.1 C10.4367808,9.38804966 9.99576999,9.54681354 9.54,9.55 C8.4354305,9.55 7.54,8.6545695 7.54,7.55 C7.54318646,7.09423001 7.70195034,6.65321923 7.99,6.3 L10.79,9.1 Z M14.04,11.22 L12.04,9.22 C12.8326969,8.03017619 12.6756193,6.4462853 11.664667,5.43533299 C10.6537147,4.42438068 9.06982381,4.26730306 7.88,5.06 L6.04,3.22 C7.1039235,2.60486054 8.31104543,2.28066208 9.54,2.28 C14.13,2.28 16.54,6.58 16.99,7.55 C16.2804385,8.97022273 15.2744745,10.22171 14.04,11.22 L14.04,11.22 Z" })
            )
          )
        )
      )
    )
  );
};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookIcon = exports.FacebookIcon = function FacebookIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "8.12",
      height: "16",
      viewBox: "0 0 8.12 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M2535.93,890.5v-7h-2v-3h2v-2.527c0-1.815,1.41-3.481,4.12-3.481a20.191,20.191,0,0,1,2.02.105v2.524s-0.97-.008-1.87-0.008a1.062,1.062,0,0,0-1.27,1.2V880.5h3v3h-3v7h-3Z",
      transform: "translate(-2533.94 -874.5)"
    })
  );
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowMemberIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FollowMemberIcon = exports.FollowMemberIcon = function FollowMemberIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", { d: "M14,14.09 L14,16.09 L12,16.09 L12,14.09 L10,14.09 L10,12.09 L12,12.09 L12,10.09 L14,10.09 L14,12.09 L16,12.09 L16,14.09 L14,14.09 Z M9,15.09 L11,15.09 L11,16.23 C10.768,16.29 10.536,16.35 10.3,16.39 C7.80460277,17.0100155 5.19539723,17.0100155 2.7,16.39 C2.05281138,16.2719791 1.41709112,16.0979925 0.8,15.87 C0.3,15.69 5.75601984e-14,15.62 5.75601984e-14,15.04 C-0.000151022392,14.2833085 0.100740541,13.5299848 0.3,12.8 C0.299276605,11.7640966 0.69252171,10.7666841 1.4,10.01 C1.90946697,9.73868565 2.44565985,9.52085729 3,9.36 C3.2438677,9.28231226 3.47857709,9.17836953 3.7,9.05 C4.43300606,9.81045069 5.44378831,10.2400519 6.5,10.2400519 C7.55621169,10.2400519 8.56699394,9.81045069 9.3,9.05 C9.52142291,9.17836953 9.7561323,9.28231226 10,9.36 C10.3404994,9.46302577 10.6744445,9.58658544 11,9.73 L11,11.09 L9,11.09 L9,15.09 L9,15.09 Z M6.5,9.44 C4.1,9.44 3.2,7.09 3,5.16 C2.7,2.79 3.9,0.99 6.5,0.99 C9.1,0.99 10.3,2.79 10,5.16 C9.8,7.09 8.9,9.44 6.5,9.44 Z" })
  );
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowingIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FollowingIcon = exports.FollowingIcon = function FollowingIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", { d: "M13.121,13.8 L11.707,15.21 L8.879,12.38 L10.293,10.97 L11.5,12.18 L14.121,9.55 L15.536,10.97 L16,11.09 L13.121,13.8 Z M6.5,9.44 C4.1,9.44 3.2,7.09 3,5.16 C2.7,2.79 3.9,0.99 6.5,0.99 C9.1,0.99 10.3,2.79 10,5.16 C9.8,7.09 8.9,9.44 6.5,9.44 L6.5,9.44 Z M3.7,9.05 C4.43300606,9.81045069 5.44378831,10.2400519 6.5,10.2400519 C7.55621169,10.2400519 8.56699394,9.81045069 9.3,9.05 C9.52142291,9.17836953 9.7561323,9.28231226 10,9.36 L10,10.09 L8,10.09 L8,14.09 L9,14.09 L9,15.09 L10,15.09 L10,16.09 L11,16.09 L11,16.23 C10.768,16.29 10.536,16.35 10.3,16.39 C7.80460277,17.0100155 5.19539723,17.0100155 2.7,16.39 C2.05281138,16.2719791 1.41709112,16.0979925 0.8,15.87 C0.3,15.69 5.76238718e-14,15.62 5.76238718e-14,15.04 C-0.000151022392,14.2833085 0.100740541,13.5299848 0.3,12.8 C0.299276605,11.7640966 0.69252171,10.7666841 1.4,10.01 C1.90946697,9.73868565 2.44565985,9.52085729 3,9.36 C3.2438677,9.28231226 3.47857709,9.17836953 3.7,9.05 Z" })
  );
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FontIcon = exports.FontIcon = function FontIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "10.812",
      height: "13",
      viewBox: "0 0 10.812 13",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M845.033,853.713H834.486v3.078h1.045a0.4,0.4,0,0,0,.417-0.342c0.018-.108.052-0.36,0.089-0.756h2.65v9.255c-0.218.036-.4,0.072-0.522,0.09s-0.219.054-.272,0.054a0.678,0.678,0,0,0-.108.018,0.516,0.516,0,0,0-.45.558v1.062h5.156v-1.062a0.532,0.532,0,0,0-.469-0.558,0.635,0.635,0,0,0-.109-0.018c-0.054,0-.142-0.036-0.27-0.054s-0.307-.054-0.522-0.09v-9.237h2.649c0.037,0.4.073,0.63,0.091,0.738a0.413,0.413,0,0,0,.432.342h1.028v-3.078h-0.288Z",
      transform: "translate(-834.5 -853.719)"
    })
  );
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GPlusIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GPlusIcon = exports.GPlusIcon = function GPlusIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "15.88",
      height: "14",
      viewBox: "0 0 15.88 14",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M2686.95,879.5h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2Zm-8.66,3.947-0.67-.513a1.01,1.01,0,0,1-.47-0.79,1.283,1.283,0,0,1,.51-0.9c0.77-.607,1.54-1.076,1.54-2.436,0-1.4-.88-2.307-1.3-2.307h1.14l1.18-1h-3.79a5.015,5.015,0,0,0-3.29,1.006,3.3,3.3,0,0,0-1.17,2.461,2.9,2.9,0,0,0,3.05,2.883c0.18,0,.38-0.019.58-0.038a1.678,1.678,0,0,0-.18.718,1.92,1.92,0,0,0,.55,1.249,7.9,7.9,0,0,0-3.51.845,2.648,2.648,0,0,0-1.41,2.242c0,1.359,1.28,2.626,3.95,2.626,3.16,0,4.83-1.745,4.83-3.472A3.193,3.193,0,0,0,2678.29,883.451Zm-2.41-2.112c-1.58,0-2.3-2.04-2.3-3.271a2.08,2.08,0,0,1,.41-1.359,1.7,1.7,0,0,1,1.28-.607c1.53,0,2.32,2.058,2.32,3.381a1.872,1.872,0,0,1-.46,1.342A1.9,1.9,0,0,1,2675.88,881.339Zm0.02,7.385c-1.97,0-3.24-.936-3.24-2.241a2.07,2.07,0,0,1,1.58-1.892,7.461,7.461,0,0,1,1.93-.295,2.967,2.967,0,0,1,.43.019c1.39,0.993,2,1.488,2,2.426C2678.6,887.879,2677.66,888.724,2675.9,888.724Z",
      transform: "translate(-2671.06 -875.5)"
    })
  );
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeIcon = exports.HomeIcon = function HomeIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "15.969",
      viewBox: "0 0 14 15.969",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M366.969,379v8a1,1,0,0,1-1,1h-2.993a1,1,0,0,1-1-1v-3a2,2,0,1,0-3.991,0v3a1,1,0,0,1-1,1H354a1,1,0,0,1-1-1v-9h0v0s3.8-3.484,5.771-5.376a1.51,1.51,0,0,1,2.4-.021c2.071,1.786,5.809,5.4,5.809,5.4Z",
      transform: "translate(-353 -372.031)"
    })
  );
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LikeHollowIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LikeHollowIcon = function LikeHollowIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ['title']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '16',
      viewBox: '0 0 17 15',
      fill: 'none',
      style: {
        fillRule: 'evenodd'
      },
      role: 'img'
    }, props),
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement('path', {
      d: 'M350,217.365a4.312,4.312,0,0,0-8-2.28,4.309,4.309,0,0,0-8,2.28,4.375,4.375,0,0,0,1.487,3.286l6.12,6.184A0.567,0.567,0,0,0,342,227a0.553,0.553,0,0,0,.4-0.165l6.12-6.184A4.375,4.375,0,0,0,350,217.365Z',
      transform: 'translate(-333.5 -212.5)'
    })
  );
};

exports.LikeHollowIcon = LikeHollowIcon;
LikeHollowIcon.propTypes = {
  title: _propTypes2.default.string
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LikeIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LikeIcon = exports.LikeIcon = function LikeIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "14",
      viewBox: "0 0 16 14",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M386,217.365a4.312,4.312,0,0,0-8-2.28,4.309,4.309,0,0,0-8,2.28,4.375,4.375,0,0,0,1.487,3.286l6.12,6.184A0.567,0.567,0,0,0,378,227a0.553,0.553,0,0,0,.4-0.165l6.12-6.184A4.375,4.375,0,0,0,386,217.365Z",
      transform: "translate(-370 -213)"
    })
  );
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkIcon = exports.LinkIcon = function LinkIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16.036",
      height: "16",
      viewBox: "0 0 16.036 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M1006.6,859.239l-3,3.006a4.218,4.218,0,0,1-6.671-.857l1.4-1.4a1.1,1.1,0,0,1,.228-0.151,2.088,2.088,0,0,0,.526.9,2.131,2.131,0,0,0,3.009,0l3.01-3.006a2.127,2.127,0,1,0-3.01-3.006l-1.07,1.07a5.336,5.336,0,0,0-2.714-.295l2.284-2.279A4.251,4.251,0,0,1,1006.6,859.239Zm-7.951,4.943-1.071,1.07a2.128,2.128,0,0,1-3.011-3.007l3.011-3.006a2.135,2.135,0,0,1,3.012,0,2.218,2.218,0,0,1,.52.9,1.056,1.056,0,0,0,.23-0.15l1.4-1.4a4.321,4.321,0,0,0-.65-0.858,4.262,4.262,0,0,0-6.019,0l-3.01,3.006a4.254,4.254,0,0,0,6.02,6.013l2.279-2.279A5.33,5.33,0,0,1,998.649,864.182Z",
      transform: "translate(-991.844 -852)"
    })
  );
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LockIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LockIcon = function LockIcon(_ref) {
  var isLocked = _ref.isLocked,
      props = _objectWithoutProperties(_ref, ['isLocked']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '13',
      height: '16',
      viewBox: '0 0 13 16',
      style: {
        fillRule: 'evenodd'
      },
      className: (0, _classnames2.default)({
        'forum-secondary-fill-color': isLocked
      })
    }, props),
    _react2.default.createElement('path', {
      d: 'M206,388H195a1,1,0,0,1-1-1v-7a2,2,0,0,1,2-2v-1.5a4.5,4.5,0,0,1,9,0V378a2,2,0,0,1,2,2v7A1,1,0,0,1,206,388Zm-3-11.5a2.5,2.5,0,0,0-5,0V378h5v-1.5Z',
      transform: 'translate(-194 -372)'
    })
  );
};

exports.LockIcon = LockIcon;
LockIcon.propTypes = {
  isLocked: _propTypes2.default.bool
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoutIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoutIcon = exports.LogoutIcon = function LogoutIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "20.656",
      height: "16",
      viewBox: "0 0 20.656 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M692,700.657l-1.456-1.456,3.395-3.2H684.5a0.5,0.5,0,0,1-.5-0.5v-1a0.5,0.5,0,0,1,.5-0.5h9.439l-3.395-3.2L692,689.343,697.657,695ZM687,689h-8v12h8v-4h2v5a1,1,0,0,1-1,1H678a1,1,0,0,1-1-1V688a1,1,0,0,1,1-1h10a1,1,0,0,1,1,1v5h-2v-4Z",
      transform: "translate(-677 -687)"
    })
  );
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemberIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberIcon = exports.MemberIcon = function MemberIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "18px",
      height: "16px",
      viewBox: "0 0 18 16",
      style: {
        fillRule: 'nonzero'
      }
    }, props),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "M11.3392723,1.65337453 C10.9892943,1.65337453 10.6551668,1.72273111 10.3488047,1.84751299 C10.8949731,2.53063719 11.2226579,3.39942113 11.2226579,4.34432282 C11.2226579,5.28922451 10.8949461,6.15798118 10.3488047,6.84113265 C10.6551668,6.96591453 10.9892943,7.03527111 11.3392723,7.03527111 C12.8064141,7.03527111 14,5.82815572 14,4.34435008 C14,2.86054444 12.8064141,1.65337453 11.3392723,1.65337453 Z" }),
      _react2.default.createElement("path", { d: "M11.6405508,8.71306667 C11.5111055,8.71306667 11.3818711,8.71719111 11.252918,8.72519111 C13.1523047,10.2095289 14.3778867,12.5349333 14.3778867,15.1447467 C14.3778867,15.4388267 14.3272969,15.7210667 14.2352227,15.9836444 L17.1705234,15.9836444 C17.6286094,15.9836444 18,15.6080356 18,15.1447467 C18,11.5983289 15.1471406,8.71306667 11.6405508,8.71306667 Z" }),
      _react2.default.createElement("path", { d: "M9,1.25255111 C8.36300391,0.496924444 7.41592969,0.01632 6.35944922,0.01632 C4.44603516,0.01632 2.88938672,1.59061333 2.88938672,3.52579556 C2.88938672,5.46097778 4.446,7.03523556 6.35944922,7.03523556 C7.41596484,7.03523556 8.36300391,6.55466667 9,5.79900444 C9.51662109,5.18609778 9.82947656,4.39249778 9.82947656,3.52576 C9.82947656,2.65902222 9.51662109,1.86545778 9,1.25255111 Z" }),
      _react2.default.createElement("path", { d: "M8.99873438,9.29372444 C8.19435938,8.92113778 7.30054687,8.71306667 6.35944922,8.71306667 C2.85285937,8.71306667 0,11.5983289 0,15.1447467 C0,15.6080356 0.371390625,15.9836444 0.829476563,15.9836444 L11.8893867,15.9836444 L11.889457,15.9836444 C12.347543,15.9835733 12.7188984,15.6079644 12.7188984,15.1447467 C12.7188984,12.5500089 11.1916758,10.3095467 8.99873438,9.29372444 Z" })
    )
  );
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuIcon = exports.MenuIcon = function MenuIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ width: "19", viewBox: "0 0 19 19" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "nonzero" },
      _react2.default.createElement("path", { d: "M3.2,5 L15.8,5 C15.9104569,5 16,5.08954305 16,5.2 L16,5.8 C16,5.91045695 15.9104569,6 15.8,6 L3.2,6 C3.08954305,6 3,5.91045695 3,5.8 L3,5.2 L3,5.2 C3,5.08954305 3.08954305,5 3.2,5 L3.2,5 Z M3.2,13 L15.8,13 C15.9104569,13 16,13.0895431 16,13.2 L16,13.8 C16,13.9104569 15.9104569,14 15.8,14 L3.2,14 C3.08954305,14 3,13.9104569 3,13.8 L3,13.2 C3,13.0895431 3.08954305,13 3.2,13 L3.2,13 Z M3.2,9 L15.8,9 C15.9104569,9 16,9.08954305 16,9.2 L16,9.8 C16,9.91045695 15.9104569,10 15.8,10 L3.2,10 C3.08954305,10 3,9.91045695 3,9.8 L3,9.2 C3,9.08954305 3.08954305,9 3.2,9 L3.2,9 Z" })
    )
  );
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MinusIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MinusIcon = exports.MinusIcon = function MinusIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "2",
      viewBox: "0 0 8 2",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("rect", { width: "8", height: "2" })
  );
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModeratorIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModeratorIcon = exports.ModeratorIcon = function ModeratorIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M728.241,771.059L707.584,769a3.6,3.6,0,0,1-2.96-2.305l-7.4-18.876a3.478,3.478,0,0,0-6.57,0L683.316,766.7a3.523,3.523,0,0,1-2.96,2.305L659.7,771.059c-3.078.312-4.321,4.361-2.013,6.541l15.567,14.39a3.846,3.846,0,0,1,1.125,3.676L669.7,815.849c-0.711,3.177,2.545,5.794,5.268,4.112l17.224-10.653a3.429,3.429,0,0,1,3.611,0l17.224,10.653c2.723,1.682,5.978-.872,5.268-4.112l-4.617-20.183a3.846,3.846,0,0,1,1.125-3.676l15.567-14.39A3.853,3.853,0,0,0,728.241,771.059Z",
      transform: "translate(-654 -743)"
    })
  );
};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModeratorSmallIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModeratorSmallIcon = exports.ModeratorSmallIcon = function ModeratorSmallIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "19",
      viewBox: "0 0 19 19",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", { d: "M9.38865493,13.0966675 L5.99777689,15.3695159 L5.99777689,15.3695159 C5.81427229,15.492516 5.56580117,15.4434673 5.44280113,15.2599627 C5.37531373,15.1592778 5.35712143,15.0334221 5.39333431,14.9177474 L6.61881162,11.00321 L3.26052421,8.54484297 L3.26052421,8.54484297 C3.0822674,8.41435365 3.04354421,8.16406547 3.17403353,7.98580866 C3.24768718,7.88519303 3.36404913,7.82468064 3.48871678,7.82216208 L7.71933169,7.73669425 L9.12378621,3.84718484 L9.12378621,3.84718484 C9.19881412,3.63940187 9.42807763,3.53178262 9.63586061,3.60681052 C9.74774042,3.64720896 9.83583649,3.73530503 9.87623493,3.84718484 L11.2806895,7.73669425 L15.5113044,7.82216208 L15.5113044,7.82216208 C15.7321732,7.82662412 15.9076056,8.00929089 15.9031435,8.23015972 C15.900625,8.35482737 15.8401126,8.47118932 15.7394969,8.54484297 L12.3812095,11.00321 L13.6066868,14.9177474 L13.6066868,14.9177474 C13.6726871,15.1285718 13.5552839,15.3529825 13.3444596,15.4189828 C13.2287849,15.4551956 13.1029292,15.4370033 13.0022442,15.3695159 L9.61136621,13.0966675 L9.61136621,13.0966675 C9.54399616,13.0515105 9.45602499,13.0515105 9.38865493,13.0966675 Z" })
  );
};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoreIcon = exports.MoreIcon = function MoreIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "4",
      height: "15.406",
      viewBox: "0 0 4 15.406",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M1000,381.719a1.928,1.928,0,1,1,2-1.927A1.964,1.964,0,0,1,1000,381.719Zm0-5.78a1.928,1.928,0,1,1,2-1.927A1.964,1.964,0,0,1,1000,375.939Zm0,7.706a1.928,1.928,0,1,1-2,1.927A1.968,1.968,0,0,1,1000,383.645Z",
      transform: "translate(-998 -372.094)"
    })
  );
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoveIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoveIcon = exports.MoveIcon = function MoveIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "17.66",
      height: "16",
      viewBox: "0 0 17.66 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M1003,545.657l-1.46-1.456,3.4-3.2H995.5a0.5,0.5,0,0,1-.5-0.5v-1a0.5,0.5,0,0,1,.5-0.5h9.44l-3.4-3.2,1.46-1.456,5.66,5.657ZM998,534h-5v12h5a1,1,0,0,1,0,2h-6a1,1,0,0,1-1-1V533a1,1,0,0,1,1-1h6A1,1,0,0,1,998,534Z",
      transform: "translate(-991 -532)"
    })
  );
};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationIcon = exports.NotificationIcon = function NotificationIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "16",
      viewBox: "0 0 12 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M845,225H835a0.858,0.858,0,0,1-1-1v-1a1.07,1.07,0,0,1,1-1v-4a5.207,5.207,0,0,1,4-5,1.023,1.023,0,0,1,1-1.007A1.013,1.013,0,0,1,841,213a5.205,5.205,0,0,1,4,5v4a1.044,1.044,0,0,1,1,1v1A0.89,0.89,0,0,1,845,225Zm-5,3a2.02,2.02,0,0,1-2-2h4A2.02,2.02,0,0,1,840,228Z",
      transform: "translate(-834 -212)"
    })
  );
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OwnerSmallIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OwnerSmallIcon = exports.OwnerSmallIcon = function OwnerSmallIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "19",
      viewBox: "0 0 19 19",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", { d: "M15.3812,6.495914 L12.6789333,8.77258837 C12.6191333,8.84477644 12.5099333,8.85722265 12.4354,8.79997005 C12.4215333,8.79001308 12.4094,8.77756686 12.3998667,8.76429089 L9.78686667,6.14327115 C9.67766667,5.99225704 9.46186667,5.95491839 9.305,6.05863687 C9.26946667,6.08186981 9.23913333,6.11091099 9.21573333,6.14493065 L6.60013333,8.81075677 C6.5464,8.88626383 6.43893333,8.90534803 6.3592,8.85390366 C6.34446667,8.84394669 6.33146667,8.83233022 6.32106667,8.81905425 L3.61966667,6.50587098 C3.5018,6.36149485 3.28426667,6.33577266 3.13346667,6.44861837 C3.0494,6.51167921 3,6.60792997 3,6.70998895 L4,14 L15,14 L16,6.70169148 C16,6.51831719 15.8448667,6.36979232 15.6533333,6.36979232 C15.5476,6.36979232 15.4470667,6.41625821 15.3812,6.495914 Z" })
  );
};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PinIcon = function PinIcon(_ref) {
  var isPinned = _ref.isPinned,
      props = _objectWithoutProperties(_ref, ['isPinned']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '10',
      height: '16',
      viewBox: '0 0 10 16',
      style: {
        fillRule: 'evenodd'
      },
      className: (0, _classnames2.default)({
        'forum-secondary-fill-color': isPinned
      })
    }, props),
    _react2.default.createElement('path', {
      d: 'M1003,212h-6a2.18,2.18,0,0,0-2,2v13a1,1,0,0,0,1,1l4-3.465,4,3.465a1.016,1.016,0,0,0,1-1V214A1.976,1.976,0,0,0,1003,212Z',
      transform: 'translate(-995 -212)'
    })
  );
};

exports.PinIcon = PinIcon;
PinIcon.propTypes = {
  isPinned: _propTypes2.default.bool
};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayArrow = exports.PlayArrow = function PlayArrow(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30" }, props),
    _react2.default.createElement("polygon", { style: { fill: '#fff' }, points: "11 9 11 21 21 14.88 11 9" })
  );
};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayIcon = exports.PlayIcon = function PlayIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30" }, props),
    _react2.default.createElement("circle", { style: { fill: '#1a1a1a' }, cx: "15", cy: "15", r: "15" }),
    _react2.default.createElement("polygon", { style: { fill: '#fff' }, points: "11 9 11 21 21 14.88 11 9" })
  );
};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileIcon = exports.ProfileIcon = function ProfileIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "16",
      viewBox: "0 0 13 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M17703.5,1158.52c2.4,0,3.3-2.37,3.5-4.32,0.3-2.39-.9-4.2-3.5-4.2s-3.8,1.81-3.5,4.2C17700.2,1156.15,17701.1,1158.52,17703.5,1158.52Zm6.5,5.65a8.662,8.662,0,0,0-.3-2.26c-0.1-.9-0.3-2.22-1.1-2.81a8.328,8.328,0,0,0-1.6-.66,3.313,3.313,0,0,1-.7-0.31,3.867,3.867,0,0,1-5.6,0,3.313,3.313,0,0,1-.7.31,8.328,8.328,0,0,0-1.6.66c-0.8.59-1,1.91-1.1,2.81a8.662,8.662,0,0,0-.3,2.26c0,0.58.3,0.66,0.8,0.84a11.438,11.438,0,0,0,1.9.52,15.6,15.6,0,0,0,7.6,0,11.438,11.438,0,0,0,1.9-.52C17709.7,1164.83,17710,1164.75,17710,1164.17Z",
      transform: "translate(-17697 -1150)"
    })
  );
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportIcon = exports.ReportIcon = function ReportIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M680,549a9,9,0,1,1,9-9A9,9,0,0,1,680,549Zm1-12a1,1,0,0,0-2,0v4a1,1,0,0,0,2,0v-4Zm-1,6a1,1,0,1,0,1,1A1,1,0,0,0,680,543Z",
      transform: "translate(-671 -531)"
    })
  );
};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchIcon = exports.SearchIcon = function SearchIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "15.344",
      height: "16.344",
      viewBox: "0 0 15.344 16.344",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M842.936,383.229l4.392,4.392-0.707.707-4.46-4.46A6.708,6.708,0,1,1,842.936,383.229ZM838.5,373a5.5,5.5,0,1,0,5.5,5.5A5.5,5.5,0,0,0,838.5,373Z",
      transform: "translate(-832 -372)"
    })
  );
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryEditIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecondaryEditIcon = exports.SecondaryEditIcon = function SecondaryEditIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M2904,333v-1h0.14l0.59-2.654,2.62,2.654H2918v1h-14Zm12.26-9.571-2.84-2.869,1.22-1.226a1.24,1.24,0,0,1,1.77,0l1.27,1.28a0.984,0.984,0,0,1,0,1.385Zm-7.93,8.009-2.84-2.869,7.19-7.263,2.84,2.869Z",
      transform: "translate(-2904 -318.969)"
    })
  );
};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsIcon = exports.SettingsIcon = function SettingsIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16.031",
      height: "16",
      viewBox: "0 0 16.031 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M527.949,694.112a0.52,0.52,0,0,0-.514-0.394,1.767,1.767,0,0,1-1.209-3.075,0.444,0.444,0,0,0,.049-0.6,7.957,7.957,0,0,0-1.268-1.28,0.446,0.446,0,0,0-.608.049,1.842,1.842,0,0,1-2,.448,1.775,1.775,0,0,1-1.08-1.736,0.445,0.445,0,0,0-.393-0.468,8.025,8.025,0,0,0-1.8,0,0.446,0.446,0,0,0-.4.458,1.779,1.779,0,0,1-1.1,1.707,1.849,1.849,0,0,1-1.981-.451,0.447,0.447,0,0,0-.6-0.051,7.915,7.915,0,0,0-1.294,1.28,0.444,0.444,0,0,0,.048.608,1.774,1.774,0,0,1,.447,2,1.85,1.85,0,0,1-1.741,1.082,0.435,0.435,0,0,0-.462.392,8.026,8.026,0,0,0,0,1.82,0.529,0.529,0,0,0,.524.393,1.753,1.753,0,0,1,1.646,1.1,1.78,1.78,0,0,1-.447,1.979,0.444,0.444,0,0,0-.049.6,7.908,7.908,0,0,0,1.266,1.281,0.445,0.445,0,0,0,.609-0.049,1.84,1.84,0,0,1,1.994-.448,1.774,1.774,0,0,1,1.082,1.736,0.445,0.445,0,0,0,.393.468,8.085,8.085,0,0,0,.921.053,7.847,7.847,0,0,0,.879-0.049,0.445,0.445,0,0,0,.4-0.458,1.778,1.778,0,0,1,1.094-1.706,1.846,1.846,0,0,1,1.981.451,0.447,0.447,0,0,0,.6.05,7.908,7.908,0,0,0,1.294-1.279,0.443,0.443,0,0,0-.048-0.608,1.767,1.767,0,0,1,1.189-3.08l0.1,0a0.445,0.445,0,0,0,.468-0.392A8.018,8.018,0,0,0,527.949,694.112Zm-7.936,3.573a2.669,2.669,0,1,1,2.668-2.668A2.671,2.671,0,0,1,520.013,697.685Z",
      transform: "translate(-512 -687)"
    })
  );
};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareIcon = exports.ShareIcon = function ShareIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "16",
      viewBox: "0 0 14 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M364.5,537a2.484,2.484,0,0,1-1.874-.861l-4.84,2.794-0.5-.866,4.847-2.8A2.493,2.493,0,1,1,364.5,537Zm-6.771,4.611,4.606,2.66A2.483,2.483,0,1,1,362,545.5c0-.087.017-0.169,0.025-0.253L357.1,542.4a2.474,2.474,0,0,1-1.6.6,2.5,2.5,0,1,1,2.5-2.5A2.473,2.473,0,0,1,357.729,541.611Z",
      transform: "translate(-353 -532)"
    })
  );
};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortIcon = exports.SortIcon = function SortIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16px",
      height: "15px",
      viewBox: "0 0 16 15",
      style: {
        fillRule: 'nonzero'
      }
    }, props),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "M3.88571429,14.5838608 L3.88571429,1.3306962 L6.28897959,3.65981013 C6.36734694,3.73575949 6.46857143,3.77373418 6.57306122,3.77373418 C6.67755102,3.77373418 6.77877551,3.73575949 6.85714286,3.65981013 C7.01387755,3.50791139 7.01387755,3.26424051 6.85714286,3.11234177 L3.77142857,0.121835443 C3.62122449,-0.0237341772 3.35673469,-0.0237341772 3.20653061,0.121835443 L0.11755102,3.11234177 C-0.0391836735,3.26424051 -0.0391836735,3.50791139 0.11755102,3.65981013 C0.274285714,3.81170886 0.525714286,3.81170886 0.68244898,3.65981013 L3.08571429,1.3306962 L3.08571429,14.5838608 C3.08571429,14.7990506 3.26530612,14.9731013 3.48734694,14.9731013 C3.70612245,14.9699367 3.88571429,14.7958861 3.88571429,14.5838608 Z" }),
      _react2.default.createElement("path", { d: "M12.2057143,14.8560127 C12.2840816,14.931962 12.3853061,14.9699367 12.4897959,14.9699367 C12.5942857,14.9699367 12.6955102,14.931962 12.7738776,14.8560127 L15.8595918,11.8655063 C16.0163265,11.7136076 16.0163265,11.4699367 15.8595918,11.318038 C15.7028571,11.1661392 15.4514286,11.1661392 15.2946939,11.318038 L12.8914286,13.6471519 L12.8914286,0.393987342 C12.8914286,0.178797468 12.7118367,0.00474683544 12.4897959,0.00474683544 C12.2677551,0.00474683544 12.0881633,0.178797468 12.0881633,0.393987342 L12.0881633,13.6471519 L9.68816327,11.318038 C9.53142857,11.1661392 9.28,11.1661392 9.12326531,11.318038 C8.96653061,11.4699367 8.96653061,11.7136076 9.12326531,11.8655063 L12.2057143,14.8560127 Z" })
    )
  );
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SubscribeIcon = function SubscribeIcon(_ref) {
  var isSubscribed = _ref.isSubscribed,
      props = _objectWithoutProperties(_ref, ['isSubscribed']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '16',
      height: '14',
      viewBox: '0 0 16 14',
      style: {
        fillRule: 'evenodd'
      },
      className: (0, _classnames2.default)({
        'forum-secondary-fill-color': isSubscribed
      })
    }, props),
    _react2.default.createElement('path', {
      'data-name': 'Rectangle 1 copy',
      d: 'M2893,526v-6h2v6h-2Zm0-14h2v6h-2v-6Zm-1.74,8.175-3.85,3.846-1.33-1.331,2.69-2.69H2879v-2h10.09l-2.77-2.768,1.41-1.414,4.95,4.95-1.41,1.414Z',
      transform: 'translate(-2879 -512)'
    })
  );
};

exports.SubscribeIcon = SubscribeIcon;
SubscribeIcon.propTypes = {
  isSubscribed: _propTypes2.default.bool
};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopCommentIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TopCommentIcon = function TopCommentIcon(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '12',
      height: '17',
      viewBox: '0 0 12 17',
      style: {
        fillRule: 'evenodd',
        fill: color
      }
    }, props),
    _react2.default.createElement('path', { d: 'M6,0 C2.6862915,-2.02906125e-16 4.05812251e-16,2.6862915 0,6 C-4.05812251e-16,9.3137085 2.6862915,12 6,12 C9.3137085,12 12,9.3137085 12,6 C12,4.40870106 11.367859,2.88257758 10.2426407,1.75735931 C9.11742242,0.632141042 7.59129894,9.74389576e-17 6,0 Z M9.94,5 L8.09,6.7 L8.53,9 C8.53886396,9.05951419 8.5113067,9.11856545 8.46,9.15 C8.42742052,9.16002564 8.39257948,9.16002564 8.36,9.15 L8.28,9.15 L6,8.1 L3.7,9.21 C3.64690295,9.23844491 3.58309705,9.23844491 3.53,9.21 C3.4932715,9.19101483 3.46600793,9.1577116 3.45464955,9.11795727 C3.44329117,9.07820295 3.44884533,9.03552322 3.47,9 L3.91,6.7 L2,5 C1.96652167,4.95192041 1.96652167,4.88807959 2,4.84 C2.02165446,4.78530252 2.07157805,4.74689975 2.13,4.74 L4.7,4.44 L5.85,2.31 C5.87954496,2.25460321 5.93721697,2.22 6,2.22 C6.06278303,2.22 6.12045504,2.25460321 6.15,2.31 L7.29,4.44 L9.85,4.78 C9.91060733,4.78742971 9.96331546,4.82507838 9.99,4.88 C9.99243292,4.92551947 9.97403463,4.96967535 9.94,5 Z', id: 'Shape' }),
    _react2.default.createElement('path', { d: 'M6,13 C4.56923057,12.9986614 3.17323082,12.5589215 2,11.74 L2,16.5 C1.99787124,16.6756399 2.08806353,16.839515 2.23758934,16.9316884 C2.38711515,17.0238619 2.57404123,17.0308132 2.73,16.95 L5.73,15.39 C5.87423031,15.3152793 6.04576969,15.3152793 6.19,15.39 L9.19,16.95 C9.34849903,17.0776976 9.56858666,17.096571 9.74651285,16.9977231 C9.92443903,16.8988752 10.0246872,16.7020376 10,16.5 L10,11.74 C8.82676918,12.5589215 7.43076943,12.9986614 6,13 L6,13 Z', id: 'Shape' })
  );
};

exports.TopCommentIcon = TopCommentIcon;
TopCommentIcon.propTypes = {
  color: _propTypes2.default.string
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwitterIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterIcon = exports.TwitterIcon = function TwitterIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "15",
      height: "12.188",
      viewBox: "0 0 15 12.188",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M2615.5,878.848a6.088,6.088,0,0,1-1.76.484,3.1,3.1,0,0,0,1.35-1.7,6.189,6.189,0,0,1-1.95.747,3.083,3.083,0,0,0-5.33,2.105,3.248,3.248,0,0,0,.08.7,8.732,8.732,0,0,1-6.34-3.216,3.016,3.016,0,0,0-.42,1.547,2.9,2.9,0,0,0,1.13,2.562,9.461,9.461,0,0,1-1.63-.385v0.039a3.3,3.3,0,0,0,2.71,3.017,2.234,2.234,0,0,1-.69.108,2.41,2.41,0,0,1-.52-0.055,3.107,3.107,0,0,0,2.9,2.137,6.112,6.112,0,0,1-3.81,1.317,5.875,5.875,0,0,1-.72-0.043,8.757,8.757,0,0,0,13.48-7.373c0-.133-0.01-0.266-0.01-0.4A6.214,6.214,0,0,0,2615.5,878.848Z",
      transform: "translate(-2600.5 -877.406)"
    })
  );
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoIcon = exports.VideoIcon = function VideoIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M17022,2428a8,8,0,1,0,8,8A8.011,8.011,0,0,0,17022,2428Zm2.8,8.42-4,2.5a0.674,0.674,0,0,1-.3.08,0.212,0.212,0,0,1-.2-0.06,0.477,0.477,0,0,1-.3-0.44v-5a0.533,0.533,0,0,1,.8-0.42l4,2.5A0.541,0.541,0,0,1,17024.8,2436.42Z",
      transform: "translate(-17014 -2428)"
    })
  );
};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewCountIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ViewCountIcon = function ViewCountIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ['title']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '19',
      height: '12',
      viewBox: '0 0 19 12',
      style: {
        fillRule: 'evenodd'
      },
      role: 'img'
    }, props),
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement('path', {
      d: 'M680.408,226c-3.162,0-6.216-1.708-9.079-5.079h0a1.464,1.464,0,0,1,0-1.889c1.259-1.51,4.674-5.024,9.188-5.045h0.04c3.162,0,6.216,1.708,9.079,5.079a1.465,1.465,0,0,1,0,1.889c-1.259,1.51-4.674,5.024-9.188,5.045h-0.039Zm-8.293-5.729c2.659,3.131,5.449,4.717,8.293,4.717h0.035c4.079-.018,7.233-3.276,8.4-4.675a0.463,0.463,0,0,0,.008-0.6c-2.659-3.131-5.448-4.718-8.293-4.718h-0.034c-4.079.019-7.234,3.277-8.4,4.676a0.464,0.464,0,0,0-.008.6h0Zm8.368,3.62a3.9,3.9,0,1,1,3.952-3.9A3.93,3.93,0,0,1,680.483,223.891Zm0-6.783a2.886,2.886,0,1,0,2.926,2.886A2.909,2.909,0,0,0,680.483,217.108Z',
      transform: 'translate(-671 -214)'
    })
  );
};

exports.ViewCountIcon = ViewCountIcon;
ViewCountIcon.propTypes = {
  title: _propTypes2.default.string
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XLarge = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XLarge = exports.XLarge = function XLarge(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      style: {
        fill: '#fff',
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M10976.4,1024.73l-14.3,14.28,13.9,13.92-0.7.74-14-13.92-14.2,14.25-0.8-.74,14.3-14.25-14.6-14.61,0.7-.74,14.6,14.61,14.3-14.28Z",
      transform: "translate(-10946.15 -1023.83)"
    })
  );
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XSmall = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XSmall = exports.XSmall = function XSmall(props) {
  return _react2.default.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      style: {
        fillRule: 'evenodd'
      }
    }, props),
    _react2.default.createElement("path", {
      d: "M1733.01,523.389L1725.39,531l7.61,7.607-0.39.394-7.61-7.607L1717.39,539l-0.39-.394,7.61-7.607-7.62-7.611,0.4-.395,7.61,7.611,7.61-7.611Z",
      transform: "translate(-1717 -523)"
    })
  );
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postForm = __webpack_require__(638);

var _postForm2 = _interopRequireDefault(_postForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postForm2.default;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(642);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(643);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (props) {
      return factory(propsMapper(props));
    };
  };
};

exports.default = (0, _createHelper2.default)(mapProps, 'mapProps');

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivateProfileActions = exports.default = undefined;

var _privateProfileActions = __webpack_require__(929);

Object.defineProperty(exports, 'PrivateProfileActions', {
  enumerable: true,
  get: function get() {
    return _privateProfileActions.PrivateProfileActions;
  }
});

var _privateProfileActions2 = _interopRequireDefault(_privateProfileActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _privateProfileActions2.default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _loginButton = __webpack_require__(944);

var _loginButton2 = _interopRequireDefault(_loginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loginButton2.default;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestLoginAction;

var _loginMember = __webpack_require__(264);

var _requestLogin = __webpack_require__(369);

var _requestLogin2 = _interopRequireDefault(_requestLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function requestLoginAction() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      (0, _requestLogin2.default)(function (response) {
        if (response) {
          dispatch((0, _loginMember.loginMember)(response)); // Needed because in some cases requestLogin does not reload an iframe
          resolve();
        } else {
          reject();
        }
      });
    });
  };
}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = preventClickInDemoMode;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _openModal = __webpack_require__(36);

var _modalTypes = __webpack_require__(26);

var _createHocName = __webpack_require__(41);

var _createHocName2 = _interopRequireDefault(_createHocName);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAME = 'PreventClickInDemoMode';

function preventClickInDemoMode(WrappedComponent) {
  var PreventClickInDemoMode = function (_Component) {
    _inherits(PreventClickInDemoMode, _Component);

    function PreventClickInDemoMode() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, PreventClickInDemoMode);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PreventClickInDemoMode.__proto__ || Object.getPrototypeOf(PreventClickInDemoMode)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
        var _this$props = _this.props,
            isDemoMode = _this$props.isDemoMode,
            viewMode = _this$props.viewMode,
            onClick = _this$props.onClick,
            openModal = _this$props.openModal;


        if (isDemoMode) {
          openModal(_modalTypes.MODAL_TYPE_DEMO_MODE, { viewMode: viewMode });
        } else {
          onClick && onClick(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PreventClickInDemoMode, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { onClick: this.handleClick }));
      }
    }]);

    return PreventClickInDemoMode;
  }(_react.Component);

  PreventClickInDemoMode.displayName = (0, _createHocName2.default)(NAME, WrappedComponent);


  PreventClickInDemoMode.propTypes = {
    isDemoMode: _propTypes2.default.bool.isRequired,
    viewMode: _propTypes2.default.string.isRequired,
    openModal: _propTypes2.default.func.isRequired,
    onClick: _propTypes2.default.func
  };

  (0, _hoistNonReactStatics2.default)(PreventClickInDemoMode, WrappedComponent);

  var mapStateToProps = function mapStateToProps(state) {
    return {
      viewMode: state.viewMode,
      isDemoMode: state.isDemoMode
    };
  };

  var mapDispatchToProps = {
    openModal: _openModal.openModal
  };

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withAuth2.default)(PreventClickInDemoMode));
}

/***/ }),
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _currentUser = __webpack_require__(583);

var _currentUser2 = _interopRequireDefault(_currentUser);

var _currentUserSettings = __webpack_require__(584);

var _currentUserSettings2 = _interopRequireDefault(_currentUserSettings);

var _isAuthenticating = __webpack_require__(585);

var _isAuthenticating2 = _interopRequireDefault(_isAuthenticating);

var _isAuthenticated = __webpack_require__(586);

var _isAuthenticated2 = _interopRequireDefault(_isAuthenticated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  currentUser: _currentUser2.default,
  currentUserSettings: _currentUserSettings2.default,
  isAuthenticated: _isAuthenticated2.default,
  isAuthenticating: _isAuthenticating2.default
});

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserSettings = exports.fetchUserSettingsFailure = exports.fetchUserSettingsSuccess = exports.fetchUserSettingsRequest = exports.FETCH_USER_SETTINGS_FAILURE = exports.FETCH_USER_SETTINGS_SUCCESS = exports.FETCH_USER_SETTINGS_REQUEST = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_USER_SETTINGS_REQUEST = exports.FETCH_USER_SETTINGS_REQUEST = 'userSettings/FETCH_REQUEST';
var FETCH_USER_SETTINGS_SUCCESS = exports.FETCH_USER_SETTINGS_SUCCESS = 'userSettings/FETCH_SUCCESS';
var FETCH_USER_SETTINGS_FAILURE = exports.FETCH_USER_SETTINGS_FAILURE = 'userSettings/FETCH_FAILURE';

var fetchUserSettingsRequest = exports.fetchUserSettingsRequest = (0, _createAction2.default)(FETCH_USER_SETTINGS_REQUEST);
var fetchUserSettingsSuccess = exports.fetchUserSettingsSuccess = (0, _createAction2.default)(FETCH_USER_SETTINGS_SUCCESS);
var fetchUserSettingsFailure = exports.fetchUserSettingsFailure = (0, _createAction2.default)(FETCH_USER_SETTINGS_FAILURE);

var fetchUserSettings = exports.fetchUserSettings = function fetchUserSettings(userId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(fetchUserSettingsRequest());

    var promise = request('/_api/users/' + userId + '/settings');

    return promise.then(function (settings) {
      return dispatch(fetchUserSettingsSuccess(settings));
    }, function () {
      return dispatch(fetchUserSettingsFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserSettings = exports.updateUserSettingsFailure = exports.updateUserSettingsSuccess = exports.updateUserSettingsRequest = exports.UPDATE_USER_SETTINGS_FAILURE = exports.UPDATE_USER_SETTINGS_SUCCESS = exports.UPDATE_USER_SETTINGS_REQUEST = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_USER_SETTINGS_REQUEST = exports.UPDATE_USER_SETTINGS_REQUEST = 'userSettings/UPDATE_REQUEST';
var UPDATE_USER_SETTINGS_SUCCESS = exports.UPDATE_USER_SETTINGS_SUCCESS = 'userSettings/UPDATE_SUCCESS';
var UPDATE_USER_SETTINGS_FAILURE = exports.UPDATE_USER_SETTINGS_FAILURE = 'userSettings/UPDATE_FAILURE';

var updateUserSettingsRequest = exports.updateUserSettingsRequest = (0, _createAction2.default)(UPDATE_USER_SETTINGS_REQUEST);
var updateUserSettingsSuccess = exports.updateUserSettingsSuccess = (0, _createAction2.default)(UPDATE_USER_SETTINGS_SUCCESS);
var updateUserSettingsFailure = exports.updateUserSettingsFailure = (0, _createAction2.default)(UPDATE_USER_SETTINGS_FAILURE);

var updateUserSettings = exports.updateUserSettings = function updateUserSettings(userId, settings) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(updateUserSettingsRequest(settings));

    var promise = request.put('/_api/users/' + userId + '/settings', settings);
    return promise.then(function () {
      return dispatch(updateUserSettingsSuccess(settings));
    }, function () {
      return dispatch(updateUserSettingsFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = experiments;

var _setDemoMode = __webpack_require__(317);

function experiments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case _setDemoMode.SET_DEMO_MODE:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _showModal = __webpack_require__(288);

var _hideModal = __webpack_require__(152);

var initalState = {
  type: null,
  props: null
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload,
      meta = _ref.meta;

  switch (type) {
    case _showModal.SHOW_MODAL:
      return _extends({}, state, payload, meta);
    case _hideModal.HIDE_MODAL:
      // TODO: fix
      // case LOCATION_CHANGE:
      return initalState;
    default:
      return state;
  }
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _counters = __webpack_require__(289);

var _addUser = __webpack_require__(536);

var _setCurrentUser = __webpack_require__(80);

var _fetchUser = __webpack_require__(420);

var _fetchMembers = __webpack_require__(199);

var _createUser = __webpack_require__(79);

var _updateUser = __webpack_require__(70);

var _blockUser = __webpack_require__(178);

var _unblockUser = __webpack_require__(179);

var _subscribe = __webpack_require__(59);

var _unsubscribe = __webpack_require__(60);

var _promoteModerator = __webpack_require__(139);

var _demoteModerator = __webpack_require__(140);

var _userSocket = __webpack_require__(78);

var _fetchFollowers = __webpack_require__(195);

var _fetchFollowing = __webpack_require__(196);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var addUsers = function addUsers(state, users) {
  return (0, _lodash.reduce)(users, function (acc, user) {
    return _extends({}, acc, _defineProperty({}, user._id, _extends({}, acc[user._id], user)));
  }, _extends({}, state));
};

var updateSubscription = function updateSubscription(_ref) {
  var state = _ref.state,
      payload = _ref.payload,
      isSubscribed = _ref.isSubscribed;

  var userId = payload.type === 'user' && payload._id;
  var user = state[userId];
  if (!user) {
    return state;
  }

  return (0, _lodash.merge)({}, state, _defineProperty({}, userId, _extends({}, (0, _counters.updatedCounters)(user, 'followerCount', isSubscribed ? _counters.increment : _counters.decrement), {
    isSubscribed: isSubscribed
  })));
};

// eslint-disable-next-line complexity

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _addUser.ADD_USER:
    case _setCurrentUser.SET_CURRENT_USER:
    case _fetchUser.FETCH_USER_SUCCESS:
    case _createUser.CREATE_USER_SUCCESS:
    case _updateUser.UPDATE_USER_SUCCESS:
    case _blockUser.BLOCK_USER_SUCCESS:
    case _unblockUser.UNBLOCK_USER_SUCCESS:
    case _promoteModerator.PROMOTE_MODERATOR_SUCCESS:
    case _demoteModerator.DEMOTE_MODERATOR_SUCCESS:
    case _userSocket.USER_SET_PERMISSIONS:
      return addUsers(state, [action.payload]);
    case _fetchMembers.FETCH_MEMBERS_SUCCESS:
      return addUsers(state, action.payload);
    case _subscribe.SUBSCRIBE_REQUEST:
      return updateSubscription({ state: state, payload: action.payload, isSubscribed: true });
    case _subscribe.SUBSCRIBE_FAILURE:
      return updateSubscription({ state: state, payload: action.payload, isSubscribed: false });
    case _unsubscribe.UNSUBSCRIBE_REQUEST:
      return updateSubscription({ state: state, payload: action.payload, isSubscribed: false });
    case _unsubscribe.UNSUBSCRIBE_FAILURE:
      return updateSubscription({ state: state, payload: action.payload, isSubscribed: true });
    case _fetchFollowers.FETCH_FOLLOWERS_SUCCESS:
      return addUsers(state, action.payload.followers);
    case _fetchFollowing.FETCH_FOLLOWING_SUCCESS:
      return addUsers(state, action.payload.following);
    default:
      return state;
  }
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUser = exports.ADD_USER = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_USER = exports.ADD_USER = 'user/ADD';
var addUser = exports.addUser = (0, _createAction2.default)(ADD_USER);

/***/ }),
/* 537 */,
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _environmentProvider = __webpack_require__(594);

var _environmentProvider2 = _interopRequireDefault(_environmentProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _environmentProvider2.default;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showJoinCommunityPopup = undefined;

var _lodash = __webpack_require__(2);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POPUP_URL = 'https://apps.wix.com/members-area/public/modal/join-community';

var onClose = function onClose(callback) {
  return function (_ref) {
    var message = _ref.message;

    if ((0, _lodash.isFunction)(callback)) {
      callback((0, _lodash.get)(message, 'payload.inCommunity', false));
    }
  };
};

var showJoinCommunityPopup = exports.showJoinCommunityPopup = function showJoinCommunityPopup(callback) {
  _wixSdkPolyfill2.default.openPopup(POPUP_URL, '100%', '100%', { origin: _wixSdkPolyfill2.default.WindowOrigin.FIXED, placement: _wixSdkPolyfill2.default.WindowPlacement.CENTER }, onClose(callback), _wixSdkPolyfill2.default.Theme.BARE);
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var params = {};
var setQueryParams = exports.setQueryParams = function setQueryParams(_params) {
  return params = _params;
};
var getQueryParams = exports.getQueryParams = function getQueryParams() {
  return params;
};

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _getOuterUrl = __webpack_require__(63);

var _getOuterUrl2 = _interopRequireDefault(_getOuterUrl);

var _wixSdkUtils = __webpack_require__(21);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

var getLocation = function getLocation(to, sectionUrl) {
  var location = void 0;
  if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object') {
    location = new _urijs2.default((0, _getOuterUrl2.default)(to.pathname, sectionUrl));
    location.search(to.search);
    location.hash(to.hash);
  } else {
    location = new _urijs2.default((0, _getOuterUrl2.default)(to, sectionUrl));
  }
  return location.toString();
};

var getState = function getState(to) {
  var location = void 0;
  if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object') {
    location = new _urijs2.default(to.pathname);
    location.search(to.search);
    location.hash(to.hash);
  } else {
    location = new _urijs2.default(to);
  }
  return (0, _lodash.trimStart)(location.toString(), '/');
};

var ExternalLink = function ExternalLink(_ref) {
  var appDefinitionId = _ref.appDefinitionId,
      sectionId = _ref.sectionId,
      to = _ref.to,
      children = _ref.children,
      renderInSeo = _ref.renderInSeo,
      renderHref = _ref.renderHref,
      sectionUrl = _ref.sectionUrl,
      props = _objectWithoutProperties(_ref, ['appDefinitionId', 'sectionId', 'to', 'children', 'renderInSeo', 'renderHref', 'sectionUrl']);

  var linkProps = (0, _lodash.omit)(props, 'dispatch', 'user');

  var handleClick = function handleClick(event) {
    if (event.defaultPrevented) {
      return;
    }
    if (!renderHref || renderHref && !isModifiedEvent(event)) {
      event.preventDefault();
      event.stopPropagation();

      _wixSdkPolyfill2.default.Utils.navigateToSection({
        appDefinitionId: appDefinitionId,
        sectionId: sectionId,
        shouldRefreshIframe: false
      }, getState(to));
    }
  };

  if ((0, _wixSdkUtils.isSeoViewMode)() && !renderInSeo) {
    return _react2.default.createElement(
      'div',
      linkProps,
      children
    );
  }
  linkProps.href = '#';
  if (renderHref) {
    linkProps.href = getLocation(to, sectionUrl);
    linkProps.target = '_top';
  }

  return _react2.default.createElement(
    'a',
    _extends({ onClick: handleClick }, linkProps),
    children
  );
};

ExternalLink.propTypes = {
  appDefinitionId: _propTypes2.default.string.isRequired,
  sectionId: _propTypes2.default.string.isRequired,
  to: _propTypes2.default.string,
  children: _propTypes2.default.node,
  renderInSeo: _propTypes2.default.bool,
  renderHref: _propTypes2.default.bool,
  sectionUrl: _propTypes2.default.string
};

ExternalLink.defaultProps = {
  renderInSeo: true,
  renderHref: true
};

exports.default = ExternalLink;

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(0);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: external "React.PropTypes"
var external__React_PropTypes_ = __webpack_require__(1);
var external__React_PropTypes__default = /*#__PURE__*/__webpack_require__.n(external__React_PropTypes_);

// CONCATENATED MODULE: ../node_modules/react-textarea-autosize/es/calculateNodeHeight.js
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var browser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE = browser ? !!document.documentElement.currentStyle : false;
var boxSizingProp = function () {
  if (!browser) {
    return 'box-sizing';
  }
  var documentStyle = window.getComputedStyle(document.documentElement);
  // TODO: remove prefixed - they are probably obsolete, were introduced in by df79cf502630744d40233b64cad01770e5584610 in 2014
  return documentStyle.getPropertyValue('box-sizing') ? 'box-sizing' : documentStyle.getPropertyValue('-moz-box-sizing') ? '-moz-box-sizing' : documentStyle.getPropertyValue('-webkit-box-sizing') ? '-webkit-box-sizing' : 'box-sizing';
}();

var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  'height': '0',
  'visibility': 'hidden',
  'overflow': 'hidden',
  'position': 'absolute',
  'z-index': '-1000',
  'top': '0',
  'right': '0'
};

var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', boxSizingProp];

var computedStyleCache = {};
var hiddenTextarea = void 0;

function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  } else if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }

  // Copy all CSS properties that have an impact on the height of the content in
  // the textbox

  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle;

  // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  Object.keys(sizingStyle).map(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  Object.keys(HIDDEN_TEXTAREA_STYLE).map(function (key) {
    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';

  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = 'x';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      height = Math.min(maxHeight, height);
    }
  }
  return { height: height, minHeight: minHeight, maxHeight: maxHeight };
}

function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // TODO: generate id in constructor + clear cache in componentWillUnmount
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});

  var boxSizing = sizingStyle[boxSizingProp];

  // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths
  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);

  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);

  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}
// CONCATENATED MODULE: ../node_modules/react-textarea-autosize/es/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * <TextareaAutosize />
 */





var noop = function noop() {};

var es_TextareaAutosize = function (_React$Component) {
  _inherits(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    _classCallCheck(this, TextareaAutosize);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._onRootDOMNode = function (node) {
      _this._rootDOMNode = node;
      if (_this.props.inputRef) _this.props.inputRef(node);
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }
      var _this$props = _this.props,
          valueLink = _this$props.valueLink,
          onChange = _this$props.onChange;

      if (valueLink) {
        valueLink.requestChange(event.target.value);
      } else {
        onChange(event);
      }
    };

    _this._resizeComponent = function () {
      if (!_this._rootDOMNode) {
        return;
      }

      var _calculateNodeHeight = calculateNodeHeight(_this._rootDOMNode, _this.props.useCacheForDOMMeasurements, _this.props.rows || _this.props.minRows, _this.props.maxRows),
          height = _calculateNodeHeight.height,
          minHeight = _calculateNodeHeight.minHeight,
          maxHeight = _calculateNodeHeight.maxHeight;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({ height: height, minHeight: minHeight, maxHeight: maxHeight });
      }
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };

    _this._controlled = typeof props.value === 'string';
    return _this;
  }

  TextareaAutosize.prototype.render = function render() {
    var _props = this.props,
        valueLink = _props.valueLink,
        _minRows = _props.minRows,
        _maxRows = _props.maxRows,
        _onHeightChange = _props.onHeightChange,
        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
        _inputRef = _props.inputRef,
        props = _objectWithoutProperties(_props, ['valueLink', 'minRows', 'maxRows', 'onHeightChange', 'useCacheForDOMMeasurements', 'inputRef']);

    if ((typeof valueLink === 'undefined' ? 'undefined' : _typeof(valueLink)) === 'object') {
      props.value = valueLink.value;
    }

    props.style = _extends({}, props.style, {
      height: this.state.height
    });

    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return external__React__default.a.createElement('textarea', _extends({}, props, {
      onChange: this._onChange,
      ref: this._onRootDOMNode
    }));
  };

  TextareaAutosize.prototype.componentDidMount = function componentDidMount() {
    this._resizeComponent();
    window.addEventListener('resize', this._resizeComponent);
  };

  TextareaAutosize.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    // Re-render with the new content then recalculate the height as required.
    this._clearNextFrame();
    this._onNextFrameActionId = onNextFrame(this._resizeComponent);
  };

  TextareaAutosize.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // Invoke callback when old height does not equal to new one.
    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height);
    }
  };

  TextareaAutosize.prototype.componentWillUnmount = function componentWillUnmount() {
    // Remove any scheduled events to prevent manipulating the node after it's
    // been unmounted.
    this._clearNextFrame();
    window.removeEventListener('resize', this._resizeComponent);
  };

  TextareaAutosize.prototype._clearNextFrame = function _clearNextFrame() {
    if (this._onNextFrameActionId) {
      clearNextFrameAction(this._onNextFrameActionId);
    }
  };

  /**
   * Put focus on a <textarea /> DOM element.
   */
  TextareaAutosize.prototype.focus = function focus() {
    this._rootDOMNode.focus();
  };

  /**
   * Shifts focus away from a <textarea /> DOM element.
   */


  TextareaAutosize.prototype.blur = function blur() {
    this._rootDOMNode.blur();
  };

  _createClass(TextareaAutosize, [{
    key: 'value',


    /**
     * Read the current value of <textarea /> from DOM.
     */
    get: function get() {
      return this._rootDOMNode.value;
    }

    /**
     * Set the current value of <textarea /> DOM node.
     */
    ,
    set: function set(val) {
      this._rootDOMNode.value = val;
    }

    /**
     * Read the current selectionStart of <textarea /> from DOM.
     */

  }, {
    key: 'selectionStart',
    get: function get() {
      return this._rootDOMNode.selectionStart;
    }

    /**
     * Set the current selectionStart of <textarea /> DOM node.
     */
    ,
    set: function set(selectionStart) {
      this._rootDOMNode.selectionStart = selectionStart;
    }

    /**
     * Read the current selectionEnd of <textarea /> from DOM.
     */

  }, {
    key: 'selectionEnd',
    get: function get() {
      return this._rootDOMNode.selectionEnd;
    }

    /**
     * Set the current selectionEnd of <textarea /> DOM node.
     */
    ,
    set: function set(selectionEnd) {
      this._rootDOMNode.selectionEnd = selectionEnd;
    }
  }]);

  return TextareaAutosize;
}(external__React__default.a.Component);

es_TextareaAutosize.propTypes = {
  /**
   * Current textarea value.
   */
  value: external__React_PropTypes__default.a.string,

  /**
   * Callback on value change.
   */
  onChange: external__React_PropTypes__default.a.func,

  /**
   * Callback on height changes.
   */
  onHeightChange: external__React_PropTypes__default.a.func,

  /**
   * Try to cache DOM measurements performed by component so that we don't
   * touch DOM when it's not needed.
   *
   * This optimization doesn't work if we dynamically style <textarea />
   * component.
   */
  useCacheForDOMMeasurements: external__React_PropTypes__default.a.bool,

  /**
   * Minimal numbder of rows to show.
   */
  rows: external__React_PropTypes__default.a.number,

  /**
   * Alias for `rows`.
   */
  minRows: external__React_PropTypes__default.a.number,

  /**
   * Maximum number of rows to show.
   */
  maxRows: external__React_PropTypes__default.a.number,

  /**
   * Allows an owner to retrieve the DOM node.
   */
  inputRef: external__React_PropTypes__default.a.func
};
es_TextareaAutosize.defaultProps = {
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};
/* harmony default export */ var es = __webpack_exports__["default"] = (es_TextareaAutosize);


function onNextFrame(cb) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(cb);
  }
  return window.setTimeout(cb, 1);
}

function clearNextFrameAction(nextFrameId) {
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(nextFrameId);
  } else {
    window.clearTimeout(nextFrameId);
  }
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _currentUserAvatar = __webpack_require__(822);

var _currentUserAvatar2 = _interopRequireDefault(_currentUserAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _currentUserAvatar2.default;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _avatarImage = __webpack_require__(825);

var _avatarImage2 = _interopRequireDefault(_avatarImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _avatarImage2.default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _fluidAvatarImage = __webpack_require__(826);

var _fluidAvatarImage2 = _interopRequireDefault(_fluidAvatarImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _fluidAvatarImage2.default;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _currentUserProfileLink = __webpack_require__(841);

var _currentUserProfileLink2 = _interopRequireDefault(_currentUserProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _currentUserProfileLink2.default;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postFormSettings = {
  form: 'post',
  fields: ['title', 'content', 'categoryId', 'ownerId'],
  validate: function validate(values) {
    var errors = {};
    var content = values.content,
        title = values.title;


    if (!_lodash2.default.trim(title)) {
      errors.title = 'required';
    }

    if (content) {
      if (content.blocks.length < 2 && !content.blocks[0].text.length) {
        errors.content = 'required';
      } else {
        var entityMap = content.entityMap;
        Object.keys(content.entityMap).forEach(function (key) {
          if (entityMap[key].data.isLoading) {
            errors.content = 'uploading';
          }
        });
      }
    }

    return errors;
  }
};

exports.default = postFormSettings;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _forDevice = __webpack_require__(182);

var _forDevice2 = _interopRequireDefault(_forDevice);

var _selectMobile = __webpack_require__(847);

var _selectMobile2 = _interopRequireDefault(_selectMobile);

var _selectDesktop = __webpack_require__(849);

var _selectDesktop2 = _interopRequireDefault(_selectDesktop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _forDevice2.default)(_selectMobile2.default, _selectDesktop2.default);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportAbuseForm = exports.REASONS = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reduxForm = __webpack_require__(40);

var _icons = __webpack_require__(9);

var _inputRadio = __webpack_require__(866);

var _inputRadio2 = _interopRequireDefault(_inputRadio);

var _buttonGroup = __webpack_require__(50);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _separator = __webpack_require__(18);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _reportAbuseForm = __webpack_require__(869);

var _reportAbuseForm2 = _interopRequireDefault(_reportAbuseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REASONS = exports.REASONS = [{
  value: '1',
  text: 'report-abuse-form.offensive-content'
}, {
  value: '2',
  text: 'report-abuse-form.offensive-media'
}, {
  value: '3',
  text: 'report-abuse-form.spam'
}];

/* eslint-disable */
var ReportAbuseForm = exports.ReportAbuseForm = function ReportAbuseForm(_ref) {
  var message = _ref.message,
      title = _ref.title,
      fields = _ref.fields,
      handleSubmit = _ref.handleSubmit,
      onCancel = _ref.onCancel,
      onClose = _ref.onClose,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_reportAbuseForm2.default.container, 'forum-text-color', contentFontClassName, 'report') },
    _react2.default.createElement(
      'h3',
      { className: (0, _classnames2.default)(_reportAbuseForm2.default.titleContainer, titleFontClassName) },
      _react2.default.createElement(_icons.ReportIcon, { className: 'forum-icon-fill' }),
      _react2.default.createElement(
        'span',
        { className: _reportAbuseForm2.default.title },
        title
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _reportAbuseForm2.default.message },
      message
    ),
    _react2.default.createElement(
      'form',
      { className: (0, _classnames2.default)(_reportAbuseForm2.default.form, 'report__form'), onSubmit: handleSubmit },
      _react2.default.createElement(
        'div',
        { className: _reportAbuseForm2.default.reasons, role: 'radiogroup', 'aria-labelledby': message, tabIndex: '0' },
        _lodash2.default.map(REASONS, function (reason, key) {
          return _react2.default.createElement(
            'div',
            { key: key, className: _reportAbuseForm2.default.reason },
            _react2.default.createElement(
              'div',
              { className: _reportAbuseForm2.default.radioInput },
              _react2.default.createElement(_inputRadio2.default, {
                name: 'reportType',
                onChange: fields.reportType.onChange,
                checked: fields.reportType.value === reason.value,
                value: reason.value,
                text: t(reason.text),
                tabIndex: key === 0 ? '0' : '-1'
              })
            ),
            _react2.default.createElement(_separator.HorizontalSeparator, { className: _reportAbuseForm2.default.separator })
          );
        })
      ),
      _react2.default.createElement(_buttonGroup2.default, {
        primaryButtonText: t('report-abuse-form.submit-button'),
        primaryButtonProps: { type: 'submit' },
        secondaryButtonText: t('report-abuse-form.cancel-button'),
        secondaryButtonProps: { onClick: function onClick() {
            return onCancel();
          } }
      })
    )
  );
};
/* eslint-enable */

ReportAbuseForm.propTypes = {
  handleSubmit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  fields: _propTypes2.default.object.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  message: _propTypes2.default.string,
  title: _propTypes2.default.string
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'report',
  fields: ['reportType', '_id'],
  initialValues: {
    reportType: REASONS[0].value
  }
})((0, _withFontClassName2.default)((0, _withTranslate2.default)(ReportAbuseForm)));

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = share;
var WIDTH = 640;
var HEIGHT = 640;
var openShareDialog = function openShareDialog(url) {
  window.open(url, 'Share', 'width=' + WIDTH + ',height=' + HEIGHT + ',toolbar=no,menubar=no,scrollbars=no,location=no,status=no');
};

var getUrl = function getUrl(socialNetwork, href) {
  switch (socialNetwork) {
    case 'facebook':
      return 'http://www.facebook.com/sharer/sharer.php?u=' + href;
    case 'twitter':
      return 'https://twitter.com/share?url=' + href;
    case 'gPlus':
      return 'https://plus.google.com/share?url=' + href;
    default:
      return;
  }
};

function share(type, path) {
  openShareDialog(getUrl(type, path));
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAVIGATE_TO_PROFILE = exports.NAVIGATE_TO_PROFILE = 'profile';
var NAVIGATE_TO_CREATE_POST = exports.NAVIGATE_TO_CREATE_POST = 'create_post';
var NAVIGATE_TO_MY_DRAFTS = exports.NAVIGATE_TO_MY_DRAFTS = 'my_drafts';
var NAVIGATE_TO_PROFILE_SETTINGS = exports.NAVIGATE_TO_PROFILE_SETTINGS = 'settings';
var LOGOUT = exports.LOGOUT = 'logout';

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _loginScreen = __webpack_require__(943);

var _loginScreen2 = _interopRequireDefault(_loginScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loginScreen2.default;

/***/ }),
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = listenToSettingsChange;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _wixSdkUtils = __webpack_require__(21);

var _updateAppSettings = __webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EXCLUDED_CSS_FONTS = /fonts\.googleapis/;

function listenToSettingsChange(store) {
  var isMainPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // TODO: remove when site colors are returned from app settings endpoint
  setTimeout(function () {
    return store.dispatch((0, _updateAppSettings.updateAppSettingsOnStore)(getStyleSettings()));
  });

  if (!(0, _wixSdkUtils.isEditor)()) {
    return;
  }

  _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.SITE_SAVED, function () {
    _wixSdkPolyfill2.default.Styles.getStyleParams(function (style) {
      store.dispatch((0, _updateAppSettings.updateAppSettings)(_wixSdkPolyfill2.default.Utils.getCompId(), 'draft', 'editor', getStyleSettings(style), isMainPage));
    });
  });

  _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.SITE_PUBLISHED, function () {
    _wixSdkPolyfill2.default.Styles.getStyleParams(function (style) {
      _wixSdkPolyfill2.default.getExternalId(function (externalId) {
        store.dispatch((0, _updateAppSettings.updateAppSettings)(_wixSdkPolyfill2.default.Utils.getCompId(), externalId || 'published', 'editor', getStyleSettings(style), isMainPage));
      });
    });
  });

  _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.STYLE_PARAMS_CHANGE, function (style) {
    store.dispatch((0, _updateAppSettings.updateAppSettingsOnStore)(getStyleSettings(style)));
  });

  _wixSdkPolyfill2.default.addEventListener(_wixSdkPolyfill2.default.Events.SETTINGS_UPDATED, function (data) {
    return store.dispatch(data);
  });
}

function getStyleSettings() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    style: _extends({}, style, {
      cssUrls: getFontCssUrls()
    }),
    textPresets: _wixSdkPolyfill2.default.Styles.getSiteTextPresets() || [],
    colorPresets: _wixSdkPolyfill2.default.Styles.getSiteColors() || []
  };
}

function getFontCssUrls() {
  return (0, _lodash2.default)(document.styleSheets).filter(function (styleSheet) {
    return styleSheet.href;
  }).map(function (styleSheet) {
    return styleSheet.href.toLowerCase();
  }).map(function (href) {
    return href.replace(/^https?:/, '');
  }).filter(function (href) {
    return !EXCLUDED_CSS_FONTS.test(href);
  }).filter(function (href) {
    return href.indexOf('font') >= 0;
  }).uniq().value();
}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 557 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createAll;

var _reducer = __webpack_require__(190);

var _reducer2 = _interopRequireDefault(_reducer);

var _createReduxForm = __webpack_require__(562);

var _createReduxForm2 = _interopRequireDefault(_createReduxForm);

var _mapValues = __webpack_require__(192);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _bindActionData = __webpack_require__(306);

var _bindActionData2 = _interopRequireDefault(_bindActionData);

var _actions = __webpack_require__(305);

var actions = _interopRequireWildcard(_actions);

var _actionTypes = __webpack_require__(191);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _createPropTypes = __webpack_require__(582);

var _createPropTypes2 = _interopRequireDefault(_createPropTypes);

var _getValuesFromState = __webpack_require__(301);

var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// bind form as first parameter of action creators
var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
  autofillWithKey: function autofillWithKey(key) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
  },
  changeWithKey: function changeWithKey(key) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
  },
  initializeWithKey: function initializeWithKey(key) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
  },
  reset: function reset(key) {
    return (0, _bindActionData2.default)(actions.reset, { key: key })();
  },
  touchWithKey: function touchWithKey(key) {
    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }

    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
  },
  untouchWithKey: function untouchWithKey(key) {
    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      args[_key5 - 1] = arguments[_key5];
    }

    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
  },
  destroy: function destroy(key) {
    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
  }
}), function (action) {
  return function (form) {
    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }

    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
  };
}));

var addArrayValue = boundActions.addArrayValue;
var autofill = boundActions.autofill;
var autofillWithKey = boundActions.autofillWithKey;
var blur = boundActions.blur;
var change = boundActions.change;
var changeWithKey = boundActions.changeWithKey;
var destroy = boundActions.destroy;
var focus = boundActions.focus;
var initialize = boundActions.initialize;
var initializeWithKey = boundActions.initializeWithKey;
var removeArrayValue = boundActions.removeArrayValue;
var reset = boundActions.reset;
var startAsyncValidation = boundActions.startAsyncValidation;
var startSubmit = boundActions.startSubmit;
var stopAsyncValidation = boundActions.stopAsyncValidation;
var stopSubmit = boundActions.stopSubmit;
var submitFailed = boundActions.submitFailed;
var swapArrayValues = boundActions.swapArrayValues;
var touch = boundActions.touch;
var touchWithKey = boundActions.touchWithKey;
var untouch = boundActions.untouch;
var untouchWithKey = boundActions.untouchWithKey;

function createAll(isReactNative, React, connect) {
  return {
    actionTypes: actionTypes,
    addArrayValue: addArrayValue,
    autofill: autofill,
    autofillWithKey: autofillWithKey,
    blur: blur,
    change: change,
    changeWithKey: changeWithKey,
    destroy: destroy,
    focus: focus,
    getValues: _getValuesFromState2.default,
    initialize: initialize,
    initializeWithKey: initializeWithKey,
    propTypes: (0, _createPropTypes2.default)(),
    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
    reducer: _reducer2.default,
    removeArrayValue: removeArrayValue,
    reset: reset,
    startAsyncValidation: startAsyncValidation,
    startSubmit: startSubmit,
    stopAsyncValidation: stopAsyncValidation,
    stopSubmit: stopSubmit,
    submitFailed: submitFailed,
    swapArrayValues: swapArrayValues,
    touch: touch,
    touchWithKey: touchWithKey,
    untouch: untouch,
    untouchWithKey: untouchWithKey
  };
}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _fieldValue = __webpack_require__(62);

var reset = function reset(value) {
  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
};

/**
 * Sets the initial values into the state and returns a new copy of the state
 */
var resetState = function resetState(values) {
  return values ? Object.keys(values).reduce(function (accumulator, key) {
    var value = values[key];
    if (Array.isArray(value)) {
      accumulator[key] = value.map(function (item) {
        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
      });
    } else if (value) {
      if ((0, _fieldValue.isFieldValue)(value)) {
        accumulator[key] = reset(value);
      } else if (typeof value === 'object' && value !== null) {
        accumulator[key] = resetState(value);
      } else {
        accumulator[key] = value;
      }
    }
    return accumulator;
  }, {}) : values;
};

exports.default = resetState;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fieldValue = __webpack_require__(62);

var isMetaKey = function isMetaKey(key) {
  return key[0] === '_';
};

/**
 * Sets an error on a field deep in the tree, returning a new copy of the state
 */
var setErrors = function setErrors(state, errors, destKey) {
  var clear = function clear() {
    if (Array.isArray(state)) {
      return state.map(function (stateItem, index) {
        return setErrors(stateItem, errors && errors[index], destKey);
      });
    }
    if (state && typeof state === 'object') {
      var result = Object.keys(state).reduce(function (accumulator, key) {
        var _extends2;

        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
      }, state);
      if ((0, _fieldValue.isFieldValue)(state)) {
        (0, _fieldValue.makeFieldValue)(result);
      }
      return result;
    }
    return (0, _fieldValue.makeFieldValue)(state);
  };
  if (typeof File !== 'undefined' && state instanceof File) {
    return state;
  }
  if (!errors) {
    if (!state) {
      return state;
    }
    if (state[destKey]) {
      var copy = _extends({}, state);
      delete copy[destKey];
      return (0, _fieldValue.makeFieldValue)(copy);
    }
    return clear();
  }
  if (typeof errors === 'string') {
    var _extends3;

    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
  }
  if (Array.isArray(errors)) {
    if (!state || Array.isArray(state)) {
      var _copy = (state || []).map(function (stateItem, index) {
        return setErrors(stateItem, errors[index], destKey);
      });
      errors.forEach(function (errorItem, index) {
        return _copy[index] = setErrors(_copy[index], errorItem, destKey);
      });
      return _copy;
    }
    return setErrors(state, errors[0], destKey); // use first error
  }
  if ((0, _fieldValue.isFieldValue)(state)) {
    var _extends4;

    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
  }
  var errorKeys = Object.keys(errors);
  if (!errorKeys.length && !state) {
    return state;
  }
  return errorKeys.reduce(function (accumulator, key) {
    var _extends5;

    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
  }, clear() || {});
};

exports.default = setErrors;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = normalizeFields;

var _fieldValue = __webpack_require__(62);

function extractKey(field) {
  var dotIndex = field.indexOf('.');
  var openIndex = field.indexOf('[');
  var closeIndex = field.indexOf(']');

  if (openIndex > 0 && closeIndex !== openIndex + 1) {
    throw new Error('found [ not followed by ]');
  }

  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
  var key = void 0;
  var nestedPath = void 0;

  if (isArray) {
    key = field.substring(0, openIndex);
    nestedPath = field.substring(closeIndex + 1);

    if (nestedPath[0] === '.') {
      nestedPath = nestedPath.substring(1);
    }
  } else if (dotIndex > 0) {
    key = field.substring(0, dotIndex);
    nestedPath = field.substring(dotIndex + 1);
  } else {
    key = field;
  }

  return { isArray: isArray, key: key, nestedPath: nestedPath };
}

function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
  if (field.isArray) {
    if (field.nestedPath) {
      var array = state && state[field.key] || [];
      var previousArray = previousState && previousState[field.key] || [];
      var nestedField = extractKey(field.nestedPath);

      return array.map(function (nestedState, i) {
        nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);

        return nestedState;
      });
    }

    var _normalizer = normalizers[fullFieldPath];

    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
  } else if (field.nestedPath) {
    var nestedState = state && state[field.key] || {};
    var _nestedField = extractKey(field.nestedPath);

    nestedState[_nestedField.key] = normalizeField(_nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);

    return nestedState;
  }

  var finalField = state && Object.assign({}, state[field.key] || {});
  var normalizer = normalizers[fullFieldPath];

  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);

  return (0, _fieldValue.makeFieldValue)(finalField);
}

function normalizeFields(normalizers, state, previousState, values, previousValues) {
  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
    var extracted = extractKey(field);

    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);

    return accumulator;
  }, {});

  return _extends({}, state, newState);
}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createReduxFormConnector = __webpack_require__(563);

var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(isReactNative, React, connect) {
  var Component = React.Component;

  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
    return function (WrappedComponent) {
      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);

      var _ref = options || {},
          _ref$withRef = _ref.withRef,
          withRef = _ref$withRef === undefined ? false : _ref$withRef;

      var configWithDefaults = _extends({
        overwriteOnInitialValuesChange: true,
        touchOnBlur: true,
        touchOnChange: false,
        destroyOnUnmount: true
      }, config);

      var ConnectedForm = function (_Component) {
        _inherits(ConnectedForm, _Component);

        function ConnectedForm(props) {
          _classCallCheck(this, ConnectedForm);

          var _this = _possibleConstructorReturn(this, _Component.call(this, props));

          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
          return _this;
        }

        ConnectedForm.prototype.getWrappedInstance = function getWrappedInstance() {
          (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
          return this.refs.wrappedInstance.refs.wrappedInstance.getWrappedInstance().refs.wrappedInstance;
        };

        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
          this.submit = submit;
        };

        ConnectedForm.prototype.render = function render() {
          if (withRef) {
            return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
              ref: 'wrappedInstance',
              submitPassback: this.handleSubmitPassback }));
          }
          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
            submitPassback: this.handleSubmitPassback }));
        };

        return ConnectedForm;
      }(Component);

      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
    };
  };
};

exports.default = createReduxForm;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _noGetters = __webpack_require__(564);

var _noGetters2 = _interopRequireDefault(_noGetters);

var _getDisplayName = __webpack_require__(304);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _createHigherOrderComponent = __webpack_require__(566);

var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
 * but if they do, the connected components below it need to be redefined.
 */
var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
    var Component = React.Component;

    var _ref = options || {},
        _ref$withRef = _ref.withRef,
        withRef = _ref$withRef === undefined ? false : _ref$withRef;

    var ReduxFormConnector = function (_Component) {
      _inherits(ReduxFormConnector, _Component);

      function ReduxFormConnector(props) {
        _classCallCheck(this, ReduxFormConnector);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.cache = new _noGetters2.default(_this, {
          ReduxForm: {
            params: [
            // props that effect how redux-form connects to the redux store
            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
          }
        });
        return _this;
      }

      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.cache.componentWillReceiveProps(nextProps);
      };

      ReduxFormConnector.prototype.render = function render() {
        var ReduxForm = this.cache.get('ReduxForm');
        // remove some redux-form config-only props

        var _props = this.props,
            reduxMountPoint = _props.reduxMountPoint,
            destroyOnUnmount = _props.destroyOnUnmount,
            form = _props.form,
            getFormState = _props.getFormState,
            touchOnBlur = _props.touchOnBlur,
            touchOnChange = _props.touchOnChange,
            passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare


        if (withRef) {
          return React.createElement(ReduxForm, _extends({}, passableProps, { ref: 'wrappedInstance' }));
        }
        return React.createElement(ReduxForm, passableProps);
      };

      return ReduxFormConnector;
    }(Component);

    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
    ReduxFormConnector.WrappedComponent = WrappedComponent;
    ReduxFormConnector.propTypes = {
      destroyOnUnmount: _propTypes2.default.bool,
      reduxMountPoint: _propTypes2.default.string,
      form: _propTypes2.default.string.isRequired,
      formKey: _propTypes2.default.string,
      getFormState: _propTypes2.default.func,
      touchOnBlur: _propTypes2.default.bool,
      touchOnChange: _propTypes2.default.bool
    };
    ReduxFormConnector.defaultProps = {
      reduxMountPoint: 'form',
      getFormState: function getFormState(state, reduxMountPoint) {
        return state[reduxMountPoint];
      }
    };
    return ReduxFormConnector;
  };
};

exports.default = createReduxFormConnector;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(565);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _deepEqual = __webpack_require__(187);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

function intersects(array1, array2) {
  return !!(array1 && array2 && array1.some(function (item) {
    return ~array2.indexOf(item);
  }));
}

var LazyCache = (function () {
  function LazyCache(component, calculators) {
    var _this = this;

    _classCallCheck(this, LazyCache);

    this.component = component;
    this.allProps = [];
    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
      var _extends2;

      var calculator = calculators[key];
      var fn = calculator.fn;
      var paramNames = calculator.params;
      paramNames.forEach(function (param) {
        if (! ~_this.allProps.indexOf(param)) {
          _this.allProps.push(param);
        }
      });
      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
        value: undefined,
        props: paramNames,
        fn: fn
      }, _extends2));
    }, {});
  }

  LazyCache.prototype.get = function get(key) {
    var component = this.component;
    var _cache$key = this.cache[key];
    var value = _cache$key.value;
    var fn = _cache$key.fn;
    var props = _cache$key.props;

    if (value !== undefined) {
      return value;
    }
    var params = props.map(function (prop) {
      return component.props[prop];
    });
    var result = fn.apply(undefined, params);
    this.cache[key].value = result;
    return result;
  };

  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var component = this.component;

    var diffProps = [];
    this.allProps.forEach(function (prop) {
      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
        diffProps.push(prop);
      }
    });
    if (diffProps.length) {
      Object.keys(this.cache).forEach(function (key) {
        if (intersects(diffProps, _this2.cache[key].props)) {
          delete _this2.cache[key].value; // uncache value
        }
      });
    }
  };

  return LazyCache;
})();

exports['default'] = LazyCache;
module.exports = exports['default'];

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _actions = __webpack_require__(305);

var importedActions = _interopRequireWildcard(_actions);

var _getDisplayName = __webpack_require__(304);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _reducer = __webpack_require__(190);

var _deepEqual = __webpack_require__(187);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _bindActionData = __webpack_require__(306);

var _bindActionData2 = _interopRequireDefault(_bindActionData);

var _getValues = __webpack_require__(307);

var _getValues2 = _interopRequireDefault(_getValues);

var _isValid = __webpack_require__(134);

var _isValid2 = _interopRequireDefault(_isValid);

var _readFields = __webpack_require__(567);

var _readFields2 = _interopRequireDefault(_readFields);

var _handleSubmit2 = __webpack_require__(577);

var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);

var _asyncValidation = __webpack_require__(578);

var _asyncValidation2 = _interopRequireDefault(_asyncValidation);

var _silenceEvents = __webpack_require__(579);

var _silenceEvents2 = _interopRequireDefault(_silenceEvents);

var _silenceEvent = __webpack_require__(312);

var _silenceEvent2 = _interopRequireDefault(_silenceEvent);

var _wrapMapDispatchToProps = __webpack_require__(580);

var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);

var _wrapMapStateToProps = __webpack_require__(581);

var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);

var _createInitialState = __webpack_require__(303);

var _createInitialState2 = _interopRequireDefault(_createInitialState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creates a HOC that knows how to create redux-connected sub-components.
 */
var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
  var Component = React.Component;

  return function (reduxMountPoint, formName, formKey, getFormState) {
    var _ref = options || {},
        _ref$withRef = _ref.withRef,
        withRef = _ref$withRef === undefined ? false : _ref$withRef;

    var ReduxForm = function (_Component) {
      _inherits(ReduxForm, _Component);

      function ReduxForm(props) {
        _classCallCheck(this, ReduxForm);

        // bind functions
        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.asyncValidate = _this.asyncValidate.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        var _this$props = _this.props,
            initialValues = _this$props.initialValues,
            submitPassback = _this$props.submitPassback;
        // Check if form state was initialized, if not, initialize it.

        var form = (0, _deepEqual2.default)(props.form, _reducer.initialState) ? (0, _createInitialState2.default)(initialValues, config.fields, {}, true, false) : props.form;
        _this.fields = (0, _readFields2.default)(_extends({}, props, { form: form }), {}, {}, _this.asyncValidate, isReactNative);
        submitPassback(function () {
          return _this.handleSubmit();
        }); // wrapped in function to disallow params
        return _this;
      }

      ReduxForm.prototype.componentWillMount = function componentWillMount() {
        var _props = this.props,
            fields = _props.fields,
            form = _props.form,
            initialize = _props.initialize,
            initialValues = _props.initialValues;

        if (initialValues && !form._initialized) {
          initialize(initialValues, fields);
        }
      };

      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
        }
        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
        }
      };

      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
        if (config.destroyOnUnmount) {
          this.props.destroy();
        }
      };

      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
        var _this2 = this;

        var _props2 = this.props,
            alwaysAsyncValidate = _props2.alwaysAsyncValidate,
            asyncValidate = _props2.asyncValidate,
            dispatch = _props2.dispatch,
            fields = _props2.fields,
            form = _props2.form,
            startAsyncValidation = _props2.startAsyncValidation,
            stopAsyncValidation = _props2.stopAsyncValidation,
            validate = _props2.validate;

        var isSubmitting = !name;
        if (asyncValidate) {
          var values = (0, _getValues2.default)(fields, form);
          if (name) {
            values[name] = value;
          }
          var syncErrors = validate(values, this.props);
          var allPristine = this.fields._meta.allPristine;

          var initialized = form._initialized;

          // if blur validating, only run async validate if sync validation passes
          // and submitting (not blur validation) or form is dirty or form was never initialized
          // unless alwaysAsyncValidate is true
          var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
          if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
            return (0, _asyncValidation2.default)(function () {
              return asyncValidate(values, dispatch, _this2.props);
            }, startAsyncValidation, stopAsyncValidation, name);
          }
        }
      };

      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
        var _this3 = this;

        var _props3 = this.props,
            onSubmit = _props3.onSubmit,
            fields = _props3.fields,
            form = _props3.form;

        var check = function check(submit) {
          if (!submit || typeof submit !== 'function') {
            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
          }
          return submit;
        };
        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
        // submitOrEvent is an event: fire submit
        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
        // submitOrEvent is the submit function: return deferred submit thunk
        (0, _silenceEvents2.default)(function () {
          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
        });
      };

      ReduxForm.prototype.render = function render() {
        var _this4 = this,
            _ref2;

        var allFields = this.fields;

        var _props4 = this.props,
            addArrayValue = _props4.addArrayValue,
            asyncBlurFields = _props4.asyncBlurFields,
            autofill = _props4.autofill,
            blur = _props4.blur,
            change = _props4.change,
            destroy = _props4.destroy,
            focus = _props4.focus,
            fields = _props4.fields,
            form = _props4.form,
            initialValues = _props4.initialValues,
            initialize = _props4.initialize,
            onSubmit = _props4.onSubmit,
            propNamespace = _props4.propNamespace,
            reset = _props4.reset,
            removeArrayValue = _props4.removeArrayValue,
            returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise,
            startAsyncValidation = _props4.startAsyncValidation,
            startSubmit = _props4.startSubmit,
            stopAsyncValidation = _props4.stopAsyncValidation,
            stopSubmit = _props4.stopSubmit,
            submitFailed = _props4.submitFailed,
            swapArrayValues = _props4.swapArrayValues,
            touch = _props4.touch,
            untouch = _props4.untouch,
            validate = _props4.validate,
            passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare


        var _allFields$_meta = allFields._meta,
            allPristine = _allFields$_meta.allPristine,
            allValid = _allFields$_meta.allValid,
            errors = _allFields$_meta.errors,
            formError = _allFields$_meta.formError,
            values = _allFields$_meta.values;


        var props = {
          // State:
          active: form._active,
          asyncValidating: form._asyncValidating,
          dirty: !allPristine,
          error: formError,
          errors: errors,
          fields: allFields,
          formKey: formKey,
          invalid: !allValid,
          pristine: allPristine,
          submitting: form._submitting,
          submitFailed: form._submitFailed,
          valid: allValid,
          values: values,

          // Actions:
          asyncValidate: (0, _silenceEvents2.default)(function () {
            return _this4.asyncValidate();
          }),
          // ^ doesn't just pass this.asyncValidate to disallow values passing
          destroyForm: (0, _silenceEvents2.default)(destroy),
          handleSubmit: this.handleSubmit,
          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
            return initialize(initValues, fields);
          }),
          resetForm: (0, _silenceEvents2.default)(reset),
          touch: (0, _silenceEvents2.default)(function () {
            return touch.apply(undefined, arguments);
          }),
          touchAll: (0, _silenceEvents2.default)(function () {
            return touch.apply(undefined, fields);
          }),
          untouch: (0, _silenceEvents2.default)(function () {
            return untouch.apply(undefined, arguments);
          }),
          untouchAll: (0, _silenceEvents2.default)(function () {
            return untouch.apply(undefined, fields);
          })
        };
        var passedProps = propNamespace ? (_ref2 = {}, _ref2[propNamespace] = props, _ref2) : props;
        if (withRef) {
          return React.createElement(WrappedComponent, _extends({}, _extends({}, passableProps, passedProps), { ref: 'wrappedInstance' }));
        }
        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
      };

      return ReduxForm;
    }(Component);

    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
    ReduxForm.WrappedComponent = WrappedComponent;
    ReduxForm.propTypes = {
      // props:
      alwaysAsyncValidate: _propTypes2.default.bool,
      asyncBlurFields: _propTypes2.default.arrayOf(_propTypes2.default.string),
      asyncValidate: _propTypes2.default.func,
      dispatch: _propTypes2.default.func.isRequired,
      fields: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
      form: _propTypes2.default.object,
      initialValues: _propTypes2.default.any,
      onSubmit: _propTypes2.default.func,
      onSubmitSuccess: _propTypes2.default.func,
      onSubmitFail: _propTypes2.default.func,
      overwriteOnInitialValuesChange: _propTypes2.default.bool.isRequired,
      propNamespace: _propTypes2.default.string,
      readonly: _propTypes2.default.bool,
      returnRejectedSubmitPromise: _propTypes2.default.bool,
      submitPassback: _propTypes2.default.func.isRequired,
      validate: _propTypes2.default.func,

      // actions:
      addArrayValue: _propTypes2.default.func.isRequired,
      autofill: _propTypes2.default.func.isRequired,
      blur: _propTypes2.default.func.isRequired,
      change: _propTypes2.default.func.isRequired,
      destroy: _propTypes2.default.func.isRequired,
      focus: _propTypes2.default.func.isRequired,
      initialize: _propTypes2.default.func.isRequired,
      removeArrayValue: _propTypes2.default.func.isRequired,
      reset: _propTypes2.default.func.isRequired,
      startAsyncValidation: _propTypes2.default.func.isRequired,
      startSubmit: _propTypes2.default.func.isRequired,
      stopAsyncValidation: _propTypes2.default.func.isRequired,
      stopSubmit: _propTypes2.default.func.isRequired,
      submitFailed: _propTypes2.default.func.isRequired,
      swapArrayValues: _propTypes2.default.func.isRequired,
      touch: _propTypes2.default.func.isRequired,
      untouch: _propTypes2.default.func.isRequired
    };
    ReduxForm.defaultProps = {
      asyncBlurFields: [],
      form: _reducer.initialState,
      readonly: false,
      returnRejectedSubmitPromise: false,
      validate: function validate() {
        return {};
      }
    };

    // bind touch flags to blur and change
    var unboundActions = _extends({}, importedActions, {
      blur: (0, _bindActionData2.default)(importedActions.blur, {
        touch: !!config.touchOnBlur
      }),
      change: (0, _bindActionData2.default)(importedActions.change, {
        touch: !!config.touchOnChange
      })
    });

    // make redux connector with or without form key
    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
      var formState = getFormState(state, reduxMountPoint);
      if (!formState) {
        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
      }
      return formState && formState[formName] && formState[formName][formKey];
    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
      form: formName,
      key: formKey
    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
      var formState = getFormState(state, reduxMountPoint);
      if (!formState) {
        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
      }
      return formState && formState[formName];
    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);

    return decorate(ReduxForm);
  };
};

exports.default = createHigherOrderComponent;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _readField = __webpack_require__(568);

var _readField2 = _interopRequireDefault(_readField);

var _write = __webpack_require__(300);

var _write2 = _interopRequireDefault(_write);

var _getValues = __webpack_require__(307);

var _getValues2 = _interopRequireDefault(_getValues);

var _removeField = __webpack_require__(576);

var _removeField2 = _interopRequireDefault(_removeField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Reads props and generates (or updates) field structure
 */
var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
  var fields = props.fields,
      form = props.form,
      validate = props.validate;

  var previousFields = previousProps.fields;
  var values = (0, _getValues2.default)(fields, form);
  var syncErrors = validate(values, props) || {};
  var errors = {};
  var formError = syncErrors._error || form._error;
  var allValid = !formError;
  var allPristine = true;
  var tally = function tally(field) {
    if (field.error) {
      errors = (0, _write2.default)(field.name, field.error, errors);
      allValid = false;
    }
    if (field.dirty) {
      allPristine = false;
    }
  };
  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
  }, _extends({}, myFields)) : _extends({}, myFields);
  fields.forEach(function (name) {
    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
  });
  Object.defineProperty(fieldObjects, '_meta', {
    value: {
      allPristine: allPristine,
      allValid: allValid,
      values: values,
      errors: errors,
      formError: formError
    }
  });
  return fieldObjects;
};
exports.default = readFields;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createOnBlur = __webpack_require__(569);

var _createOnBlur2 = _interopRequireDefault(_createOnBlur);

var _createOnChange = __webpack_require__(570);

var _createOnChange2 = _interopRequireDefault(_createOnChange);

var _createOnDragStart = __webpack_require__(310);

var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);

var _createOnDrop = __webpack_require__(571);

var _createOnDrop2 = _interopRequireDefault(_createOnDrop);

var _createOnFocus = __webpack_require__(572);

var _createOnFocus2 = _interopRequireDefault(_createOnFocus);

var _silencePromise = __webpack_require__(573);

var _silencePromise2 = _interopRequireDefault(_silencePromise);

var _read = __webpack_require__(299);

var _read2 = _interopRequireDefault(_read);

var _updateField = __webpack_require__(574);

var _updateField2 = _interopRequireDefault(_updateField);

var _isChecked = __webpack_require__(311);

var _isChecked2 = _interopRequireDefault(_isChecked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSuffix(input, closeIndex) {
  var suffix = input.substring(closeIndex + 1);
  if (suffix[0] === '.') {
    suffix = suffix.substring(1);
  }
  return suffix;
}

var getNextKey = function getNextKey(path) {
  var dotIndex = path.indexOf('.');
  var openIndex = path.indexOf('[');
  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    return path.substring(0, openIndex);
  }
  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
};

var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
  return (
    // remove array indices
    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
  );
};

var readField = function readField(state, fieldName) {
  var pathToHere = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var fields = arguments[3];
  var syncErrors = arguments[4];
  var asyncValidate = arguments[5];
  var isReactNative = arguments[6];
  var props = arguments[7];
  var callback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function () {
    return null;
  };
  var prefix = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  var asyncBlurFields = props.asyncBlurFields,
      autofill = props.autofill,
      blur = props.blur,
      change = props.change,
      focus = props.focus,
      form = props.form,
      initialValues = props.initialValues,
      readonly = props.readonly,
      addArrayValue = props.addArrayValue,
      removeArrayValue = props.removeArrayValue,
      swapArrayValues = props.swapArrayValues;

  var dotIndex = fieldName.indexOf('.');
  var openIndex = fieldName.indexOf('[');
  var closeIndex = fieldName.indexOf(']');
  if (openIndex > 0 && closeIndex !== openIndex + 1) {
    throw new Error('found [ not followed by ]');
  }

  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    // array field
    var key = fieldName.substring(0, openIndex);
    var rest = getSuffix(fieldName, closeIndex);
    var stateArray = state && state[key] || [];
    var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
    var subfields = props.fields.reduce(function (accumulator, field) {
      if (field.indexOf(fullPrefix) === 0) {
        accumulator.push(field);
      }
      return accumulator;
    }, []).map(function (field) {
      return getSuffix(field, prefix.length + closeIndex);
    });
    var addMethods = function addMethods(dest) {
      Object.defineProperty(dest, 'addField', {
        value: function value(_value, index) {
          return addArrayValue(pathToHere + key, _value, index, subfields);
        }
      });
      Object.defineProperty(dest, 'removeField', {
        value: function value(index) {
          return removeArrayValue(pathToHere + key, index);
        }
      });
      Object.defineProperty(dest, 'swapFields', {
        value: function value(indexA, indexB) {
          return swapArrayValues(pathToHere + key, indexA, indexB);
        }
      });
      return dest;
    };
    if (!fields[key] || fields[key].length !== stateArray.length) {
      fields[key] = fields[key] ? [].concat(fields[key]) : [];
      addMethods(fields[key]);
    }
    var fieldArray = fields[key];
    var changed = false;
    stateArray.forEach(function (fieldState, index) {
      if (rest && !fieldArray[index]) {
        fieldArray[index] = {};
        changed = true;
      }
      var dest = rest ? fieldArray[index] : {};
      var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
      var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');

      var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
      if (fieldArray[index] !== result) {
        if (rest) {
          // if something's after [] in field name, the array item is an object field
          // we need it to compare !== to the original (so react re-renders appropriately)
          result = _extends({}, dest);
        }
        fieldArray[index] = result;
        changed = true;
      }
    });
    if (fieldArray.length > stateArray.length) {
      // remove extra items that aren't in state array
      fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
    }
    if (changed) {
      fieldArray = addMethods([].concat(fieldArray));
    }
    fields[key] = fieldArray;
    return fieldArray;
  }
  if (dotIndex > 0) {
    // subobject field
    var _key = fieldName.substring(0, dotIndex);
    var _rest = fieldName.substring(dotIndex + 1);
    var subobject = fields[_key] || {};
    var nextPath = pathToHere + _key + '.';
    var nextKey = getNextKey(_rest);
    var nextPrefix = prefix + _key + '.';
    var previous = subobject[nextKey];
    var result = readField(state[_key] || {}, _rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
    if (result !== previous) {
      var _extends2;

      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
    }
    fields[_key] = subobject;
    return subobject;
  }
  var name = pathToHere + fieldName;
  var field = fields[fieldName] || {};
  if (field.name !== name) {
    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
    var initialFormValue = (0, _read2.default)(name + '.initial', form);
    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
    initialValue = initialValue === undefined ? '' : initialValue;
    field.name = name;
    field.checked = (0, _isChecked2.default)(initialValue);
    field.value = initialValue;
    field.initialValue = initialValue;
    if (!readonly) {
      field.autofill = function (value) {
        return autofill(name, value);
      };
      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
      });
      field.onChange = onChange;
      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
        return field.value;
      });
      field.onDrop = (0, _createOnDrop2.default)(name, change);
      field.onFocus = (0, _createOnFocus2.default)(name, focus);
      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
    }
    field.valid = true;
    field.invalid = false;
    Object.defineProperty(field, '_isField', { value: true });
  }

  var fieldState = (fieldName ? state[fieldName] : state) || {};
  var syncError = (0, _read2.default)(name, syncErrors);
  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
  if (fieldName || fields[fieldName] !== updated) {
    fields[fieldName] = updated;
  }
  callback(updated);
  return updated;
};

exports.default = readField;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getValue = __webpack_require__(308);

var _getValue2 = _interopRequireDefault(_getValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
  return function (event) {
    var value = (0, _getValue2.default)(event, isReactNative);
    blur(name, value);
    if (afterBlur) {
      afterBlur(name, value);
    }
  };
};
exports.default = createOnBlur;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getValue = __webpack_require__(308);

var _getValue2 = _interopRequireDefault(_getValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createOnChange = function createOnChange(name, change, isReactNative) {
  return function (event) {
    return change(name, (0, _getValue2.default)(event, isReactNative));
  };
};
exports.default = createOnChange;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createOnDragStart = __webpack_require__(310);

var createOnDrop = function createOnDrop(name, change) {
  return function (event) {
    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
  };
};
exports.default = createOnDrop;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var createOnFocus = function createOnFocus(name, focus) {
  return function () {
    return focus(name);
  };
};
exports.default = createOnFocus;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isPromise = __webpack_require__(193);

var _isPromise2 = _interopRequireDefault(_isPromise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {
  return undefined;
};

var silencePromise = function silencePromise(promise) {
  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
};

exports.default = silencePromise;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isPristine = __webpack_require__(575);

var _isPristine2 = _interopRequireDefault(_isPristine);

var _isValid = __webpack_require__(134);

var _isValid2 = _interopRequireDefault(_isValid);

var _isChecked = __webpack_require__(311);

var _isChecked2 = _interopRequireDefault(_isChecked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Updates a field object from the store values
 */
var updateField = function updateField(field, formField, active, syncError) {
  var diff = {};
  var formFieldValue = formField.value === undefined ? '' : formField.value;

  // update field value
  if (field.value !== formFieldValue) {
    diff.value = formFieldValue;
    diff.checked = (0, _isChecked2.default)(formFieldValue);
  }

  // update dirty/pristine
  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
  if (field.pristine !== pristine) {
    diff.dirty = !pristine;
    diff.pristine = pristine;
  }

  // update field error
  var error = syncError || formField.submitError || formField.asyncError;
  if (error !== field.error) {
    diff.error = error;
  }
  var valid = (0, _isValid2.default)(error);
  if (field.valid !== valid) {
    diff.invalid = !valid;
    diff.valid = valid;
  }

  if (active !== field.active) {
    diff.active = active;
  }
  var touched = !!formField.touched;
  if (touched !== field.touched) {
    diff.touched = touched;
  }
  var visited = !!formField.visited;
  if (visited !== field.visited) {
    diff.visited = visited;
  }
  var autofilled = !!formField.autofilled;
  if (autofilled !== field.autofilled) {
    diff.autofilled = autofilled;
  }

  if ('initial' in formField && formField.initial !== field.initialValue) {
    field.initialValue = formField.initial;
  }

  return Object.keys(diff).length ? _extends({}, field, diff) : field;
};
exports.default = updateField;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isPristine;
function isPristine(initial, data) {
  if (initial === data) {
    return true;
  }
  if (typeof initial === 'boolean' || typeof data === 'boolean') {
    return initial === data;
  } else if (initial instanceof Date && data instanceof Date) {
    return initial.getTime() === data.getTime();
  } else if (initial && typeof initial === 'object') {
    if (!data || typeof data !== 'object') {
      return false;
    }
    var initialKeys = Object.keys(initial);
    var dataKeys = Object.keys(data);
    if (initialKeys.length !== dataKeys.length) {
      return false;
    }
    for (var index = 0; index < dataKeys.length; index++) {
      var key = dataKeys[index];
      if (!isPristine(initial[key], data[key])) {
        return false;
      }
    }
  } else if (initial || data) {
    // allow '' to equate to undefined or null
    return initial === data;
  } else if (initial === null && data === 0 || initial === 0 && data === null) {
    return false;
  }
  return true;
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var without = function without(object, key) {
  var copy = _extends({}, object);
  delete copy[key];
  return copy;
};

var removeField = function removeField(fields, path) {
  var dotIndex = path.indexOf('.');
  var openIndex = path.indexOf('[');
  var closeIndex = path.indexOf(']');
  if (openIndex > 0 && closeIndex !== openIndex + 1) {
    throw new Error('found [ not followed by ]');
  }
  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    // array field
    var key = path.substring(0, openIndex);
    if (!Array.isArray(fields[key])) {
      return without(fields, key);
    }
    var rest = path.substring(closeIndex + 1);
    if (rest[0] === '.') {
      rest = rest.substring(1);
    }
    if (rest) {
      var _extends2;

      var copy = [];
      fields[key].forEach(function (item, index) {
        var result = removeField(item, rest);
        if (Object.keys(result).length) {
          copy[index] = result;
        }
      });
      return copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key);
    }
    return without(fields, key);
  }
  if (dotIndex > 0) {
    var _extends3;

    // subobject field
    var _key = path.substring(0, dotIndex);
    var _rest = path.substring(dotIndex + 1);
    if (!fields[_key]) {
      return fields;
    }
    var result = removeField(fields[_key], _rest);
    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[_key] = removeField(fields[_key], _rest), _extends3)) : without(fields, _key);
  }
  return without(fields, path);
};

exports.default = removeField;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isPromise = __webpack_require__(193);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _isValid = __webpack_require__(134);

var _isValid2 = _interopRequireDefault(_isValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
  var dispatch = props.dispatch,
      fields = props.fields,
      onSubmitSuccess = props.onSubmitSuccess,
      onSubmitFail = props.onSubmitFail,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      submitFailed = props.submitFailed,
      returnRejectedSubmitPromise = props.returnRejectedSubmitPromise,
      touch = props.touch,
      validate = props.validate;

  var syncErrors = validate(values, props);
  touch.apply(undefined, fields); // touch all fields
  if ((0, _isValid2.default)(syncErrors)) {
    var doSubmit = function doSubmit() {
      var result = submit(values, dispatch, props);
      if ((0, _isPromise2.default)(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult);
          }
          return submitResult;
        }, function (submitError) {
          stopSubmit(submitError);
          if (onSubmitFail) {
            onSubmitFail(submitError);
          }
          if (returnRejectedSubmitPromise) {
            return Promise.reject(submitError);
          }
        });
      }
      if (onSubmitSuccess) {
        onSubmitSuccess(result);
      }
      return result;
    };
    var asyncValidateResult = asyncValidate();
    return (0, _isPromise2.default)(asyncValidateResult) ?
    // asyncValidateResult will be rejected if async validation failed
    asyncValidateResult.then(doSubmit, function () {
      submitFailed();
      if (onSubmitFail) {
        onSubmitFail();
      }
      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
    }) : doSubmit(); // no async validation, so submit
  }
  submitFailed();

  if (onSubmitFail) {
    onSubmitFail(syncErrors);
  }

  if (returnRejectedSubmitPromise) {
    return Promise.reject(syncErrors);
  }
};

exports.default = handleSubmit;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isPromise = __webpack_require__(193);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _isValid = __webpack_require__(134);

var _isValid2 = _interopRequireDefault(_isValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!(0, _isPromise2.default)(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (!(0, _isValid2.default)(errors)) {
        stop(errors);
        return Promise.reject();
      } else if (rejected) {
        stop();
        throw new Error('Asynchronous validation promise was rejected without errors.');
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

exports.default = asyncValidation;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _silenceEvent = __webpack_require__(312);

var _silenceEvent2 = _interopRequireDefault(_silenceEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

exports.default = silenceEvents;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(6);

var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
  if (mapDispatchToProps) {
    if (typeof mapDispatchToProps === 'function') {
      if (mapDispatchToProps.length > 1) {
        return function (dispatch, ownProps) {
          return _extends({
            dispatch: dispatch
          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
        };
      }
      return function (dispatch) {
        return _extends({
          dispatch: dispatch
        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
      };
    }
    return function (dispatch) {
      return _extends({
        dispatch: dispatch
      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
    };
  }
  return function (dispatch) {
    return _extends({
      dispatch: dispatch
    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
  };
};

exports.default = wrapMapDispatchToProps;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
  if (mapStateToProps) {
    if (typeof mapStateToProps !== 'function') {
      throw new Error('mapStateToProps must be a function');
    }
    if (mapStateToProps.length > 1) {
      return function (state, ownProps) {
        return _extends({}, mapStateToProps(state, ownProps), {
          form: getForm(state)
        });
      };
    }
    return function (state) {
      return _extends({}, mapStateToProps(state), {
        form: getForm(state)
      });
    };
  }
  return function (state) {
    return {
      form: getForm(state)
    };
  };
};

exports.default = wrapMapStateToProps;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createPropTypes = function createPropTypes() {
  return {
    // State:
    active: _propTypes2.default.string, // currently active field
    asyncValidating: _propTypes2.default.bool.isRequired, // true if async validation is running
    autofilled: _propTypes2.default.bool, // true if set programmatically by autofill
    dirty: _propTypes2.default.bool.isRequired, // true if any values are different from initialValues
    error: _propTypes2.default.any, // form-wide error from '_error' key in validation result
    errors: _propTypes2.default.object, // a map of errors corresponding to structure of form data (result of validation)
    fields: _propTypes2.default.object.isRequired, // the map of fields
    formKey: _propTypes2.default.any, // the form key if one was provided (used when doing multirecord forms)
    invalid: _propTypes2.default.bool.isRequired, // true if there are any validation errors
    pristine: _propTypes2.default.bool.isRequired, // true if the values are the same as initialValues
    submitting: _propTypes2.default.bool.isRequired, // true if the form is in the process of being submitted
    submitFailed: _propTypes2.default.bool.isRequired, // true if the form was submitted and failed for any reason
    valid: _propTypes2.default.bool.isRequired, // true if there are no validation errors
    values: _propTypes2.default.object.isRequired, // the values of the form as they will be submitted

    // Actions:
    asyncValidate: _propTypes2.default.func.isRequired, // function to trigger async validation
    destroyForm: _propTypes2.default.func.isRequired, // action to destroy the form's data in Redux
    handleSubmit: _propTypes2.default.func.isRequired, // function to submit the form
    initializeForm: _propTypes2.default.func.isRequired, // action to initialize form data
    resetForm: _propTypes2.default.func.isRequired, // action to reset the form data to previously initialized values
    touch: _propTypes2.default.func.isRequired, // action to mark fields as touched
    touchAll: _propTypes2.default.func.isRequired, // action to mark ALL fields as touched
    untouch: _propTypes2.default.func.isRequired, // action to mark fields as untouched
    untouchAll: _propTypes2.default.func.isRequired // action to mark ALL fields as untouched
  };
};

exports.default = createPropTypes;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createUser = __webpack_require__(79);

var _updateUser = __webpack_require__(70);

var _setCurrentUser = __webpack_require__(80);

var _userSocket = __webpack_require__(78);

var _logoutMember = __webpack_require__(129);

var _setAuth = __webpack_require__(245);

var _updateUserPrivacyStatus = __webpack_require__(389);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  switch (type) {
    case _setCurrentUser.SET_CURRENT_USER:
    case _createUser.CREATE_USER_SUCCESS:
      return _extends({}, state || {}, payload);
    case _updateUser.UPDATE_USER_SUCCESS:
    case _userSocket.USER_SET_PERMISSIONS:
      return state && state._id === payload._id ? _extends({}, state, payload) : state;
    case _logoutMember.LOGOUT_MEMBER_SUCCESS:
      return null;
    case _setAuth.SET_AUTH:
      return _extends({}, state, payload.currentUser);
    case _updateUserPrivacyStatus.UPDATE_USER_PRIVACY_STATUS:
      return _extends({}, state, {
        privacyStatus: payload
      });
    default:
      return state;
  }
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fetchUserSettings = __webpack_require__(531);

var _updateUserSettings = __webpack_require__(532);

var _logoutMember = __webpack_require__(129);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  switch (type) {
    case _fetchUserSettings.FETCH_USER_SETTINGS_SUCCESS:
    case _updateUserSettings.UPDATE_USER_SETTINGS_REQUEST:
      return payload;
    case _logoutMember.LOGOUT_MEMBER_SUCCESS:
      return null;
    default:
      return state;
  }
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createUser = __webpack_require__(79);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _ref = arguments[1];
  var type = _ref.type;

  switch (type) {
    case _createUser.CREATE_USER_REQUEST:
      return true;
    case _createUser.CREATE_USER_SUCCESS:
    case _createUser.CREATE_USER_FAILURE:
      return false;
    default:
      return state;
  }
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createUser = __webpack_require__(79);

var _setCurrentUser = __webpack_require__(80);

var _logoutMember = __webpack_require__(129);

var _setAuth = __webpack_require__(245);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _setCurrentUser.SET_CURRENT_USER:
    case _createUser.CREATE_USER_SUCCESS:
      return true;
    case _logoutMember.LOGOUT_MEMBER_SUCCESS:
      return false;
    case _setAuth.SET_AUTH:
      return Boolean(payload.isAuthenticated);
    default:
      return state;
  }
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = isLoaded;

var _setIsLoaded = __webpack_require__(198);

var _fetchComments = __webpack_require__(136);

var _fetchPosts = __webpack_require__(138);

var _fetchPostsByOwnerId = __webpack_require__(130);

var _fetchNotifications = __webpack_require__(158);

var _fetchPost = __webpack_require__(165);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isLoaded() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _setIsLoaded.SET_IS_LOADED:
      return setIsLoaded(state, action.payload);

    case _fetchPostsByOwnerId.FETCH_USER_POSTS_SUCCESS:
    case _fetchPostsByOwnerId.FETCH_USER_POSTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'profile-posts',
        id: action.payload.ownerId,
        isLoaded: true
      });

    case _fetchPost.FETCH_POST_SUCCESS:
    case _fetchPost.FETCH_POST_FAILURE:
      return setIsLoaded(state, {
        entity: 'post',
        id: action.payload.postSlug,
        isLoaded: true
      });

    case _fetchPosts.FETCH_POSTS_SUCCESS:
    case _fetchPosts.FETCH_POSTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'posts',
        id: action.meta.categoryId,
        isLoaded: true
      });

    case _fetchComments.FETCH_COMMENTS_SUCCESS:
    case _fetchComments.FETCH_COMMENTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'comments',
        id: action.payload.postSlug,
        isLoaded: true
      });

    case _fetchNotifications.FETCH_NOTIFICATIONS_SUCCESS:
    case _fetchNotifications.FETCH_NOTIFICATIONS_FAILURE:
      return setIsLoaded(state, {
        entity: 'notifications',
        isLoaded: true
      });

    default:
      return state;
  }
}

function setIsLoaded(state, _ref) {
  var entity = _ref.entity,
      _ref$id = _ref.id,
      id = _ref$id === undefined ? '' : _ref$id,
      isLoaded = _ref.isLoaded;

  return _extends({}, state, _defineProperty({}, entity, _extends({}, state[entity], _defineProperty({}, id, isLoaded))));
}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = isLoading;

var _setIsLoading = __webpack_require__(418);

var _fetchPost = __webpack_require__(165);

var _fetchPosts = __webpack_require__(138);

var _fetchPostsByOwnerId = __webpack_require__(130);

var _fetchComments = __webpack_require__(136);

var _fetchMembers = __webpack_require__(199);

var _fetchNotifications = __webpack_require__(158);

var _fetchSearch = __webpack_require__(131);

var _search = __webpack_require__(394);

var _fetchFollowers = __webpack_require__(195);

var _fetchFollowing = __webpack_require__(196);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line complexity
function isLoading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _setIsLoading.SET_IS_LOADING:
      return setIsLoading(state, action.payload);
    case _fetchPost.FETCH_POST_REQUEST:
      {
        return setIsLoading(state, {
          entity: 'post',
          id: action.payload.postSlug,
          isLoading: true
        });
      }
    case _fetchPost.FETCH_POST_SUCCESS:
    case _fetchPost.FETCH_POST_FAILURE:
      return setIsLoading(state, {
        entity: 'post',
        id: action.payload.postSlug,
        isLoading: false
      });

    case _fetchPostsByOwnerId.FETCH_USER_POSTS_REQUEST:
      {
        return setIsLoading(state, {
          entity: 'profile-posts',
          isLoading: true
        });
      }
    case _fetchPostsByOwnerId.FETCH_USER_POSTS_SUCCESS:
    case _fetchPostsByOwnerId.FETCH_USER_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'profile-posts',
        isLoading: false
      });
    case _fetchPosts.FETCH_POSTS_REQUEST:
      {
        return setIsLoading(state, {
          entity: 'posts',
          isLoading: true
        });
      }
    case _fetchPosts.FETCH_POSTS_SUCCESS:
    case _fetchPosts.FETCH_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'posts',
        isLoading: false
      });
    case _fetchComments.FETCH_COMMENTS_REQUEST:
      {
        return setIsLoading(state, {
          entity: 'comments',
          id: action.payload.postSlug,
          isLoading: true
        });
      }
    case _fetchComments.FETCH_COMMENTS_SUCCESS:
    case _fetchComments.FETCH_COMMENTS_FAILURE:
      return setIsLoading(state, {
        entity: 'comments',
        id: action.payload.postSlug,
        isLoading: false
      });

    case _fetchMembers.FETCH_MEMBERS_REQUEST:
      {
        return setIsLoading(state, {
          entity: 'members',
          isLoading: true
        });
      }
    case _fetchMembers.FETCH_MEMBERS_SUCCESS:
    case _fetchMembers.FETCH_MEMBERS_FAILURE:
      return setIsLoading(state, {
        entity: 'members',
        isLoading: false
      });

    case _fetchNotifications.FETCH_NOTIFICATIONS_REQUEST:
      return setIsLoading(state, {
        entity: 'notifications',
        isLoading: true
      });
    case _fetchNotifications.FETCH_NOTIFICATIONS_SUCCESS:
    case _fetchNotifications.FETCH_NOTIFICATIONS_FAILURE:
      return setIsLoading(state, {
        entity: 'notifications',
        isLoading: false
      });

    case _fetchSearch.FETCH_SEARCH_SUCCESS:
    case _fetchSearch.FETCH_SEARCH_FAILURE:
    case _search.SEARCH_CLEAR_RESULTS:
      return setIsLoading(state, {
        entity: 'search',
        isLoading: false
      });

    case _fetchFollowers.FETCH_FOLLOWERS_REQUEST:
      return setIsLoading(state, {
        entity: 'followers',
        isLoading: true
      });

    case _fetchFollowers.FETCH_FOLLOWERS_FAILURE:
    case _fetchFollowers.FETCH_FOLLOWERS_SUCCESS:
      return setIsLoading(state, {
        entity: 'followers',
        isLoading: false
      });

    case _fetchFollowing.FETCH_FOLLOWING_REQUEST:
      return setIsLoading(state, {
        entity: 'following',
        isLoading: true
      });

    case _fetchFollowing.FETCH_FOLLOWING_FAILURE:
    case _fetchFollowing.FETCH_FOLLOWING_SUCCESS:
      return setIsLoading(state, {
        entity: 'following',
        isLoading: false
      });

    default:
      return state;
  }
}

function setIsLoading(state, _ref) {
  var entity = _ref.entity,
      _ref$id = _ref.id,
      id = _ref$id === undefined ? '' : _ref$id,
      isLoading = _ref.isLoading;

  return _extends({}, state, _defineProperty({}, entity, _extends({}, state[entity], _defineProperty({}, id, isLoading))));
}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _showMessage = __webpack_require__(159);

var _hideMessage = __webpack_require__(395);

var initialState = {};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _showMessage.SHOW_MESSAGE:
      return action.payload;
    case _hideMessage.HIDE_MESSAGE:
      return initialState;
    default:
      return state;
  }
};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _fetchPosts = __webpack_require__(138);

var _fetchPostsByOwnerId = __webpack_require__(130);

var _fetchComments = __webpack_require__(136);

var _pagination = __webpack_require__(45);

var _pagination2 = __webpack_require__(166);

var _fetchComment = __webpack_require__(313);

var _createComment = __webpack_require__(176);

var _commentSocket = __webpack_require__(314);

var _deleteComment = __webpack_require__(137);

var _deletePost = __webpack_require__(132);

var _movePost = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  comments: {
    entitiesByPage: {},
    entityCount: 0
  },
  posts: {
    entitiesByPage: {},
    entityCount: 0
  }
};

var getNewEntities = function getNewEntities(state, entities, meta) {
  return {
    entitiesByPage: _defineProperty({}, meta.page, entities.map(function (entity) {
      return entity._id;
    })),
    entityCount: meta.entityCount
  };
};

var appendComment = function appendComment(state, comment) {
  var newEntityCount = state.entityCount + 1;
  var lastPage = (0, _pagination.getLastPage)(newEntityCount, _pagination2.COMMENTS_PER_PAGE);
  var tempEntities = state.entitiesByPage[lastPage] || [];
  return _extends({}, state.comments, {
    entitiesByPage: _extends({}, state.entitiesByPage, _defineProperty({}, lastPage, [].concat(_toConsumableArray(tempEntities), [comment._id]))),
    entityCount: newEntityCount
  });
};

var removePost = function removePost(entitiesByPage, deletedPostId) {
  return _lodash2.default.reduce(entitiesByPage, function (acc, ids, page) {
    return _extends({}, acc, _defineProperty({}, page, _lodash2.default.filter(ids, function (postId) {
      return postId !== deletedPostId;
    })));
  }, {});
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload,
      _ref$meta = _ref.meta,
      meta = _ref$meta === undefined ? {} : _ref$meta;

  switch (type) {
    case _fetchPostsByOwnerId.FETCH_USER_POSTS_SUCCESS:
    case _fetchPosts.FETCH_POSTS_SUCCESS:
      return _extends({}, state, {
        posts: getNewEntities(state.posts, payload, meta)
      });
    case _movePost.MOVE_POST_SUCCESS:
    case _deletePost.DELETE_POST_SUCCESS:
      return _extends({}, state, {
        posts: {
          entitiesByPage: removePost(state.posts.entitiesByPage, payload),
          entityCount: state.posts.entityCount - 1
        }
      });
    case _fetchComments.FETCH_COMMENTS_SUCCESS:
      return _extends({}, state, {
        comments: getNewEntities(state.comments, payload.comments, meta)
      });
    case _createComment.CREATE_COMMENT_SUCCESS:
    case _commentSocket.NEW_COMMENT:
      return _extends({}, state, {
        comments: appendComment(state.comments, payload)
      });
    case _fetchComment.FETCH_COMMENT_SUCCESS:
      return _extends({}, state, {
        comments: appendComment(state.comments, payload.comment)
      });
    case _deleteComment.DELETE_COMMENT_SUCCESS:
      return _extends({}, state, {
        comments: _extends({}, state.comments, {
          entityCount: state.comments.entityCount - 1
        })
      });
    default:
      return state;
  }
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePost = exports.SOCKET_UPDATE_POST = exports.UPDATE_POST = exports.emitClosePost = exports.emitOpenPost = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _wsActions = __webpack_require__(128);

var _wsChannel = __webpack_require__(151);

var emitOpenPost = exports.emitOpenPost = function emitOpenPost(post) {
  return (0, _wsActions.joinChannel)((0, _wsChannel.getChannel)(_extends({ type: 'post' }, post)));
};
var emitClosePost = exports.emitClosePost = function emitClosePost(post) {
  return (0, _wsActions.leaveChannel)((0, _wsChannel.getChannel)(_extends({ type: 'post' }, post)));
};

var UPDATE_POST = exports.UPDATE_POST = 'post/UPDATE';
var SOCKET_UPDATE_POST = exports.SOCKET_UPDATE_POST = 'update post';
var updatePost = exports.updatePost = function updatePost(payload) {
  return {
    type: UPDATE_POST,
    payload: payload
  };
};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setSiteInfo = __webpack_require__(452);

var initialState = {};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _setSiteInfo.SET_SITE_INFO:
      return action.payload;
    default:
      return state;
  }
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = viewMode;

var _setViewMode = __webpack_require__(256);

function viewMode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'site';
  var action = arguments[1];

  switch (action.type) {
    case _setViewMode.SET_VIEW_MODE:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EnvironmentProvider = function (_Component) {
  _inherits(EnvironmentProvider, _Component);

  function EnvironmentProvider() {
    _classCallCheck(this, EnvironmentProvider);

    return _possibleConstructorReturn(this, (EnvironmentProvider.__proto__ || Object.getPrototypeOf(EnvironmentProvider)).apply(this, arguments));
  }

  _createClass(EnvironmentProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { environment: this.props.environment };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return EnvironmentProvider;
}(_react.Component);

EnvironmentProvider.propTypes = {
  environment: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.element.isRequired
};

EnvironmentProvider.childContextTypes = {
  environment: _propTypes2.default.object.isRequired
};

exports.default = EnvironmentProvider;

/***/ }),
/* 595 */,
/* 596 */,
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.JsAcl = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

/**
 * @name AclRegistry
 * @constructs AclRegistry
 * @description Initializes a new ACL role registry
 */
function AclRegistry() {
    var self = this;
    var _storage = {};

    self.add = function (item, parents /*null*/) {
        parents = typeof parents === 'undefined' ? null : parents;

        if (self.has(item)) {
            throw new Error('Item "' + item + '" already exists in the registry');
        }

        var itemParents = [];

        if (parents !== null) {
            if (!Array.isArray(parents)) {
                parents = [parents];
            }

            parents.forEach(function (parent) {
                if (!self.has(parent)) {
                    throw new Error('Parent role "' + parent + '" for "' + item + '" not exists in the registry');
                }

                itemParents.push(parent);
                _storage[parent].children.push(item);
            });
        }

        _storage[item] = {
            id: item,
            parents: itemParents,
            children: []
        };

        return self;
    };

    self.get = function (item) {
        if (!self.has(item)) {
            throw new Error('Item "' + item + '" not exists in the registry');
        }

        return item;
    };

    self.has = function (item) {
        return _storage[item] !== undefined;
    };

    self.getParents = function (item) {
        if (!self.has(item)) {
            throw new Error('Item "' + item + '" not exists in the registry');
        }

        return _storage[item].parents;
    };

    self.inherits = function (item, inherit, onlyParents /*false*/) {
        onlyParents = typeof onlyParents === 'undefined' ? false : onlyParents;

        if (!self.has(item) || !self.has(inherit)) {
            throw new Error('Items not exists in the registry');
        }

        var inherits = _storage[item].parents.indexOf(inherit) !== -1;

        if (inherits || onlyParents) {
            return inherits;
        }

        for (var i = 0; i < _storage[item].parents.length; i++) {
            var parent = _storage[item].parents[i];

            if (self.inherits(parent, inherit)) {
                return true;
            }
        }

        return false;
    };

    self.remove = function (item) {
        if (!self.has(item)) {
            throw new Error('Item "' + item + '" not exists in the registry');
        }

        _storage[item].children.forEach(function (child) {
            var index = _storage[child].parents.indexOf(item);
            if (index !== -1) {
                _storage[child].parents.splice(index, 1);
            }
        });
        _storage[item].parents.forEach(function (parent) {
            var index = _storage[parent].children.indexOf(item);
            if (index !== -1) {
                _storage[parent].children.splice(index, 1);
            }
        });

        delete _storage[item];

        return self;
    };

    self.removeAll = function () {
        _storage = {};

        return self;
    };

    self.getItems = function () {
        return JSON.parse(JSON.stringify(_storage));
    };

    return self;
}

module.exports = AclRegistry;
},{}],"/src/index.js":[function(_dereq_,module,exports){
/**
 * @interface AclResourceInterface
 */
/**
 * Returns the string identifier of the Resource
 *
 * @function
 * @name AclResourceInterface#getResourceId
 * @returns {string}
 */

/**
 * Role provider interface, provides existing roles list
 *
 * @interface AclRoleInterface
 */
/**
 * Returns array of the Role string identifiers
 *
 * @function
 * @name AclRoleInterface#getRoles
 * @returns {Array<string>}
 */


var AclRegistry = _dereq_('./acl-registry');

function Acl() {
    var self = this;

    self.TYPE_ALLOW = 'TYPE_ALLOW';
    self.TYPE_DENY  = 'TYPE_DENY';
    self.OP_ADD = 'OP_ADD';
    self.OP_REMOVE = 'OP_REMOVE';
    self.USER_IDENTITY_ROLE = 'acl.role';

    var _userIdentity = null,
        _roleRegistry = new AclRegistry(),// jshint ignore:line
        _resources = {},
        _rules = {
            allResources: {
                allRoles: {
                    allPrivileges: {
                        type: self.TYPE_DENY,
                        assert: null
                    },
                    byPrivilegeId: {}
                },
                byRoleId: {}
            },
            byResourceId: {}
        },
        _isAllowedResource = null,
        _isAllowedRole = null;

    /**
     * @returns {(AclRoleInterface|null)}
     */
    self.getUserIdentity = function () {
        return _userIdentity;
    };

    /**
     * @param {AclRoleInterface} identity
     * @returns {Acl} Provides a fluent interface
     */
    self.setUserIdentity = function (identity) {
        if (!(identity instanceof Object) || typeof identity.getRoles !== 'function') {
            throw new Error('Incorrect user identity');
        }

        if (self.hasRole(self.USER_IDENTITY_ROLE)) {
            self.removeRole(self.USER_IDENTITY_ROLE);
        }

        self.addRole(self.USER_IDENTITY_ROLE, identity.getRoles());

        _userIdentity = identity;

        return self;
    };

    self.clearUserIdentity = function () {
        _userIdentity = null;
        self.removeRole(self.USER_IDENTITY_ROLE);

        return self;
    };

    /**
     * @param {(string|AclResourceInterface)} [resource=null]
     * @param {string} [privilege=null]
     * @returns {boolean}
     */
    self.can = function (resource, privilege) {
        resource = typeof resource === 'undefined' ? null : resource;
        privilege = typeof privilege === 'undefined' ? null : privilege;

        if (self.getUserIdentity() === null) {
            throw new Error('User identity is null');
        }

        return self.isAllowed(self.USER_IDENTITY_ROLE, resource, privilege);
    };

    /**
     * Adds an "allow" rule to the ACL
     *
     * @param {(string|Array)} [roles=null]
     * @param {(string|Array)} [resources=null]
     * @param {(string|Array)} [privileges=null]
     * @param {AclAssertion} assert
     * @return {Acl} Provides a fluent interface
     */
    self.allow = function (roles /*null*/, resources /*null*/, privileges /*null*/, assert /*null*/) {
        roles = typeof roles === 'undefined' ? null : roles;
        resources = typeof resources === 'undefined' ? null : resources;
        privileges = typeof privileges === 'undefined' ? null : privileges;
        assert = typeof assert === 'undefined' ? null : assert;

        return setRule(self.OP_ADD, self.TYPE_ALLOW, roles, resources, privileges, assert);
    };

    /**
     * Adds a "deny" rule to the ACL
     *
     * @param {(string|Array)} [roles=null]
     * @param {(string|Array)} [resources=null]
     * @param {(string|Array)} [privileges=null]
     * @param {AclAssertion} assert
     * @return {Acl} Provides a fluent interface
     */
    self.deny = function (roles /*null*/, resources /*null*/, privileges /*null*/, assert /*null*/) {
        roles = typeof roles === 'undefined' ? null : roles;
        resources = typeof resources === 'undefined' ? null : resources;
        privileges = typeof privileges === 'undefined' ? null : privileges;
        assert = typeof assert === 'undefined' ? null : assert;

        return setRule(self.OP_ADD, self.TYPE_DENY, roles, resources, privileges, assert);
    };

    /**
     * Removes an "allow" rule from the ACL
     *
     * @param {(string|Array)} [roles=null]
     * @param {(string|Array)} [resources=null]
     * @param {(string|Array)} [privileges=null]
     * @param {AclAssertion} assert
     * @return {Acl} Provides a fluent interface
     */
    self.removeAllow = function (roles, resources, privileges, assert) {
        roles = typeof roles === 'undefined' ? null : roles;
        resources = typeof resources === 'undefined' ? null : resources;
        privileges = typeof privileges === 'undefined' ? null : privileges;
        assert = typeof assert === 'undefined' ? null : assert;

        return setRule(self.OP_REMOVE, self.TYPE_ALLOW, roles, resources, privileges, assert);
    };

    /**
     * Removes an "deny" rule from the ACL
     *
     * @param {(string|Array)} [roles=null]
     * @param {(string|Array)} [resources=null]
     * @param {(string|Array)} [privileges=null]
     * @param {AclAssertion} assert
     * @return {Acl} Provides a fluent interface
     */
    self.removeDeny = function (roles, resources, privileges, assert) {
        roles = typeof roles === 'undefined' ? null : roles;
        resources = typeof resources === 'undefined' ? null : resources;
        privileges = typeof privileges === 'undefined' ? null : privileges;
        assert = typeof assert === 'undefined' ? null : assert;

        return setRule(self.OP_REMOVE, self.TYPE_DENY, roles, resources, privileges, assert);
    };

    /**
     * Returns true if and only if the Role has access to the Resource
     *
     * The $role and $resource parameters may be references to, or the string identifiers for,
     * an existing Resource and Role combination.
     *
     * If either $role or $resource is null, then the query applies to all Roles or all Resources,
     * respectively. Both may be null to query whether the ACL has a "blacklist" rule
     * (allow everything to all). By default, Zend\Permissions\Acl creates a "whitelist" rule (deny
     * everything to all), and this method would return false unless this default has
     * been overridden (i.e., by executing $acl->allow()).
     *
     * If a $privilege is not provided, then this method returns false if and only if the
     * Role is denied access to at least one privilege upon the Resource. In other words, this
     * method returns true if and only if the Role is allowed all privileges on the Resource.
     *
     * This method checks Role inheritance using a depth-first traversal of the Role registry.
     * The highest priority parent (i.e., the parent most recently added) is checked first,
     * and its respective parents are checked similarly before the lower-priority parents of
     * the Role are checked.
     *
     * @param  {string} [role=null]
     * @param  {string|AclResourceInterface} [resource=null]
     * @param  {string} [privilege=null]
     * @return {boolean}
     */
    self.isAllowed = function (role, resource, privilege) {
        role = typeof role === 'undefined' ? null : role;
        resource = typeof resource === 'undefined' ? null : resource;
        privilege = typeof privilege === 'undefined' ? null : privilege;
        var result, ruleTypeAllPrivileges;

        // reset role & resource to null
        _isAllowedRole = null;
        _isAllowedResource = null;

        if (role !== null) {
            _isAllowedRole = role;
            role = self.getRole(role);
        }
        if (resource !== null) {
            _isAllowedResource = resource;
            resource = self.getResource(resource);
        }

        if (privilege === null) {
            // query on all privileges
            do {
                // depth-first search on $role if it is not 'allRoles' pseudo-parent
                if (role !== null && (result = roleDFSAllPrivileges(role, resource, privilege)) !== null) {
                    return result;
                }

                // look for rule on 'allRoles' pseudo-parent
                var rules;
                if ((rules = getRules(resource, null)) !== null) {
                    for (privilege in rules.byPrivilegeId) {
                        if (self.TYPE_DENY === getRuleType(resource, null, privilege)) {
                            return false;
                        }
                    }
                    if (null !== (ruleTypeAllPrivileges = getRuleType(resource, null, null))) {
                        return self.TYPE_ALLOW === ruleTypeAllPrivileges;
                    }
                }

                // try next Resource
                resource = _resources[resource].parent;
            } while (true); // loop terminates at 'allResources' pseudo-parent
        } else {
            // query on one privilege
            do {
                // depth-first search on $role if it is not 'allRoles' pseudo-parent
                if (role !== null && null !== (result = roleDFSOnePrivilege(role, resource, privilege))) {
                    return result;
                }

                // look for rule on 'allRoles' pseudo-parent
                var ruleType;
                if (null !== (ruleType = getRuleType(resource, null, privilege))) {
                    return self.TYPE_ALLOW === ruleType;
                } else if (null !== (ruleTypeAllPrivileges = getRuleType(resource, null, null))) {
                    result = self.TYPE_ALLOW === ruleTypeAllPrivileges;
                    if (result || null === resource) {
                        return result;
                    }
                }

                // try next Resource
                resource = _resources[resource].parent;
            } while (true); // loop terminates at 'allResources' pseudo-parent
        }

    };

    /**
     * Adds a Resource having an identifier unique to the ACL
     *
     * The $parent parameter may be a reference to, or the string identifier for,
     * the existing Resource from which the newly added Resource will inherit.
     *
     * @param  {string} resource
     * @param  {string} [parent=null]
     * @return {Acl} Provides a fluent interface
     */
    self.addResource = function (resource, parent) {
        parent = typeof parent === 'undefined' ? null : parent;

        if (typeof resource !== 'string' || resource === '') {
            throw new Error('addResource() expects resource to be a not empty string');
        }

        var resourceId = resource;

        if (self.hasResource(resourceId)) {
            throw new Error("Resource id 'resourceId' already exists in the ACL");
        }

        if (parent !== null) {
            if (!self.hasResource(parent)) {
                throw new Error("Parent resource id not exists in the ACL");
            }

            _resources[parent].children.push(resourceId);
        }

        _resources[resourceId] = {
            id: resourceId,
            parent: parent,
            children: []
        };

        return self;
    };

    /**
     * Returns the identified Resource
     *
     * The $resource parameter can either be a Resource or a Resource identifier.
     *
     * @param  {(string|AclResourceInterface)} resource
     * @return {string}
     */
    self.getResource = function (resource) {
        if (!self.hasResource(resource)) {
            throw new Error("Resource '$resourceId' not found");
        }

        if (resource instanceof Object && typeof resource.getResourceId === 'function') {
            resource = resource.getResourceId();
        }

        return _resources[resource].id;
    };

    /**
     * @return {Array.<string>} of registered resources
     */
    self.getResources = function () {
        return Object.keys(_resources);
    };

    /**
     * Returns true if and only if the Resource exists in the ACL
     *
     * The $resource parameter can either be a Resource or a Resource identifier.
     *
     * @param {(string|AclResourceInterface)} resource
     * @return {boolean}
     */
    self.hasResource = function (resource) {
        if (resource instanceof Object && typeof resource.getResourceId === 'function') {
            resource = resource.getResourceId();
        }

        return _resources[resource] !== undefined;
    };

    /**
     * Returns true if and only if $resource inherits from $inherit
     *
     * Both parameters may be either a Resource or a Resource identifier. If
     * $onlyParent is true, then $resource must inherit directly from
     * $inherit in order to return true. By default, this method looks
     * through the entire inheritance tree to determine whether $resource
     * inherits from $inherit through its ancestor Resources.
     *
     * @param {(AclResourceInterface|string)} resource
     * @param {(AclResourceInterface|string)} inherit
     * @param {boolean} [onlyParent=false]
     * @return {boolean}
     */
    self.inheritsResource = function (resource, inherit, onlyParent) {
        var parentId = null;

        resource = self.getResource(resource);
        inherit = self.getResource(inherit);

        if (_resources[resource].parent !== null) {
            parentId = _resources[resource].parent;
            if (parentId === inherit) {
                return true;
            } else if (onlyParent) {
                return false;
            }
        } else {
            return false;
        }

        while (_resources[parentId].parent !== null) {
            parentId = _resources[parentId].parent;
            if (inherit === parentId) {
                return true;
            }
        }

        return false;
    };

    /**
     * Removes a Resource and all of its children
     *
     * The $resource parameter can either be a Resource or a Resource identifier.
     *
     * @param  {(string|AclResourceInterface)} resource
     * @return {Acl} Provides a fluent interface
     */
    self.removeResource = function (resource) {
        if (!self.hasResource(resource)) {
            throw new Error("Resource '$resourceId' not found");
        }

        if (resource instanceof Object && typeof resource.getResourceId === 'function') {
            resource = resource.getResourceId();
        }

        var resourcesRemoved = [resource],
            resourceParent = _resources[resource].parent;

        if (resourceParent !== null) {
            _resources[resourceParent].children.splice(_resources[resourceParent].children.indexOf(resource), 1);
        }

        _resources[resource].children.forEach(function(child) {
            self.removeResource(child);
            resourcesRemoved.push(child);
        });

        resourcesRemoved.forEach(function(resourceRemoved) {
            for (var resourceCurrent in _rules.byResourceId) {
                if (resourceRemoved === resourceCurrent) {
                    delete _rules.byResourceId[resourceCurrent];
                }
            }
        });

        delete _resources[resource];

        return self;
    };

    /**
     * Removes all Resources
     *
     * @return {Acl} Provides a fluent interface
     */
    self.removeResourceAll = function () {
        for (var resourceId in _resources) {
            for (var resourceIdCurrent in _rules.byResourceId) {
                if (resourceId === resourceIdCurrent) {
                    delete _rules.byResourceId[resourceIdCurrent];
                }
            }
        }

        _resources = {};

        return self;
    };

    /**
     * Adds a Role having an identifier unique to the registry
     *
     * The $parents parameter may be a reference to, or the string identifier for,
     * a Role existing in the registry, or $parents may be passed as an array of
     * these - mixing string identifiers and objects is ok - to indicate the Roles
     * from which the newly added Role will directly inherit.
     *
     * In order to resolve potential ambiguities with conflicting rules inherited
     * from different parents, the most recently added parent takes precedence over
     * parents that were previously added. In other words, the first parent added
     * will have the least priority, and the last parent added will have the
     * highest priority.
     *
     * @param  {string} role
     * @param  {(string|Array.<string>)} [parents=null]
     * @return {Acl} Provides a fluent interface
     */
    self.addRole = function (role, parents) {
        parents = typeof parents === 'undefined' ? null : parents;

        if (typeof role !== 'string' || role === '') {
            throw new Error('addRole() expects role to be a not empty string');
        }

        _roleRegistry.add(role, parents);

        return self;
    };

    /**
     * Returns the identified Role
     *
     * The $role parameter can either be a Role or Role identifier.
     *
     * @param  {string} role
     * @return {string}
     */
    self.getRole = function (role) {
        return _roleRegistry.get(role);
    };

    /**
     * @return {Array.<string>} of registered roles
     */
    self.getRoles = function () {
        return Object.keys(_roleRegistry.getItems());
    };

    /**
     * Returns true if and only if the Role exists in the registry
     *
     * The $role parameter can either be a Role or a Role identifier.
     *
     * @param  {string} role
     * @return {boolean}
     */
    self.hasRole = function (role) {
        return _roleRegistry.has(role);
    };

    /**
     * Returns true if and only if $role inherits from $inherit
     *
     * Both parameters may be either a Role or a Role identifier. If
     * $onlyParents is true, then $role must inherit directly from
     * $inherit in order to return true. By default, this method looks
     * through the entire inheritance DAG to determine whether $role
     * inherits from $inherit through its ancestor Roles.
     *
     * @param  {string} role
     * @param  {string} inherit
     * @param  {boolean} [onlyParents=false]
     * @return {boolean}
     */
    self.inheritsRole = function (role, inherit, onlyParents) {
        onlyParents = typeof onlyParents === 'undefined' ? false : onlyParents;

        return _roleRegistry.inherits(role, inherit, onlyParents);
    };

    /**
     * Removes the Role from the registry
     *
     * The $role parameter can either be a Role or a Role identifier.
     *
     * @param  {string} role
     * @return {Acl} Provides a fluent interface
     */
    self.removeRole = function (role) {
        _roleRegistry.remove(role);

        if (_rules.allResources.byRoleId[role] !== undefined) {
            delete _rules.allResources.byRoleId[role];
        }

        for (var resourceCurrent in _rules.byResourceId) {
            var visitor = _rules.byResourceId[resourceCurrent];

            if (visitor.byRoleId !== undefined && visitor.byRoleId[role] !== undefined) {
                delete visitor.byRoleId[role];
            }
        }

        return self;
    };

    /**
     * Removes all Roles from the registry
     *
     * @return {Acl} Provides a fluent interface
     */
    self.removeRoleAll = function () {
        _roleRegistry.removeAll();

        for (var roleCurrent in _rules.allResources.byRoleId) {
            delete _rules.allResources.byRoleId[roleCurrent];
        }

        for (var resourceCurrent in _rules.byResourceId) {
            for (var roleIdCurrent in _rules.byResourceId[resourceCurrent].byRoleId) {
                delete _rules.byResourceId[resourceCurrent].byRoleId[roleIdCurrent];
            }
        }

        return self;
    };


    /**
     * Performs operations on ACL rules
     *
     * The $operation parameter may be either OP_ADD or OP_REMOVE, depending on whether the
     * user wants to add or remove a rule, respectively:
     *
     * OP_ADD specifics:
     *
     *      A rule is added that would allow one or more Roles access to [certain $privileges
     *      upon] the specified Resource(s).
     *
     * OP_REMOVE specifics:
     *
     *      The rule is removed only in the context of the given Roles, Resources, and privileges.
     *      Existing rules to which the remove operation does not apply would remain in the
     *      ACL.
     *
     * The $type parameter may be either TYPE_ALLOW or TYPE_DENY, depending on whether the
     * rule is intended to allow or deny permission, respectively.
     *
     * The $roles and $resources parameters may be references to, or the string identifiers for,
     * existing Resources/Roles, or they may be passed as arrays of these - mixing string identifiers
     * and objects is ok - to indicate the Resources and Roles to which the rule applies. If either
     * $roles or $resources is null, then the rule applies to all Roles or all Resources, respectively.
     * Both may be null in order to work with the default rule of the ACL.
     *
     * The $privileges parameter may be used to further specify that the rule applies only
     * to certain privileges upon the Resource(s) in question. This may be specified to be a single
     * privilege with a string, and multiple privileges may be specified as an array of strings.
     *
     * If $assert is provided, then its assert() method must return true in order for
     * the rule to apply. If $assert is provided with $roles, $resources, and $privileges all
     * equal to null, then a rule having a type of:
     *
     *      TYPE_ALLOW will imply a type of TYPE_DENY, and
     *
     *      TYPE_DENY will imply a type of TYPE_ALLOW
     *
     * when the rule's assertion fails. This is because the ACL needs to provide expected
     * behavior when an assertion upon the default ACL rule fails.
     *
     * @param  {string} operation
     * @param  {string} type
     * @param  {string|Array.<string>} [roles=null]
     * @param  {string|Array.<string>} [resources=null]
     * @param  {string|Array.<string>} [privileges=null]
     * @param  {function} [assert=null]
     * @return {Acl} Provides a fluent interface
     */
    function setRule (
        operation,
        type,
        roles,
        resources,
        privileges,
        assert
    ) {
        roles = typeof roles === 'undefined' ? null : roles;
        resources = typeof resources === 'undefined' ? null : resources;
        privileges = typeof privileges === 'undefined' ? null : privileges;
        assert = typeof assert === 'undefined' ? null : assert;

        // ensure that the rule type is valid; normalize input to uppercase
        type = type.toUpperCase();
        if (self.TYPE_ALLOW !== type && self.TYPE_DENY !== type) {
            throw new Error('Unsupported rule type');
        }

        // ensure that all specified Roles exist; normalize input to array of Role objects or null
        if (!Array.isArray(roles)) {
            roles = [roles];
        } else if (0 === roles.length) {
            roles = [null];
        }
        var rolesTemp = roles;
        roles = [];
        rolesTemp.forEach(function (role) {
            if (role !== null) {
                roles.push(self.getRole(role));
            } else {
                roles.push(null);
            }
        });

        // ensure that all specified Resources exist; normalize input to array of Resource objects or null
        if (!Array.isArray(resources)) {
            if (resources === null && Object.keys(_resources).length > 0) {
                resources = Object.keys(_resources);
                // Passing a null resource; make sure "global" permission is also set!
                if (resources.indexOf(null) === -1) {
                    resources.unshift(null);
                }
            } else {
                resources = [resources];
            }
        } else if (resources.length === 0) {
            resources = [null];
        }
        var resourcesTemp = resources;
        resources = [];
        resourcesTemp.forEach(function (resource) {
            if (resource !== null) {
                resource = self.getResource(resource);

                var children = getChildResources(resource);
                resources = resources.concat(children);
                resources.push(resource);
            } else {
                resources.push(null);
            }
        });

        // normalize privileges to array
        if (privileges === null ) {
            privileges = [];
        } else if (!Array.isArray(privileges)) {
            privileges = [privileges];
        }

        switch (operation) {
            // add to the rules
            case self.OP_ADD:
                resources.forEach(function (resource) {
                    roles.forEach(function (role) {
                        var rules = getRules(resource, role, true);
                        if (privileges.length === 0) {
                            set(rules, 'allPrivileges.type', type);
                            set(rules, 'allPrivileges.assert', assert);
                            if (rules.byPrivilegeId === undefined) {
                                rules.byPrivilegeId = {};
                            }
                        } else {
                            privileges.forEach(function (privilege) {
                                set(rules, 'byPrivilegeId.' + privilege + '.type', type);
                                set(rules, 'byPrivilegeId.' + privilege + '.assert', assert);
                            });
                        }
                    });
                });
                break;

            // remove from the rules
            case self.OP_REMOVE:
                resources.forEach(function (resource) {
                    roles.forEach(function (role) {
                        var rules = getRules(resource, role);
                        if (rules === null) {
                            return;
                        }

                        if (privileges.length === 0) {
                            if (resource === null && role === null) {
                                if (rules.allPrivileges.type === type) {
                                    set(rules, 'allPrivileges.type', self.TYPE_DENY);
                                    set(rules, 'allPrivileges.assert', null);
                                    rules.byPrivilegeId = {};
                                }
                                return;
                            }

                            if (rules.allPrivileges !== undefined && rules.allPrivileges.type !== undefined && rules.allPrivileges.type === type) {
                                delete rules.allPrivileges;
                            }
                        } else {
                            privileges.forEach(function (privilege) {
                                if (rules.byPrivilegeId !== undefined && rules.byPrivilegeId[privilege] !== undefined &&
                                    rules.byPrivilegeId[privilege].type === type
                                ) {
                                    delete rules.byPrivilegeId[privilege];
                                }
                            });
                        }
                    });
                });
                break;

            default:
                throw new Error('Unsupported operation');
        }

        return self;
    }

    /**
     * Returns the rules associated with a Resource and a Role, or null if no such rules exist
     *
     * If either $resource or $role is null, this means that the rules returned are for all Resources or all Roles,
     * respectively. Both can be null to return the default rule set for all Resources and all Roles.
     *
     * If the $create parameter is true, then a rule set is first created and then returned to the caller.
     *
     * @param {string} [resource=null]
     * @param {string} [role=null]
     * @param {boolean} [create=false]
     * @return {Object|null}
     */
    function getRules (resource, role, create) {
        resource = typeof resource === 'undefined' ? null : resource;
        role = typeof role === 'undefined' ? null : role;
        create = typeof create === 'undefined' ? false : create;

        var visitor;

        // follow $resource
        do {
            if (resource === null) {
                visitor = _rules.allResources;
                break;
            }
            //var resourceId = resource.getResourceId();
            var resourceId = resource;
            if (_rules.byResourceId[resourceId] === undefined) {
                if (!create) {
                    return null;
                }
                _rules.byResourceId[resourceId] = {};
            }
            visitor = _rules.byResourceId[resourceId];
        } while (false);

        // follow $role
        if (role === null) {
            if (visitor.allRoles === undefined) {
                if (!create) {
                    return null;
                }
                set(visitor, 'allRoles.byPrivilegeId', {});
            }
            return visitor.allRoles;
        }
        //var roleId = role.getRoleId();
        var roleId = role;
        if (visitor.byRoleId === undefined || visitor.byRoleId[roleId] === undefined) {
            if (!create) {
                return null;
            }
            set(visitor, 'byRoleId.' + roleId + '.byPrivilegeId', {});
        }
        return visitor.byRoleId[roleId];
    }

    /**
     * Performs a depth-first search of the Role DAG, starting at $role, in order to find a rule
     * allowing/denying $role access to all privileges upon $resource
     *
     * This method returns true if a rule is found and allows access. If a rule exists and denies access,
     * then this method returns false. If no applicable rule is found, then this method returns null.
     *
     * @param {string} role
     * @param {string} [resource=null]
     * @return {(boolean|null)}
     */
    function roleDFSAllPrivileges(role, resource){
        var dfs = {
                visited: {},
                stack: []
            }, result;

        if (null !== (result = roleDFSVisitAllPrivileges(role, resource, dfs))) {
            return result;
        }

        // This comment is needed due to a strange php-cs-fixer bug
        while (null !== (role = array_pop(dfs.stack))) {
            if (dfs.visited[role] === undefined) {
                if (null !== (result = roleDFSVisitAllPrivileges(role, resource, dfs))) {
                    return result;
                }
            }
        }

        return null;
    }

    /**
     * Visits an $role in order to look for a rule allowing/denying $role access to all privileges upon $resource
     *
     * This method returns true if a rule is found and allows access. If a rule exists and denies access,
     * then this method returns false. If no applicable rule is found, then this method returns null.
     *
     * This method is used by the internal depth-first search algorithm and may modify the DFS data structure.
     *
     * @param {string} role
     * @param {string} [resource=null]
     * @param {Object} [dfs=null]
     * @return {(boolean|null)}
     */
    function roleDFSVisitAllPrivileges(role, resource, dfs) {
        resource = typeof resource === 'undefined' ? null : resource;
        dfs = typeof dfs === 'undefined' ? null : dfs;

        if (dfs === null) {
            throw new Error('$dfs parameter may not be null');
        }

        var rules;
        if ((rules = getRules(resource, role)) !== null) {
            for (var privilege in rules.byPrivilegeId) {
                if (self.TYPE_DENY === getRuleType(resource, role, privilege)) {
                    return false;
                }
            }
            var ruleTypeAllPrivileges;
            if (null !== (ruleTypeAllPrivileges = getRuleType(resource, role, null))) {
                return self.TYPE_ALLOW === ruleTypeAllPrivileges;
            }
        }

        dfs.visited[role] = true;
        _roleRegistry.getParents(role).forEach(function (roleParent) {
            dfs.stack.push(roleParent);
        });

        return null;
    }

    /**
     * Performs a depth-first search of the Role DAG, starting at $role, in order to find a rule
     * allowing/denying $role access to a $privilege upon $resource
     *
     * This method returns true if a rule is found and allows access. If a rule exists and denies access,
     * then this method returns false. If no applicable rule is found, then this method returns null.
     *
     * @param {string} role
     * @param {string} [resource=null]
     * @param {string} [privilege=null]
     * @return {(boolean|null)}
     */
    function roleDFSOnePrivilege(role, resource, privilege) {
        resource = typeof resource === 'undefined' ? null : resource;
        privilege = typeof privilege === 'undefined' ? null : privilege;

        if (null === privilege) {
            throw new Error('$privilege parameter may not be null');
        }

        var dfs = {
                visited: {},
                stack: []
            }, result;

        if (null !== (result = roleDFSVisitOnePrivilege(role, resource, privilege, dfs))) {
            return result;
        }

        // This comment is needed due to a strange php-cs-fixer bug
        while (null !== (role = array_pop(dfs.stack))) {
            if (dfs.visited[role] === undefined) {
                if (null !== (result = roleDFSVisitOnePrivilege(role, resource, privilege, dfs))) {
                    return result;
                }
            }
        }

        return null;
    }

    /**
     * Visits an $role in order to look for a rule allowing/denying $role access to a $privilege upon $resource
     *
     * This method returns true if a rule is found and allows access. If a rule exists and denies access,
     * then this method returns false. If no applicable rule is found, then this method returns null.
     *
     * This method is used by the internal depth-first search algorithm and may modify the DFS data structure.
     *
     * @param {string} role
     * @param {string} [resource=null]
     * @param {string} [privilege=null]
     * @param {Object} [dfs=null]
     * @return {(boolean|null)}
     */
    function roleDFSVisitOnePrivilege(role, resource, privilege, dfs) {
        resource = typeof resource === 'undefined' ? null : resource;
        privilege = typeof privilege === 'undefined' ? null : privilege;
        dfs = typeof dfs === 'undefined' ? null : dfs;

        if (privilege === null) {
            throw new Error('$privilege parameter may not be null');
        }

        if (dfs === null) {
            throw new Error('$dfs parameter may not be null');
        }

        var ruleTypeOnePrivilege, ruleTypeAllPrivileges;
        if (null !== (ruleTypeOnePrivilege = getRuleType(resource, role, privilege))) {
            return self.TYPE_ALLOW === ruleTypeOnePrivilege;
        } else if (null !== (ruleTypeAllPrivileges = getRuleType(resource, role, null))) {
            return self.TYPE_ALLOW === ruleTypeAllPrivileges;
        }

        dfs.visited[role] = true;
        _roleRegistry.getParents(role).forEach(function (roleParent) {
            dfs.stack.push(roleParent);
        });

        return null;
    }

    /**
     * Returns the rule type associated with the specified Resource, Role, and privilege
     * combination.
     *
     * If a rule does not exist or its attached assertion fails, which means that
     * the rule is not applicable, then this method returns null. Otherwise, the
     * rule type applies and is returned as either TYPE_ALLOW or TYPE_DENY.
     *
     * If $resource or $role is null, then this means that the rule must apply to
     * all Resources or Roles, respectively.
     *
     * If $privilege is null, then the rule must apply to all privileges.
     *
     * If all three parameters are null, then the default ACL rule type is returned,
     * based on whether its assertion method passes.
     *
     * @param  {null|string} [resource=null]
     * @param  {null|string} [role=null]
     * @param  {null|string} [privilege=null]
     * @return {(string|null)}
     */
    function getRuleType(resource, role, privilege) {
        resource = typeof resource === 'undefined' ? null : resource;
        role = typeof role === 'undefined' ? null : role;
        privilege = typeof privilege === 'undefined' ? null : privilege;


        // get the rules for the $resource and $role
        var rules = getRules(resource, role), rule;
        if (rules === null) {
            return null;
        }

        // follow $privilege
        if (privilege === null) {
            if (rules.allPrivileges !== undefined) {
                rule = rules.allPrivileges;
            } else {
                return null;
            }
        } else if (rules.byPrivilegeId === undefined || rules.byPrivilegeId[privilege] === undefined) {
            return null;
        } else {
            rule = rules.byPrivilegeId[privilege];
        }

        // check assertion first
        var assertionValue = null;
        if (rule.assert !== null) {
            var assertion = rule.assert;
            assertionValue = assertion.call(
                self,
                _isAllowedRole === self.USER_IDENTITY_ROLE && self.getUserIdentity() !== null ? self.getUserIdentity() : role,
                _isAllowedResource !== null ? _isAllowedResource : resource,
                privilege
            );
        }

        if (rule.assert === null || assertionValue === true) {
            return rule.type;
        } else if (null !== resource || null !== role || null !== privilege) {
            return null;
        } else if (self.TYPE_ALLOW === rule.type) {
            return self.TYPE_DENY;
        }

        return self.TYPE_ALLOW;
    }

    /**
     * Returns all child resources from the given resource.
     *
     * @param {string} resource
     * @return []
     */
    function getChildResources(resource){
        var result = [], children = _resources[resource].children;
        children.forEach(function (child) {
            var childReturn = getChildResources(child);
            childReturn.push(child);
            result = result.concat(childReturn);
        });

        return result;
    }

    function set(schema, path, value) {
        var pList = path.split('.'),
            len = pList.length;

        for (var i = 0; i < len - 1; i++) {
            var elem = pList[i];
            if(!schema[elem]) {
                schema[elem] = {};
            }
            schema = schema[elem];
        }

        schema[pList[len - 1]] = value;
    }

    function array_pop(inputArr) {
        var key = '',
            lastKey = '';

        if (inputArr.hasOwnProperty('length')) {
            // Indexed
            if (!inputArr.length) {
                // Done popping, are we?
                return null;
            }
            return inputArr.pop();
        } else {
            // Associative
            for (key in inputArr) {
                if (inputArr.hasOwnProperty(key)) {
                    lastKey = key;
                }
            }
            if (lastKey) {
                var tmp = inputArr[lastKey];
                delete(inputArr[lastKey]);
                return tmp;
            } else {
                return null;
            }
        }
    }
}

module.exports = Acl;
},{"./acl-registry":1}]},{},[])("/src/index.js")
});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(599);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _config = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (externalUrl, sectionUrl) {
  var sectionUri = (0, _urijs2.default)(sectionUrl || (0, _config.getConfig)().sectionUrl || '');
  var sectionUrlWithoutQuery = (0, _urijs2.default)(sectionUrl || (0, _config.getConfig)().sectionUrl || '').search('').toString();
  var externalUri = (0, _urijs2.default)(externalUrl.replace(sectionUrlWithoutQuery, ''));

  var sectionParams = sectionUri.search(true);
  var externalParams = externalUri.search(true);

  (0, _lodash.forEach)(sectionParams, function (value, key) {
    if (externalParams[key] === value) {
      delete externalParams[key];
    }
  });

  return externalUri.search(externalParams).toString();
};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var handleEventNoop = function handleEventNoop(ev) {
  ev.stopPropagation();
  ev.preventDefault();
};

var NoopLink = function NoopLink(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(
    'span',
    _extends({}, props, { onClick: handleEventNoop }),
    children
  );
};

NoopLink.propTypes = {
  children: _propTypes2.default.node
};

exports.default = NoopLink;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memberUserMapper;

var _stripProtocol = __webpack_require__(603);

var _stripProtocol2 = _interopRequireDefault(_stripProtocol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function memberUserMapper(_ref) {
  var id = _ref.id,
      name = _ref.name,
      _ref$email = _ref.email,
      email = _ref$email === undefined ? '' : _ref$email,
      image = _ref.image,
      _ref$attributes = _ref.attributes,
      attributes = _ref$attributes === undefined ? {} : _ref$attributes;

  return {
    siteMemberId: id,
    name: name || attributes.name || email.substring(0, email.indexOf('@')) || 'unknown',
    email: email,
    image: (0, _stripProtocol2.default)(image || attributes.imageUrl)
  };
}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripProtocol;
function stripProtocol(url) {
  if (url && url.length) {
    return url.replace(/^https?:/, '');
  } else {
    return url;
  }
}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GatewayRegistry = __webpack_require__(141);

var _GatewayRegistry2 = _interopRequireDefault(_GatewayRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Gateway = function (_React$Component) {
  _inherits(Gateway, _React$Component);

  function Gateway(props, context) {
    _classCallCheck(this, Gateway);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.gatewayRegistry = context.gatewayRegistry;
    return _this;
  }

  Gateway.prototype.componentWillMount = function componentWillMount() {
    this.id = this.gatewayRegistry.register(this.props.into, this.props.children);
    this.renderIntoGatewayNode(this.props);
  };

  Gateway.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this.gatewayRegistry.clearChild(this.props.into, this.id);
    this.renderIntoGatewayNode(props);
  };

  Gateway.prototype.componentWillUnmount = function componentWillUnmount() {
    this.gatewayRegistry.unregister(this.props.into, this.id);
  };

  Gateway.prototype.renderIntoGatewayNode = function renderIntoGatewayNode(props) {
    this.gatewayRegistry.addChild(this.props.into, this.id, props.children);
  };

  Gateway.prototype.render = function render() {
    return null;
  };

  return Gateway;
}(_react2.default.Component);

Gateway.contextTypes = {
  gatewayRegistry: _propTypes2.default.instanceOf(_GatewayRegistry2.default).isRequired
};
Gateway.propTypes = {
  into: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
};
exports.default = Gateway;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GatewayRegistry = __webpack_require__(141);

var _GatewayRegistry2 = _interopRequireDefault(_GatewayRegistry);

var _reactPropTypes = __webpack_require__(606);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GatewayDest = function (_React$Component) {
  _inherits(GatewayDest, _React$Component);

  function GatewayDest(props, context) {
    _classCallCheck(this, GatewayDest);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.state = {
      children: null
    };

    _this.gatewayRegistry = context.gatewayRegistry;
    return _this;
  }

  GatewayDest.prototype.componentWillMount = function componentWillMount() {
    this.gatewayRegistry.addContainer(this.props.name, this);
  };

  GatewayDest.prototype.componentWillUnmount = function componentWillUnmount() {
    this.gatewayRegistry.removeContainer(this.props.name, this);
  };

  GatewayDest.prototype.render = function render() {
    var _props = this.props,
        component = _props.component,
        tagName = _props.tagName,
        attrs = _objectWithoutProperties(_props, ['component', 'tagName']);

    delete attrs.name;
    return _react2.default.createElement(component || tagName || 'div', attrs, this.state.children);
  };

  return GatewayDest;
}(_react2.default.Component);

GatewayDest.contextTypes = {
  gatewayRegistry: _propTypes2.default.instanceOf(_GatewayRegistry2.default).isRequired
};
GatewayDest.propTypes = {
  name: _propTypes2.default.string.isRequired,
  tagName: (0, _reactPropTypes.deprecated)(_propTypes2.default.string, 'Use "component" instead.'),
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};
exports.default = GatewayDest;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isRequiredForA11y = exports.elementType = exports.deprecated = exports.componentOrElement = exports.all = undefined;

var _all2 = __webpack_require__(607);

var _all3 = _interopRequireDefault(_all2);

var _componentOrElement2 = __webpack_require__(113);

var _componentOrElement3 = _interopRequireDefault(_componentOrElement2);

var _deprecated2 = __webpack_require__(608);

var _deprecated3 = _interopRequireDefault(_deprecated2);

var _elementType2 = __webpack_require__(226);

var _elementType3 = _interopRequireDefault(_elementType2);

var _isRequiredForA11y2 = __webpack_require__(610);

var _isRequiredForA11y3 = _interopRequireDefault(_isRequiredForA11y2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.all = _all3.default;
exports.componentOrElement = _componentOrElement3.default;
exports.deprecated = _deprecated3.default;
exports.elementType = _elementType3.default;
exports.isRequiredForA11y = _isRequiredForA11y3.default;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(225);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = deprecated;

var _warning = __webpack_require__(609);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GatewayRegistry = __webpack_require__(141);

var _GatewayRegistry2 = _interopRequireDefault(_GatewayRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GatewayProvider = function (_React$Component) {
  _inherits(GatewayProvider, _React$Component);

  GatewayProvider.prototype.getChildContext = function getChildContext() {
    return {
      gatewayRegistry: this.gatewayRegistry
    };
  };

  function GatewayProvider(props, context) {
    _classCallCheck(this, GatewayProvider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.gatewayRegistry = new _GatewayRegistry2.default();
    return _this;
  }

  GatewayProvider.prototype.render = function render() {
    return this.props.children;
  };

  return GatewayProvider;
}(_react2.default.Component);

GatewayProvider.childContextTypes = {
  gatewayRegistry: _propTypes2.default.instanceOf(_GatewayRegistry2.default).isRequired
};
GatewayProvider.propTypes = {
  children: _propTypes2.default.element
};
exports.default = GatewayProvider;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(318);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(616);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(322);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 613 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(319);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(321);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(227);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(228);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _PropTypes = __webpack_require__(322);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 617 */,
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalRoot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactTransitionGroup = __webpack_require__(122);

var _modals = __webpack_require__(619);

var _modals2 = _interopRequireDefault(_modals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_TIMEOUT = 200;

var ModalRoot = exports.ModalRoot = function (_Component) {
  _inherits(ModalRoot, _Component);

  function ModalRoot() {
    _classCallCheck(this, ModalRoot);

    return _possibleConstructorReturn(this, (ModalRoot.__proto__ || Object.getPrototypeOf(ModalRoot)).apply(this, arguments));
  }

  _createClass(ModalRoot, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          modalType = _props.modalType,
          modalProps = _props.modalProps;

      var ModalComponent = _modals2.default[modalType];

      return _react2.default.createElement(
        _reactTransitionGroup.CSSTransitionGroup,
        {
          component: 'div',
          transitionName: 'modal',
          transitionEnterTimeout: ANIMATION_TIMEOUT,
          transitionLeaveTimeout: ANIMATION_TIMEOUT
        },
        ModalComponent ? _react2.default.createElement(ModalComponent, modalProps) : null
      );
    }
  }]);

  return ModalRoot;
}(_react.Component);

ModalRoot.propTypes = {
  modalType: _propTypes2.default.string,
  modalProps: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    modalType: state.modal.type,
    modalProps: state.modal.props,
    auth: state.auth
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ModalRoot);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types$MODAL_TYPE_DIS;

var _modalTypes = __webpack_require__(26);

var types = _interopRequireWildcard(_modalTypes);

var _discardPostModal = __webpack_require__(620);

var _discardPostModal2 = _interopRequireDefault(_discardPostModal);

var _postCreateModal = __webpack_require__(636);

var _postCreateModal2 = _interopRequireDefault(_postCreateModal);

var _changePostCategoryModal = __webpack_require__(844);

var _changePostCategoryModal2 = _interopRequireDefault(_changePostCategoryModal);

var _movePostModal = __webpack_require__(853);

var _movePostModal2 = _interopRequireDefault(_movePostModal);

var _deleteCommentModal = __webpack_require__(855);

var _deleteCommentModal2 = _interopRequireDefault(_deleteCommentModal);

var _deletePostModal = __webpack_require__(858);

var _deletePostModal2 = _interopRequireDefault(_deletePostModal);

var _demoModal = __webpack_require__(860);

var _demoModal2 = _interopRequireDefault(_demoModal);

var _reportCommentModal = __webpack_require__(864);

var _reportCommentModal2 = _interopRequireDefault(_reportCommentModal);

var _reportPostModal = __webpack_require__(870);

var _reportPostModal2 = _interopRequireDefault(_reportPostModal);

var _sharePostModal = __webpack_require__(872);

var _sharePostModal2 = _interopRequireDefault(_sharePostModal);

var _shareLinkModal = __webpack_require__(892);

var _shareLinkModal2 = _interopRequireDefault(_shareLinkModal);

var _shareCommentModal = __webpack_require__(897);

var _shareCommentModal2 = _interopRequireDefault(_shareCommentModal);

var _reportMemberModal = __webpack_require__(899);

var _reportMemberModal2 = _interopRequireDefault(_reportMemberModal);

var _promoteModeratorModal = __webpack_require__(901);

var _promoteModeratorModal2 = _interopRequireDefault(_promoteModeratorModal);

var _demoteModeratorModal = __webpack_require__(908);

var _demoteModeratorModal2 = _interopRequireDefault(_demoteModeratorModal);

var _unfollowMemberModal = __webpack_require__(913);

var _unfollowMemberModal2 = _interopRequireDefault(_unfollowMemberModal);

var _blockMemberModal = __webpack_require__(918);

var _blockMemberModal2 = _interopRequireDefault(_blockMemberModal);

var _unblockMemberModal = __webpack_require__(921);

var _unblockMemberModal2 = _interopRequireDefault(_unblockMemberModal);

var _deleteCategoryModal = __webpack_require__(923);

var _deleteCategoryModal2 = _interopRequireDefault(_deleteCategoryModal);

var _profileActionsWidget = __webpack_require__(925);

var _profileActionsWidget2 = _interopRequireDefault(_profileActionsWidget);

var _profileActionsUpperPart = __webpack_require__(934);

var _profileActionsUpperPart2 = _interopRequireDefault(_profileActionsUpperPart);

var _loginModal = __webpack_require__(937);

var _loginModal2 = _interopRequireDefault(_loginModal);

var _textEditorLinkModal = __webpack_require__(947);

var _textEditorLinkModal2 = _interopRequireDefault(_textEditorLinkModal);

var _textEditorVideoEmbedModal = __webpack_require__(952);

var _textEditorVideoEmbedModal2 = _interopRequireDefault(_textEditorVideoEmbedModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_types$MODAL_TYPE_DIS = {}, _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_DISCARD_POST, _discardPostModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_CREATE_POST, _postCreateModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_CHANGE_CATEGORY, _changePostCategoryModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_DELETE_COMMENT, _deleteCommentModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_DELETE_POST, _deletePostModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_DELETE_CATEGORY, _deleteCategoryModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_MOVE_POST, _movePostModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_REPORT_COMMENT, _reportCommentModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_REPORT_POST, _reportPostModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_REPORT_MEMBER, _reportMemberModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_PROMOTE_MODERATOR, _promoteModeratorModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_DEMOTE_MODERATOR, _demoteModeratorModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_UNFOLLOW_MEMBER, _unfollowMemberModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_BLOCK_MEMBER, _blockMemberModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_UNBLOCK_MEMBER, _unblockMemberModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_SHARE_POST, _sharePostModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_SHARE_LINK, _shareLinkModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_SHARE_COMMENT, _shareCommentModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_LOGIN, _loginModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_PROFILE_ACTIONS, _profileActionsWidget2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART, _profileActionsUpperPart2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_TEXT_EDITOR_LINK, _textEditorLinkModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_TEXT_EDITOR_VIDEO_EMBED, _textEditorVideoEmbedModal2.default), _defineProperty(_types$MODAL_TYPE_DIS, types.MODAL_TYPE_DEMO_MODE, _demoModal2.default), _types$MODAL_TYPE_DIS);

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _discardPostModal = __webpack_require__(621);

var _discardPostModal2 = _interopRequireDefault(_discardPostModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _discardPostModal2.default;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscardPostModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _confirmation = __webpack_require__(64);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _icons = __webpack_require__(9);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscardPostModal = exports.DiscardPostModal = function DiscardPostModal(_ref) {
  var closeModal = _ref.closeModal,
      discardPost = _ref.discardPost,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(
      _confirmation2.default,
      {
        icon: _icons.DiscardIcon,
        title: t('discard-post-modal.discard-post'),
        confirm: t('discard-post-modal.confirm'),
        cancel: t('discard-post-modal.cancel'),
        onConfirm: discardPost,
        onCancel: closeModal
      },
      _react2.default.createElement(
        'p',
        null,
        t('discard-post-modal.are-you-sure')
      )
    )
  );
};

DiscardPostModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  discardPost: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    discardPost: function discardPost() {
      return (0, _closeModal.closeModal)(ownProps.categorySlug);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(DiscardPostModal));

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _modal = __webpack_require__(624);

var _modal2 = _interopRequireDefault(_modal);

var _accessibility = __webpack_require__(49);

var _accessibilityListener = __webpack_require__(324);

var _accessibilityListener2 = _interopRequireDefault(_accessibilityListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = exports.Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.setInitialFocusElement = function (ref) {
      _this.initialFocusElement = ref;
    }, _this.focusInitialElement = function () {
      _this.initialFocusElement && _this.initialFocusElement.focus();
    }, _this.renderCloseButtonDesktop = function () {
      var _this$props = _this.props,
          t = _this$props.t,
          onClose = _this$props.onClose;

      if (!onClose) {
        return null;
      }

      return _react2.default.createElement(
        'button',
        {
          className: (0, _classnames2.default)(_modal2.default.closeIcon, 'modal__close'),
          onClick: _this.handleClose,
          onKeyUp: (0, _accessibility.handleEnterKeyUp)(_this.handleClose),
          'aria-label': t('modal.close')
        },
        _react2.default.createElement(_icons.XLarge, null)
      );
    }, _this.handleClose = function () {
      return _this.props.onClose && _this.props.onClose();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // call onClose() without arguments for modal


  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusInitialElement();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          isDesktop = _props.isDesktop,
          backdrop = _props.backdrop,
          cardBackgroundColor = _props.cardBackgroundColor;

      var containerClassName = (0, _classnames2.default)(_modal2.default.container, _defineProperty({}, _modal2.default.withShadow, !backdrop));
      var style = { backgroundColor: cardBackgroundColor };

      return _react2.default.createElement(
        'main',
        {
          ref: this.setInitialFocusElement,
          className: containerClassName,
          onKeyUp: (0, _accessibility.handleEscapeKeyUp)(this.handleClose),
          tabIndex: '0'
        },
        _react2.default.createElement(_accessibilityListener2.default, null),
        backdrop ? _react2.default.createElement('div', {
          className: (0, _classnames2.default)(_modal2.default.backdrop, 'modal__overlay'),
          onClick: this.handleClose,
          onKeyUp: (0, _accessibility.handleEnterKeyUp)(this.handleClose)
        }) : null,
        isDesktop ? this.renderCloseButtonDesktop(this.handleClose) : null,
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_modal2.default.modal, className, 'default-forum-card-background-color'), style: style },
          children
        ),
        _react2.default.createElement('div', { className: _modal2.default.focusWrapper, tabIndex: '0', onKeyUp: (0, _accessibility.handleTabKeyUp)(this.focusInitialElement) })
      );
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  className: _propTypes2.default.string,
  cardBackgroundColor: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onClose: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool,
  isDesktop: _propTypes2.default.bool,
  backdrop: _propTypes2.default.bool,
  t: _propTypes2.default.func.isRequired
};

Modal.defaultProps = {
  backdrop: true
};

// prettier-ignore
exports.default = (0, _lodash.flowRight)(_withCardBackgroundColor2.default, _withDeviceType2.default, _withTranslate2.default)(Modal);

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Y6t2","backdrop":"_1Zuei","modal":"_3_TqG","withShadow":"_1-QmZ","closeIcon":"_2ui-m","focusWrapper":"_2gs9r"};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibilityListener = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _accessibilityListener = __webpack_require__(626);

var _accessibilityListener2 = _interopRequireDefault(_accessibilityListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccessibilityListener = exports.AccessibilityListener = function (_Component) {
  _inherits(AccessibilityListener, _Component);

  function AccessibilityListener() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AccessibilityListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccessibilityListener.__proto__ || Object.getPrototypeOf(AccessibilityListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleTabKeyUp = function (e) {
      if (e.which === 9 && document.body.classList.contains(_accessibilityListener2.default.noOutline)) {
        document.body.classList.remove(_accessibilityListener2.default.noOutline);
      }
    }, _this.handleClick = function () {
      if (!document.body.classList.contains(_accessibilityListener2.default.noOutline)) {
        document.body.classList.add(_accessibilityListener2.default.noOutline);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AccessibilityListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.classList.add(_accessibilityListener2.default.noOutline);

      if (!this.props.isMobile) {
        document.addEventListener('keyup', this.handleTabKeyUp);
        document.addEventListener('click', this.handleClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.props.isMobile) {
        document.removeEventListener('keyup', this.handleTabKeyUp);
        document.removeEventListener('click', this.handleClick);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return AccessibilityListener;
}(_react.Component);

AccessibilityListener.propTypes = {
  isMobile: _propTypes2.default.bool.isRequired
};

exports.default = (0, _withDeviceType2.default)(AccessibilityListener);

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"noOutline":"oGUTa"};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _buttonGroup = __webpack_require__(50);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _confirmation = __webpack_require__(634);

var _confirmation2 = _interopRequireDefault(_confirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Confirmation = function Confirmation(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      children = _ref.children,
      confirm = _ref.confirm,
      onConfirm = _ref.onConfirm,
      cancel = _ref.cancel,
      onCancel = _ref.onCancel,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName;

  var Icon = icon;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_confirmation2.default.container, contentFontClassName, 'forum-text-color') },
    _react2.default.createElement(
      'h3',
      { className: (0, _classnames2.default)(_confirmation2.default.titleContainer, titleFontClassName) },
      _react2.default.createElement(Icon, { className: (0, _classnames2.default)(_confirmation2.default.icon, 'forum-icon-fill') }),
      _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)(_confirmation2.default.title, 'confirmation__title'), 'data-hook': 'confirmation__title' },
        title
      )
    ),
    children && _react2.default.createElement(
      'div',
      { className: _confirmation2.default.content, 'data-hook': 'confirmation__content' },
      children
    ),
    _react2.default.createElement(_buttonGroup2.default, {
      primaryButtonText: confirm,
      primaryButtonProps: { onClick: function onClick() {
          return onConfirm();
        } },
      secondaryButtonText: cancel,
      secondaryButtonProps: { onClick: function onClick() {
          return onCancel();
        } }
    })
  );
};

Confirmation.propTypes = {
  icon: _propTypes2.default.any.isRequired,
  title: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node,
  confirm: _propTypes2.default.string.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  cancel: _propTypes2.default.string.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired
};

exports.default = (0, _withFontClassName2.default)(Confirmation);

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _buttonGroup = __webpack_require__(633);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = function ButtonGroup(_ref) {
  var primaryButtonText = _ref.primaryButtonText,
      primaryButtonProps = _ref.primaryButtonProps,
      isPrimaryButtonVisible = _ref.isPrimaryButtonVisible,
      secondaryButtonText = _ref.secondaryButtonText,
      secondaryButtonProps = _ref.secondaryButtonProps,
      isSecondaryButtonVisible = _ref.isSecondaryButtonVisible;
  return _react2.default.createElement(
    'div',
    { className: _buttonGroup2.default.wrapper },
    _react2.default.createElement(
      'div',
      { className: _buttonGroup2.default.container },
      renderButton(isSecondaryButtonVisible, secondaryButtonText, _extends({}, secondaryButtonProps, {
        isSecondary: true,
        className: (0, _classnames2.default)(_buttonGroup2.default.button, 'button-group__secondary-button'),
        'data-hook': 'cancel-button'
      })),
      renderButton(isPrimaryButtonVisible, primaryButtonText, _extends({}, primaryButtonProps, {
        className: (0, _classnames2.default)(_buttonGroup2.default.button, 'button-group__primary-button'),
        'data-hook': 'submit-button'
      }))
    )
  );
};

function renderButton(isVisible, text, props) {
  if (!isVisible) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: _buttonGroup2.default.buttonWrapper },
    _react2.default.createElement(
      _button2.default,
      props,
      text
    )
  );
}

ButtonGroup.propTypes = {
  primaryButtonText: _propTypes2.default.string,
  primaryButtonProps: _propTypes2.default.object,
  isPrimaryButtonVisible: _propTypes2.default.bool,
  secondaryButtonText: _propTypes2.default.string,
  secondaryButtonProps: _propTypes2.default.object,
  isSecondaryButtonVisible: _propTypes2.default.bool
};

ButtonGroup.defaultProps = {
  primaryButtonProps: {},
  isPrimaryButtonVisible: true,
  secondaryButtonProps: {},
  isSecondaryButtonVisible: true
};

exports.default = ButtonGroup;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _buttonTooltip = __webpack_require__(630);

var _buttonTooltip2 = _interopRequireDefault(_buttonTooltip);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _button = __webpack_require__(325);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SHOW_TIMEOUT = 200;
var HIDE_TIMEOUT = 3000;

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isTooltipVisible: false
    }, _this.handleMouseEnter = function () {
      _this.showTooltip();
    }, _this.handleMouseLeave = function () {
      _this.hideTooltip();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hideTooltip();
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip() {
      var _this2 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.setState({ isTooltipVisible: true }, function () {
          _this2.timeout = setTimeout(function () {
            return _this2.hideTooltip();
          }, HIDE_TIMEOUT);
        });
      }, SHOW_TIMEOUT);
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      clearTimeout(this.timeout);
      this.setState({
        isTooltipVisible: false
      });
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      var isTooltipVisible = this.state.isTooltipVisible;
      var tooltipText = this.props.tooltipText;


      if (!tooltipText) {
        return null;
      }

      return _react2.default.createElement(
        _buttonTooltip2.default,
        { isVisible: isTooltipVisible, target: this },
        tooltipText
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          Component = _props.component,
          className = _props.className,
          contentFontClassName = _props.contentFontClassName,
          isSecondary = _props.isSecondary,
          isMuted = _props.isMuted,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['component', 'className', 'contentFontClassName', 'isSecondary', 'isMuted', 'children']);

      var isPrimary = !isSecondary;
      var containerClassName = (0, _classnames2.default)(_button2.default.button, className, contentFontClassName, isPrimary ? 'button-background-color' : 'button-border-color', isPrimary ? 'button-primary-text-color' : 'button-secondary-text-color', (_classNames = {}, _defineProperty(_classNames, _button2.default.secondary, isSecondary), _defineProperty(_classNames, _button2.default.isMuted, isMuted), _classNames));
      var componentProps = (0, _lodash.omit)(otherProps, 'currentUser', 'dispatch', 'isAuthenticated', 'isBlocked', 'isDemoMode', 'isOwner', 'openModal', 'titleFontClassName', 'tooltipText', 'viewMode', 'forPublicUser', 'isPrivate');

      return _react2.default.createElement(
        Component,
        _extends({
          className: containerClassName
        }, componentProps, {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }),
        this.renderTooltip(),
        _react2.default.createElement(
          'span',
          { className: _button2.default.wrapper },
          children
        )
      );
    }
  }]);

  return Button;
}(_react.Component);

Button.propTypes = {
  contentFontClassName: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string,
  className: _propTypes2.default.string,
  isSecondary: _propTypes2.default.bool,
  isMuted: _propTypes2.default.bool,
  component: _propTypes2.default.any,
  children: _propTypes2.default.node,
  tooltipText: _propTypes2.default.string
};

Button.defaultProps = {
  component: 'button'
};

exports.default = (0, _withFontClassName2.default)(Button);

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _buttonTooltip = __webpack_require__(631);

var _buttonTooltip2 = _interopRequireDefault(_buttonTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _buttonTooltip2.default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactGateway = __webpack_require__(405);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _buttonTooltip = __webpack_require__(632);

var _buttonTooltip2 = _interopRequireDefault(_buttonTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonTooltip = function (_Component) {
  _inherits(ButtonTooltip, _Component);

  function ButtonTooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ButtonTooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonTooltip.__proto__ || Object.getPrototypeOf(ButtonTooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.setContainer = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ButtonTooltip, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var isVisible = this.props.isVisible;


      if (isVisible !== prevProps.isVisible) {
        if (isVisible) {
          this.showComponent();
        } else {
          this.hideComponent();
        }
      }
    }
  }, {
    key: 'showComponent',
    value: function showComponent() {
      var target = this.props.target;

      var rect = this.container.getBoundingClientRect();
      var targetRect = (0, _reactDom.findDOMNode)(target).getBoundingClientRect();

      this.setState({
        position: {
          left: targetRect.right - targetRect.width / 2 + 19 - rect.width,
          top: targetRect.top - (12 + rect.height)
        }
      });
    }
  }, {
    key: 'hideComponent',
    value: function hideComponent() {
      this.setState({
        position: null
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cardBackgroundColor = _props.cardBackgroundColor,
          contentFontClassName = _props.contentFontClassName,
          children = _props.children;
      var position = this.state.position;


      var containerClassName = (0, _classnames2.default)(_buttonTooltip2.default.bubble, contentFontClassName, 'forum-text-color', 'forum-card-border-color');
      var style = _extends({
        backgroundColor: cardBackgroundColor,
        visibility: position ? 'visible' : 'hidden'
      }, position);

      return _react2.default.createElement(
        _reactGateway.Gateway,
        { into: 'tooltip' },
        _react2.default.createElement(
          'div',
          { className: containerClassName, style: style, ref: this.setContainer },
          _react2.default.createElement(
            'div',
            { className: _buttonTooltip2.default.content, 'data-hook': 'tooltip' },
            children
          ),
          _react2.default.createElement(
            'div',
            { className: _buttonTooltip2.default.triangleWrapper },
            _react2.default.createElement('div', {
              className: (0, _classnames2.default)(_buttonTooltip2.default.triangle, 'forum-card-border-color'),
              style: { backgroundColor: cardBackgroundColor }
            })
          )
        )
      );
    }
  }]);

  return ButtonTooltip;
}(_react.Component);

ButtonTooltip.propTypes = {
  style: _propTypes2.default.object,
  cardBackgroundColor: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  target: _propTypes2.default.any.isRequired,
  isVisible: _propTypes2.default.bool,
  children: _propTypes2.default.node
};

exports.default = (0, _withCardBackgroundColor2.default)((0, _withFontClassName2.default)(ButtonTooltip));

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bubble":"_3JWtj","content":"_2AzkO","triangleWrapper":"_1hpoh","triangle":"_3fu9P"};

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"aVyUX","container":"_10x6h","buttonWrapper":"_1PNkO","button":"_3pcIy"};

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"titleContainer":"_8yyOS","container":"_2gJZC","icon":"AT10m","title":"_3j86f","content":"_2qimT"};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeWixModal = undefined;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var closeWixModal = exports.closeWixModal = function closeWixModal(action) {
  return function () {
    _wixSdkPolyfill2.default.closeWindow(action);
  };
};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postCreateModal = __webpack_require__(637);

var _postCreateModal2 = _interopRequireDefault(_postCreateModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postCreateModal2.default;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostCreateModal = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reduxForm = __webpack_require__(40);

var _closeModal = __webpack_require__(12);

var _currentUserSelectors = __webpack_require__(67);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _postForm = __webpack_require__(517);

var _postForm2 = _interopRequireDefault(_postForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostCreateModal = exports.PostCreateModal = function (_Component) {
  _inherits(PostCreateModal, _Component);

  function PostCreateModal(props) {
    _classCallCheck(this, PostCreateModal);

    var _this = _possibleConstructorReturn(this, (PostCreateModal.__proto__ || Object.getPrototypeOf(PostCreateModal)).call(this, props));

    _this.state = {
      initialValues: { ownerId: props.ownerId, categoryId: props.categoryId }
    };
    return _this;
  }

  _createClass(PostCreateModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleClose = _props.closeModal,
          categoryId = _props.categoryId,
          submit = _props.submit;

      return _react2.default.createElement(
        _modal2.default,
        { onClose: handleClose },
        _react2.default.createElement(_postForm2.default, {
          onSubmit: handleClose,
          onSubmitButtonClick: submit,
          onCancel: function onCancel() {
            return handleClose();
          },
          initialValues: this.state.initialValues,
          categoryId: categoryId
        })
      );
    }
  }]);

  return PostCreateModal;
}(_react.Component);

PostCreateModal.propTypes = {
  ownerId: _propTypes2.default.string.isRequired,
  categoryId: _propTypes2.default.string.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  submit: _propTypes2.default.func.isRequired,
  post: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    ownerId: (0, _currentUserSelectors.getCurrentUserId)(state)
  };
};

var mapDispatchToProps = {
  closeModal: _closeModal.closeModal,
  submit: function submit() {
    return (0, _reduxForm.startSubmit)('post');
  }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostCreateModal);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reduxForm = __webpack_require__(40);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _inputText = __webpack_require__(639);

var _inputText2 = _interopRequireDefault(_inputText);

var _styledTextEditor = __webpack_require__(292);

var _currentUserAvatar = __webpack_require__(543);

var _currentUserAvatar2 = _interopRequireDefault(_currentUserAvatar);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _postCreateActions = __webpack_require__(839);

var _postCreateActions2 = _interopRequireDefault(_postCreateActions);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _currentUserProfileLink = __webpack_require__(546);

var _currentUserProfileLink2 = _interopRequireDefault(_currentUserProfileLink);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _postFormSettings = __webpack_require__(547);

var _postFormSettings2 = _interopRequireDefault(_postFormSettings);

var _postFormUtils = __webpack_require__(842);

var _postForm = __webpack_require__(843);

var _postForm2 = _interopRequireDefault(_postForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostForm = exports.PostForm = function (_Component) {
  _inherits(PostForm, _Component);

  function PostForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PostForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostForm.__proto__ || Object.getPrototypeOf(PostForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleDrop = function (event) {
      return event.preventDefault();
    }, _this.handleCancelClick = function () {
      _this.props.onCancel((0, _postFormUtils.isModified)(_this.props.fields, _this.state.initialContent));
    }, _this.handleContentChange = function (contentState) {
      // persist initial state to test for isModified on edit discard
      _this.props.fields.content.onChange(contentState);
      _this.setState({
        initialContent: _this.state.initialContent || contentState
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PostForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var submitting = _ref2.submitting,
          handleSubmit = _ref2.handleSubmit;

      if (submitting && !this.props.submitting) {
        handleSubmit();
      }
    }
  }, {
    key: 'renderMoreButton',
    value: function renderMoreButton() {
      var _props = this.props,
          postId = _props.postId,
          categoryId = _props.categoryId;

      if (!postId) {
        return _react2.default.createElement(
          _moreButton2.default,
          { className: _postForm2.default.moreButton },
          _react2.default.createElement(_postCreateActions2.default, { categoryId: categoryId })
        );
      }
    }
  }, {
    key: 'renderAvatar',
    value: function renderAvatar() {
      var isMobile = this.props.isMobile;

      return _react2.default.createElement(
        _currentUserProfileLink2.default,
        null,
        _react2.default.createElement(_currentUserAvatar2.default, { type: isMobile ? null : _currentUserAvatar2.default.LARGE })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$fields = _props2.fields,
          title = _props2$fields.title,
          content = _props2$fields.content,
          limit = _props2.limit,
          postId = _props2.postId,
          handleSubmitButtonClick = _props2.onSubmitButtonClick,
          submitting = _props2.submitting,
          invalid = _props2.invalid,
          t = _props2.t,
          borderWidth = _props2.borderWidth,
          contentFontClassName = _props2.contentFontClassName,
          titleFontClassName = _props2.titleFontClassName,
          errors = _props2.errors,
          isDesktop = _props2.isDesktop,
          forPublicUser = _props2.forPublicUser;
      var titleValue = title.value,
          onTitleChange = title.onChange;

      var containerClassName = (0, _classnames2.default)(_postForm2.default.form, 'forum-text-color', 'forum-card-background-color', 'forum-card-border-color', contentFontClassName);
      var isButtonDisabled = submitting || invalid;
      var buttonTooltipText = void 0;

      if (errors.title && errors.content) {
        buttonTooltipText = t('post-form.require-fields');
      } else if (errors.title) {
        buttonTooltipText = t('post-form.require-title');
      } else if (errors.content) {
        buttonTooltipText = errors.content === 'required' ? t('post-form.require-content') : t('post-form.uploading');
      }

      return _react2.default.createElement(
        'div',
        { className: containerClassName, style: { borderWidth: borderWidth } },
        _react2.default.createElement(
          'div',
          { className: _postForm2.default.wrapper },
          _react2.default.createElement(
            'div',
            { className: _postForm2.default.mainArea },
            _react2.default.createElement(
              'div',
              { className: _postForm2.default.header },
              this.renderAvatar()
            ),
            _react2.default.createElement(
              'div',
              { className: _postForm2.default.titleInputWrapper },
              _react2.default.createElement(_inputText2.default, {
                value: titleValue,
                onChange: onTitleChange,
                containerClassName: titleFontClassName,
                className: (0, _classnames2.default)(_postForm2.default.titleInput, 'forum-text-color'),
                maxLength: limit,
                placeholder: t('post-form.give-this-post-a-title'),
                autoFocus: !postId || isDesktop,
                onDrop: this.handleDrop,
                'data-hook': 'post-form__title-input'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(_postForm2.default.content, 'post-form__text-editor') },
              _react2.default.createElement(_styledTextEditor.TextEditor, _extends({
                placeholder: t('text-editor.placeholder'),
                identifier: 'post'
              }, content, {
                onChange: this.handleContentChange
              }))
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _postForm2.default.footer },
            _react2.default.createElement(
              'div',
              { className: _postForm2.default.editorControls },
              _react2.default.createElement(_styledTextEditor.TextEditorMediaButtons, { identifier: 'post' })
            ),
            _react2.default.createElement(
              'div',
              { className: _postForm2.default.buttons },
              _react2.default.createElement(
                'span',
                { className: _postForm2.default.button },
                _react2.default.createElement(
                  _button2.default,
                  { isSecondary: true, onClick: this.handleCancelClick },
                  t('post-form.cancel')
                )
              ),
              _react2.default.createElement(
                'span',
                { className: _postForm2.default.button },
                _react2.default.createElement(
                  _button2.default,
                  {
                    onClick: !isButtonDisabled && forPublicUser(handleSubmitButtonClick),
                    tooltipText: buttonTooltipText,
                    isMuted: isButtonDisabled,
                    'data-hook': 'post-form__publish-button'
                  },
                  postId ? t('post-form.update') : t('post-form.publish')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PostForm;
}(_react.Component);

PostForm.propTypes = {
  fields: _propTypes2.default.object.isRequired,
  handleSubmit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  onSubmitButtonClick: _propTypes2.default.func.isRequired,
  borderWidth: _propTypes2.default.number.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  errors: _propTypes2.default.object.isRequired,
  limit: _propTypes2.default.number,
  submitting: _propTypes2.default.bool,
  invalid: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isDesktop: _propTypes2.default.bool.isRequired,
  t: _propTypes2.default.func,
  postId: _propTypes2.default.string,
  categoryId: _propTypes2.default.string,
  forPublicUser: _propTypes2.default.func
};

PostForm.defaultProps = {
  limit: 60
};

exports.default = _lodash2.default.flowRight((0, _reduxForm.reduxForm)(_postFormSettings2.default), _withDeviceType2.default, _withTranslate2.default, _withCardBorderWidth2.default, _withFontClassName2.default, _withAuth2.default)(PostForm);

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _inputText = __webpack_require__(640);

var _inputText2 = _interopRequireDefault(_inputText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _inputText2.default;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _getColors = __webpack_require__(265);

var _reactTextareaAutosize = __webpack_require__(542);

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _inputText = __webpack_require__(641);

var _inputText2 = _interopRequireDefault(_inputText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputText = function (_Component) {
  _inherits(InputText, _Component);

  function InputText(props) {
    _classCallCheck(this, InputText);

    var _this = _possibleConstructorReturn(this, (InputText.__proto__ || Object.getPrototypeOf(InputText)).call(this, props));

    _this.state = {
      hasFocus: false
    };


    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    return _this;
  }

  _createClass(InputText, [{
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({ hasFocus: false });
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.setState({ hasFocus: true });
    }
  }, {
    key: 'renderCounter',
    value: function renderCounter() {
      var _props = this.props,
          value = _props.value,
          maxLength = _props.maxLength;

      var left = maxLength - value.length;
      if (maxLength) {
        return _react2.default.createElement(
          'span',
          {
            className: (0, _classnames2.default)(_inputText2.default.counter, _defineProperty({}, _inputText2.default.hasFocus, this.state.hasFocus)),
            style: left === 0 ? { color: (0, _getColors.getSecondaryColor)() } : null
          },
          left
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          containerClassName = _props2.containerClassName,
          props = _objectWithoutProperties(_props2, ['className', 'containerClassName']);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_inputText2.default.inputWrapper, containerClassName) },
        _react2.default.createElement(_reactTextareaAutosize2.default, _extends({
          className: (0, _classnames2.default)(_inputText2.default.input, className),
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, props)),
        this.renderCounter()
      );
    }
  }]);

  return InputText;
}(_react.Component);

InputText.propTypes = {
  autoFocus: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  containerClassName: _propTypes2.default.string,
  maxLength: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string
};

exports.default = InputText;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inputWrapper":"_17cLG","input":"AucvT","counter":"_2jm_F","hasFocus":"_2dDy4"};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var createHelper = function createHelper(func, helperName) {
  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (false) {
    var _ret = function () {
      /* eslint-disable global-require */
      var wrapDisplayName = require('./wrapDisplayName').default;
      /* eslint-enable global-require */

      if (noArgs) {
        return {
          v: function v(BaseComponent) {
            var Component = func(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          }
        };
      }

      return {
        v: function v() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return function (BaseComponent) {
            var Component = func.apply(undefined, args)(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          };
        }
      };
    }();

    if (typeof _ret === "object") return _ret.v;
  }

  return func;
};

exports.default = createHelper;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(644);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(645);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__(646);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && ("production" === 'production' || !Component.propTypes));
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
};

exports.default = isClassComponent;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractHashtags = exports.DraftRenderer = exports.TextEditorMediaButtons = exports.TextEditorMobileToolbar = exports.default = undefined;

var _textEditorMobileToolbar = __webpack_require__(648);

Object.defineProperty(exports, 'TextEditorMobileToolbar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_textEditorMobileToolbar).default;
  }
});

var _textEditorMediaButtons = __webpack_require__(725);

Object.defineProperty(exports, 'TextEditorMediaButtons', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_textEditorMediaButtons).default;
  }
});

var _draftRenderer = __webpack_require__(727);

Object.defineProperty(exports, 'DraftRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_draftRenderer).default;
  }
});

var _hashtag = __webpack_require__(240);

Object.defineProperty(exports, 'extractHashtags', {
  enumerable: true,
  get: function get() {
    return _hashtag.extractHashtags;
  }
});

var _textEditor = __webpack_require__(800);

var _textEditor2 = _interopRequireDefault(_textEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _textEditor2.default;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _buttons = __webpack_require__(53);

var _separator = __webpack_require__(18);

var _textEditorButtonGroup = __webpack_require__(229);

var _textEditorButtonGroup2 = _interopRequireDefault(_textEditorButtonGroup);

var _textEditorMobileToolbar = __webpack_require__(724);

var _textEditorMobileToolbar2 = _interopRequireDefault(_textEditorMobileToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTONS_LEFT = [_buttons.BUTTON_BOLD, _buttons.BUTTON_ITALIC, _buttons.BUTTON_HEADER_DROPDOWN, _buttons.BUTTON_ALIGN_TEXT_DROPDOWN, _buttons.BUTTON_LIST_DROPDOWN, _buttons.BUTTON_BLOCKQUOTE, _buttons.BUTTON_LINK];
var BUTTONS_RIGHT = [_buttons.BUTTON_IMAGE, _buttons.BUTTON_VIDEO];

var TextEditorMobileToolbar = function TextEditorMobileToolbar(_ref) {
  var identifier = _ref.identifier,
      theme = _ref.theme;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)((0, _lodash.get)(theme, 'container'), 'text-editor-mobile-toolbar'),
      style: (0, _lodash.get)(theme, 'containerStyle')
    },
    _react2.default.createElement(
      'div',
      { className: _textEditorMobileToolbar2.default.flexContainer },
      renderGroup(BUTTONS_LEFT, identifier, true, (0, _lodash.get)(theme, 'button')),
      renderGroup(BUTTONS_RIGHT, identifier, false, (0, _lodash.get)(theme, 'button'))
    ),
    _react2.default.createElement(_separator.HorizontalSeparator, null)
  );
};

function renderGroup(buttons, identifier, disableOnBlur, theme) {
  return _react2.default.createElement(_textEditorButtonGroup2.default, {
    buttons: buttons,
    identifier: identifier,
    containerClassName: _textEditorMobileToolbar2.default.buttons,
    buttonClassName: _textEditorMobileToolbar2.default.button,
    disableOnBlur: disableOnBlur,
    theme: theme
  });
}

TextEditorMobileToolbar.propTypes = {
  identifier: _propTypes2.default.string.isRequired,
  theme: _propTypes2.default.object
};

exports.default = TextEditorMobileToolbar;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulletSeparator = exports.VerticalSeparator = exports.HorizontalSeparator = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _separator = __webpack_require__(650);

var _separator2 = _interopRequireDefault(_separator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorizontalSeparator = exports.HorizontalSeparator = function HorizontalSeparator(_ref) {
  var className = _ref.className,
      inverted = _ref.inverted;
  return _react2.default.createElement('div', { className: (0, _classnames2.default)(_separator2.default.horizontal, className, getClassName(inverted)) });
};

HorizontalSeparator.propTypes = {
  className: _propTypes2.default.string,
  inverted: _propTypes2.default.bool
};

var VerticalSeparator = exports.VerticalSeparator = function VerticalSeparator(_ref2) {
  var className = _ref2.className,
      inverted = _ref2.inverted;
  return _react2.default.createElement('div', { className: (0, _classnames2.default)(_separator2.default.vertical, className, getClassName(inverted)) });
};

VerticalSeparator.propTypes = {
  className: _propTypes2.default.string,
  inverted: _propTypes2.default.bool
};

var BulletSeparator = exports.BulletSeparator = function BulletSeparator(_ref3) {
  var className = _ref3.className,
      inverted = _ref3.inverted;
  return _react2.default.createElement('div', { className: (0, _classnames2.default)(_separator2.default.bullet, className, getClassName(inverted)) });
};

BulletSeparator.propTypes = {
  className: _propTypes2.default.string,
  inverted: _propTypes2.default.bool
};

function getClassName(inverted) {
  return inverted ? 'forum-inverted-separator-background-color' : 'forum-separator-background-color';
}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"O2IaJ","vertical":"_1H6Sn","bullet":"_1i8oU"};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openWixModal = undefined;

var _urijs = __webpack_require__(19);

var _urijs2 = _interopRequireDefault(_urijs);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _config = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODAL_POSITION = {
  origin: _wixSdkPolyfill2.default.WindowOrigin.FIXED,
  placement: _wixSdkPolyfill2.default.WindowPlacement.CENTER
};

var openWixModal = exports.openWixModal = function openWixModal(type) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch, getState, _ref) {
    var baseUrl = _ref.baseUrl;

    var onClose = function onClose(data) {
      var action = data && data.message;
      if (action) {
        dispatch(action);
      }
    };
    var data = JSON.stringify({ type: type, props: props });
    var debug = (0, _urijs2.default)(window.location.search).search(true).debug;
    var url = baseUrl + '/modal';

    _wixSdkPolyfill2.default.openPopup(url + '?data=' + data + '&section-url=' + (0, _config.getConfig)().sectionUrl + '&debug=' + debug, '100%', '100%', MODAL_POSITION, onClose, _wixSdkPolyfill2.default.Theme.BARE);
  };
};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlignLeftIcon = function AlignLeftIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 18" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-175.000000, -16.000000)" },
        _react2.default.createElement("path", {
          d: "M175,16 L189,16 L189,18 L175,18 L175,16 Z M175,20 L183,20 L183,22 L175,22 L175,20 Z M175,24 L183,24 L183,26 L175,26 L175,24 Z M175,28 L183,28 L183,30 L175,30 L175,28 Z M175,32 L189,32 L189,34 L175,34 L175,32 Z M185,20 L195,20 L195,30 L185,30 L185,20 Z",
          transform: "translate(185.000000, 25.000000) scale(-1, 1) translate(-185.000000, -25.000000)"
        })
      )
    )
  );
};

exports.default = AlignLeftIcon;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlignRightIcon = function AlignRightIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 18" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-219.000000, -16.000000)" },
        _react2.default.createElement("path", { d: "M219,16 L233,16 L233,18 L219,18 L219,16 Z M219,20 L227,20 L227,22 L219,22 L219,20 Z M219,24 L227,24 L227,26 L219,26 L219,24 Z M219,28 L227,28 L227,30 L219,30 L219,28 Z M219,32 L233,32 L233,34 L219,34 L219,32 Z M229,20 L239,20 L239,30 L229,30 L229,20 Z" })
      )
    )
  );
};

exports.default = AlignRightIcon;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlignTextCenterIcon = function AlignTextCenterIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 16" }, props),
    _react2.default.createElement("path", {
      stroke: "none",
      fillRule: "evenodd",
      transform: "translate(-12.000000, -55.000000)",
      d: "M12,55 L28,55 L28,57 L12,57 L12,55 Z M16,59 L24,59 L24,60 L16,60 L16,59 Z M12,62 L28,62 L28,64 L12,64 L12,62 Z M16,66 L24,66 L24,67 L16,67 L16,66 Z M12,69 L28,69 L28,71 L12,71 L12,69 Z"
    })
  );
};

exports.default = AlignTextCenterIcon;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlignTextJustifyIcon = function AlignTextJustifyIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 16" }, props),
    _react2.default.createElement("path", {
      stroke: "none",
      fillRule: "evenodd",
      transform: "translate(-12.000000, -137.000000)",
      d: "M12,137 L28,137 L28,139 L12,139 L12,137 Z M12,141 L28,141 L28,142 L12,142 L12,141 Z M12,144 L28,144 L28,146 L12,146 L12,144 Z M12,148 L28,148 L28,149 L12,149 L12,148 Z M12,151 L20,151 L20,153 L12,153 L12,151 Z"
    })
  );
};

exports.default = AlignTextJustifyIcon;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlignTextLeftIcon = function AlignTextLeftIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 16" }, props),
    _react2.default.createElement("path", {
      stroke: "none",
      fillRule: "evenodd",
      transform: "translate(-12.000000, -12.000000)",
      d: "M12,12 L28,12 L28,14 L12,14 L12,12 Z M12,16 L20,16 L20,17 L12,17 L12,16 Z M12,19 L28,19 L28,21 L12,21 L12,19 Z M12,23 L20,23 L20,24 L12,24 L12,23 Z M12,26 L28,26 L28,28 L12,28 L12,26 Z"
    })
  );
};

exports.default = AlignTextLeftIcon;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlignTextRightIcon = function AlignTextRightIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 16" }, props),
    _react2.default.createElement(
      "g",
      { transform: "translate(-12.000000, -96.000000)", stroke: "none", fillRule: "evenodd" },
      _react2.default.createElement("path", {
        d: "M12,96 L28,96 L28,98 L12,98 L12,96 Z M12,100 L20,100 L20,101 L12,101 L12,100 Z M12,103 L28,103 L28,105 L12,105 L12,103 Z M12,107 L20,107 L20,108 L12,108 L12,107 Z M12,110 L28,110 L28,112 L12,112 L12,110 Z",
        transform: "translate(20.000000, 104.000000) scale(-1, 1) translate(-20.000000, -104.000000)"
      })
    )
  );
};

exports.default = AlignTextRightIcon;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoldIcon = function BoldIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 12 14" }, props),
    _react2.default.createElement("path", {
      stroke: "none",
      fillRule: "eventodd",
      d: "M95.357,72.571A3.128,3.128,0,0,0,97.4,69.608a3.215,3.215,0,0,0-1.435-2.8A5.54,5.54,0,0,0,92.91,66H86v2.356h1.211v9.287H86V80h6.487a7.343,7.343,0,0,0,3.764-.9A3.591,3.591,0,0,0,98,75.855,3.262,3.262,0,0,0,95.357,72.571Zm-3.206-1.026h-2.08V68.356h1.863c1.852,0,2.61.44,2.61,1.517C94.544,71.255,93.244,71.545,92.151,71.545Zm-2.08,2.425h2.2c2.038,0,2.87.515,2.87,1.779s-1,1.895-2.968,1.895h-2.1V73.97Z",
      transform: "translate(-86 -66)"
    })
  );
};

exports.default = BoldIcon;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CameraIcon = function CameraIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 16" }, props),
    _react2.default.createElement("path", {
      fillRule: "evenodd",
      stroke: "none",
      d: "M375.218,68.182a2.68,2.68,0,0,0-1.885-.721H371l-0.532-1.308a1.821,1.821,0,0,0-.723-0.813A1.959,1.959,0,0,0,368.666,65h-5.332a1.961,1.961,0,0,0-1.079.341,1.815,1.815,0,0,0-.723.813L361,67.461h-2.333a2.68,2.68,0,0,0-1.885.721A2.284,2.284,0,0,0,356,69.923v8.616a2.283,2.283,0,0,0,.781,1.74,2.679,2.679,0,0,0,1.885.721h14.666a2.679,2.679,0,0,0,1.885-.721,2.28,2.28,0,0,0,.781-1.74V69.923A2.28,2.28,0,0,0,375.218,68.182ZM369.3,77.274a4.928,4.928,0,0,1-6.593,0,4.065,4.065,0,0,1,0-6.086,4.928,4.928,0,0,1,6.593,0A4.067,4.067,0,0,1,369.3,77.274ZM366,71.461a3.011,3.011,0,0,0-2.119.813,2.614,2.614,0,0,0,0,3.914,3.171,3.171,0,0,0,4.238,0,2.614,2.614,0,0,0,0-3.914A3.012,3.012,0,0,0,366,71.461Z",
      transform: "translate(-356 -65)"
    })
  );
};

exports.default = CameraIcon;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteIcon = function DeleteIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 13 16" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-326.000000, -17.000000)" },
        _react2.default.createElement("path", { d: "M338,21.2666667 L338,30.8666667 C338,32.0448741 337.104569,33 336,33 L329,33 C327.895431,33 327,32.0448741 327,30.8666667 L327,21.2666667 C326.447715,21.2666667 326,20.7891037 326,20.2 C326,19.6108963 326.447715,19.1333333 327,19.1333333 L330,19.1333333 L330,17 L335,17 L335,19.1333333 L338,19.1333333 C338.552285,19.1333333 339,19.6108963 339,20.2 C339,20.7891037 338.552285,21.2666667 338,21.2666667 Z M334,18.0666667 L331,18.0666667 L331,19.1333333 L334,19.1333333 L334,18.0666667 Z M329.5,22.3333333 C329.776142,22.3333333 330,22.5721148 330,22.8666667 L330,29.2666667 C330,29.5612185 329.776142,29.8 329.5,29.8 C329.223858,29.8 329,29.5612185 329,29.2666667 L329,22.8666667 C329,22.5721148 329.223858,22.3333333 329.5,22.3333333 Z M332.5,22.3333333 C332.776142,22.3333333 333,22.5721148 333,22.8666667 L333,29.2666667 C333,29.5612185 332.776142,29.8 332.5,29.8 C332.223858,29.8 332,29.5612185 332,29.2666667 L332,22.8666667 C332,22.5721148 332.223858,22.3333333 332.5,22.3333333 Z M335.5,22.3333333 C335.776142,22.3333333 336,22.5721148 336,22.8666667 L336,29.2666667 C336,29.5612185 335.776142,29.8 335.5,29.8 C335.223858,29.8 335,29.5612185 335,29.2666667 L335,22.8666667 C335,22.5721148 335.223858,22.3333333 335.5,22.3333333 Z" })
      )
    )
  );
};

exports.default = DeleteIcon;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FitToPageIcon = function FitToPageIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 14 18" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement("rect", { opacity: "0.6", x: "0", y: "16", width: "14", height: "2" }),
      _react2.default.createElement("rect", { opacity: "0.6", x: "0", y: "0", width: "14", height: "2" }),
      _react2.default.createElement("rect", { x: "0", y: "4", width: "14", height: "10" })
    )
  );
};

exports.default = FitToPageIcon;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullWidthIcon = function FullWidthIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 18" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement("rect", { opacity: "0.6", x: "3", y: "16", width: "14", height: "2" }),
      _react2.default.createElement("rect", { opacity: "0.6", x: "3", y: "0", width: "14", height: "2" }),
      _react2.default.createElement("rect", { x: "0", y: "4", width: "20", height: "10" })
    )
  );
};

exports.default = FullWidthIcon;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeadlineIcon = function HeadlineIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 10.8 13', style: { fillRule: 'evenodd' } }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      d: 'M15480.2,1200.71h-10.5v3.08h1a0.468,0.468,0,0,0,.5-0.34v-0.76h2.7v9.26c-0.2.03-.4,0.07-0.5,0.09-0.2.02-.2,0.05-0.3,0.05s-0.1.02-.1,0.02a0.561,0.561,0,0,0-.5.56v1.06h5.2v-1.06a0.561,0.561,0,0,0-.5-0.56s0-.02-0.1-0.02a1.775,1.775,0,0,0-.3-0.05c-0.1-.02-0.3-0.06-0.5-0.09v-9.24h2.7a1.275,1.275,0,0,0,.1.74,0.365,0.365,0,0,0,.4.34h1v-3.08h-0.3Z',
      transform: 'translate(-15469.7 -1200.72)'
    })
  );
};

exports.default = HeadlineIcon;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderSmallIcon = function HeaderSmallIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 10 11" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", fillRule: "evenodd", transform: "translate(-130.000000, -21.000000)" },
      _react2.default.createElement("path", { d: "M139.734195,21 L130,21 L130,23.6010602 L130.964467,23.6010602 C131.15506,23.6102984 131.321923,23.4849956 131.349331,23.3120535 C131.365944,23.2207882 131.397323,23.0078359 131.431472,22.6731966 L133.87725,22.6731966 L133.87725,30.4941231 C133.67605,30.5245448 133.508076,30.5549666 133.395478,30.5701775 C133.28288,30.5853883 133.193355,30.6158101 133.144439,30.6158101 C133.11082,30.6184117 133.077486,30.6234986 133.044762,30.631021 C132.790214,30.6601292 132.606584,30.8686144 132.629442,31.1025582 L132.629442,32 L137.388094,32 L137.388094,31.1025582 C137.402553,30.8653482 137.212936,30.6587862 136.955238,30.631021 C136.922251,30.6232844 136.88859,30.6181948 136.854638,30.6158101 C136.804799,30.6158101 136.723581,30.5853883 136.605445,30.5701775 C136.48731,30.5549666 136.322104,30.5245448 136.123673,30.4941231 L136.123673,22.6884075 L138.568528,22.6884075 C138.602677,23.026427 138.635902,23.2207882 138.652515,23.3120535 C138.685557,23.4873453 138.857301,23.6118353 139.051223,23.6010602 L140,23.6010602 L140,21 L139.734195,21 L139.734195,21 Z" })
    )
  );
};

exports.default = HeaderSmallIcon;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItalicIcon = function ItalicIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 10 14" }, props),
    _react2.default.createElement("path", {
      stroke: "none",
      fillRule: "evenodd",
      d: "M122.1,66l-0.641,2.482h1.437l-2.836,8.966h-1.423L118,80h6.054l0.634-2.552h-1.527l2.826-8.966h1.372L128,66H122.1Z",
      transform: "translate(-118 -66)"
    })
  );
};

exports.default = ItalicIcon;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkIcon = function LinkIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 16" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-332.000000, -17.000000)" },
        _react2.default.createElement("path", { d: "M346.7545,24.2519842 L343.760346,27.2542802 C342.837124,28.1960846 341.526332,28.650695 340.218722,28.4825904 C338.911112,28.3144857 337.757709,27.5430815 337.102346,26.3983362 L338.499618,25.0000613 C338.568906,24.9405135 338.645348,24.8898508 338.727174,24.8492474 C338.823407,25.1884755 339.004027,25.497744 339.252149,25.7481384 C340.082196,26.5762028 341.425238,26.5762028 342.255285,25.7481384 L345.259419,22.7458424 C345.799447,22.2096444 346.01148,21.4252629 345.81522,20.6897467 C345.61896,19.9542306 345.044414,19.380036 344.309165,19.1846132 C343.573916,18.9891903 342.79038,19.2024182 342.255285,19.7435464 L341.18737,20.812228 C340.325272,20.480631 339.391818,20.3790958 338.478659,20.5175915 L340.758208,18.2413996 C341.831125,17.1694962 343.393985,16.7518221 344.858073,17.1457111 C346.322162,17.5396001 347.465049,18.685211 347.85622,20.1510034 C348.247391,21.6167958 347.827418,23.1800808 346.7545,24.2519842 Z M338.818994,29.1888935 L337.750081,30.257575 C336.917297,31.0638227 335.592438,31.0532935 334.772554,30.2339112 C333.95267,29.4145289 333.940387,28.0887339 334.744949,27.2542802 L337.750081,24.2519842 C338.58138,23.4241216 339.924913,23.4241216 340.756212,24.2519842 C340.997913,24.5062477 341.175793,24.8143373 341.275199,25.1508753 C341.357905,25.1111476 341.435075,25.0607836 341.50475,25.0010601 L342.902022,23.6027852 C342.722316,23.2911949 342.504381,23.0033142 342.253289,22.7458424 C340.593079,21.0890496 337.906228,21.0890496 336.246018,22.7458424 L333.241884,25.7481384 C331.584675,27.4084671 331.58624,30.0988266 333.245377,31.7572246 C334.904515,33.4156226 337.592944,33.4140576 339.250152,31.7537292 L341.524711,29.4775373 C340.613052,29.6176868 339.680643,29.5182181 338.818994,29.1888935 Z" })
      )
    )
  );
};

exports.default = LinkIcon;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderedListIcon = function OrderedListIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 16 16', style: { fillRule: 'evenodd' } }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      d: 'M264,74H254a1,1,0,0,1,0-2h10A1,1,0,1,1,264,74Zm0-6H254a1,1,0,0,1,0-2h10A1,1,0,1,1,264,68ZM249,80h2V79h1v2h-3V80Zm1-2h-1V77h3v1h-1v1h-1V78Zm-1-4h1V73h1v1h1v1h-3V74Zm0-2V71h3v2h-1V72h-2Zm1-6h-1V65h2v4h-1V66Zm4,12h10a1,1,0,0,1,0,2H254A1,1,0,0,1,254,78Z',
      transform: 'translate(-249 -65)'
    })
  );
};

exports.default = OrderedListIcon;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OriginalSizeIcon = function OriginalSizeIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 18" }, props),
    _react2.default.createElement("path", { d: "M0,0V18H20V0ZM7.42,12.5H6V8H4.24V6.89A2.84,2.84,0,0,0,5,6.83a1.85,1.85,0,0,0,.62-.23A1.26,1.26,0,0,0,6,6.17a1.49,1.49,0,0,0,.25-.67H7.42Zm3.82,0H9.67V11h1.57Zm0-3.54H9.67V7.42h1.57Zm4.52,3.54H14.34V8H12.58V6.89a2.73,2.73,0,0,0,.71-.06,1.9,1.9,0,0,0,.63-.23,1.26,1.26,0,0,0,.46-.43,1.49,1.49,0,0,0,.25-.67h1.13Z" })
  );
};

exports.default = OriginalSizeIcon;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuoteIcon = function QuoteIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 15.031 13.031', style: { fillRule: 'evenodd' } }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      d: 'M299.858,70.44a14.6,14.6,0,0,1-.492,3.785,6.812,6.812,0,0,1-1.888,2.951,9.271,9.271,0,0,1-2.737,1.769,0.825,0.825,0,0,1-1.072-.4l-0.59-1.234a0.813,0.813,0,0,1,.408-1.092,4.945,4.945,0,0,0,2.056-1.528,4.56,4.56,0,0,0,.733-1.715A3.544,3.544,0,1,1,299.858,70.44Zm-8.492,3.785a6.826,6.826,0,0,1-1.886,2.951,9.339,9.339,0,0,1-2.74,1.769,0.824,0.824,0,0,1-1.07-.4l-0.592-1.234a0.812,0.812,0,0,1,.409-1.092,4.925,4.925,0,0,0,2.054-1.528,4.452,4.452,0,0,0,.734-1.715,3.544,3.544,0,1,1,3.581-2.537A14.566,14.566,0,0,1,291.366,74.225Z',
      transform: 'translate(-284.969 -66)'
    })
  );
};

exports.default = QuoteIcon;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CodeIcon = function CodeIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 17 17" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", fillRule: "evenodd" },
      _react2.default.createElement("path", { d: "M5.9996,16.0039 L4.15696535,16.0039 C3.84158572,16.0039 3.54567398,15.9559 3.2711769,15.8589 C2.99667982,15.7639 2.75625152,15.6079 2.55183881,15.3909 C2.34742609,15.1749 2.18681609,14.9009 2.07000883,14.5709 C1.95320156,14.2399 1.89479792,13.8409 1.89479792,13.3729 L1.89479792,10.2729 C1.89479792,9.9959 1.81595302,9.7749 1.65826321,9.6059 C1.4996,9.4379 1.31562855,9.3119 1.10537547,9.2279 C0.894148994,9.1439 0.683895912,9.0899 0.473642829,9.0659 C0.262416353,9.0409 0.104726541,9.0289 -0.000400000001,9.0289 L-0.000400000001,6.9749 C0.104726541,6.9749 0.262416353,6.9629 0.473642829,6.9389 C0.683895912,6.9149 0.894148994,6.8599 1.10537547,6.7759 C1.31562855,6.6919 1.4996,6.5659 1.65826321,6.3989 C1.81595302,6.2299 1.89479792,6.0079 1.89479792,5.7319 L1.89479792,2.6129 C1.89479792,2.1449 1.94930798,1.7449 2.06124828,1.4149 C2.17221518,1.0839 2.329905,0.8149 2.53431772,0.6039 C2.73873043,0.3939 2.97915873,0.2399 3.2546292,0.1449 C3.52815289,0.0479 3.829905,-0.0001 4.15696535,-0.0001 L5.9996,-0.0001 L5.9996,2.0549 L5.14009319,2.0549 C4.87046308,2.0549 4.66020999,2.0909 4.50836055,2.1629 C4.3565111,2.2339 4.24262401,2.3279 4.16669929,2.4419 C4.08980117,2.5569 4.04307826,2.6829 4.02653056,2.8199 C4.00900947,2.9589 3.99927554,3.0879 3.99927554,3.2079 L3.99927554,6.1089 C3.99927554,6.5299 3.9408719,6.8599 3.82406463,7.1009 C3.70725737,7.3419 3.56416846,7.5249 3.39479792,7.6499 C3.22445399,7.7759 3.03756236,7.8609 2.83314964,7.9019 C2.62873692,7.9449 2.43211136,7.9719 2.24521973,7.9839 L2.24521973,8.0199 C2.43211136,8.0319 2.62873692,8.0559 2.83314964,8.0919 C3.03756236,8.1279 3.22445399,8.2089 3.39479792,8.3349 C3.56416846,8.4619 3.70725737,8.6449 3.82406463,8.8849 C3.9408719,9.1259 3.99927554,9.4559 3.99927554,9.8759 L3.99927554,12.7959 C3.99927554,12.9159 4.00900947,13.0449 4.02653056,13.1839 C4.04307826,13.3209 4.08980117,13.4469 4.16669929,13.5619 C4.24262401,13.6759 4.3565111,13.7699 4.50836055,13.8409 C4.66020999,13.9129 4.87046308,13.9489 5.14009319,13.9489 L5.9996,13.9489 L5.9996,16.0039 Z" }),
      _react2.default.createElement("path", {
        d: "M17,16.004 L15.1573653,16.004 C14.8419857,16.004 14.546074,15.956 14.2715769,15.859 C13.9970798,15.764 13.7566515,15.608 13.5522388,15.391 C13.3478261,15.175 13.1872161,14.901 13.0704088,14.571 C12.9536016,14.24 12.8951979,13.841 12.8951979,13.373 L12.8951979,10.273 C12.8951979,9.996 12.816353,9.775 12.6586632,9.606 C12.5,9.438 12.3160286,9.312 12.1057755,9.228 C11.894549,9.144 11.6842959,9.09 11.4740428,9.066 C11.2628164,9.041 11.1051265,9.029 11,9.029 L11,6.975 C11.1051265,6.975 11.2628164,6.963 11.4740428,6.939 C11.6842959,6.915 11.894549,6.86 12.1057755,6.776 C12.3160286,6.692 12.5,6.566 12.6586632,6.399 C12.816353,6.23 12.8951979,6.008 12.8951979,5.732 L12.8951979,2.613 C12.8951979,2.145 12.949708,1.745 13.0616483,1.415 C13.1726152,1.084 13.330305,0.815 13.5347177,0.604 C13.7391304,0.394 13.9795587,0.24 14.2550292,0.145 C14.5285529,0.048 14.830305,0 15.1573653,0 L17,0 L17,2.055 L16.1404932,2.055 C15.8708631,2.055 15.66061,2.091 15.5087605,2.163 C15.3569111,2.234 15.243024,2.328 15.1670993,2.442 C15.0902012,2.557 15.0434783,2.683 15.0269306,2.82 C15.0094095,2.959 14.9996755,3.088 14.9996755,3.208 L14.9996755,6.109 C14.9996755,6.53 14.9412719,6.86 14.8244646,7.101 C14.7076574,7.342 14.5645685,7.525 14.3951979,7.65 C14.224854,7.776 14.0379624,7.861 13.8335496,7.902 C13.6291369,7.945 13.4325114,7.972 13.2456197,7.984 C13.4325114,8.032 13.6291369,8.056 13.8335496,8.092 C14.0379624,8.128 14.224854,8.209 14.3951979,8.335 C14.5645685,8.462 14.7076574,8.645 14.8244646,8.885 C14.9412719,9.126 14.9996755,9.456 14.9996755,9.876 L14.9996755,12.796 C14.9996755,12.916 15.0094095,13.045 15.0269306,13.184 C15.0434783,13.321 15.0902012,13.447 15.1670993,13.562 C15.243024,13.676 15.3569111,13.77 15.5087605,13.841 C15.66061,13.913 15.8708631,13.949 16.1404932,13.949 L17,13.949 L17,16.004 Z",
        id: "Fill-1",
        transform: "translate(14.000000, 8.002000) rotate(-180.000000) translate(-14.000000, -8.002000)"
      })
    )
  );
};

exports.default = CodeIcon;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReplaceIcon = function ReplaceIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 16" }, props),
    _react2.default.createElement(
      "g",
      { strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-287.000000, -17.000000)", fillRule: "nonzero" },
        _react2.default.createElement("path", { d: "M297.001716,27.8755353 L300.2505,27.9165001 C299.047537,29.7652943 296.989183,30.8808798 294.780812,30.8809592 C291.601676,30.757293 289.073179,28.1756705 289.020875,25 L288.020017,25 C287.969133,26.8169762 288.660573,28.5764937 289.935462,29.8742619 C291.210352,31.1720301 292.959071,31.8964618 294.779811,31.8811019 C297.240026,31.8303657 299.537439,30.6430278 300.999142,28.666857 L300.999142,32 L302,32 L302,27.004282 L297.001716,27.004282 L297.001716,27.8755353 L297.001716,27.8755353 Z M292.998284,22.1254639 L289.757506,22.0834999 C290.962274,20.2346294 293.02178,19.1192355 295.231198,19.1190408 C298.410808,19.2431088 300.940233,21.8238856 300.995139,25 L301.995997,25 C302.044674,23.1823602 301.351379,21.4230028 300.075202,20.1256502 C298.799026,18.8282975 297.049538,18.1043371 295.228196,18.1198972 C292.76607,18.1718065 290.466702,19.358627 289.000858,21.3341422 L289.000858,18 L288,18 L288,22.995718 L292.998284,22.995718 L292.998284,22.1204682 L292.998284,22.1254639 Z" })
      )
    )
  );
};

exports.default = ReplaceIcon;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmallCenterIcon = function SmallCenterIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 14 18" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement("rect", { opacity: "0.6", x: "0", y: "16", width: "14", height: "2" }),
      _react2.default.createElement("rect", { opacity: "0.6", x: "0", y: "0", width: "14", height: "2" }),
      _react2.default.createElement("rect", { x: "2", y: "4", width: "10", height: "10" })
    )
  );
};

exports.default = SmallCenterIcon;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnorderedListIcon = function UnorderedListIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({ viewBox: '0 0 16 14', style: { fillRule: 'evenodd' } }, props),
    _react2.default.createElement('path', {
      stroke: 'none',
      d: 'M253,90h12v2H253V90Zm-4,0h2v2h-2V90Zm4,4h12v2H253V94Zm-4,0h2v2h-2V94Zm4,4h12v2H253V98Zm-4,0h2v2h-2V98Zm4,4h12v2H253v-2Zm-4,0h2v2h-2v-2Z',
      transform: 'translate(-249 -90)'
    })
  );
};

exports.default = UnorderedListIcon;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoIcon = function VideoIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 14" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", fillRule: "nonzero" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-342.000000, -1064.000000)" },
        _react2.default.createElement(
          "g",
          { transform: "translate(213.000000, 163.000000)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(80.000000, 900.000000)" },
            _react2.default.createElement("path", { d: "M69,3.55142232 L69,12.4398249 C69,13.1269147 68.2705001,13.5557987 67.6869002,13.214442 L64.0565655,11.0787746 L64.0565655,11.6870897 C64.0565655,13.5164114 62.6018569,15 60.8081454,15 L52.2484201,15 C50.4547086,15 49,13.5164114 49,11.6870897 L49,4.31291028 C49,2.48358862 50.4547086,1 52.2484201,1 L60.8124366,1 C62.6061481,1 64.0608567,2.48358862 64.0608567,4.31291028 L64.0608567,4.92122538 L67.6911914,2.78555799 C68.2705001,2.43544858 69,2.86870897 69,3.55142232 Z" })
          )
        )
      )
    )
  );
};

exports.default = VideoIcon;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createAlignmentButton;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _textEditorButton = __webpack_require__(42);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createAlignmentButton(_ref) {
  var _class, _temp2;

  var alignment = _ref.alignment,
      Content = _ref.content,
      tooltipText = _ref.tooltipText;

  return _temp2 = _class = function (_Component) {
    _inherits(AlignmentButton, _Component);

    function AlignmentButton() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, AlignmentButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AlignmentButton.__proto__ || Object.getPrototypeOf(AlignmentButton)).call.apply(_ref2, [this].concat(args))), _this), _this.isActive = function () {
        return _this.props.alignment === alignment;
      }, _this.handleClick = function () {
        return _this.props.setAlignment(alignment);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AlignmentButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            setAlignment = _props.setAlignment,
            alignment = _props.alignment,
            className = _props.className,
            buttonProps = _objectWithoutProperties(_props, ['setAlignment', 'alignment', 'className']);

        return _react2.default.createElement(_textEditorButton2.default, _extends({
          className: (0, _classnames2.default)(className, 'text-editor__align-' + alignment + '-button'),
          onClick: this.handleClick,
          isActive: this.isActive(),
          icon: Content,
          tooltipText: tooltipText
        }, buttonProps));
      }
    }]);

    return AlignmentButton;
  }(_react.Component), _class.propTypes = {
    setAlignment: _propTypes2.default.func.isRequired,
    alignment: _propTypes2.default.string,
    className: _propTypes2.default.string
  }, _temp2;
}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = height;

var _offset = __webpack_require__(114);

var _offset2 = _interopRequireDefault(_offset);

var _isWindow = __webpack_require__(115);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function height(node, client) {
  var win = (0, _isWindow2.default)(node);
  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset2.default)(node).height;
}
module.exports = exports['default'];

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(679);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(333);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(52);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerWindow;

var _ownerDocument = __webpack_require__(65);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownerWindow(node) {
  var doc = (0, _ownerDocument2.default)(node);
  return doc && doc.defaultView || doc.parentWindow;
}
module.exports = exports['default'];

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _offset = __webpack_require__(114);

var _offset2 = _interopRequireDefault(_offset);

var _requestAnimationFrame = __webpack_require__(227);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _componentOrElement = __webpack_require__(113);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _Affix = __webpack_require__(331);

var _Affix2 = _interopRequireDefault(_Affix);

var _addEventListener = __webpack_require__(142);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _getContainer = __webpack_require__(143);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _getDocumentHeight = __webpack_require__(335);

var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);

var _ownerDocument = __webpack_require__(54);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(336);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<AutoAffix/>` component wraps `<Affix/>` to automatically calculate
 * offsets in many common cases.
 */
var AutoAffix = function (_React$Component) {
  _inherits(AutoAffix, _React$Component);

  function AutoAffix(props, context) {
    _classCallCheck(this, AutoAffix);

    var _this = _possibleConstructorReturn(this, (AutoAffix.__proto__ || Object.getPrototypeOf(AutoAffix)).call(this, props, context));

    _this.state = {
      offsetTop: null,
      offsetBottom: null,
      width: null
    };
    return _this;
  }

  _createClass(AutoAffix, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;

      this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
        return _this2.onWindowScroll();
      });

      this._windowResizeListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'resize', function () {
        return _this2.onWindowResize();
      });

      this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
        return _this2.onDocumentClick();
      });

      this.onUpdate();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this._needPositionUpdate = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this._needPositionUpdate) {
        this._needPositionUpdate = false;
        this.onUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      if (this._windowScrollListener) {
        this._windowScrollListener.remove();
      }
      if (this._documentClickListener) {
        this._documentClickListener.remove();
      }
      if (this._windowResizeListener) {
        this._windowResizeListener.remove();
      }
    }
  }, {
    key: 'onWindowScroll',
    value: function onWindowScroll() {
      this.onUpdate();
    }
  }, {
    key: 'onWindowResize',
    value: function onWindowResize() {
      var _this3 = this;

      if (this.props.autoWidth) {
        (0, _requestAnimationFrame2.default)(function () {
          return _this3.onUpdate();
        });
      }
    }
  }, {
    key: 'onDocumentClick',
    value: function onDocumentClick() {
      var _this4 = this;

      (0, _requestAnimationFrame2.default)(function () {
        return _this4.onUpdate();
      });
    }
  }, {
    key: 'onUpdate',
    value: function onUpdate() {
      if (!this._isMounted) {
        return;
      }

      var _getOffset = (0, _offset2.default)(this.refs.positioner),
          offsetTop = _getOffset.top,
          width = _getOffset.width;

      var container = (0, _getContainer2.default)(this.props.container);
      var offsetBottom = void 0;
      if (container) {
        var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(this));

        var _getOffset2 = (0, _offset2.default)(container),
            top = _getOffset2.top,
            height = _getOffset2.height;

        offsetBottom = documentHeight - top - height;
      } else {
        offsetBottom = null;
      }

      this.updateState(offsetTop, offsetBottom, width);
    }
  }, {
    key: 'updateState',
    value: function updateState(offsetTop, offsetBottom, width) {
      if (offsetTop === this.state.offsetTop && offsetBottom === this.state.offsetBottom && width === this.state.width) {
        return;
      }

      this.setState({ offsetTop: offsetTop, offsetBottom: offsetBottom, width: width });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoWidth = _props.autoWidth,
          viewportOffsetTop = _props.viewportOffsetTop,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['autoWidth', 'viewportOffsetTop', 'children']);

      var _state = this.state,
          offsetTop = _state.offsetTop,
          offsetBottom = _state.offsetBottom,
          width = _state.width;


      delete props.container;

      var effectiveOffsetTop = Math.max(offsetTop, viewportOffsetTop || 0);

      var _props2 = this.props,
          affixStyle = _props2.affixStyle,
          bottomStyle = _props2.bottomStyle;

      if (autoWidth) {
        affixStyle = _extends({ width: width }, affixStyle);
        bottomStyle = _extends({ width: width }, bottomStyle);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { ref: 'positioner' }),
        _react2.default.createElement(
          _Affix2.default,
          _extends({}, props, {
            offsetTop: effectiveOffsetTop,
            viewportOffsetTop: viewportOffsetTop,
            offsetBottom: offsetBottom,
            affixStyle: affixStyle,
            bottomStyle: bottomStyle
          }),
          children
        )
      );
    }
  }]);

  return AutoAffix;
}(_react2.default.Component);

AutoAffix.propTypes = _extends({}, _Affix2.default.propTypes, {
  /**
   * The logical container node or component for determining offset from bottom
   * of viewport, or a function that returns it
   */
  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
  /**
   * Automatically set width when affixed
   */
  autoWidth: _react2.default.PropTypes.bool
});

// This intentionally doesn't inherit default props from `<Affix>`, so that the
// auto-calculated offsets can apply.
AutoAffix.defaultProps = {
  viewportOffsetTop: 0,
  autoWidth: true
};

exports.default = AutoAffix;
module.exports = exports['default'];

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(687);

var _warning2 = _interopRequireDefault(_warning);

var _componentOrElement = __webpack_require__(113);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _elementType = __webpack_require__(226);

var _elementType2 = _interopRequireDefault(_elementType);

var _Portal = __webpack_require__(235);

var _Portal2 = _interopRequireDefault(_Portal);

var _ModalManager = __webpack_require__(688);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _ownerDocument = __webpack_require__(54);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _addEventListener = __webpack_require__(142);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(693);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _inDOM = __webpack_require__(52);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _activeElement = __webpack_require__(694);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(232);

var _contains2 = _interopRequireDefault(_contains);

var _getContainer = __webpack_require__(143);

var _getContainer2 = _interopRequireDefault(_getContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */
var Modal = _react2.default.createClass({
  displayName: 'Modal',


  propTypes: _extends({}, _Portal2.default.propTypes, {

    /**
     * Set the visibility of the Modal
     */
    show: _react2.default.PropTypes.bool,

    /**
     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
     *
     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
     * page content can be placed behind a virtual backdrop as well as a visual one.
     */
    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),

    /**
     * A callback fired when the Modal is opening.
     */
    onShow: _react2.default.PropTypes.func,

    /**
     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
     *
     * The `onHide` callback only signals intent from the Modal,
     * you must actually set the `show` prop to `false` for the Modal to close.
     */
    onHide: _react2.default.PropTypes.func,

    /**
     * Include a backdrop component.
     */
    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),

    /**
     * A function that returns a backdrop component. Useful for custom
     * backdrop rendering.
     *
     * ```js
     *  renderBackdrop={props => <MyBackdrop {...props} />}
     * ```
     */
    renderBackdrop: _react2.default.PropTypes.func,

    /**
     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
     */
    onEscapeKeyUp: _react2.default.PropTypes.func,

    /**
     * A callback fired when the backdrop, if specified, is clicked.
     */
    onBackdropClick: _react2.default.PropTypes.func,

    /**
     * A style object for the backdrop component.
     */
    backdropStyle: _react2.default.PropTypes.object,

    /**
     * A css class or classes for the backdrop component.
     */
    backdropClassName: _react2.default.PropTypes.string,

    /**
     * A css class or set of classes applied to the modal container when the modal is open,
     * and removed when it is closed.
     */
    containerClassName: _react2.default.PropTypes.string,

    /**
     * Close the modal when escape key is pressed
     */
    keyboard: _react2.default.PropTypes.bool,

    /**
     * A `<Transition/>` component to use for the dialog and backdrop components.
     */
    transition: _elementType2.default,

    /**
     * The `timeout` of the dialog transition if specified. This number is used to ensure that
     * transition callbacks are always fired, even if browser transition events are canceled.
     *
     * See the Transition `timeout` prop for more infomation.
     */
    dialogTransitionTimeout: _react2.default.PropTypes.number,

    /**
     * The `timeout` of the backdrop transition if specified. This number is used to
     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
     *
     * See the Transition `timeout` prop for more infomation.
     */
    backdropTransitionTimeout: _react2.default.PropTypes.number,

    /**
     * When `true` The modal will automatically shift focus to itself when it opens, and
     * replace it to the last focused element when it closes. This also
     * works correctly with any Modal children that have the `autoFocus` prop.
     *
     * Generally this should never be set to `false` as it makes the Modal less
     * accessible to assistive technologies, like screen readers.
     */
    autoFocus: _react2.default.PropTypes.bool,

    /**
     * When `true` The modal will prevent focus from leaving the Modal while open.
     *
     * Generally this should never be set to `false` as it makes the Modal less
     * accessible to assistive technologies, like screen readers.
     */
    enforceFocus: _react2.default.PropTypes.bool,

    /**
     * When `true` The modal will restore focus to previously focused element once
     * modal is hidden
     */
    restoreFocus: _react2.default.PropTypes.bool,

    /**
     * Callback fired before the Modal transitions in
     */
    onEnter: _react2.default.PropTypes.func,

    /**
     * Callback fired as the Modal begins to transition in
     */
    onEntering: _react2.default.PropTypes.func,

    /**
     * Callback fired after the Modal finishes transitioning in
     */
    onEntered: _react2.default.PropTypes.func,

    /**
     * Callback fired right before the Modal transitions out
     */
    onExit: _react2.default.PropTypes.func,

    /**
     * Callback fired as the Modal begins to transition out
     */
    onExiting: _react2.default.PropTypes.func,

    /**
     * Callback fired after the Modal finishes transitioning out
     */
    onExited: _react2.default.PropTypes.func,

    /**
     * A ModalManager instance used to track and manage the state of open
     * Modals. Useful when customizing how modals interact within a container
     */
    manager: _react2.default.PropTypes.object.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    var noop = function noop() {};

    return {
      show: false,
      backdrop: true,
      keyboard: true,
      autoFocus: true,
      enforceFocus: true,
      restoreFocus: true,
      onHide: noop,
      manager: modalManager,
      renderBackdrop: function renderBackdrop(props) {
        return _react2.default.createElement('div', props);
      }
    };
  },
  omitProps: function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  },
  getInitialState: function getInitialState() {
    return { exited: !this.props.show };
  },
  render: function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        dialogTransitionTimeout = _props.dialogTransitionTimeout,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          transitionAppear: true,
          unmountOnExit: true,
          'in': show,
          timeout: dialogTransitionTimeout,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: 'modal',
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        dialog
      )
    );
  },
  renderBackdrop: function renderBackdrop() {
    var _this = this;

    var _props2 = this.props,
        backdropStyle = _props2.backdropStyle,
        backdropClassName = _props2.backdropClassName,
        renderBackdrop = _props2.renderBackdrop,
        Transition = _props2.transition,
        backdropTransitionTimeout = _props2.backdropTransitionTimeout;


    var backdropRef = function backdropRef(ref) {
      return _this.backdrop = ref;
    };

    var backdrop = _react2.default.createElement('div', {
      ref: backdropRef,
      style: this.props.backdropStyle,
      className: this.props.backdropClassName,
      onClick: this.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        { transitionAppear: true,
          'in': this.props.show,
          timeout: backdropTransitionTimeout
        },
        renderBackdrop({
          ref: backdropRef,
          style: backdropStyle,
          className: backdropClassName,
          onClick: this.handleBackdropClick
        })
      );
    }

    return backdrop;
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  },
  componentWillUpdate: function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  },
  componentDidMount: function componentDidMount() {
    if (this.props.show) {
      this.onShow();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var _props3 = this.props,
        show = _props3.show,
        transition = _props3.transition;


    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  },
  onShow: function onShow() {
    var doc = (0, _ownerDocument2.default)(this);
    var container = (0, _getContainer2.default)(this.props.container, doc.body);

    this.props.manager.add(this, container, this.props.containerClassName);

    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);

    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);

    this.focus();

    if (this.props.onShow) {
      this.props.onShow();
    }
  },
  onHide: function onHide() {
    this.props.manager.remove(this);

    this._onDocumentKeyupListener.remove();

    this._onFocusinListener.remove();

    if (this.props.restoreFocus) {
      this.restoreLastFocus();
    }
  },
  setMountNode: function setMountNode(ref) {
    this.mountNode = ref ? ref.getMountNode() : ref;
  },
  handleHidden: function handleHidden() {
    this.setState({ exited: true });
    this.onHide();

    if (this.props.onExited) {
      var _props4;

      (_props4 = this.props).onExited.apply(_props4, arguments);
    }
  },
  handleBackdropClick: function handleBackdropClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (this.props.onBackdropClick) {
      this.props.onBackdropClick(e);
    }

    if (this.props.backdrop === true) {
      this.props.onHide();
    }
  },
  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
      if (this.props.onEscapeKeyUp) {
        this.props.onEscapeKeyUp(e);
      }
      this.props.onHide();
    }
  },
  checkForFocus: function checkForFocus() {
    if (_inDOM2.default) {
      this.lastFocus = (0, _activeElement2.default)();
    }
  },
  focus: function focus() {
    var autoFocus = this.props.autoFocus;
    var modalContent = this.getDialogElement();
    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
    var focusInModal = current && (0, _contains2.default)(modalContent, current);

    if (modalContent && autoFocus && !focusInModal) {
      this.lastFocus = current;

      if (!modalContent.hasAttribute('tabIndex')) {
        modalContent.setAttribute('tabIndex', -1);
        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
      }

      modalContent.focus();
    }
  },
  restoreLastFocus: function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  },
  enforceFocus: function enforceFocus() {
    var enforceFocus = this.props.enforceFocus;


    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
      return;
    }

    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
    var modal = this.getDialogElement();

    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
      modal.focus();
    }
  },


  //instead of a ref, which might conflict with one the parent applied.
  getDialogElement: function getDialogElement() {
    var node = this.refs.modal;
    return node && node.lastChild;
  },
  isTopModal: function isTopModal() {
    return this.props.manager.isTopModal(this);
  }
});

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(233);

var _style2 = _interopRequireDefault(_style);

var _class = __webpack_require__(689);

var _class2 = _interopRequireDefault(_class);

var _scrollbarSize = __webpack_require__(690);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(691);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(692);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function () {
  function ModalManager() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
        _ref2$handleContainer = _ref2.handleContainerOverflow,
        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

    _classCallCheck(this, ModalManager);

    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow;
    this.modals = [];
    this.containers = [];
    this.data = [];
  }

  _createClass(ModalManager, [{
    key: 'add',
    value: function add(modal, container, className) {
      var modalIdx = this.modals.indexOf(modal);
      var containerIdx = this.containers.indexOf(container);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal);

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
      }

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        //right now only the first modal of a container will have its classes applied
        classes: className ? className.split(/\s+/) : [],

        overflowing: (0, _isOverflowing2.default)(container)
      };

      if (this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      data.classes.forEach(_class2.default.addClass.bind(null, container));

      this.containers.push(container);
      this.data.push(data);

      return modalIdx;
    }
  }, {
    key: 'remove',
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return;
      }

      var containerIdx = findContainer(this.data, modal);
      var data = this.data[containerIdx];
      var container = this.containers[containerIdx];

      data.modals.splice(data.modals.indexOf(modal), 1);

      this.modals.splice(modalIdx, 1);

      // if that was the last modal in a container,
      // clean up the container
      if (data.modals.length === 0) {
        data.classes.forEach(_class2.default.removeClass.bind(null, container));

        if (this.handleContainerOverflow) {
          removeContainerStyle(data, container);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
        }
        this.containers.splice(containerIdx, 1);
        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        //otherwise make sure the next top modal is visible to a SR
        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
      }
    }
  }, {
    key: 'isTopModal',
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = exports.removeClass = exports.addClass = undefined;

var _addClass = __webpack_require__(319);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(321);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _hasClass = __webpack_require__(320);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addClass = _addClass2.default;
exports.removeClass = _removeClass2.default;
exports.hasClass = _hasClass2.default;
exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(52);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isOverflowing;

var _isWindow = __webpack_require__(115);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(65);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(65);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(235);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(337);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(338);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

var _elementType = __webpack_require__(226);

var _elementType2 = _interopRequireDefault(_elementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  _createClass(Overlay, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.setState({ exited: false });
      } else if (!nextProps.transition) {
        // Otherwise let handleHidden take care of marking exited.
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          container = _props.container,
          containerPadding = _props.containerPadding,
          target = _props.target,
          placement = _props.placement,
          shouldUpdatePosition = _props.shouldUpdatePosition,
          rootClose = _props.rootClose,
          children = _props.children,
          Transition = _props.transition,
          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

      // Don't un-render the overlay while it's transitioning out.


      var mountOverlay = props.show || Transition && !this.state.exited;
      if (!mountOverlay) {
        // Don't bother showing anything if we don't have to.
        return null;
      }

      var child = children;

      // Position is be inner-most because it adds inline styles into the child,
      // which the other wrappers don't forward correctly.
      child = _react2.default.createElement(
        _Position2.default,
        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
        child
      );

      if (Transition) {
        var onExit = props.onExit,
            onExiting = props.onExiting,
            onEnter = props.onEnter,
            onEntering = props.onEntering,
            onEntered = props.onEntered;

        // This animates the child node by injecting props, so it must precede
        // anything that adds a wrapping div.

        child = _react2.default.createElement(
          Transition,
          {
            'in': props.show,
            transitionAppear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: this.onHiddenListener,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
          },
          child
        );
      }

      // This goes after everything else because it adds a wrapping div.
      if (rootClose) {
        child = _react2.default.createElement(
          _RootCloseWrapper2.default,
          { onRootClose: props.onHide },
          child
        );
      }

      return _react2.default.createElement(
        _Portal2.default,
        { container: container },
        child
      );
    }
  }, {
    key: 'handleHidden',
    value: function handleHidden() {
      this.setState({ exited: true });

      if (this.props.onExited) {
        var _props2;

        (_props2 = this.props).onExited.apply(_props2, arguments);
      }
    }
  }]);

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _react2.default.PropTypes.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _react2.default.PropTypes.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _react2.default.PropTypes.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `<Transition/>` component used to animate the overlay changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _react2.default.PropTypes.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _react2.default.PropTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _react2.default.PropTypes.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _react2.default.PropTypes.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _react2.default.PropTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _react2.default.PropTypes.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculatePosition;

var _offset = __webpack_require__(114);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(697);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(234);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(54);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = position;

var _offset = __webpack_require__(114);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(332);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(234);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(698);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(233);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(115);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _on = __webpack_require__(334);

var _on2 = _interopRequireDefault(_on);

var _properties = __webpack_require__(228);

var _properties2 = _interopRequireDefault(_properties);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var transitionEndEvent = _properties2.default.end;

var UNMOUNTED = exports.UNMOUNTED = 0;
var EXITED = exports.EXITED = 1;
var ENTERING = exports.ENTERING = 2;
var ENTERED = exports.ENTERED = 3;
var EXITING = exports.EXITING = 4;

/**
 * The Transition component lets you define and run css transitions with a simple declarative api.
 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
 * but is specifically optimized for transitioning a single child "in" or "out".
 *
 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
 * The extensive set of lifecycle callbacks means you have control over
 * the transitioning now at each step of the way.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (props.transitionAppear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  _createClass(Transition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateStatus();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var status = this.state.status;


      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateStatus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cancelNextCallback();
    }
  }, {
    key: 'updateStatus',
    value: function updateStatus() {
      var _this2 = this;

      if (this.nextStatus !== null) {
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (this.nextStatus === ENTERING) {
          this.props.onEnter(node);

          this.safeSetState({ status: ENTERING }, function () {
            _this2.props.onEntering(node);

            _this2.onTransitionEnd(node, function () {
              _this2.safeSetState({ status: ENTERED }, function () {
                _this2.props.onEntered(node);
              });
            });
          });
        } else {
          this.props.onExit(node);

          this.safeSetState({ status: EXITING }, function () {
            _this2.props.onExiting(node);

            _this2.onTransitionEnd(node, function () {
              _this2.safeSetState({ status: EXITED }, function () {
                _this2.props.onExited(node);
              });
            });
          });
        }

        this.nextStatus = null;
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    }
  }, {
    key: 'cancelNextCallback',
    value: function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    }
  }, {
    key: 'safeSetState',
    value: function safeSetState(nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      this.setState(nextState, this.setNextCallback(callback));
    }
  }, {
    key: 'setNextCallback',
    value: function setNextCallback(callback) {
      var _this3 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this3.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    }
  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd(node, handler) {
      this.setNextCallback(handler);

      if (node) {
        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
        setTimeout(this.nextCallback, this.props.timeout);
      } else {
        setTimeout(this.nextCallback, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          childProps = _objectWithoutProperties(_props, ['children', 'className']);

      Object.keys(Transition.propTypes).forEach(function (key) {
        return delete childProps[key];
      });

      var transitionClassName = void 0;
      if (status === EXITED) {
        transitionClassName = this.props.exitedClassName;
      } else if (status === ENTERING) {
        transitionClassName = this.props.enteringClassName;
      } else if (status === ENTERED) {
        transitionClassName = this.props.enteredClassName;
      } else if (status === EXITING) {
        transitionClassName = this.props.exitingClassName;
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, _extends({}, childProps, {
        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
      }));
    }
  }]);

  return Transition;
}(_react2.default.Component);

Transition.propTypes = {
  /**
   * Show the component; triggers the enter or exit animation
   */
  in: _react2.default.PropTypes.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _react2.default.PropTypes.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is not shown
   */
  unmountOnExit: _react2.default.PropTypes.bool,

  /**
   * Run the enter animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: _react2.default.PropTypes.bool,

  /**
   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
   * transition indefinately if the browser transitionEnd events are
   * canceled or interrupted.
   *
   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
   * setting this to the duration of your animation (or a bit above it).
   */
  timeout: _react2.default.PropTypes.number,

  /**
   * CSS class or classes applied when the component is exited
   */
  exitedClassName: _react2.default.PropTypes.string,
  /**
   * CSS class or classes applied while the component is exiting
   */
  exitingClassName: _react2.default.PropTypes.string,
  /**
   * CSS class or classes applied when the component is entered
   */
  enteredClassName: _react2.default.PropTypes.string,
  /**
   * CSS class or classes applied while the component is entering
   */
  enteringClassName: _react2.default.PropTypes.string,

  /**
   * Callback fired before the "entering" classes are applied
   */
  onEnter: _react2.default.PropTypes.func,
  /**
   * Callback fired after the "entering" classes are applied
   */
  onEntering: _react2.default.PropTypes.func,
  /**
   * Callback fired after the "enter" classes are applied
   */
  onEntered: _react2.default.PropTypes.func,
  /**
   * Callback fired before the "exiting" classes are applied
   */
  onExit: _react2.default.PropTypes.func,
  /**
   * Callback fired after the "exiting" classes are applied
   */
  onExiting: _react2.default.PropTypes.func,
  /**
   * Callback fired after the "exited" classes are applied
   */
  onExited: _react2.default.PropTypes.func
};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.displayName = 'Transition';

Transition.defaultProps = {
  in: false,
  unmountOnExit: false,
  transitionAppear: false,

  timeout: 5000,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

exports.default = Transition;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"j4TbR","icon":"_236tj","isHighlighted":"-RCjA","iconHover":"_3EwDE","background":"rt_4x"};

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_30-Kh","content":"_2mCW3","triangleWrapper":"_2fdAw","triangle":"_14pOC","top":"YsVUr"};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createBlockTypeButton;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _textEditorButton = __webpack_require__(42);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createBlockTypeButton(_ref) {
  var _class, _temp2;

  var blockType = _ref.blockType,
      Content = _ref.content,
      tooltipText = _ref.tooltipText;

  return _temp2 = _class = function (_Component) {
    _inherits(BlockTypeButton, _Component);

    function BlockTypeButton() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, BlockTypeButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = BlockTypeButton.__proto__ || Object.getPrototypeOf(BlockTypeButton)).call.apply(_ref2, [this].concat(args))), _this), _this.isActive = function () {
        return _this.props.isBlockType(blockType);
      }, _this.handleClick = function () {
        return _this.props.toggleBlockType(blockType);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BlockTypeButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            isBlockType = _props.isBlockType,
            toggleBlockType = _props.toggleBlockType,
            className = _props.className,
            buttonProps = _objectWithoutProperties(_props, ['isBlockType', 'toggleBlockType', 'className']);

        return _react2.default.createElement(_textEditorButton2.default, _extends({
          className: (0, _classnames2.default)(className, 'text-editor__' + blockType + '-button'),
          onClick: this.handleClick,
          isActive: this.isActive(),
          icon: Content,
          tooltipText: tooltipText
        }, buttonProps));
      }
    }]);

    return BlockTypeButton;
  }(_react.Component), _class.propTypes = {
    isBlockType: _propTypes2.default.func.isRequired,
    toggleBlockType: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string
  }, _temp2;
}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _textEditorButton = __webpack_require__(42);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createButton(_ref) {
  var _class, _temp;

  var className = _ref.className,
      displayName = _ref.displayName,
      Content = _ref.content,
      tooltipText = _ref.tooltipText;

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(_textEditorButton2.default, _extends({ className: className, icon: Content, tooltipText: tooltipText }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = displayName, _temp;
}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createDropdownButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _textEditorDropdownButton = __webpack_require__(705);

var _textEditorDropdownButton2 = _interopRequireDefault(_textEditorDropdownButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createDropdownButton(_ref) {
  var buttons = _ref.buttons;

  return function (props) {
    return _react2.default.createElement(_textEditorDropdownButton2.default, _extends({ buttons: buttons }, props));
  };
}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _textEditorButton = __webpack_require__(42);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

var _textEditorDropdown = __webpack_require__(706);

var _textEditorDropdown2 = _interopRequireDefault(_textEditorDropdown);

var _textEditorDropdownButton = __webpack_require__(708);

var _textEditorDropdownButton2 = _interopRequireDefault(_textEditorDropdownButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditorDropdownButton = function (_Component) {
  _inherits(TextEditorDropdownButton, _Component);

  function TextEditorDropdownButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextEditorDropdownButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextEditorDropdownButton.__proto__ || Object.getPrototypeOf(TextEditorDropdownButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getFirstButton = function () {
      return (0, _lodash.find)(_this.props.buttons, function (_ref2) {
        var value = _ref2.value;
        return _this.props.isActive(value);
      }) || _this.props.buttons[0];
    }, _this.getDropdownButtons = function () {
      var firstButtonValue = _this.getFirstButton().value;
      return (0, _lodash.sortBy)(_this.props.buttons, function (_ref3) {
        var value = _ref3.value;
        return value === firstButtonValue ? 0 : 1;
      });
    }, _this.handleTriggerClick = function () {
      _this.setState({
        isVisible: true,
        height: (0, _reactDom.findDOMNode)(_this).offsetHeight
      });
    }, _this.handleDocumentMouseDown = function (event) {
      var node = (0, _reactDom.findDOMNode)(_this);
      if (!node.contains(event.target)) {
        _this.setState({
          isVisible: false
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextEditorDropdownButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleDocumentMouseDown, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleDocumentMouseDown, true);
    }
  }, {
    key: 'renderButton',
    value: function renderButton(_ref4, buttonProps) {
      var _this2 = this;

      var value = _ref4.value,
          icon = _ref4.icon,
          tooltipText = _ref4.tooltipText,
          className = _ref4.className;
      var _props = this.props,
          isActive = _props.isActive,
          onClick = _props.onClick;

      var handleClick = function handleClick() {
        onClick(value);
        _this2.setState({
          isVisible: false
        });
      };
      return _react2.default.createElement(_textEditorButton2.default, _extends({
        isActive: isActive(value),
        onClick: handleClick,
        icon: icon,
        tooltipText: tooltipText,
        className: className
      }, buttonProps));
    }
  }, {
    key: 'renderDropdown',
    value: function renderDropdown(buttonProps) {
      var _this3 = this;

      var isVisible = this.state.isVisible;
      var _props2 = this.props,
          isInverted = _props2.isInverted,
          theme = _props2.theme;


      if (!isVisible) {
        return null;
      }
      return _react2.default.createElement(
        _textEditorDropdown2.default,
        { itemHeight: this.state.height, isInverted: isInverted, theme: (0, _lodash.get)(theme, 'dropdown') },
        (0, _lodash.map)(this.getDropdownButtons(), function (button, key) {
          return _this3.renderButton(button, _extends({}, buttonProps, {
            key: key
          }));
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          isActive = _props3.isActive,
          onClick = _props3.onClick,
          className = _props3.className,
          buttonProps = _objectWithoutProperties(_props3, ['isActive', 'onClick', 'className']);

      var button = this.renderButton(this.getFirstButton(), _extends({}, buttonProps, {
        onClick: this.handleTriggerClick
      }));

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_textEditorDropdownButton2.default.container, className) },
        button,
        this.renderDropdown(buttonProps)
      );
    }
  }]);

  return TextEditorDropdownButton;
}(_react.Component);

TextEditorDropdownButton.propTypes = {
  buttons: _propTypes2.default.array.isRequired,
  isActive: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  cardBackgroundColor: _propTypes2.default.string,
  isInverted: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.object
};
exports.default = TextEditorDropdownButton;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _separator = __webpack_require__(18);

var _textEditorDropdown = __webpack_require__(707);

var _textEditorDropdown2 = _interopRequireDefault(_textEditorDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextEditorDropdown = function TextEditorDropdown(_ref) {
  var children = _ref.children,
      itemHeight = _ref.itemHeight,
      theme = _ref.theme;

  var containerClassName = (0, _classnames2.default)(_textEditorDropdown2.default.container, 'text-editor-dropdown', (0, _lodash.get)(theme, 'container'));
  var style = (0, _lodash.get)(theme, 'containerStyle');
  var content = _react2.default.Children.map(children, function (child) {
    return _react2.default.createElement(
      'div',
      { className: _textEditorDropdown2.default.item },
      _react2.default.createElement(
        'div',
        { style: { height: itemHeight } },
        child
      ),
      _react2.default.createElement(_separator.HorizontalSeparator, { className: _textEditorDropdown2.default.separator })
    );
  });

  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: style },
    content
  );
};

TextEditorDropdown.propTypes = {
  children: _propTypes2.default.node,
  itemHeight: _propTypes2.default.number,
  theme: _propTypes2.default.object
};

exports.default = TextEditorDropdown;

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"BiHon","separator":"_1st_W","item":"_2GYRv"};

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1LoOM"};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createInlineStyleButton;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _textEditorButton = __webpack_require__(42);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createInlineStyleButton(_ref) {
  var _class, _temp2;

  var inlineStyle = _ref.inlineStyle,
      Content = _ref.content,
      tooltipText = _ref.tooltipText;

  return _temp2 = _class = function (_Component) {
    _inherits(InlineStyleButton, _Component);

    function InlineStyleButton() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, InlineStyleButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = InlineStyleButton.__proto__ || Object.getPrototypeOf(InlineStyleButton)).call.apply(_ref2, [this].concat(args))), _this), _this.isActive = function () {
        return _this.props.hasInlineStyle(inlineStyle);
      }, _this.handleClick = function () {
        return _this.props.setInlineStyle(inlineStyle);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(InlineStyleButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            hasInlineStyle = _props.hasInlineStyle,
            setInlineStyle = _props.setInlineStyle,
            className = _props.className,
            buttonProps = _objectWithoutProperties(_props, ['hasInlineStyle', 'setInlineStyle', 'className']);

        return _react2.default.createElement(_textEditorButton2.default, _extends({
          className: (0, _classnames2.default)(className, 'text-editor__' + inlineStyle.toLowerCase() + '-button'),
          onClick: this.handleClick,
          isActive: this.isActive(),
          icon: Content,
          tooltipText: tooltipText
        }, buttonProps));
      }
    }]);

    return InlineStyleButton;
  }(_react.Component), _class.propTypes = {
    hasInlineStyle: _propTypes2.default.func.isRequired,
    setInlineStyle: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string
  }, _temp2;
}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSizeButton;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _textEditorButton = __webpack_require__(42);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createSizeButton(_ref) {
  var _class, _temp2;

  var size = _ref.size,
      Content = _ref.content,
      tooltipText = _ref.tooltipText;

  return _temp2 = _class = function (_Component) {
    _inherits(SizeButton, _Component);

    function SizeButton() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, SizeButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SizeButton.__proto__ || Object.getPrototypeOf(SizeButton)).call.apply(_ref2, [this].concat(args))), _this), _this.isActive = function () {
        return _this.props.size === size;
      }, _this.handleClick = function () {
        return _this.props.setSize(size);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SizeButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            setSize = _props.setSize,
            size = _props.size,
            className = _props.className,
            buttonProps = _objectWithoutProperties(_props, ['setSize', 'size', 'className']);

        return _react2.default.createElement(_textEditorButton2.default, _extends({
          className: (0, _classnames2.default)(className, 'text-editor__size-' + _lodash2.default.kebabCase(size) + '-button'),
          icon: Content,
          onClick: this.handleClick,
          isActive: this.isActive(),
          tooltipText: tooltipText
        }, buttonProps));
      }
    }]);

    return SizeButton;
  }(_react.Component), _class.propTypes = {
    setSize: _propTypes2.default.func.isRequired,
    size: _propTypes2.default.string,
    className: _propTypes2.default.string
  }, _temp2;
}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createUploadButton;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _textEditorUploadButton = __webpack_require__(712);

var _textEditorUploadButton2 = _interopRequireDefault(_textEditorUploadButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUploadButton(_ref) {
  var _class, _temp;

  var Content = _ref.content,
      tooltipText = _ref.tooltipText;

  return _temp = _class = function (_Component) {
    _inherits(UploadButton, _Component);

    function UploadButton() {
      _classCallCheck(this, UploadButton);

      return _possibleConstructorReturn(this, (UploadButton.__proto__ || Object.getPrototypeOf(UploadButton)).apply(this, arguments));
    }

    _createClass(UploadButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            onFileChange = _props.onFileChange,
            buttonProps = _objectWithoutProperties(_props, ['onFileChange']);

        return _react2.default.createElement(_textEditorUploadButton2.default, _extends({
          onFileChange: this.props.onFileChange,
          icon: Content,
          tooltipText: tooltipText
        }, buttonProps));
      }
    }]);

    return UploadButton;
  }(_react.Component), _class.propTypes = {
    onFileChange: _propTypes2.default.func.isRequired
  }, _temp;
}

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextEditorUploadButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _textEditorButton = __webpack_require__(42);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

var _textEditorUploadButton = __webpack_require__(713);

var _textEditorUploadButton2 = _interopRequireDefault(_textEditorUploadButton);

var _accessibility = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditorUploadButton = exports.TextEditorUploadButton = function (_Component) {
  _inherits(TextEditorUploadButton, _Component);

  function TextEditorUploadButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextEditorUploadButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextEditorUploadButton.__proto__ || Object.getPrototypeOf(TextEditorUploadButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseDown = function (event) {
      event.preventDefault();
    }, _this.handleChange = function (event) {
      if (event.target.files[0]) {
        _this.props.onFileChange(event);
      }
      _this.form.reset();
    }, _this.setForm = function (form) {
      _this.form = form;
    }, _this.triggerInputClick = function () {
      _this.input && _this.input.click();
    }, _this.setInput = function (input) {
      _this.input = input;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextEditorUploadButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isDisabled = _props.isDisabled,
          onFileChange = _props.onFileChange,
          otherProps = _objectWithoutProperties(_props, ['isDisabled', 'onFileChange']);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_textEditorUploadButton2.default.button, 'text-editor-upload-button') },
        _react2.default.createElement(
          _textEditorButton2.default,
          _extends({ isDisabled: isDisabled }, otherProps, { onKeyUp: (0, _accessibility.handleEnterKeyUp)(this.triggerInputClick) }),
          _react2.default.createElement(
            'form',
            { ref: this.setForm },
            _react2.default.createElement('input', {
              ref: this.setInput,
              className: _textEditorUploadButton2.default.input,
              type: 'file',
              onChange: this.handleChange,
              accept: 'image/*',
              disabled: isDisabled,
              onMouseDown: this.handleMouseDown,
              tabIndex: '-1'
            })
          )
        )
      );
    }
  }]);

  return TextEditorUploadButton;
}(_react.Component);

TextEditorUploadButton.propTypes = {
  onFileChange: _propTypes2.default.func,
  isDisabled: _propTypes2.default.bool
};

exports.default = TextEditorUploadButton;

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_3o1yP","input":"_3yQso"};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createMediaDialogButton;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _textEditorButton = __webpack_require__(42);

var _textEditorButton2 = _interopRequireDefault(_textEditorButton);

var _normalizeImageData = __webpack_require__(715);

var _normalizeImageData2 = _interopRequireDefault(_normalizeImageData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createMediaDialogButton(_ref) {
  var _class, _temp2;

  var className = _ref.className,
      displayName = _ref.displayName,
      Content = _ref.content,
      tooltipText = _ref.tooltipText;

  return _temp2 = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref2, [this].concat(args))), _this), _this.handleClick = function () {
        return _wixSdkPolyfill2.default.Settings.openMediaDialog(_wixSdkPolyfill2.default.Settings.MediaType.IMAGE, false, function (imageData) {
          return _this.props.onFileSelect((0, _normalizeImageData2.default)(imageData));
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(_textEditorButton2.default, _extends({
          className: className,
          icon: Content,
          tooltipText: tooltipText,
          onClick: this.handleClick
        }, this.props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = displayName, _class.propTypes = {
    onFileSelect: _propTypes2.default.func
  }, _temp2;
}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeImageData;
function normalizeImageData(imageData) {
  return {
    original_file_name: imageData.fileName, // eslint-disable-line
    file_name: imageData.relativeUri, // eslint-disable-line
    width: imageData.width,
    height: imageData.height
  };
}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/* pica 2.0.8 nodeca/pica */(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.pica = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

/* global document */

module.exports = function () {
  return document.createElement('canvas');
};

},{}],2:[function(require,module,exports){
'use strict';

var lastId = 1;

module.exports = function () {
  return lastId++;
};

},{}],3:[function(require,module,exports){
'use strict';

var IDLE = 2000;
var TIMEOUT = 500;

function Pool(create) {
  this.create = create;

  this.available = [];
  this.acquired = {};
  this.lastId = 1;

  this.timeoutId = 0;
}

Pool.prototype.acquire = function () {
  var self = this;
  var resource;
  if (this.available.length !== 0) {
    resource = this.available.pop();
  } else {
    resource = this.create();
    resource.id = this.lastId++;
    resource.release = function () {
      self.release(resource);
    };
  }
  this.acquired[resource.id] = resource;
  return resource;
};

Pool.prototype.release = function (resource) {
  delete this.acquired[resource.id];
  resource.lastUsed = Date.now();
  this.available.push(resource);

  if (this.timeoutId === 0) {
    this.timeoutId = setTimeout(this.gc.bind(this), TIMEOUT);
  }
};

Pool.prototype.gc = function () {
  var now = Date.now();

  this.available = this.available.filter(function (resource) {
    if (now - resource.lastUsed > IDLE) {
      resource.destroy();
      return false;
    }
    return true;
  });

  if (this.available.length !== 0) {
    this.timeoutId = setTimeout(this.gc.bind(this), TIMEOUT);
  } else {
    this.timeoutId = 0;
  }
};

module.exports = Pool;

},{}],4:[function(require,module,exports){
// High speed resize with tuneable speed/quality ratio

'use strict';


// Precision of fixed FP values
var FIXED_FRAC_BITS = 14;


//
// Presets for quality 0..3. Filter functions + window size
//
var FILTER_INFO = [
  { // Nearest neibor (Box)
    win: 0.5,
    filter: function (x) {
      return (x >= -0.5 && x < 0.5) ? 1.0 : 0.0;
    }
  },
  { // Hamming
    win: 1.0,
    filter: function (x) {
      if (x <= -1.0 || x >= 1.0) { return 0.0; }
      if (x > -1.19209290E-07 && x < 1.19209290E-07) { return 1.0; }
      var xpi = x * Math.PI;
      return ((Math.sin(xpi) / xpi) *  (0.54 + 0.46 * Math.cos(xpi / 1.0)));
    }
  },
  { // Lanczos, win = 2
    win: 2.0,
    filter: function (x) {
      if (x <= -2.0 || x >= 2.0) { return 0.0; }
      if (x > -1.19209290E-07 && x < 1.19209290E-07) { return 1.0; }
      var xpi = x * Math.PI;
      return (Math.sin(xpi) / xpi) * Math.sin(xpi / 2.0) / (xpi / 2.0);
    }
  },
  { // Lanczos, win = 3
    win: 3.0,
    filter: function (x) {
      if (x <= -3.0 || x >= 3.0) { return 0.0; }
      if (x > -1.19209290E-07 && x < 1.19209290E-07) { return 1.0; }
      var xpi = x * Math.PI;
      return (Math.sin(xpi) / xpi) * Math.sin(xpi / 3.0) / (xpi / 3.0);
    }
  }
];

function clampTo8(i) { return i < 0 ? 0 : (i > 255 ? 255 : i); }

function toFixedPoint(num) { return Math.round(num * ((1 << FIXED_FRAC_BITS) - 1)); }


// Calculate convolution filters for each destination point,
// and pack data to Int16Array:
//
// [ shift, length, data..., shift2, length2, data..., ... ]
//
// - shift - offset in src image
// - length - filter length (in src points)
// - data - filter values sequence
//
function createFilters(quality, srcSize, destSize, scale, offset) {

  var filterFunction = FILTER_INFO[quality].filter;

  var scaleInverted = 1.0 / scale;
  var scaleClamped  = Math.min(1.0, scale); // For upscale

  // Filter window (averaging interval), scaled to src image
  var srcWindow = FILTER_INFO[quality].win / scaleClamped;

  var destPixel, srcPixel, srcFirst, srcLast, filterElementSize,
      floatFilter, fxpFilter, total, pxl, idx, floatVal, filterTotal, filterVal;
  var leftNotEmpty, rightNotEmpty, filterShift, filterSize;

  var maxFilterElementSize = Math.floor((srcWindow + 1) * 2);
  var packedFilter    = new Int16Array((maxFilterElementSize + 2) * destSize);
  var packedFilterPtr = 0;

  // For each destination pixel calculate source range and built filter values
  for (destPixel = 0; destPixel < destSize; destPixel++) {

    // Scaling should be done relative to central pixel point
    srcPixel = (destPixel + 0.5) * scaleInverted + offset;

    srcFirst = Math.max(0, Math.floor(srcPixel - srcWindow));
    srcLast  = Math.min(srcSize - 1, Math.ceil(srcPixel + srcWindow));

    filterElementSize = srcLast - srcFirst + 1;
    floatFilter = new Float32Array(filterElementSize);
    fxpFilter = new Int16Array(filterElementSize);

    total = 0.0;

    // Fill filter values for calculated range
    for (pxl = srcFirst, idx = 0; pxl <= srcLast; pxl++, idx++) {
      floatVal = filterFunction(((pxl + 0.5) - srcPixel) * scaleClamped);
      total += floatVal;
      floatFilter[idx] = floatVal;
    }

    // Normalize filter, convert to fixed point and accumulate conversion error
    filterTotal = 0;

    for (idx = 0; idx < floatFilter.length; idx++) {
      filterVal = floatFilter[idx] / total;
      filterTotal += filterVal;
      fxpFilter[idx] = toFixedPoint(filterVal);
    }

    // Compensate normalization error, to minimize brightness drift
    fxpFilter[destSize >> 1] += toFixedPoint(1.0 - filterTotal);

    //
    // Now pack filter to useable form
    //
    // 1. Trim heading and tailing zero values, and compensate shitf/length
    // 2. Put all to single array in this format:
    //
    //    [ pos shift, data length, value1, value2, value3, ... ]
    //

    leftNotEmpty = 0;
    while (leftNotEmpty < fxpFilter.length && fxpFilter[leftNotEmpty] === 0) {
      leftNotEmpty++;
    }

    if (leftNotEmpty < fxpFilter.length) {
      rightNotEmpty = fxpFilter.length - 1;
      while (rightNotEmpty > 0 && fxpFilter[rightNotEmpty] === 0) {
        rightNotEmpty--;
      }

      filterShift = srcFirst + leftNotEmpty;
      filterSize = rightNotEmpty - leftNotEmpty + 1;

      packedFilter[packedFilterPtr++] = filterShift; // shift
      packedFilter[packedFilterPtr++] = filterSize; // size

      packedFilter.set(fxpFilter.subarray(leftNotEmpty, rightNotEmpty + 1), packedFilterPtr);
      packedFilterPtr += filterSize;
    } else {
      // zero data, write header only
      packedFilter[packedFilterPtr++] = 0; // shift
      packedFilter[packedFilterPtr++] = 0; // size
    }
  }
  return packedFilter;
}

// Convolve image in horizontal directions and transpose output. In theory,
// transpose allow:
//
// - use the same convolver for both passes (this fails due different
//   types of input array and temporary buffer)
// - making vertical pass by horisonltal lines inprove CPU cache use.
//
// But in real life this doesn't work :)
//
function convolveHorizontally(src, dest, srcW, srcH, destW, filters) {

  var r, g, b, a;
  var filterPtr, filterShift, filterSize;
  var srcPtr, srcY, destX, filterVal;
  var srcOffset = 0, destOffset = 0;

  // For each row
  for (srcY = 0; srcY < srcH; srcY++) {
    filterPtr  = 0;

    /*eslint-disable space-infix-ops*/

    // Apply precomputed filters to each destination row point
    for (destX = 0; destX < destW; destX++) {
      // Get the filter that determines the current output pixel.
      filterShift = filters[filterPtr++];
      filterSize  = filters[filterPtr++];

      srcPtr = (srcOffset + (filterShift * 4))|0;

      r = g = b = a = 0;

      // Apply the filter to the row to get the destination pixel r, g, b, a
      for (; filterSize > 0; filterSize--) {
        filterVal = filters[filterPtr++];

        // Use reverse order to workaround deopts in old v8 (node v.10)
        // Big thanks to @mraleph (Vyacheslav Egorov) for the tip.
        a = (a + filterVal * src[srcPtr + 3])|0;
        b = (b + filterVal * src[srcPtr + 2])|0;
        g = (g + filterVal * src[srcPtr + 1])|0;
        r = (r + filterVal * src[srcPtr])|0;
        srcPtr = (srcPtr + 4)|0;
      }

      // Bring this value back in range. All of the filter scaling factors
      // are in fixed point with FIXED_FRAC_BITS bits of fractional part.
      //
      // (!) Add 1/2 of value before clamping to get proper rounding. In other
      // case brightness loss will be noticeable if you resize image with white
      // border and place it on white background.
      //
      dest[destOffset + 3] = clampTo8((a + (1 << 13)) >> 14/*FIXED_FRAC_BITS*/);
      dest[destOffset + 2] = clampTo8((b + (1 << 13)) >> 14/*FIXED_FRAC_BITS*/);
      dest[destOffset + 1] = clampTo8((g + (1 << 13)) >> 14/*FIXED_FRAC_BITS*/);
      dest[destOffset]     = clampTo8((r + (1 << 13)) >> 14/*FIXED_FRAC_BITS*/);
      destOffset = (destOffset + srcH * 4)|0;
    }

    destOffset = ((srcY + 1) * 4)|0;
    srcOffset  = ((srcY + 1) * srcW * 4)|0;
  }
}

// Technically, convolvers are the same. But input array and temporary
// buffer can be of different type (especially, in old browsers). So,
// keep code in separate functions to avoid deoptimizations & speed loss.

function convolveVertically(src, dest, srcW, srcH, destW, filters) {

  var r, g, b, a;
  var filterPtr, filterShift, filterSize;
  var srcPtr, srcY, destX, filterVal;
  var srcOffset = 0, destOffset = 0;

  // For each row
  for (srcY = 0; srcY < srcH; srcY++) {
    filterPtr  = 0;

    /*eslint-disable space-infix-ops*/

    // Apply precomputed filters to each destination row point
    for (destX = 0; destX < destW; destX++) {
      // Get the filter that determines the current output pixel.
      filterShift = filters[filterPtr++];
      filterSize  = filters[filterPtr++];

      srcPtr = (srcOffset + (filterShift * 4))|0;

      r = g = b = a = 0;

      // Apply the filter to the row to get the destination pixel r, g, b, a
      for (; filterSize > 0; filterSize--) {
        filterVal = filters[filterPtr++];

        // Use reverse order to workaround deopts in old v8 (node v.10)
        // Big thanks to @mraleph (Vyacheslav Egorov) for the tip.
        a = (a + filterVal * src[srcPtr + 3])|0;
        b = (b + filterVal * src[srcPtr + 2])|0;
        g = (g + filterVal * src[srcPtr + 1])|0;
        r = (r + filterVal * src[srcPtr])|0;
        srcPtr = (srcPtr + 4)|0;
      }

      // Bring this value back in range. All of the filter scaling factors
      // are in fixed point with FIXED_FRAC_BITS bits of fractional part.
      //
      // (!) Add 1/2 of value before clamping to get proper rounding. In other
      // case brightness loss will be noticeable if you resize image with white
      // border and place it on white background.
      //
      dest[destOffset + 3] = clampTo8((a + (1 << 13)) >> 14/*FIXED_FRAC_BITS*/);
      dest[destOffset + 2] = clampTo8((b + (1 << 13)) >> 14/*FIXED_FRAC_BITS*/);
      dest[destOffset + 1] = clampTo8((g + (1 << 13)) >> 14/*FIXED_FRAC_BITS*/);
      dest[destOffset]     = clampTo8((r + (1 << 13)) >> 14/*FIXED_FRAC_BITS*/);
      destOffset = (destOffset + srcH * 4)|0;
    }

    destOffset = ((srcY + 1) * 4)|0;
    srcOffset  = ((srcY + 1) * srcW * 4)|0;
  }
}


function resetAlpha(dst, width, height) {
  var ptr = 3, len = (width * height * 4)|0;
  while (ptr < len) { dst[ptr] = 0xFF; ptr = (ptr + 4)|0; }
}


function resize(options) {
  var src   = options.src;
  var srcW  = options.width;
  var srcH  = options.height;
  var destW = options.toWidth;
  var destH = options.toHeight;
  var scaleX = options.scaleX || options.toWidth / options.width;
  var scaleY = options.scaleY || options.toHeight / options.height;
  var offsetX = options.offsetX || 0;
  var offsetY = options.offsetY || 0;
  var dest  = options.dest || new Uint8Array(destW * destH * 4);
  var quality = typeof options.quality === 'undefined' ? 3 : options.quality;
  var alpha = options.alpha || false;

  if (srcW < 1 || srcH < 1 || destW < 1 || destH < 1) { return []; }

  var filtersX = createFilters(quality, srcW, destW, scaleX, offsetX),
      filtersY = createFilters(quality, srcH, destH, scaleY, offsetY);

  var tmp  = new Uint8Array(destW * srcH * 4);

  // To use single function we need src & tmp of the same type.
  // But src can be CanvasPixelArray, and tmp - Uint8Array. So, keep
  // vertical and horizontal passes separately to avoid deoptimization.

  convolveHorizontally(src, tmp, srcW, srcH, destW, filtersX);
  convolveVertically(tmp, dest, srcH, destW, destH, filtersY);

  // That's faster than doing checks in convolver.
  // !!! Note, canvas data is not premultipled. We don't need other
  // alpha corrections.

  if (!alpha) {
    resetAlpha(dest, destW, destH);
  }

  return dest;
}


module.exports = resize;

},{}],5:[function(require,module,exports){
// Unsharp mask filter
//
// http://stackoverflow.com/a/23322820/1031804
// USM(O) = O + (2 * (Amount / 100) * (O - GB))
// GB - gaussian blur.
//
// Image is converted from RGB to HSL, unsharp mask is applied to the
// lightness channel and then image is converted back to RGB.

'use strict';


var glurMono16 = require('glur/mono16');

function getLightness(img, width, height) {
  var size = width * height;
  var out = new Uint16Array(size);
  var r, g, b, min, max;
  for (var i = 0; i < size; i++) {
    r = img[4 * i];
    g = img[4 * i + 1];
    b = img[4 * i + 2];
    max = (r >= g && r >= b) ? r : (g >= b && g >= r) ? g : b;
    min = (r <= g && r <= b) ? r : (g <= b && g <= r) ? g : b;
    out[i] = (max + min) * 257 >> 1;
  }
  return out;
}

function unsharp(img, width, height, amount, radius, threshold) {
  var r, g, b;
  var h, s, l;
  var min, max;
  var m1, m2, hShifted;
  var diff, iTimes4;

  if (amount === 0 || radius < 0.5) {
    return;
  }
  if (radius > 2.0) {
    radius = 2.0;
  }

  var lightness = getLightness(img, width, height);

  var blured = new Uint16Array(lightness); // copy, because blur modify src

  glurMono16(blured, width, height, radius);

  /* eslint-disable space-infix-ops */
  var amountFp = (amount / 100 * 0x1000 + 0.5)|0;
  var thresholdFp = (threshold * 257)|0;

  var size = width * height;

  for (var i = 0; i < size; i++) {
    diff = 2 * (lightness[i] - blured[i]);

    if (Math.abs(diff) >= thresholdFp) {
      iTimes4 = i * 4;
      r = img[iTimes4];
      g = img[iTimes4 + 1];
      b = img[iTimes4 + 2];

      // convert RGB to HSL
      // take RGB, 8-bit unsigned integer per each channel
      // save HSL, H and L are 16-bit unsigned integers, S is 12-bit unsigned integer
      // math is taken from here: http://www.easyrgb.com/index.php?X=MATH&H=18
      // and adopted to be integer (fixed point in fact) for sake of performance
      max = (r >= g && r >= b) ? r : (g >= r && g >= b) ? g : b; // min and max are in [0..0xff]
      min = (r <= g && r <= b) ? r : (g <= r && g <= b) ? g : b;
      l = (max + min) * 257 >> 1; // l is in [0..0xffff] that is caused by multiplication by 257

      if (min === max) {
        h = s = 0;
      } else {
        s = (l <= 0x7fff) ?
          (((max - min) * 0xfff) / (max + min))|0 :
          (((max - min) * 0xfff) / (2 * 0xff - max - min))|0; // s is in [0..0xfff]
        // h could be less 0, it will be fixed in backward conversion to RGB, |h| <= 0xffff / 6
        h = (r === max) ? (((g - b) * 0xffff) / (6 * (max - min)))|0
          : (g === max) ? 0x5555 + ((((b - r) * 0xffff) / (6 * (max - min)))|0) // 0x5555 == 0xffff / 3
          : 0xaaaa + ((((r - g) * 0xffff) / (6 * (max - min)))|0); // 0xaaaa == 0xffff * 2 / 3
      }

      // add unsharp mask mask to the lightness channel
      l += (amountFp * diff + 0x800) >> 12;
      if (l > 0xffff) {
        l = 0xffff;
      } else if (l < 0) {
        l = 0;
      }

      // convert HSL back to RGB
      // for information about math look above
      if (s === 0) {
        r = g = b = l >> 8;
      } else {
        m2 = (l <= 0x7fff) ? (l * (0x1000 + s) + 0x800) >> 12 :
          l  + (((0xffff - l) * s + 0x800) >>  12);
        m1 = 2 * l - m2 >> 8;
        m2 >>= 8;
        // save result to RGB channels
        // R channel
        hShifted = (h + 0x5555) & 0xffff; // 0x5555 == 0xffff / 3
        r = (hShifted >= 0xaaaa) ? m1 // 0xaaaa == 0xffff * 2 / 3
          : (hShifted >= 0x7fff) ?  m1 + ((m2 - m1) * 6 * (0xaaaa - hShifted) + 0x8000 >> 16)
          : (hShifted >= 0x2aaa) ? m2 // 0x2aaa == 0xffff / 6
          : m1 + ((m2 - m1) * 6 * hShifted + 0x8000 >> 16);
        // G channel
        hShifted = h & 0xffff;
        g = (hShifted >= 0xaaaa) ? m1 // 0xaaaa == 0xffff * 2 / 3
          : (hShifted >= 0x7fff) ?  m1 + ((m2 - m1) * 6 * (0xaaaa - hShifted) + 0x8000 >> 16)
          : (hShifted >= 0x2aaa) ? m2 // 0x2aaa == 0xffff / 6
          : m1 + ((m2 - m1) * 6 * hShifted + 0x8000 >> 16);
        // B channel
        hShifted = (h - 0x5555) & 0xffff;
        b = (hShifted >= 0xaaaa) ? m1 // 0xaaaa == 0xffff * 2 / 3
          : (hShifted >= 0x7fff) ?  m1 + ((m2 - m1) * 6 * (0xaaaa - hShifted) + 0x8000 >> 16)
          : (hShifted >= 0x2aaa) ? m2 // 0x2aaa == 0xffff / 6
          : m1 + ((m2 - m1) * 6 * hShifted + 0x8000 >> 16);
      }

      img[iTimes4] = r;
      img[iTimes4 + 1] = g;
      img[iTimes4 + 2] = b;
    }
  }
}

module.exports = unsharp;
module.exports.lightness = getLightness;

},{"glur/mono16":11}],6:[function(require,module,exports){
'use strict';

/*
 * pixelFloor and pixelCeil are modified versions of Math.floor and Math.ceil
 * functions which take into account floating point arithmetic errors.
 * Those errors can cause undesired increments/decrements of sizes and offsets:
 * Math.ceil(36 / (36 / 500)) = 501
 * pixelCeil(36 / (36 / 500)) = 500
 */

var PIXEL_EPSILON = 1e-5;

function pixelFloor(x) {
  var nearest = Math.round(x);

  if (Math.abs(x - nearest) < PIXEL_EPSILON) { return nearest; }
  return Math.floor(x);
}

function pixelCeil(x) {
  var nearest = Math.round(x);

  if (Math.abs(x - nearest) < PIXEL_EPSILON) { return nearest; }
  return Math.ceil(x);
}

module.exports.createRegions = function createRegions(options) {
  var scaleX = options.toWidth / options.width;
  var scaleY = options.toHeight / options.height;

  var innerTileWidth = pixelFloor(options.srcTileSize * scaleX) - 2 * options.destTileBorder;
  var innerTileHeight = pixelFloor(options.srcTileSize * scaleY) - 2 * options.destTileBorder;

  var x, y;
  var innerX, innerY, toTileWidth, toTileHeight;
  var tiles = [];
  var tile;

  // we go top-to-down instead of left-to-right to make image displayed from top to
  // doesn in the browser
  for (innerY = 0; innerY < options.toHeight; innerY += innerTileHeight) {
    for (innerX = 0; innerX < options.toWidth; innerX += innerTileWidth) {
      x = innerX - options.destTileBorder;
      if (x < 0) { x = 0; }
      toTileWidth = innerX + innerTileWidth + options.destTileBorder - x;
      if (x + toTileWidth >= options.toWidth) {
        toTileWidth = options.toWidth - x;
      }

      y = innerY - options.destTileBorder;
      if (y < 0) { y = 0; }
      toTileHeight = innerY + innerTileHeight + options.destTileBorder - y;
      if (y + toTileHeight >= options.toHeight) {
        toTileHeight = options.toHeight - y;
      }

      tile = {
        toX: x,
        toY: y,
        toWidth: toTileWidth,
        toHeight: toTileHeight,

        toInnerX: innerX,
        toInnerY: innerY,
        toInnerWidth: innerTileWidth,
        toInnerHeight: innerTileHeight,

        offsetX: x / scaleX - pixelFloor(x / scaleX),
        offsetY: y / scaleY - pixelFloor(y / scaleY),
        scaleX: scaleX,
        scaleY: scaleY,

        x: pixelFloor(x / scaleX),
        y: pixelFloor(y / scaleY),
        width: pixelCeil(toTileWidth / scaleX),
        height: pixelCeil(toTileHeight / scaleY)
      };

      tiles.push(tile);
    }
  }

  return tiles;
};

module.exports.eachLimit = function eachLimit(list, limit, iterator, callback) {
  if (list.length === 0) {
    callback();
  }

  var executed = 0;
  var finished = 0;
  var failed = false;

  function next(err) {
    if (failed) {
      return;
    }
    if (err) {
      failed = true;
      callback(err);
      return;
    }

    finished++;
    if (finished === list.length) {
      callback();
    } else if (executed < list.length) {
      iterator(list[executed++], next);
    }
  }

  while (executed < limit && executed < list.length) {
    iterator(list[executed++], next);
  }
};

},{}],7:[function(require,module,exports){
// Web Worker wrapper for image resize function

'use strict';

module.exports = function (self) {
  var resize = require('./resize_array');
  var unsharp = require('./unsharp');

  self.onmessage = function (ev) {
    var options = ev.data;
    options.dest = new Uint8Array(options.toWidth * options.toHeight * 4);

    resize(options);

    if (options.unsharpAmount) {
      unsharp(options.dest, options.toWidth, options.toHeight,
        options.unsharpAmount, options.unsharpRadius, options.unsharpThreshold);
    }

    self.postMessage({ output: options.dest }, [ options.dest.buffer ]);
  };
};

},{"./resize_array":4,"./unsharp":5}],8:[function(require,module,exports){
/*eslint space-infix-ops:0*/

'use strict';

var resize        = require('./js/resize_array');
var unsharp       = require('./js/unsharp');
var createRegions = require('./js/utils').createRegions;
var eachLimit     = require('./js/utils').eachLimit;
var generateId    = require('./js/generate_id');
var createCanvas  = require('./js/create_canvas');

var SRC_TILE_SIZE = 1024;
var DEST_TILE_BORDER = 3;

function resize_js(from, to, options, callback) {
  var toCtx = to.getContext('2d', { alpha: Boolean(options.alpha) });

  // We use intermediate canvases because, getImageData() from canvas region
  // is 8x times slower in FF than getImageData() from whole canvas.
  // That adds ~20% delay in Chrome :(.
  //
  // See https://bugzilla.mozilla.org/show_bug.cgi?id=1001069

  var fromTile = createCanvas();

  fromTile.width = Math.min(SRC_TILE_SIZE, from.width);
  fromTile.height = Math.min(SRC_TILE_SIZE, from.height);

  var fromTileCtx = fromTile.getContext('2d', { alpha: Boolean(options.alpha) });

  // Should not use previous content of reused canvas when alpha exists.
  fromTileCtx.globalCompositeOperation = 'copy';

  var regions = createRegions({
    width: from.naturalWidth || from.width,
    height: from.naturalHeight || from.height,
    srcTileSize: SRC_TILE_SIZE,
    toWidth: to.width,
    toHeight: to.height,
    destTileBorder: Math.ceil(Math.max(DEST_TILE_BORDER, 2.5 * options.unsharpRadius|0))
  });

  eachLimit(regions, 1, function (tile, next) {
    fromTileCtx.drawImage(from, tile.x, tile.y, tile.width, tile.height,
      0, 0, tile.width, tile.height);

    var fromImageData = fromTileCtx.getImageData(0, 0, tile.width, tile.height);
    var toImageData   = toCtx.createImageData(tile.toWidth, tile.toHeight);

    var _opts = {
      src:      fromImageData.data,
      dest:     toImageData.data,
      width:    tile.width,
      height:   tile.height,
      toWidth:  tile.toWidth,
      toHeight: tile.toHeight,
      scaleX:   tile.scaleX,
      scaleY:   tile.scaleY,
      offsetX:  tile.offsetX,
      offsetY:  tile.offsetY,
      quality:  options.quality,
      alpha:    options.alpha,
      unsharpAmount:    options.unsharpAmount,
      unsharpRadius:    options.unsharpRadius,
      unsharpThreshold: options.unsharpThreshold
    };

    resize(_opts);

    if (options.unsharpAmount) {
      unsharp(_opts.dest, _opts.toWidth, _opts.toHeight,
        _opts.unsharpAmount, _opts.unsharpRadius, _opts.unsharpThreshold);
    }

    toCtx.putImageData(toImageData, tile.toX, tile.toY,
      tile.toInnerX - tile.toX, tile.toInnerY - tile.toY,
      tile.toInnerWidth, tile.toInnerHeight);
    next();
  }, callback);

  return generateId();
}

module.exports = resize_js;
module.exports.terminate = function () {};

},{"./js/create_canvas":1,"./js/generate_id":2,"./js/resize_array":4,"./js/unsharp":5,"./js/utils":6}],9:[function(require,module,exports){
/* global navigator, window */
/*eslint space-infix-ops:0*/

'use strict';


var webworkify    = require('webworkify');
var resizeWorker  = require('./js/worker.js');
var createRegions = require('./js/utils').createRegions;
var eachLimit     = require('./js/utils').eachLimit;
var generateId    = require('./js/generate_id');
var createCanvas  = require('./js/create_canvas');
var Pool          = require('./js/pool');

var SRC_TILE_SIZE = 1024;
var DEST_TILE_BORDER = 3;
var NEED_SAFARI_FIX = false;
try {
  NEED_SAFARI_FIX = navigator.userAgent.indexOf('Safari') !== -1;
} catch (e) {}

var workersPool = new Pool(function () {
  return {
    value: webworkify(resizeWorker),
    destroy: function () {
      this.value.terminate();

      if (typeof window !== 'undefined') {
        var url = window.URL || window.webkitURL || window.mozURL || window.msURL;
        if (url && url.revokeObjectURL && this.value.objectURL) {
          url.revokeObjectURL(this.value.objectURL);
        }
      }
    }
  };
});

var running = {};

function resize_js_ww(from, to, options, callback) {
  var toCtx = to.getContext('2d', { alpha: Boolean(options.alpha) });
  /* We use intermediate canvases because without it Firefox resizes 8x times slower
   * than with it. It makes resize 20% slower in Chrome */
  var fromTile = createCanvas();

  fromTile.width = Math.min(SRC_TILE_SIZE, from.naturalWidth || from.width);
  fromTile.height = Math.min(SRC_TILE_SIZE, from.naturalHeight || from.height);

  var fromTileCtx = fromTile.getContext('2d', { alpha: Boolean(options.alpha) });

  // Should not use previous content of reused canvas when alpha exists.
  fromTileCtx.globalCompositeOperation = 'copy';

  var regions = createRegions({
    width: from.naturalWidth || from.width,
    height: from.naturalHeight || from.height,
    srcTileSize: SRC_TILE_SIZE,
    toWidth: to.width,
    toHeight: to.height,
    destTileBorder: Math.ceil(Math.max(DEST_TILE_BORDER, 2.5 * options.unsharpRadius|0))
  });

  var concurrency = 1;
  if (typeof navigator !== 'undefined') {
    concurrency = navigator.hardwareConcurrency || 1;
  }

  var id = options._id || generateId();

  running[id] = true;
  eachLimit(regions, concurrency, function (tile, next) {
    fromTileCtx.drawImage(from, tile.x, tile.y, tile.width, tile.height,
      0, 0, tile.width, tile.height);

    var fromImageData = fromTileCtx.getImageData(0, 0, tile.width, tile.height);

    var _opts = {
      src:      fromImageData.data,
      width:    tile.width,
      height:   tile.height,
      toWidth:  tile.toWidth,
      toHeight: tile.toHeight,
      scaleX:   tile.scaleX,
      scaleY:   tile.scaleY,
      offsetX:  tile.offsetX,
      offsetY:  tile.offsetY,
      quality:  options.quality,
      alpha:    options.alpha,
      unsharpAmount:    options.unsharpAmount,
      unsharpRadius:    options.unsharpRadius,
      unsharpThreshold: options.unsharpThreshold
    };

    var worker = workersPool.acquire();

    worker.value.onmessage = function (ev) {
      var i, l;
      var imageDataTo, output, dest;

      worker.release();

      if (!running[id]) {
        next(true);
        return;
      }
      if (ev.data.err) {
        next(ev.data.err);
        return;
      }

      imageDataTo = toCtx.createImageData(tile.toWidth, tile.toHeight);
      output = ev.data.output;
      dest = imageDataTo.data;

      if (dest.set) {
        dest.set(output);
      } else {
        for (i = 0, l = output.length; i < l; i++) {
          dest[i] = output[i];
        }
      }

      if (NEED_SAFARI_FIX) {
        // Safari draws thin white stripes between tiles without this fix
        toCtx.putImageData(imageDataTo, tile.toX, tile.toY,
          tile.toInnerX - tile.toX, tile.toInnerY - tile.toY,
          tile.toInnerWidth + 1e-5, tile.toInnerHeight + 1e-5);
      } else {
        toCtx.putImageData(imageDataTo, tile.toX, tile.toY,
          tile.toInnerX - tile.toX, tile.toInnerY - tile.toY,
          tile.toInnerWidth, tile.toInnerHeight);
      }
      next();
    };

    worker.value.postMessage(_opts, [ _opts.src.buffer ]);
  }, function (err) {
    if (running[id]) {
      delete running[id];
      callback(err);
    }
  });

  return id;
}

function terminate(id) {
  if (running[id]) {
    delete running[id];
  }
}

module.exports = resize_js_ww;
module.exports.terminate = terminate;

},{"./js/create_canvas":1,"./js/generate_id":2,"./js/pool":3,"./js/utils":6,"./js/worker.js":7,"webworkify":13}],10:[function(require,module,exports){
/*global window,document*/
'use strict';


var unsharp = require('./js/unsharp');
var generateId = require('./js/generate_id');

// shaders

var shadersContent = {};

/*eslint-disable no-path-concat*/
shadersContent['#vsh-basic'] =
  "precision highp float;\nattribute vec2 a_position;\nattribute vec2 a_texCoord;\n\nuniform vec2 u_resolution;\n\nvarying vec2 v_texCoord;\n\nvoid main() {\n   vec2 clipSpace = a_position / u_resolution * 2.0 - 1.0;\n\n   gl_Position = vec4(clipSpace, 0, 1);\n   v_texCoord = a_texCoord;\n}\n";
shadersContent['#fsh-lanczos1d-optimized-tpl'] =
  "precision highp float;\n\nvarying vec2 v_texCoord;\n\nuniform sampler2D u_image;\n\n#define addPoint(offset, kv, total)   {vec2 pos = v_texCoord + offset; gl_FragColor += texture2D(u_image, pos) * kv; total += kv; }\n\nvoid main()\n{\n__CODE__\n}\n";

// optimization

var FILTER_INFO = [
  { // Nearest neibor (Box)
    win: 0.5,
    filter: function (x) {
      return (x >= -0.5 && x < 0.5) ? 1.0 : 0.0;
    }
  },
  { // Hamming
    win: 1.0,
    filter: function (x) {
      if (x <= -1.0 || x >= 1.0) { return 0.0; }
      if (x > -1.19209290E-07 && x < 1.19209290E-07) { return 1.0; }
      var xpi = x * Math.PI;
      return ((Math.sin(xpi) / xpi) *  (0.54 + 0.46 * Math.cos(xpi / 1.0)));
    }
  },
  { // Lanczos, win = 2
    win: 2.0,
    filter: function (x) {
      if (x <= -2.0 || x >= 2.0) { return 0.0; }
      if (x > -1.19209290E-07 && x < 1.19209290E-07) { return 1.0; }
      var xpi = x * Math.PI;
      return (Math.sin(xpi) / xpi) * Math.sin(xpi / 2.0) / (xpi / 2.0);
    }
  },
  { // Lanczos, win = 3
    win: 3.0,
    filter: function (x) {
      if (x <= -3.0 || x >= 3.0) { return 0.0; }
      if (x > -1.19209290E-07 && x < 1.19209290E-07) { return 1.0; }
      var xpi = x * Math.PI;
      return (Math.sin(xpi) / xpi) * Math.sin(xpi / 3.0) / (xpi / 3.0);
    }
  }
];

// error

function error(msg) {
  try {
    (window.console.error || window.console.log).call(window.console, msg);
  } catch (__) {}
}


function checkGlError(gl) {
  var e = gl.getError();
  if (e !== gl.NO_ERROR) { throw new Error('gl error ' + e); }
}

// create

function createGl(canvas) {
  return canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
}


function createShader(gl, type, src) {
  var shader = gl.createShader(type);

  gl.shaderSource(shader, src);
  gl.compileShader(shader);

  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    error('Shader compile error: ' + gl.getShaderInfoLog(shader) + '. Source: `' + src + '`');
    gl.deleteShader(shader);
    return null;
  }

  return shader;
}

function createProgram(gl, vertexShader, fragmentShader) {
  var program = gl.createProgram();

  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);

  gl.linkProgram(program);

  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    error('Program linking error: ' + gl.getProgramInfoLog(program));
    gl.deleteProgram(program);
  }

  checkGlError(gl);
  return program;
}

// shader params

function setAttributeValues(gl, program, name, values, options) {
  var a = gl.getAttribLocation(program, name);

  gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(values), gl.STATIC_DRAW);
  gl.enableVertexAttribArray(a);
  gl.vertexAttribPointer(a, options.elementSize, gl.FLOAT, false, 0, 0);
  checkGlError(gl);
}


function setUniform1i(gl, program, name, i0) {
  var u = gl.getUniformLocation(program, name);
  gl.uniform1i(u, i0);
}


function setUniform2f(gl, program, name, f0, f1) {
  var u = gl.getUniformLocation(program, name);
  gl.uniform2f(u, f0, f1);
}

// texture

function loadTexture(gl, texUnit, data) {
  var tex = gl.createTexture();
  gl.activeTexture(gl.TEXTURE0 + texUnit);
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, data);
  checkGlError(gl);
  return tex;
}


function createTextureSize(gl, texUnit, width, height) {
  var tex = gl.createTexture();
  gl.activeTexture(gl.TEXTURE0 + texUnit);
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
  checkGlError(gl);
  return tex;
}


function setupTextureFBO(gl, texUnit, width, height) {
  var texture = createTextureSize(gl, texUnit, width, height);

  var oldFbo = gl.getParameter(gl.FRAMEBUFFER_BINDING);

  var fbo = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);

  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);

//  gl.viewport(0, 0, width, height);

  checkGlError(gl);

  return {
    fbo: fbo,
    texture: texture,
    oldFbo: oldFbo
  };
}

// process

function vec2Rectangle(x, y, w, h) {
  var x1 = x;
  var x2 = x + w;
  var y1 = y;
  var y2 = y + h;
  return [ x1, y1, x2, y1, x1, y2, x1, y2, x2, y1, x2, y2 ];
}

function generateFragmentShader(options) {
  var template = shadersContent['#fsh-lanczos1d-optimized-tpl'];

  var direction = options.direction;

  var scaleW = options.texW / options.destW,
      scaleH = options.texH / options.destH,
      scale = direction === 'horizontal' ? scaleW : scaleH;

  // filter

  var quality = 3;

  var filterFunction = FILTER_INFO[quality].filter;

  var winSize = FILTER_INFO[quality].win;

  // kernel processing

  var isHorizontal = direction === 'horizontal';

  var pixelSizeX = 1.0 / options.texW,
      pixelSizeY = 1.0 / options.texH,
      pixelSize = isHorizontal ? pixelSizeX : pixelSizeY;

  var count = Math.ceil(winSize * scale) * 2.0;

  var code = 'float total = 0.0;\ngl_FragColor = vec4(0.0);\n';

  function float(v) {
    return v.toFixed(20);
  }

  for (var i = 0; i < count + 1; i++) {
    var offset = i - count / 2.0;
    var x = (offset) / scale;
    var kv = filterFunction(x);

    var p = pixelSize * offset;
    var px = isHorizontal ? p : 0.0;
    var py = isHorizontal ? 0.0 : p;

    code += 'addPoint(vec2(' + float(px) + ', ' + float(py) + '), ' + float(kv) + ', total);\n';
  }

  code += 'gl_FragColor /= vec4(total);';

  var fragmentShader = template.replace('__CODE__', code);

  return fragmentShader;
}

function createProgramOptimized(gl, options) {
  var vertexShader = createShader(gl, gl.VERTEX_SHADER, shadersContent['#vsh-basic']);
  var fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, generateFragmentShader(options));

  return createProgram(gl, vertexShader, fragmentShader);
}

function convolveOptimized(gl, texUnit0, texW, texH, texUnit, direction, destW, destH, flipY) {

  var programOptions = {
    direction: direction,
    texW: texW,
    texH: texH,
    destW: destW,
    destH: destH
  };

  var program = createProgramOptimized(gl, programOptions);

  gl.useProgram(program);

  setUniform1i(gl, program, 'u_image', texUnit0);
//  setUniform2f(gl, program, 'u_imageSize', texWidth, texHeight);
  setUniform2f(gl, program, 'u_resolution', destW, destH);

  setAttributeValues(gl, program, 'a_texCoord',
    [ 0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1 ], { elementSize: 2 });
  setAttributeValues(gl, program, 'a_position',
    !flipY ? vec2Rectangle(0, 0, destW, destH) : vec2Rectangle(0, destH, destW, -destH), { elementSize: 2 });

  gl.viewport(0, 0, destW, destH);

  var fboObject = setupTextureFBO(gl, texUnit, destW, destH);

  gl.viewport(0, 0, destW, destH);
  gl.drawArrays(gl.TRIANGLES, 0, 6);
  gl.bindFramebuffer(gl.FRAMEBUFFER, fboObject.oldFbo);

  checkGlError(gl);

  return fboObject;
}


function webglProcessResizeOptimized(from, gl, options) {
  var srcW = from.naturalWidth || from.width,
      srcH = from.naturalHeight || from.height,
      dstW = gl.canvas.width,
      dstH = gl.canvas.height;

  var texUnit0 = 0;
  var texUnit1 = 1;
  var texUnit2 = 2;

  loadTexture(gl, texUnit0, from);

  convolveOptimized(gl, texUnit0, srcW, srcH, texUnit1, 'horizontal', dstW, srcH, false);

  var finalFboObject = convolveOptimized(gl, texUnit1, dstW, srcH, texUnit2, 'vertical', dstW, dstH, true);

  gl.flush();

  var fb = gl.createFramebuffer();

  gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, finalFboObject.texture, 0);

  var fb_status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);

  if (fb_status !== gl.FRAMEBUFFER_COMPLETE) {
    throw new Error('Bad framebuffer status: ' + fb_status);
  }

  // Clear alpha for sure, if disabled.
  if (!options.alpha) {
    gl.clearColor(1, 1, 1, 1);
    gl.colorMask(false, false, false, true);
    gl.clear(gl.COLOR_BUFFER_BIT);
  }

  var pixels = new Uint8Array(dstW * dstH * 4);

  gl.readPixels(0, 0, dstW, dstH, gl.RGBA, gl.UNSIGNED_BYTE, pixels);

  var unsharpAmount = typeof options.unsharpAmount === 'undefined' ? 0 : (options.unsharpAmount | 0);
  var unsharpRadius = typeof options.unsharpRadius === 'undefined' ? 0 : (options.unsharpRadius);
  var unsharpThreshold = typeof options.unsharpThreshold === 'undefined' ? 0 : (options.unsharpThreshold | 0);

  if (unsharpAmount) {
    unsharp(pixels, dstW, dstH, unsharpAmount, unsharpRadius, unsharpThreshold);
  }

  return pixels;
}

// exports

module.exports = function (from, to, options, callback) {
  var gl, canvas;

  try {
    // create temporarry canvas [

    canvas = document.createElement('canvas');
    canvas.id = 'pica-webgl-temporarry-canvas';
    canvas.height = to.height;
    canvas.width = to.width;
    document.body.appendChild(canvas);

    // create temporarry canvas ]

    gl = createGl(canvas);

    var data = webglProcessResizeOptimized(from, gl, options);


    gl.finish();
    document.body.removeChild(canvas);

    var ctxTo = to.getContext('2d');
    var imageDataTo = ctxTo.createImageData(to.width, to.height);

    imageDataTo.data.set(data);
    ctxTo.putImageData(imageDataTo, 0, 0);

    callback(null, data);
  } catch (e) {
    error(e);
    gl.finish();
    document.body.removeChild(canvas);
    callback(e);
  }

  return generateId();
};

module.exports.terminate = function () {};

},{"./js/generate_id":2,"./js/unsharp":5}],11:[function(require,module,exports){
// Calculate Gaussian blur of an image using IIR filter
// The method is taken from Intel's white paper and code example attached to it:
// https://software.intel.com/en-us/articles/iir-gaussian-blur-filter
// -implementation-using-intel-advanced-vector-extensions

var a0, a1, a2, a3, b1, b2, left_corner, right_corner;

function gaussCoef(sigma) {
  if (sigma < 0.5) {
    sigma = 0.5;
  }

  var a = Math.exp(0.726 * 0.726) / sigma,
      g1 = Math.exp(-a),
      g2 = Math.exp(-2 * a),
      k = (1 - g1) * (1 - g1) / (1 + 2 * a * g1 - g2);

  a0 = k;
  a1 = k * (a - 1) * g1;
  a2 = k * (a + 1) * g1;
  a3 = -k * g2;
  b1 = 2 * g1;
  b2 = -g2;
  left_corner = (a0 + a1) / (1 - b1 - b2);
  right_corner = (a2 + a3) / (1 - b1 - b2);

  // Attempt to force type to FP32.
  return new Float32Array([ a0, a1, a2, a3, b1, b2, left_corner, right_corner ]);
}

function convolveMono16(src, out, line, coeff, width, height) {
  // takes src image and writes the blurred and transposed result into out

  var prev_src, curr_src, curr_out, prev_out, prev_prev_out;
  var src_index, out_index, line_index;
  var i, j;
  var coeff_a0, coeff_a1, coeff_b1, coeff_b2;

  for (i = 0; i < height; i++) {
    src_index = i * width;
    out_index = i;
    line_index = 0;

    // left to right
    prev_src = src[src_index];
    prev_prev_out = prev_src * coeff[6];
    prev_out = prev_prev_out;

    coeff_a0 = coeff[0];
    coeff_a1 = coeff[1];
    coeff_b1 = coeff[4];
    coeff_b2 = coeff[5];

    for (j = 0; j < width; j++) {
      curr_src = src[src_index];

      curr_out = curr_src * coeff_a0 +
                 prev_src * coeff_a1 +
                 prev_out * coeff_b1 +
                 prev_prev_out * coeff_b2;

      prev_prev_out = prev_out;
      prev_out = curr_out;
      prev_src = curr_src;

      line[line_index] = prev_out;
      line_index++;
      src_index++;
    }

    src_index--;
    line_index--;
    out_index += height * (width - 1);

    // right to left
    prev_src = src[src_index];
    prev_prev_out = prev_src * coeff[7];
    prev_out = prev_prev_out;
    curr_src = prev_src;

    coeff_a0 = coeff[2];
    coeff_a1 = coeff[3];

    for (j = width - 1; j >= 0; j--) {
      curr_out = curr_src * coeff_a0 +
                 prev_src * coeff_a1 +
                 prev_out * coeff_b1 +
                 prev_prev_out * coeff_b2;

      prev_prev_out = prev_out;
      prev_out = curr_out;

      prev_src = curr_src;
      curr_src = src[src_index];

      out[out_index] = line[line_index] + prev_out;

      src_index--;
      line_index--;
      out_index -= height;
    }
  }
}


function blurMono16(src, width, height, radius) {
  // Quick exit on zero radius
  if (!radius) { return; }

  var out      = new Uint16Array(src.length),
      tmp_line = new Float32Array(Math.max(width, height));

  var coeff = gaussCoef(radius);

  convolveMono16(src, out, tmp_line, coeff, width, height, radius);
  convolveMono16(out, src, tmp_line, coeff, height, width, radius);
}

module.exports = blurMono16;

},{}],12:[function(require,module,exports){
'use strict';
/* eslint-disable no-unused-vars */
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (e) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (Object.getOwnPropertySymbols) {
			symbols = Object.getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],13:[function(require,module,exports){
var bundleFn = arguments[3];
var sources = arguments[4];
var cache = arguments[5];

var stringify = JSON.stringify;

module.exports = function (fn, options) {
    var wkey;
    var cacheKeys = Object.keys(cache);

    for (var i = 0, l = cacheKeys.length; i < l; i++) {
        var key = cacheKeys[i];
        var exp = cache[key].exports;
        // Using babel as a transpiler to use esmodule, the export will always
        // be an object with the default export as a property of it. To ensure
        // the existing api and babel esmodule exports are both supported we
        // check for both
        if (exp === fn || exp && exp.default === fn) {
            wkey = key;
            break;
        }
    }

    if (!wkey) {
        wkey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);
        var wcache = {};
        for (var i = 0, l = cacheKeys.length; i < l; i++) {
            var key = cacheKeys[i];
            wcache[key] = key;
        }
        sources[wkey] = [
            Function(['require','module','exports'], '(' + fn + ')(self)'),
            wcache
        ];
    }
    var skey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);

    var scache = {}; scache[wkey] = wkey;
    sources[skey] = [
        Function(['require'], (
            // try to call default if defined to also support babel esmodule
            // exports
            'var f = require(' + stringify(wkey) + ');' +
            '(f.default ? f.default : f)(self);'
        )),
        scache
    ];

    var workerSources = {};
    resolveSources(skey);

    function resolveSources(key) {
        workerSources[key] = true;

        for (var depPath in sources[key][1]) {
            var depKey = sources[key][1][depPath];
            if (!workerSources[depKey]) {
                resolveSources(depKey);
            }
        }
    }

    var src = '(' + bundleFn + ')({'
        + Object.keys(workerSources).map(function (key) {
            return stringify(key) + ':['
                + sources[key][0]
                + ',' + stringify(sources[key][1]) + ']'
            ;
        }).join(',')
        + '},{},[' + stringify(skey) + '])'
    ;

    var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

    var blob = new Blob([src], { type: 'text/javascript' });
    if (options && options.bare) { return blob; }
    var workerUrl = URL.createObjectURL(blob);
    var worker = new Worker(workerUrl);
    worker.objectURL = workerUrl;
    return worker;
};

},{}],"/":[function(require,module,exports){
'use strict';

/*global window, document*/
/*eslint space-infix-ops:0*/

// Feature detect
var WORKER = (typeof window !== 'undefined') && ('Worker' in window);
if (WORKER) {
  // IE don't allow to create webworkers from string. We should check it.
  // https://connect.microsoft.com/IE/feedback/details/801810/web-workers-from-blob-urls-in-ie-10-and-11
  try {
    var wkr = require('webworkify')(function () {});
    wkr.terminate();
  } catch (__) {
    WORKER = false;
  }
}

var WEBGL = false,
    __cvs;
try {
  if (typeof document !== 'undefined' &&
      typeof window !== 'undefined' &&
      window.WebGLRenderingContext) {

    __cvs = document.createElement('canvas');

    if (__cvs.getContext('webgl') || __cvs.getContext('experimental-webgl')) {
      WEBGL = true;
    }
  }
} catch (__) {
} finally {
  __cvs = null;
}

var resize_js     = require('./lib/resize_js');
var resize_js_ww  = require('./lib/resize_js_ww');
var resize_webgl  = require('./lib/resize_webgl');
var resize_array  = require('./lib/js/resize_array');
var unsharp       = require('./lib/js/unsharp');
var assign        = require('object-assign');

////////////////////////////////////////////////////////////////////////////////
// Helpers
function _class(obj) { return Object.prototype.toString.call(obj); }
function isFunction(obj) { return _class(obj) === '[object Function]'; }

////////////////////////////////////////////////////////////////////////////////
// API methods

// Canvas async resize
//
function resizeCanvas(from, to, options, callback) {
  if (isFunction(options)) {
    callback = options;
    options = {};
  }

  if (!isNaN(options)) {
    options = { quality: options, alpha: false };
  }

  // Force flag reset to simplify status check
  if (!WEBGL) { exports.WEBGL = false; }

  if (WEBGL && exports.WEBGL) {
    exports.debug('Resize canvas with WebGL');

    var id = resize_webgl(from, to, options, function (err) {
      if (err) {
        exports.debug('WebGL resize failed, do fallback and cancel next attempts');
        exports.debug(err);

        WEBGL = false;
        resizeCanvas(from, to, assign({}, options, { _id: id }), callback);
      } else {
        callback();
      }
    });
    return id;
  }

  // Force flag reset to simplify status check
  if (!WORKER) { exports.WW = false; }

  if (WORKER && exports.WW) {
    exports.debug('Resize buffer in WebWorker');

    return resize_js_ww(from, to, options, callback);
  }

  // Fallback to sync call, if WebWorkers not available
  exports.debug('Resize buffer sync (freeze event loop)');

  return resize_js(from, to, options, callback);
}

// RGBA buffer resize
//
function resizeBuffer(options, callback) {
  var _opts = {
    src:      options.src,
    dest:     options.dest,
    width:    options.width|0,
    height:   options.height|0,
    toWidth:  options.toWidth|0,
    toHeight: options.toHeight|0,
    quality:  options.quality,
    alpha:    options.alpha,
    unsharpAmount:    options.unsharpAmount,
    unsharpRadius:    options.unsharpRadius,
    unsharpThreshold: options.unsharpThreshold
  };

  _opts.dest = resize_array(_opts);

  if (_opts.unsharpAmount) {
    unsharp(_opts.dest, _opts.toWidth, _opts.toHeight,
      _opts.unsharpAmount, _opts.unsharpRadius, _opts.unsharpThreshold);
  }

  callback(null, _opts.dest);
}

function terminate(id) {
  resize_js.terminate(id);
  resize_js_ww.terminate(id);
  resize_webgl.terminate(id);
}

exports.resizeCanvas = resizeCanvas;
exports.resizeBuffer = resizeBuffer;
exports.terminate = terminate;
exports.WW = WORKER;
exports.WEBGL = false; // WEBGL;
exports.debug = function () {};

},{"./lib/js/resize_array":4,"./lib/js/unsharp":5,"./lib/resize_js":8,"./lib/resize_js_ww":9,"./lib/resize_webgl":10,"object-assign":12,"webworkify":13}]},{},[])("/")
});

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataUriToU = __webpack_require__(718);

var _dataUriToU2 = _interopRequireDefault(_dataUriToU);

var _exifComponent = __webpack_require__(719);

var _exifComponent2 = _interopRequireDefault(_exifComponent);

var _exifRotate = __webpack_require__(721);

var _exifRotate2 = _interopRequireDefault(_exifRotate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORIENTATIONS = {
  'top-left': 1,
  'top-right': 2,
  'bottom-right': 3,
  'bottom-left': 4,
  'left-top': 5,
  'right-top': 6,
  'right-bottom': 7,
  'left-bottom': 8
};

function urlToImage(url, fn) {
  var img = new Image();
  if (fn) {
    img.onload = fn.bind(null, img);
  }
  img.src = url;
  return img;
}

function fixOrientation(url, fn) {
  var buf = (0, _dataUriToU2.default)(url);
  var categories = {};
  try {
    categories = (0, _exifComponent2.default)(buf.buffer);
  } catch (err) {}

  var orientation = 0;
  if (categories.Orientation && typeof categories.Orientation.value === 'number') {
    orientation = categories.Orientation.value;
  } else if (ORIENTATIONS[categories.orientation]) {
    orientation = ORIENTATIONS[categories.orientation];
  }

  if (orientation === 0) {
    return fn(url);
  }

  urlToImage(url, function (img) {
    fn((0, _exifRotate2.default)(img, orientation));
  });
}

exports.default = fixOrientation;

/***/ }),
/* 718 */
/***/ (function(module, exports) {


/**
 * Return a `Blob` for the given data `uri`.
 *
 * @param {String} uri
 * @return {Blob}
 * @api public
 */

module.exports = function(uri){
  var data = uri.split(',')[1];
  var bytes = atob(data);
  var buf = new ArrayBuffer(bytes.length);
  var arr = new Uint8Array(buf);

  for (var i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i);
  }

  arr.type = mime(uri);
  return arr;
};

/**
 * Return data uri mime type.
 */

function mime(uri) {
  return uri.split(';')[0].slice(5);
}


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var ExifReader = __webpack_require__(720).ExifReader;

/**
 * Parse EXIF tags in `buf`.
 *
 * @param {ArrayBuffer} buf
 * @return {Object}
 * @api public
 */

module.exports = function(buf){
  var exif = new ExifReader;
  exif.load(buf);
  var tags = exif.getAllTags();
  var out = {};

  for(var tag in tags) {
    out[spaces(tag)] = tags[tag].description;
  }

  return out;
};

/**
 * Convert camel-case to lowercase words
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function spaces(str) {
  return str.replace(/([A-Z][a-z])|([a-z][A-Z])|([A-Z])/g, function(m) {
    return (1 == m.length)
      ? m.toLowerCase()
      : (m[0] == m[0].toUpperCase()) ? ' ' + m.toLowerCase() : m[0] + ' ' + m[1].toLowerCase()
  }).replace(/^\s+|\s+$/g, '');
}


/***/ }),
/* 720 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.6.2
/*
# ExifReader 1.0.1
# http://github.com/mattiasw/exifreader
# Copyright (C) 2011-2013  Mattias Wallander <mattias@wallander.eu>
# Licensed under the GNU Lesser General Public License version 3 or later
# See license text at http://www.gnu.org/licenses/lgpl.txt
*/


(function() {
  (typeof exports !== "undefined" && exports !== null ? exports : this).ExifReader = (function() {
    ExifReader.prototype._MIN_DATA_BUFFER_LENGTH = 2;

    ExifReader.prototype._JPEG_ID_SIZE = 2;

    ExifReader.prototype._JPEG_ID = 0xffd8;

    ExifReader.prototype._APP_MARKER_SIZE = 2;

    ExifReader.prototype._APP0_MARKER = 0xffe0;

    ExifReader.prototype._APP1_MARKER = 0xffe1;

    ExifReader.prototype._APP15_MARKER = 0xffef;

    ExifReader.prototype._APP_ID_OFFSET = 4;

    ExifReader.prototype._BYTES_Exif = 0x45786966;

    ExifReader.prototype._TIFF_HEADER_OFFSET = 10;

    ExifReader.prototype._BYTE_ORDER_BIG_ENDIAN = 0x4949;

    ExifReader.prototype._BYTE_ORDER_LITTLE_ENDIAN = 0x4d4d;

    function ExifReader() {
      var _this = this;

      this._getTagValueAt = {
        1: function(offset) {
          return _this._getByteAt(offset);
        },
        2: function(offset) {
          return _this._getAsciiAt(offset);
        },
        3: function(offset) {
          return _this._getShortAt(offset);
        },
        4: function(offset) {
          return _this._getLongAt(offset);
        },
        5: function(offset) {
          return _this._getRationalAt(offset);
        },
        7: function(offset) {
          return _this._getUndefinedAt(offset);
        },
        9: function(offset) {
          return _this._getSlongAt(offset);
        },
        10: function(offset) {
          return _this._getSrationalAt(offset);
        }
      };
      this._tiffHeaderOffset = 0;
    }

    /*
    # Loads all the Exif tags from the specified image file buffer.
    #
    # data ArrayBuffer Image file data
    */


    ExifReader.prototype.load = function(data) {
      return this.loadView(new DataView(data));
    };

    /*
    # Loads all the Exif tags from the specified image file buffer view. Probably
    # used when DataView isn't supported by the browser.
    #
    # @_dataView DataView Image file data view
    */


    ExifReader.prototype.loadView = function(_dataView) {
      this._dataView = _dataView;
      this._tags = {};
      this._checkImageHeader();
      return this._readTags();
    };

    ExifReader.prototype._checkImageHeader = function() {
      var dataView;

      dataView = this._dataView;
      if (dataView.byteLength < this._MIN_DATA_BUFFER_LENGTH || dataView.getUint16(0, false) !== this._JPEG_ID) {
        throw new Error('Invalid image format');
      }
      this._parseAppMarkers(dataView);
      if (!this._hasExifData()) {
        throw new Error('No Exif data');
      }
    };

    ExifReader.prototype._parseAppMarkers = function(dataView) {
      var appMarkerPosition, fieldLength, _results;

      appMarkerPosition = this._JPEG_ID_SIZE;
      _results = [];
      while (true) {
        if (dataView.byteLength < appMarkerPosition + this._APP_ID_OFFSET + 5) {
          break;
        }
        if (this._isApp1ExifMarker(dataView, appMarkerPosition)) {
          fieldLength = dataView.getUint16(appMarkerPosition + this._APP_MARKER_SIZE, false);
          this._tiffHeaderOffset = appMarkerPosition + this._TIFF_HEADER_OFFSET;
        } else if (this._isAppMarker(dataView, appMarkerPosition)) {
          fieldLength = dataView.getUint16(appMarkerPosition + this._APP_MARKER_SIZE, false);
        } else {
          break;
        }
        _results.push(appMarkerPosition += this._APP_MARKER_SIZE + fieldLength);
      }
      return _results;
    };

    ExifReader.prototype._isApp1ExifMarker = function(dataView, appMarkerPosition) {
      return dataView.getUint16(appMarkerPosition, false) === this._APP1_MARKER && dataView.getUint32(appMarkerPosition + this._APP_ID_OFFSET, false) === this._BYTES_Exif && dataView.getUint8(appMarkerPosition + this._APP_ID_OFFSET + 4, false) === 0x00;
    };

    ExifReader.prototype._isAppMarker = function(dataView, appMarkerPosition) {
      var appMarker;

      appMarker = dataView.getUint16(appMarkerPosition, false);
      return appMarker >= this._APP0_MARKER && appMarker <= this._APP15_MARKER;
    };

    ExifReader.prototype._hasExifData = function() {
      return this._tiffHeaderOffset !== 0;
    };

    ExifReader.prototype._readTags = function() {
      this._setByteOrder();
      this._read0thIfd();
      this._readExifIfd();
      this._readGpsIfd();
      return this._readInteroperabilityIfd();
    };

    ExifReader.prototype._setByteOrder = function() {
      if (this._dataView.getUint16(this._tiffHeaderOffset) === this._BYTE_ORDER_BIG_ENDIAN) {
        return this._littleEndian = true;
      } else if (this._dataView.getUint16(this._tiffHeaderOffset) === this._BYTE_ORDER_LITTLE_ENDIAN) {
        return this._littleEndian = false;
      } else {
        throw new Error('Illegal byte order value. Faulty image.');
      }
    };

    ExifReader.prototype._read0thIfd = function() {
      var ifdOffset;

      ifdOffset = this._getIfdOffset();
      return this._readIfd('0th', ifdOffset);
    };

    ExifReader.prototype._getIfdOffset = function() {
      return this._tiffHeaderOffset + this._getLongAt(this._tiffHeaderOffset + 4);
    };

    ExifReader.prototype._readExifIfd = function() {
      var ifdOffset;

      if (this._tags['Exif IFD Pointer'] != null) {
        ifdOffset = this._tiffHeaderOffset + this._tags['Exif IFD Pointer'].value;
        return this._readIfd('exif', ifdOffset);
      }
    };

    ExifReader.prototype._readGpsIfd = function() {
      var ifdOffset;

      if (this._tags['GPS Info IFD Pointer'] != null) {
        ifdOffset = this._tiffHeaderOffset + this._tags['GPS Info IFD Pointer'].value;
        return this._readIfd('gps', ifdOffset);
      }
    };

    ExifReader.prototype._readInteroperabilityIfd = function() {
      var ifdOffset;

      if (this._tags['Interoperability IFD Pointer'] != null) {
        ifdOffset = this._tiffHeaderOffset + this._tags['Interoperability IFD Pointer'].value;
        return this._readIfd('interoperability', ifdOffset);
      }
    };

    ExifReader.prototype._readIfd = function(ifdType, offset) {
      var fieldIndex, numberOfFields, tag, _i, _results;

      numberOfFields = this._getShortAt(offset);
      offset += 2;
      _results = [];
      for (fieldIndex = _i = 0; 0 <= numberOfFields ? _i < numberOfFields : _i > numberOfFields; fieldIndex = 0 <= numberOfFields ? ++_i : --_i) {
        tag = this._readTag(ifdType, offset);
        this._tags[tag.name] = {
          'value': tag.value,
          'description': tag.description
        };
        _results.push(offset += 12);
      }
      return _results;
    };

    ExifReader.prototype._readTag = function(ifdType, offset) {
      var tagCode, tagCount, tagDescription, tagName, tagType, tagValue, tagValueOffset;

      tagCode = this._getShortAt(offset);
      tagType = this._getShortAt(offset + 2);
      tagCount = this._getLongAt(offset + 4);
      if (this._typeSizes[tagType] * tagCount <= 4) {
        tagValue = this._getTagValue(offset + 8, tagType, tagCount);
      } else {
        tagValueOffset = this._getLongAt(offset + 8);
        tagValue = this._getTagValue(this._tiffHeaderOffset + tagValueOffset, tagType, tagCount);
      }
      if (tagType === this._tagTypes['ASCII']) {
        tagValue = this._splitNullSeparatedAsciiString(tagValue);
      }
      if (this._tagNames[ifdType][tagCode] != null) {
        if ((this._tagNames[ifdType][tagCode]['name'] != null) && (this._tagNames[ifdType][tagCode]['description'] != null)) {
          tagName = this._tagNames[ifdType][tagCode]['name'];
          tagDescription = this._tagNames[ifdType][tagCode]['description'](tagValue);
        } else {
          tagName = this._tagNames[ifdType][tagCode];
          if (tagValue instanceof Array) {
            tagDescription = tagValue.join(', ');
          } else {
            tagDescription = tagValue;
          }
        }
        return {
          'name': tagName,
          'value': tagValue,
          'description': tagDescription
        };
      } else {
        return {
          'name': "undefined-" + tagCode,
          'value': tagValue,
          'description': tagValue
        };
      }
    };

    ExifReader.prototype._getTagValue = function(offset, type, count) {
      var tagValue, value, valueIndex;

      value = (function() {
        var _i, _results;

        _results = [];
        for (valueIndex = _i = 0; 0 <= count ? _i < count : _i > count; valueIndex = 0 <= count ? ++_i : --_i) {
          tagValue = this._getTagValueAt[type](offset);
          offset += this._typeSizes[type];
          _results.push(tagValue);
        }
        return _results;
      }).call(this);
      if (value.length === 1) {
        value = value[0];
      } else if (type === this._tagTypes['ASCII']) {
        value = this._getAsciiValue(value);
      }
      return value;
    };

    ExifReader.prototype._getAsciiValue = function(charArray) {
      var charCode, newCharArray;

      return newCharArray = (function() {
        var _i, _len, _results;

        _results = [];
        for (_i = 0, _len = charArray.length; _i < _len; _i++) {
          charCode = charArray[_i];
          _results.push(String.fromCharCode(charCode));
        }
        return _results;
      })();
    };

    ExifReader.prototype._getByteAt = function(offset) {
      return this._dataView.getUint8(offset);
    };

    ExifReader.prototype._getAsciiAt = function(offset) {
      return this._dataView.getUint8(offset);
    };

    ExifReader.prototype._getShortAt = function(offset) {
      return this._dataView.getUint16(offset, this._littleEndian);
    };

    ExifReader.prototype._getLongAt = function(offset) {
      return this._dataView.getUint32(offset, this._littleEndian);
    };

    ExifReader.prototype._getRationalAt = function(offset) {
      return this._getLongAt(offset) / this._getLongAt(offset + 4);
    };

    ExifReader.prototype._getUndefinedAt = function(offset) {
      return this._getByteAt(offset);
    };

    ExifReader.prototype._getSlongAt = function(offset) {
      return this._dataView.getInt32(offset, this._littleEndian);
    };

    ExifReader.prototype._getSrationalAt = function(offset) {
      return this._getSlongAt(offset) / this._getSlongAt(offset + 4);
    };

    ExifReader.prototype._splitNullSeparatedAsciiString = function(string) {
      var character, i, tagValue, _i, _len;

      tagValue = [];
      i = 0;
      for (_i = 0, _len = string.length; _i < _len; _i++) {
        character = string[_i];
        if (character === '\x00') {
          i++;
          continue;
        }
        if (tagValue[i] == null) {
          tagValue[i] = '';
        }
        tagValue[i] += character;
      }
      return tagValue;
    };

    ExifReader.prototype._typeSizes = {
      1: 1,
      2: 1,
      3: 2,
      4: 4,
      5: 8,
      7: 1,
      9: 4,
      10: 8
    };

    ExifReader.prototype._tagTypes = {
      'BYTE': 1,
      'ASCII': 2,
      'SHORT': 3,
      'LONG': 4,
      'RATIONAL': 5,
      'UNDEFINED': 7,
      'SLONG': 9,
      'SRATIONAL': 10
    };

    ExifReader.prototype._tagNames = {
      '0th': {
        0x0100: 'ImageWidth',
        0x0101: 'ImageLength',
        0x0102: 'BitsPerSample',
        0x0103: 'Compression',
        0x0106: 'PhotometricInterpretation',
        0x010e: 'ImageDescription',
        0x010f: 'Make',
        0x0110: 'Model',
        0x0111: 'StripOffsets',
        0x0112: {
          'name': 'Orientation',
          'description': function(value) {
            switch (value) {
              case 1:
                return 'top-left';
              case 2:
                return 'top-right';
              case 3:
                return 'bottom-right';
              case 4:
                return 'bottom-left';
              case 5:
                return 'left-top';
              case 6:
                return 'right-top';
              case 7:
                return 'right-bottom';
              case 8:
                return 'left-bottom';
              default:
                return 'Undefined';
            }
          }
        },
        0x0115: 'SamplesPerPixel',
        0x0116: 'RowsPerStrip',
        0x0117: 'StripByteCounts',
        0x011a: 'XResolution',
        0x011b: 'YResolution',
        0x011c: 'PlanarConfiguration',
        0x0128: {
          'name': 'ResolutionUnit',
          'description': function(value) {
            switch (value) {
              case 2:
                return 'inches';
              case 3:
                return 'centimeters';
              default:
                return 'Unknown';
            }
          }
        },
        0x012d: 'TransferFunction',
        0x0131: 'Software',
        0x0132: 'DateTime',
        0x013b: 'Artist',
        0x013e: 'WhitePoint',
        0x013f: 'PrimaryChromaticities',
        0x0201: 'JPEGInterchangeFormat',
        0x0202: 'JPEGInterchangeFormatLength',
        0x0211: 'YCbCrCoefficients',
        0x0212: 'YCbCrSubSampling',
        0x0213: {
          'name': 'YCbCrPositioning',
          'description': function(value) {
            switch (value) {
              case 1:
                return 'centered';
              case 2:
                return 'co-sited';
              default:
                return 'undefied ' + value;
            }
          }
        },
        0x0214: 'ReferenceBlackWhite',
        0x8298: {
          'name': 'Copyright',
          'description': function(value) {
            return value.join('; ');
          }
        },
        0x8769: 'Exif IFD Pointer',
        0x8825: 'GPS Info IFD Pointer'
      },
      'exif': {
        0x829a: 'ExposureTime',
        0x829d: 'FNumber',
        0x8822: {
          'name': 'ExposureProgram',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Undefined';
              case 1:
                return 'Manual';
              case 2:
                return 'Normal program';
              case 3:
                return 'Aperture priority';
              case 4:
                return 'Shutter priority';
              case 5:
                return 'Creative program';
              case 6:
                return 'Action program';
              case 7:
                return 'Portrait mode';
              case 8:
                return 'Landscape mode';
              default:
                return 'Unknown';
            }
          }
        },
        0x8824: 'SpectralSensitivity',
        0x8827: 'ISOSpeedRatings',
        0x8828: {
          'name': 'OECF',
          'description': function(value) {
            return '[Raw OECF table data]';
          }
        },
        0x9000: {
          'name': 'ExifVersion',
          'description': function(value) {
            var charCode, string, _i, _len;

            string = '';
            for (_i = 0, _len = value.length; _i < _len; _i++) {
              charCode = value[_i];
              string += String.fromCharCode(charCode);
            }
            return string;
          }
        },
        0x9003: 'DateTimeOriginal',
        0x9004: 'DateTimeDigitized',
        0x9101: {
          'name': 'ComponentsConfiguration',
          'description': function(value) {
            var character, string, _i, _len;

            string = '';
            for (_i = 0, _len = value.length; _i < _len; _i++) {
              character = value[_i];
              switch (character) {
                case 0x31:
                  string += 'Y';
                  break;
                case 0x32:
                  string += 'Cb';
                  break;
                case 0x33:
                  string += 'Cr';
                  break;
                case 0x34:
                  string += 'R';
                  break;
                case 0x35:
                  string += 'G';
                  break;
                case 0x36:
                  string += 'B';
              }
            }
            return string;
          }
        },
        0x9102: 'CompressedBitsPerPixel',
        0x9201: 'ShutterSpeedValue',
        0x9202: 'ApertureValue',
        0x9203: 'BrightnessValue',
        0x9204: 'ExposureBiasValue',
        0x9205: 'MaxApertureValue',
        0x9206: 'SubjectDistance',
        0x9207: {
          'name': 'MeteringMode',
          'description': function(value) {
            switch (value) {
              case 1:
                return 'Average';
              case 2:
                return 'CenterWeightedAverage';
              case 3:
                return 'Spot';
              case 4:
                return 'MultiSpot';
              case 5:
                return 'Pattern';
              case 6:
                return 'Partial';
              case 255:
                return 'Other';
              default:
                return 'Unknown';
            }
          }
        },
        0x9208: {
          'name': 'LightSource',
          'description': function(value) {
            switch (value) {
              case 1:
                return 'Daylight';
              case 2:
                return 'Fluorescent';
              case 3:
                return 'Tungsten (incandescent light)';
              case 4:
                return 'Flash';
              case 9:
                return 'Fine weather';
              case 10:
                return 'Cloudy weather';
              case 11:
                return 'Shade';
              case 12:
                return 'Daylight fluorescent (D 5700 – 7100K)';
              case 13:
                return 'Day white fluorescent (N 4600 – 5400K)';
              case 14:
                return 'Cool white fluorescent (W 3900 – 4500K)';
              case 15:
                return 'White fluorescent (WW 3200 – 3700K)';
              case 17:
                return 'Standard light A';
              case 18:
                return 'Standard light B';
              case 19:
                return 'Standard light C';
              case 20:
                return 'D55';
              case 21:
                return 'D65';
              case 22:
                return 'D75';
              case 23:
                return 'D50';
              case 24:
                return 'ISO studio tungsten';
              case 255:
                return 'Other light source';
              default:
                return 'Unknown';
            }
          }
        },
        0x9209: {
          'name': 'Flash',
          'description': function(value) {
            switch (value) {
              case 0x00:
                return 'Flash did not fire';
              case 0x01:
                return 'Flash fired';
              case 0x05:
                return 'Strobe return light not detected';
              case 0x07:
                return 'Strobe return light detected';
              case 0x09:
                return 'Flash fired, compulsory flash mode';
              case 0x0d:
                return 'Flash fired, compulsory flash mode, return light not detected';
              case 0x0f:
                return 'Flash fired, compulsory flash mode, return light detected';
              case 0x10:
                return 'Flash did not fire, compulsory flash mode';
              case 0x18:
                return 'Flash did not fire, auto mode';
              case 0x19:
                return 'Flash fired, auto mode';
              case 0x1d:
                return 'Flash fired, auto mode, return light not detected';
              case 0x1f:
                return 'Flash fired, auto mode, return light detected';
              case 0x20:
                return 'No flash function';
              case 0x41:
                return 'Flash fired, red-eye reduction mode';
              case 0x45:
                return 'Flash fired, red-eye reduction mode, return light not detected';
              case 0x47:
                return 'Flash fired, red-eye reduction mode, return light detected';
              case 0x49:
                return 'Flash fired, compulsory flash mode, red-eye reduction mode';
              case 0x4d:
                return 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected';
              case 0x4f:
                return 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected';
              case 0x59:
                return 'Flash fired, auto mode, red-eye reduction mode';
              case 0x5d:
                return 'Flash fired, auto mode, return light not detected, red-eye reduction mode';
              case 0x5f:
                return 'Flash fired, auto mode, return light detected, red-eye reduction mode';
              default:
                return 'Unknown';
            }
          }
        },
        0x920a: 'FocalLength',
        0x9214: {
          'name': 'SubjectArea',
          'description': function(value) {
            switch (value.length) {
              case 2:
                return "Location; X: " + value[0] + ", Y: " + value[1];
              case 3:
                return "Circle; X: " + value[0] + ", Y: " + value[1] + ", diameter: " + value[2];
              case 4:
                return "Rectangle; X: " + value[0] + ", Y: " + value[1] + ", width: " + value[2] + ", height: " + value[3];
              default:
                return 'Unknown';
            }
          }
        },
        0x927c: {
          'name': 'MakerNote',
          'description': function(value) {
            return '[Raw maker note data]';
          }
        },
        0x9286: {
          'name': 'UserComment',
          'description': function(value) {
            switch (value.slice(0, 8).map(function(charCode) {
                  return String.fromCharCode(charCode);
                }).join('')) {
              case 'ASCII\x00\x00\x00':
                return value.slice(8, value.length).map(function(charCode) {
                  return String.fromCharCode(charCode);
                }).join('');
              case 'JIS\x00\x00\x00\x00\x00':
                return '[JIS encoded text]';
              case 'UNICODE\x00':
                return '[Unicode encoded text]';
              case '\x00\x00\x00\x00\x00\x00\x00\x00':
                return '[Undefined encoding]';
            }
          }
        },
        0x9290: 'SubSecTime',
        0x9291: 'SubSecTimeOriginal',
        0x9292: 'SubSecTimeDigitized',
        0xa000: {
          'name': 'FlashpixVersion',
          'description': function(value) {
            var charCode, string, _i, _len;

            string = '';
            for (_i = 0, _len = value.length; _i < _len; _i++) {
              charCode = value[_i];
              string += String.fromCharCode(charCode);
            }
            return string;
          }
        },
        0xa001: {
          'name': 'ColorSpace',
          'description': function(value) {
            switch (value) {
              case 1:
                return 'sRGB';
              case 0xffff:
                return 'Uncalibrated';
              default:
                return 'Unknown';
            }
          }
        },
        0xa002: 'PixelXDimension',
        0xa003: 'PixelYDimension',
        0xa004: 'RelatedSoundFile',
        0xa005: 'Interoperability IFD Pointer',
        0xa20b: 'FlashEnergy',
        0xa20c: {
          'name': 'SpatialFrequencyResponse',
          'description': function(value) {
            return '[Raw SFR table data]';
          }
        },
        0xa20e: 'FocalPlaneXResolution',
        0xa20f: 'FocalPlaneYResolution',
        0xa210: {
          'name': 'FocalPlaneResolutionUnit',
          'description': function(value) {
            switch (value) {
              case 2:
                return 'inches';
              case 3:
                return 'centimeters';
              default:
                return 'Unknown';
            }
          }
        },
        0xa214: {
          'name': 'SubjectLocation',
          'description': function(value) {
            return "X: " + value[0] + ", Y: " + value[1];
          }
        },
        0xa215: 'ExposureIndex',
        0xa217: {
          'name': 'SensingMethod',
          'description': function(value) {
            switch (value) {
              case 1:
                return 'Undefined';
              case 2:
                return 'One-chip color area sensor';
              case 3:
                return 'Two-chip color area sensor';
              case 4:
                return 'Three-chip color area sensor';
              case 5:
                return 'Color sequential area sensor';
              case 7:
                return 'Trilinear sensor';
              case 8:
                return 'Color sequential linear sensor';
              default:
                return 'Unknown';
            }
          }
        },
        0xa300: {
          'name': 'FileSource',
          'description': function(value) {
            switch (value) {
              case 3:
                return 'DSC';
              default:
                return 'Unknown';
            }
          }
        },
        0xa301: {
          'name': 'SceneType',
          'description': function(value) {
            switch (value) {
              case 1:
                return 'A directly photographed image';
              default:
                return 'Unknown';
            }
          }
        },
        0xa302: {
          'name': 'CFAPattern',
          'description': function(value) {
            return '[Raw CFA pattern table data]';
          }
        },
        0xa401: {
          'name': 'CustomRendered',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Normal process';
              case 1:
                return 'Custom process';
              default:
                return 'Unknown';
            }
          }
        },
        0xa402: {
          'name': 'ExposureMode',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Auto exposure';
              case 1:
                return 'Manual exposure';
              case 2:
                return 'Auto bracket';
              default:
                return 'Unknown';
            }
          }
        },
        0xa403: {
          'name': 'WhiteBalance',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Auto white balance';
              case 1:
                return 'Manual white balance';
              default:
                return 'Unknown';
            }
          }
        },
        0xa404: {
          'name': 'DigitalZoomRatio',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Digital zoom was not used';
              default:
                return value;
            }
          }
        },
        0xa405: {
          'name': 'FocalLengthIn35mmFilm',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Unknown';
              default:
                return value;
            }
          }
        },
        0xa406: {
          'name': 'SceneCaptureType',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Standard';
              case 1:
                return 'Landscape';
              case 2:
                return 'Portrait';
              case 3:
                return 'Night scene';
              default:
                return 'Unknown';
            }
          }
        },
        0xa407: {
          'name': 'GainControl',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'None';
              case 1:
                return 'Low gain up';
              case 2:
                return 'High gain up';
              case 3:
                return 'Low gain down';
              case 4:
                return 'High gain down';
              default:
                return 'Unknown';
            }
          }
        },
        0xa408: {
          'name': 'Contrast',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Normal';
              case 1:
                return 'Soft';
              case 2:
                return 'Hard';
              default:
                return 'Unknown';
            }
          }
        },
        0xa409: {
          'name': 'Saturation',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Normal';
              case 1:
                return 'Low saturation';
              case 2:
                return 'High saturation';
              default:
                return 'Unknown';
            }
          }
        },
        0xa40a: {
          'name': 'Sharpness',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Normal';
              case 1:
                return 'Soft';
              case 2:
                return 'Hard';
              default:
                return 'Unknown';
            }
          }
        },
        0xa40b: {
          'name': 'DeviceSettingDescription',
          'description': function(value) {
            return '[Raw device settings table data]';
          }
        },
        0xa40c: {
          'name': 'SubjectDistanceRange',
          'description': function(value) {
            switch (value) {
              case 1:
                return 'Macro';
              case 2:
                return 'Close view';
              case 3:
                return 'Distant view';
              default:
                return 'Unknown';
            }
          }
        },
        0xa420: 'ImageUniqueID'
      },
      'gps': {
        0x0000: {
          'name': 'GPSVersionID',
          'description': function(value) {
            var _ref, _ref1;

            if ((value[0] === (_ref = value[1]) && _ref === 2) && (value[2] === (_ref1 = value[3]) && _ref1 === 0)) {
              return 'Version 2.2';
            } else {
              return 'Unknown';
            }
          }
        },
        0x0001: {
          'name': 'GPSLatitudeRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'N':
                return 'North latitude';
              case 'S':
                return 'South latitude';
              default:
                return 'Unknown';
            }
          }
        },
        0x0002: {
          'name': 'GPSLatitude',
          'description': function(value) {
            return value[0] + value[1] / 60 + value[2] / 3600;
          }
        },
        0x0003: {
          'name': 'GPSLongitudeRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'E':
                return 'East longitude';
              case 'W':
                return 'West longitude';
              default:
                return 'Unknown';
            }
          }
        },
        0x0004: {
          'name': 'GPSLongitude',
          'description': function(value) {
            return value[0] + value[1] / 60 + value[2] / 3600;
          }
        },
        0x0005: {
          'name': 'GPSAltitudeRef',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Sea level';
              case 1:
                return 'Sea level reference (negative value)';
              default:
                return 'Unknown';
            }
          }
        },
        0x0006: {
          'name': 'GPSAltitude',
          'description': function(value) {
            return value + ' m';
          }
        },
        0x0007: {
          'name': 'GPSTimeStamp',
          'description': function(value) {
            var padZero;

            padZero = function(num) {
              var i;

              return ((function() {
                var _i, _ref, _results;

                _results = [];
                for (i = _i = 0, _ref = 2 - ('' + Math.floor(num)).length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
                  _results.push('0');
                }
                return _results;
              })()) + num;
            };
            return value.map(padZero).join(':');
          }
        },
        0x0008: 'GPSSatellites',
        0x0009: {
          'name': 'GPSStatus',
          'description': function(value) {
            switch (value.join('')) {
              case 'A':
                return 'Measurement in progress';
              case 'V':
                return 'Measurement Interoperability';
              default:
                return 'Unknown';
            }
          }
        },
        0x000a: {
          'name': 'GPSMeasureMode',
          'description': function(value) {
            switch (value.join('')) {
              case '2':
                return '2-dimensional measurement';
              case '3':
                return '3-dimensional measurement';
              default:
                return 'Unknown';
            }
          }
        },
        0x000b: 'GPSDOP',
        0x000c: {
          'name': 'GPSSpeedRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'K':
                return 'Kilometers per hour';
              case 'M':
                return 'Miles per hour';
              case 'N':
                return 'Knots';
              default:
                return 'Unknown';
            }
          }
        },
        0x000d: 'GPSSpeed',
        0x000e: {
          'name': 'GPSTrackRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'T':
                return 'True direction';
              case 'M':
                return 'Magnetic direction';
              default:
                return 'Unknown';
            }
          }
        },
        0x000f: 'GPSTrack',
        0x0010: {
          'name': 'GPSImgDirectionRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'T':
                return 'True direction';
              case 'M':
                return 'Magnetic direction';
              default:
                return 'Unknown';
            }
          }
        },
        0x0011: 'GPSImgDirection',
        0x0012: 'GPSMapDatum',
        0x0013: {
          'name': 'GPSDestLatitudeRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'N':
                return 'North latitude';
              case 'S':
                return 'South latitude';
              default:
                return 'Unknown';
            }
          }
        },
        0x0014: {
          'name': 'GPSDestLatitude',
          'description': function(value) {
            return value[0] + value[1] / 60 + value[2] / 3600;
          }
        },
        0x0015: {
          'name': 'GPSDestLongitudeRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'E':
                return 'East longitude';
              case 'W':
                return 'West longitude';
              default:
                return 'Unknown';
            }
          }
        },
        0x0016: {
          'name': 'GPSDestLongitude',
          'description': function(value) {
            return value[0] + value[1] / 60 + value[2] / 3600;
          }
        },
        0x0017: {
          'name': 'GPSDestBearingRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'T':
                return 'True direction';
              case 'M':
                return 'Magnetic direction';
              default:
                return 'Unknown';
            }
          }
        },
        0x0018: 'GPSDestBearing',
        0x0019: {
          'name': 'GPSDestDistanceRef',
          'description': function(value) {
            switch (value.join('')) {
              case 'K':
                return 'Kilometers';
              case 'M':
                return 'Miles';
              case 'N':
                return 'Knots';
              default:
                return 'Unknown';
            }
          }
        },
        0x001a: 'GPSDestDistance',
        0x001b: {
          'name': 'GPSProcessingMethod',
          'description': function(value) {
            switch (value.slice(0, 8).map(function(charCode) {
                  return String.fromCharCode(charCode);
                }).join('')) {
              case 'ASCII\x00\x00\x00':
                return value.slice(8, value.length).map(function(charCode) {
                  return String.fromCharCode(charCode);
                }).join('');
              case 'JIS\x00\x00\x00\x00\x00':
                return '[JIS encoded text]';
              case 'UNICODE\x00':
                return '[Unicode encoded text]';
              case '\x00\x00\x00\x00\x00\x00\x00\x00':
                return '[Undefined encoding]';
            }
          }
        },
        0x001c: {
          'name': 'GPSAreaInformation',
          'description': function(value) {
            switch (value.slice(0, 8).map(function(charCode) {
                  return String.fromCharCode(charCode);
                }).join('')) {
              case 'ASCII\x00\x00\x00':
                return value.slice(8, value.length).map(function(charCode) {
                  return String.fromCharCode(charCode);
                }).join('');
              case 'JIS\x00\x00\x00\x00\x00':
                return '[JIS encoded text]';
              case 'UNICODE\x00':
                return '[Unicode encoded text]';
              case '\x00\x00\x00\x00\x00\x00\x00\x00':
                return '[Undefined encoding]';
            }
          }
        },
        0x001d: 'GPSDateStamp',
        0x001e: {
          'name': 'GPSDifferential',
          'description': function(value) {
            switch (value) {
              case 0:
                return 'Measurement without differential correction';
              case 1:
                return 'Differential correction applied';
              default:
                return 'Unknown';
            }
          }
        }
      },
      'interoperability': {
        0x0001: 'InteroperabilityIndex',
        0x0002: 'UnknownInteroperabilityTag0x0002',
        0x1001: 'UnknownInteroperabilityTag0x1001',
        0x1002: 'UnknownInteroperabilityTag0x1002'
      }
    };

    /*
    # Gets the image's value of the tag with the given name.
    #
    # name string The name of the tag to get the value of
    #
    # Returns the value of the tag with the given name if it exists,
    # otherwise throws "Undefined".
    */


    ExifReader.prototype.getTagValue = function(name) {
      if (this._tags[name] != null) {
        return this._tags[name].value;
      } else {
        return void 0;
      }
    };

    /*
    # Gets the image's description of the tag with the given name.
    #
    # name string The name of the tag to get the description of
    #
    # Returns the description of the tag with the given name if it exists,
    # otherwise throws "Undefined".
    */


    ExifReader.prototype.getTagDescription = function(name) {
      if (this._tags[name] != null) {
        return this._tags[name].description;
      } else {
        return void 0;
      }
    };

    /*
    # Gets all the image's tags.
    #
    # Returns the image's tags as an associative array: name -> description.
    */


    ExifReader.prototype.getAllTags = function() {
      return this._tags;
    };

    return ExifReader;

  })();

}).call(this);


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rotateComponent = __webpack_require__(722);

var _rotateComponent2 = _interopRequireDefault(_rotateComponent);

var _flipComponent = __webpack_require__(723);

var _flipComponent2 = _interopRequireDefault(_flipComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORIENTATIONS = [{ op: 'none', degrees: 0 }, { op: 'flip-x', degrees: 0 }, { op: 'none', degrees: 180 }, { op: 'flip-y', degrees: 0 }, { op: 'flip-x', degrees: 90 }, { op: 'none', degrees: 90 }, { op: 'flip-x', degrees: -90 }, { op: 'none', degrees: -90 }];

/**
 * Rotate `img` with orientation `n` when necessary.
 *
 * The `img` dimensions are updated as necessary to
 * reflect the rotation applied.
 *
 * @param {Image} img
 * @param {Number} n
 * @return {String} data uri
 */
function orient(img, n) {
  var o = ORIENTATIONS[n - 1];

  // canvas
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');

  // dims
  if (rotated(n)) {
    canvas.height = img.width;
    canvas.width = img.height;
  } else {
    canvas.width = img.width;
    canvas.height = img.height;
  }

  // flip
  if (o.op === 'flip-x') {
    (0, _flipComponent2.default)(canvas, true, false);
  }
  if (o.op === 'flip-y') {
    (0, _flipComponent2.default)(canvas, false, true);
  }

  // rotate
  if (o.degrees) {
    (0, _rotateComponent2.default)(ctx, {
      degrees: o.degrees,
      x: canvas.width / 2,
      y: canvas.height / 2
    });

    if (rotated(n)) {
      var d = canvas.width - canvas.height;
      ctx.translate(d / 2, -d / 2);
    }
  }

  ctx.drawImage(img, 0, 0);
  return canvas.toDataURL('image/jpeg');
}

/**
 * Check if we need to change dims.
 */
function rotated(n) {
  return [5, 6, 7, 8].indexOf(n) > -1;
}

exports.default = orient;

/***/ }),
/* 722 */
/***/ (function(module, exports) {


module.exports = function(ctx, o){
  var x = o.x || 0;
  var y = o.y || 0;

  if (o.degrees) {
    o.radians = o.degrees * (Math.PI / 180);
  }

  ctx.translate(x, y);
  ctx.rotate(o.radians);
  ctx.translate(-x, -y);
};


/***/ }),
/* 723 */
/***/ (function(module, exports) {


module.exports = function(canvas, x, y){
  var ctx = canvas.getContext('2d');

  ctx.translate(
    x ? canvas.width : 0,
    y ? canvas.height : 0);

  ctx.scale(
    x ? -1 : 1,
    y ? -1 : 1);
};


/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flexContainer":"pVQHD","buttons":"_3nOti","button":"_1DQF9"};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _buttons = __webpack_require__(53);

var _textEditorButtonGroup = __webpack_require__(229);

var _textEditorButtonGroup2 = _interopRequireDefault(_textEditorButtonGroup);

var _textEditorMediaButtons = __webpack_require__(726);

var _textEditorMediaButtons2 = _interopRequireDefault(_textEditorMediaButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTONS = [_buttons.BUTTON_IMAGE, _buttons.BUTTON_VIDEO];

var TextEditorMediaButtons = function TextEditorMediaButtons(_ref) {
  var identifier = _ref.identifier,
      theme = _ref.theme;
  return _react2.default.createElement(_textEditorButtonGroup2.default, {
    buttons: BUTTONS,
    containerClassName: (0, _classnames2.default)(_textEditorMediaButtons2.default.buttons, 'text-editor-media-buttons'),
    buttonClassName: _textEditorMediaButtons2.default.button,
    identifier: identifier,
    theme: theme
  });
};

TextEditorMediaButtons.propTypes = {
  identifier: _propTypes2.default.string.isRequired,
  theme: _propTypes2.default.object.isRequired
};

exports.default = TextEditorMediaButtons;

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"_1lovc","button":"_3rs_0"};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _draftJsPluginsEditor = __webpack_require__(340);

var _draftJsPluginsEditor2 = _interopRequireDefault(_draftJsPluginsEditor);

var _draftJsDragNDropPlugin = __webpack_require__(341);

var _draftJsDragNDropPlugin2 = _interopRequireDefault(_draftJsDragNDropPlugin);

var _decorateComponentWithProps = __webpack_require__(51);

var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);

var _textEditorImage = __webpack_require__(343);

var _textEditorImage2 = _interopRequireDefault(_textEditorImage);

var _textEditorVideoEmbed = __webpack_require__(345);

var _textEditorVideoEmbed2 = _interopRequireDefault(_textEditorVideoEmbed);

var _textEditorHashtag = __webpack_require__(347);

var _textEditorHashtag2 = _interopRequireDefault(_textEditorHashtag);

var _experiments = __webpack_require__(32);

var _wixParams = __webpack_require__(24);

var _withSettingsColor = __webpack_require__(68);

var _withSettingsColor2 = _interopRequireDefault(_withSettingsColor);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _image = __webpack_require__(348);

var _image2 = _interopRequireDefault(_image);

var _videoEmbed = __webpack_require__(349);

var _videoEmbed2 = _interopRequireDefault(_videoEmbed);

var _mediaBlock = __webpack_require__(350);

var _mediaBlock2 = _interopRequireDefault(_mediaBlock);

var _codeBlock = __webpack_require__(354);

var _codeBlock2 = _interopRequireDefault(_codeBlock);

var _hashtag = __webpack_require__(240);

var _hashtag2 = _interopRequireDefault(_hashtag);

var _textEditorUtils = __webpack_require__(66);

var _createTextEditorDecorator = __webpack_require__(360);

var _createTextEditorDecorator2 = _interopRequireDefault(_createTextEditorDecorator);

var _createBlockRenderMap = __webpack_require__(361);

var _createBlockRenderMap2 = _interopRequireDefault(_createBlockRenderMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftRenderer = function (_Component) {
  _inherits(DraftRenderer, _Component);

  function DraftRenderer(props) {
    _classCallCheck(this, DraftRenderer);

    var _this = _possibleConstructorReturn(this, (DraftRenderer.__proto__ || Object.getPrototypeOf(DraftRenderer)).call(this, props));

    _this.state = {};

    _this.handleChange = function (editorState) {
      return _this.setState({
        editorState: editorState
      });
    };

    var atomicBlockPlugin = (0, _mediaBlock2.default)(_extends({
      theme: (0, _lodash.get)(props.theme, 'mediaBlock')
    }, (0, _lodash.get)(props.config, 'mediaBlock')));
    _this.MediaBlockEditor = atomicBlockPlugin.MediaBlockEditor;

    var dndPlugin = (0, _draftJsDragNDropPlugin2.default)();

    var imagePlugin = (0, _image2.default)({
      Image: (0, _decorateComponentWithProps2.default)(_textEditorImage2.default, {
        isPublic: props.isPublic
      }),
      decorator: (0, _draftJsPluginsEditor.composeDecorators)(atomicBlockPlugin.decorator, dndPlugin.decorator)
    });

    var videoEmbedPlugin = (0, _videoEmbed2.default)({
      VideoEmbed: _textEditorVideoEmbed2.default,
      decorator: (0, _draftJsPluginsEditor.composeDecorators)(atomicBlockPlugin.decorator, dndPlugin.decorator)
    });

    _this.plugins = [atomicBlockPlugin, dndPlugin, imagePlugin, videoEmbedPlugin];
    _this.blockRenderMap = (0, _createBlockRenderMap2.default)({ titleTheme: (0, _lodash.get)(props.theme, 'title') });

    if (props.isCodeBlockEnabled) {
      _this.plugins.push((0, _codeBlock2.default)({ backgroundColor: props.codeBackgroundColor }));
    }

    if (props.enableHashtags) {
      _this.plugins.push((0, _hashtag2.default)({
        Hashtag: (0, _decorateComponentWithProps2.default)(_textEditorHashtag2.default, {
          createHref: function createHref(decoratedText) {
            return '/search/posts?query=' + encodeURIComponent('#') + decoratedText;
          },
          theme: (0, _lodash.get)(props.theme, 'hashtag')
        })
      }));
    }

    _this.decorators = [(0, _createTextEditorDecorator2.default)({ theme: props.theme, followLinks: props.followLinks })];

    _this.state = {
      editorState: (0, _textEditorUtils.createEditorState)((0, _textEditorUtils.cleanUpContent)(props.content))
    };
    return _this;
  }

  _createClass(DraftRenderer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var content = _ref.content;

      if (content !== this.props.content) {
        this.updateContent(content);
      }
    }
  }, {
    key: 'updateContent',
    value: function updateContent(content) {
      var decorator = this.state.editorState.getDecorator();
      this.setState({
        editorState: (0, _textEditorUtils.createEditorState)((0, _textEditorUtils.cleanUpContent)(content), decorator)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          type = _props.type;

      var containerClassName = (0, _classnames2.default)((0, _lodash.get)(theme, 'container'), (0, _lodash.get)(theme, 'types.' + type));

      return _react2.default.createElement(
        'div',
        { className: containerClassName },
        _react2.default.createElement(_draftJsPluginsEditor2.default, {
          onChange: this.handleChange,
          editorState: this.state.editorState,
          blockStyleFn: (0, _lodash.get)(theme, 'blockStyleFn'),
          blockRenderMap: this.blockRenderMap,
          plugins: this.plugins,
          decorators: this.decorators,
          readOnly: true
        })
      );
    }
  }]);

  return DraftRenderer;
}(_react.Component);

DraftRenderer.propTypes = {
  content: _propTypes2.default.object.isRequired,
  type: _propTypes2.default.string,
  identifier: _propTypes2.default.string,
  isPublic: _propTypes2.default.bool,
  isCodeBlockEnabled: _propTypes2.default.bool,
  enableHashtags: _propTypes2.default.bool,
  codeBackgroundColor: _propTypes2.default.string,
  theme: _propTypes2.default.object,
  followLinks: _propTypes2.default.bool,
  config: _propTypes2.default.object
};

exports.default = (0, _lodash.flowRight)((0, _withExperiment2.default)({
  isCodeBlockEnabled: _experiments.EXPERIMENT_CODE_BLOCK
}), (0, _withSettingsColor2.default)(_wixParams.APP_TEXT_COLOR_PATH, 'codeBackgroundColor', 'color-5', 0.1))(DraftRenderer);

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(10);

exports.default = function (text) {
  return _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromText(text));
}; /**
    * Create an editor state with some text in it already
    */

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This code originally has been copied from Recompose
// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/compose.js
exports.default = function () {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  return function () {
    var result = last.apply(undefined, arguments);
    for (var i = funcs.length - 2; i >= 0; i -= 1) {
      var f = funcs[i];
      result = f(result);
    }
    return result;
  };
};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = __webpack_require__(10);

var _immutable = __webpack_require__(31);

var _MultiDecorator = __webpack_require__(731);

var _MultiDecorator2 = _interopRequireDefault(_MultiDecorator);

var _createCompositeDecorator = __webpack_require__(732);

var _createCompositeDecorator2 = _interopRequireDefault(_createCompositeDecorator);

var _moveSelectionToEnd = __webpack_require__(733);

var _moveSelectionToEnd2 = _interopRequireDefault(_moveSelectionToEnd);

var _proxies = __webpack_require__(734);

var _proxies2 = _interopRequireDefault(_proxies);

var _defaultKeyBindingPlugin = __webpack_require__(735);

var defaultKeyBindingPlugin = _interopRequireWildcard(_defaultKeyBindingPlugin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-continue,no-restricted-syntax */


/**
 * The main editor component
 */
var PluginEditor = function (_Component) {
  _inherits(PluginEditor, _Component);

  function PluginEditor(props) {
    _classCallCheck(this, PluginEditor);

    var _this = _possibleConstructorReturn(this, (PluginEditor.__proto__ || Object.getPrototypeOf(PluginEditor)).call(this, props));

    _initialiseProps.call(_this);

    var plugins = [_this.props].concat(_toConsumableArray(_this.resolvePlugins()));
    plugins.forEach(function (plugin) {
      if (typeof plugin.initialize !== 'function') return;
      plugin.initialize(_this.getPluginMethods());
    });

    // attach proxy methods like `focus` or `blur`
    _proxies2.default.forEach(function (method) {
      _this[method] = function () {
        var _this$editor;

        return (_this$editor = _this.editor)[method].apply(_this$editor, arguments);
      };
    });

    _this.state = {}; // TODO for Nik: ask ben why this is relevent
    return _this;
  }

  _createClass(PluginEditor, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var decorators = this.resolveDecorators();
      var compositeDecorator = (0, _createCompositeDecorator2.default)(decorators.filter(function (decorator) {
        return !_this2.decoratorIsCustom(decorator);
      }), this.getEditorState, this.onChange);

      var customDecorators = decorators.filter(function (decorator) {
        return _this2.decoratorIsCustom(decorator);
      });

      var multiDecorator = new _MultiDecorator2.default([].concat(_toConsumableArray(customDecorators), [compositeDecorator]));

      var editorState = _draftJs.EditorState.set(this.props.editorState, { decorator: multiDecorator });
      this.onChange((0, _moveSelectionToEnd2.default)(editorState));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      this.resolvePlugins().forEach(function (plugin) {
        if (plugin.willUnmount) {
          plugin.willUnmount({
            getEditorState: _this3.getEditorState,
            setEditorState: _this3.onChange
          });
        }
      });
    }

    // Cycle through the plugins, changing the editor state with what the plugins
    // changed (or didn't)


    // TODO further down in render we use readOnly={this.props.readOnly || this.state.readOnly}. Ask Ben why readOnly is here just from the props? Why would plugins use this instead of just taking it from getProps?


    // Return true if decorator implements the DraftDecoratorType interface
    // @see https://github.com/facebook/draft-js/blob/master/src/model/decorators/DraftDecoratorType.js

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var pluginHooks = this.createPluginHooks();
      var customStyleMap = this.resolveCustomStyleMap();
      var accessibilityProps = this.resolveAccessibilityProps();
      var blockRenderMap = this.resolveblockRenderMap();
      return _react2.default.createElement(_draftJs.Editor, _extends({}, this.props, accessibilityProps, pluginHooks, {
        readOnly: this.props.readOnly || this.state.readOnly,
        customStyleMap: customStyleMap,
        blockRenderMap: blockRenderMap,
        onChange: this.onChange,
        editorState: this.props.editorState,
        ref: function ref(element) {
          _this4.editor = element;
        }
      }));
    }
  }]);

  return PluginEditor;
}(_react.Component);

PluginEditor.propTypes = {
  editorState: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  plugins: _propTypes2.default.array,
  defaultKeyBindings: _propTypes2.default.bool,
  defaultBlockRenderMap: _propTypes2.default.bool,
  customStyleMap: _propTypes2.default.object,
  decorators: _propTypes2.default.array
};
PluginEditor.defaultProps = {
  defaultBlockRenderMap: true,
  defaultKeyBindings: true,
  customStyleMap: {},
  plugins: [],
  decorators: []
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onChange = function (editorState) {
    var newEditorState = editorState;
    _this5.resolvePlugins().forEach(function (plugin) {
      if (plugin.onChange) {
        newEditorState = plugin.onChange(newEditorState, _this5.getPluginMethods());
      }
    });

    if (_this5.props.onChange) {
      _this5.props.onChange(newEditorState, _this5.getPluginMethods());
    }
  };

  this.getPlugins = function () {
    return _this5.props.plugins.slice(0);
  };

  this.getProps = function () {
    return _extends({}, _this5.props);
  };

  this.getReadOnly = function () {
    return _this5.props.readOnly;
  };

  this.setReadOnly = function (readOnly) {
    if (readOnly !== _this5.state.readOnly) _this5.setState({ readOnly: readOnly });
  };

  this.getEditorRef = function () {
    return _this5.editor;
  };

  this.getEditorState = function () {
    return _this5.props.editorState;
  };

  this.getPluginMethods = function () {
    return {
      getPlugins: _this5.getPlugins,
      getProps: _this5.getProps,
      setEditorState: _this5.onChange,
      getEditorState: _this5.getEditorState,
      getReadOnly: _this5.getReadOnly,
      setReadOnly: _this5.setReadOnly,
      getEditorRef: _this5.getEditorRef
    };
  };

  this.createEventHooks = function (methodName, plugins) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var newArgs = [].slice.apply(args);
      newArgs.push(_this5.getPluginMethods());

      return plugins.some(function (plugin) {
        return typeof plugin[methodName] === 'function' && plugin[methodName].apply(plugin, _toConsumableArray(newArgs)) === true;
      });
    };
  };

  this.createHandleHooks = function (methodName, plugins) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var newArgs = [].slice.apply(args);
      newArgs.push(_this5.getPluginMethods());

      return plugins.some(function (plugin) {
        return typeof plugin[methodName] === 'function' && plugin[methodName].apply(plugin, _toConsumableArray(newArgs)) === 'handled';
      }) ? 'handled' : 'not-handled';
    };
  };

  this.createFnHooks = function (methodName, plugins) {
    return function () {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      var newArgs = [].slice.apply(args);

      newArgs.push(_this5.getPluginMethods());

      if (methodName === 'blockRendererFn') {
        var block = { props: {} };
        plugins.forEach(function (plugin) {
          if (typeof plugin[methodName] !== 'function') return;
          var result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
          if (result !== undefined && result !== null) {
            var pluginProps = result.props,
                pluginRest = _objectWithoutProperties(result, ['props']); // eslint-disable-line no-use-before-define


            var _block = block,
                props = _block.props,
                rest = _objectWithoutProperties(_block, ['props']); // eslint-disable-line no-use-before-define


            block = _extends({}, rest, pluginRest, { props: _extends({}, props, pluginProps) });
          }
        });

        return block.component ? block : false;
      } else if (methodName === 'blockStyleFn') {
        var styles = void 0;
        plugins.forEach(function (plugin) {
          if (typeof plugin[methodName] !== 'function') return;
          var result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
          if (result !== undefined && result !== null) {
            styles = (styles ? styles + ' ' : '') + result;
          }
        });

        return styles || false;
      }

      var result = void 0;
      var wasHandled = plugins.some(function (plugin) {
        if (typeof plugin[methodName] !== 'function') return false;
        result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
        return result !== undefined;
      });
      return wasHandled ? result : false;
    };
  };

  this.createPluginHooks = function () {
    var pluginHooks = {};
    var eventHookKeys = [];
    var handleHookKeys = [];
    var fnHookKeys = [];
    var plugins = [_this5.props].concat(_toConsumableArray(_this5.resolvePlugins()));

    plugins.forEach(function (plugin) {
      Object.keys(plugin).forEach(function (attrName) {
        if (attrName === 'onChange') return;

        // if `attrName` has been added as a hook key already, ignore this one
        if (eventHookKeys.indexOf(attrName) !== -1 || fnHookKeys.indexOf(attrName) !== -1) return;

        var isEventHookKey = attrName.indexOf('on') === 0;
        if (isEventHookKey) {
          eventHookKeys.push(attrName);
          return;
        }

        var isHandleHookKey = attrName.indexOf('handle') === 0;
        if (isHandleHookKey) {
          handleHookKeys.push(attrName);
          return;
        }

        // checks if `attrName` ends with 'Fn'
        var isFnHookKey = attrName.length - 2 === attrName.indexOf('Fn');
        if (isFnHookKey) {
          fnHookKeys.push(attrName);
        }
      });
    });

    eventHookKeys.forEach(function (attrName) {
      pluginHooks[attrName] = _this5.createEventHooks(attrName, plugins);
    });

    handleHookKeys.forEach(function (attrName) {
      pluginHooks[attrName] = _this5.createHandleHooks(attrName, plugins);
    });

    fnHookKeys.forEach(function (attrName) {
      pluginHooks[attrName] = _this5.createFnHooks(attrName, plugins);
    });

    return pluginHooks;
  };

  this.resolvePlugins = function () {
    var plugins = _this5.props.plugins.slice(0);
    if (_this5.props.defaultKeyBindings) {
      plugins.push(defaultKeyBindingPlugin);
    }

    return plugins;
  };

  this.resolveDecorators = function () {
    var _props = _this5.props,
        decorators = _props.decorators,
        plugins = _props.plugins;

    return (0, _immutable.List)([{ decorators: decorators }].concat(_toConsumableArray(plugins))).filter(function (plugin) {
      return plugin.decorators !== undefined;
    }).flatMap(function (plugin) {
      return plugin.decorators;
    });
  };

  this.decoratorIsCustom = function (decorator) {
    return typeof decorator.getDecorations === 'function' && typeof decorator.getComponentForKey === 'function' && typeof decorator.getPropsForKey === 'function';
  };

  this.resolveCustomStyleMap = function () {
    return _this5.props.plugins.filter(function (plug) {
      return plug.customStyleMap !== undefined;
    }).map(function (plug) {
      return plug.customStyleMap;
    }).concat([_this5.props.customStyleMap]).reduce(function (styles, style) {
      return _extends({}, styles, style);
    }, {});
  };

  this.resolveblockRenderMap = function () {
    var blockRenderMap = _this5.props.plugins.filter(function (plug) {
      return plug.blockRenderMap !== undefined;
    }).reduce(function (maps, plug) {
      return maps.merge(plug.blockRenderMap);
    }, (0, _immutable.Map)({}));
    if (_this5.props.defaultBlockRenderMap) {
      blockRenderMap = _draftJs.DefaultDraftBlockRenderMap.merge(blockRenderMap);
    }
    if (_this5.props.blockRenderMap) {
      blockRenderMap = blockRenderMap.merge(_this5.props.blockRenderMap);
    }
    return blockRenderMap;
  };

  this.resolveAccessibilityProps = function () {
    var accessibilityProps = {};
    var plugins = [_this5.props].concat(_toConsumableArray(_this5.resolvePlugins()));
    plugins.forEach(function (plugin) {
      if (typeof plugin.getAccessibilityProps !== 'function') return;
      var props = plugin.getAccessibilityProps();
      var popupProps = {};

      if (accessibilityProps.ariaHasPopup === undefined) {
        popupProps.ariaHasPopup = props.ariaHasPopup;
      } else if (props.ariaHasPopup === 'true') {
        popupProps.ariaHasPopup = 'true';
      }

      if (accessibilityProps.ariaExpanded === undefined) {
        popupProps.ariaExpanded = props.ariaExpanded;
      } else if (props.ariaExpanded === 'true') {
        popupProps.ariaExpanded = 'true';
      }

      accessibilityProps = _extends({}, accessibilityProps, props, popupProps);
    });

    return accessibilityProps;
  };
};

exports.default = PluginEditor;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__(31);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KEY_SEPARATOR = '-';

var MultiDecorator = function () {
  function MultiDecorator(decorators) {
    _classCallCheck(this, MultiDecorator);

    this.decorators = _immutable2.default.List(decorators);
  }

  /**
   * Return list of decoration IDs per character
   *
   * @param {ContentBlock} block
   * @return {List<String>}
   */


  _createClass(MultiDecorator, [{
    key: 'getDecorations',
    value: function getDecorations(block, contentState) {
      var decorations = new Array(block.getText().length).fill(null);

      this.decorators.forEach(function (decorator, i) {
        var subDecorations = decorator.getDecorations(block, contentState);

        subDecorations.forEach(function (key, offset) {
          if (!key) {
            return;
          }

          decorations[offset] = i + KEY_SEPARATOR + key;
        });
      });

      return _immutable2.default.List(decorations);
    }

    /**
     * Return component to render a decoration
     *
     * @param {String} key
     * @return {Function}
     */

  }, {
    key: 'getComponentForKey',
    value: function getComponentForKey(key) {
      var decorator = this.getDecoratorForKey(key);
      return decorator.getComponentForKey(MultiDecorator.getInnerKey(key));
    }

    /**
     * Return props to render a decoration
     *
     * @param {String} key
     * @return {Object}
     */

  }, {
    key: 'getPropsForKey',
    value: function getPropsForKey(key) {
      var decorator = this.getDecoratorForKey(key);
      return decorator.getPropsForKey(MultiDecorator.getInnerKey(key));
    }

    /**
     * Return a decorator for a specific key
     *
     * @param {String} key
     * @return {Decorator}
     */

  }, {
    key: 'getDecoratorForKey',
    value: function getDecoratorForKey(key) {
      var parts = key.split(KEY_SEPARATOR);
      var index = Number(parts[0]);

      return this.decorators.get(index);
    }

    /**
     * Return inner key for a decorator
     *
     * @param {String} key
     * @return {String}
     */

  }], [{
    key: 'getInnerKey',
    value: function getInnerKey(key) {
      var parts = key.split(KEY_SEPARATOR);
      return parts.slice(1).join(KEY_SEPARATOR);
    }
  }]);

  return MultiDecorator;
}();

module.exports = MultiDecorator;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Creates a composite decorator based on the provided plugins
                                                                                                                                                                                                                                                                   */

var _immutable = __webpack_require__(31);

var _draftJs = __webpack_require__(10);

var _decorateComponentWithProps = __webpack_require__(51);

var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (decorators, getEditorState, setEditorState) {
  var convertedDecorators = (0, _immutable.List)(decorators).map(function (decorator) {
    return _extends({}, decorator, {
      component: (0, _decorateComponentWithProps2.default)(decorator.component, { getEditorState: getEditorState, setEditorState: setEditorState })
    });
  }).toJS();

  return new _draftJs.CompositeDecorator(convertedDecorators);
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(10);

/**
 * Returns a new EditorState where the Selection is at the end.
 *
 * This ensures to mimic the textarea behaviour where the Selection is placed at
 * the end. This is needed when blocks (like stickers or other media) are added
 * without the editor having had focus yet. It still works to place the
 * Selection at a specific location by clicking on the text.
 */
var moveSelectionToEnd = function moveSelectionToEnd(editorState) {
  var content = editorState.getCurrentContent();
  var blockMap = content.getBlockMap();

  var key = blockMap.last().getKey();
  var length = blockMap.last().getLength();

  var selection = new _draftJs.SelectionState({
    anchorKey: key,
    anchorOffset: length,
    focusKey: key,
    focusOffset: length
  });

  return _draftJs.EditorState.acceptSelection(editorState, selection);
};

exports.default = moveSelectionToEnd;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// the list of available proxies can be found here: https://github.com/facebook/draft-js/blob/master/src/component/base/DraftEditor.react.js#L120
var proxies = ['focus', 'blur', 'setMode', 'exitCurrentMode', 'restoreEditorDOM', 'setRenderGuard', 'removeRenderGuard', 'setClipboard', 'getClipboard', 'getEditorKey', 'update', 'onDragEnter', 'onDragLeave'];

exports.default = proxies;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyBindingFn = keyBindingFn;

var _draftJs = __webpack_require__(10);

/**
 * Handle default key bindings.
 *
 * @param {Event} event
 * @return {String} defaultCommand
 */
function keyBindingFn(event) {
  return (0, _draftJs.getDefaultKeyBinding)(event);
}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(10);

var _addBlock = __webpack_require__(737);

var _addBlock2 = _interopRequireDefault(_addBlock);

var _removeBlock = __webpack_require__(738);

var _removeBlock2 = _interopRequireDefault(_removeBlock);

var _constants = __webpack_require__(342);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (selection, dataTransfer, isInternal, _ref) {
  var getEditorState = _ref.getEditorState,
      setEditorState = _ref.setEditorState;

  var editorState = getEditorState();

  // Get data 'text' (anything else won't move the cursor) and expecting kind of data (text/key)
  var raw = dataTransfer.data.getData('text');
  var data = raw ? raw.split(':') : [];

  if (data.length !== 2) {
    return undefined;
  }

  // Existing block dropped
  if (data[0] === _constants.DRAFTJS_BLOCK_KEY) {
    var blockKey = data[1];

    // Get content, selection, block
    var contentState = editorState.getCurrentContent();
    var block = contentState.getBlockForKey(blockKey);
    var entity = contentState.getEntity(block.getEntityAt(0));
    var contentStateAfterInsert = (0, _addBlock2.default)(editorState, selection, block.getType(), entity.data, entity.type);
    var contentStateAfterRemove = (0, _removeBlock2.default)(contentStateAfterInsert, blockKey);

    // force to new selection
    var newSelection = new _draftJs.SelectionState({
      anchorKey: blockKey,
      anchorOffset: 0,
      focusKey: blockKey,
      focusOffset: 0
    });
    var newState = _draftJs.EditorState.push(editorState, contentStateAfterRemove, 'move-block');
    setEditorState(_draftJs.EditorState.forceSelection(newState, newSelection));
  }

  return 'handled';
};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (editorState, selection, type, data, entityType) {
  var text = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ' ';

  var currentContentState = editorState.getCurrentContent();
  var currentSelectionState = selection;

  // in case text is selected it is removed and then the block is appended
  var afterRemovalContentState = _draftJs.Modifier.removeRange(currentContentState, currentSelectionState, 'backward');

  // deciding on the postion to split the text
  var targetSelection = afterRemovalContentState.getSelectionAfter();
  var blockKeyForTarget = targetSelection.get('focusKey');
  var block = currentContentState.getBlockForKey(blockKeyForTarget);
  var insertionTargetSelection = void 0;
  var insertionTargetBlock = void 0;

  // In case there are no characters or entity or the selection is at the start it
  // is safe to insert the block in the current block.
  // Otherwise a new block is created (the block is always its own block)
  var isEmptyBlock = block.getLength() === 0 && block.getEntityAt(0) === null;
  var selectedFromStart = currentSelectionState.getStartOffset() === 0;
  if (isEmptyBlock || selectedFromStart) {
    insertionTargetSelection = targetSelection;
    insertionTargetBlock = afterRemovalContentState;
  } else {
    // the only way to insert a new seems to be by splitting an existing in to two
    insertionTargetBlock = _draftJs.Modifier.splitBlock(afterRemovalContentState, targetSelection);

    // the position to insert our blocks
    insertionTargetSelection = insertionTargetBlock.getSelectionAfter();
  }

  // TODO not sure why we need it …
  var newContentStateAfterSplit = _draftJs.Modifier.setBlockType(insertionTargetBlock, insertionTargetSelection, type);

  // creating a new ContentBlock including the entity with data
  // Entity will be created with a specific type, if defined, else will fall back to the ContentBlock type
  var contentStateWithEntity = newContentStateAfterSplit.createEntity(entityType || type, 'IMMUTABLE', _extends({}, data));
  var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  var charData = _draftJs.CharacterMetadata.create({ entity: entityKey });

  var fragmentArray = [new _draftJs.ContentBlock({
    key: (0, _draftJs.genKey)(),
    type: type,
    text: text,
    characterList: (0, _immutable.List)((0, _immutable.Repeat)(charData, text.length || 1)) }),

  // new contentblock so we can continue wrting right away after inserting the block
  new _draftJs.ContentBlock({
    key: (0, _draftJs.genKey)(),
    type: 'unstyled',
    text: '',
    characterList: (0, _immutable.List)() })];

  // create fragment containing the two content blocks
  var fragment = _draftJs.BlockMapBuilder.createFromArray(fragmentArray);

  // replace the contentblock we reserved for our insert
  return _draftJs.Modifier.replaceWithFragment(newContentStateAfterSplit, insertionTargetSelection, fragment);
};

var _immutable = __webpack_require__(31);

var _draftJs = __webpack_require__(10);

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (contentState, blockKey) {
  var afterKey = contentState.getKeyAfter(blockKey);
  var afterBlock = contentState.getBlockForKey(afterKey);
  var targetRange = void 0;

  // Only if the following block the last with no text then the whole block
  // should be removed. Otherwise the block should be reduced to an unstyled block
  // without any characters.
  if (afterBlock && afterBlock.getType() === 'unstyled' && afterBlock.getLength() === 0 && afterBlock === contentState.getBlockMap().last()) {
    targetRange = new _draftJs.SelectionState({
      anchorKey: blockKey,
      anchorOffset: 0,
      focusKey: afterKey,
      focusOffset: 0
    });
  } else {
    targetRange = new _draftJs.SelectionState({
      anchorKey: blockKey,
      anchorOffset: 0,
      focusKey: blockKey,
      focusOffset: 1
    });
  }

  // change the blocktype and remove the characterList entry with the block
  var newContentState = _draftJs.Modifier.setBlockType(contentState, targetRange, 'unstyled');
  return _draftJs.Modifier.removeRange(newContentState, targetRange, 'backward');
};

var _draftJs = __webpack_require__(10);

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(342);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Get a component's display name
var getDisplayName = function getDisplayName(WrappedComponent) {
  var component = WrappedComponent.WrappedComponent || WrappedComponent;
  return component.displayName || component.name || 'Component';
};

exports.default = function (_ref) {
  var store = _ref.store;
  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(BlockDraggableDecorator, _Component);

      function BlockDraggableDecorator() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, BlockDraggableDecorator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = BlockDraggableDecorator.__proto__ || Object.getPrototypeOf(BlockDraggableDecorator)).call.apply(_ref2, [this].concat(args))), _this), _this.startDrag = function (event) {
          event.dataTransfer.dropEffect = 'move'; // eslint-disable-line no-param-reassign
          // declare data and give info that its an existing key and a block needs to be moved
          event.dataTransfer.setData('text', _constants.DRAFTJS_BLOCK_KEY + ':' + _this.props.block.key);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      // eslint-disable-next-line no-redeclare


      // Handle start-drag and set dataTransfer data with blockKey


      _createClass(BlockDraggableDecorator, [{
        key: 'render',
        value: function render() {
          var readOnly = store.getReadOnly();
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
            onDragStart: !readOnly ? this.startDrag : undefined
          }));
        }
      }]);

      return BlockDraggableDecorator;
    }(_react.Component), _class.displayName = 'BlockDraggable(' + getDisplayName(WrappedComponent) + ')', _class.WrappedComponent = WrappedComponent.WrappedComponent || WrappedComponent, _temp2;
  };
};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _imageLoader = __webpack_require__(741);

var _imageLoader2 = _interopRequireDefault(_imageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ImageLoader = function ImageLoader(_ref) {
  var className = _ref.className,
      type = _ref.type;
  return _react2.default.createElement('div', { className: (0, _classnames2.default)(_imageLoader2.default.loader, className, 'image-loader', _defineProperty({}, _imageLoader2.default[type], type)) });
};

ImageLoader.propTypes = {
  className: _propTypes2.default.string,
  type: _propTypes2.default.string
};

exports.default = ImageLoader;

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"_1mZJZ","load6":"_1qACZ","medium":"_3sDpo","mini":"_3sH5l"};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ExternalLink = function ExternalLink(_ref) {
  var children = _ref.children,
      followLinks = _ref.followLinks,
      otherProps = _objectWithoutProperties(_ref, ['children', 'followLinks']);

  var linkProps = (0, _lodash.omit)(otherProps, 'contentState', 'entityKey', 'offsetKey');
  var rel = (0, _lodash.compact)(['noopener', 'noreferrer', !followLinks && 'nofollow']).join(' ');

  return _react2.default.createElement(
    'a',
    _extends({ target: '_blank', rel: rel }, linkProps),
    children
  );
};

ExternalLink.propTypes = {
  children: _propTypes2.default.node,
  followLinks: _propTypes2.default.bool
};

ExternalLink.defaultProps = {
  followLinks: true
};

exports.default = ExternalLink;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function (opts) {
  var re = {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = __webpack_require__(744).source;
  re.src_Cc  = __webpack_require__(745).source;
  re.src_Z   = __webpack_require__(746).source;
  re.src_P   = __webpack_require__(747).source;

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = '[><\uff5c]';

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 =

    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';

  re.src_port =

    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

  re.src_host_terminator =

    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';

  re.src_path =

    '(?:' +
      '[/?#]' +
        '(?:' +
          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' +
          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
          '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
                                     // - english
                                     // - percent-encoded
                                     // - parts of file path
                                     // until more examples found.
          '\\.(?!' + re.src_ZCc + '|[.]).|' +
          (opts && opts['---'] ?
            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
          :
            '\\-+|'
          ) +
          '\\,(?!' + re.src_ZCc + ').|' +      // allow `,,,` in paths
          '\\!(?!' + re.src_ZCc + '|[!]).|' +
          '\\?(?!' + re.src_ZCc + '|[?]).' +
        ')+' +
      '|\\/' +
    ')?';

  re.src_email_name =

    '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';

  re.src_xn =

    'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =

    // Allow letters & digits (http://test1)
    '(?:' +
      re.src_xn +
      '|' +
      re.src_pseudo_letter + '{1,63}' +
    ')';

  re.src_domain =

    '(?:' +
      re.src_xn +
      '|' +
      '(?:' + re.src_pseudo_letter + ')' +
      '|' +
      // don't allow `--` in domain names, because:
      // - that can conflict with markdown &mdash; / &ndash;
      // - nobody use those anyway
      '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
    ')';

  re.src_host =

    '(?:' +
    // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
    ')';

  re.tpl_host_fuzzy =

    '(?:' +
      re.src_ip4 +
    '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
    ')';

  re.tpl_host_no_ip_fuzzy =

    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';

  re.src_host_strict =

    re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict =

    re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_host_port_no_ip_fuzzy_strict =

    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;


  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test =

    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';

  re.tpl_email_fuzzy =

      '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';

  re.tpl_link_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';

  re.tpl_link_no_ip_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';

  return re;
};


/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1vJYL","isLoading":"_1ka5G","image":"_3UZeM"};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactPlayer = __webpack_require__(750);

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _reactOverlays = __webpack_require__(154);

var _index = __webpack_require__(9);

var _index2 = __webpack_require__(155);

var _index3 = _interopRequireDefault(_index2);

var _tooltip = __webpack_require__(339);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withEventEmitter = __webpack_require__(760);

var _withEventEmitter2 = _interopRequireDefault(_withEventEmitter);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _videoEmbed = __webpack_require__(146);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _videoEmbed2 = __webpack_require__(762);

var _videoEmbed3 = _interopRequireDefault(_videoEmbed2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_WAIT_TIME = 5000;

var getStyle = function getStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      thumbnail_url = _ref.thumbnail_url;

  return {
    backgroundImage: 'url(' + thumbnail_url + ')'
  };
};

var VideoEmbed = function (_Component) {
  _inherits(VideoEmbed, _Component);

  function VideoEmbed() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, VideoEmbed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = VideoEmbed.__proto__ || Object.getPrototypeOf(VideoEmbed)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      isLoading: false,
      isLoaded: false,
      isTooltipVisible: false
    }, _this.handleMouseEnter = function () {
      _this.timeout = setTimeout(function () {
        _this.setState({
          isTooltipVisible: true
        });
      }, 500);
    }, _this.handleMouseLeave = function () {
      clearTimeout(_this.timeout);
      _this.setState({
        isTooltipVisible: false
      });
    }, _this.setPlayer = function (player) {
      _this.player = player;
    }, _this.handleVideoStart = function (player) {
      if (_this.player !== player) {
        _this.setState({
          isLoading: false,
          isLoaded: false
        });
      }
    }, _this.handlePlay = function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.setState({ isLoading: true });
      setTimeout(function () {
        return _this.handleReady();
      }, MAX_WAIT_TIME);
    }, _this.handleReady = function () {
      if (_this.state.isLoading) {
        _this.setState({ isLoaded: true });
      }
    }, _this.handleStart = function () {
      _this.props.eventEmitter.emitEvent('video-start', [_this.player]);
    }, _this.renderPlayIcon = function () {
      return _react2.default.createElement(
        'span',
        { ref: _this.setPlayIconWrapper },
        _react2.default.createElement(_index.PlayIcon, { className: _videoEmbed3.default.icon })
      );
    }, _this.setPlayIconWrapper = function (ref) {
      return _this.playIconWrapper = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VideoEmbed, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.eventEmitter.on('video-start', this.handleVideoStart);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.eventEmitter.removeListener('video-start', this.handleVideoStart);
      clearTimeout(this.timeout);
    }
  }, {
    key: 'renderThumbnail',
    value: function renderThumbnail() {
      var _state = this.state,
          isLoading = _state.isLoading,
          isLoaded = _state.isLoaded;
      var _props = this.props,
          isMobile = _props.isMobile,
          isDesktop = _props.isDesktop,
          t = _props.t,
          isPlayDisabled = _props.isPlayDisabled;

      var handleOverlayClick = isPlayDisabled ? _lodash2.default.noop : this.handlePlay;

      return !isLoaded && _react2.default.createElement(
        'div',
        {
          className: _videoEmbed3.default.thumbnail,
          style: getStyle(this.props.oembed),
          onClick: handleOverlayClick,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          'data-hook': 'video'
        },
        _react2.default.createElement('div', { className: _videoEmbed3.default.overlay }),
        !isLoading && isMobile && _react2.default.createElement(
          'div',
          { className: _videoEmbed3.default.button },
          _react2.default.createElement(_index.PlayArrow, { className: _videoEmbed3.default.arrow }),
          ' ',
          t('video-embed.load-video')
        ),
        !isLoading && isDesktop && this.renderPlayIcon(),
        isLoading && _react2.default.createElement(_index3.default, { type: 'medium' }),
        _react2.default.createElement(
          _reactOverlays.Overlay,
          {
            show: isPlayDisabled && this.state.isTooltipVisible,
            placement: 'top',
            container: (0, _scrollParent2.default)(),
            target: this.playIconWrapper,
            onHide: this.handleMouseLeave,
            rootClose: true
          },
          _react2.default.createElement(
            _tooltip2.default,
            null,
            t('video-embed.disabled-tooltip')
          )
        )
      );
    }
  }, {
    key: 'renderPlayer',
    value: function renderPlayer() {
      var isLoading = this.state.isLoading;
      var _props2 = this.props,
          isDesktop = _props2.isDesktop,
          oembed = _props2.oembed;

      return isLoading && _react2.default.createElement(_reactPlayer2.default, {
        ref: this.setPlayer,
        className: _videoEmbed3.default.player,
        width: '100%',
        height: '100%',
        url: (0, _videoEmbed.buildUrl)(oembed.video_url),
        onReady: this.handleReady,
        onStart: this.handleStart,
        playing: isDesktop,
        controls: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _videoEmbed3.default.videoEmbed },
        this.renderPlayer(),
        this.renderThumbnail()
      );
    }
  }]);

  return VideoEmbed;
}(_react.Component);

VideoEmbed.propTypes = {
  oembed: _propTypes2.default.object.isRequired,
  eventEmitter: _propTypes2.default.object.isRequired,
  isMobile: _propTypes2.default.bool,
  isDesktop: _propTypes2.default.bool,
  t: _propTypes2.default.func.isRequired,
  isPlayDisabled: _propTypes2.default.bool
};

exports.default = (0, _withTranslate2.default)((0, _withDeviceType2.default)((0, _withEventEmitter2.default)(VideoEmbed)));

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props3 = __webpack_require__(239);

var _YouTube = __webpack_require__(751);

var _YouTube2 = _interopRequireDefault(_YouTube);

var _SoundCloud = __webpack_require__(753);

var _SoundCloud2 = _interopRequireDefault(_SoundCloud);

var _Vimeo = __webpack_require__(755);

var _Vimeo2 = _interopRequireDefault(_Vimeo);

var _FilePlayer = __webpack_require__(145);

var _FilePlayer2 = _interopRequireDefault(_FilePlayer);

var _Streamable = __webpack_require__(757);

var _Streamable2 = _interopRequireDefault(_Streamable);

var _Vidme = __webpack_require__(758);

var _Vidme2 = _interopRequireDefault(_Vidme);

var _Wistia = __webpack_require__(759);

var _Wistia2 = _interopRequireDefault(_Wistia);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactPlayer = function (_Component) {
  _inherits(ReactPlayer, _Component);

  function ReactPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.seekTo = function (fraction) {
      if (_this.player) {
        _this.player.seekTo(fraction);
      }
    }, _this.progress = function () {
      if (_this.props.url && _this.player) {
        var loaded = _this.player.getFractionLoaded() || 0;
        var played = _this.player.getFractionPlayed() || 0;
        var progress = {};
        if (loaded !== _this.prevLoaded) {
          progress.loaded = loaded;
        }
        if (played !== _this.prevPlayed) {
          progress.played = played;
        }
        if (progress.loaded || progress.played) {
          _this.props.onProgress(progress);
        }
        _this.prevLoaded = loaded;
        _this.prevPlayed = played;
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
    }, _this.ref = function (player) {
      _this.player = player;
    }, _this.renderPlayer = function (Player) {
      var active = Player.canPlay(_this.props.url);

      var _this$props = _this.props,
          youtubeConfig = _this$props.youtubeConfig,
          soundcloudConfig = _this$props.soundcloudConfig,
          vimeoConfig = _this$props.vimeoConfig,
          fileConfig = _this$props.fileConfig,
          activeProps = _objectWithoutProperties(_this$props, ['youtubeConfig', 'soundcloudConfig', 'vimeoConfig', 'fileConfig']);

      var props = active ? _extends({}, activeProps, { ref: _this.ref }) : {};
      return _react2['default'].createElement(Player, _extends({
        key: Player.displayName,
        youtubeConfig: youtubeConfig,
        soundcloudConfig: soundcloudConfig,
        vimeoConfig: vimeoConfig,
        fileConfig: fileConfig
      }, props));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.progress();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume || this.props.playbackRate !== nextProps.playbackRate || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden;
    }
  }, {
    key: 'renderPlayers',
    value: function renderPlayers() {
      // Build array of players to render based on URL and preload config
      var _props = this.props,
          url = _props.url,
          youtubeConfig = _props.youtubeConfig,
          vimeoConfig = _props.vimeoConfig;

      var players = [];
      if (_YouTube2['default'].canPlay(url)) {
        players.push(_YouTube2['default']);
      } else if (_SoundCloud2['default'].canPlay(url)) {
        players.push(_SoundCloud2['default']);
      } else if (_Vimeo2['default'].canPlay(url)) {
        players.push(_Vimeo2['default']);
      } else if (_Streamable2['default'].canPlay(url)) {
        players.push(_Streamable2['default']);
      } else if (_Vidme2['default'].canPlay(url)) {
        players.push(_Vidme2['default']);
      } else if (_Wistia2['default'].canPlay(url)) {
        players.push(_Wistia2['default']);
      } else if (url) {
        // Fall back to FilePlayer if nothing else can play the URL
        players.push(_FilePlayer2['default']);
      }
      // Render additional players if preload config is set
      if (!_YouTube2['default'].canPlay(url) && youtubeConfig.preload) {
        players.push(_YouTube2['default']);
      }
      if (!_Vimeo2['default'].canPlay(url) && vimeoConfig.preload) {
        players.push(_Vimeo2['default']);
      }
      return players.map(this.renderPlayer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          width = _props2.width,
          height = _props2.height,
          className = _props2.className,
          hidden = _props2.hidden;

      var players = this.renderPlayers();
      return _react2['default'].createElement(
        'div',
        { style: _extends({}, style, { width: width, height: height }), className: className, hidden: hidden },
        players
      );
    }
  }]);

  return ReactPlayer;
}(_react.Component);

ReactPlayer.displayName = 'ReactPlayer';
ReactPlayer.propTypes = _props3.propTypes;
ReactPlayer.defaultProps = _props3.defaultProps;
exports['default'] = ReactPlayer;
module.exports = exports['default'];

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loadScript = __webpack_require__(346);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _Base2 = __webpack_require__(144);

var _Base3 = _interopRequireDefault(_Base2);

var _utils = __webpack_require__(752);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';
var DEFAULT_PLAYER_VARS = {
  autoplay: 0,
  playsinline: 1,
  showinfo: 0,
  rel: 0,
  iv_load_policy: 3
};

var YouTube = function (_Base) {
  _inherits(YouTube, _Base);

  function YouTube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.onStateChange = function (_ref2) {
      var data = _ref2.data;
      var _this$props = _this.props,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) _this.onPlay();
      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();
      if (data === ENDED) _this.onEnded();
      if (data === CUED) _this.onReady();
    }, _this.onEnded = function () {
      var _this$props2 = _this.props,
          loop = _this$props2.loop,
          onEnded = _this$props2.onEnded;

      if (loop) {
        _this.seekTo(0);
      }
      onEnded();
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          url = _props.url,
          youtubeConfig = _props.youtubeConfig;

      if (!url && youtubeConfig.preload) {
        this.preloading = true;
        this.load(BLANK_VIDEO_URL);
      }
      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'getSDK',
    value: function getSDK() {
      if (window[SDK_GLOBAL] && window[SDK_GLOBAL].loaded) {
        return Promise.resolve(window[SDK_GLOBAL]);
      }
      return new Promise(function (resolve, reject) {
        var previousOnReady = window[SDK_GLOBAL_READY];
        window[SDK_GLOBAL_READY] = function () {
          if (previousOnReady) previousOnReady();
          resolve(window[SDK_GLOBAL]);
        };
        (0, _loadScript2['default'])(SDK_URL, function (err) {
          if (err) reject(err);
        });
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props2 = this.props,
          controls = _props2.controls,
          youtubeConfig = _props2.youtubeConfig,
          _onError = _props2.onError;

      var id = url && url.match(MATCH_URL)[1];
      if (this.isReady) {
        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url)
        });
        return;
      }
      if (this.loadingSDK) {
        this.loadOnReady = url;
        return;
      }
      this.loadingSDK = true;
      this.getSDK().then(function (YT) {
        _this2.player = new YT.Player(_this2.container, {
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _extends({}, DEFAULT_PLAYER_VARS, {
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, youtubeConfig.playerVars),
          events: {
            onReady: function onReady() {
              _this2.loadingSDK = false;
              _this2.onReady();
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        });
      }, _onError);
    }
  }, {
    key: 'play',
    value: function play() {
      if (!this.isReady || !this.player.playVideo) return;
      this.player.playVideo();
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (!this.isReady || !this.player.pauseVideo) return;
      this.player.pauseVideo();
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!this.isReady || !this.player.stopVideo) return;
      this.player.stopVideo();
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
      if (!this.isReady || !this.player.seekTo) return;
      this.player.seekTo(this.getDuration() * fraction);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      if (!this.isReady || !this.player.setVolume) return;
      this.player.setVolume(fraction * 100);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      if (!this.isReady || !this.player.setPlaybackRate) return;
      this.player.setPlaybackRate(rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady || !this.player.getDuration) return null;
      return this.player.getDuration();
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      if (!this.isReady || !this.getDuration()) return null;
      return this.player.getCurrentTime() / this.getDuration();
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      if (!this.isReady || !this.player.getVideoLoadedFraction) return null;
      return this.player.getVideoLoadedFraction();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%',
        display: this.props.url ? 'block' : 'none'
      };
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return YouTube;
}(_Base3['default']);

YouTube.displayName = 'YouTube';
exports['default'] = YouTube;
module.exports = exports['default'];

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseStartTime = parseStartTime;
var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/;

// Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds
function parseStartTime(url) {
  var match = url.match(MATCH_START_QUERY);
  if (match) {
    var stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseStartStamp(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp, 10);
    }
  }
  return 0;
}

function parseStartStamp(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fetchJsonp = __webpack_require__(754);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _FilePlayer2 = __webpack_require__(145);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

var _props3 = __webpack_require__(239);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = '//api.soundcloud.com/resolve.json';
var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;

var songData = {}; // Cache song data requests

var SoundCloud = function (_FilePlayer) {
  _inherits(SoundCloud, _FilePlayer);

  function SoundCloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      image: null
    }, _this.clientId = _this.props.soundcloudConfig.clientId || _props3.defaultProps.soundcloudConfig.clientId, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SoundCloud, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return _get(SoundCloud.prototype.__proto__ || Object.getPrototypeOf(SoundCloud.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState) || this.state.image !== nextState.image;
    }
  }, {
    key: 'getSongData',
    value: function getSongData(url) {
      var _this2 = this;

      if (songData[url]) {
        return Promise.resolve(songData[url]);
      }
      return (0, _fetchJsonp2['default'])(RESOLVE_URL + '?url=' + url + '&client_id=' + this.clientId).then(function (response) {
        if (response.ok) {
          songData[url] = response.json();
          return songData[url];
        } else {
          _this2.props.onError(new Error('SoundCloud track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this3 = this;

      var _props = this.props,
          soundcloudConfig = _props.soundcloudConfig,
          onError = _props.onError;

      this.stop();
      this.getSongData(url).then(function (data) {
        if (!_this3.mounted) return;
        if (!data.streamable) {
          onError(new Error('SoundCloud track is not streamable'));
          return;
        }
        var image = data.artwork_url || data.user.avatar_url;
        if (image && soundcloudConfig.showArtwork) {
          _this3.setState({ image: image.replace('-large', '-t500x500') });
        }
        _this3.player.src = data.stream_url + '?client_id=' + _this3.clientId;
      }, onError);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          url = _props2.url,
          loop = _props2.loop,
          controls = _props2.controls;

      var style = {
        display: url ? 'block' : 'none',
        height: '100%',
        backgroundImage: this.state.image ? 'url(' + this.state.image + ')' : null,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('audio', {
          ref: this.ref,
          type: 'audio/mpeg',
          preload: 'auto',
          style: {
            width: '100%',
            height: '100%'
          },
          controls: controls,
          loop: loop
        })
      );
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return SoundCloud;
}(_FilePlayer3['default']);

SoundCloud.displayName = 'SoundCloud';
exports['default'] = SoundCloud;
module.exports = exports['default'];

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _queryString = __webpack_require__(756);

var _Base2 = __webpack_require__(144);

var _Base3 = _interopRequireDefault(_Base2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IFRAME_SRC = 'https://player.vimeo.com/video/';
var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
var DEFAULT_IFRAME_PARAMS = {
  api: 1,
  autoplay: 0,
  badge: 0,
  byline: 0,
  fullscreen: 1,
  portrait: 0,
  title: 0
};

var Vimeo = function (_Base) {
  _inherits(Vimeo, _Base);

  function Vimeo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.onMessage = function (e) {
      if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
      _this.origin = _this.origin || e.origin;
      var data = JSON.parse(e.data);
      if (data.event === 'ready') {
        _this.postMessage('getDuration');
        _this.postMessage('addEventListener', 'playProgress');
        _this.postMessage('addEventListener', 'loadProgress');
        _this.postMessage('addEventListener', 'play');
        _this.postMessage('addEventListener', 'pause');
        _this.postMessage('addEventListener', 'finish');
      }
      if (data.event === 'playProgress') _this.fractionPlayed = data.data.percent;
      if (data.event === 'loadProgress') _this.fractionLoaded = data.data.percent;
      if (data.event === 'play') _this.onPlay();
      if (data.event === 'pause') _this.props.onPause();
      if (data.event === 'finish') _this.onEnded();
      if (data.method === 'getDuration') {
        _this.duration = data.value; // Store for use later
        _this.onReady();
      }
    }, _this.onEnded = function () {
      var _this$props = _this.props,
          loop = _this$props.loop,
          onEnded = _this$props.onEnded;

      if (loop) {
        _this.seekTo(0);
      }
      onEnded();
    }, _this.postMessage = function (method, value) {
      if (!_this.origin) return;
      var data = JSON.stringify({ method: method, value: value });
      return _this.iframe.contentWindow && _this.iframe.contentWindow.postMessage(data, _this.origin);
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Vimeo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          url = _props.url,
          vimeoConfig = _props.vimeoConfig;

      window.addEventListener('message', this.onMessage, false);

      if (!url && vimeoConfig.preload) {
        this.preloading = true;
        this.load(BLANK_VIDEO_URL);
      }

      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.onMessage, false);
      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'getIframeParams',
    value: function getIframeParams() {
      return _extends({}, DEFAULT_IFRAME_PARAMS, this.props.vimeoConfig.iframeParams);
    }
  }, {
    key: 'load',
    value: function load(url) {
      var id = url.match(MATCH_URL)[3];
      this.iframe.src = IFRAME_SRC + id + '?' + (0, _queryString.stringify)(this.getIframeParams());
    }
  }, {
    key: 'play',
    value: function play() {
      this.postMessage('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.postMessage('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.iframe.src = '';
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, fraction);
      this.postMessage('seekTo', this.duration * fraction);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.postMessage('setVolume', fraction);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.postMessage('setPlaybackRate', rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      return this.fractionPlayed || null;
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      return this.fractionLoaded || null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _getIframeParams = this.getIframeParams(),
          fullscreen = _getIframeParams.fullscreen;

      var style = {
        display: this.props.url ? 'block' : 'none',
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        frameBorder: '0',
        style: style,
        allowFullScreen: fullscreen
      });
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Vimeo;
}(_Base3['default']);

Vimeo.displayName = 'Vimeo';
exports['default'] = Vimeo;
module.exports = exports['default'];

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(377);
var objectAssign = __webpack_require__(519);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FilePlayer2 = __webpack_require__(145);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = 'https://api.streamable.com/videos/';
var MATCH_URL = /^https?:\/\/streamable.com\/([a-z0-9]+)$/;

var cache = {}; // Cache song data requests

var Streamable = function (_FilePlayer) {
  _inherits(Streamable, _FilePlayer);

  function Streamable() {
    _classCallCheck(this, Streamable);

    return _possibleConstructorReturn(this, (Streamable.__proto__ || Object.getPrototypeOf(Streamable)).apply(this, arguments));
  }

  _createClass(Streamable, [{
    key: 'getData',
    value: function getData(url) {
      var onError = this.props.onError;

      var id = url.match(MATCH_URL)[1];
      if (cache[id]) {
        return Promise.resolve(cache[id]);
      }
      return window.fetch(RESOLVE_URL + id).then(function (response) {
        if (response.status === 200) {
          cache[id] = response.json();
          return cache[id];
        } else {
          onError(new Error('Streamable track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var onError = this.props.onError;

      this.stop();
      this.getData(url).then(function (data) {
        if (!_this2.mounted) return;
        _this2.player.src = data.files.mp4.url;
      }, onError);
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Streamable;
}(_FilePlayer3['default']);

Streamable.displayName = 'Streamable';
exports['default'] = Streamable;
module.exports = exports['default'];

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FilePlayer2 = __webpack_require__(145);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = 'https://api.vid.me/videoByUrl/';
var MATCH_URL = /^https?:\/\/vid.me\/([a-z0-9]+)$/i;

var cache = {}; // Cache song data requests

var Vidme = function (_FilePlayer) {
  _inherits(Vidme, _FilePlayer);

  function Vidme() {
    _classCallCheck(this, Vidme);

    return _possibleConstructorReturn(this, (Vidme.__proto__ || Object.getPrototypeOf(Vidme)).apply(this, arguments));
  }

  _createClass(Vidme, [{
    key: 'getData',
    value: function getData(url) {
      var onError = this.props.onError;

      var id = url.match(MATCH_URL)[1];
      if (cache[id]) {
        return Promise.resolve(cache[id]);
      }
      return window.fetch(RESOLVE_URL + id).then(function (response) {
        if (response.status === 200) {
          cache[id] = response.json();
          return cache[id];
        } else {
          onError(new Error('Vidme track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var onError = this.props.onError;

      this.stop();
      this.getData(url).then(function (data) {
        if (!_this2.mounted) return;
        _this2.player.src = data.video.complete_url;
      }, onError);
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Vidme;
}(_FilePlayer3['default']);

Vidme.displayName = 'Vidme';
exports['default'] = Vidme;
module.exports = exports['default'];

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loadScript = __webpack_require__(346);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _Base2 = __webpack_require__(144);

var _Base3 = _interopRequireDefault(_Base2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var MATCH_URL = /^https?:\/\/(.+)?(wistia.com|wi.st)\/(medias|embed)\/(.*)$/;

var Wistia = function (_Base) {
  _inherits(Wistia, _Base);

  function Wistia() {
    _classCallCheck(this, Wistia);

    return _possibleConstructorReturn(this, (Wistia.__proto__ || Object.getPrototypeOf(Wistia)).apply(this, arguments));
  }

  _createClass(Wistia, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onStart = _props.onStart,
          onPause = _props.onPause,
          onEnded = _props.onEnded;

      this.loadingSDK = true;
      this.getSDK().then(function () {
        window._wq = window._wq || [];
        window._wq.push({
          id: _this2.getID(_this2.props.url),
          onReady: function onReady(player) {
            _this2.loadingSDK = false;
            _this2.player = player;
            _this2.player.bind('start', onStart);
            _this2.player.bind('play', _this2.onPlay);
            _this2.player.bind('pause', onPause);
            _this2.player.bind('end', onEnded);
            _this2.onReady();
          }
        });
      });
    }
  }, {
    key: 'getSDK',
    value: function getSDK() {
      return new Promise(function (resolve, reject) {
        if (window[SDK_GLOBAL]) {
          resolve();
        } else {
          (0, _loadScript2['default'])(SDK_URL, function (err, script) {
            if (err) reject(err);
            resolve(script);
          });
        }
      });
    }
  }, {
    key: 'getID',
    value: function getID(url) {
      return url && url.match(MATCH_URL)[4];
    }
  }, {
    key: 'load',
    value: function load(url) {
      var id = this.getID(url);
      if (this.isReady) {
        this.player.replaceWith(id);
        this.props.onReady();
        this.onReady();
      }
    }
  }, {
    key: 'play',
    value: function play() {
      if (!this.isReady || !this.player) return;
      this.player.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (!this.isReady || !this.player) return;
      this.player && this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!this.isReady || !this.player) return;
      this.player.pause();
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(Wistia.prototype.__proto__ || Object.getPrototypeOf(Wistia.prototype), 'seekTo', this).call(this, fraction);
      if (!this.isReady || !this.player) return;
      this.player.time(this.getDuration() * fraction);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      if (!this.isReady || !this.player || !this.player.volume) return;
      this.player.volume(fraction);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      if (!this.isReady || !this.player || !this.player.playbackRate) return;
      this.player.playbackRate(rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady || !this.player || !this.player.duration) return;
      return this.player.duration();
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      if (!this.isReady || !this.player || !this.player.percentWatched) return null;
      return this.player.percentWatched();
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.getID(this.props.url);
      var className = 'wistia_embed wistia_async_' + id;
      var style = {
        width: '100%',
        height: '100%',
        display: this.props.url ? 'block' : 'none'
      };
      return _react2['default'].createElement('div', { className: className, style: style });
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Wistia;
}(_Base3['default']);

Wistia.displayName = 'Wistia';
exports['default'] = Wistia;
module.exports = exports['default'];

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withEventEmitter;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _wolfy87Eventemitter = __webpack_require__(761);

var _wolfy87Eventemitter2 = _interopRequireDefault(_wolfy87Eventemitter);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _getDisplayName = __webpack_require__(48);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = new _wolfy87Eventemitter2.default();

function withEventEmitter(WrappedComponent) {
  var Wrapper = function Wrapper(props) {
    return _react2.default.createElement(WrappedComponent, _extends({ eventEmitter: emitter }, props));
  };

  Wrapper.displayName = 'WithEventEmitter(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';

  (0, _hoistNonReactStatics2.default)(Wrapper, WrappedComponent);

  return Wrapper;
}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * EventEmitter v5.2.4 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function (exports) {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    function isValidListener (listener) {
        if (typeof listener === 'function' || listener instanceof RegExp) {
            return true
        } else if (listener && typeof listener === 'object') {
            return isValidListener(listener.listener)
        } else {
            return false
        }
    }

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        if (!isValidListener(listener)) {
            throw new TypeError('listener must be a function');
        }

        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the first argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);

                for (i = 0; i < listeners.length; i++) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return EventEmitter;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}(this || {}));


/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"videoEmbed":"LipyJ","player":"_2USpl","thumbnail":"_22Td9","overlay":"e-x8j","button":"_1Moxh","arrow":"_2ZPdG","icon":"_33WoB"};

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2s8DT","isLoading":"_3x5i7"};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hover":"_4LH4I"};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createStore = function createStore(initialState) {
  var state = initialState || {};
  var listeners = {};

  var subscribeToItem = function subscribeToItem(key, callback) {
    listeners[key] = listeners[key] || [];
    listeners[key].push(callback);
  };

  var unsubscribeFromItem = function unsubscribeFromItem(key, callback) {
    listeners[key] = listeners[key].filter(function (listener) {
      return listener !== callback;
    });
  };

  var updateItem = function updateItem(key, item) {
    state = _extends({}, state, _defineProperty({}, key, item));
    if (listeners[key]) {
      listeners[key].forEach(function (listener) {
        return listener(state[key]);
      });
    }
  };

  var getItem = function getItem(key) {
    return state[key];
  };

  return {
    subscribeToItem: subscribeToItem,
    unsubscribeFromItem: unsubscribeFromItem,
    updateItem: updateItem,
    getItem: getItem
  };
};

exports.default = createStore;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createDecorator;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createDecorator(_ref) {
  var store = _ref.store,
      theme = _ref.theme;

  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref2, [this].concat(args))), _this), _this.isLoading = function () {
          var block = _this.props.block;

          var getEditorState = store.getItem('getEditorState');
          var entityKey = block.getEntityAt(0);
          var entity = getEditorState().getCurrentContent().getEntity(entityKey);

          return entity.data.isLoading;
        }, _this.updateStore = function () {
          var _this$props = _this.props,
              block = _this$props.block,
              blockProps = _this$props.blockProps,
              contentState = _this$props.contentState;


          store.updateItem('editorFocus', blockProps.editorFocus);

          if (blockProps.isFocused && blockProps.isCollapsedSelection) {
            var blockNode = (0, _reactDom.findDOMNode)(_this);
            var boundingRect = blockNode.getBoundingClientRect();
            var entityKey = block.getEntityAt(0);
            store.updateItem('size', blockProps.size);
            store.updateItem('setSize', blockProps.setSize);
            store.updateItem('alignment', blockProps.alignment);
            store.updateItem('setAlignment', blockProps.setAlignment);
            store.updateItem('setHref', blockProps.setHref);
            store.updateItem('deleteBlock', blockProps.deleteBlock);
            store.updateItem('boundingRect', boundingRect);
            store.updateItem('entityKey', entityKey);
            store.updateItem('entity', contentState.getEntity(entityKey));
            store.updateItem('visibleBlock', block.getKey());
          } else if (store.getItem('visibleBlock') === block.getKey()) {
            store.updateItem('visibleBlock', null);
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          var selectBlock = store.getItem('selectBlock');
          var isLoading = this.isLoading();

          setTimeout(function () {
            if (isLoading) {
              selectBlock(_this2.props.block);
              _this2.updateStore();
            }
          }, 1000);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.updateStore();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          store.updateItem('visibleBlock', null);
        }
      }, {
        key: 'render',
        value: function render() {
          var _classNames;

          var _props = this.props,
              className = _props.className,
              blockProps = _props.blockProps;
          var alignment = blockProps.alignment,
              size = blockProps.size;

          var containerClassName = (0, _classnames2.default)(className, (_classNames = {}, _defineProperty(_classNames, theme.alignLeft, alignment === 'left'), _defineProperty(_classNames, theme.alignRight, alignment === 'right'), _defineProperty(_classNames, theme.sizeFullWidth, size === 'fullWidth'), _defineProperty(_classNames, theme.sizeContentWidth, size === 'content'), _defineProperty(_classNames, theme.sizeSmallCenter, size === 'smallCenter'), _defineProperty(_classNames, theme.sizeOriginal, size === 'original'), _classNames));

          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { className: containerClassName }));
        }
      }]);

      return _class;
    }(_react.Component), _class.propTypes = {
      block: _propTypes2.default.object,
      blockProps: _propTypes2.default.object,
      className: _propTypes2.default.string,
      contentState: _propTypes2.default.object
    }, _temp2;
  };
}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _buttons = __webpack_require__(330);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = __webpack_require__(14);

var _mediaBlockEditor = __webpack_require__(768);

var _mediaBlockEditor2 = _interopRequireDefault(_mediaBlockEditor);

var _separator = __webpack_require__(18);

var _toolbarInput = __webpack_require__(769);

var _toolbarInput2 = _interopRequireDefault(_toolbarInput);

var _getToolbarPosition = __webpack_require__(351);

var _getToolbarPosition2 = _interopRequireDefault(_getToolbarPosition);

var _viewModeSelectors = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MediaBlockEditor = function (_Component) {
  _inherits(MediaBlockEditor, _Component);

  function MediaBlockEditor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MediaBlockEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MediaBlockEditor.__proto__ || Object.getPrototypeOf(MediaBlockEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.clearTimeout = function () {
      return clearTimeout(_this.timeout);
    }, _this.onVisibilityChanged = function (visibleBlock) {
      _this.clearTimeout();
      // timeout is needed here to get correct position
      _this.timeout = setTimeout(function () {
        return _this.updateState(visibleBlock);
      });
    }, _this.updateState = function (visibleBlock) {
      var toolbar = (0, _reactDom.findDOMNode)(_this);
      var style = visibleBlock ? (0, _getToolbarPosition2.default)(toolbar.parentNode.getBoundingClientRect(), _this.props.pluginData.getItem('boundingRect'), toolbar.getBoundingClientRect()) : { visibility: 'hidden' };

      var alignment = _this.props.pluginData.getItem('alignment') || 'default';
      _this.setState({
        isVisible: Boolean(visibleBlock),
        alignment: alignment,
        style: style,
        isInputVisible: false
      });
    }, _this.handleUpload = function (event) {
      return _this.props.onUpload({
        file: event.target.files[0],
        entityKey: _this.props.pluginData.getItem('entityKey')
      });
    }, _this.setAlignment = function (alignment) {
      return _this.setState({ alignment: alignment });
    }, _this.setSize = function (size) {
      return _this.setState({ size: size });
    }, _this.isUploading = function () {
      return _this.props.pluginData.getItem('entity').data.isLoading;
    }, _this.handleDeleteButtonClick = function () {
      var pluginData = _this.props.pluginData;

      pluginData.updateItem('visibleBlock', null);
      pluginData.getItem('deleteBlock')();
    }, _this.handleLinkFormSubmit = function (href) {
      var pluginData = _this.props.pluginData;

      var setHref = pluginData.getItem('setHref');

      _this.hideInput();
      setHref(href);
    }, _this.handleLinkButtonClick = function () {
      return _this.setState({
        isInputVisible: true,
        initialInputValue: (0, _lodash.get)(_this.props.pluginData.getItem('entity'), 'data.href'),
        submitHandler: _this.handleLinkFormSubmit
      });
    }, _this.handleChangeVideoButtonClick = function () {
      return _this.setState({
        isInputVisible: true,
        initialInputValue: (0, _lodash.get)(_this.props.pluginData.getItem('entity'), 'data.url'),
        submitHandler: _this.handleVideoEmbedFormSubmit
      });
    }, _this.handleVideoEmbedFormSubmit = function (url) {
      return _this.props.onVideoEmbedChange({
        entityKey: _this.props.pluginData.getItem('entityKey'),
        url: url
      });
    }, _this.handleCancel = function () {
      return _this.setState({
        isInputVisible: false,
        initialInputValue: null,
        submitHandler: null
      });
    }, _this.handleMouseDown = function (event) {
      return event.preventDefault();
    }, _this.renderInput = function () {
      var _this$state = _this.state,
          isInputVisible = _this$state.isInputVisible,
          initialInputValue = _this$state.initialInputValue,
          submitHandler = _this$state.submitHandler;

      return isInputVisible ? _react2.default.createElement(
        'div',
        { className: _mediaBlockEditor2.default.input },
        _react2.default.createElement(_toolbarInput2.default, { onSubmit: submitHandler, onCancel: _this.handleCancel, initialValue: initialInputValue })
      ) : null;
    }, _this.renderButton = function (buttonType, key) {
      var _this$state2 = _this.state,
          alignment = _this$state2.alignment,
          size = _this$state2.size;
      var _this$props = _this.props,
          pluginData = _this$props.pluginData,
          theme = _this$props.theme,
          isEditor = _this$props.isEditor,
          onFileSelect = _this$props.onFileSelect;

      var setSize = pluginData.getItem('setSize');
      var setAlignment = pluginData.getItem('setAlignment');
      var buttonTheme = (0, _lodash.get)(theme, 'button');

      switch (buttonType) {
        case 'sizeFullWidth':
          return wrapButton(_react2.default.createElement(_buttons.SizeFullWidthButton, { setSize: setSize, size: size, theme: buttonTheme }), key);
        case 'sizeContent':
          return wrapButton(_react2.default.createElement(_buttons.SizeContentButton, { setSize: setSize, size: size, theme: buttonTheme }), key, _mediaBlockEditor2.default.smallSpace);
        case 'sizeText':
          return wrapButton(_react2.default.createElement(_buttons.SizeTextButton, { setSize: setSize, size: size, theme: buttonTheme }), key, _mediaBlockEditor2.default.smallSpace);
        case 'sizeOriginal':
          return wrapButton(_react2.default.createElement(_buttons.SizeOriginalButton, { setSize: setSize, size: size, theme: buttonTheme }), key);

        case 'alignLeft':
          return wrapButton(_react2.default.createElement(_buttons.AlignLeftButton, { setAlignment: setAlignment, alignment: alignment, theme: buttonTheme }), key);
        case 'alignRight':
          return wrapButton(_react2.default.createElement(_buttons.AlignRightButton, { setAlignment: setAlignment, alignment: alignment, theme: buttonTheme }), key);

        case 'reupload':
          if (isEditor) {
            return wrapButton(_react2.default.createElement(_buttons.ReuploadMediaDialogButton, {
              onFileSelect: onFileSelect,
              isDisabled: _this.isUploading(),
              theme: buttonTheme
            }), key);
          }

          return wrapButton(_react2.default.createElement(_buttons.ReuploadButton, { onFileChange: _this.handleUpload, isDisabled: _this.isUploading(), theme: buttonTheme }), key);

        case 'changeVideo':
          return wrapButton(_react2.default.createElement(_buttons.ChangeButton, { onClick: _this.handleChangeVideoButtonClick, theme: buttonTheme }), key);

        case 'link':
          return wrapButton(_react2.default.createElement(_buttons.LinkButton, { onClick: _this.handleLinkButtonClick, theme: buttonTheme }), key);

        case 'delete':
          return wrapButton(_react2.default.createElement(_buttons.DeleteButton, { onClick: _this.handleDeleteButtonClick, theme: buttonTheme }), key);

        case '-':
          return _react2.default.createElement(
            'div',
            { className: _mediaBlockEditor2.default.separator, key: key },
            _react2.default.createElement(_separator.VerticalSeparator, null)
          );

        default:
          return null;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MediaBlockEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.pluginData.subscribeToItem('visibleBlock', this.onVisibilityChanged);
      this.props.pluginData.subscribeToItem('alignment', this.setAlignment);
      this.props.pluginData.subscribeToItem('size', this.setSize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pluginData = _props.pluginData,
          theme = _props.theme;
      var _state = this.state,
          isVisible = _state.isVisible,
          style = _state.style;

      var containerClassName = (0, _classnames2.default)(_mediaBlockEditor2.default.container, (0, _lodash.get)(theme, 'container'), 'media-block-editor', _defineProperty({}, _mediaBlockEditor2.default.visible, pluginData.getItem('editorFocus') && isVisible));
      var containerStyle = _extends({}, style, (0, _lodash.get)(theme, 'containerStyle'));
      var entity = pluginData.getItem('entity');
      var buttons = (0, _lodash.attempt)(this.props.buttons, entity);
      return _react2.default.createElement(
        'div',
        {
          className: containerClassName,
          style: containerStyle,
          onClick: function onClick() {} // needed to receive mouse events on iOS
          , onMouseDown: this.handleMouseDown
        },
        this.renderInput(),
        _react2.default.createElement(
          'div',
          { className: _mediaBlockEditor2.default.flexContainer },
          (0, _lodash2.default)(buttons).filter(_lodash.identity).map(function (button, index) {
            return _this2.renderButton(button, index);
          }).value()
        )
      );
    }
  }]);

  return MediaBlockEditor;
}(_react.Component);

function wrapButton(button, key, className) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_mediaBlockEditor2.default.button, className), key: key },
    button
  );
}

MediaBlockEditor.propTypes = {
  pluginData: _propTypes2.default.object,
  cardBackgroundColor: _propTypes2.default.string,
  onUpload: _propTypes2.default.func.isRequired,
  onFileSelect: _propTypes2.default.func.isRequired,
  onVideoEmbedChange: _propTypes2.default.func.isRequired,
  buttons: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]),
  theme: _propTypes2.default.object,
  isEditor: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isEditor: (0, _viewModeSelectors.isEditor)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MediaBlockEditor);

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3IdtH","visible":"_1hVz_","flexContainer":"_3CAT6","button":"_2w_bZ","smallSpace":"_1txNy","separator":"_34Zyt","input":"_11jhI"};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _separator = __webpack_require__(18);

var _xIcon = __webpack_require__(770);

var _xIcon2 = _interopRequireDefault(_xIcon);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _toolbarInput = __webpack_require__(771);

var _toolbarInput2 = _interopRequireDefault(_toolbarInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToolbarInput = function (_Component) {
  _inherits(ToolbarInput, _Component);

  function ToolbarInput(props) {
    _classCallCheck(this, ToolbarInput);

    var _this = _possibleConstructorReturn(this, (ToolbarInput.__proto__ || Object.getPrototypeOf(ToolbarInput)).call(this, props));

    _this.handleChange = function (event) {
      return _this.setState({
        value: event.target.value
      });
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        _this.props.onSubmit(_this.state.value);
      }
    };

    _this.handleCancelButtonKeyDown = function (event) {
      event.preventDefault();
      _this.props.onCancel();
    };

    _this.state = {
      value: props.initialValue || ''
    };
    return _this;
  }

  _createClass(ToolbarInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cardBackgroundColor = _props.cardBackgroundColor,
          contentFontClassName = _props.contentFontClassName;

      var containerClassName = (0, _classnames2.default)(_toolbarInput2.default.container, contentFontClassName, 'default-forum-card-background-color');
      var style = { backgroundColor: cardBackgroundColor };
      var inputClassName = (0, _classnames2.default)(_toolbarInput2.default.input, 'forum-text-color');

      return _react2.default.createElement(
        'div',
        { className: containerClassName, style: style },
        _react2.default.createElement('div', { className: _toolbarInput2.default.borders }),
        _react2.default.createElement(
          'div',
          { className: _toolbarInput2.default.flexContainer },
          _react2.default.createElement('input', {
            className: inputClassName,
            type: 'text',
            placeholder: 'Paste or type a link...',
            onChange: this.handleChange,
            value: this.state.value,
            onKeyDown: this.handleKeyDown,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur
          }),
          _react2.default.createElement(_separator.VerticalSeparator, null),
          _react2.default.createElement(
            'div',
            { className: _toolbarInput2.default.close },
            _react2.default.createElement(_xIcon2.default, {
              className: (0, _classnames2.default)(_toolbarInput2.default.closeIcon, 'forum-icon-fill', 'button-hover-fill'),
              width: '12',
              onClick: this.handleCancelButtonKeyDown
            })
          )
        )
      );
    }
  }]);

  return ToolbarInput;
}(_react.Component);

ToolbarInput.propTypes = {
  cardBackgroundColor: _propTypes2.default.string,
  contentFontClassName: _propTypes2.default.string,
  initialValue: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired
};

exports.default = _lodash2.default.flowRight(_withFontClassName2.default, _withCardBackgroundColor2.default)(ToolbarInput);

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var xIcon = function xIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 12 12" }, props),
    _react2.default.createElement(
      "g",
      { stroke: "none", fillRule: "evenodd" },
      _react2.default.createElement("path", { d: "M6,4.58578644 L1.75735931,0.343145751 L0.343145751,1.75735931 L4.58578644,6 L0.343145751,10.2426407 L1.75735931,11.6568542 L6,7.41421356 L10.2426407,11.6568542 L11.6568542,10.2426407 L7.41421356,6 L11.6568542,1.75735931 L10.2426407,0.343145751 L6,4.58578644 Z" })
    )
  );
};

exports.default = xIcon;

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3NN86","borders":"_3Fo1w","flexContainer":"_3EQdU","input":"BgZr0","close":"emXCq","closeIcon":"_3CAky"};

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  getKeyBinding: __webpack_require__(773),
  hasSelectionInBlock: __webpack_require__(774),
  handleKeyCommand: __webpack_require__(775),
  handleReturn: __webpack_require__(782),
  handleTab: __webpack_require__(785)
};


/***/ }),
/* 773 */
/***/ (function(module, exports) {

/**
 * Return command for a keyboard event
 *
 * @param {SyntheticKeyboardEvent} event
 * @return {String}
 */
function getKeyBinding(e) {}

module.exports = getKeyBinding;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * Return true if selection is inside a code block
 *
 * @param {Draft.EditorState} editorState
 * @return {Boolean}
 */
function hasSelectionInBlock(editorState) {
  var selection = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var startKey = selection.getStartKey();
  var currentBlock = contentState.getBlockForKey(startKey);

  return currentBlock.getType() === 'code-block';
}

module.exports = hasSelectionInBlock;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var removeIndent = __webpack_require__(776);

/**
 * Handle key command for code blocks
 *
 * @param {Draft.EditorState} editorState
 * @param {String} command
 * @return {Boolean}
 */
function handleKeyCommand(editorState, command) {
  if (command === 'backspace') {
    return removeIndent(editorState);
  }
}

module.exports = handleKeyCommand;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var Draft = __webpack_require__(10);
var endsWith = __webpack_require__(777);

var getNewLine = __webpack_require__(147);
var getIndentation = __webpack_require__(355);
var getLines = __webpack_require__(357);
var getLineAnchorForOffset = __webpack_require__(358);

/**
 * Remove last indentation before cursor, return undefined if no modification is done
 *
 * @param {Draft.EditorState} editorState
 * @return {Draft.EditorState|undefined}
 */
function removeIndent(editorState) {
  var contentState = editorState.getCurrentContent();
  var selection = editorState.getSelection();

  if (!selection.isCollapsed()) {
    return;
  }

  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var currentBlock = contentState.getBlockForKey(startKey);
  var blockText = currentBlock.getText();

  // Detect newline separator and indentation
  var newLine = getNewLine(blockText);
  var indent = getIndentation(blockText);

  // Get current line
  var lines = getLines(blockText, newLine);
  var lineAnchor = getLineAnchorForOffset(blockText, startOffset, newLine);

  var currentLine = lines.get(lineAnchor.getLine());
  var beforeSelection = currentLine.slice(0, lineAnchor.getOffset());

  // If the line before selection ending with the indentation?
  if (!endsWith(beforeSelection, indent)) {
    return;
  }

  // Remove indent
  var beforeIndentOffset = startOffset - indent.length;
  var rangeToRemove = selection.merge({
    focusKey: startKey,
    focusOffset: beforeIndentOffset,
    anchorKey: startKey,
    anchorOffset: startOffset,
    isBackward: true
  });

  var newContentState = Draft.Modifier.removeRange(
    contentState,
    rangeToRemove,
    'backward'
  );
  var newEditorState = Draft.EditorState.push(
    editorState,
    newContentState,
    'remove-range'
  );

  return Draft.EditorState.forceSelection(
    newEditorState,
    newContentState.getSelectionAfter()
  );
}

module.exports = removeIndent;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * ends-with <https://github.com/jonschlinkert/ends-with>
 *
 * Copyright (c) 2014 Jon Schlinkert, contributors.
 * Licensed under the MIT license.
 */



module.exports = function (a, b) {
  if (Array.isArray(a)) {
    return a[a.length - 1] === b;
  }

  a = String(a);
  b = String(b);

  var i = b.length;
  var len = a.length - i;

  while (i--) {
    if (b.charAt(i) !== a.charAt(len + i)) {
      return false;
    }
  }
  return true;
};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	var newlines = (str.match(/(?:\r?\n)/g) || []);

	if (newlines.length === 0) {
		return null;
	}

	var crlf = newlines.filter(function (el) {
		return el === '\r\n';
	}).length;

	var lf = newlines.length - crlf;

	return crlf > lf ? '\r\n' : '\n';
};

module.exports.graceful = function (str) {
	return module.exports(str) || '\n';
};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isFinite = __webpack_require__(780);

module.exports = function (str, n) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected `input` to be a string');
	}

	if (n < 0 || !isFinite(n)) {
		throw new TypeError('Expected `count` to be a positive finite number');
	}

	var ret = '';

	do {
		if (n & 1) {
			ret += str;
		}

		str += str;
	} while ((n >>= 1));

	return ret;
};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var numberIsNan = __webpack_require__(781);

module.exports = Number.isFinite || function (val) {
	return !(typeof val !== 'number' || numberIsNan(val) || val === Infinity || val === -Infinity);
};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = Number.isNaN || function (x) {
	return x !== x;
};


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var Draft = __webpack_require__(10);
var insertNewLine = __webpack_require__(783);

/**
 *  We split code blocks only if user pressed Cmd+Enter
 *
 * @param {SyntheticKeyboardEvent} event
 * @param {Draft.EditorState} editorState
 * @return {Draft.EditorState}
 */
function handleReturn(e, editorState) {
  var contentState = editorState.getCurrentContent();
  var selection = editorState.getSelection();

  // Command+Return: As usual, split blocks
  if (selection.isCollapsed() && Draft.KeyBindingUtil.hasCommandModifier(e)) {
    var newContentState = Draft.Modifier.splitBlock(contentState, selection);
    return Draft.EditorState.push(editorState, newContentState, 'split-block');
  }

  return insertNewLine(editorState);
}

module.exports = handleReturn;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var Draft = __webpack_require__(10);
var getNewLine = __webpack_require__(147);
var getLines = __webpack_require__(357);
var getLineAnchorForOffset = __webpack_require__(358);
var getIndentForLine = __webpack_require__(784);

/**
 *  Insert a new line with right inden
 *
 * @param {SyntheticKeyboardEvent} event
 * @param {Draft.EditorState} editorState
 * @return {Draft.EditorState}
 */
function insertNewLine(editorState) {
  var contentState = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var currentBlock = contentState.getBlockForKey(startKey);
  var blockText = currentBlock.getText();

  var newContentState;

  // Detect newline separation
  var newLine = getNewLine(blockText);

  // Add or replace
  if (selection.isCollapsed()) {
    // Create line to insert with right indentation
    var lines = getLines(blockText, newLine);
    var currentLineIndex = getLineAnchorForOffset(
      blockText,
      startOffset,
      newLine
    ).getLine();
    var currentLine = lines.get(currentLineIndex);
    var lineToInsert = newLine + getIndentForLine(currentLine);

    newContentState = Draft.Modifier.insertText(
      contentState,
      selection,
      lineToInsert
    );
  } else {
    newContentState = Draft.Modifier.replaceText(
      contentState,
      selection,
      newLine
    );
  }

  var newEditorState = Draft.EditorState.push(
    editorState,
    newContentState,
    'insert-characters'
  );

  return Draft.EditorState.forceSelection(
    newEditorState,
    newContentState.getSelectionAfter()
  );
}

module.exports = insertNewLine;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var detectIndent = __webpack_require__(356);

/**
 * Return indentation of a line
 * @param {String} line
 * @return {String}
 */
function getIndentForLine(line) {
  return detectIndent(line).indent || '';
}

module.exports = getIndentForLine;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var Draft = __webpack_require__(10);
var getIndentation = __webpack_require__(355);

// TODO: tab should complete indentation instead of just inserting one

/**
 * Handle pressing tab in the editor
 *
 * @param {SyntheticKeyboardEvent} event
 * @param {Draft.EditorState} editorState
 * @return {Draft.EditorState}
 */
function handleTab(e, editorState) {
  e.preventDefault();

  var contentState = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  var currentBlock = contentState.getBlockForKey(startKey);

  var indentation = getIndentation(currentBlock.getText());
  var newContentState;

  if (selection.isCollapsed()) {
    newContentState = Draft.Modifier.insertText(
      contentState,
      selection,
      indentation
    );
  } else {
    newContentState = Draft.Modifier.replaceText(
      contentState,
      selection,
      indentation
    );
  }

  return Draft.EditorState.push(
    editorState,
    newContentState,
    'insert-characters'
  );
}

module.exports = handleTab;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(31);

var _immutable2 = _interopRequireDefault(_immutable);

var _prismjs = __webpack_require__(787);

var _prismjs2 = _interopRequireDefault(_prismjs);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _highlightingTheme = __webpack_require__(788);

var _highlightingTheme2 = _interopRequireDefault(_highlightingTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_SYNTAX = 'javascript';
var CODE_TOKEN_CLASS_NAMES = {
  keyword: 'button-color',
  operator: 'button-color',
  function: 'icon-secondary-color',
  constant: 'icon-secondary-color',
  'class-name': 'icon-secondary-color',
  boolean: 'forum-editor-code-value-color',
  string: 'forum-editor-code-value-color',
  number: 'forum-editor-code-value-color',
  regex: 'forum-editor-code-value-color',
  variable: 'forum-editor-code-value-color',
  'template-string': 'forum-editor-code-value-color'
};

var PrismDecorator = function () {
  function PrismDecorator() {
    _classCallCheck(this, PrismDecorator);

    this.highlighted = {};
  }

  _createClass(PrismDecorator, [{
    key: 'getDecorations',
    value: function getDecorations(block) {
      var blockKey = block.getKey();
      var blockText = block.getText();
      var decorations = Array(blockText.length).fill(null);

      this.highlighted[blockKey] = {};

      if (block.getType() !== 'code-block') {
        return _immutable2.default.List(decorations); // eslint-disable-line new-cap
      }

      // Parse text using Prism
      var grammar = _prismjs2.default.languages[DEFAULT_SYNTAX];
      var tokens = _prismjs2.default.tokenize(blockText, grammar);
      var offset = 0;

      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];

        if (typeof token === 'string') {
          offset += token.length;
        } else {
          var tokenId = 'tok' + offset;
          var resultId = blockKey + '-' + tokenId;

          this.highlighted[blockKey][tokenId] = token;

          addDecorations(decorations, offset, offset + getTokenLength(token), resultId);
          offset += getTokenLength(token);
        }
      }

      return _immutable2.default.List(decorations); // eslint-disable-line new-cap
    }
  }, {
    key: 'getComponentForKey',
    value: function getComponentForKey() {
      return function (props) {
        var type = props.type; // eslint-disable-line react/prop-types

        var className = (0, _classnames2.default)(CODE_TOKEN_CLASS_NAMES[type], _highlightingTheme2.default[type]);
        return _react2.default.createElement('span', _extends({}, props, { className: className }));
      };
    }
  }, {
    key: 'getPropsForKey',
    value: function getPropsForKey(key) {
      var parts = key.split('-');
      var blockKey = parts[0];
      var tokId = parts[1];
      var type = this.highlighted[blockKey][tokId].type;

      return {
        type: type
      };
    }
  }]);

  return PrismDecorator;
}();

exports.default = PrismDecorator;


function getTokenLength(token) {
  var tokenContent = token.content || token;
  if (typeof tokenContent === 'string') {
    return tokenContent.length;
  }

  return _lodash2.default.reduce(token.content, function (acc, token) {
    return getTokenLength(token) + acc;
  }, 0);
}

function addDecorations(decorations, start, end, componentKey) {
  for (var i = start; i < end; i++) {
    decorations[i] = componentKey;
  }
}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/* **********************************************
     Begin prism-core.js
********************************************** */

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
		? self // if in worker
		: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 * MIT license http://www.opensource.org/licenses/mit-license.php/
 * @author Lea Verou http://lea.verou.me
 */

var Prism = (function(){

// Private helper vars
var lang = /\blang(?:uage)?-(\w+)\b/i;
var uniqueId = 0;

var _ = _self.Prism = {
	manual: _self.Prism && _self.Prism.manual,
	disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
	util: {
		encode: function (tokens) {
			if (tokens instanceof Token) {
				return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
			} else if (_.util.type(tokens) === 'Array') {
				return tokens.map(_.util.encode);
			} else {
				return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
			}
		},

		type: function (o) {
			return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
		},

		objId: function (obj) {
			if (!obj['__id']) {
				Object.defineProperty(obj, '__id', { value: ++uniqueId });
			}
			return obj['__id'];
		},

		// Deep clone a language definition (e.g. to extend it)
		clone: function (o) {
			var type = _.util.type(o);

			switch (type) {
				case 'Object':
					var clone = {};

					for (var key in o) {
						if (o.hasOwnProperty(key)) {
							clone[key] = _.util.clone(o[key]);
						}
					}

					return clone;

				case 'Array':
					return o.map(function(v) { return _.util.clone(v); });
			}

			return o;
		}
	},

	languages: {
		extend: function (id, redef) {
			var lang = _.util.clone(_.languages[id]);

			for (var key in redef) {
				lang[key] = redef[key];
			}

			return lang;
		},

		/**
		 * Insert a token before another token in a language literal
		 * As this needs to recreate the object (we cannot actually insert before keys in object literals),
		 * we cannot just provide an object, we need anobject and a key.
		 * @param inside The key (or language id) of the parent
		 * @param before The key to insert before. If not provided, the function appends instead.
		 * @param insert Object with the key/value pairs to insert
		 * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
		 */
		insertBefore: function (inside, before, insert, root) {
			root = root || _.languages;
			var grammar = root[inside];

			if (arguments.length == 2) {
				insert = arguments[1];

				for (var newToken in insert) {
					if (insert.hasOwnProperty(newToken)) {
						grammar[newToken] = insert[newToken];
					}
				}

				return grammar;
			}

			var ret = {};

			for (var token in grammar) {

				if (grammar.hasOwnProperty(token)) {

					if (token == before) {

						for (var newToken in insert) {

							if (insert.hasOwnProperty(newToken)) {
								ret[newToken] = insert[newToken];
							}
						}
					}

					ret[token] = grammar[token];
				}
			}

			// Update references in other language definitions
			_.languages.DFS(_.languages, function(key, value) {
				if (value === root[inside] && key != inside) {
					this[key] = ret;
				}
			});

			return root[inside] = ret;
		},

		// Traverse a language definition with Depth First Search
		DFS: function(o, callback, type, visited) {
			visited = visited || {};
			for (var i in o) {
				if (o.hasOwnProperty(i)) {
					callback.call(o, i, o[i], type || i);

					if (_.util.type(o[i]) === 'Object' && !visited[_.util.objId(o[i])]) {
						visited[_.util.objId(o[i])] = true;
						_.languages.DFS(o[i], callback, null, visited);
					}
					else if (_.util.type(o[i]) === 'Array' && !visited[_.util.objId(o[i])]) {
						visited[_.util.objId(o[i])] = true;
						_.languages.DFS(o[i], callback, i, visited);
					}
				}
			}
		}
	},
	plugins: {},

	highlightAll: function(async, callback) {
		_.highlightAllUnder(document, async, callback);
	},

	highlightAllUnder: function(container, async, callback) {
		var env = {
			callback: callback,
			selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
		};

		_.hooks.run("before-highlightall", env);

		var elements = env.elements || container.querySelectorAll(env.selector);

		for (var i=0, element; element = elements[i++];) {
			_.highlightElement(element, async === true, env.callback);
		}
	},

	highlightElement: function(element, async, callback) {
		// Find language
		var language, grammar, parent = element;

		while (parent && !lang.test(parent.className)) {
			parent = parent.parentNode;
		}

		if (parent) {
			language = (parent.className.match(lang) || [,''])[1].toLowerCase();
			grammar = _.languages[language];
		}

		// Set language on the element, if not present
		element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;

		if (element.parentNode) {
			// Set language on the parent, for styling
			parent = element.parentNode;

			if (/pre/i.test(parent.nodeName)) {
				parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
			}
		}

		var code = element.textContent;

		var env = {
			element: element,
			language: language,
			grammar: grammar,
			code: code
		};

		_.hooks.run('before-sanity-check', env);

		if (!env.code || !env.grammar) {
			if (env.code) {
				_.hooks.run('before-highlight', env);
				env.element.textContent = env.code;
				_.hooks.run('after-highlight', env);
			}
			_.hooks.run('complete', env);
			return;
		}

		_.hooks.run('before-highlight', env);

		if (async && _self.Worker) {
			var worker = new Worker(_.filename);

			worker.onmessage = function(evt) {
				env.highlightedCode = evt.data;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				callback && callback.call(env.element);
				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
			};

			worker.postMessage(JSON.stringify({
				language: env.language,
				code: env.code,
				immediateClose: true
			}));
		}
		else {
			env.highlightedCode = _.highlight(env.code, env.grammar, env.language);

			_.hooks.run('before-insert', env);

			env.element.innerHTML = env.highlightedCode;

			callback && callback.call(element);

			_.hooks.run('after-highlight', env);
			_.hooks.run('complete', env);
		}
	},

	highlight: function (text, grammar, language) {
		var tokens = _.tokenize(text, grammar);
		return Token.stringify(_.util.encode(tokens), language);
	},

	matchGrammar: function (text, strarr, grammar, index, startPos, oneshot, target) {
		var Token = _.Token;

		for (var token in grammar) {
			if(!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			if (token == target) {
				return;
			}

			var patterns = grammar[token];
			patterns = (_.util.type(patterns) === "Array") ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				var pattern = patterns[j],
					inside = pattern.inside,
					lookbehind = !!pattern.lookbehind,
					greedy = !!pattern.greedy,
					lookbehindLength = 0,
					alias = pattern.alias;

				if (greedy && !pattern.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
					pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
				}

				pattern = pattern.pattern || pattern;

				// Don’t cache length as it changes during the loop
				for (var i = index, pos = startPos; i < strarr.length; pos += strarr[i].length, ++i) {

					var str = strarr[i];

					if (strarr.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					pattern.lastIndex = 0;

					var match = pattern.exec(str),
					    delNum = 1;

					// Greedy patterns can override/remove up to two previously matched tokens
					if (!match && greedy && i != strarr.length - 1) {
						pattern.lastIndex = pos;
						match = pattern.exec(text);
						if (!match) {
							break;
						}

						var from = match.index + (lookbehind ? match[1].length : 0),
						    to = match.index + match[0].length,
						    k = i,
						    p = pos;

						for (var len = strarr.length; k < len && (p < to || (!strarr[k].type && !strarr[k - 1].greedy)); ++k) {
							p += strarr[k].length;
							// Move the index i to the element in strarr that is closest to from
							if (from >= p) {
								++i;
								pos = p;
							}
						}

						/*
						 * If strarr[i] is a Token, then the match starts inside another Token, which is invalid
						 * If strarr[k - 1] is greedy we are in conflict with another greedy pattern
						 */
						if (strarr[i] instanceof Token || strarr[k - 1].greedy) {
							continue;
						}

						// Number of tokens to delete and replace with the new match
						delNum = k - i;
						str = text.slice(pos, p);
						match.index -= pos;
					}

					if (!match) {
						if (oneshot) {
							break;
						}

						continue;
					}

					if(lookbehind) {
						lookbehindLength = match[1].length;
					}

					var from = match.index + lookbehindLength,
					    match = match[0].slice(lookbehindLength),
					    to = from + match.length,
					    before = str.slice(0, from),
					    after = str.slice(to);

					var args = [i, delNum];

					if (before) {
						++i;
						pos += before.length;
						args.push(before);
					}

					var wrapped = new Token(token, inside? _.tokenize(match, inside) : match, alias, match, greedy);

					args.push(wrapped);

					if (after) {
						args.push(after);
					}

					Array.prototype.splice.apply(strarr, args);

					if (delNum != 1)
						_.matchGrammar(text, strarr, grammar, i, pos, true, token);

					if (oneshot)
						break;
				}
			}
		}
	},

	tokenize: function(text, grammar, language) {
		var strarr = [text];

		var rest = grammar.rest;

		if (rest) {
			for (var token in rest) {
				grammar[token] = rest[token];
			}

			delete grammar.rest;
		}

		_.matchGrammar(text, strarr, grammar, 0, 0, false);

		return strarr;
	},

	hooks: {
		all: {},

		add: function (name, callback) {
			var hooks = _.hooks.all;

			hooks[name] = hooks[name] || [];

			hooks[name].push(callback);
		},

		run: function (name, env) {
			var callbacks = _.hooks.all[name];

			if (!callbacks || !callbacks.length) {
				return;
			}

			for (var i=0, callback; callback = callbacks[i++];) {
				callback(env);
			}
		}
	}
};

var Token = _.Token = function(type, content, alias, matchedStr, greedy) {
	this.type = type;
	this.content = content;
	this.alias = alias;
	// Copy of the full string this token was created from
	this.length = (matchedStr || "").length|0;
	this.greedy = !!greedy;
};

Token.stringify = function(o, language, parent) {
	if (typeof o == 'string') {
		return o;
	}

	if (_.util.type(o) === 'Array') {
		return o.map(function(element) {
			return Token.stringify(element, language, o);
		}).join('');
	}

	var env = {
		type: o.type,
		content: Token.stringify(o.content, language, parent),
		tag: 'span',
		classes: ['token', o.type],
		attributes: {},
		language: language,
		parent: parent
	};

	if (o.alias) {
		var aliases = _.util.type(o.alias) === 'Array' ? o.alias : [o.alias];
		Array.prototype.push.apply(env.classes, aliases);
	}

	_.hooks.run('wrap', env);

	var attributes = Object.keys(env.attributes).map(function(name) {
		return name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
	}).join(' ');

	return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';

};

if (!_self.document) {
	if (!_self.addEventListener) {
		// in Node.js
		return _self.Prism;
	}

	if (!_.disableWorkerMessageHandler) {
		// In worker
		_self.addEventListener('message', function (evt) {
			var message = JSON.parse(evt.data),
				lang = message.language,
				code = message.code,
				immediateClose = message.immediateClose;

			_self.postMessage(_.highlight(code, _.languages[lang], lang));
			if (immediateClose) {
				_self.close();
			}
		}, false);
	}

	return _self.Prism;
}

//Get current script and highlight
var script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();

if (script) {
	_.filename = script.src;

	if (!_.manual && !script.hasAttribute('data-manual')) {
		if(document.readyState !== "loading") {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(_.highlightAll);
			} else {
				window.setTimeout(_.highlightAll, 16);
			}
		}
		else {
			document.addEventListener('DOMContentLoaded', _.highlightAll);
		}
	}
}

return _self.Prism;

})();

if (typeof module !== 'undefined' && module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof global !== 'undefined') {
	global.Prism = Prism;
}


/* **********************************************
     Begin prism-markup.js
********************************************** */

Prism.languages.markup = {
	'comment': /<!--[\s\S]*?-->/,
	'prolog': /<\?[\s\S]+?\?>/,
	'doctype': /<!DOCTYPE[\s\S]+?>/i,
	'cdata': /<!\[CDATA\[[\s\S]*?]]>/i,
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/i,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'attr-value': {
				pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,
				inside: {
					'punctuation': [
						/^=/,
						{
							pattern: /(^|[^\\])["']/,
							lookbehind: true
						}
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': /&#?[\da-z]{1,8};/i
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function(env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Prism.languages.xml = Prism.languages.markup;
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;


/* **********************************************
     Begin prism-css.js
********************************************** */

Prism.languages.css = {
	'comment': /\/\*[\s\S]*?\*\//,
	'atrule': {
		pattern: /@[\w-]+?.*?(?:;|(?=\s*\{))/i,
		inside: {
			'rule': /@[\w-]+/
			// See rest below
		}
	},
	'url': /url\((?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
	'selector': /[^{}\s][^{};]*?(?=\s*\{)/,
	'string': {
		pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'property': /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
	'important': /\B!important\b/i,
	'function': /[-a-z0-9]+(?=\()/i,
	'punctuation': /[(){};:]/
};

Prism.languages.css['atrule'].inside.rest = Prism.util.clone(Prism.languages.css);

if (Prism.languages.markup) {
	Prism.languages.insertBefore('markup', 'tag', {
		'style': {
			pattern: /(<style[\s\S]*?>)[\s\S]*?(?=<\/style>)/i,
			lookbehind: true,
			inside: Prism.languages.css,
			alias: 'language-css',
			greedy: true
		}
	});

	Prism.languages.insertBefore('inside', 'attr-value', {
		'style-attr': {
			pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
			inside: {
				'attr-name': {
					pattern: /^\s*style/i,
					inside: Prism.languages.markup.tag.inside
				},
				'punctuation': /^\s*=\s*['"]|['"]\s*$/,
				'attr-value': {
					pattern: /.+/i,
					inside: Prism.languages.css
				}
			},
			alias: 'language-css'
		}
	}, Prism.languages.markup.tag);
}

/* **********************************************
     Begin prism-clike.js
********************************************** */

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
		lookbehind: true,
		inside: {
			punctuation: /[.\\]/
		}
	},
	'keyword': /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
	'boolean': /\b(?:true|false)\b/,
	'function': /[a-z0-9_]+(?=\()/i,
	'number': /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i,
	'operator': /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
	'punctuation': /[{}[\];(),.:]/
};


/* **********************************************
     Begin prism-javascript.js
********************************************** */

Prism.languages.javascript = Prism.languages.extend('clike', {
	'keyword': /\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
	'number': /\b-?(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+|\d*\.?\d+(?:[Ee][+-]?\d+)?|NaN|Infinity)\b/,
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*\()/i,
	'operator': /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
});

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: /(^|[^/])\/(?!\/)(\[[^\]\r\n]+]|\\.|[^/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
		lookbehind: true,
		greedy: true
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)|[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/i,
		alias: 'function'
	}
});

Prism.languages.insertBefore('javascript', 'string', {
	'template-string': {
		pattern: /`(?:\\[\s\S]|[^\\`])*`/,
		greedy: true,
		inside: {
			'interpolation': {
				pattern: /\$\{[^}]+\}/,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	}
});

if (Prism.languages.markup) {
	Prism.languages.insertBefore('markup', 'tag', {
		'script': {
			pattern: /(<script[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript,
			alias: 'language-javascript',
			greedy: true
		}
	});
}

Prism.languages.js = Prism.languages.javascript;


/* **********************************************
     Begin prism-file-highlight.js
********************************************** */

(function () {
	if (typeof self === 'undefined' || !self.Prism || !self.document || !document.querySelector) {
		return;
	}

	self.Prism.fileHighlight = function() {

		var Extensions = {
			'js': 'javascript',
			'py': 'python',
			'rb': 'ruby',
			'ps1': 'powershell',
			'psm1': 'powershell',
			'sh': 'bash',
			'bat': 'batch',
			'h': 'c',
			'tex': 'latex'
		};

		Array.prototype.slice.call(document.querySelectorAll('pre[data-src]')).forEach(function (pre) {
			var src = pre.getAttribute('data-src');

			var language, parent = pre;
			var lang = /\blang(?:uage)?-(?!\*)(\w+)\b/i;
			while (parent && !lang.test(parent.className)) {
				parent = parent.parentNode;
			}

			if (parent) {
				language = (pre.className.match(lang) || [, ''])[1];
			}

			if (!language) {
				var extension = (src.match(/\.(\w+)$/) || [, ''])[1];
				language = Extensions[extension] || extension;
			}

			var code = document.createElement('code');
			code.className = 'language-' + language;

			pre.textContent = '';

			code.textContent = 'Loading…';

			pre.appendChild(code);

			var xhr = new XMLHttpRequest();

			xhr.open('GET', src, true);

			xhr.onreadystatechange = function () {
				if (xhr.readyState == 4) {

					if (xhr.status < 400 && xhr.responseText) {
						code.textContent = xhr.responseText;

						Prism.highlightElement(code);
					}
					else if (xhr.status >= 400) {
						code.textContent = '✖ Error ' + xhr.status + ' while fetching file: ' + xhr.statusText;
					}
					else {
						code.textContent = '✖ Error: File does not exist or is empty';
					}
				}
			};

			xhr.send(null);
		});

	};

	document.addEventListener('DOMContentLoaded', self.Prism.fileHighlight);

})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"comment":"_3k5Do"};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _draftJs = __webpack_require__(10);

var _textEditorCodeBlock = __webpack_require__(790);

var _textEditorCodeBlock2 = _interopRequireDefault(_textEditorCodeBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TextEditorCodeBlock = function TextEditorCodeBlock(_ref) {
  var backgroundColor = _ref.blockProps.backgroundColor,
      rest = _objectWithoutProperties(_ref, ['blockProps']);

  return _react2.default.createElement(
    'pre',
    { className: _textEditorCodeBlock2.default.container },
    _react2.default.createElement(
      'div',
      { className: _textEditorCodeBlock2.default.code, style: { backgroundColor: backgroundColor } },
      _react2.default.createElement(_draftJs.EditorBlock, rest)
    )
  );
};

TextEditorCodeBlock.propTypes = {
  blockProps: _propTypes2.default.object
};

exports.default = TextEditorCodeBlock;

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2gTM8","code":"_6mJo9"};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */

// Taken from https://github.com/draft-js-plugins/draft-js-plugins/blob/master/draft-js-hashtag-plugin/src/utils/hashtagRegex.js

// Some minimizers convert string escapes into their literal values, which leads to intermittent Unicode normalization bugs and
// increases the gzipped download size. Use RegEx literals as opposed to string literals to prevent that.
var unicodeLettersAndMarks = /A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u192B\u1930-\u193B\u19B0-\u19C0\u19C8\u19C9\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2D/.source;
var unicodeNumbers = /0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19/.source;
var hashtagSpecialChars = /_\u200c\u200d\ua67e\u05be\u05f3\u05f4\uff5e\u301c\u309b\u309c\u30a0\u30fb\u3003\u0f0b\u0f0c\u00b7/.source;

// Twitter considers a valid hashtag to be one that contains at least one:
// - unicode letter or mark
// - numbers, underscores, and select special characters
var regexes = {};
regexes.hashSigns = /[#＃]/;
regexes.hashtagAlpha = new RegExp('[' + unicodeLettersAndMarks + ']');
regexes.hashtagAlphaNumeric = new RegExp('[' + unicodeLettersAndMarks + unicodeNumbers + hashtagSpecialChars + ']');
regexes.endHashtagMatch = regexSupplant(/^(?:#{hashSigns}|:\/\/)/);
regexes.hashtagBoundary = new RegExp('(?:^|$|[^&' + unicodeLettersAndMarks + unicodeNumbers + hashtagSpecialChars + '])');
regexes.validHashtag = regexSupplant(/(#{hashtagBoundary})(#{hashSigns})(?!\ufe0f|\u20e3)(#{hashtagAlphaNumeric}*#{hashtagAlpha}#{hashtagAlphaNumeric}*)/gi);

// A function that composes regexes together
function regexSupplant(regex, flags) {
  flags = flags || '';
  if (typeof regex !== 'string') {
    if (regex.global && flags.indexOf('g') < 0) {
      flags += 'g';
    }
    if (regex.ignoreCase && flags.indexOf('i') < 0) {
      flags += 'i';
    }
    if (regex.multiline && flags.indexOf('m') < 0) {
      flags += 'm';
    }

    regex = regex.source;
  }

  return new RegExp(regex.replace(/#\{(\w+)\}/g, function (match, name) {
    var newRegex = regexes[name] || '';
    if (typeof newRegex !== 'string') {
      newRegex = newRegex.source;
    }
    return newRegex;
  }), flags);
}

exports.default = regexes;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hashtagStrategy;

var _lodash = __webpack_require__(2);

var _extractHashtags = __webpack_require__(359);

var _extractHashtags2 = _interopRequireDefault(_extractHashtags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hashtagStrategy(contentBlock, callback) {
  var results = (0, _extractHashtags2.default)(contentBlock.getText());
  (0, _lodash.forEach)(results, function (hashtag) {
    return callback(hashtag.indices[0], hashtag.indices[1]);
  });
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLinkDecorator;

var _linkifyIt = __webpack_require__(344);

var _linkifyIt2 = _interopRequireDefault(_linkifyIt);

var _decorateComponentWithProps = __webpack_require__(51);

var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);

var _textEditorLink = __webpack_require__(794);

var _textEditorLink2 = _interopRequireDefault(_textEditorLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkify = (0, _linkifyIt2.default)();

function createLinkDecorator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ignoredBlockType = _ref.ignoredBlockTypes,
      ignoredBlockTypes = _ref$ignoredBlockType === undefined ? [] : _ref$ignoredBlockType,
      theme = _ref.theme,
      followLinks = _ref.followLinks;

  return {
    strategy: function strategy(contentBlock, callback) {
      if (ignoredBlockTypes.indexOf(contentBlock.getType()) > -1) {
        return;
      }

      var links = linkify.match(contentBlock.get('text'));
      if (typeof links !== 'undefined' && links !== null) {
        for (var i = 0; i < links.length; i += 1) {
          callback(links[i].index, links[i].lastIndex);
        }
      }
    },
    component: (0, _decorateComponentWithProps2.default)(_textEditorLink2.default, { theme: theme, followLinks: followLinks })
  };
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(237);

var _index2 = _interopRequireDefault(_index);

var _formatUrl = __webpack_require__(238);

var _formatUrl2 = _interopRequireDefault(_formatUrl);

var _textEditorLink = __webpack_require__(795);

var _textEditorLink2 = _interopRequireDefault(_textEditorLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TextEditorLink = function TextEditorLink(_ref) {
  var children = _ref.children,
      decoratedText = _ref.decoratedText,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ['children', 'decoratedText', 'theme']);

  return _react2.default.createElement(
    _index2.default,
    _extends({ className: (0, _classnames2.default)(_textEditorLink2.default.container, theme), href: (0, _formatUrl2.default)(decoratedText) }, otherProps),
    children
  );
};

TextEditorLink.propTypes = {
  children: _propTypes2.default.node,
  decoratedText: _propTypes2.default.string,
  theme: _propTypes2.default.string
};

exports.default = TextEditorLink;

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2gaIj"};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLinkEntityDecorator;

var _decorateComponentWithProps = __webpack_require__(51);

var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);

var _textEditorEntityLink = __webpack_require__(797);

var _textEditorEntityLink2 = _interopRequireDefault(_textEditorEntityLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function strategy(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
}

function createLinkEntityDecorator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      theme = _ref.theme,
      followLinks = _ref.followLinks;

  return {
    strategy: strategy,
    component: (0, _decorateComponentWithProps2.default)(_textEditorEntityLink2.default, { theme: theme, followLinks: followLinks })
  };
}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _externalLink = __webpack_require__(237);

var _externalLink2 = _interopRequireDefault(_externalLink);

var _formatUrl = __webpack_require__(238);

var _formatUrl2 = _interopRequireDefault(_formatUrl);

var _textEditorEntityLink = __webpack_require__(798);

var _textEditorEntityLink2 = _interopRequireDefault(_textEditorEntityLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextEditorEntityLink = function TextEditorEntityLink(_ref) {
  var children = _ref.children,
      entityKey = _ref.entityKey,
      contentState = _ref.contentState,
      theme = _ref.theme,
      followLinks = _ref.followLinks;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      url = _contentState$getEnti.url;

  return _react2.default.createElement(
    _externalLink2.default,
    { className: (0, _classnames2.default)(_textEditorEntityLink2.default.container, theme), href: (0, _formatUrl2.default)(url), followLinks: followLinks },
    children
  );
};

TextEditorEntityLink.propTypes = {
  children: _propTypes2.default.node,
  entityKey: _propTypes2.default.string,
  contentState: _propTypes2.default.object,
  theme: _propTypes2.default.string,
  followLinks: _propTypes2.default.bool
};

exports.default = TextEditorEntityLink;

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wAGW"};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TextEditorTitleWrapper = function TextEditorTitleWrapper(_ref) {
  var theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ['theme']);

  return _react2.default.createElement('div', _extends({ className: (0, _lodash.get)(theme, 'container') }, rest));
};

TextEditorTitleWrapper.propTypes = {
  theme: _propTypes2.default.object
};

exports.default = TextEditorTitleWrapper;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextEditor = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(14);

var _draftJs = __webpack_require__(10);

var _draftJsPluginsEditor = __webpack_require__(340);

var _draftJsPluginsEditor2 = _interopRequireDefault(_draftJsPluginsEditor);

var _draftJsDragNDropPlugin = __webpack_require__(341);

var _draftJsDragNDropPlugin2 = _interopRequireDefault(_draftJsDragNDropPlugin);

var _draftJsFocusPlugin = __webpack_require__(801);

var _draftJsFocusPlugin2 = _interopRequireDefault(_draftJsFocusPlugin);

var _reactRedux = __webpack_require__(5);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _decorateComponentWithProps = __webpack_require__(51);

var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);

var _experiments = __webpack_require__(32);

var _wixParams = __webpack_require__(24);

var _openModal = __webpack_require__(36);

var _insertTextEditorEntity = __webpack_require__(167);

var _updateTextEditor = __webpack_require__(261);

var _inlineToolbarShown = __webpack_require__(408);

var _upload = __webpack_require__(171);

var _setTextEditorEntityData = __webpack_require__(125);

var _updateTextEditorVideoEmbed = __webpack_require__(808);

var _uploadStarted = __webpack_require__(231);

var _uploadEnded = __webpack_require__(230);

var _textEditorImage = __webpack_require__(343);

var _textEditorImage2 = _interopRequireDefault(_textEditorImage);

var _textEditorHashtag = __webpack_require__(347);

var _textEditorHashtag2 = _interopRequireDefault(_textEditorHashtag);

var _textEditorVideoEmbed = __webpack_require__(345);

var _textEditorVideoEmbed2 = _interopRequireDefault(_textEditorVideoEmbed);

var _textEditorInlineToolbar = __webpack_require__(809);

var _textEditorInlineToolbar2 = _interopRequireDefault(_textEditorInlineToolbar);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withSettingsColor = __webpack_require__(68);

var _withSettingsColor2 = _interopRequireDefault(_withSettingsColor);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _image = __webpack_require__(348);

var _image2 = _interopRequireDefault(_image);

var _videoEmbed = __webpack_require__(349);

var _videoEmbed2 = _interopRequireDefault(_videoEmbed);

var _mediaBlock = __webpack_require__(350);

var _mediaBlock2 = _interopRequireDefault(_mediaBlock);

var _codeBlock = __webpack_require__(354);

var _codeBlock2 = _interopRequireDefault(_codeBlock);

var _hashtag = __webpack_require__(240);

var _hashtag2 = _interopRequireDefault(_hashtag);

var _textEditorSelectors = __webpack_require__(236);

var _userAgentSelectors = __webpack_require__(813);

var _textEditorUtils = __webpack_require__(66);

var _textSelectionUtils = __webpack_require__(814);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _getToolbarPosition = __webpack_require__(351);

var _getToolbarPosition2 = _interopRequireDefault(_getToolbarPosition);

var _resizeImage = __webpack_require__(271);

var _resizeImage2 = _interopRequireDefault(_resizeImage);

var _createTextEditorDecorator = __webpack_require__(360);

var _createTextEditorDecorator2 = _interopRequireDefault(_createTextEditorDecorator);

var _createBlockRenderMap = __webpack_require__(361);

var _createBlockRenderMap2 = _interopRequireDefault(_createBlockRenderMap);

var _keyBindings = __webpack_require__(815);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditor = exports.TextEditor = function (_Component) {
  _inherits(TextEditor, _Component);

  function TextEditor(props) {
    _classCallCheck(this, TextEditor);

    var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this, props));

    _initialiseProps.call(_this);

    var mediaBlockPlugin = (0, _mediaBlock2.default)(_extends({
      onUpload: _this.handleImageChange,
      onFileSelect: _this.handleFileSelect,
      onVideoEmbedChange: _this.handleVideoEmbedChange,
      isDesktop: props.isDesktop,
      getEditorRef: function getEditorRef() {
        return _this.editor;
      },
      theme: (0, _lodash.get)(props.theme, 'mediaBlock')
    }, (0, _lodash.get)(props.config, 'mediaBlock')));
    _this.MediaBlockEditor = mediaBlockPlugin.MediaBlockEditor;

    var dndPlugin = (0, _draftJsDragNDropPlugin2.default)();
    var focusPlugin = (0, _draftJsFocusPlugin2.default)({
      theme: (0, _lodash.get)(props.theme, 'focus')
    });

    var imagePlugin = (0, _image2.default)({
      Image: _textEditorImage2.default,
      decorator: (0, _draftJsPluginsEditor.composeDecorators)(focusPlugin.decorator, mediaBlockPlugin.decorator, dndPlugin.decorator)
    });

    var videoEmbedPlugin = (0, _videoEmbed2.default)({
      VideoEmbed: _textEditorVideoEmbed2.default,
      decorator: (0, _draftJsPluginsEditor.composeDecorators)(focusPlugin.decorator, mediaBlockPlugin.decorator, dndPlugin.decorator)
    });

    _this.plugins = [focusPlugin, mediaBlockPlugin, dndPlugin, imagePlugin, videoEmbedPlugin];

    _this.blockRenderMap = (0, _createBlockRenderMap2.default)({ titleTheme: (0, _lodash.get)(props.theme, 'title') });

    if (props.isCodeBlockEnabled) {
      _this.plugins.push((0, _codeBlock2.default)({
        backgroundColor: props.codeBackgroundColor
      }));
    }

    if (props.enableHashtags) {
      _this.plugins.push((0, _hashtag2.default)({
        Hashtag: (0, _decorateComponentWithProps2.default)(_textEditorHashtag2.default, {
          theme: (0, _lodash.get)(props.theme, 'hashtag')
        })
      }));
    }

    _this.decorators = [(0, _createTextEditorDecorator2.default)({ theme: props.theme })];

    _this.state = {
      editorState: (0, _textEditorUtils.createEditorState)(_this.props.initialValue),
      inlineToolbar: {
        isVisible: false
      }
    };
    return _this;
  }

  return TextEditor;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.componentDidMount = function () {
    _this2.props.autoFocus && _this2.editor.focus();
  };

  this.componentWillReceiveProps = function (_ref) {
    var editorState = _ref.editorState,
        initialValue = _ref.initialValue;

    if (editorState && editorState !== _this2.props.editorState) {
      _this2.handleEditorChange(editorState);
    }

    if (_this2.props.initialValue !== initialValue && initialValue) {
      var decorator = _this2.state.editorState.getDecorator();
      _this2.handleEditorChange((0, _textEditorUtils.createEditorState)(initialValue, decorator));
    }
  };

  this.componentDidUpdate = function (prevProps, _ref2) {
    var editorState = _ref2.editorState,
        inlineToolbar = _ref2.inlineToolbar;

    var hasFocus = _this2.state.editorState && _this2.state.editorState.getSelection().getHasFocus();
    var hadFocus = editorState.getSelection().getHasFocus();
    if (hasFocus && !hadFocus) {
      _this2.editor.focus();
    }
    if (!inlineToolbar.isVisible && _this2.state.inlineToolbar.isVisible) {
      _this2.props.inlineToolbarShown(_this2.state.inlineToolbar.isVisible);
    }
  };

  this.setEditor = function (ref) {
    return _this2.editor = ref;
  };

  this.setContainer = function (ref) {
    return _this2.container = ref;
  };

  this.setInlineToolbar = function (ref) {
    return _this2.inlineToolbar = ref;
  };

  this.getEditableElement = function () {
    return _this2.editor ? (0, _reactDom.findDOMNode)(_this2.editor).querySelector('[contenteditable]') : null;
  };

  this.handleFileSelect = function (imageData) {
    var _props = _this2.props,
        insertTextEditorEntity = _props.insertTextEditorEntity,
        editorState = _props.editorState,
        identifier = _props.identifier;

    var props = { src: imageData };
    var entityKey = editorState.getCurrentContent().createEntity('IMAGE', 'IMMUTABLE', props).getLastCreatedEntityKey();

    insertTextEditorEntity({
      entityKey: entityKey,
      identifier: identifier
    });
  };

  this.handleImageChange = function (_ref3) {
    var file = _ref3.file,
        entityKey = _ref3.entityKey;

    _this2.props.uploadStarted({ type: _upload.TYPE_IMAGE });
    return (0, _resizeImage2.default)(file).then(function (imageData) {
      var _props2 = _this2.props,
          setTextEditorEntityData = _props2.setTextEditorEntityData,
          upload = _props2.upload,
          identifier = _props2.identifier,
          uploadEnded = _props2.uploadEnded;

      setTextEditorEntityData({
        entityData: {
          src: imageData,
          isLoading: true
        },
        entityKey: entityKey,
        identifier: identifier
      });

      var shouldUploadDataUrl = file.type !== 'image/gif';
      upload(shouldUploadDataUrl ? imageData.dataUrl : file, _upload.TYPE_IMAGE, function (file) {
        uploadEnded({ type: _upload.TYPE_IMAGE });
        return setTextEditorEntityData({
          entityData: {
            src: file,
            isLoading: false
          },
          entityKey: entityKey,
          identifier: identifier
        });
      });
    });
  };

  this.handleVideoEmbedChange = function (data) {
    return _this2.props.updateTextEditorVideoEmbed(_extends({}, data, {
      identifier: _this2.props.identifier
    }));
  };

  this.handleBackgroundMouseDown = function () {
    return _this2.shouldFocusContent = document.activeElement !== _this2.getEditableElement();
  };

  this.handleBackgroundClick = function (event) {
    if (_this2.shouldFocusContent) {
      _this2.editor.focus(); //tODO;
      return;
    }

    var editableElement = _this2.getEditableElement();
    var currentElement = event.target;
    var shouldBlur = true;

    while (currentElement) {
      if (currentElement === editableElement || currentElement === _this2.inlineToolbar) {
        shouldBlur = false;
        break;
      }
      currentElement = currentElement.parentNode;
    }

    if (shouldBlur) {
      _this2.editor.blur();
    }
  };

  this.handleReturn = function () {
    // prevents editor from crashing when enter is pressed while atomic block is focused
    if ((0, _textEditorUtils.isAtomicBlockFocused)(_this2.state.editorState)) {
      return 'handled';
    }
    return 'not-handled';
  };

  this.handleEditorChange = function (editorState) {
    var _props3 = _this2.props,
        onChange = _props3.onChange,
        updateTextEditor = _props3.updateTextEditor,
        identifier = _props3.identifier,
        isDesktop = _props3.isDesktop;


    _this2.setState({ editorState: editorState });
    updateTextEditor({ identifier: identifier, editorState: editorState });
    if (onChange) {
      onChange((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
    }

    var selection = editorState.getSelection();
    if (!selection.isCollapsed() && selection.getHasFocus() && isDesktop) {
      setTimeout(function () {
        // setTimeout is used here to get correct selection position
        var selectionRange = (0, _textSelectionUtils.getSelectionRange)(window.getSelection());
        if (!selectionRange) {
          _this2.hideInlineToolbar();
          return;
        }

        _this2.showInlineToolbar(selectionRange);
      });
    } else {
      _this2.hideInlineToolbar();
    }
  };

  this.showInlineToolbar = function (selectionRange) {
    _this2.setState({
      inlineToolbar: {
        isVisible: true,
        position: (0, _getToolbarPosition2.default)(_this2.container.getBoundingClientRect(), selectionRange.getBoundingClientRect(), _this2.inlineToolbar.children[0].getBoundingClientRect())
      }
    });
  };

  this.hideInlineToolbar = function () {
    _this2.setState({
      inlineToolbar: {
        isVisible: false
      }
    });
  };

  this.onKeyCommand = function (command) {
    var _props4 = _this2.props,
        editorState = _props4.editorState,
        openModal = _props4.openModal,
        identifier = _props4.identifier;

    return (0, _keyBindings.handleKeyCommand)({
      command: command,
      editorState: editorState,
      identifier: identifier,
      handleEditorChange: _this2.handleEditorChange,
      openModal: openModal
    });
  };

  this.onBeforeInput = function (chars) {
    var editorState = _this2.props.editorState;

    var selection = editorState.getSelection();

    // prevents editor from crashing when space is pressed while atomic block is focused
    if ((0, _textEditorUtils.isAtomicBlockFocused)(editorState) && chars === ' ') {
      return 'handled';
    }

    if (selection.isCollapsed() && !(0, _textEditorUtils.hasLinksInSelection)(editorState)) {
      var content = editorState.getCurrentContent();
      var inlineStyle = editorState.getCurrentInlineStyle();
      var newContent = _draftJs.Modifier.insertText(content, selection, chars, inlineStyle);
      var newState = _draftJs.EditorState.push(editorState, newContent, 'insert-characters');
      _this2.handleEditorChange(newState);
      return 'handled';
    }

    return 'not-handled';
  };

  this.renderInlineToolbar = function () {
    var inlineToolbar = _this2.state.inlineToolbar;
    var _props5 = _this2.props,
        identifier = _props5.identifier,
        theme = _props5.theme;


    return _react2.default.createElement(
      'div',
      { ref: _this2.setInlineToolbar, style: { display: inlineToolbar.isVisible ? 'block' : 'none' } },
      _react2.default.createElement(_textEditorInlineToolbar2.default, {
        position: inlineToolbar.position,
        identifier: identifier,
        theme: (0, _lodash.get)(theme, 'toolbar')
      })
    );
  };

  this.render = function () {
    var editorState = _this2.state.editorState;
    var _props6 = _this2.props,
        identifier = _props6.identifier,
        isCodeBlockEnabled = _props6.isCodeBlockEnabled,
        isMac = _props6.isMac,
        placeholder = _props6.placeholder,
        type = _props6.type,
        _props6$theme = _props6.theme,
        theme = _props6$theme === undefined ? {} : _props6$theme,
        t = _props6.t;

    var firstBlock = editorState.getCurrentContent().getBlockMap().first().toJSON();
    var firstBlockType = firstBlock.type;
    var firstBlockTextAlignment = firstBlock.data.textAlignment;
    var className = (0, _classnames2.default)('text-editor', (0, _lodash.get)(theme, 'container'), (0, _lodash.get)(theme, 'types.' + type), (0, _lodash.get)(theme, 'placeholder.' + firstBlockTextAlignment), _defineProperty({}, (0, _lodash.get)(theme, 'placeholder.hidden'), firstBlockType !== 'unstyled'));
    var MediaBlockEditor = _this2.MediaBlockEditor;


    return _react2.default.createElement(
      'div',
      {
        className: className,
        ref: _this2.setContainer,
        id: (0, _textEditorUtils.getFocusableContainerId)(identifier),
        role: 'form',
        'aria-label': (0, _keyBindings.keyBindingsLabel)({ isCodeBlockEnabled: isCodeBlockEnabled, isMac: isMac, t: t }),
        tabIndex: '0'
      },
      _this2.renderInlineToolbar(),
      _react2.default.createElement(_draftJsPluginsEditor2.default, {
        ref: _this2.setEditor,
        editorState: editorState,
        onChange: _this2.handleEditorChange,
        onFocus: _this2.props.onFocus,
        onBlur: _this2.props.onBlur,
        handleReturn: _this2.handleReturn //eslint-disable-line react/jsx-handler-names
        , handleKeyCommand: _this2.onKeyCommand,
        keyBindingFn: (0, _keyBindings.keyBindingFn)(isCodeBlockEnabled),
        handleBeforeInput: _this2.onBeforeInput,
        blockStyleFn: theme.blockStyleFn,
        blockRenderMap: _this2.blockRenderMap,
        placeholder: placeholder,
        plugins: _this2.plugins,
        decorators: _this2.decorators,
        spellCheck: true,
        autoCapitalize: 'off',
        autoComplete: 'off',
        autoCorrect: 'off'
      }),
      _react2.default.createElement(MediaBlockEditor, { theme: (0, _lodash.get)(theme, 'toolbar') })
    );
  };
};

TextEditor.propTypes = {
  autoFocus: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  editorState: _propTypes2.default.object,
  updateTextEditor: _propTypes2.default.func,
  upload: _propTypes2.default.func,
  uploadStarted: _propTypes2.default.func,
  uploadEnded: _propTypes2.default.func,
  setTextEditorEntityData: _propTypes2.default.func,
  updateTextEditorVideoEmbed: _propTypes2.default.func,
  TextEditorToolbar: _propTypes2.default.node,
  isDesktop: _propTypes2.default.bool,
  isMac: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  type: _propTypes2.default.string,
  inlineToolbarShown: _propTypes2.default.func,
  initialValue: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  identifier: _propTypes2.default.string.isRequired,
  isCodeBlockEnabled: _propTypes2.default.bool,
  enableHashtags: _propTypes2.default.bool,
  codeBackgroundColor: _propTypes2.default.string,
  theme: _propTypes2.default.object,
  config: _propTypes2.default.object,
  insertTextEditorEntity: _propTypes2.default.func,
  t: _propTypes2.default.func.isRequired,
  openModal: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    editorState: (0, _textEditorSelectors.getTextEditorStateByKey)(state, ownProps.identifier),
    isMac: (0, _userAgentSelectors.getIsMac)(state)
  };
};

var mapDispatchToProps = {
  openModal: _openModal.openModal,
  updateTextEditor: _updateTextEditor.updateTextEditor,
  inlineToolbarShown: _inlineToolbarShown.inlineToolbarShown,
  upload: _upload.upload,
  uploadStarted: _uploadStarted.uploadStarted,
  uploadEnded: _uploadEnded.uploadEnded,
  setTextEditorEntityData: _setTextEditorEntityData.setTextEditorEntityData,
  updateTextEditorVideoEmbed: _updateTextEditorVideoEmbed.updateTextEditorVideoEmbed,
  insertTextEditorEntity: _insertTextEditorEntity.insertTextEditorEntity
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _withExperiment2.default)({
  isCodeBlockEnabled: _experiments.EXPERIMENT_CODE_BLOCK
}), _withDeviceType2.default, (0, _withSettingsColor2.default)(_wixParams.APP_TEXT_COLOR_PATH, 'codeBackgroundColor', 'color-5', 0.1), _withTranslate2.default)(TextEditor);

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(10);

var _setSelection = __webpack_require__(802);

var _setSelection2 = _interopRequireDefault(_setSelection);

var _setSelectionToBlock = __webpack_require__(352);

var _setSelectionToBlock2 = _interopRequireDefault(_setSelectionToBlock);

var _createDecorator = __webpack_require__(803);

var _createDecorator2 = _interopRequireDefault(_createDecorator);

var _createBlockKeyStore = __webpack_require__(805);

var _createBlockKeyStore2 = _interopRequireDefault(_createBlockKeyStore);

var _blockInSelection = __webpack_require__(806);

var _blockInSelection2 = _interopRequireDefault(_blockInSelection);

var _getBlockMapKeys = __webpack_require__(362);

var _getBlockMapKeys2 = _interopRequireDefault(_getBlockMapKeys);

var _style = {
  "unfocused": "draftJsEmojiPlugin__unfocused__1Wvrs",
  "focused": "draftJsEmojiPlugin__focused__3Mksn"
};

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusableBlockIsSelected = function focusableBlockIsSelected(editorState, blockKeyStore) {
  var selection = editorState.getSelection();
  if (selection.getAnchorKey() !== selection.getFocusKey()) {
    return false;
  }
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(selection.getAnchorKey());
  return blockKeyStore.includes(block.getKey());
};

exports.default = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var blockKeyStore = (0, _createBlockKeyStore2.default)({});
  var theme = config.theme ? config.theme : _style2.default;
  var lastSelection = void 0;
  var lastContentState = void 0;

  return {
    onChange: function onChange(editorState) {
      // in case the content changed there is no need to re-render blockRendererFn
      // since if a block was added it will be rendered anyway and if it was text
      // then the change was not a pure selection change
      var contentState = editorState.getCurrentContent();
      if (!contentState.equals(lastContentState)) {
        lastContentState = contentState;
        return editorState;
      }
      lastContentState = contentState;

      // if the selection didn't change there is no need to re-render
      var selection = editorState.getSelection();
      if (lastSelection && selection.equals(lastSelection)) {
        lastSelection = editorState.getSelection();
        return editorState;
      }

      // Note: Only if the previous or current selection contained a focusableBlock a re-render is needed.
      var focusableBlockKeys = blockKeyStore.getAll();
      if (lastSelection) {
        var lastBlockMapKeys = (0, _getBlockMapKeys2.default)(contentState, lastSelection.getStartKey(), lastSelection.getEndKey());
        if (lastBlockMapKeys.some(function (key) {
          return focusableBlockKeys.includes(key);
        })) {
          lastSelection = selection;
          // By forcing the selection the editor will trigger the blockRendererFn which is
          // necessary for the blockProps containing isFocus to be passed down again.
          return _draftJs.EditorState.forceSelection(editorState, editorState.getSelection());
        }
      }

      var currentBlockMapKeys = (0, _getBlockMapKeys2.default)(contentState, selection.getStartKey(), selection.getEndKey());
      if (currentBlockMapKeys.some(function (key) {
        return focusableBlockKeys.includes(key);
      })) {
        lastSelection = selection;
        // By forcing the selection the editor will trigger the blockRendererFn which is
        // necessary for the blockProps containing isFocus to be passed down again.
        return _draftJs.EditorState.forceSelection(editorState, editorState.getSelection());
      }

      return editorState;
    },
    keyBindingFn: function keyBindingFn(evt, _ref) {
      var getEditorState = _ref.getEditorState,
          setEditorState = _ref.setEditorState;

      var editorState = getEditorState();
      // TODO match by entitiy instead of block type
      if (focusableBlockIsSelected(editorState, blockKeyStore)) {
        // arrow left
        if (evt.keyCode === 37) {
          (0, _setSelection2.default)(getEditorState, setEditorState, 'up', evt);
        }
        // arrow right
        if (evt.keyCode === 39) {
          (0, _setSelection2.default)(getEditorState, setEditorState, 'down', evt);
        }
      }

      // Don't manually overwrite in case the shift key is used to avoid breaking
      // native behaviour that works anyway.
      if (evt.shiftKey) {
        return;
      }

      // arrow left
      if (evt.keyCode === 37) {
        // Covering the case to select the before block
        var selection = editorState.getSelection();
        var selectionKey = selection.getAnchorKey();
        var beforeBlock = editorState.getCurrentContent().getBlockBefore(selectionKey);
        // only if the selection caret is a the left most position
        if (beforeBlock && selection.getAnchorOffset() === 0 && blockKeyStore.includes(beforeBlock.getKey())) {
          (0, _setSelection2.default)(getEditorState, setEditorState, 'up', evt);
        }
      }
      // arrow right
      if (evt.keyCode === 39) {
        // Covering the case to select the after block
        var _selection = editorState.getSelection();
        var _selectionKey = _selection.getFocusKey();
        var currentBlock = editorState.getCurrentContent().getBlockForKey(_selectionKey);
        var afterBlock = editorState.getCurrentContent().getBlockAfter(_selectionKey);
        var notAtomicAndLastPost = currentBlock.getType() !== 'atomic' && currentBlock.getLength() === _selection.getFocusOffset();
        if (afterBlock && notAtomicAndLastPost && blockKeyStore.includes(afterBlock.getKey())) {
          (0, _setSelection2.default)(getEditorState, setEditorState, 'down', evt);
        }
      }
    },

    // Wrap all block-types in block-focus decorator
    blockRendererFn: function blockRendererFn(contentBlock, _ref2) {
      var getEditorState = _ref2.getEditorState,
          setEditorState = _ref2.setEditorState;

      // This makes it mandatory to have atomic blocks for focus but also improves performance
      // since all the selection checks are not necessary.
      // In case there is a use-case where focus makes sense for none atomic blocks we can add it
      // in the future.
      if (contentBlock.getType() !== 'atomic') {
        return undefined;
      }

      var editorState = getEditorState();
      var isFocused = (0, _blockInSelection2.default)(editorState, contentBlock.getKey());

      return {
        props: {
          isFocused: isFocused,
          isCollapsedSelection: editorState.getSelection().isCollapsed(),
          setFocusToBlock: function setFocusToBlock() {
            (0, _setSelectionToBlock2.default)(getEditorState, setEditorState, contentBlock);
          }
        }
      };
    },
    // Handle down/up arrow events and set activeBlock/selection if necessary
    onDownArrow: function onDownArrow(event, _ref3) {
      var getEditorState = _ref3.getEditorState,
          setEditorState = _ref3.setEditorState;

      // TODO edgecase: if one block is selected and the user wants to expand the selection using the shift key

      var editorState = getEditorState();
      if (focusableBlockIsSelected(editorState, blockKeyStore)) {
        (0, _setSelection2.default)(getEditorState, setEditorState, 'down', event);
        return;
      }

      // Don't manually overwrite in case the shift key is used to avoid breaking
      // native behaviour that works anyway.
      if (event.shiftKey) {
        return;
      }

      // Covering the case to select the after block with arrow down
      var selectionKey = editorState.getSelection().getAnchorKey();
      var afterBlock = editorState.getCurrentContent().getBlockAfter(selectionKey);
      if (afterBlock && blockKeyStore.includes(afterBlock.getKey())) {
        (0, _setSelection2.default)(getEditorState, setEditorState, 'down', event);
      }
    },
    onUpArrow: function onUpArrow(event, _ref4) {
      var getEditorState = _ref4.getEditorState,
          setEditorState = _ref4.setEditorState;

      // TODO edgecase: if one block is selected and the user wants to expand the selection using the shift key

      var editorState = getEditorState();
      if (focusableBlockIsSelected(editorState, blockKeyStore)) {
        (0, _setSelection2.default)(getEditorState, setEditorState, 'up', event);
      }

      // Don't manually overwrite in case the shift key is used to avoid breaking
      // native behaviour that works anyway.
      if (event.shiftKey) {
        return;
      }

      // Covering the case to select the before block with arrow up
      var selectionKey = editorState.getSelection().getAnchorKey();
      var beforeBlock = editorState.getCurrentContent().getBlockBefore(selectionKey);
      if (beforeBlock && blockKeyStore.includes(beforeBlock.getKey())) {
        (0, _setSelection2.default)(getEditorState, setEditorState, 'up', event);
      }
    },
    decorator: (0, _createDecorator2.default)({ theme: theme, blockKeyStore: blockKeyStore })
  };
};

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(10);

var _DraftOffsetKey = __webpack_require__(353);

var _DraftOffsetKey2 = _interopRequireDefault(_DraftOffsetKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Set selection of editor to next/previous block
exports.default = function (getEditorState, setEditorState, mode, event) {
  var editorState = getEditorState();
  var selectionKey = editorState.getSelection().getAnchorKey();
  var newActiveBlock = mode === 'up' ? editorState.getCurrentContent().getBlockBefore(selectionKey) : editorState.getCurrentContent().getBlockAfter(selectionKey);

  if (newActiveBlock && newActiveBlock.get('key') === selectionKey) {
    return;
  }

  if (newActiveBlock) {
    // TODO verify that always a key-0-0 exists
    var offsetKey = _DraftOffsetKey2.default.encode(newActiveBlock.getKey(), 0, 0);
    var node = document.querySelectorAll('[data-offset-key="' + offsetKey + '"]')[0];
    // set the native selection to the node so the caret is not in the text and
    // the selectionState matches the native selection
    var selection = window.getSelection();
    var range = document.createRange();
    range.setStart(node, 0);
    range.setEnd(node, 0);
    selection.removeAllRanges();
    selection.addRange(range);

    var offset = mode === 'up' ? newActiveBlock.getLength() : 0;
    event.preventDefault();
    setEditorState(_draftJs.EditorState.forceSelection(editorState, new _draftJs.SelectionState({
      anchorKey: newActiveBlock.getKey(),
      anchorOffset: offset,
      focusKey: newActiveBlock.getKey(),
      focusOffset: offset,
      isBackward: false
    })));
  }
};

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _unionClassNames = __webpack_require__(804);

var _unionClassNames2 = _interopRequireDefault(_unionClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Get a component's display name
var getDisplayName = function getDisplayName(WrappedComponent) {
  var component = WrappedComponent.WrappedComponent || WrappedComponent;
  return component.displayName || component.name || 'Component';
};

exports.default = function (_ref) {
  var theme = _ref.theme,
      blockKeyStore = _ref.blockKeyStore;
  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(BlockFocusDecorator, _Component);

      function BlockFocusDecorator() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, BlockFocusDecorator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = BlockFocusDecorator.__proto__ || Object.getPrototypeOf(BlockFocusDecorator)).call.apply(_ref2, [this].concat(args))), _this), _this.onClick = function (evt) {
          evt.preventDefault();
          if (!_this.props.blockProps.isFocused) {
            _this.props.blockProps.setFocusToBlock();
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(BlockFocusDecorator, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          blockKeyStore.add(this.props.block.getKey());
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          blockKeyStore.remove(this.props.block.getKey());
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              blockProps = _props.blockProps,
              className = _props.className;
          var isFocused = blockProps.isFocused;

          var combinedClassName = isFocused ? (0, _unionClassNames2.default)(className, theme.focused) : (0, _unionClassNames2.default)(className, theme.unfocused);
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
            onClick: this.onClick,
            className: combinedClassName
          }));
        }
      }]);

      return BlockFocusDecorator;
    }(_react.Component), _class.displayName = 'BlockFocus(' + getDisplayName(WrappedComponent) + ')', _class.WrappedComponent = WrappedComponent.WrappedComponent || WrappedComponent, _temp2;
  };
};

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = unionClassNames;
/**
 * Returns the union of the passed-in arrays: the list of unique items, in order,
 * that are present in one or more of the arrays.
 *
 * @param {...array} arrs - at least two iterable objects must be provide
 */
var union = function union() {
  for (var _len = arguments.length, arrs = Array(_len), _key = 0; _key < _len; _key++) {
    arrs[_key] = arguments[_key];
  }

  if (arrs) {
    var _ret = function () {
      var result = [];
      arrs.forEach(function (arr) {
        if (arr) {
          arr.forEach(function (obj) {
            if (result.indexOf(obj) < 0) {
              result.push(obj);
            }
          });
        }
      });
      return {
        v: result
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }

  return undefined;
};

/**
 * Returns a string containing all classes without duplicates.
 *
 * @param existingClassNames {String} - one or multiple classes
 * @param additionalClassNames {String} - one or multiple classes
 *
 * @example
 * // returns 'style-id-23 button buy-button'
 * unionClassNames('style-id-23 button', 'button buy-button')
 *
 * Originally inspired by https://github.com/rackt/react-autocomplete/blob/master/lib/union-class-names.js
 */
function unionClassNames(existingClassNames, additionalClassNames) {
  if (!existingClassNames && !additionalClassNames) return '';
  if (!existingClassNames) return additionalClassNames;
  if (!additionalClassNames) return existingClassNames;
  return union(existingClassNames.split(' '), additionalClassNames.split(' ')).join(' ');
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(31);

var createBlockKeyStore = function createBlockKeyStore() {
  var keys = (0, _immutable.List)();

  var add = function add(key) {
    keys = keys.push(key);
    return keys;
  };

  var remove = function remove(key) {
    keys = keys.filter(function (item) {
      return item !== key;
    });
    return keys;
  };

  return {
    add: add,
    remove: remove,
    includes: function includes(key) {
      return keys.includes(key);
    },
    getAll: function getAll() {
      return keys;
    }
  };
};

exports.default = createBlockKeyStore;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getSelectedBlocksMapKeys = __webpack_require__(807);

var _getSelectedBlocksMapKeys2 = _interopRequireDefault(_getSelectedBlocksMapKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (editorState, blockKey) {
  var selectedBlocksKeys = (0, _getSelectedBlocksMapKeys2.default)(editorState);
  return selectedBlocksKeys.includes(blockKey);
};

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getBlockMapKeys = __webpack_require__(362);

var _getBlockMapKeys2 = _interopRequireDefault(_getBlockMapKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (editorState) {
  var selectionState = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  return (0, _getBlockMapKeys2.default)(contentState, selectionState.getStartKey(), selectionState.getEndKey());
};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTextEditorVideoEmbed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fetchOembed = __webpack_require__(363);

var _setTextEditorEntityData = __webpack_require__(125);

var _videoEmbed = __webpack_require__(146);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var updateTextEditorVideoEmbed = function updateTextEditorVideoEmbed(_ref) {
  var identifier = _ref.identifier,
      entityKey = _ref.entityKey,
      entityData = _objectWithoutProperties(_ref, ['identifier', 'entityKey']);

  return function (dispatch) {
    dispatch((0, _setTextEditorEntityData.setTextEditorEntityData)({
      identifier: identifier,
      entityKey: entityKey,
      entityData: _extends({
        oembed: null,
        isLoading: true
      }, entityData)
    }));

    var publicUrl = (0, _videoEmbed.buildUrl)(entityData.url);
    return dispatch((0, _fetchOembed.fetchOembed)(publicUrl)).then(function (oembed) {
      return dispatch((0, _setTextEditorEntityData.setTextEditorEntityData)({
        identifier: identifier,
        entityKey: entityKey,
        entityData: {
          oembed: oembed,
          isLoading: false
        }
      }));
    });
  };
};
exports.updateTextEditorVideoEmbed = updateTextEditorVideoEmbed;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(5);

var _buttons = __webpack_require__(53);

var _openModal = __webpack_require__(36);

var _separator = __webpack_require__(18);

var _textEditorButtonGroup = __webpack_require__(229);

var _textEditorButtonGroup2 = _interopRequireDefault(_textEditorButtonGroup);

var _textEditorToolbar = __webpack_require__(810);

var _textEditorToolbar2 = _interopRequireDefault(_textEditorToolbar);

var _experiments = __webpack_require__(32);

var _withExperiment = __webpack_require__(56);

var _withExperiment2 = _interopRequireDefault(_withExperiment);

var _textEditorInlineToolbar = __webpack_require__(812);

var _textEditorInlineToolbar2 = _interopRequireDefault(_textEditorInlineToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextEditorInlineToolbar = function TextEditorInlineToolbar(_ref) {
  var position = _ref.position,
      identifier = _ref.identifier,
      isCodeButtonVisible = _ref.isCodeButtonVisible,
      theme = _ref.theme;

  var buttons = (0, _lodash.map)(getGroups(isCodeButtonVisible), function (_ref2) {
    var buttons = _ref2.buttons,
        buttonClassName = _ref2.buttonClassName;
    return renderGroup(buttons, identifier, buttonClassName, (0, _lodash.get)(theme, 'button'));
  });
  var containerClassName = (0, _classnames2.default)(_textEditorInlineToolbar2.default.container, 'text-editor-inline-toolbar');

  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: position, onMouseDown: handleMouseDown },
    _react2.default.createElement(
      _textEditorToolbar2.default,
      { theme: theme },
      buttons
    )
  );
};

function handleMouseDown(event) {
  event.preventDefault();
}

function renderGroup(buttons, identifier, buttonClassName, theme) {
  return [_react2.default.createElement(_textEditorButtonGroup2.default, {
    key: 'group',
    buttons: buttons,
    containerClassName: _textEditorInlineToolbar2.default.group,
    buttonClassName: (0, _classnames2.default)(_textEditorInlineToolbar2.default.button, buttonClassName),
    theme: theme,
    identifier: identifier
  }), _react2.default.createElement(_separator.VerticalSeparator, { key: 'separator', className: _textEditorInlineToolbar2.default.separator })];
}

function getGroups(isCodeButtonVisible) {
  return [{
    buttons: [_buttons.BUTTON_BOLD, _buttons.BUTTON_ITALIC, _buttons.BUTTON_TITLE, _buttons.BUTTON_SUBTITLE]
  }, {
    buttons: isCodeButtonVisible ? [_buttons.BUTTON_ALIGN_TEXT_DROPDOWN, _buttons.BUTTON_NUMBERING, _buttons.BUTTON_BULLETS, _buttons.BUTTON_BLOCKQUOTE, _buttons.BUTTON_CODE_BLOCK] : [_buttons.BUTTON_ALIGN_TEXT_DROPDOWN, _buttons.BUTTON_NUMBERING, _buttons.BUTTON_BULLETS, _buttons.BUTTON_BLOCKQUOTE],
    buttonClassName: _textEditorInlineToolbar2.default.largeSpacings
  }, {
    buttons: [_buttons.BUTTON_LINK]
  }];
}

TextEditorInlineToolbar.propTypes = {
  position: _propTypes2.default.object,
  identifier: _propTypes2.default.string.isRequired,
  isCodeButtonVisible: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};

var mapDispatchToProps = {
  openModal: _openModal.openModal
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(undefined, mapDispatchToProps), (0, _withExperiment2.default)({ isCodeButtonVisible: _experiments.EXPERIMENT_CODE_BLOCK }))(TextEditorInlineToolbar);

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _textEditorToolbar = __webpack_require__(811);

var _textEditorToolbar2 = _interopRequireDefault(_textEditorToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextEditorToolbar = function TextEditorToolbar(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? {} : _ref$theme;

  var containerClassName = (0, _classnames2.default)(_textEditorToolbar2.default.container, theme.container);
  return _react2.default.createElement(
    'div',
    { className: containerClassName, style: theme.containerStyle },
    children
  );
};

TextEditorToolbar.propTypes = {
  children: _propTypes2.default.node,
  theme: _propTypes2.default.object
};

exports.default = TextEditorToolbar;

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"CinYi"};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1jsVB","group":"_2t5T7","button":"ptp5E","largeSpacings":"_6r7hM","separator":"_1jKyo"};

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getUserAgent = exports.getUserAgent = function getUserAgent(state) {
  return state.userAgent;
};
var getIsMac = exports.getIsMac = function getIsMac(state) {
  return getUserAgent(state).isMac;
};

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INLINE_TOOLBAR_WIDTH = 302;
var INLINE_TOOLBAR_HEIGHT = 50;
var GAP_SIZE = 5;
var ADJUSTMENT_OFFSET = exports.ADJUSTMENT_OFFSET = 40;

var getSelectionRange = exports.getSelectionRange = function getSelectionRange(selection) {
  if (selection.rangeCount === 0) {
    return null;
  }
  return selection.getRangeAt(0);
};

var getInlineToolbarPosition = exports.getInlineToolbarPosition = function getInlineToolbarPosition(selectionRange, editorElement) {
  var editorRect = editorElement.getBoundingClientRect();
  var rangeRect = selectionRange.getBoundingClientRect();
  var rangeWidth = rangeRect.right - rangeRect.left;

  var left = rangeRect.left - editorRect.left + rangeWidth / 2 - INLINE_TOOLBAR_WIDTH / 2 + ADJUSTMENT_OFFSET;
  var top = rangeRect.top - editorRect.top - INLINE_TOOLBAR_HEIGHT - GAP_SIZE;

  return { left: left, top: top };
};

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleKeyCommand = exports.keyBindingFn = exports.getButtonShortcuts = exports.getKeyMatch = exports.keyBindingsLabel = undefined;

var _BUTTON_HANDLERS;

var _lodash = __webpack_require__(2);

var _draftJs = __webpack_require__(10);

var _buttons = __webpack_require__(53);

var _buttonShortcuts = __webpack_require__(816);

var _blockTypeModifiers = __webpack_require__(327);

var _linkModifiers = __webpack_require__(328);

var _textAlignmentModifiers = __webpack_require__(329);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var bindToggleBlockType = function bindToggleBlockType(_ref) {
  var command = _ref.command,
      editorState = _ref.editorState;
  return (0, _blockTypeModifiers.toggleBlockType)(command, editorState);
};
var bindSetTextAlignment = function bindSetTextAlignment(_ref2) {
  var command = _ref2.command,
      editorState = _ref2.editorState;
  return (0, _textAlignmentModifiers.setTextAlignment)(command, editorState);
};

var BUTTON_HANDLERS = (_BUTTON_HANDLERS = {}, _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_TITLE, bindToggleBlockType), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_SUBTITLE, bindToggleBlockType), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_NUMBERING, bindToggleBlockType), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_BULLETS, bindToggleBlockType), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_BLOCKQUOTE, bindToggleBlockType), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_CODE_BLOCK, function (_ref3) {
  var command = _ref3.command,
      editorState = _ref3.editorState;
  return (0, _blockTypeModifiers.toggleBlockTypeAndEnsureSpaces)(command, editorState);
}), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_LINK, _linkModifiers.toggleLink), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_ALIGN_LEFT, bindSetTextAlignment), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_ALIGN_RIGHT, bindSetTextAlignment), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_ALIGN_CENTER, bindSetTextAlignment), _defineProperty(_BUTTON_HANDLERS, _buttons.BUTTON_ALIGN_JUSTIFY, bindSetTextAlignment), _BUTTON_HANDLERS);

// Update the shortcuts list on key bindings update!
var keyBindingsLabel = exports.keyBindingsLabel = function keyBindingsLabel(_ref4) {
  var isCodeBlockEnabled = _ref4.isCodeBlockEnabled,
      isMac = _ref4.isMac,
      t = _ref4.t;
  return (
    // prettier-ignore
    isCodeBlockEnabled ? isMac ? t('text-editor.enter-content-editor-mac') : t('text-editor.enter-content-editor') : isMac ? t('text-editor.enter-content-editor-without-codeblock-mac') : t('text-editor.enter-content-editor-without-codeblock')
  );
};

var getKeyMatch = exports.getKeyMatch = function getKeyMatch(bindings, e) {
  var shortcut = (0, _lodash.pickBy)({
    command: _draftJs.KeyBindingUtil.hasCommandModifier(e),
    commandOption: Boolean((e.ctrlKey || e.metaKey) && e.altKey),
    option: Boolean(e.altKey),
    shift: Boolean(e.shiftKey),
    key: String.fromCharCode(e.keyCode)
  });

  return (0, _lodash.findKey)(bindings, function (binding) {
    return (0, _lodash.isEqual)(binding, shortcut);
  });
};

var getButtonShortcuts = exports.getButtonShortcuts = function getButtonShortcuts(isCodeBlockEnabled) {
  return (0, _lodash.omitBy)(_buttonShortcuts.BUTTON_SHORTCUTS, function (_, button) {
    return button === _buttons.BUTTON_CODE_BLOCK && !isCodeBlockEnabled;
  });
};

var keyBindingFn = exports.keyBindingFn = function keyBindingFn(isCodeBlockEnabled) {
  return function (e) {
    var keyMatch = getKeyMatch(getButtonShortcuts(isCodeBlockEnabled), e);
    if (keyMatch) {
      return keyMatch;
    }

    return (0, _draftJs.getDefaultKeyBinding)(e);
  };
};

var getNewState = function getNewState(_ref5) {
  var command = _ref5.command,
      identifier = _ref5.identifier,
      editorState = _ref5.editorState,
      openModal = _ref5.openModal;

  var handler = BUTTON_HANDLERS[command];

  if (handler) {
    return handler({ command: command, editorState: editorState, identifier: identifier, openModal: openModal });
  }

  return _draftJs.RichUtils.handleKeyCommand(editorState, command);
};

var handleKeyCommand = exports.handleKeyCommand = function handleKeyCommand(_ref6) {
  var command = _ref6.command,
      identifier = _ref6.identifier,
      editorState = _ref6.editorState,
      openModal = _ref6.openModal,
      handleEditorChange = _ref6.handleEditorChange;

  var newState = getNewState({ command: command, identifier: identifier, editorState: editorState, openModal: openModal });

  if (newState) {
    handleEditorChange(newState);
    return 'handled';
  }

  return 'not-handled';
};

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_SHORTCUTS = undefined;

var _BUTTON_SHORTCUTS;

var _buttons = __webpack_require__(53);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  Keys mapped by default:
  https://github.com/facebook/draft-js/blob/e1d3f7657f053fedf3d29346d3a4de81399b068b/src/component/utils/getDefaultKeyBinding.js#L77

  bold Command+B
  italic Command+I
  underline Command+U
*/
var BUTTON_SHORTCUTS = exports.BUTTON_SHORTCUTS = (_BUTTON_SHORTCUTS = {}, _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_TITLE, { command: true, shift: true, key: '1' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_SUBTITLE, { command: true, shift: true, key: '2' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_NUMBERING, { command: true, shift: true, key: 'M' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_BULLETS, { command: true, shift: true, key: 'L' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_BLOCKQUOTE, { command: true, shift: true, key: '9' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_CODE_BLOCK, { command: true, shift: true, key: '8' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_LINK, { command: true, key: 'K' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_ALIGN_LEFT, { command: true, key: 'L' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_ALIGN_RIGHT, { command: true, key: 'R' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_ALIGN_CENTER, { command: true, key: 'E' }), _defineProperty(_BUTTON_SHORTCUTS, _buttons.BUTTON_ALIGN_JUSTIFY, { command: true, key: 'J' }), _BUTTON_SHORTCUTS);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTheme;

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _focusTheme = __webpack_require__(818);

var _focusTheme2 = _interopRequireDefault(_focusTheme);

var _textEditorTheme = __webpack_require__(819);

var _textEditorTheme2 = _interopRequireDefault(_textEditorTheme);

var _textAlignmentTheme = __webpack_require__(820);

var _textAlignmentTheme2 = _interopRequireDefault(_textAlignmentTheme);

var _mediaBlockTheme = __webpack_require__(821);

var _mediaBlockTheme2 = _interopRequireDefault(_mediaBlockTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTheme(_ref) {
  var cardBackgroundColor = _ref.cardBackgroundColor,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName;

  var button = {
    icon: {
      normal: (0, _classnames2.default)('forum-icon-fill', 'forum-icon-stroke'),
      highlighted: (0, _classnames2.default)('button-fill', 'button-stroke'),
      hover: (0, _classnames2.default)('button-fill', 'button-stroke')
    },
    tooltip: {
      container: (0, _classnames2.default)('forum-card-color', 'forum-text-background-color', contentFontClassName),
      containerStyle: {
        color: cardBackgroundColor
      },
      triangle: 'forum-text-background-color'
    },
    dropdown: {
      container: 'default-forum-card-background-color',
      containerStyle: {
        backgroundColor: cardBackgroundColor
      }
    }
  };

  return {
    container: (0, _classnames2.default)(_textEditorTheme2.default.container),
    types: {
      comment: _textEditorTheme2.default.comment
    },
    placeholder: {
      right: _textEditorTheme2.default.placeholderRight,
      center: _textEditorTheme2.default.placeholderCenter,
      hidden: _textEditorTheme2.default.placeholderHidden
    },
    blockStyleFn: function blockStyleFn(contentBlock) {
      var _contentBlock$toJS = contentBlock.toJS(),
          type = _contentBlock$toJS.type,
          textAlignment = _contentBlock$toJS.data.textAlignment;

      var classList = [];

      switch (contentBlock.getType()) {
        case 'blockquote':
          classList.push((0, _classnames2.default)(_textEditorTheme2.default.quote, 'forum-quote-border-color'));
          break;
        case 'header-one':
          classList.push(_textEditorTheme2.default.headerOne);
          break;
        case 'header-two':
          classList.push(_textEditorTheme2.default.headerTwo);
          break;
        case 'atomic':
          classList.push(_textEditorTheme2.default.atomic);
          break;
        default:
          classList.push(_textEditorTheme2.default.text);
          break;
      }

      if (type !== 'atomic') {
        classList.push(_textAlignmentTheme2.default[textAlignment]);
      }

      return _classnames2.default.apply(undefined, classList);
    },
    title: {
      container: titleFontClassName
    },
    focus: {
      focused: (0, _classnames2.default)(_focusTheme2.default.focused, 'button-after-border-color'),
      unfocused: (0, _classnames2.default)(_focusTheme2.default.unfocused, 'button-hover-after-border-color')
    },
    toolbar: {
      container: (0, _classnames2.default)('default-forum-card-background-color', 'forum-card-border-color'),
      containerStyle: {
        backgroundColor: cardBackgroundColor
      },
      button: button
    },
    button: button,
    mediaBlock: _mediaBlockTheme2.default,
    link: 'button-hover-color',
    hashtag: 'button-color'
  };
}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"unfocused":"_2kkfg","focused":"_1vaWv"};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3cEB6","elementSpacing":"_22h_P","blockStyleSpacing":"NUbo2","text":"FKgzh _22h_P","comment":"_1GRia","quote":"_3hNg5 NUbo2","headerOne":"_13jxB _22h_P","headerTwo":"EJvdv _22h_P","atomic":"uSErq","placeholderRight":"_1EuaY","placeholderCenter":"_1UYbE","placeholderHidden":"_1FyTs"};

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"center":"_3BxRa","justify":"_2OIdO","right":"ih-I8"};

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"alignLeft":"_2fiXN","alignRight":"_2KfeU","sizeFullWidth":"_1afAR","sizeContentWidth":"u9NEb","sizeSmallCenter":"_1NIIO","sizeOriginal":"_320qW"};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(5);

var _avatar = __webpack_require__(409);

var _avatar2 = _interopRequireDefault(_avatar);

var _currentUserSelectors = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: (0, _currentUserSelectors.getCurrentUser)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_avatar2.default);

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _userBadge = __webpack_require__(272);

var _userBadge2 = _interopRequireDefault(_userBadge);

var _avatar = __webpack_require__(836);

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Avatar(_ref) {
  var type = _ref.type,
      _ref$user = _ref.user,
      user = _ref$user === undefined ? {} : _ref$user;

  var className = (0, _classnames2.default)(_avatar2.default.container, 'forum-text-color', _defineProperty({}, _avatar2.default[type], type), 'avatar');
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(className) },
    _react2.default.createElement(_userAvatarImage2.default, { type: type, user: user }),
    _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)(_avatar2.default.name), 'data-hook': 'avatar__name' },
      user.name
    ),
    _react2.default.createElement(_userBadge2.default, { user: user })
  );
}

Avatar.LARGE = 'large';

Avatar.propTypes = {
  user: _propTypes2.default.object.isRequired,
  type: _propTypes2.default.string
};

exports.default = Avatar;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(15);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _avatarImage = __webpack_require__(544);

var _avatarImage2 = _interopRequireDefault(_avatarImage);

var _resolveUserImage = __webpack_require__(249);

var _resolveUserImage2 = _interopRequireDefault(_resolveUserImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UserAvatarImage = function UserAvatarImage(_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === undefined ? {} : _ref$user,
      props = _objectWithoutProperties(_ref, ['user']);

  return _react2.default.createElement(_avatarImage2.default, _extends({ image: (0, _resolveUserImage2.default)(user.image), user: user }, (0, _lodash.omit)(props, 'dispatch')));
};

(0, _hoistNonReactStatics2.default)(UserAvatarImage, _avatarImage2.default);

UserAvatarImage.propTypes = {
  className: _propTypes2.default.string,
  user: _propTypes2.default.object.isRequired,
  type: _propTypes2.default.string
};

exports.default = UserAvatarImage;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _fluidAvatarImage = __webpack_require__(545);

var _fluidAvatarImage2 = _interopRequireDefault(_fluidAvatarImage);

var _avatarImage = __webpack_require__(828);

var _avatarImage2 = _interopRequireDefault(_avatarImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AvatarImage = function AvatarImage(_ref) {
  var Component = _ref.component,
      type = _ref.type,
      image = _ref.image,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ['component', 'type', 'image', 'className']);

  var componentProps = Component === AvatarImage.defaultProps.component ? (0, _lodash.omit)(otherProps, 'user') : otherProps;

  return _react2.default.createElement(
    Component,
    _extends({ className: (0, _classnames2.default)(_avatarImage2.default.image, className, _avatarImage2.default[type], 'avatar-image') }, componentProps),
    _react2.default.createElement(_fluidAvatarImage2.default, { image: image })
  );
};

AvatarImage.LARGE = 'large';
AvatarImage.EXTRA_LARGE = 'extraLarge';
AvatarImage.PROMOTE = 'promote';
AvatarImage.WIDGET = 'widget';
AvatarImage.COMMENT = 'comment';
AvatarImage.COMMENT_SEARCH = 'commentSearch';

AvatarImage.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  className: _propTypes2.default.string,
  image: _propTypes2.default.string,
  type: _propTypes2.default.string
};

AvatarImage.defaultProps = {
  component: 'span'
};

exports.default = AvatarImage;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fluidAvatarImage = __webpack_require__(827);

var _fluidAvatarImage2 = _interopRequireDefault(_fluidAvatarImage);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyle = function getStyle(image) {
  return image ? { backgroundImage: 'url(' + image + ')' } : {};
};

var FluidAvatarImage = function FluidAvatarImage(_ref) {
  var image = _ref.image;
  return _react2.default.createElement('div', { className: (0, _classnames2.default)(_fluidAvatarImage2.default.container, 'fluid-avatar-image'), style: getStyle(image) });
};

FluidAvatarImage.propTypes = {
  image: _propTypes2.default.string
};

exports.default = FluidAvatarImage;

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Fm4K"};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"image":"nFerz","large":"CAPYM","extraLarge":"_9SCgh","promote":"_3ZZAW","member":"_2YKcv","widget":"_3ddMG","comment":"HWieH","commentSearch":"_3setc"};

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _badge = __webpack_require__(830);

var _badge2 = _interopRequireDefault(_badge);

var _userRole = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserBadge = function UserBadge(_ref) {
  var user = _ref.user,
      _ref$hideRoles = _ref.hideRoles,
      hideRoles = _ref$hideRoles === undefined ? [] : _ref$hideRoles;

  var role = (0, _userRole.getUserRole)(user);
  return role && hideRoles.indexOf(role) === -1 ? _react2.default.createElement(_badge2.default, { role: role }) : null;
};

UserBadge.propTypes = {
  user: _propTypes2.default.object.isRequired,
  hideRoles: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = UserBadge;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _badge = __webpack_require__(831);

var _badge2 = _interopRequireDefault(_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _badge2.default;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BADGES;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOverlays = __webpack_require__(154);

var _icons = __webpack_require__(9);

var _tooltip = __webpack_require__(832);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _scrollParent = __webpack_require__(38);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _permissionsChecker = __webpack_require__(269);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _badge = __webpack_require__(835);

var _badge2 = _interopRequireDefault(_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BADGES = (_BADGES = {}, _defineProperty(_BADGES, _permissionsChecker.ROLE_OWNER, _icons.OwnerSmallIcon), _defineProperty(_BADGES, _permissionsChecker.ROLE_ADMIN, _icons.OwnerSmallIcon), _defineProperty(_BADGES, _permissionsChecker.ROLE_MODERATOR, _icons.ModeratorSmallIcon), _BADGES);

var Badge = function (_Component) {
  _inherits(Badge, _Component);

  function Badge(props) {
    _classCallCheck(this, Badge);

    var _this = _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).call(this, props));

    _this.state = {
      isTooltipVisible: false
    };


    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    return _this;
  }

  _createClass(Badge, [{
    key: 'handleMouseEnter',
    value: function handleMouseEnter() {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        _this2.setState({
          isTooltipVisible: true
        });
      }, 250);
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      clearTimeout(this.timeout);
      this.setState({
        isTooltipVisible: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          role = _props.role,
          t = _props.t;

      var Icon = BADGES[role];
      if (Icon) {
        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(_badge2.default.container, className, 'badge'),
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            'data-hook': 'badge'
          },
          _react2.default.createElement(Icon, { className: (0, _classnames2.default)(_badge2.default.icon, 'forum-icon-fill') }),
          _react2.default.createElement(
            _reactOverlays.Overlay,
            {
              show: this.state.isTooltipVisible,
              placement: 'top',
              container: (0, _scrollParent2.default)(),
              target: this,
              onHide: this.handleMouseLeave,
              rootClose: true
            },
            _react2.default.createElement(
              _tooltip2.default,
              null,
              t('badge.' + role)
            )
          )
        );
      }
      return null;
    }
  }]);

  return Badge;
}(_react.Component);

Badge.propTypes = {
  className: _propTypes2.default.string,
  role: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(Badge);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _tooltip = __webpack_require__(833);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _tooltip2.default;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _tooltip = __webpack_require__(834);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      style = _ref.style,
      placement = _ref.placement;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_tooltip2.default.container, _defineProperty({}, _tooltip2.default[placement], placement)), style: style },
    children,
    _react2.default.createElement('span', { className: _tooltip2.default.triangle })
  );
};

Tooltip.propTypes = {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  placement: _propTypes2.default.string
};

exports.default = Tooltip;

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"AsKxH","triangle":"_2qqLP","top":"_1rKEu"};

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2GgmO","icon":"_2eWEl"};

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2NZd5","name":"_2F9CD","large":"_3DkaF"};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreButton = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _moreButton = __webpack_require__(838);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _icons = __webpack_require__(9);

var _accessibility = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BOTTOM_THRESHOLD = 60;

var MoreButton = exports.MoreButton = function (_Component) {
  _inherits(MoreButton, _Component);

  function MoreButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MoreButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MoreButton.__proto__ || Object.getPrototypeOf(MoreButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isVisible: false
    }, _this.handleClick = function (event) {
      if (_this.state.isVisible) {
        _this.hideComponent();
      } else {
        _this.showComponent();
      }
      event.preventDefault();
    }, _this.setContainer = function (element) {
      return _this.container = element;
    }, _this.setActionsContainer = function (element) {
      return _this.actionsContainer = element;
    }, _this.checkIfFits = function () {
      var rect = _this.container.getBoundingClientRect();
      var scrollOffset = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      var bodyHeight = document.body.offsetHeight;
      var topOffset = scrollOffset + rect.top;
      var bottomOffset = bodyHeight - topOffset - rect.height;
      var actionsHeight = _this.actionsContainer ? _this.actionsContainer.offsetHeight : 0;
      _this.setState({
        isAtTop: actionsHeight > bottomOffset - BOTTOM_THRESHOLD && actionsHeight < topOffset
      });
    }, _this.showComponent = function () {
      document.addEventListener('click', _this.hideComponent);
      _this.setState({
        isVisible: true
      }, _this.checkIfFits);
    }, _this.hideComponent = function () {
      document.removeEventListener('click', _this.hideComponent);
      _this.setState({
        isVisible: false
      });
    }, _this.componentWillUnmount = function () {
      document.removeEventListener('click', _this.hideComponent);
    }, _this.renderActionsContainer = function () {
      var _this$props = _this.props,
          contentFontClassName = _this$props.contentFontClassName,
          cardBackgroundColor = _this$props.cardBackgroundColor;

      var actionsContainerClass = (0, _classnames2.default)(_moreButton2.default.actions, contentFontClassName, 'forum-text-color', 'default-forum-card-background-color', _defineProperty({}, _moreButton2.default.actionsTop, _this.state.isAtTop));
      var actionsContainerStyle = {
        backgroundColor: cardBackgroundColor
      };

      return _react2.default.createElement(
        'div',
        {
          className: actionsContainerClass,
          style: actionsContainerStyle,
          role: 'menu',
          'aria-live': 'polite',
          ref: _this.setActionsContainer,
          'data-hook': 'actions'
        },
        _this.props.children
      );
    }, _this.render = function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          icon = _this$props2.icon,
          t = _this$props2.t,
          isWhite = _this$props2.isWhite,
          buttonClassName = _this$props2.className;

      var className = (0, _classnames2.default)(buttonClassName, _moreButton2.default.more, 'more-button', _defineProperty({}, _moreButton2.default.moreWhite, isWhite));

      return _react2.default.createElement(
        'div',
        {
          onClick: _this.handleClick,
          className: className,
          ref: _this.setContainer,
          onKeyUp: (0, _accessibility.handleEscapeKeyUp)(_this.hideComponent),
          'data-hook': 'more-button'
        },
        _react2.default.createElement(
          'div',
          {
            className: _moreButton2.default.icon,
            tabIndex: '0',
            role: 'menubar',
            'aria-label': t('more-button.more-actions'),
            onKeyUp: (0, _accessibility.handleEnterKeyUp)(_this.handleClick),
            id: id
          },
          icon
        ),
        _this.state.isVisible ? _this.renderActionsContainer() : null
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return MoreButton;
}(_react.Component);

MoreButton.propTypes = {
  cardBackgroundColor: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  isWhite: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  icon: _propTypes2.default.node,
  t: _propTypes2.default.func.isRequired
};

MoreButton.defaultProps = {
  icon: _react2.default.createElement(_icons.MoreIcon, { className: (0, _classnames2.default)(_moreButton2.default.moreIcon, 'forum-icon-fill') })
};

exports.default = (0, _lodash.flowRight)(_withCardBackgroundColor2.default, _withTranslate2.default, _withFontClassName2.default)(MoreButton);

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"_J4Cp","more":"_1h-NJ","actions":"_1eEWW","actionsTop":"is5pC"};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _postCreateActions = __webpack_require__(840);

var _postCreateActions2 = _interopRequireDefault(_postCreateActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postCreateActions2.default;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostCreateActions = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modalTypes = __webpack_require__(26);

var _openModal = __webpack_require__(36);

var _icons = __webpack_require__(9);

var _moreButton = __webpack_require__(127);

var _moreButton2 = _interopRequireDefault(_moreButton);

var _withPermissions = __webpack_require__(123);

var _withPermissions2 = _interopRequireDefault(_withPermissions);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostCreateActions = exports.PostCreateActions = function (_Component) {
  _inherits(PostCreateActions, _Component);

  function PostCreateActions(props) {
    _classCallCheck(this, PostCreateActions);

    var _this = _possibleConstructorReturn(this, (PostCreateActions.__proto__ || Object.getPrototypeOf(PostCreateActions)).call(this, props));

    _this.openModal = _this.openModal.bind(_this);
    return _this;
  }

  _createClass(PostCreateActions, [{
    key: 'openModal',
    value: function openModal(type) {
      var _this2 = this;

      return function () {
        return _this2.props.openModal(type, {
          categoryId: _this2.props.categoryId
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          canRender = _props.canRender,
          t = _props.t;

      return _react2.default.createElement(
        'div',
        null,
        canRender('move', 'post', function () {
          return _react2.default.createElement(
            _moreButton2.default,
            { onClick: _this3.openModal(_modalTypes.MODAL_TYPE_CHANGE_CATEGORY) },
            _react2.default.createElement(_icons.MoveIcon, null),
            t('post-create-actions.move-post')
          );
        })
      );
    }
  }]);

  return PostCreateActions;
}(_react.Component);

PostCreateActions.propTypes = {
  openModal: _propTypes2.default.func.isRequired,
  categoryId: _propTypes2.default.string.isRequired,
  canRender: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired
};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openModal: _openModal.openModal
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)((0, _withPermissions2.default)(PostCreateActions)));

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrentUserProfileLink = function CurrentUserProfileLink(_ref) {
  var children = _ref.children,
      currentUser = _ref.currentUser,
      ProfileLink = _ref.navigation.ProfileLink;
  return _react2.default.createElement(
    ProfileLink,
    { user: currentUser },
    children
  );
};

CurrentUserProfileLink.propTypes = {
  children: _propTypes2.default.node,
  currentUser: _propTypes2.default.object,
  navigation: _propTypes2.default.object
};

exports.default = (0, _lodash.flowRight)(_withAuth2.default, (0, _withEnvironment2.default)({ navigation: 'navigation' }))(CurrentUserProfileLink);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isModified = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isModified = exports.isModified = function isModified(fields, initialContent) {
  if (_lodash2.default.find(_lodash2.default.omit(fields, 'content'), function (field) {
    return field.dirty;
  })) {
    return true;
  }
  return JSON.stringify(initialContent) !== JSON.stringify(fields.content.value);
};

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form":"_1-oEI","header":"_ESF1","moreButton":"_4xOqd","footer":"_2G7s4","editorControls":"JB4DT","buttons":"-hosk","button":"_1p7bI","wrapper":"ir4O6","titleInputWrapper":"k4XZN","titleInput":"UnITK","mainArea":"_1XDF8","content":"_1wqNS"};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _changePostCategoryModal = __webpack_require__(845);

var _changePostCategoryModal2 = _interopRequireDefault(_changePostCategoryModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _changePostCategoryModal2.default;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePostCategoryModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _moveToCategory = __webpack_require__(364);

var _moveToCategory2 = _interopRequireDefault(_moveToCategory);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangePostCategoryModal = exports.ChangePostCategoryModal = function ChangePostCategoryModal(_ref) {
  var categories = _ref.categories,
      changeCategory = _ref.changeCategory,
      closeModal = _ref.closeModal,
      categoryId = _ref.categoryId,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_moveToCategory2.default, {
      onClick: changeCategory,
      onCancel: closeModal,
      categories: categories,
      currentCategoryId: categoryId,
      message: t('change-post-category-modal.move-post-to-another-category')
    })
  );
};

ChangePostCategoryModal.propTypes = {
  categories: _propTypes2.default.array.isRequired,
  changeCategory: _propTypes2.default.func.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired,
  categoryId: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return { categories: state.categories };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    changeCategory: function changeCategory(categoryId) {
      return (0, _closeModal.closeModal)(categoryId);
    },
    closeModal: _closeModal.closeModal
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withTranslate2.default)(ChangePostCategoryModal));

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _buttonGroup = __webpack_require__(50);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _select = __webpack_require__(548);

var _select2 = _interopRequireDefault(_select);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _moveToCategory = __webpack_require__(852);

var _moveToCategory2 = _interopRequireDefault(_moveToCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoveToCategory = function (_Component) {
  _inherits(MoveToCategory, _Component);

  function MoveToCategory(props) {
    _classCallCheck(this, MoveToCategory);

    var _this = _possibleConstructorReturn(this, (MoveToCategory.__proto__ || Object.getPrototypeOf(MoveToCategory)).call(this, props));

    _this.state = {};


    _this.handleCategoryChange = _this.handleCategoryChange.bind(_this);
    _this.handleMove = _this.handleMove.bind(_this);
    _this.handleCancelClick = _this.handleCancelClick.bind(_this);

    var categories = _this.props.categories.filter(function (category) {
      return category._id !== _this.props.currentCategoryId;
    });
    _this.state = {
      categoryId: categories.length ? categories[0]._id : null
    };
    return _this;
  }

  _createClass(MoveToCategory, [{
    key: 'handleCategoryChange',
    value: function handleCategoryChange(categoryId) {
      this.setState({ categoryId: categoryId });
    }
  }, {
    key: 'handleMove',
    value: function handleMove() {
      this.props.onClick(this.state.categoryId);
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.onCancel();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          titleFontClassName = _props.titleFontClassName,
          contentFontClassName = _props.contentFontClassName,
          t = _props.t,
          categories = _props.categories,
          currentCategoryId = _props.currentCategoryId;

      var className = (0, _classnames2.default)(_moveToCategory2.default.container, contentFontClassName, 'forum-text-color', 'move-to-category');
      var options = (0, _lodash2.default)(categories).filter(function (category) {
        return category._id !== currentCategoryId;
      }).map(function (category) {
        return {
          label: category.label,
          value: category._id
        };
      }).value();
      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'h3',
          { className: (0, _classnames2.default)(_moveToCategory2.default.titleContainer, titleFontClassName) },
          _react2.default.createElement(_icons.MoveIcon, { className: 'forum-icon-fill' }),
          _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)(_moveToCategory2.default.title, 'move-to-category__title') },
            t('move-to-category.move-to-category')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _moveToCategory2.default.message },
          this.props.message
        ),
        _react2.default.createElement(
          'div',
          { className: _moveToCategory2.default.selectWrapper },
          _react2.default.createElement(_select2.default, { options: options, defaultValue: this.state.categoryId, onChange: this.handleCategoryChange })
        ),
        _react2.default.createElement(_buttonGroup2.default, {
          primaryButtonText: t('move-to-category.move-post'),
          primaryButtonProps: { onClick: this.handleMove },
          secondaryButtonText: t('move-to-category.cancel'),
          secondaryButtonProps: { onClick: this.handleCancelClick }
        })
      );
    }
  }]);

  return MoveToCategory;
}(_react.Component);

MoveToCategory.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  categories: _propTypes2.default.array.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired,
  currentCategoryId: _propTypes2.default.string,
  message: _propTypes2.default.string
};

exports.default = (0, _withFontClassName2.default)((0, _withTranslate2.default)(MoveToCategory));

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _selectMobile = __webpack_require__(848);

var _selectMobile2 = _interopRequireDefault(_selectMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectMobile = function (_Component) {
  _inherits(SelectMobile, _Component);

  function SelectMobile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectMobile.__proto__ || Object.getPrototypeOf(SelectMobile)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
      _lodash2.default.invoke(_this, 'props.onChange', event.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectMobile, [{
    key: 'renderOptions',
    value: function renderOptions() {
      return _lodash2.default.map(this.props.options, function (_ref2) {
        var value = _ref2.value,
            label = _ref2.label;
        return _react2.default.createElement(
          'option',
          { key: value, value: value, name: label },
          label
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var defaultValue = this.props.defaultValue;

      return _react2.default.createElement(
        'div',
        { className: _selectMobile2.default.container },
        _react2.default.createElement(
          'select',
          {
            className: (0, _classnames2.default)(_selectMobile2.default.select, 'forum-text-color', 'select-mobile__select'),
            onChange: this.handleChange,
            defaultValue: defaultValue
          },
          this.renderOptions()
        ),
        _react2.default.createElement(_icons.ArrowDownIcon, { className: (0, _classnames2.default)(_selectMobile2.default.selectIcon, 'forum-icon-fill') }),
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_selectMobile2.default.borders, 'forum-text-border-color') })
      );
    }
  }]);

  return SelectMobile;
}(_react.Component);

SelectMobile.propTypes = {
  cardBackgroundColor: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  defaultValue: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.any.isRequired
  }))
};

exports.default = SelectMobile;

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2nh5d","selectIcon":"_1qiuj","select":"_1oAtP","borders":"_1wdty"};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectDesktop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactClickOutside = __webpack_require__(850);

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _icons = __webpack_require__(9);

var _separator = __webpack_require__(18);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _selectDesktop = __webpack_require__(851);

var _selectDesktop2 = _interopRequireDefault(_selectDesktop);

var _accessibility = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BORDER_WIDTH = 1;

var SelectDesktop = exports.SelectDesktop = function (_Component) {
  _inherits(SelectDesktop, _Component);

  function SelectDesktop(props) {
    _classCallCheck(this, SelectDesktop);

    var _this = _possibleConstructorReturn(this, (SelectDesktop.__proto__ || Object.getPrototypeOf(SelectDesktop)).call(this, props));

    _this.handleBoxClick = function () {
      _this.setState({
        isExpanded: true
      });
    };

    _this.handleBoxKeyPress = function () {
      _this.setState({
        isExpanded: true
      });
    };

    _this.handleOptionClick = function (option) {
      if (_this.state.value !== option.value) {
        _lodash2.default.invoke(_this, 'props.onChange', option.value);
      }
      _this.setState({
        value: option.value,
        isExpanded: false
      });
    };

    _this.handleClickOutside = function () {
      _this.setState({ isExpanded: false });
    };

    _this.setElementToFocus = function (ref) {
      _this.elementToFocus = ref;
    };

    _this.componentDidUpdate = function () {
      if (_this.elementToFocus) {
        _this.elementToFocus.focus();
        _this.elementToFocus = undefined;
      }
    };

    var defaultValue = _this.props.defaultValue;

    _this.state = {
      value: defaultValue,
      isExpanded: false
    };
    return _this;
  }

  _createClass(SelectDesktop, [{
    key: 'getSelectedOption',
    value: function getSelectedOption() {
      var _this2 = this;

      return _lodash2.default.find(this.props.options, function (option) {
        return option.value === _this2.state.value;
      }) || {};
    }
  }, {
    key: 'renderCollapsed',
    value: function renderCollapsed() {
      var _props = this.props,
          cardBackgroundColor = _props.cardBackgroundColor,
          height = _props.height,
          isTransparent = _props.isTransparent;

      var containerClassName = (0, _classnames2.default)(_selectDesktop2.default.box, 'select-desktop__box', {
        'default-forum-card-background-color': !isTransparent
      });
      var selectedOption = this.getSelectedOption();
      var style = {
        backgroundColor: isTransparent ? null : cardBackgroundColor,
        height: height
      };

      return _react2.default.createElement(
        'div',
        {
          className: containerClassName,
          style: style,
          onClick: this.handleBoxClick,
          onKeyUp: (0, _accessibility.handleEnterKeyUp)(this.handleBoxKeyPress),
          tabIndex: '0'
        },
        _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)(_selectDesktop2.default.label, 'select-desktop__label') },
          selectedOption.label
        ),
        _react2.default.createElement(_icons.ArrowDownIcon, { className: (0, _classnames2.default)(_selectDesktop2.default.arrow, 'forum-icon-fill') }),
        isTransparent ? null : _react2.default.createElement('div', { className: (0, _classnames2.default)(_selectDesktop2.default.borders, 'forum-text-border-color') })
      );
    }
  }, {
    key: 'renderExpanded',
    value: function renderExpanded() {
      var _this3 = this;

      var _props2 = this.props,
          cardBackgroundColor = _props2.cardBackgroundColor,
          options = _props2.options,
          height = _props2.height;
      var value = this.state.value;

      var selectedOption = this.getSelectedOption();
      var otherOptions = _lodash2.default.filter(options, function (option) {
        return option.value !== value;
      });
      var items = _lodash2.default.map([selectedOption].concat(_toConsumableArray(otherOptions)), function (option, index) {
        var isFirst = index === 0;
        var containerClassName = (0, _classnames2.default)(_selectDesktop2.default.option, 'select-desktop__option', {
          'button-color': isFirst
        });
        var style = { height: height - BORDER_WIDTH };
        var handleOptionClick = function handleOptionClick() {
          return _this3.handleOptionClick(option);
        };

        return _react2.default.createElement(
          'div',
          {
            ref: isFirst && _this3.setElementToFocus,
            className: containerClassName,
            key: option.value,
            onClick: handleOptionClick,
            onKeyUp: (0, _accessibility.handleEnterKeyUp)(handleOptionClick),
            tabIndex: '0',
            'data-hook': 'listbox-option'
          },
          _react2.default.createElement(
            'div',
            { className: _selectDesktop2.default.optionWrapper, style: style },
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_selectDesktop2.default.hoverBackground, 'forum-text-background-color') }),
            _react2.default.createElement(
              'div',
              { className: _selectDesktop2.default.optionContent },
              _react2.default.createElement(
                'span',
                { className: _selectDesktop2.default.label },
                option.label
              ),
              _react2.default.createElement(_icons.ArrowUpIcon, { className: (0, _classnames2.default)(_selectDesktop2.default.arrow, 'forum-icon-fill') })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _selectDesktop2.default.separator },
            _react2.default.createElement(_separator.HorizontalSeparator, null)
          )
        );
      });

      var overlayClassName = (0, _classnames2.default)(_selectDesktop2.default.overlay, 'default-forum-card-background-color');
      return _react2.default.createElement(
        _reactClickOutside2.default,
        { onClickOutside: this.handleClickOutside },
        _react2.default.createElement(
          'div',
          { className: overlayClassName, style: { backgroundColor: cardBackgroundColor } },
          _react2.default.createElement(
            'div',
            { className: _selectDesktop2.default.scrollable },
            items
          ),
          _react2.default.createElement('div', { className: (0, _classnames2.default)(_selectDesktop2.default.borders, 'forum-text-border-color') })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          contentFontClassName = _props3.contentFontClassName,
          height = _props3.height,
          isScrollable = _props3.isScrollable;

      var containerClassName = (0, _classnames2.default)(_selectDesktop2.default.container, contentFontClassName, className, 'forum-text-color', _defineProperty({}, _selectDesktop2.default.isScrollable, isScrollable));
      var isExpanded = this.state.isExpanded;

      var style = { height: height };
      return _react2.default.createElement(
        'div',
        { className: containerClassName, style: style, role: 'listbox', 'data-hook': 'listbox' },
        isExpanded ? this.renderExpanded() : this.renderCollapsed()
      );
    }
  }]);

  return SelectDesktop;
}(_react.Component);

SelectDesktop.propTypes = {
  className: _propTypes2.default.string,
  cardBackgroundColor: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  defaultValue: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  height: _propTypes2.default.number,
  isTransparent: _propTypes2.default.bool,
  isScrollable: _propTypes2.default.bool,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.any.isRequired
  }))
};

SelectDesktop.defaultProps = {
  isScrollable: true
};

exports.default = _lodash2.default.flowRight(_withCardBackgroundColor2.default, _withFontClassName2.default)(SelectDesktop);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClickOutside = function (_Component) {
  _inherits(ClickOutside, _Component);

  function ClickOutside(props) {
    _classCallCheck(this, ClickOutside);

    var _this = _possibleConstructorReturn(this, (ClickOutside.__proto__ || Object.getPrototypeOf(ClickOutside)).call(this, props));

    _this.handle = function (e) {
      if (e.type === 'touchend') _this.isTouch = true;
      if (e.type === 'click' && _this.isTouch) return;
      var onClickOutside = _this.props.onClickOutside;

      var el = _this.container;
      if (!el.contains(e.target)) onClickOutside(e);
    };

    _this.getContainer = _this.getContainer.bind(_this);
    _this.isTouch = false;
    return _this;
  }

  _createClass(ClickOutside, [{
    key: 'getContainer',
    value: function getContainer(ref) {
      this.container = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onClickOutside = _props.onClickOutside,
          props = _objectWithoutProperties(_props, ['children', 'onClickOutside']);

      return _react2.default.createElement(
        'div',
        _extends({}, props, { ref: this.getContainer }),
        children
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('touchend', this.handle, true);
      document.addEventListener('click', this.handle, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('touchend', this.handle, true);
      document.removeEventListener('click', this.handle, true);
    }
  }]);

  return ClickOutside;
}(_react.Component);

ClickOutside.propTypes = {
  onClickOutside: _propTypes2.default.func.isRequired
};
exports.default = ClickOutside;

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2kCF0","borders":"U0l_H","box":"_2QQjh","label":"_3WT5p","arrow":"_1acLQ","option":"_3ZKun","overlay":"OcqRG","isScrollable":"_3qeU_","scrollable":"_7OmJ1","optionWrapper":"_3HabG","optionContent":"_3meoQ","hoverBackground":"_3ow39","separator":"_3pYVI"};

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3KhGz","titleContainer":"_3d-o-","title":"_2E7My","message":"_3lBx3","selectWrapper":"_2WMow"};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _movePostModal = __webpack_require__(854);

var _movePostModal2 = _interopRequireDefault(_movePostModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _movePostModal2.default;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _moveToCategory = __webpack_require__(364);

var _moveToCategory2 = _interopRequireDefault(_moveToCategory);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MovePostModal = function MovePostModal(_ref) {
  var categories = _ref.categories,
      move = _ref.move,
      closeModal = _ref.closeModal,
      categoryId = _ref.categoryId,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_moveToCategory2.default, {
      categories: categories,
      currentCategoryId: categoryId,
      onClick: move,
      onCancel: closeModal,
      message: t('move-post-modal.move-this-post')
    })
  );
};

MovePostModal.propTypes = {
  move: _propTypes2.default.func.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  categories: _propTypes2.default.array.isRequired,
  categoryId: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    categories: state.categories
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    move: function move(categoryId) {
      return (0, _closeModal.closeModal)({ categoryId: categoryId, postId: ownProps.postId });
    },
    closeModal: _closeModal.closeModal
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withTranslate2.default)(MovePostModal));

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _deleteCommentModal = __webpack_require__(856);

var _deleteCommentModal2 = _interopRequireDefault(_deleteCommentModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _deleteCommentModal2.default;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteCommentModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _deleteConfirmation = __webpack_require__(241);

var _deleteConfirmation2 = _interopRequireDefault(_deleteConfirmation);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteCommentModal = exports.DeleteCommentModal = function DeleteCommentModal(_ref) {
  var closeModal = _ref.closeModal,
      deleteComment = _ref.deleteComment,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_deleteConfirmation2.default, {
      title: t('delete-comment-modal.delete-comment'),
      message: t('delete-comment-modal.are-you-sure'),
      onConfirm: deleteComment,
      onCancel: closeModal
    })
  );
};

DeleteCommentModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  deleteComment: _propTypes2.default.func.isRequired,
  postId: _propTypes2.default.string.isRequired,
  commentId: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    deleteComment: function deleteComment() {
      return (0, _closeModal.closeModal)({
        postId: ownProps.postId,
        commentId: ownProps.commentId
      });
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(DeleteCommentModal));

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icons = __webpack_require__(9);

var _confirmation = __webpack_require__(64);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DeleteConfirmation = function DeleteConfirmation(_ref) {
  var t = _ref.t,
      message = _ref.message,
      props = _objectWithoutProperties(_ref, ['t', 'message']);

  return _react2.default.createElement(
    _confirmation2.default,
    _extends({
      icon: _icons.DeleteIcon,
      confirm: t('delete-confirmation.delete'),
      cancel: t('delete-confirmation.cancel')
    }, props),
    _react2.default.createElement(
      'p',
      null,
      message
    )
  );
};

DeleteConfirmation.propTypes = {
  title: _propTypes2.default.string,
  message: _propTypes2.default.string,
  onConfirm: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)(DeleteConfirmation);

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _deletePostModal = __webpack_require__(859);

var _deletePostModal2 = _interopRequireDefault(_deletePostModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _deletePostModal2.default;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeletePostModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _deleteConfirmation = __webpack_require__(241);

var _deleteConfirmation2 = _interopRequireDefault(_deleteConfirmation);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeletePostModal = exports.DeletePostModal = function DeletePostModal(_ref) {
  var closeModal = _ref.closeModal,
      deletePost = _ref.deletePost,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_deleteConfirmation2.default, {
      title: t('delete-post-modal.delete-post'),
      message: t('delete-post-modal.will-detele-comments'),
      onConfirm: deletePost,
      onCancel: closeModal
    })
  );
};

DeletePostModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  deletePost: _propTypes2.default.func.isRequired,
  postId: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    deletePost: function deletePost() {
      return (0, _closeModal.closeModal)(ownProps.postId);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(DeletePostModal));

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _demoModal = __webpack_require__(861);

var _demoModal2 = _interopRequireDefault(_demoModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _demoModal2.default;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemoModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _closeModal = __webpack_require__(12);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _demoConfirmation = __webpack_require__(862);

var _demoConfirmation2 = _interopRequireDefault(_demoConfirmation);

var _isTemplate = __webpack_require__(406);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DemoModal = exports.DemoModal = function DemoModal(_ref) {
  var viewMode = _ref.viewMode,
      closeModal = _ref.closeModal,
      t = _ref.t;

  var type = viewMode;
  if (viewMode === 'site' && (0, _isTemplate.isTemplate)()) {
    type = 'template';
  }

  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_demoConfirmation2.default, {
      title: t('demo-modal.demo-mode'),
      message: t('demo-modal.message-' + type),
      confirmButton: t(viewMode === 'preview' ? 'demo-modal.activate-forum' : 'demo-modal.confirm'),
      onConfirm: function onConfirm() {
        closeModal(viewMode === 'preview');
      },
      onCancel: closeModal
    })
  );
};

DemoModal.propTypes = {
  viewMode: _propTypes2.default.string.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(DemoModal));

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _demoConfirmation = __webpack_require__(863);

var _demoConfirmation2 = _interopRequireDefault(_demoConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _demoConfirmation2.default;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemoConfirmation = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icons = __webpack_require__(9);

var _confirmation = __webpack_require__(64);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DemoConfirmation = exports.DemoConfirmation = function DemoConfirmation(_ref) {
  var title = _ref.title,
      message = _ref.message,
      confirmButton = _ref.confirmButton,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      t = _ref.t;
  return _react2.default.createElement(
    _confirmation2.default,
    {
      icon: _icons.AlertIcon,
      title: title,
      confirm: confirmButton,
      onConfirm: onConfirm,
      cancel: t('demo-confirmation.cancel-button'),
      onCancel: onCancel
    },
    _react2.default.createElement(
      'p',
      null,
      message
    )
  );
};

DemoConfirmation.propTypes = {
  t: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string,
  confirmButton: _propTypes2.default.string,
  message: _propTypes2.default.string
};

exports.default = (0, _withTranslate2.default)(DemoConfirmation);

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _reportCommentModal = __webpack_require__(865);

var _reportCommentModal2 = _interopRequireDefault(_reportCommentModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reportCommentModal2.default;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportCommentModal = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _reportAbuseForm = __webpack_require__(242);

var _reportAbuseForm2 = _interopRequireDefault(_reportAbuseForm);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportCommentModal = exports.ReportCommentModal = function ReportCommentModal(_ref) {
  var closeModal = _ref.closeModal,
      reportComment = _ref.reportComment,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_reportAbuseForm2.default, {
      initialValues: { reportType: '1' },
      onSubmit: reportComment,
      onCancel: closeModal,
      title: t('report-comment-modal.report-comment'),
      message: t('report-comment-modal.help-us-understand')
    })
  );
};

ReportCommentModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  reportComment: _propTypes2.default.func.isRequired,
  postId: _propTypes2.default.string.isRequired,
  commentId: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    reportComment: function reportComment(report) {
      return (0, _closeModal.closeModal)(_extends({}, report, {
        postId: ownProps.postId,
        commentId: ownProps.commentId
      }));
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(ReportCommentModal));

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _inputRadio = __webpack_require__(867);

var _inputRadio2 = _interopRequireDefault(_inputRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _inputRadio2.default;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _inputRadio = __webpack_require__(868);

var _inputRadio2 = _interopRequireDefault(_inputRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var InputRadio = function InputRadio(_ref) {
  var text = _ref.text,
      tabIndex = _ref.tabIndex,
      props = _objectWithoutProperties(_ref, ['text', 'tabIndex']);

  return _react2.default.createElement(
    'label',
    { className: _inputRadio2.default.label },
    _react2.default.createElement('input', _extends({ className: _inputRadio2.default.radio, type: 'radio' }, props)),
    _react2.default.createElement('span', { className: (0, _classnames2.default)(_inputRadio2.default.fakeRadio, 'button-border-color'), 'data-hook': 'input-radio' }),
    _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)(_inputRadio2.default.fakeRadioChecked, 'button-border-color') },
      _react2.default.createElement('span', { className: (0, _classnames2.default)(_inputRadio2.default.innerCircle, 'button-background-color') })
    ),
    _react2.default.createElement(
      'span',
      { className: _inputRadio2.default.text, role: 'radio', 'aria-checked': props.checked, tabIndex: tabIndex },
      text
    )
  );
};

InputRadio.propTypes = {
  name: _propTypes2.default.string,
  value: _propTypes2.default.any,
  text: _propTypes2.default.node,
  checked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  tabIndex: _propTypes2.default.string.isRequired
};

exports.default = InputRadio;

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"_3H9eA","radio":"_1NndF","fakeRadioChecked":"_4pWoS","fakeRadio":"_16kV9","innerCircleWrapper":"_2OA4_","innerCircle":"_3aco1","text":"_1qunH"};

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1m39X","titleContainer":"_1xmlg","title":"Uy52Y","message":"_1jmvq","reason":"_1f4t4","separator":"M0iBI","radioInput":"_2slWS","form":"IjTLo","reasons":"_2HWxP"};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _reportPostModal = __webpack_require__(871);

var _reportPostModal2 = _interopRequireDefault(_reportPostModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reportPostModal2.default;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportPostModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _reportAbuseForm = __webpack_require__(242);

var _reportAbuseForm2 = _interopRequireDefault(_reportAbuseForm);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPostModal = exports.ReportPostModal = function ReportPostModal(_ref) {
  var closeModal = _ref.closeModal,
      postId = _ref.postId,
      reportPost = _ref.reportPost,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_reportAbuseForm2.default, {
      initialValues: { _id: postId, reportType: '1' },
      onSubmit: reportPost,
      onCancel: closeModal,
      title: t('report-post-modal.report-post'),
      message: t('report-post-modal.help-us-understand')
    })
  );
};

ReportPostModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  reportPost: _propTypes2.default.func.isRequired,
  postId: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    reportPost: function reportPost(report) {
      return (0, _closeModal.closeModal)(report);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(ReportPostModal));

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _sharePostModal = __webpack_require__(873);

var _sharePostModal2 = _interopRequireDefault(_sharePostModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _sharePostModal2.default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _shareForm = __webpack_require__(365);

var _shareForm2 = _interopRequireDefault(_shareForm);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SharePostModal = function SharePostModal(_ref) {
  var closeModal = _ref.closeModal,
      categorySlug = _ref.categorySlug,
      postSlug = _ref.postSlug,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_shareForm2.default, { title: t('share-post-modal.share-post'), path: '/' + categorySlug + '/' + postSlug })
  );
};

SharePostModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  categorySlug: _propTypes2.default.string.isRequired,
  postSlug: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = {
  closeModal: _closeModal.closeModal
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(SharePostModal));

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _shareButton = __webpack_require__(875);

var _shareButton2 = _interopRequireDefault(_shareButton);

var _shareLink = __webpack_require__(366);

var _shareLink2 = _interopRequireDefault(_shareLink);

var _share = __webpack_require__(550);

var _share2 = _interopRequireDefault(_share);

var _getOuterUrl = __webpack_require__(63);

var _getOuterUrl2 = _interopRequireDefault(_getOuterUrl);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _shareForm = __webpack_require__(891);

var _shareForm2 = _interopRequireDefault(_shareForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShareForm = exports.ShareForm = function (_Component) {
  _inherits(ShareForm, _Component);

  function ShareForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShareForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShareForm.__proto__ || Object.getPrototypeOf(ShareForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLinkShareFormVisible: false
    }, _this.handleLinkButtonClick = function () {
      _this.setState({
        isLinkShareFormVisible: true
      });
    }, _this.handleShare = function (socialNetwork) {
      (0, _share2.default)(socialNetwork, (0, _getOuterUrl2.default)(_this.props.path));
    }, _this.handleCancel = function () {
      _this.setState({
        isLinkShareFormVisible: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShareForm, [{
    key: 'renderShareButtons',
    value: function renderShareButtons() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { className: _shareForm2.default.content },
        _react2.default.createElement(
          'span',
          { className: _shareForm2.default.button },
          _react2.default.createElement(_shareButton2.default, { type: 'facebook', title: t('share-button.via-facebook'), onClick: this.handleShare })
        ),
        _react2.default.createElement(
          'span',
          { className: _shareForm2.default.button },
          _react2.default.createElement(_shareButton2.default, { type: 'twitter', title: t('share-button.via-twitter'), onClick: this.handleShare })
        ),
        _react2.default.createElement(
          'span',
          { className: _shareForm2.default.button },
          _react2.default.createElement(_shareButton2.default, { type: 'gPlus', title: t('share-button.via-google-plus'), onClick: this.handleShare })
        ),
        _react2.default.createElement(
          'span',
          { className: _shareForm2.default.button },
          _react2.default.createElement(_shareButton2.default, { type: 'link', title: t('share-button.via-link'), onClick: this.handleLinkButtonClick })
        )
      );
    }
  }, {
    key: 'renderLinkShareForm',
    value: function renderLinkShareForm() {
      var isLinkShareFormVisible = this.state.isLinkShareFormVisible;

      if (!isLinkShareFormVisible) {
        return null;
      }

      var path = this.props.path;

      return _react2.default.createElement(
        'div',
        { className: _shareForm2.default.content },
        _react2.default.createElement(_shareLink2.default, { url: (0, _getOuterUrl2.default)(path), onCancel: this.handleCancel })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var isLinkShareFormVisible = this.state.isLinkShareFormVisible;

      var title = isLinkShareFormVisible ? t('share-form.share-link') : this.props.title;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_shareForm2.default.container, 'forum-text-color', this.props.titleFontClassName) },
        _react2.default.createElement(
          'div',
          { className: _shareForm2.default.message },
          _react2.default.createElement(_icons.ShareIcon, { className: 'forum-icon-fill' }),
          _react2.default.createElement(
            'span',
            { className: _shareForm2.default.title },
            title
          )
        ),
        isLinkShareFormVisible ? this.renderLinkShareForm() : this.renderShareButtons()
      );
    }
  }]);

  return ShareForm;
}(_react.Component);

ShareForm.propTypes = {
  title: _propTypes2.default.string.isRequired,
  path: _propTypes2.default.string.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};
exports.default = (0, _withFontClassName2.default)((0, _withTranslate2.default)(ShareForm));

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _shareButton = __webpack_require__(876);

var _shareButton2 = _interopRequireDefault(_shareButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shareButton2.default;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _shareButton = __webpack_require__(877);

var _shareButton2 = _interopRequireDefault(_shareButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICONS = {
  facebook: _icons.FacebookIcon,
  twitter: _icons.TwitterIcon,
  gPlus: _icons.GPlusIcon,
  link: _icons.LinkIcon
};

var ShareButton = function (_Component) {
  _inherits(ShareButton, _Component);

  function ShareButton(props) {
    _classCallCheck(this, ShareButton);

    var _this = _possibleConstructorReturn(this, (ShareButton.__proto__ || Object.getPrototypeOf(ShareButton)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(ShareButton, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          onClick = _props.onClick,
          type = _props.type;

      onClick(type);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          type = _props2.type,
          title = _props2.title;

      var Icon = ICONS[type];
      return _react2.default.createElement(
        'button',
        {
          className: (0, _classnames2.default)(_shareButton2.default.button, _shareButton2.default[type]),
          onClick: this.handleClick,
          'aria-label': title,
          'data-hook': 'share-button__' + type
        },
        _react2.default.createElement(Icon, { className: _shareButton2.default.icon })
      );
    }
  }]);

  return ShareButton;
}(_react.Component);

ShareButton.propTypes = {
  type: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired
};
exports.default = ShareButton;

/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_3MnNz","icon":"_2UukF","facebook":"_3DqWr","twitter":"SoTmV","gPlus":"_12p8Q","link":"_3c0FC"};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _readOnlyInput = __webpack_require__(879);

var _readOnlyInput2 = _interopRequireDefault(_readOnlyInput);

var _buttonGroup = __webpack_require__(50);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _shareLink = __webpack_require__(882);

var _shareLink2 = _interopRequireDefault(_shareLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Clipboard = void 0;
try {
  Clipboard = __webpack_require__(883);
} catch (e) {}

var ShareLink = function (_Component) {
  _inherits(ShareLink, _Component);

  function ShareLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShareLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShareLink.__proto__ || Object.getPrototypeOf(ShareLink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isClipboardSupported: false
    }, _this.setButton = function (button) {
      return _this.button = button;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShareLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isSupported = Clipboard.isSupported();
      this.setState({
        isClipboardSupported: isSupported
      });

      if (isSupported) {
        this.clipboard = new Clipboard('.' + _shareLink2.default.container + ' [data-clipboard-text]');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          onCancel = _props.onCancel,
          url = _props.url;
      var isClipboardSupported = this.state.isClipboardSupported;

      var primaryButtonProps = void 0;

      if (isClipboardSupported) {
        primaryButtonProps = {
          'data-clipboard-text': url
        };
      } else {
        primaryButtonProps = {
          style: {
            display: 'none'
          }
        };
      }

      return _react2.default.createElement(
        'div',
        { className: _shareLink2.default.container },
        _react2.default.createElement(
          'div',
          { className: _shareLink2.default.input },
          _react2.default.createElement(_readOnlyInput2.default, { value: url, autoFocus: true })
        ),
        _react2.default.createElement(_buttonGroup2.default, {
          primaryButtonText: t('share-link.copy'),
          primaryButtonProps: primaryButtonProps,
          secondaryButtonText: t('share-link.cancel'),
          secondaryButtonProps: { onClick: onCancel }
        })
      );
    }
  }]);

  return ShareLink;
}(_react.Component);

ShareLink.propTypes = {
  url: _propTypes2.default.string.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};

exports.default = (0, _withTranslate2.default)(ShareLink);

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _readOnlyInput = __webpack_require__(880);

var _readOnlyInput2 = _interopRequireDefault(_readOnlyInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _readOnlyInput2.default;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _readOnlyInput = __webpack_require__(881);

var _readOnlyInput2 = _interopRequireDefault(_readOnlyInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReadOnlyInput = function (_Component) {
  _inherits(ReadOnlyInput, _Component);

  function ReadOnlyInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReadOnlyInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReadOnlyInput.__proto__ || Object.getPrototypeOf(ReadOnlyInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchStart = function () {
      _this.input.focus();
      _this.input.setSelectionRange(0, _this.input.value.length);
    }, _this.setInput = function (element) {
      _this.input = element;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReadOnlyInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.autoFocus) {
        return;
      }

      // Needed to focus field on iOS
      try {
        var event = document.createEvent('TouchEvent');
        event.initEvent('touchstart', true, true);
        this.input.dispatchEvent(event);
      } catch (e) {
        this.handleTouchStart();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _readOnlyInput2.default.container },
        _react2.default.createElement('input', {
          className: (0, _classnames2.default)(_readOnlyInput2.default.input, 'forum-text-color'),
          type: 'text',
          ref: this.setInput,
          value: this.props.value,
          onTouchStart: this.handleTouchStart,
          onClick: this.handleTouchStart,
          readOnly: true,
          'data-hook': 'input-field'
        }),
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_readOnlyInput2.default.borders, 'forum-text-border-color') })
      );
    }
  }]);

  return ReadOnlyInput;
}(_react.Component);

ReadOnlyInput.propTypes = {
  value: _propTypes2.default.string,
  autoFocus: _propTypes2.default.bool
};
exports.default = ReadOnlyInput;

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_20AKj","input":"_1JIaK","borders":"VXuDD"};

/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2RLlb","input":"Qg0lZ"};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(884), __webpack_require__(886), __webpack_require__(887)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(885)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 885 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 886 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(888);
var delegate = __webpack_require__(889);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 888 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(890);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 890 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2xhCN","message":"_3te3p","title":"_30f3O","content":"_2Z-0_","button":"aWsk5"};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _shareLinkModal = __webpack_require__(893);

var _shareLinkModal2 = _interopRequireDefault(_shareLinkModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shareLinkModal2.default;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _shareLinkForm = __webpack_require__(894);

var _shareLinkForm2 = _interopRequireDefault(_shareLinkForm);

var _closeModal = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareLinkModal = function ShareLinkModal(_ref) {
  var closeModal = _ref.closeModal,
      url = _ref.url;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_shareLinkForm2.default, { url: url, onCancel: closeModal })
  );
};

ShareLinkModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  url: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func
};

var mapDispatchToProps = {
  closeModal: _closeModal.closeModal
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(ShareLinkModal);

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _shareLinkForm = __webpack_require__(895);

var _shareLinkForm2 = _interopRequireDefault(_shareLinkForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shareLinkForm2.default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(9);

var _shareLink = __webpack_require__(366);

var _shareLink2 = _interopRequireDefault(_shareLink);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _shareLinkForm = __webpack_require__(896);

var _shareLinkForm2 = _interopRequireDefault(_shareLinkForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareLinkForm = function ShareLinkForm(_ref) {
  var url = _ref.url,
      _onCancel = _ref.onCancel,
      titleFontClassName = _ref.titleFontClassName,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_shareLinkForm2.default.container, 'forum-text-color', titleFontClassName) },
    _react2.default.createElement(
      'div',
      { className: _shareLinkForm2.default.message },
      _react2.default.createElement(_icons.LinkIcon, { className: 'forum-icon-fill' }),
      _react2.default.createElement(
        'span',
        { className: _shareLinkForm2.default.title },
        t('share-form.share-link')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _shareLinkForm2.default.content },
      _react2.default.createElement(_shareLink2.default, { url: url, onCancel: function onCancel() {
          return _onCancel();
        } })
    )
  );
};

ShareLinkForm.propTypes = {
  url: _propTypes2.default.string.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  titleFontClassName: _propTypes2.default.string,
  t: _propTypes2.default.func
};

exports.default = _lodash2.default.flowRight(_withFontClassName2.default, _withTranslate2.default)(ShareLinkForm);

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2crmW","message":"_1MrZl","title":"_37s6P","content":"_2iyxB","button":"g7DNb"};

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _shareCommentModal = __webpack_require__(898);

var _shareCommentModal2 = _interopRequireDefault(_shareCommentModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shareCommentModal2.default;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _shareForm = __webpack_require__(365);

var _shareForm2 = _interopRequireDefault(_shareForm);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareCommentModal = function ShareCommentModal(_ref) {
  var closeModal = _ref.closeModal,
      categorySlug = _ref.categorySlug,
      postSlug = _ref.postSlug,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_shareForm2.default, { title: t('share-comment-modal.share-comment'), path: '/' + categorySlug + '/' + postSlug })
  );
};

ShareCommentModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  categorySlug: _propTypes2.default.string.isRequired,
  postSlug: _propTypes2.default.string.isRequired,
  commentId: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = {
  closeModal: _closeModal.closeModal
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(ShareCommentModal));

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _reportMemberModal = __webpack_require__(900);

var _reportMemberModal2 = _interopRequireDefault(_reportMemberModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reportMemberModal2.default;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportMemberModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _reportAbuseForm = __webpack_require__(242);

var _reportAbuseForm2 = _interopRequireDefault(_reportAbuseForm);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportMemberModal = exports.ReportMemberModal = function ReportMemberModal(_ref) {
  var closeModal = _ref.closeModal,
      userId = _ref.userId,
      reportUser = _ref.reportUser,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_reportAbuseForm2.default, {
      initialValues: { _id: userId, reportType: '1' },
      onSubmit: reportUser,
      onCancel: closeModal,
      title: t('report-member-modal.report-member'),
      message: t('report-member-modal.help-us-understand')
    })
  );
};

ReportMemberModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  reportUser: _propTypes2.default.func.isRequired,
  userId: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = {
  closeModal: _closeModal.closeModal,
  reportUser: function reportUser(report) {
    return (0, _closeModal.closeModal)(report);
  }
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(ReportMemberModal));

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promoteModeratorModal = __webpack_require__(902);

var _promoteModeratorModal2 = _interopRequireDefault(_promoteModeratorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _promoteModeratorModal2.default;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _promoteModeratorModal = __webpack_require__(903);

var _promoteModeratorModal2 = _interopRequireDefault(_promoteModeratorModal);

var _closeModal = __webpack_require__(12);

var _userSelectors = __webpack_require__(69);

var _searchSelectors = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: (0, _userSelectors.getUserById)(state, ownProps.userId) || (0, _searchSelectors.getUserById)(state, ownProps.userId)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    promoteModerator: function promoteModerator() {
      return (0, _closeModal.closeModal)(ownProps.userId);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_promoteModeratorModal2.default);

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promoteModeratorModal = __webpack_require__(904);

var _promoteModeratorModal2 = _interopRequireDefault(_promoteModeratorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _promoteModeratorModal2.default;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoteModeratorModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _icons = __webpack_require__(9);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _confirmation = __webpack_require__(64);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _promoteUserDetails = __webpack_require__(367);

var _promoteUserDetails2 = _interopRequireDefault(_promoteUserDetails);

var _separator = __webpack_require__(18);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _promoteModeratorModal = __webpack_require__(907);

var _promoteModeratorModal2 = _interopRequireDefault(_promoteModeratorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromoteModeratorModal = exports.PromoteModeratorModal = function PromoteModeratorModal(_ref) {
  var user = _ref.user,
      closeModal = _ref.closeModal,
      promoteModerator = _ref.promoteModerator,
      isDesktop = _ref.isDesktop,
      isMobile = _ref.isMobile,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { className: _promoteModeratorModal2.default.modal, onClose: closeModal },
    _react2.default.createElement(
      'div',
      { className: _promoteModeratorModal2.default.container },
      _react2.default.createElement(_promoteUserDetails2.default, { user: user }),
      isMobile && _react2.default.createElement(_separator.HorizontalSeparator, { className: _promoteModeratorModal2.default.horizontalSeparator }),
      isDesktop && _react2.default.createElement(_separator.VerticalSeparator, { className: _promoteModeratorModal2.default.verticalSeparator }),
      _react2.default.createElement(
        _confirmation2.default,
        {
          icon: _icons.ModeratorIcon,
          title: t('promote-moderator-modal.set-as-moderator'),
          confirm: t('promote-moderator-modal.confirm'),
          onConfirm: promoteModerator,
          cancel: t('promote-moderator-modal.cancel'),
          onCancel: closeModal
        },
        _react2.default.createElement(
          'p',
          null,
          t('promote-moderator-modal.have-access-to-categories')
        ),
        _react2.default.createElement(
          'p',
          null,
          t('promote-moderator-modal.what-they-can-do')
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            t('promote-moderator-modal.delete-posts')
          ),
          _react2.default.createElement(
            'li',
            null,
            t('promote-moderator-modal.disable-commenting')
          ),
          _react2.default.createElement(
            'li',
            null,
            t('promote-moderator-modal.move-posts')
          )
        )
      )
    )
  );
};

PromoteModeratorModal.propTypes = {
  user: _propTypes2.default.object.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  promoteModerator: _propTypes2.default.func.isRequired,
  isDesktop: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

exports.default = _lodash2.default.flowRight(_withDeviceType2.default, _withTranslate2.default)(PromoteModeratorModal);

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _promoteUserDetails = __webpack_require__(906);

var _promoteUserDetails2 = _interopRequireDefault(_promoteUserDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromoteUserDetails = function PromoteUserDetails(_ref) {
  var contentFontClassName = _ref.contentFontClassName,
      user = _ref.user;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_promoteUserDetails2.default.container, contentFontClassName, 'forum-text-color') },
    _react2.default.createElement(_userAvatarImage2.default, { type: 'promote', user: user }),
    _react2.default.createElement(
      'h3',
      { className: _promoteUserDetails2.default.name },
      user.name
    )
  );
};

PromoteUserDetails.propTypes = {
  contentFontClassName: _propTypes2.default.string.isRequired,
  user: _propTypes2.default.object.isRequired
};

exports.default = (0, _withFontClassName2.default)(PromoteUserDetails);

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3KP0I","name":"_2CQ9n"};

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1C0Er","container":"_3QC39","verticalSeparator":"bxCRi","horizontalSeparator":"_2K5kg"};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _demoteModeratorModal = __webpack_require__(909);

var _demoteModeratorModal2 = _interopRequireDefault(_demoteModeratorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _demoteModeratorModal2.default;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _closeModal = __webpack_require__(12);

var _demoteModeratorModal = __webpack_require__(910);

var _demoteModeratorModal2 = _interopRequireDefault(_demoteModeratorModal);

var _userSelectors = __webpack_require__(69);

var _searchSelectors = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: (0, _userSelectors.getUserById)(state, ownProps.userId) || (0, _searchSelectors.getUserById)(state, ownProps.userId)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    demoteModerator: function demoteModerator() {
      return (0, _closeModal.closeModal)(ownProps.userId);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_demoteModeratorModal2.default);

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _demoteModeratorModal = __webpack_require__(911);

var _demoteModeratorModal2 = _interopRequireDefault(_demoteModeratorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _demoteModeratorModal2.default;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DemoteModeratorModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _icons = __webpack_require__(9);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _confirmation = __webpack_require__(64);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _promoteUserDetails = __webpack_require__(367);

var _promoteUserDetails2 = _interopRequireDefault(_promoteUserDetails);

var _separator = __webpack_require__(18);

var _withDeviceType = __webpack_require__(20);

var _withDeviceType2 = _interopRequireDefault(_withDeviceType);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _demoteModeratorModal = __webpack_require__(912);

var _demoteModeratorModal2 = _interopRequireDefault(_demoteModeratorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DemoteModeratorModal = exports.DemoteModeratorModal = function DemoteModeratorModal(_ref) {
  var user = _ref.user,
      closeModal = _ref.closeModal,
      demoteModerator = _ref.demoteModerator,
      isDesktop = _ref.isDesktop,
      isMobile = _ref.isMobile,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { className: _demoteModeratorModal2.default.modal, onClose: closeModal },
    _react2.default.createElement(
      'div',
      { className: _demoteModeratorModal2.default.container },
      _react2.default.createElement(_promoteUserDetails2.default, { user: user }),
      isMobile && _react2.default.createElement(_separator.HorizontalSeparator, { className: _demoteModeratorModal2.default.horizontalSeparator }),
      isDesktop && _react2.default.createElement(_separator.VerticalSeparator, { className: _demoteModeratorModal2.default.verticalSeparator }),
      _react2.default.createElement(
        _confirmation2.default,
        {
          icon: _icons.ModeratorIcon,
          title: t('demote-moderator-modal.remove-moderator-permissions'),
          confirm: t('demote-moderator-modal.confirm'),
          onConfirm: demoteModerator,
          cancel: t('demote-moderator-modal.cancel'),
          onCancel: closeModal
        },
        _react2.default.createElement(
          'p',
          null,
          t('demote-moderator-modal.are-you-sure')
        ),
        _react2.default.createElement(
          'p',
          null,
          t('demote-moderator-modal.will-no-longer')
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            t('demote-moderator-modal.delete-posts')
          ),
          _react2.default.createElement(
            'li',
            null,
            t('demote-moderator-modal.disable-commenting')
          ),
          _react2.default.createElement(
            'li',
            null,
            t('demote-moderator-modal.move-posts')
          )
        )
      )
    )
  );
};

DemoteModeratorModal.propTypes = {
  user: _propTypes2.default.object.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  demoteModerator: _propTypes2.default.func.isRequired,
  isDesktop: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

exports.default = _lodash2.default.flowRight(_withDeviceType2.default, _withTranslate2.default)(DemoteModeratorModal);

/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2Qjzk","container":"_2Ff8F","verticalSeparator":"_2SC6B","horizontalSeparator":"_34wZ5"};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _unfollowMemberModal = __webpack_require__(914);

var _unfollowMemberModal2 = _interopRequireDefault(_unfollowMemberModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _unfollowMemberModal2.default;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnfollowMemberModal = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(34);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _memberConfirmation = __webpack_require__(915);

var _memberConfirmation2 = _interopRequireDefault(_memberConfirmation);

var _closeModal = __webpack_require__(12);

var _userSelectors = __webpack_require__(69);

var _searchSelectors = __webpack_require__(148);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnfollowMemberModal = exports.UnfollowMemberModal = function UnfollowMemberModal(_ref) {
  var user = _ref.user,
      closeModal = _ref.closeModal,
      unfollowMember = _ref.unfollowMember,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(
      _memberConfirmation2.default,
      {
        user: user,
        confirm: t('follow-member-modal.unfollow'),
        cancel: t('follow-member-modal.cancel'),
        onConfirm: unfollowMember,
        onCancel: closeModal
      },
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'follow-member-modal.unfollow-user',
          name: _react2.default.createElement(
            'strong',
            null,
            user.name
          )
        })
      )
    )
  );
};

UnfollowMemberModal.propTypes = {
  userId: _propTypes2.default.string.isRequired,
  user: _propTypes2.default.object.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  unfollowMember: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: (0, _userSelectors.getUserById)(state, ownProps.userId) || (0, _searchSelectors.getUserById)(state, ownProps.userId)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    unfollowMember: function unfollowMember() {
      return (0, _closeModal.closeModal)(ownProps.userId);
    }
  }, dispatch);
};

exports.default = _lodash2.default.flowRight((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withTranslate2.default)(UnfollowMemberModal);

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _memberConfirmation = __webpack_require__(916);

var _memberConfirmation2 = _interopRequireDefault(_memberConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _memberConfirmation2.default;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _buttonGroup = __webpack_require__(50);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _userAvatarImage = __webpack_require__(116);

var _userAvatarImage2 = _interopRequireDefault(_userAvatarImage);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _memberConfirmation = __webpack_require__(917);

var _memberConfirmation2 = _interopRequireDefault(_memberConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberConfirmation = function MemberConfirmation(_ref) {
  var user = _ref.user,
      children = _ref.children,
      confirm = _ref.confirm,
      onConfirm = _ref.onConfirm,
      cancel = _ref.cancel,
      onCancel = _ref.onCancel,
      contentFontClassName = _ref.contentFontClassName;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_memberConfirmation2.default.container, contentFontClassName, 'forum-text-color') },
    _react2.default.createElement(
      'div',
      { className: _memberConfirmation2.default.avatar },
      _react2.default.createElement(_userAvatarImage2.default, { type: 'promote', user: user })
    ),
    children && _react2.default.createElement(
      'div',
      { className: _memberConfirmation2.default.content },
      children
    ),
    _react2.default.createElement(_buttonGroup2.default, {
      primaryButtonText: confirm,
      primaryButtonProps: { onClick: function onClick() {
          return onConfirm();
        } },
      secondaryButtonText: cancel,
      secondaryButtonProps: { onClick: function onClick() {
          return onCancel();
        } }
    })
  );
};

MemberConfirmation.propTypes = {
  user: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node,
  confirm: _propTypes2.default.string.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  cancel: _propTypes2.default.string.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  contentFontClassName: _propTypes2.default.string
};

exports.default = (0, _withFontClassName2.default)(MemberConfirmation);

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2l3Cw","avatar":"_2V8Oj","content":"_2Z6uX"};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _blockMemberModal = __webpack_require__(919);

var _blockMemberModal2 = _interopRequireDefault(_blockMemberModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _blockMemberModal2.default;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockMemberModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _blockConfirmation = __webpack_require__(368);

var _blockConfirmation2 = _interopRequireDefault(_blockConfirmation);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockMemberModal = exports.BlockMemberModal = function BlockMemberModal(_ref) {
  var closeModal = _ref.closeModal,
      blockMember = _ref.blockMember,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_blockConfirmation2.default, {
      title: t('block-member-modal.block-user'),
      message: t('block-member-modal.are-you-sure'),
      confirmButton: t('block-member-modal.confirm'),
      onConfirm: blockMember,
      onCancel: closeModal
    })
  );
};

BlockMemberModal.propTypes = {
  userId: _propTypes2.default.string.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  blockMember: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    blockMember: function blockMember() {
      return (0, _closeModal.closeModal)(ownProps.userId);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(BlockMemberModal));

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockConfirmation = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icons = __webpack_require__(9);

var _confirmation = __webpack_require__(64);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockConfirmation = exports.BlockConfirmation = function BlockConfirmation(_ref) {
  var title = _ref.title,
      message = _ref.message,
      confirmButton = _ref.confirmButton,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      t = _ref.t;
  return _react2.default.createElement(
    _confirmation2.default,
    {
      icon: _icons.BlockIcon,
      title: title,
      confirm: confirmButton,
      onConfirm: onConfirm,
      cancel: t('block-confirmation.cancel-button'),
      onCancel: onCancel
    },
    _react2.default.createElement(
      'p',
      null,
      message
    )
  );
};

BlockConfirmation.propTypes = {
  t: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string,
  confirmButton: _propTypes2.default.string,
  message: _propTypes2.default.string
};

exports.default = (0, _withTranslate2.default)(BlockConfirmation);

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _unblockMemberModal = __webpack_require__(922);

var _unblockMemberModal2 = _interopRequireDefault(_unblockMemberModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _unblockMemberModal2.default;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnblockMemberModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _blockConfirmation = __webpack_require__(368);

var _blockConfirmation2 = _interopRequireDefault(_blockConfirmation);

var _closeModal = __webpack_require__(12);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnblockMemberModal = exports.UnblockMemberModal = function UnblockMemberModal(_ref) {
  var closeModal = _ref.closeModal,
      unblockMember = _ref.unblockMember,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_blockConfirmation2.default, {
      title: t('unblock-member-modal.unblock-user'),
      message: t('unblock-member-modal.are-you-sure'),
      confirmButton: t('unblock-member-modal.confirm'),
      onConfirm: unblockMember,
      onCancel: closeModal
    })
  );
};

UnblockMemberModal.propTypes = {
  userId: _propTypes2.default.string.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  unblockMember: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    unblockMember: function unblockMember() {
      return (0, _closeModal.closeModal)(ownProps.userId);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(UnblockMemberModal));

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _deleteCategoryModal = __webpack_require__(924);

var _deleteCategoryModal2 = _interopRequireDefault(_deleteCategoryModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _deleteCategoryModal2.default;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteCategoryModal = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _closeModal = __webpack_require__(12);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _deleteConfirmation = __webpack_require__(241);

var _deleteConfirmation2 = _interopRequireDefault(_deleteConfirmation);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteCategoryModal = exports.DeleteCategoryModal = function DeleteCategoryModal(_ref) {
  var closeModal = _ref.closeModal,
      deleteCategory = _ref.deleteCategory,
      t = _ref.t;
  return _react2.default.createElement(
    _modal2.default,
    { onClose: closeModal },
    _react2.default.createElement(_deleteConfirmation2.default, {
      title: t('delete-category-modal.delete-category'),
      message: t('delete-category-modal.will-delete-posts-and-comments'),
      onConfirm: deleteCategory,
      onCancel: closeModal
    })
  );
};

DeleteCategoryModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  deleteCategory: _propTypes2.default.func.isRequired,
  categoryId: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    closeModal: _closeModal.closeModal,
    deleteCategory: function deleteCategory() {
      return (0, _closeModal.closeModal)(ownProps.categoryId);
    }
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _withTranslate2.default)(DeleteCategoryModal));

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profileActionsWidget = __webpack_require__(926);

var _profileActionsWidget2 = _interopRequireDefault(_profileActionsWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profileActionsWidget2.default;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileActionsWidget = undefined;

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _popupWidgetProfileActions = __webpack_require__(927);

var _popupWidgetProfileActions2 = _interopRequireDefault(_popupWidgetProfileActions);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _widgetPopup = __webpack_require__(184);

var _withCardBackgroundColor = __webpack_require__(39);

var _withCardBackgroundColor2 = _interopRequireDefault(_withCardBackgroundColor);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _profileActionsWidget = __webpack_require__(933);

var _profileActionsWidget2 = _interopRequireDefault(_profileActionsWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileActionsWidget = exports.ProfileActionsWidget = function (_Component) {
  _inherits(ProfileActionsWidget, _Component);

  function ProfileActionsWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProfileActionsWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfileActionsWidget.__proto__ || Object.getPrototypeOf(ProfileActionsWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      style: {}
    }, _this.componentDidMount = function () {
      (0, _widgetPopup.popupLoaded)();
      _wixSdkPolyfill2.default.PubSub.subscribe(_widgetPopup.COMMUNITIES_POPUP_SHOW, _this.showPopup);
      _wixSdkPolyfill2.default.PubSub.subscribe(_widgetPopup.COMMUNITIES_POPUP_HIDE, _this.hidePopup);
    }, _this.componentWillUnmount = function () {
      _wixSdkPolyfill2.default.PubSub.unsubscribe(_widgetPopup.COMMUNITIES_POPUP_SHOW, _this.showPopup);
      _wixSdkPolyfill2.default.PubSub.unsubscribe(_widgetPopup.COMMUNITIES_POPUP_HIDE, _this.hidePopup);
    }, _this.getTriangleCenterPosition = function () {
      var containerRect = _this.container.getBoundingClientRect();
      var triangleRect = _this.triangleRef.getBoundingClientRect();
      var triangleCenterPosition = triangleRect.left + triangleRect.width / 2;
      var triangleCenterPositionRelativeToContainer = triangleCenterPosition - containerRect.left;
      return triangleCenterPositionRelativeToContainer;
    }, _this.showPopup = function (_ref2) {
      var _ref2$data = _ref2.data,
          x = _ref2$data.x,
          y = _ref2$data.y;

      _this.setState({
        style: {
          marginLeft: x - _this.getTriangleCenterPosition(),
          marginTop: y
        }
      });
      _wixSdkPolyfill2.default.setHeight(10000);
      (0, _widgetPopup.popupToggled)();
    }, _this.hidePopup = function () {
      _wixSdkPolyfill2.default.setHeight(0);
    }, _this.handleHidePopup = function () {
      (0, _widgetPopup.hidePopup)();
    }, _this.setContainer = function (container) {
      _this.container = container;
    }, _this.setTriangleRef = function (el) {
      _this.triangleRef = el;
    }, _this.render = function () {
      var _this$props = _this.props,
          cardBackgroundColor = _this$props.cardBackgroundColor,
          contentFontClassName = _this$props.contentFontClassName;

      var actionsClassName = (0, _classnames2.default)(_profileActionsWidget2.default.container, _profileActionsWidget2.default.right, contentFontClassName, 'forum-text-color', 'forum-card-border-color', 'default-forum-card-background-color');

      var triangleClassName = (0, _classnames2.default)(_profileActionsWidget2.default.triangle, 'forum-card-border-color', 'default-forum-card-background-color');
      var backgroundStyle = {
        backgroundColor: cardBackgroundColor
      };

      return _react2.default.createElement(
        'div',
        { onClick: _this.handleHidePopup, className: _profileActionsWidget2.default.overlay },
        _react2.default.createElement(
          'div',
          { className: _profileActionsWidget2.default.wrapper, style: _this.state.style, ref: _this.setContainer },
          _react2.default.createElement(
            'div',
            { className: actionsClassName },
            _react2.default.createElement('div', { className: triangleClassName, style: backgroundStyle, ref: _this.setTriangleRef }),
            _react2.default.createElement(
              'div',
              { className: 'default-forum-card-background-color', style: backgroundStyle },
              _react2.default.createElement(_popupWidgetProfileActions2.default, null)
            )
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ProfileActionsWidget;
}(_react.Component);

ProfileActionsWidget.propTypes = {
  cardBackgroundColor: _propTypes2.default.string,
  contentFontClassName: _propTypes2.default.string
};

exports.default = (0, _lodash.flowRight)(_withCardBackgroundColor2.default, _withFontClassName2.default)(ProfileActionsWidget);

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _popupWidgetProfileActions = __webpack_require__(928);

var _popupWidgetProfileActions2 = _interopRequireDefault(_popupWidgetProfileActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _popupWidgetProfileActions2.default;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _reactRedux = __webpack_require__(5);

var _applications = __webpack_require__(25);

var _widgetAvatarActions = __webpack_require__(551);

var _buttonClicked2 = __webpack_require__(57);

var _privateProfileActions = __webpack_require__(520);

var _widgetPopup = __webpack_require__(184);

var _communitiesContextSelectors = __webpack_require__(47);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    blogConfig: (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.BLOG_APP_ID),
    navigation: {
      navigateToProfile: function navigateToProfile() {
        return (0, _widgetPopup.sendButtonClicked)({ type: _widgetAvatarActions.NAVIGATE_TO_PROFILE });
      },
      navigateToProfileSettings: function navigateToProfileSettings() {
        return (0, _widgetPopup.sendButtonClicked)({ type: _widgetAvatarActions.NAVIGATE_TO_PROFILE_SETTINGS });
      },
      navigateToCreatePost: function navigateToCreatePost() {
        return (0, _widgetPopup.sendButtonClicked)({ type: _widgetAvatarActions.NAVIGATE_TO_CREATE_POST });
      },
      navigateToMyDrafts: function navigateToMyDrafts() {
        return (0, _widgetPopup.sendButtonClicked)({ type: _widgetAvatarActions.NAVIGATE_TO_MY_DRAFTS });
      }
    }
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    buttonClicked: function buttonClicked(data) {
      return dispatch((0, _buttonClicked2.buttonClicked)(_extends({ name: 'action_click', type: 'profile_widget' }, data)));
    },
    navigateToRoot: function navigateToRoot() {},
    logoutMember: function logoutMember() {
      return (0, _widgetPopup.sendButtonClicked)({ type: _widgetAvatarActions.LOGOUT });
    }
  };
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withTranslate2.default)(_privateProfileActions.PrivateProfileActions);

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivateProfileActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _applications = __webpack_require__(25);

var _routerUtils = __webpack_require__(55);

var _buttonClicked2 = __webpack_require__(57);

var _logoutMember = __webpack_require__(129);

var _actionButton = __webpack_require__(250);

var _actionButton2 = _interopRequireDefault(_actionButton);

var _userRole = __webpack_require__(169);

var _communitiesContextSelectors = __webpack_require__(47);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withAuth = __webpack_require__(23);

var _withAuth2 = _interopRequireDefault(_withAuth);

var _withEnvironment = __webpack_require__(30);

var _withEnvironment2 = _interopRequireDefault(_withEnvironment);

var _isMemberPartInstalled = __webpack_require__(932);

var _memberAreaSelectors = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivateProfileActions = exports.PrivateProfileActions = function (_Component) {
  _inherits(PrivateProfileActions, _Component);

  function PrivateProfileActions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PrivateProfileActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrivateProfileActions.__proto__ || Object.getPrototypeOf(PrivateProfileActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleGoToProfile = function () {
      var _this$props = _this.props,
          buttonClicked = _this$props.buttonClicked,
          navigateToProfile = _this$props.navigation.navigateToProfile,
          user = _this$props.user;

      buttonClicked({ action: 'profile' });
      navigateToProfile(user);
    }, _this.handleLogout = function () {
      var _this$props2 = _this.props,
          buttonClicked = _this$props2.buttonClicked,
          navigateToRoot = _this$props2.navigateToRoot,
          logoutMember = _this$props2.logoutMember;

      navigateToRoot();
      buttonClicked({ action: 'logout' });
      logoutMember();
    }, _this.handleGoToSettings = function () {
      var _this$props3 = _this.props,
          buttonClicked = _this$props3.buttonClicked,
          navigateToProfileSettings = _this$props3.navigation.navigateToProfileSettings,
          user = _this$props3.user;

      buttonClicked({ action: 'settings' });
      navigateToProfileSettings(user);
    }, _this.handleGoToCreatePost = function () {
      var _this$props4 = _this.props,
          buttonClicked = _this$props4.buttonClicked,
          navigateToCreatePost = _this$props4.navigation.navigateToCreatePost;

      buttonClicked({ action: 'create_post' });
      navigateToCreatePost();
    }, _this.handleGoToMyDrafts = function () {
      var _this$props5 = _this.props,
          buttonClicked = _this$props5.buttonClicked,
          navigateToMyDrafts = _this$props5.navigation.navigateToMyDrafts,
          user = _this$props5.user;

      buttonClicked({ action: 'my_drafts' });
      navigateToMyDrafts(user);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PrivateProfileActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isInstalled = _props.blogConfig.isInstalled,
          isMemberPartInstalled = _props.isMemberPartInstalled,
          currentUser = _props.currentUser,
          t = _props.t;

      var canWrite = ['owner', 'writer'].indexOf((0, _userRole.getUserRoleByApp)(currentUser, _applications.BLOG_APP_ID)) > -1;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'private-profile-actions__profile', onClick: this.handleGoToProfile },
          t('breadcrumbs.profile')
        ),
        isInstalled && canWrite && _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'private-profile-actions__create-post', onClick: this.handleGoToCreatePost },
          t('private-profile-actions.create-post')
        ),
        isInstalled && isMemberPartInstalled && canWrite && _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'private-profile-actions__drafts', onClick: this.handleGoToMyDrafts },
          t('private-profile-actions.my-drafts')
        ),
        _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'private-profile-actions__settings', onClick: this.handleGoToSettings },
          t('private-profile-actions.settings')
        ),
        _react2.default.createElement(
          _actionButton2.default,
          { 'data-hook': 'private-profile-actions__logout', onClick: this.handleLogout },
          t('private-profile-actions.logout')
        )
      );
    }
  }]);

  return PrivateProfileActions;
}(_react.Component);

PrivateProfileActions.propTypes = {
  blogConfig: _propTypes2.default.object,
  buttonClicked: _propTypes2.default.func,
  currentUser: _propTypes2.default.object,
  logoutMember: _propTypes2.default.func,
  navigation: _propTypes2.default.object,
  navigateToRoot: _propTypes2.default.func,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object,
  isMemberPartInstalled: _propTypes2.default.bool,
  isMemberAreaActive: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    blogConfig: (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.BLOG_APP_ID),
    isMemberPartInstalled: (0, _isMemberPartInstalled.isMemberPartInstalled)(state),
    isMemberAreaActive: (0, _memberAreaSelectors.isMemberAreaActive)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    buttonClicked: function buttonClicked(data) {
      return (0, _buttonClicked2.buttonClicked)(_extends({ name: 'action_click', type: 'profile' }, data));
    },
    logoutMember: _logoutMember.logoutMember,
    navigateToRoot: function navigateToRoot() {
      return (0, _routerUtils.replace)('/');
    }
  }, dispatch);
};

// prettier-ignore
exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withAuth2.default, (0, _withEnvironment2.default)({ navigation: 'navigation' }), _withTranslate2.default)(PrivateProfileActions);

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _separator = __webpack_require__(18);

var _accessibility = __webpack_require__(49);

var _actionButton = __webpack_require__(931);

var _actionButton2 = _interopRequireDefault(_actionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionButton = function ActionButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      children = _ref.children;

  var icon = (0, _lodash.isArray)(children) ? children[0] : null;
  var text = (0, _lodash.isArray)(children) ? children[1] : children;
  var rest = (0, _lodash.isArray)(children) ? children.slice(2) : null;

  return _react2.default.createElement(
    'div',
    {
      onClick: onClick,
      onKeyUp: (0, _accessibility.handleEnterKeyUp)(onClick),
      className: (0, _classnames2.default)(_actionButton2.default.actionItem, className, 'action-button'),
      role: 'menuitem',
      tabIndex: '0',
      'data-hook': 'action-button'
    },
    _react2.default.createElement(
      'div',
      { className: _actionButton2.default.actionWrapper },
      icon && _react2.default.createElement(
        'div',
        { className: _actionButton2.default.icon },
        icon
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_actionButton2.default.actionText, 'blog-text-color', 'action-button__text') },
        text
      ),
      rest
    ),
    _react2.default.createElement(
      'div',
      { className: _actionButton2.default.separator },
      _react2.default.createElement(_separator.HorizontalSeparator, null)
    )
  );
};

ActionButton.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired
};

exports.default = ActionButton;

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actionItem":"VcUai","actionWrapper":"_39hWI","actionText":"_33TU9","icon":"O7y0d","separator":"_3hGsT"};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMemberPartInstalled = undefined;

var _applications = __webpack_require__(25);

var _communitiesContextSelectors = __webpack_require__(47);

var isMemberPartInstalled = exports.isMemberPartInstalled = function isMemberPartInstalled(state) {
  return (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.MEMBERS_APP_ID).isInstalled || (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.SANTA_MEMBERS_APP_ID).isInstalled;
};

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2SB0u","container":"INBbS","overlay":"_1a9zH","triangle":"_3Pzg2","right":"_2320Y","top":"_2pdhd"};

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _profileActionsUpperPart = __webpack_require__(935);

var _profileActionsUpperPart2 = _interopRequireDefault(_profileActionsUpperPart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _profileActionsUpperPart2.default;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileActionsUpperPart = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _profileActionsUpperPart = __webpack_require__(936);

var _profileActionsUpperPart2 = _interopRequireDefault(_profileActionsUpperPart);

var _widgetPopup = __webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileActionsUpperPart = exports.ProfileActionsUpperPart = function (_Component) {
  _inherits(ProfileActionsUpperPart, _Component);

  function ProfileActionsUpperPart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProfileActionsUpperPart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfileActionsUpperPart.__proto__ || Object.getPrototypeOf(ProfileActionsUpperPart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      style: {}
    }, _this.componentDidMount = function () {
      _wixSdkPolyfill2.default.PubSub.subscribe(_widgetPopup.COMMUNITIES_POPUP_SHOW, _this.showPopup);
      _wixSdkPolyfill2.default.PubSub.subscribe(_widgetPopup.COMMUNITIES_POPUP_HIDE, _this.hidePopup);
    }, _this.componentWillUnmount = function () {
      _wixSdkPolyfill2.default.PubSub.unsubscribe(_widgetPopup.COMMUNITIES_POPUP_SHOW, _this.showPopup);
      _wixSdkPolyfill2.default.PubSub.unsubscribe(_widgetPopup.COMMUNITIES_POPUP_HIDE, _this.hidePopup);
    }, _this.showPopup = function () {
      _wixSdkPolyfill2.default.setHeight(10000);
    }, _this.hidePopup = function () {
      _wixSdkPolyfill2.default.setHeight(0);
    }, _this.handleHidePopup = function () {
      (0, _widgetPopup.hidePopup)();
    }, _this.render = function () {
      return _react2.default.createElement('div', { onClick: _this.handleHidePopup, className: _profileActionsUpperPart2.default.overlay });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ProfileActionsUpperPart;
}(_react.Component);

exports.default = ProfileActionsUpperPart;

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1lw_k"};

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _loginModal = __webpack_require__(938);

var _loginModal2 = _interopRequireDefault(_loginModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loginModal2.default;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _fullScreenWindow = __webpack_require__(939);

var _fullScreenWindow2 = _interopRequireDefault(_fullScreenWindow);

var _loginScreen = __webpack_require__(552);

var _loginScreen2 = _interopRequireDefault(_loginScreen);

var _icons = __webpack_require__(9);

var _closeModal = __webpack_require__(12);

var _loginMember = __webpack_require__(264);

var _loginModal = __webpack_require__(946);

var _loginModal2 = _interopRequireDefault(_loginModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginModal = function (_Component) {
  _inherits(LoginModal, _Component);

  function LoginModal(props) {
    _classCallCheck(this, LoginModal);

    var _this = _possibleConstructorReturn(this, (LoginModal.__proto__ || Object.getPrototypeOf(LoginModal)).call(this, props));

    _this.handleLogin = _this.handleLogin.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    return _this;
  }

  _createClass(LoginModal, [{
    key: 'handleLogin',
    value: function handleLogin(member) {
      var _props = this.props,
          loginMember = _props.loginMember,
          closeModal = _props.closeModal;


      return loginMember(member).then(function () {
        return closeModal();
      });
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.props.closeModal();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _fullScreenWindow2.default,
        null,
        _react2.default.createElement(
          'div',
          { className: _loginModal2.default.container },
          _react2.default.createElement(
            _loginScreen2.default,
            { onLogin: this.handleLogin, onLoginError: this.handleClose },
            _react2.default.createElement(
              'button',
              { className: _loginModal2.default.closeButton, onClick: this.handleClose },
              _react2.default.createElement(_icons.XSmall, null)
            )
          )
        )
      );
    }
  }]);

  return LoginModal;
}(_react.Component);

LoginModal.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  loginMember: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = {
  closeModal: _closeModal.closeModal,
  loginMember: _loginMember.loginMember
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(LoginModal);

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _fullScreenWindow = __webpack_require__(940);

var _fullScreenWindow2 = _interopRequireDefault(_fullScreenWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _fullScreenWindow2.default;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bodyScroll = __webpack_require__(941);

var _fullScreenWindow = __webpack_require__(942);

var _fullScreenWindow2 = _interopRequireDefault(_fullScreenWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullScreenWindow = function (_Component) {
  _inherits(FullScreenWindow, _Component);

  function FullScreenWindow() {
    _classCallCheck(this, FullScreenWindow);

    return _possibleConstructorReturn(this, (FullScreenWindow.__proto__ || Object.getPrototypeOf(FullScreenWindow)).apply(this, arguments));
  }

  _createClass(FullScreenWindow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _bodyScroll.disableScroll)();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _bodyScroll.enableScroll)();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _fullScreenWindow2.default.container },
        _react2.default.createElement(
          'div',
          { className: _fullScreenWindow2.default.content },
          this.props.children
        )
      );
    }
  }]);

  return FullScreenWindow;
}(_react.Component);

FullScreenWindow.propTypes = {
  children: _propTypes2.default.node
};
exports.default = FullScreenWindow;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NO_SCROLL_CLASS = 'no-scroll';
var scrollTop = 0;

var enableScroll = exports.enableScroll = function enableScroll() {
  document.documentElement.classList.remove(NO_SCROLL_CLASS);
  window.scrollTo(0, scrollTop);
};
var disableScroll = exports.disableScroll = function disableScroll() {
  scrollTop = window.scrollY || document.documentElement.scrollTop;
  document.documentElement.classList.add(NO_SCROLL_CLASS);
};

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2zxXv","content":"_33iep"};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _loginButton = __webpack_require__(521);

var _loginButton2 = _interopRequireDefault(_loginButton);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withCardBorderWidth = __webpack_require__(43);

var _withCardBorderWidth2 = _interopRequireDefault(_withCardBorderWidth);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _loginScreen = __webpack_require__(945);

var _loginScreen2 = _interopRequireDefault(_loginScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LoginScreen = function LoginScreen(_ref) {
  var children = _ref.children,
      t = _ref.t,
      borderWidth = _ref.borderWidth,
      titleFontClassName = _ref.titleFontClassName,
      contentFontClassName = _ref.contentFontClassName,
      props = _objectWithoutProperties(_ref, ['children', 't', 'borderWidth', 'titleFontClassName', 'contentFontClassName']);

  var className = (0, _classnames2.default)(_loginScreen2.default.page, 'login-screen', 'forum-card-background-color', 'forum-card-border-color', 'forum-text-color', contentFontClassName);
  return _react2.default.createElement(
    'div',
    { className: className, style: { borderWidth: borderWidth } },
    _react2.default.createElement(
      'div',
      { className: _loginScreen2.default.closeButton },
      children
    ),
    _react2.default.createElement(
      'div',
      { className: titleFontClassName },
      _react2.default.createElement(
        'h1',
        { className: (0, _classnames2.default)(_loginScreen2.default.title, 'login-screen__title') },
        t('login-screen.login-required')
      )
    ),
    _react2.default.createElement(
      'p',
      { className: (0, _classnames2.default)(_loginScreen2.default.description, 'login-screen__description') },
      t('login-screen.login-description')
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_loginScreen2.default.loginButtonContainer, 'login-screen__login-button-container') },
      _react2.default.createElement(_loginButton2.default, _extends({ autoLogin: true }, props))
    )
  );
};

LoginScreen.propTypes = {
  children: _propTypes2.default.node,
  onLogin: _propTypes2.default.func.isRequired,
  onLoginError: _propTypes2.default.func.isRequired,
  borderWidth: _propTypes2.default.number.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _withTranslate2.default)((0, _withCardBorderWidth2.default)((0, _withFontClassName2.default)(LoginScreen)));

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _modalTypes = __webpack_require__(26);

var _openModal = __webpack_require__(36);

var _button = __webpack_require__(72);

var _button2 = _interopRequireDefault(_button);

var _requestLogin = __webpack_require__(369);

var _requestLogin2 = _interopRequireDefault(_requestLogin);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _button3 = __webpack_require__(325);

var _button4 = _interopRequireDefault(_button3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginButton = function (_Component) {
  _inherits(LoginButton, _Component);

  function LoginButton(props) {
    _classCallCheck(this, LoginButton);

    var _this = _possibleConstructorReturn(this, (LoginButton.__proto__ || Object.getPrototypeOf(LoginButton)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(LoginButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoLogin) {
        setTimeout(function () {
          return _this2.handleClick();
        }, 100);
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          onLogin = _props.onLogin,
          onLoginError = _props.onLoginError,
          viewMode = _props.viewMode,
          isDemoMode = _props.isDemoMode,
          openModal = _props.openModal;


      if (isDemoMode) {
        openModal(_modalTypes.MODAL_TYPE_DEMO_MODE, { viewMode: viewMode });
      } else {
        (0, _requestLogin2.default)(function (memberDetails) {
          if (memberDetails) {
            onLogin(memberDetails.data || memberDetails);
          } else {
            onLoginError();
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _button2.default,
        { className: (0, _classnames2.default)(_button4.default.button, 'login-button'), onClick: this.handleClick },
        t('login-button.sign-up')
      );
    }
  }]);

  return LoginButton;
}(_react.Component);

LoginButton.propTypes = {
  autoLogin: _propTypes2.default.bool,
  onLogin: _propTypes2.default.func.isRequired,
  onLoginError: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func.isRequired,
  viewMode: _propTypes2.default.string.isRequired,
  isDemoMode: _propTypes2.default.bool,
  openModal: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    viewMode: state.viewMode,
    isDemoMode: state.isDemoMode
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openModal: _openModal.openModal
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withTranslate2.default)(LoginButton));

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"closeButton":"_3No4S","page":"_2vQgS","title":"_3HAUe","description":"_2zNj0","loginButtonContainer":"_3aDWi"};

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2FI7d","closeButton":"_2oplK"};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _textEditorLinkModal = __webpack_require__(948);

var _textEditorLinkModal2 = _interopRequireDefault(_textEditorLinkModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _textEditorLinkModal2.default;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _textEditorLinkForm = __webpack_require__(949);

var _textEditorLinkForm2 = _interopRequireDefault(_textEditorLinkForm);

var _closeModal = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextEditEditorLinkModal = function TextEditEditorLinkModal(_ref) {
  var insertTextEditorLink = _ref.insertTextEditorLink,
      closeModal = _ref.closeModal;
  return _react2.default.createElement(
    _modal2.default,
    { backdrop: true, onClose: closeModal },
    _react2.default.createElement(_textEditorLinkForm2.default, { onSubmit: insertTextEditorLink, onCancel: closeModal })
  );
};

TextEditEditorLinkModal.propTypes = {
  insertTextEditorLink: _propTypes2.default.func.isRequired,
  closeModal: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var identifier = _ref2.identifier;
  return (0, _redux.bindActionCreators)({
    insertTextEditorLink: function insertTextEditorLink(data) {
      return (0, _closeModal.closeModal)(_extends({}, data, {
        identifier: identifier
      }));
    },
    closeModal: _closeModal.closeModal
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(TextEditEditorLinkModal);

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _textEditorLinkForm = __webpack_require__(950);

var _textEditorLinkForm2 = _interopRequireDefault(_textEditorLinkForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _textEditorLinkForm2.default;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reduxForm = __webpack_require__(40);

var _buttonGroup = __webpack_require__(50);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _icons = __webpack_require__(9);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _textEditorLinkForm = __webpack_require__(951);

var _textEditorLinkForm2 = _interopRequireDefault(_textEditorLinkForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFieldProps = function getFieldProps(field) {
  return {
    value: field.value,
    onChange: field.onChange,
    onFocus: field.onFocus,
    onBlur: field.onBlur
  };
};
var TextEditorLinkForm = function TextEditorLinkForm(props) {
  var url = props.fields.url,
      handleSubmit = props.handleSubmit,
      onCancel = props.onCancel,
      t = props.t,
      titleFontClassName = props.titleFontClassName,
      contentFontClassName = props.contentFontClassName;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_textEditorLinkForm2.default.container, contentFontClassName, 'forum-text-color') },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_textEditorLinkForm2.default.titleWrapper, titleFontClassName) },
      _react2.default.createElement(_icons.LinkIcon, { className: 'forum-icon-fill' }),
      _react2.default.createElement(
        'span',
        { className: _textEditorLinkForm2.default.title },
        t('text-editor-link-form.title')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _textEditorLinkForm2.default.inputWrapper },
      _react2.default.createElement('input', _extends({
        className: _textEditorLinkForm2.default.input,
        autoFocus: true,
        placeholder: t('text-editor-link-form.placeholder')
      }, getFieldProps(url), {
        'data-hook': 'link-input'
      })),
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_textEditorLinkForm2.default.border, 'forum-text-border-color') })
    ),
    _react2.default.createElement(_buttonGroup2.default, {
      primaryButtonText: t('text-editor-link-form.button'),
      primaryButtonProps: { onClick: handleSubmit },
      secondaryButtonText: t('text-editor-link-form.cancel-button'),
      secondaryButtonProps: { onClick: function onClick() {
          return onCancel();
        } }
    })
  );
};

TextEditorLinkForm.propTypes = {
  fields: _propTypes2.default.object.isRequired,
  t: _propTypes2.default.func.isRequired,
  handleSubmit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  titleFontClassName: _propTypes2.default.string.isRequired,
  contentFontClassName: _propTypes2.default.string.isRequired
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'text-editor-link',
  fields: ['url']
})((0, _withTranslate2.default)((0, _withFontClassName2.default)(TextEditorLinkForm)));

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2ZpGv","titleWrapper":"_2XBOh","title":"Z3vki","inputWrapper":"Btxfp","input":"AJ8Y4","border":"_1QRS9"};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _textEditorVideoEmbedModal = __webpack_require__(953);

var _textEditorVideoEmbedModal2 = _interopRequireDefault(_textEditorVideoEmbedModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _textEditorVideoEmbedModal2.default;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__(6);

var _reactRedux = __webpack_require__(5);

var _modal = __webpack_require__(13);

var _modal2 = _interopRequireDefault(_modal);

var _textEditorVideoEmbedForm = __webpack_require__(954);

var _textEditorVideoEmbedForm2 = _interopRequireDefault(_textEditorVideoEmbedForm);

var _closeModal = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextEditEditorVideoEmbedModal = function TextEditEditorVideoEmbedModal(_ref) {
  var insertTextEditorVideoEmbed = _ref.insertTextEditorVideoEmbed,
      closeModal = _ref.closeModal;
  return _react2.default.createElement(
    _modal2.default,
    { backdrop: true, onClose: closeModal },
    _react2.default.createElement(_textEditorVideoEmbedForm2.default, { onSubmit: insertTextEditorVideoEmbed, onCancel: closeModal })
  );
};

TextEditEditorVideoEmbedModal.propTypes = {
  insertTextEditorVideoEmbed: _propTypes2.default.func.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  identifier: _propTypes2.default.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var identifier = _ref2.identifier;
  return (0, _redux.bindActionCreators)({
    insertTextEditorVideoEmbed: function insertTextEditorVideoEmbed(data) {
      return (0, _closeModal.closeModal)(_extends({
        identifier: identifier
      }, data));
    },
    closeModal: _closeModal.closeModal
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(TextEditEditorVideoEmbedModal);

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _textEditorVideoEmbedForm = __webpack_require__(955);

var _textEditorVideoEmbedForm2 = _interopRequireDefault(_textEditorVideoEmbedForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _textEditorVideoEmbedForm2.default;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _reduxForm = __webpack_require__(40);

var _buttonGroup = __webpack_require__(50);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _icons = __webpack_require__(9);

var _textEditorVideoEmbedFormSettings = __webpack_require__(956);

var _textEditorVideoEmbedFormSettings2 = _interopRequireDefault(_textEditorVideoEmbedFormSettings);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _withFontClassName = __webpack_require__(11);

var _withFontClassName2 = _interopRequireDefault(_withFontClassName);

var _textEditorVideoEmbedForm = __webpack_require__(957);

var _textEditorVideoEmbedForm2 = _interopRequireDefault(_textEditorVideoEmbedForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFieldProps = function getFieldProps(field) {
  return {
    value: field.value,
    onChange: field.onChange,
    onFocus: field.onFocus,
    onBlur: field.onBlur
  };
};
var TextEditorVideoEmbedForm = function TextEditorVideoEmbedForm(_ref) {
  var url = _ref.fields.url,
      dirty = _ref.dirty,
      invalid = _ref.invalid,
      handleSubmit = _ref.handleSubmit,
      onCancel = _ref.onCancel,
      t = _ref.t,
      contentFontClassName = _ref.contentFontClassName;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_textEditorVideoEmbedForm2.default.container, contentFontClassName, 'forum-text-color') },
    dirty && invalid && url && _react2.default.createElement(
      'div',
      { className: _textEditorVideoEmbedForm2.default.error },
      t('text-editor-video-embed-form.invalid-url')
    ),
    _react2.default.createElement(
      'h3',
      { className: _textEditorVideoEmbedForm2.default.title },
      _react2.default.createElement(_icons.VideoIcon, { className: (0, _classnames2.default)(_textEditorVideoEmbedForm2.default.icon, 'forum-icon-fill') }),
      _react2.default.createElement(
        'span',
        null,
        t('text-editor-video-embed-form.add-video')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _textEditorVideoEmbedForm2.default.inputWrapper },
      _react2.default.createElement('input', _extends({
        className: (0, _classnames2.default)(_textEditorVideoEmbedForm2.default.input, contentFontClassName),
        autoFocus: true,
        placeholder: t('text-editor-video-embed-form.placeholder')
      }, getFieldProps(url))),
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_textEditorVideoEmbedForm2.default.border, 'forum-text-border-color') })
    ),
    _react2.default.createElement(_buttonGroup2.default, {
      primaryButtonText: t('text-editor-video-embed-form.button'),
      primaryButtonProps: { onClick: handleSubmit },
      secondaryButtonText: t('text-editor-video-embed-form.cancel-button'),
      secondaryButtonProps: { onClick: function onClick() {
          return onCancel();
        } }
    })
  );
};

TextEditorVideoEmbedForm.propTypes = {
  fields: _propTypes2.default.object.isRequired,
  dirty: _propTypes2.default.bool,
  invalid: _propTypes2.default.bool,
  contentFontClassName: _propTypes2.default.string,
  t: _propTypes2.default.func.isRequired,
  handleSubmit: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired
};

exports.default = (0, _reduxForm.reduxForm)(_textEditorVideoEmbedFormSettings2.default)((0, _withTranslate2.default)((0, _withFontClassName2.default)(TextEditorVideoEmbedForm)));

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _videoEmbed = __webpack_require__(146);

var textEditorVideoEmbedFormSettings = {
  form: 'text-editor-video-embed',
  fields: ['url'],
  validate: function validate(values) {
    var errors = {};
    var url = values.url;


    if (!url) {
      errors.url = 'required';
    } else if (!(0, _videoEmbed.isSupported)(url)) {
      errors.url = 'not-supported';
    }

    return errors;
  }
};

exports.default = textEditorVideoEmbedFormSettings;

/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_30id7","error":"_3SjIf","icon":"_3fwJQ","title":"_2CC5f","inputWrapper":"_6SxH9","input":"jgkVD","border":"_39pls"};

/***/ }),
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startEditingComment = exports.START_EDITING_COMMENT = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var START_EDITING_COMMENT = exports.START_EDITING_COMMENT = 'comment/START_EDITING';
var startEditingComment = exports.startEditingComment = (0, _createAction2.default)(START_EDITING_COMMENT);

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSitePages = exports.SET_SITE_PAGES = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_SITE_PAGES = exports.SET_SITE_PAGES = 'sitePages/SET';
var setSitePages = exports.setSitePages = (0, _createAction2.default)(SET_SITE_PAGES);

/***/ }),
/* 1002 */,
/* 1003 */,
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _applications = __webpack_require__(25);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var MembersAreaLink = function MembersAreaLink(_ref) {
  var appDefinitionId = _ref.appDefinitionId,
      appPageId = _ref.appPageId,
      onClick = _ref.onClick,
      children = _ref.children,
      viewedUser = _ref.viewedUser,
      props = _objectWithoutProperties(_ref, ['appDefinitionId', 'appPageId', 'onClick', 'children', 'viewedUser']);

  var linkProps = (0, _lodash.omit)(props, 'dispatch');

  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }
    if (event.defaultPrevented) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    _wixSdkPolyfill2.default.getPublicAPI({ appDefinitionId: _applications.SANTA_MEMBERS_APP_ID }, function (api) {
      api.navigateToSection({
        appDefinitionId: appDefinitionId,
        appPageId: appPageId,
        viewedUser: viewedUser
      });
    }, console.error);
  };

  return _react2.default.createElement(
    'a',
    _extends({ onClick: handleClick, href: '#' }, linkProps),
    children
  );
};

MembersAreaLink.propTypes = {
  appDefinitionId: _propTypes2.default.string,
  appPageId: _propTypes2.default.string,
  children: _propTypes2.default.node,
  viewedUser: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

exports.default = MembersAreaLink;

/***/ }),
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_BREADCRUMBS_LOGIN = exports.SHOW_BREADCRUMBS_LOGIN = 'breadcrumbs/SHOW_BREADCRUMBS_LOGIN';

var showBreadcrumbsLogin = exports.showBreadcrumbsLogin = function showBreadcrumbsLogin(payload) {
  return {
    type: SHOW_BREADCRUMBS_LOGIN,
    payload: payload
  };
};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = commentsReducer;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _fetchComments = __webpack_require__(136);

var _fetchComment = __webpack_require__(313);

var _createComment = __webpack_require__(176);

var _updateComment = __webpack_require__(446);

var _deleteComment = __webpack_require__(137);

var _commentSocket = __webpack_require__(314);

var _incrementCommentLikeCount = __webpack_require__(246);

var _updateUser = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var comment = function comment(state, action) {
  switch (action.type) {
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
      if (state._id === action.payload._id) {
        return _extends({}, state, {
          isLiked: !state.isLiked,
          likeCount: state.likeCount + (state.isLiked ? -1 : 1),
          isLikeInProgress: true
        });
      }
      return state;
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
      if (state._id === action.payload._id) {
        return _lodash2.default.omit(_extends({}, state, action.payload), 'isLikeInProgress');
      }
      return state;
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
      if (state._id === action.payload._id) {
        return _lodash2.default.omit(_extends({}, state, {
          isLiked: !state.isLiked,
          likeCount: state.likeCount + (state.isLiked ? -1 : 1)
        }), 'isLikeInProgress');
      }
      return state;
    case _updateUser.UPDATE_USER_SUCCESS:
      if (state.owner._id === action.payload.id) {
        return _extends({}, state, { owner: action.payload });
      }
      return state;
    default:
      return state;
  }
};

var commentList = function commentList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  switch (type) {
    case _fetchComments.FETCH_COMMENTS_SUCCESS:
      return (0, _lodash2.default)([].concat(_toConsumableArray(state), _toConsumableArray(payload.comments))).unionBy('_id').sortBy('createdDate').value();
    case _createComment.CREATE_COMMENT_SUCCESS:
    case _updateComment.UPDATE_COMMENT_SUCCESS:
    case _commentSocket.NEW_COMMENT:
      return (0, _lodash2.default)([payload]).unionBy(state, '_id').sortBy('createdDate').value();
    case _fetchComment.FETCH_COMMENT_SUCCESS:
      return (0, _lodash2.default)([payload.comment]).unionBy(state, '_id').sortBy('createdDate').value();
    case _deleteComment.DELETE_COMMENT_SUCCESS:
      return state.filter(function (comment) {
        return comment._id !== payload._id;
      });
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
      return state.map(function (current) {
        return comment(current, { type: type, payload: payload });
      });
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
      return state.map(function (current) {
        return comment(current, { type: type, payload: payload });
      });
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
      return state.map(function (current) {
        return comment(current, { type: type, payload: payload });
      });
    case _updateUser.UPDATE_USER_SUCCESS:
      return state.map(function (current) {
        return comment(current, { type: type, payload: payload });
      });
    default:
      return state;
  }
};

function commentsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      _action$payload = action.payload,
      payload = _action$payload === undefined ? {} : _action$payload;
  var postId = payload.postId;


  switch (type) {
    case _fetchComments.FETCH_COMMENTS_REQUEST:
      return _defineProperty({}, postId, state[postId]);
    case _fetchComments.FETCH_COMMENTS_SUCCESS:
    case _fetchComment.FETCH_COMMENT_SUCCESS:
    case _createComment.CREATE_COMMENT_SUCCESS:
    case _updateComment.UPDATE_COMMENT_SUCCESS:
    case _commentSocket.NEW_COMMENT:
    case _deleteComment.DELETE_COMMENT_SUCCESS:
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
      return _defineProperty({}, postId, commentList(state[postId], action));
    default:
      return state;
  }
}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fetchPost = __webpack_require__(165);

var _fetchPosts = __webpack_require__(138);

var _fetchPostsByOwnerId = __webpack_require__(130);

var _fetchSearch = __webpack_require__(131);

var _updatePost = __webpack_require__(397);

var _setCategories = __webpack_require__(268);

var _deletePost = __webpack_require__(132);

var _createPost = __webpack_require__(200);

var _movePost = __webpack_require__(177);

var _pinPost = __webpack_require__(398);

var _unpinPost = __webpack_require__(399);

var _addTopComment = __webpack_require__(449);

var _removeTopComment = __webpack_require__(450);

var _enablePostComments = __webpack_require__(400);

var _disablePostComments = __webpack_require__(401);

var _subscribe = __webpack_require__(59);

var _unsubscribe = __webpack_require__(60);

var _incrementPostLikeCount = __webpack_require__(160);

var _promoteModerator = __webpack_require__(139);

var _demoteModerator = __webpack_require__(140);

var _userSocket = __webpack_require__(78);

var _updateUser = __webpack_require__(70);

var _blockUser = __webpack_require__(178);

var _unblockUser = __webpack_require__(179);

var _categorySocket = __webpack_require__(260);

var _postSocket = __webpack_require__(591);

var _deleteComment = __webpack_require__(137);

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line complexity
var post = function post(state, action) {
  switch (action.type) {
    case _subscribe.SUBSCRIBE_REQUEST:
      if (state._id === action.payload._id) {
        return _extends({}, state, { isSubscribed: true });
      }
      return state;
    case _subscribe.SUBSCRIBE_FAILURE:
      if (state._id === action.payload._id) {
        return _extends({}, state, { isSubscribed: false });
      }
      return state;
    case _unsubscribe.UNSUBSCRIBE_REQUEST:
      if (state._id === action.payload._id) {
        return _extends({}, state, { isSubscribed: false });
      }
      return state;
    case _unsubscribe.UNSUBSCRIBE_FAILURE:
      if (state._id === action.payload._id) {
        return _extends({}, state, { isSubscribed: true });
      }
      return state;
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_REQUEST:
      if (state._id === action.payload._id) {
        return _extends({}, state, {
          isLiked: !state.isLiked,
          likeCount: state.likeCount + (state.isLiked ? -1 : 1),
          isLikeInProgress: true
        });
      }
      return state;
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_SUCCESS:
      if (state._id === action.payload._id) {
        return _lodash2.default.omit(_extends({}, state, action.payload), 'isLikeInProgress');
      }
      return state;
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_FAILURE:
      if (state._id === action.payload._id) {
        return _lodash2.default.omit(_extends({}, state, {
          isLiked: !state.isLiked
        }), 'isLikeInProgress');
      }
      return state;
    case _promoteModerator.PROMOTE_MODERATOR_SUCCESS:
    case _demoteModerator.DEMOTE_MODERATOR_SUCCESS:
    case _userSocket.USER_SET_PERMISSIONS:
    case _updateUser.UPDATE_USER_SUCCESS:
    case _blockUser.BLOCK_USER_SUCCESS:
    case _unblockUser.UNBLOCK_USER_SUCCESS:
      if (state.owner._id === action.payload._id) {
        return _extends({}, state, { owner: action.payload });
      }
      return state;
    case _deleteComment.DELETE_COMMENT_SUCCESS:
      if (state.topCommentId === action.payload._id) {
        return _extends({}, state, { topCommentId: null });
      }
      return state;
    default:
      return state;
  }
};

// eslint-disable-next-line complexity

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _fetchPost.FETCH_POST_SUCCESS:
      return unionPosts(state, [payload.post]);
    case _fetchPostsByOwnerId.FETCH_USER_POSTS_SUCCESS:
    case _fetchPosts.FETCH_POSTS_SUCCESS:
      return unionPosts(state, payload);
    case _postSocket.UPDATE_POST:
    case _updatePost.UPDATE_POST_SUCCESS:
    case _movePost.MOVE_POST_SUCCESS:
    case _pinPost.PIN_POST_SUCCESS:
    case _unpinPost.UNPIN_POST_SUCCESS:
    case _addTopComment.ADD_TOP_COMMENT_SUCCESS:
    case _removeTopComment.REMOVE_TOP_COMMENT_SUCCESS:
    case _enablePostComments.ENABLE_POST_COMMENTS_SUCCESS:
    case _disablePostComments.DISABLE_POST_COMMENTS_SUCCESS:
      return unionPosts(state, [payload]);
    case _categorySocket.NEW_POST:
    case _createPost.CREATE_POST_SUCCESS:
      return unionPosts(state, [payload]);
    case _fetchSearch.FETCH_SEARCH_SUCCESS:
      return unionPosts(state, payload.posts.filter(function (post) {
        return post.type === 'post';
      }));
    case _setCategories.SET_CATEGORIES:
      {
        var categoryIds = payload.map(function (category) {
          return category._id;
        });
        return _lodash2.default.omitBy(state, function (post) {
          return categoryIds.indexOf(post.categoryId) === -1;
        });
      }
    case _deletePost.DELETE_POST_SUCCESS:
      return _lodash2.default.omit(state, payload);
    case _subscribe.SUBSCRIBE_REQUEST:
    case _subscribe.SUBSCRIBE_FAILURE:
    case _unsubscribe.UNSUBSCRIBE_REQUEST:
    case _unsubscribe.UNSUBSCRIBE_FAILURE:
      if (payload.type === 'post') {
        return Object.keys(state).reduce(function (result, current) {
          result[current] = post(state[current], { type: type, payload: payload });
          return result;
        }, {});
      }
      return state;
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_SUCCESS:
      return Object.keys(state).reduce(function (result, current) {
        result[current] = post(state[current], { type: type, payload: payload });
        return result;
      }, {});
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_FAILURE:
      return Object.keys(state).reduce(function (result, current) {
        result[current] = post(state[current], { type: type, payload: payload });
        return result;
      }, {});
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_REQUEST:
      return Object.keys(state).reduce(function (result, current) {
        result[current] = post(state[current], { type: type, payload: payload });
        return result;
      }, {});
    case _promoteModerator.PROMOTE_MODERATOR_SUCCESS:
    case _demoteModerator.DEMOTE_MODERATOR_SUCCESS:
    case _userSocket.USER_SET_PERMISSIONS:
    case _updateUser.UPDATE_USER_SUCCESS:
    case _blockUser.BLOCK_USER_SUCCESS:
    case _unblockUser.UNBLOCK_USER_SUCCESS:
    case _deleteComment.DELETE_COMMENT_SUCCESS:
      return Object.keys(state).reduce(function (result, current) {
        result[current] = post(state[current], { type: type, payload: payload });
        return result;
      }, {});
    case _categorySocket.UPDATE_POST_COUNTERS:
      return _extends({}, state, _defineProperty({}, payload._id, _extends({}, state[payload._id], payload)));
    default:
      return state;
  }
};

function unionPosts(oldPosts, newPosts) {
  return newPosts.reduce(function (result, post) {
    result[post._id] = post;
    return result;
  }, _extends({}, oldPosts));
}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitePages;

var _setSitePages = __webpack_require__(1001);

function sitePages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _setSitePages.SET_SITE_PAGES:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_MEMBERS = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_MEMBERS = exports.CLEAR_MEMBERS = 'member/CLEAR';

exports.default = (0, _createAction2.default)(CLEAR_MEMBERS);

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applicationLoaded = exports.APPLICATION_LOADED = undefined;

var _lodash = __webpack_require__(2);

var _appLifecycleService = __webpack_require__(170);

var appLifecycleService = _interopRequireWildcard(_appLifecycleService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var APPLICATION_LOADED = exports.APPLICATION_LOADED = 'application/LOADED';

var triggerFedopsAppLoaded = (0, _lodash.once)(function (fedopsLogger) {
  return fedopsLogger.appLoaded();
});

var applicationLoaded = exports.applicationLoaded = function applicationLoaded() {
  return function (dispatch, getState, _ref) {
    var fedopsLogger = _ref.fedopsLogger;

    appLifecycleService.appLoaded({ logInSdk: true });
    fedopsLogger && triggerFedopsAppLoaded(fedopsLogger);
    return { type: APPLICATION_LOADED };
  };
};

/***/ }),
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stopEditingComment = exports.STOP_EDITING_COMMENT = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STOP_EDITING_COMMENT = exports.STOP_EDITING_COMMENT = 'comment/STOP_EDITING';
var stopEditingComment = exports.stopEditingComment = (0, _createAction2.default)(STOP_EDITING_COMMENT);

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HIDE_NEW_POST_MESSAGE = exports.HIDE_NEW_POST_MESSAGE = 'newPostMessage/HIDE';
var HIDE_NEW_POST_MESSAGE_DEBOUNCED = exports.HIDE_NEW_POST_MESSAGE_DEBOUNCED = 'newPostMessage/HIDE_DEBOUNCED';

var hideNewPostMessage = exports.hideNewPostMessage = function hideNewPostMessage() {
  return function (dispatch) {
    dispatch({
      type: HIDE_NEW_POST_MESSAGE
    });
  };
};

var hideNewPostMessageDebounced = exports.hideNewPostMessageDebounced = function hideNewPostMessageDebounced(debounce) {
  var action = hideNewPostMessage();
  action.type = HIDE_NEW_POST_MESSAGE_DEBOUNCED;
  action.meta = { debounce: debounce };

  return action;
};

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_NOTIFICATION_COUNT = exports.SET_NOTIFICATION_COUNT = 'notifications/SET_COUNT';

var setNotificationCount = exports.setNotificationCount = function setNotificationCount(payload) {
  return {
    type: SET_NOTIFICATION_COUNT,
    payload: payload
  };
};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearTypingUsers = exports.removeTypingUser = exports.SOCKET_STOP_TYPING_MESSAGE = exports.SOCKET_TYPING_MESSAGE = exports.START_TYPING_DEBOUNCED = exports.CLEAR_TYPING_USERS = exports.REMOVE_TYPING_USER = exports.ADD_TYPING_USER = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.emitTyping = emitTyping;
exports.emitTypingThrottled = emitTypingThrottled;
exports.addTypingUser = addTypingUser;
exports.removeTypingUserDebounced = removeTypingUserDebounced;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _reduxDebounce = __webpack_require__(287);

var _wsActions = __webpack_require__(128);

var _wsChannel = __webpack_require__(151);

var _typingSelectors = __webpack_require__(1178);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_TYPING_USER = exports.ADD_TYPING_USER = 'typing/ADD_USER';
var REMOVE_TYPING_USER = exports.REMOVE_TYPING_USER = 'typing/REMOVE_USER';
var CLEAR_TYPING_USERS = exports.CLEAR_TYPING_USERS = 'typing/CLEAR_USERS';
var START_TYPING_DEBOUNCED = exports.START_TYPING_DEBOUNCED = 'typing/START_DEBOUNCED';

var SOCKET_TYPING_MESSAGE = exports.SOCKET_TYPING_MESSAGE = 'typing';
var SOCKET_STOP_TYPING_MESSAGE = exports.SOCKET_STOP_TYPING_MESSAGE = 'stop typing';

function emitTyping(user, post) {
  var channel = (0, _wsChannel.getChannel)(_extends({ type: 'post' }, post));
  return function (dispatch) {
    dispatch((0, _wsActions.emitMessage)(SOCKET_TYPING_MESSAGE, channel, { user: user, post: post }));
  };
}

var EMIT_TYPING_TIMEOUT = 2000;
var REMOVE_TYPING_USER_TIMEOUT = 4000;

function emitTypingThrottled(user, post) {
  var action = emitTyping(user, post);
  action.type = START_TYPING_DEBOUNCED;
  action.meta = {
    throttle: {
      wait: EMIT_TYPING_TIMEOUT,
      leading: true,
      trailing: true
    }
  };
  return action;
}

function addTypingUser(_ref) {
  var user = _ref.user;

  return {
    type: ADD_TYPING_USER,
    payload: user
  };
}

var removeTypingUser = exports.removeTypingUser = function removeTypingUser(_ref2) {
  var user = _ref2.user;
  return function (dispatch) {
    return dispatch({
      type: REMOVE_TYPING_USER,
      payload: user
    });
  };
};

var removeTypingUserDebouncedType = function removeTypingUserDebouncedType(userId) {
  return 'REMOVE_TYPING_USER_' + userId + '_DEBOUNCED';
};

function removeTypingUserDebounced(payload) {
  var action = removeTypingUser(payload);
  action.type = removeTypingUserDebouncedType(payload.user._id);
  action.meta = { debounce: REMOVE_TYPING_USER_TIMEOUT };
  return action;
}

var clearTypingUsers = exports.clearTypingUsers = function clearTypingUsers() {
  return function (dispatch, getState) {
    dispatch({
      type: _reduxDebounce.CANCEL,
      payload: {
        type: _lodash2.default.map((0, _typingSelectors.getTypingUserIds)(getState()), removeTypingUserDebouncedType)
      }
    });

    dispatch({ type: CLEAR_TYPING_USERS });
  };
};

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCurrentMember = undefined;

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

var _loginMember = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchCurrentMember = exports.fetchCurrentMember = function fetchCurrentMember() {
  return function (dispatch) {
    return new Promise(function (resolve) {
      _wixSdkPolyfill2.default.currentMember(function (member) {
        if (member) {
          dispatch((0, _loginMember.loginMember)(member.data || member)).then(resolve); // OR is needed because callback is called with different data
          return;
        }
        resolve();
      });
    });
  };
};

/***/ }),
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionLoggerMiddleware = exports.shouldLogReduxActions = undefined;

var _reduxLogger = __webpack_require__(1255);

var _config = __webpack_require__(29);

var shouldLogReduxActions = exports.shouldLogReduxActions = function shouldLogReduxActions() {
  return (0, _config.getConfig)().logReduxActions;
};

var actionLoggerMiddleware = exports.actionLoggerMiddleware = (0, _reduxLogger.createLogger)({
  level: {
    prevState: function prevState() {
      return false;
    },
    action: function action() {
      return false;
    },
    nextState: function nextState() {
      return false;
    },
    error: function error() {
      return 'log';
    }
  },
  titleFormatter: function titleFormatter(action) {
    return (0, _config.getConfig)().bundleName + ' ' + JSON.stringify(action);
  }
});

exports.default = actionLoggerMiddleware;

/***/ }),
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearFollowers = exports.CLEAR_FOLLOWERS = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_FOLLOWERS = exports.CLEAR_FOLLOWERS = 'followers/CLEAR';
var clearFollowers = exports.clearFollowers = (0, _createAction2.default)(CLEAR_FOLLOWERS);

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearFollowing = exports.CLEAR_FOLLOWING = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_FOLLOWING = exports.CLEAR_FOLLOWING = 'following/CLEAR';
var clearFollowing = exports.clearFollowing = (0, _createAction2.default)(CLEAR_FOLLOWING);

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_HEADER = exports.UPDATE_HEADER = 'header/UPDATE';

var updateHeader = exports.updateHeader = function updateHeader(payload) {
  return {
    type: UPDATE_HEADER,
    payload: payload
  };
};

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _byId = __webpack_require__(1227);

var _byId2 = _interopRequireDefault(_byId);

var _metadata = __webpack_require__(1228);

var _metadata2 = _interopRequireDefault(_metadata);

var _idList = __webpack_require__(1229);

var _idList2 = _interopRequireDefault(_idList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  byId: _byId2.default,
  metadata: _metadata2.default,
  idList: _idList2.default
});

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var READ_NOTIFICATION_REQUEST = exports.READ_NOTIFICATION_REQUEST = 'notification/READ_REQUEST';
var READ_NOTIFICATION_SUCCESS = exports.READ_NOTIFICATION_SUCCESS = 'notification/READ_SUCCESS';
var READ_NOTIFICATION_FAILURE = exports.READ_NOTIFICATION_FAILURE = 'notification/READ_FAILURE';

var readNotificationRequest = exports.readNotificationRequest = function readNotificationRequest() {
  return { type: READ_NOTIFICATION_REQUEST };
};
var readNotificationSuccess = exports.readNotificationSuccess = function readNotificationSuccess(payload) {
  return { type: READ_NOTIFICATION_SUCCESS, payload: payload };
};
var readNotificationFailure = exports.readNotificationFailure = function readNotificationFailure() {
  return { type: READ_NOTIFICATION_FAILURE };
};

var readNotification = exports.readNotification = function readNotification(notificationId) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;

    dispatch(readNotificationRequest());

    var promise = request.put('/_api/notifications/' + notificationId + '/read', {});
    return promise.then(function (notification) {
      return dispatch(readNotificationSuccess(notification));
    }).catch(function () {
      return dispatch(readNotificationFailure());
    }).then(function () {
      return promise;
    });
  };
};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENABLE_NOTIFICATION_COUNT_CHANGE = exports.ENABLE_NOTIFICATION_COUNT_CHANGE = 'notifications/ENABLE_NOTIFICATIONS_COUNT_CHANGE';

var enableNotificationCountChanges = exports.enableNotificationCountChanges = function enableNotificationCountChanges(enable) {
  return {
    type: ENABLE_NOTIFICATION_COUNT_CHANGE,
    payload: enable
  };
};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_SEARCH_RESULTS = exports.SOCKET_SEARCH_RESULTS_MESSAGE = exports.SOCKET_SEARCH_MESSAGE = undefined;
exports.default = fetchSearchResults;
exports.emitSearch = emitSearch;

var _wsActions = __webpack_require__(128);

var SOCKET_SEARCH_MESSAGE = exports.SOCKET_SEARCH_MESSAGE = 'search';
var SOCKET_SEARCH_RESULTS_MESSAGE = exports.SOCKET_SEARCH_RESULTS_MESSAGE = 'search results';
var FETCH_SEARCH_RESULTS = exports.FETCH_SEARCH_RESULTS = 'search/FETCH_RESULTS';

function fetchSearchResults(uuid, results) {
  return {
    type: FETCH_SEARCH_RESULTS,
    payload: {
      uuid: uuid,
      results: results
    }
  };
}

function emitSearch(query, uuid) {
  return (0, _wsActions.emitMessage)(SOCKET_SEARCH_MESSAGE, '', { query: query, uuid: uuid });
}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _socketIo = __webpack_require__(1232);

var initialState = {
  connected: false,
  connecting: true
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _socketIo.SOCKET_CONNECT:
      return _extends({}, state, { connected: true, connecting: false });
    case _socketIo.SOCKET_DISCONNECT:
      return _extends({}, state, { connected: false, connecting: false });
    case _socketIo.SOCKET_RECONNECTING:
      return _extends({}, state, { connected: false, connecting: true });
    case _socketIo.SOCKET_RECONNECT:
      return _extends({}, state, { connected: true, connecting: false });
    case _socketIo.SOCKET_RECONNECT_FAILED:
      return _extends({}, state, { connected: false, connecting: false });
    default:
      return state;
  }
};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypingUserIds = exports.getTypingUsers = undefined;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTypingUsers = exports.getTypingUsers = function getTypingUsers(state) {
  return state.typing;
};
var getTypingUserIds = exports.getTypingUserIds = function getTypingUserIds(state) {
  return _lodash2.default.map(getTypingUsers(state), function (user) {
    return user._id;
  });
};

/***/ }),
/* 1179 */,
/* 1180 */,
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _iconButton = __webpack_require__(1479);

var _iconButton2 = _interopRequireDefault(_iconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _iconButton2.default;

/***/ }),
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var stripNewLines = function stripNewLines(value) {
  return value && value.replace(/\n/g, '');
};

var post = exports.post = {
  title: stripNewLines
};

var category = exports.category = {
  label: stripNewLines,
  description: stripNewLines
};

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = breadcrumbsWidget;

var _showBreadrumbsLogin = __webpack_require__(1053);

var _setViewMode = __webpack_require__(256);

var initialState = {
  showLogin: true
};

function breadcrumbsWidget() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _showBreadrumbsLogin.SHOW_BREADCRUMBS_LOGIN:
      return {
        showLogin: action.payload
      };
    case _setViewMode.SET_VIEW_MODE:
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createComment = __webpack_require__(176);

exports.default = function (state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _createComment.CREATE_COMMENT_SUCCESS:
      return _extends({}, state, {
        content: {},
        image: {}
      });
    default:
      return state;
  }
};

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = commentEdit;

var _startEditingComment = __webpack_require__(1000);

var _stopEditingComment = __webpack_require__(1098);

var _updateComment = __webpack_require__(446);

function commentEdit() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case _startEditingComment.START_EDITING_COMMENT:
      return action.payload;
    case _stopEditingComment.STOP_EDITING_COMMENT:
    case _updateComment.UPDATE_COMMENT_SUCCESS:
      return null;
    default:
      return state;
  }
}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _idList = __webpack_require__(1216);

var _idList2 = _interopRequireDefault(_idList);

var _metadata = __webpack_require__(1217);

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  idList: _idList2.default,
  metadata: _metadata2.default
});

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = followersIdListReducer;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _fetchFollowers = __webpack_require__(195);

var _clearFollowers = __webpack_require__(1170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function followersIdListReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _fetchFollowers.FETCH_FOLLOWERS_SUCCESS:
      return [].concat(_toConsumableArray(state), _toConsumableArray(_lodash2.default.map(action.payload.followers, function (follower) {
        return follower._id;
      })));
    case _clearFollowers.CLEAR_FOLLOWERS:
      return [];
    default:
      return state;
  }
}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = followersMetadataReducer;

var _fetchFollowers = __webpack_require__(195);

function followersMetadataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _fetchFollowers.FETCH_FOLLOWERS_SUCCESS:
      return action.meta;
    default:
      return state;
  }
}

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _idList = __webpack_require__(1219);

var _idList2 = _interopRequireDefault(_idList);

var _metadata = __webpack_require__(1220);

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  idList: _idList2.default,
  metadata: _metadata2.default
});

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = followingIdListReducer;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _fetchFollowing = __webpack_require__(196);

var _clearFollowing = __webpack_require__(1171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function followingIdListReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _fetchFollowing.FETCH_FOLLOWING_SUCCESS:
      return [].concat(_toConsumableArray(state), _toConsumableArray(_lodash2.default.map(action.payload.following, function (follower) {
        return follower._id;
      })));
    case _clearFollowing.CLEAR_FOLLOWING:
      return [];
    default:
      return state;
  }
}

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = followingMetadataReducer;

var _fetchFollowing = __webpack_require__(196);

function followingMetadataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _fetchFollowing.FETCH_FOLLOWING_SUCCESS:
      return action.meta;
    default:
      return state;
  }
}

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _updateHeader = __webpack_require__(1172);

var initialState = {
  offset: 0,
  height: 0
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _updateHeader.UPDATE_HEADER:
      return action.payload;
    default:
      return state;
  }
};

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRouterRedux = __webpack_require__(44);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  key: undefined,
  items: []
};

var find = function find(items, key) {
  return items.findIndex(function (item) {
    return item.key === key;
  });
};

var locationChange = function locationChange(state, _ref) {
  var _ref$payload = _ref.payload,
      action = _ref$payload.action,
      location = _objectWithoutProperties(_ref$payload, ['action']);

  var currentIdx = find(state.items, state.key);
  var locationIdx = find(state.items, location.key);
  switch (action) {
    case 'POP':
      if (locationIdx > -1) {
        return _extends({}, state, { key: location.key });
      }
      return { key: location.key, items: [].concat(_toConsumableArray(state.items), [location]) };
    case 'PUSH':
      return { key: location.key, items: [].concat(_toConsumableArray(state.items.slice(0, currentIdx + 1)), [location]) };
    case 'REPLACE':
      return { key: location.key, items: [].concat(_toConsumableArray(state.items.slice(0, locationIdx)), [location]) };
    default:
      return state;
  }
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _reactRouterRedux.LOCATION_CHANGE:
      return locationChange(state, action);
    default:
      return state;
  }
};

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(6);

var _idList = __webpack_require__(1224);

var _idList2 = _interopRequireDefault(_idList);

var _metadata = __webpack_require__(1225);

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  idList: _idList2.default,
  metadata: _metadata2.default
});

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _clearMembers = __webpack_require__(1085);

var _fetchMembers = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _clearMembers.CLEAR_MEMBERS:
      return [];
    case _fetchMembers.FETCH_MEMBERS_SUCCESS:
      {
        var idList = action.payload.map(function (member) {
          return member._id;
        });
        return action.meta.page > 1 ? _lodash2.default.union(state, idList) : idList;
      }
    default:
      return state;
  }
};

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clearMembers = __webpack_require__(1085);

var _fetchMembers = __webpack_require__(199);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { count: 0 };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _clearMembers.CLEAR_MEMBERS:
      return { count: 0 };
    case _fetchMembers.FETCH_MEMBERS_SUCCESS:
      return { count: action.meta.count };
    default:
      return state;
  }
};

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _showNewPostMessage = __webpack_require__(396);

var _hideNewPostMessage = __webpack_require__(1099);

var initialState = null;

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _showNewPostMessage.SHOW_NEW_POST_MESSAGE:
      return action.payload;
    case _hideNewPostMessage.HIDE_NEW_POST_MESSAGE:
      return initialState;
    default:
      return state;
  }
};

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _fetchNotifications = __webpack_require__(158);

var _readNotification = __webpack_require__(1174);

var _userSocket = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _fetchNotifications.FETCH_NOTIFICATIONS_SUCCESS:
      return _lodash2.default.reduce(action.payload, function (newState, notification) {
        newState[notification._id] = notification;
        return newState;
      }, _extends({}, state));
    case _readNotification.READ_NOTIFICATION_SUCCESS:
      return _extends({}, state, _defineProperty({}, action.payload._id, action.payload));
    case _userSocket.NEW_NOTIFICATION:
      return _extends({}, state, _defineProperty({}, action.payload._id, action.payload));
    default:
      return state;
  }
};

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _applications = __webpack_require__(25);

var _setCurrentUser = __webpack_require__(80);

var _fetchNotifications = __webpack_require__(158);

var _userSocket = __webpack_require__(78);

var _enableNotificationsCountChange = __webpack_require__(1175);

var _setNotificationCount = __webpack_require__(1100);

var getNotificationsCountFromUser = function getNotificationsCountFromUser(user) {
  return (0, _lodash.get)(user, 'counters.' + _applications.NOTIFICATIONS_APP_ID + '.notificationsCount', 0);
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { count: 0, isUpdateAllowed: true };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _enableNotificationsCountChange.ENABLE_NOTIFICATION_COUNT_CHANGE:
      return _extends({}, state, { isUpdateAllowed: action.payload });
    case _setCurrentUser.SET_CURRENT_USER:
      return state.isUpdateAllowed ? _extends({}, state, { count: getNotificationsCountFromUser(action.payload) }) : state;
    case _fetchNotifications.FETCH_NOTIFICATIONS_SUCCESS:
      return _extends({}, state, { count: 0 });
    case _userSocket.NEW_NOTIFICATION:
      return state.isUpdateAllowed ? _extends({}, state, { count: state.count + 1 }) : state;
    case _setNotificationCount.SET_NOTIFICATION_COUNT:
      return _extends({}, state, {
        count: action.payload
      });
    default:
      return state;
  }
};

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _fetchNotifications = __webpack_require__(158);

var _userSocket = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _fetchNotifications.FETCH_NOTIFICATIONS_SUCCESS:
      return _lodash2.default.union(state, action.payload.map(function (notification) {
        return notification._id;
      }));
    case _userSocket.NEW_NOTIFICATION:
      return [].concat(_toConsumableArray(state), [action.payload._id]);
    default:
      return state;
  }
};

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _updateUser = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _updateUser.UPDATE_USER_SUCCESS:
      {
        var user = action.payload;
        if (_lodash2.default.get(state, '_id.value') === action.payload._id) {
          return _extends({}, state, {
            name: _extends({}, state.name, {
              initial: user.name,
              value: user.name
            }),
            cover: _extends({}, state.cover, {
              initial: user.cover,
              value: user.cover
            }),
            image: _extends({}, state.image, {
              initial: user.image,
              value: user.image
            })
          });
        }
        return state;
      }
    default:
      return state;
  }
};

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _counters = __webpack_require__(289);

var _search = __webpack_require__(394);

var _searchSocket = __webpack_require__(1176);

var _fetchSearch = __webpack_require__(131);

var _subscribe = __webpack_require__(59);

var _unsubscribe = __webpack_require__(60);

var _incrementFollowingCount = __webpack_require__(451);

var _updateUser = __webpack_require__(70);

var _promoteModerator = __webpack_require__(139);

var _demoteModerator = __webpack_require__(140);

var _incrementPostLikeCount = __webpack_require__(160);

var _incrementCommentLikeCount = __webpack_require__(246);

var _movePost = __webpack_require__(177);

var _pinPost = __webpack_require__(398);

var _unpinPost = __webpack_require__(399);

var _enablePostComments = __webpack_require__(400);

var _disablePostComments = __webpack_require__(401);

var _deletePost = __webpack_require__(132);

var _deleteComment = __webpack_require__(137);

var _userSocket = __webpack_require__(78);

var _blockUser = __webpack_require__(178);

var _unblockUser = __webpack_require__(179);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  lastSearchUuid: undefined,
  posts: [],
  members: []
};

// eslint-disable-next-line complexity
var post = function post(state, action) {
  switch (action.type) {
    case _movePost.MOVE_POST_SUCCESS:
    case _pinPost.PIN_POST_SUCCESS:
    case _unpinPost.UNPIN_POST_SUCCESS:
    case _enablePostComments.ENABLE_POST_COMMENTS_SUCCESS:
    case _disablePostComments.DISABLE_POST_COMMENTS_SUCCESS:
      if (state._id === action.payload._id) {
        return _extends({}, action.payload, { type: 'post' });
      }
      return state;
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_SUCCESS:
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
      if (state._id === action.payload._id) {
        return (0, _lodash.omit)(_extends({}, state, action.payload), 'isLikeInProgress');
      }
      return state;
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_REQUEST:
      {
        if (state._id === action.payload._id) {
          return _extends({}, state, {
            isLiked: !state.isLiked,
            likeCount: state.likeCount + (state.isLiked ? -1 : 1),
            isLikeInProgress: true
          });
        }
        return state;
      }
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_FAILURE:
      if (state._id === action.payload._id) {
        return (0, _lodash.omit)(_extends({}, state, {
          isLiked: !state.isLiked,
          likeCount: state.likeCount + (state.isLiked ? -1 : 1)
        }), 'isLikeInProgress');
      }
      return state;
    case _promoteModerator.PROMOTE_MODERATOR_SUCCESS:
    case _demoteModerator.DEMOTE_MODERATOR_SUCCESS:
    case _userSocket.USER_SET_PERMISSIONS:
    case _updateUser.UPDATE_USER_SUCCESS:
    case _blockUser.BLOCK_USER_SUCCESS:
    case _unblockUser.UNBLOCK_USER_SUCCESS:
      if (state.owner._id === action.payload._id) {
        return _extends({}, state, { owner: action.payload });
      }
      return state;
    default:
      return state;
  }
};

var updateFollowingCount = function updateFollowingCount(_ref) {
  var user = _ref.user,
      userId = _ref.userId,
      isFollowing = _ref.isFollowing;

  if (user._id !== userId) {
    return user;
  }

  return (0, _lodash.merge)({}, user, _extends({}, (0, _counters.updatedCounters)(user, 'followingCount', isFollowing ? _counters.increment : _counters.decrement)));
};

var updateSubscription = function updateSubscription(_ref2) {
  var user = _ref2.user,
      userId = _ref2.userId,
      isSubscribed = _ref2.isSubscribed;

  if (user._id !== userId) {
    return user;
  }

  return (0, _lodash.merge)({}, user, _extends({}, (0, _counters.updatedCounters)(user, 'followerCount', isSubscribed ? _counters.increment : _counters.decrement), {
    isSubscribed: isSubscribed
  }));
};

var member = function member(user, action) {
  switch (action.type) {
    case _promoteModerator.PROMOTE_MODERATOR_SUCCESS:
    case _demoteModerator.DEMOTE_MODERATOR_SUCCESS:
    case _userSocket.USER_SET_PERMISSIONS:
    case _updateUser.UPDATE_USER_SUCCESS:
    case _blockUser.BLOCK_USER_SUCCESS:
    case _unblockUser.UNBLOCK_USER_SUCCESS:
      if (user._id === action.payload._id) {
        return action.payload;
      }
      return user;
    case _incrementFollowingCount.INCREMENT_FOLLOWING_COUNT:
      return updateFollowingCount({ user: user, userId: action.payload, isFollowing: true });
    case _incrementFollowingCount.DECREMENT_FOLLOWING_COUNT:
      return updateFollowingCount({ user: user, userId: action.payload, isFollowing: false });
    case _subscribe.SUBSCRIBE_REQUEST:
      return updateSubscription({ user: user, userId: action.payload._id, isSubscribed: true });
    case _unsubscribe.UNSUBSCRIBE_REQUEST:
      return updateSubscription({ user: user, userId: action.payload._id, isSubscribed: false });
    case _subscribe.SUBSCRIBE_FAILURE:
      return updateSubscription({ user: user, userId: action.payload._id, isSubscribed: false });
    case _unsubscribe.UNSUBSCRIBE_FAILURE:
      return updateSubscription({ user: user, userId: action.payload._id, isSubscribed: true });
    default:
      return user;
  }
};

var renameUsersKey = function renameUsersKey(data) {
  var users = data.users,
      result = _objectWithoutProperties(data, ['users']);

  result.members = users;

  return result;
};

// eslint-disable-next-line complexity

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _search.SEARCH:
      return _extends({}, state, { query: action.payload });
    case _search.SEARCH_QUERY_SEND:
      return _extends({}, state, { lastSearchUuid: action.payload.uuid });
    case _fetchSearch.FETCH_SEARCH_SUCCESS:
      return _extends({}, state, renameUsersKey(action.payload), { posts: action.payload.posts });
    case _fetchSearch.FETCH_SEARCH_FAILURE:
    case _search.SEARCH_CLEAR_RESULTS:
      return _extends({}, state, { posts: [], members: [] });
    case _searchSocket.FETCH_SEARCH_RESULTS:
      if (state.lastSearchUuid === action.payload.uuid) {
        return _extends({}, state, renameUsersKey(action.payload.results));
      }
      return state;
    case _subscribe.SUBSCRIBE_REQUEST:
    case _unsubscribe.UNSUBSCRIBE_REQUEST:
    case _subscribe.SUBSCRIBE_FAILURE:
    case _unsubscribe.UNSUBSCRIBE_FAILURE:
      {
        var index = (0, _lodash.findIndex)(state.members, ['_id', action.payload._id]);
        if (index > -1) {
          var currentMember = member(state.members[index], action);
          return _extends({}, state, {
            members: [].concat(_toConsumableArray(state.members.slice(0, index)), [currentMember], _toConsumableArray(state.members.slice(index + 1)))
          });
        }
        return state;
      }
    case _incrementFollowingCount.INCREMENT_FOLLOWING_COUNT:
    case _incrementFollowingCount.DECREMENT_FOLLOWING_COUNT:
    case _promoteModerator.PROMOTE_MODERATOR_SUCCESS:
    case _demoteModerator.DEMOTE_MODERATOR_SUCCESS:
    case _userSocket.USER_SET_PERMISSIONS:
    case _updateUser.UPDATE_USER_SUCCESS:
    case _blockUser.BLOCK_USER_SUCCESS:
    case _unblockUser.UNBLOCK_USER_SUCCESS:
      return _extends({}, state, {
        posts: state.posts.map(function (entity) {
          return post(entity, action);
        }),
        members: state.members.map(function (entity) {
          return member(entity, action);
        })
      });
    case _deletePost.DELETE_POST_SUCCESS:
    case _deleteComment.DELETE_COMMENT_SUCCESS:
      return _extends({}, state, { posts: state.posts.filter(function (post) {
          return post._id !== action.payload;
        }) });
    case _movePost.MOVE_POST_SUCCESS:
    case _pinPost.PIN_POST_SUCCESS:
    case _unpinPost.UNPIN_POST_SUCCESS:
    case _enablePostComments.ENABLE_POST_COMMENTS_SUCCESS:
    case _disablePostComments.DISABLE_POST_COMMENTS_SUCCESS:
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_REQUEST:
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
    case _incrementCommentLikeCount.INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_FAILURE:
    case _incrementPostLikeCount.INCREMENT_POST_LIKE_COUNT_SUCCESS:
      {
        var _index = (0, _lodash.findIndex)(state.posts, ['_id', action.payload._id]);
        if (_index > -1) {
          var currentPost = post(state.posts[_index], action);
          return _extends({}, state, {
            posts: [].concat(_toConsumableArray(state.posts.slice(0, _index)), [currentPost], _toConsumableArray(state.posts.slice(_index + 1)))
          });
        }
        return state;
      }
    default:
      return state;
  }
};

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socketConnect = socketConnect;
exports.socketError = socketError;
exports.socketDisconnect = socketDisconnect;
exports.socketReconnect = socketReconnect;
exports.socketReconnectAttempt = socketReconnectAttempt;
exports.socketReconnecting = socketReconnecting;
exports.socketReconnectError = socketReconnectError;
exports.socketReconnectFailed = socketReconnectFailed;
var SOCKET_CONNECT = exports.SOCKET_CONNECT = 'socket-io/CONNECT';
var SOCKET_ERROR = exports.SOCKET_ERROR = 'socket-io/ERROR';
var SOCKET_DISCONNECT = exports.SOCKET_DISCONNECT = 'socket-io/DISCONNECT';
var SOCKET_RECONNECT = exports.SOCKET_RECONNECT = 'socket-io/RECONNECT';
var SOCKET_RECONNECT_ATTEMPT = exports.SOCKET_RECONNECT_ATTEMPT = 'socket-io/RECONNECT_ATTEMPT';
var SOCKET_RECONNECTING = exports.SOCKET_RECONNECTING = 'socket-io/RECONNECTING';
var SOCKET_RECONNECT_ERROR = exports.SOCKET_RECONNECT_ERROR = 'socket-io/RECONNECT_ERROR';
var SOCKET_RECONNECT_FAILED = exports.SOCKET_RECONNECT_FAILED = 'socket-io/RECONNECT_FAILED';

function socketConnect() {
  return {
    type: SOCKET_CONNECT
  };
}

function socketError(error) {
  return {
    type: SOCKET_ERROR,
    payload: error
  };
}

function socketDisconnect() {
  return {
    type: SOCKET_DISCONNECT
  };
}

function socketReconnect(attempt) {
  return {
    type: SOCKET_RECONNECT,
    payload: attempt
  };
}

function socketReconnectAttempt() {
  return {
    type: SOCKET_RECONNECT_ATTEMPT
  };
}

function socketReconnecting(attempt) {
  return {
    type: SOCKET_RECONNECTING,
    payload: attempt
  };
}

function socketReconnectError(error) {
  return {
    type: SOCKET_RECONNECT_ERROR,
    payload: error
  };
}

function socketReconnectFailed() {
  return {
    type: SOCKET_RECONNECT_FAILED
  };
}

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = textEditorReducer;

var _draftJs = __webpack_require__(10);

var _updateTextEditor = __webpack_require__(261);

var _setTextEditorEntityData = __webpack_require__(125);

var _insertTextEditorLink = __webpack_require__(454);

var _insertTextEditorEntity = __webpack_require__(167);

var _removeTextEditorEntity = __webpack_require__(1234);

var _textEditorUtils = __webpack_require__(66);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var editorState = function editorState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _setTextEditorEntityData.SET_TEXT_EDITOR_ENTITY_DATA:
      {
        var entityData = payload.entityData,
            entityKey = payload.entityKey;

        state.getCurrentContent().mergeEntityData(entityKey, entityData);

        return _draftJs.EditorState.forceSelection(state, state.getSelection());
      }

    case _removeTextEditorEntity.REMOVE_TEXT_EDITOR_ENTITY:
      {
        var blockKey = payload.blockKey,
            _entityKey = payload.entityKey;

        return (0, _textEditorUtils.removeEntity)(state, blockKey, _entityKey);
      }

    case _insertTextEditorLink.INSERT_TEXT_EDITOR_LINK:
      return (0, _textEditorUtils.insertLink)(state, payload.url);

    case _insertTextEditorEntity.INSERT_TEXT_EDITOR_ENTITY:
      {
        return _draftJs.AtomicBlockUtils.insertAtomicBlock(state, payload.entityKey, ' ');
      }

    default:
      return state;
  }
};

function textEditorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case _updateTextEditor.UPDATE_TEXT_EDITOR:
      return _extends({}, state, _defineProperty({}, payload.identifier, payload.editorState));

    case _insertTextEditorLink.INSERT_TEXT_EDITOR_LINK:
    case _insertTextEditorEntity.INSERT_TEXT_EDITOR_ENTITY:
    case _setTextEditorEntityData.SET_TEXT_EDITOR_ENTITY_DATA:
    case _removeTextEditorEntity.REMOVE_TEXT_EDITOR_ENTITY:
      return _extends({}, state, _defineProperty({}, payload.identifier, editorState(state[payload.identifier], action)));

    default:
      return state;
  }
}

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTextEditorEntity = exports.REMOVE_TEXT_EDITOR_ENTITY = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REMOVE_TEXT_EDITOR_ENTITY = exports.REMOVE_TEXT_EDITOR_ENTITY = 'textEditor/REMOVE_ENTITY';

var removeTextEditorEntity = exports.removeTextEditorEntity = (0, _createAction2.default)(REMOVE_TEXT_EDITOR_ENTITY);

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _typingSocket = __webpack_require__(1101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = [];

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _typingSocket.ADD_TYPING_USER:
      if (_lodash2.default.find(state, function (user) {
        return user._id === action.payload._id;
      })) {
        return state;
      }
      return [action.payload].concat(_toConsumableArray(state));
    case _typingSocket.REMOVE_TYPING_USER:
      return [].concat(_toConsumableArray(state.filter(function (user) {
        return user._id !== action.payload._id;
      })));
    case _typingSocket.CLEAR_TYPING_USERS:
      return [];
    default:
      return state;
  }
};

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserAgent = exports.SET_USER_AGENT = undefined;

var _createAction = __webpack_require__(7);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_USER_AGENT = exports.SET_USER_AGENT = 'userAgent/SET';

var setUserAgent = exports.setUserAgent = (0, _createAction2.default)(SET_USER_AGENT);

/***/ }),
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _notificationButton = __webpack_require__(1478);

var _notificationButton2 = _interopRequireDefault(_notificationButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _notificationButton2.default;

/***/ }),
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalRootReducer = undefined;

var _redux = __webpack_require__(6);

var _reduxForm = __webpack_require__(40);

var _reactRouterRedux = __webpack_require__(44);

var _formNormalizers = __webpack_require__(1211);

var formNormalizers = _interopRequireWildcard(_formNormalizers);

var _appSettings = __webpack_require__(414);

var _appSettings2 = _interopRequireDefault(_appSettings);

var _auth = __webpack_require__(530);

var _auth2 = _interopRequireDefault(_auth);

var _breadcrumbsWidget = __webpack_require__(1212);

var _breadcrumbsWidget2 = _interopRequireDefault(_breadcrumbsWidget);

var _commentForm = __webpack_require__(1213);

var _commentForm2 = _interopRequireDefault(_commentForm);

var _comments = __webpack_require__(1054);

var _comments2 = _interopRequireDefault(_comments);

var _communitiesContext = __webpack_require__(415);

var _communitiesContext2 = _interopRequireDefault(_communitiesContext);

var _editedCommentId = __webpack_require__(1214);

var _editedCommentId2 = _interopRequireDefault(_editedCommentId);

var _experiments = __webpack_require__(315);

var _experiments2 = _interopRequireDefault(_experiments);

var _followers = __webpack_require__(1215);

var _followers2 = _interopRequireDefault(_followers);

var _following = __webpack_require__(1218);

var _following2 = _interopRequireDefault(_following);

var _forumData = __webpack_require__(416);

var _forumData2 = _interopRequireDefault(_forumData);

var _header = __webpack_require__(1221);

var _header2 = _interopRequireDefault(_header);

var _isDemoMode = __webpack_require__(533);

var _isDemoMode2 = _interopRequireDefault(_isDemoMode);

var _isLoaded = __webpack_require__(587);

var _isLoaded2 = _interopRequireDefault(_isLoaded);

var _isLoading = __webpack_require__(588);

var _isLoading2 = _interopRequireDefault(_isLoading);

var _locationHistory = __webpack_require__(1222);

var _locationHistory2 = _interopRequireDefault(_locationHistory);

var _members = __webpack_require__(1223);

var _members2 = _interopRequireDefault(_members);

var _message = __webpack_require__(589);

var _message2 = _interopRequireDefault(_message);

var _modal = __webpack_require__(534);

var _modal2 = _interopRequireDefault(_modal);

var _newPostMessage = __webpack_require__(1226);

var _newPostMessage2 = _interopRequireDefault(_newPostMessage);

var _notifications = __webpack_require__(1173);

var _notifications2 = _interopRequireDefault(_notifications);

var _pagination = __webpack_require__(590);

var _pagination2 = _interopRequireDefault(_pagination);

var _posts = __webpack_require__(1055);

var _posts2 = _interopRequireDefault(_posts);

var _profileForm = __webpack_require__(1230);

var _profileForm2 = _interopRequireDefault(_profileForm);

var _search = __webpack_require__(1231);

var _search2 = _interopRequireDefault(_search);

var _siteInfo = __webpack_require__(592);

var _siteInfo2 = _interopRequireDefault(_siteInfo);

var _sitePages = __webpack_require__(1056);

var _sitePages2 = _interopRequireDefault(_sitePages);

var _socketIo = __webpack_require__(1177);

var _socketIo2 = _interopRequireDefault(_socketIo);

var _categories = __webpack_require__(453);

var _categories2 = _interopRequireDefault(_categories);

var _textEditor = __webpack_require__(1233);

var _textEditor2 = _interopRequireDefault(_textEditor);

var _typing = __webpack_require__(1235);

var _typing2 = _interopRequireDefault(_typing);

var _users = __webpack_require__(535);

var _users2 = _interopRequireDefault(_users);

var _viewMode = __webpack_require__(593);

var _viewMode2 = _interopRequireDefault(_viewMode);

var _userAgent = __webpack_require__(1373);

var _userAgent2 = _interopRequireDefault(_userAgent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = (0, _redux.combineReducers)({
  appSettings: _appSettings2.default,
  auth: _auth2.default,
  breadcrumbsWidget: _breadcrumbsWidget2.default,
  comments: _comments2.default,
  communitiesContext: _communitiesContext2.default,
  commentEdit: _editedCommentId2.default,
  experiments: _experiments2.default,
  followers: _followers2.default,
  following: _following2.default,
  forumData: _forumData2.default,
  header: _header2.default,
  isDemoMode: _isDemoMode2.default,
  isLoaded: _isLoaded2.default,
  isLoading: _isLoading2.default,
  locationHistory: _locationHistory2.default,
  members: _members2.default,
  message: _message2.default,
  modal: _modal2.default,
  newPostMessage: _newPostMessage2.default,
  notifications: _notifications2.default,
  pagination: _pagination2.default,
  posts: _posts2.default,
  routing: _reactRouterRedux.routerReducer,
  search: _search2.default,
  siteInfo: _siteInfo2.default,
  sitePages: _sitePages2.default,
  socket: _socketIo2.default,
  categories: _categories2.default,
  textEditor: _textEditor2.default,
  typing: _typing2.default,
  users: _users2.default,
  userAgent: _userAgent2.default,
  viewMode: _viewMode2.default,
  form: _reduxForm.reducer.plugin({
    comment: _commentForm2.default,
    profile: _profileForm2.default
  }).normalize(formNormalizers)
});
var modalRootReducer = exports.modalRootReducer = (0, _redux.combineReducers)({
  auth: _auth2.default,
  appSettings: _appSettings2.default,
  communitiesContext: _communitiesContext2.default,
  experiments: _experiments2.default,
  forumData: _forumData2.default,
  modal: _modal2.default,
  routing: _reactRouterRedux.routerReducer,
  categories: _categories2.default,
  users: _users2.default,
  userAgent: _userAgent2.default,
  form: _reduxForm.reducer.normalize(formNormalizers)
});

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNavigation = undefined;

var _applications = __webpack_require__(25);

var _communitiesContextSelectors = __webpack_require__(47);

var _forumDataSelectors = __webpack_require__(457);

var _forum = __webpack_require__(1377);

var _forum2 = _interopRequireDefault(_forum);

var _forumWithMembersApp = __webpack_require__(1378);

var _forumWithMembersApp2 = _interopRequireDefault(_forumWithMembersApp);

var _forumWithMembersArea = __webpack_require__(1380);

var _forumWithMembersArea2 = _interopRequireDefault(_forumWithMembersArea);

var _forumWithMembersAreaRemoved = __webpack_require__(1382);

var _forumWithMembersAreaRemoved2 = _interopRequireDefault(_forumWithMembersAreaRemoved);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createNavigation = exports.createNavigation = function createNavigation(store) {
  var state = store.getState();
  if ((0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.MEMBERS_APP_ID).isInstalled) {
    return _forumWithMembersApp2.default;
  } else if ((0, _forumDataSelectors.getCommunityId)(state)) {
    return _forum2.default;
  } else if ((0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.SANTA_MEMBERS_APP_ID).isInstalled) {
    return _forumWithMembersArea2.default;
  } else {
    return _forumWithMembersAreaRemoved2.default;
  }
};

/***/ }),
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotifications = exports.getCount = undefined;

var _reselect = __webpack_require__(46);

var getById = function getById(state) {
  return state.notifications.byId;
};
var getIdList = function getIdList(state) {
  return state.notifications.idList;
};
var getCount = exports.getCount = function getCount(state) {
  return state.viewMode === 'editor' ? 5 : state.notifications.metadata.count;
};

var sortNotifications = function sortNotifications(notifications) {
  return notifications.sort(function (a, b) {
    if (!a.createdDate) {
      return 1;
    }
    return new Date(b.createdDate) - new Date(a.createdDate);
  });
};

var getNotifications = exports.getNotifications = (0, _reselect.createSelector)([getById, getIdList], function (byId, idList) {
  return sortNotifications(idList.map(function (id) {
    return byId[id];
  }));
});

/***/ }),
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE_VIDEO = exports.TYPE_IMAGE = undefined;
exports.default = uploadFile;

var _lodash = __webpack_require__(2);

var _lodash2 = _interopRequireDefault(_lodash);

var _dataurlToBlob = __webpack_require__(1812);

var _dataurlToBlob2 = _interopRequireDefault(_dataurlToBlob);

var _encodingOptions = __webpack_require__(1813);

var _encodingOptions2 = _interopRequireDefault(_encodingOptions);

var _requestCredentials = __webpack_require__(326);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_ENCODING_OPTIONS = new _encodingOptions2.default().setVideoFormats(['mp4', 'webm']).setAudioFormat('m4a').toFormParams();

var IMAGE_PROPERTIES = ['width', 'height', 'file_name', 'original_file_name'];

exports.TYPE_IMAGE = _requestCredentials.TYPE_IMAGE;
exports.TYPE_VIDEO = _requestCredentials.TYPE_VIDEO;
function uploadFile(file, type, _ref) {
  var uploadToken = _ref.uploadToken,
      uploadUrl = _ref.uploadUrl;

  var formData = new FormData();

  var blob = file;
  try {
    blob = (0, _dataurlToBlob2.default)(blob);
  } catch (e) {}

  formData.append('file', blob);
  formData.append('media_type', type);
  formData.append('upload_token', uploadToken);
  if (type === _requestCredentials.TYPE_VIDEO) {
    _lodash2.default.forEach(DEFAULT_ENCODING_OPTIONS, function (value, key) {
      return formData.append(key, value);
    });
  }

  var request = new XMLHttpRequest();
  var promise = new Promise(function (resolve, reject) {
    try {
      request.responseType = 'json'; // IE11 does not support responseType json
    } catch (error) {}
    request.addEventListener('load', function (event) {
      var data = event.target.response[0];
      try {
        data = JSON.parse(event.target.response)[0];
      } catch (error) {}

      if (type === _requestCredentials.TYPE_IMAGE) {
        data = _lodash2.default.pick(data, IMAGE_PROPERTIES);
      }

      resolve(data);
    });
    request.addEventListener('error', reject);
    request.open('POST', uploadUrl);
    request.send(formData);
  });

  return {
    xhr: request,
    promise: promise
  };
}

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wsMiddleware;

var _searchSocket = __webpack_require__(1176);

var _searchSocket2 = _interopRequireDefault(_searchSocket);

var _typingSocket = __webpack_require__(1101);

var _commentSocket = __webpack_require__(314);

var _categorySocket = __webpack_require__(260);

var _postSocket = __webpack_require__(591);

var _userSocket = __webpack_require__(78);

var _setCurrentUser = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var channels = {};
var socketActionCreators = {};

var getPayload = function getPayload(cb) {
  return function (msg) {
    return cb(msg.payload);
  };
};

socketActionCreators[_searchSocket.SOCKET_SEARCH_RESULTS_MESSAGE] = getPayload(_searchSocket2.default);
socketActionCreators[_typingSocket.SOCKET_TYPING_MESSAGE] = function (message) {
  return function (dispatch) {
    dispatch(getPayload(_typingSocket.removeTypingUserDebounced)(message));
    dispatch(getPayload(_typingSocket.addTypingUser)(message));
  };
};
socketActionCreators[_commentSocket.SOCKET_NEW_COMMENT] = getPayload(_commentSocket.newComment);
socketActionCreators[_categorySocket.SOCKET_NEW_POST] = getPayload(_categorySocket.newPost);
socketActionCreators[_categorySocket.SOCKET_UPDATE_POST_COUNTERS] = getPayload(_categorySocket.updatePostCounters);
socketActionCreators[_categorySocket.SOCKET_UPDATE_CATEGORY_COUNTERS] = getPayload(_categorySocket.updateCategoryCounters);
socketActionCreators[_postSocket.SOCKET_UPDATE_POST] = getPayload(_postSocket.updatePost);
socketActionCreators[_userSocket.SOCKET_NEW_NOTIFICATION] = getPayload(_userSocket.newNotification);
socketActionCreators[_userSocket.SOCKET_USER_PERMISSIONS_CHANGED] = getPayload(_userSocket.setUserPermissions);
socketActionCreators[_userSocket.SOCKET_USER_UPDATED] = getPayload(_setCurrentUser.setCurrentUser);

function wsMiddleware(wsClient, instanceId) {
  var channelPrefix = 'instance-' + instanceId + '/';
  return function (store) {
    return function (next) {
      return function (action) {
        var payload = {};

        switch (action.type) {
          case 'WS_JOIN':
            payload.channel = action.payload.channel;
            if (action.payload.channel.indexOf('user-') === -1) {
              payload.channel = '' + channelPrefix + action.payload.channel;
            }
            wsClient.queue('join', payload);
            channels[payload.channel] = wsClient.createListener(payload.channel);
            Object.keys(socketActionCreators).forEach(function (event) {
              channels[payload.channel].on(event, function (data) {
                store.dispatch(socketActionCreators[event](data));
              });
            });
            break;
          case 'WS_LEAVE':
            payload.channel = '' + channelPrefix + action.payload.channel;
            if (channels[payload.channel]) {
              channels[payload.channel].destroy();
              delete channels[payload.channel];
            }
            break;
          case 'WS_EMIT':
            payload.channel = '' + channelPrefix + action.payload.channel;
            payload.eventName = action.payload.eventName;
            payload.payload = action.payload.message;
            wsClient.queue('emit', payload);
            break;

          default:
            return next(action);
        }
      };
    };
  };
}

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uploadMiddleware;

var _upload = __webpack_require__(171);

var _cancelUploads = __webpack_require__(422);

function uploadMiddleware(uploadFile, requestCredentials, request) {
  var requests = [];
  var removeFinishedRequests = function removeFinishedRequests() {
    requests = requests.filter(function (xhr) {
      return xhr.readystate !== 4;
    });
  };

  return function (store) {
    return function (next) {
      return function (action) {
        switch (action.type) {
          case _upload.UPLOAD:
            {
              var _action$payload = action.payload,
                  file = _action$payload.file,
                  type = _action$payload.type,
                  onSuccess = _action$payload.onSuccess;


              return requestCredentials(request, type).then(function (credentials) {
                var _uploadFile = uploadFile(file, type, credentials),
                    xhr = _uploadFile.xhr,
                    promise = _uploadFile.promise;

                requests.push(xhr);
                return promise;
              }).then(function (file) {
                return store.dispatch(onSuccess(file));
              }).then(removeFinishedRequests).catch(removeFinishedRequests);
            }

          case _cancelUploads.CANCEL_UPLOADS:
            {
              requests.forEach(function (xhr) {
                xhr.abort();
              });
              requests = [];
              return Promise.resolve();
            }

          default:
            return next(action);
        }
      };
    };
  };
}

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wsClient", [], factory);
	else if(typeof exports === 'object')
		exports["wsClient"] = factory();
	else
		root["wsClient"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var uuid = __webpack_require__(1);
	
	module.exports = function wsClient(_ref) {
	  var wsUrl = _ref.wsUrl,
	      token = _ref.token;
	
	  if (!wsUrl) {
	    throw new Error('wsUrl must be provided');
	  }
	  if (!token) {
	    throw new Error('token must be provided');
	  }
	
	  var pingInterval = 30000;
	  var connecting = void 0;
	  var ready = void 0;
	  var sessionId = void 0;
	  var ws = void 0;
	  var errorCount = 0;
	  var pingTimeoutFn = void 0;
	  var evs = [];
	  var processTimeout = void 0;
	  wsUrl = wsUrl.replace('http://', 'ws://').replace('https://', 'wss://');
	  var inNode = typeof window === 'undefined';
	  var WebSocket = inNode ? global.WebSocket : window.WebSocket;
	
	  var messageEventHandlers = {};
	  var presenceEventHandlers = {};
	  var infoEventHandlers = {};
	  var closeEventHandlers = { close: [] };
	  var systemEventHandlers = {
	    connected: [], ack: [], pong: [], unauthorized: [], error: []
	  };
	
	  function randomId() {
	    return uuid.v4();
	  }
	
	  function onOpen(cb) {
	    ws.onopen = function () {
	      return cb();
	    };
	  }
	
	  function attachEventHandlers() {
	    ws.onmessage = function (event) {
	      var message = JSON.parse(event.data);
	      var systemEvents = Object.keys(systemEventHandlers);
	      if (systemEvents.indexOf(message.type) !== -1) {
	        systemEventHandlers[message.type].forEach(function (handler) {
	          handler.fn(message);
	        });
	      } else if (message.type === 'message') {
	        var channel = message.channel;
	        if (messageEventHandlers[channel] && messageEventHandlers[channel][message.eventName]) {
	          messageEventHandlers[channel][message.eventName].forEach(function (handler) {
	            handler(message);
	          });
	        }
	        channel.split('/').reduce(function (prev, curr) {
	          if (messageEventHandlers[prev] && messageEventHandlers[prev][message.eventName]) {
	            messageEventHandlers[prev][message.eventName].forEach(function (handler) {
	              handler(message);
	            });
	          }
	          return prev + '/' + curr;
	        });
	      } else if (message.type === 'presence') {
	        var _channel = message.channel;
	        if (presenceEventHandlers[_channel]) {
	          presenceEventHandlers[_channel].forEach(function (handler) {
	            handler(message);
	          });
	        }
	      } else if (message.type === 'info') {
	        var _channel2 = message.data.channel;
	        if (infoEventHandlers[_channel2]) {
	          infoEventHandlers[_channel2].forEach(function (handler) {
	            handler(message);
	          });
	        }
	      } else if (message.type === 'error') {
	        if (systemEventHandlers.error) {
	          systemEventHandlers.error.forEach(function (handler) {
	            handler.fn(message);
	          });
	        }
	      }
	    };
	  }
	
	  function onAck(id, callback) {
	    systemEventHandlers.ack.push({
	      id: id, fn: function fn(msg) {
	        if (msg.id === id) {
	          callback(msg);
	        }
	      }
	    });
	  }
	
	  function offAck(id) {
	    var index = systemEventHandlers.ack.findIndex(function (item) {
	      return item.id === id;
	    });
	    if (index !== -1) {
	      systemEventHandlers.ack.splice(index, 1);
	    }
	  }
	
	  function onConnected(callback) {
	    systemEventHandlers.connected.push({ fn: function fn(msg) {
	        return callback(msg);
	      } });
	  }
	
	  function onPong(id, callback) {
	    systemEventHandlers.pong.push({
	      id: id, fn: function fn(msg) {
	        if (msg.id === id) {
	          callback(msg);
	        }
	      }
	    });
	  }
	
	  function offPong(id) {
	    var index = systemEventHandlers.pong.findIndex(function (item) {
	      return item.id === id;
	    });
	    if (index !== -1) {
	      systemEventHandlers.pong.splice(index, 1);
	    }
	  }
	
	  function connect() {
	    ready = false;
	    if (errorCount > 50 || connecting) {
	      return;
	    }
	
	    connecting = true;
	    ws = new WebSocket(wsUrl + '?token=' + token + '&sessionId=' + (sessionId || ''));
	    attachEventHandlers();
	    ws.onerror = function (error) {
	      errorCount++;
	      connecting = false;
	      if (systemEventHandlers.error) {
	        systemEventHandlers.error.forEach(function (handler) {
	          return handler.fn(error);
	        });
	      }
	      clearTimeout(pingTimeoutFn);
	      setTimeout(function () {
	        return connect();
	      }, 100 * errorCount);
	    };
	    onOpen(function () {
	      onConnected(function (msg) {
	        errorCount = 0;
	        sessionId = msg.sessionId;
	        ready = true;
	        connecting = false;
	        clearTimeout(pingTimeoutFn);
	        pingTimeoutFn = setTimeout(function () {
	          return ping();
	        }, pingInterval);
	      });
	    });
	  }
	
	  function initHandlers(channel) {
	    if (!messageEventHandlers[channel]) {
	      messageEventHandlers[channel] = {};
	    }
	    if (!presenceEventHandlers[channel]) {
	      presenceEventHandlers[channel] = [];
	    }
	    if (!infoEventHandlers[channel]) {
	      infoEventHandlers[channel] = [];
	    }
	  }
	
	  function addMessageHandler(_ref2) {
	    var channel = _ref2.channel,
	        eventName = _ref2.eventName,
	        callback = _ref2.callback;
	
	    if (!messageEventHandlers[channel][eventName]) {
	      messageEventHandlers[channel][eventName] = [];
	    }
	    messageEventHandlers[channel][eventName].push(callback);
	  }
	
	  function addPresenceHandler(_ref3) {
	    var channel = _ref3.channel,
	        callback = _ref3.callback;
	
	    presenceEventHandlers[channel].push(callback);
	  }
	
	  function addInfoHandler(_ref4) {
	    var channel = _ref4.channel,
	        callback = _ref4.callback;
	
	    infoEventHandlers[channel].push(callback);
	  }
	
	  function ping() {
	    if (ws.readyState !== ws.OPEN && ws.readyState !== ws.CONNECTING) {
	      connect();
	    }
	    if (!ready) {
	      clearTimeout(pingTimeoutFn);
	      pingTimeoutFn = setTimeout(function () {
	        return ping();
	      }, 50);
	      return;
	    }
	
	    var id = randomId();
	    ws.send(JSON.stringify({ type: 'ping', id: id }));
	    onPong(id, function () {
	      offPong(id);
	      clearTimeout(pingTimeoutFn);
	      pingTimeoutFn = setTimeout(function () {
	        return ping();
	      }, pingInterval);
	    });
	  }
	
	  function close() {
	    closeEventHandlers.close.forEach(function (handler) {
	      return handler();
	    });
	    messageEventHandlers = {};
	    presenceEventHandlers = {};
	    infoEventHandlers = {};
	    systemEventHandlers = {};
	    closeEventHandlers = {};
	    return ws.close();
	  }
	
	  function createListener(channel) {
	    initHandlers(channel);
	    return {
	      on: function on(eventName, callback) {
	        return addMessageHandler({ channel: channel, eventName: eventName, callback: callback });
	      },
	      onPresence: function onPresence(callback) {
	        return addPresenceHandler({ channel: channel, callback: callback });
	      },
	      onInfo: function onInfo(callback) {
	        return addInfoHandler({ channel: channel, callback: callback });
	      },
	      leave: function leave() {
	        queue('leave', { channel: channel });
	        delete messageEventHandlers[channel];
	        delete presenceEventHandlers[channel];
	        delete infoEventHandlers[channel];
	      },
	      emit: function emit(eventName, payload) {
	        queue('emit', { eventName: eventName, channel: channel, payload: payload });
	      },
	      // @TODO: remove once released and forum code updated not to use .destroy()
	      destroy: function destroy() {
	        queue('leave', { channel: channel });
	        delete messageEventHandlers[channel];
	        delete presenceEventHandlers[channel];
	        delete infoEventHandlers[channel];
	      }
	    };
	  }
	
	  function queue(event, payload) {
	    var ev = void 0;
	    if (event === 'join') {
	      ev = { type: 'subscribe', channel: payload.channel };
	    } else if (event === 'emit') {
	      ev = { type: 'publish', eventName: payload.eventName, channel: payload.channel, payload: payload.payload };
	    } else if (event === 'leave') {
	      ev = { type: 'unsubscribe', channel: payload.channel };
	    } else if (event === 'presence') {
	      ev = { type: 'presence', payload: payload };
	    }
	    ev.id = randomId();
	    evs.push(ev);
	    processQueue();
	    return ev.id;
	  }
	
	  function processQueue() {
	    clearTimeout(processTimeout);
	
	    if (evs.length < 1) {
	      return;
	    }
	    if (ws.readyState !== ws.OPEN) {
	      connect();
	    }
	    if (!ready) {
	      processTimeout = setTimeout(function () {
	        return processQueue();
	      }, 50);
	      return;
	    }
	
	    var ev = evs.shift();
	
	    if (ev) {
	      ws.send(JSON.stringify(ev));
	
	      onAck(ev.id, function () {
	        offAck(ev.id);
	        processQueue();
	      });
	    }
	  }
	
	  function join(channel) {
	    queue('join', { channel: channel });
	    return createListener(channel);
	  }
	
	  function onError(callback) {
	    systemEventHandlers.error.push({ fn: callback });
	  }
	
	  function onClose(callback) {
	    closeEventHandlers.close.push(callback);
	  }
	
	  function onAuthRequired(callback) {
	    systemEventHandlers.unauthorized.push({ fn: callback });
	  }
	
	  connect();
	
	  return {
	    close: close,
	    createListener: createListener,
	    queue: queue,
	    join: join,
	    onError: onError,
	    onClose: onClose,
	    onAuthRequired: onAuthRequired,
	    onConnect: onConnected
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(2);
	var v4 = __webpack_require__(5);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(3);
	var bytesToUuid = __webpack_require__(4);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(3);
	var bytesToUuid = __webpack_require__(4);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ })
/******/ ])
});
;
//# sourceMappingURL=ws-client.es5.js.map

/***/ }),
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _setUserAgent = __webpack_require__(1236);

var userAgent = function userAgent() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _setUserAgent.SET_USER_AGENT:
      return _extends({}, state, payload);
    default:
      return state;
  }
};

exports.default = userAgent;

/***/ }),
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _reactRedux = __webpack_require__(5);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _navigateToSection = __webpack_require__(421);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Link: _internalLink2.default,
  MembersLink: (0, _reactRedux.connect)(function () {
    return { to: '/members' };
  })(_internalLink2.default),
  ProfileLink: (0, _reactRedux.connect)(function (state, _ref) {
    var user = _ref.user;
    return { to: '/profiles/' + (0, _lodash.get)(user, 'slug') };
  })(_internalLink2.default),
  FollowingLink: (0, _reactRedux.connect)(function (state, _ref2) {
    var user = _ref2.user;
    return { to: '/profiles/' + (0, _lodash.get)(user, 'slug') + '/following' };
  })(_internalLink2.default),
  FollowersLink: (0, _reactRedux.connect)(function (state, _ref3) {
    var user = _ref3.user;
    return { to: '/profiles/' + (0, _lodash.get)(user, 'slug') + '/followers' };
  })(_internalLink2.default),
  SettingsLink: (0, _reactRedux.connect)(function (state, _ref4) {
    var user = _ref4.user;
    return { to: '/profiles/' + (0, _lodash.get)(user, 'slug') + '/settings' };
  })(_internalLink2.default),
  NotificationsLink: (0, _reactRedux.connect)(function () {
    return { to: '/notifications' };
  })(_internalLink2.default),
  navigateToMembers: function navigateToMembers() {
    return (0, _navigateToSection.navigateToForum)('/members');
  },
  navigateToProfile: function navigateToProfile(user) {
    return (0, _navigateToSection.navigateToForum)('/profiles/' + (0, _lodash.get)(user, 'slug'));
  },
  navigateToProfileSettings: function navigateToProfileSettings(user) {
    return (0, _navigateToSection.navigateToForum)('/profiles/' + (0, _lodash.get)(user, 'slug') + '/settings');
  },
  navigateToNotifications: function navigateToNotifications() {
    return (0, _navigateToSection.navigateToForum)('/notifications');
  },
  navigateToEditPost: function navigateToEditPost(location) {
    return (0, _navigateToSection.navigateToForum)(location);
  },
  navigateToCreatePost: _lodash.noop,
  navigateToMyDrafts: _lodash.noop
};

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _reactRedux = __webpack_require__(5);

var _applications = __webpack_require__(25);

var _link = __webpack_require__(1379);

var _communitiesContextSelectors = __webpack_require__(47);

var _navigateToSection = __webpack_require__(421);

exports.default = {
  Link: _link.InternalLink,
  MembersLink: (0, _reactRedux.connect)(function (state) {
    return {
      appDefinitionId: _applications.MEMBERS_APP_ID,
      sectionId: 'members',
      sectionUrl: (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.MEMBERS_APP_ID).sectionUrl,
      to: '/'
    };
  })(_link.ExternalLink),
  ProfileLink: (0, _reactRedux.connect)(function (state, _ref) {
    var user = _ref.user;
    return {
      appDefinitionId: _applications.MEMBERS_APP_ID,
      sectionId: 'members',
      sectionUrl: (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.MEMBERS_APP_ID).sectionUrl,
      to: '/' + (0, _lodash.get)(user, 'slug')
    };
  })(_link.ExternalLink),
  FollowingLink: (0, _reactRedux.connect)(function (state, _ref2) {
    var user = _ref2.user;
    return {
      appDefinitionId: _applications.MEMBERS_APP_ID,
      sectionId: 'members',
      sectionUrl: (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.MEMBERS_APP_ID).sectionUrl,
      to: '/' + (0, _lodash.get)(user, 'slug') + '/following'
    };
  })(_link.ExternalLink),
  FollowersLink: (0, _reactRedux.connect)(function (state, _ref3) {
    var user = _ref3.user;
    return {
      appDefinitionId: _applications.MEMBERS_APP_ID,
      sectionId: 'members',
      sectionUrl: (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.MEMBERS_APP_ID).sectionUrl,
      to: '/' + (0, _lodash.get)(user, 'slug') + '/followers'
    };
  })(_link.ExternalLink),
  SettingsLink: (0, _reactRedux.connect)(function (state, _ref4) {
    var user = _ref4.user;
    return {
      appDefinitionId: _applications.MEMBERS_APP_ID,
      sectionId: 'members',
      sectionUrl: (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.MEMBERS_APP_ID).sectionUrl,
      to: '/' + (0, _lodash.get)(user, 'slug') + '/settings'
    };
  })(_link.ExternalLink),
  NotificationsLink: (0, _reactRedux.connect)(function (state) {
    return {
      appDefinitionId: _applications.MEMBERS_APP_ID,
      sectionId: 'members',
      sectionUrl: (0, _communitiesContextSelectors.getApplicationConfig)(state, _applications.MEMBERS_APP_ID).sectionUrl,
      to: '/notifications'
    };
  })(_link.ExternalLink),
  navigateToMembers: function navigateToMembers() {
    return (0, _navigateToSection.navigateToMembers)('/');
  },
  navigateToProfile: function navigateToProfile(user) {
    return (0, _navigateToSection.navigateToMembers)('/' + (0, _lodash.get)(user, 'slug'));
  },
  navigateToProfileSettings: function navigateToProfileSettings(user) {
    return (0, _navigateToSection.navigateToMembers)('/' + (0, _lodash.get)(user, 'slug') + '/settings');
  },
  navigateToNotifications: function navigateToNotifications() {
    return (0, _navigateToSection.navigateToMembers)('/notifications');
  },
  navigateToEditPost: function navigateToEditPost(location) {
    return (0, _navigateToSection.navigateToForum)(location);
  },
  navigateToCreatePost: function navigateToCreatePost() {
    return (0, _navigateToSection.navigateToBlog)('/create-post');
  },
  navigateToMyDrafts: function navigateToMyDrafts(user) {
    return (0, _navigateToSection.navigateToMembers)('/' + user.slug + '/blog-drafts');
  }
};

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _externalLink = __webpack_require__(541);

Object.defineProperty(exports, 'ExternalLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_externalLink).default;
  }
});

var _internalLink = __webpack_require__(126);

Object.defineProperty(exports, 'InternalLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_internalLink).default;
  }
});

var _membersAreaLink = __webpack_require__(1004);

Object.defineProperty(exports, 'MembersAreaLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_membersAreaLink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _reactRedux = __webpack_require__(5);

var _applications = __webpack_require__(25);

var _forUserPrivacyType = __webpack_require__(1381);

var _forUserPrivacyType2 = _interopRequireDefault(_forUserPrivacyType);

var _externalLink = __webpack_require__(541);

var _externalLink2 = _interopRequireDefault(_externalLink);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _noopLink = __webpack_require__(601);

var _noopLink2 = _interopRequireDefault(_noopLink);

var _membersAreaLink = __webpack_require__(1004);

var _membersAreaLink2 = _interopRequireDefault(_membersAreaLink);

var _navigateToSection = __webpack_require__(421);

var _wixSdkPolyfill = __webpack_require__(8);

var _wixSdkPolyfill2 = _interopRequireDefault(_wixSdkPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEMBERS_SECTION_APP_ID = '14dbefd2-01b4-fb61-32a7-3abd44da4908';
var SETTINGS_SECTION_APP_ID = '14f25dc5-6af3-5420-9568-f9c5ed98c9b1';
var NOTIFICATIONS_SECTION_APP_ID = '14f25924-5664-31b2-9568-f9c5ed98c9b1';

exports.default = {
  Link: _internalLink2.default,
  MembersLink: (0, _reactRedux.connect)(function () {
    return {
      appDefinitionId: MEMBERS_SECTION_APP_ID,
      sectionId: 'all_members',
      to: '/',
      renderHref: false
    };
  })(_externalLink2.default),
  ProfileLink: (0, _reactRedux.connect)(undefined, function (dispatch, _ref) {
    var user = _ref.user;
    return {
      onClick: function onClick(event) {
        event.preventDefault();
        event.stopPropagation();

        _wixSdkPolyfill2.default.getPublicAPI({ appDefinitionId: _applications.SANTA_MEMBERS_APP_ID }, function (api) {
          api.navigateToMember({
            memberId: (0, _lodash.get)(user, 'siteMemberId')
          }, console.error);
        }, console.error);
      }
    };
  })((0, _forUserPrivacyType2.default)(_membersAreaLink2.default)),
  FollowingLink: _noopLink2.default,
  FollowersLink: _noopLink2.default,
  SettingsLink: (0, _reactRedux.connect)(function () {
    return {
      appDefinitionId: SETTINGS_SECTION_APP_ID,
      sectionId: 'settings',
      to: '/',
      renderHref: false
    };
  })(_externalLink2.default),
  NotificationsLink: (0, _reactRedux.connect)(function () {
    return {
      appDefinitionId: NOTIFICATIONS_SECTION_APP_ID,
      sectionId: 'notifications',
      to: '/',
      renderHref: false
    };
  })(_externalLink2.default),
  navigateToMembers: function navigateToMembers() {
    return _wixSdkPolyfill2.default.Utils.navigateToSection({
      appDefinitionId: MEMBERS_SECTION_APP_ID,
      sectionId: 'all_members',
      shouldRefreshIframe: false
    }, '');
  },
  navigateToProfile: function navigateToProfile(user) {
    return _wixSdkPolyfill2.default.getPublicAPI({ appDefinitionId: _applications.SANTA_MEMBERS_APP_ID }, function (api) {
      api.navigateToMember({
        memberId: (0, _lodash.get)(user, 'siteMemberId')
      }, console.error);
    }, console.error);
  },
  navigateToProfileSettings: function navigateToProfileSettings() {
    return _wixSdkPolyfill2.default.Utils.navigateToSection({
      appDefinitionId: SETTINGS_SECTION_APP_ID,
      sectionId: 'settings',
      shouldRefreshIframe: false
    }, '');
  },
  navigateToNotifications: function navigateToNotifications() {
    return _wixSdkPolyfill2.default.Utils.navigateToSection({
      appDefinitionId: NOTIFICATIONS_SECTION_APP_ID,
      sectionId: 'notifications',
      shouldRefreshIframe: false
    }, '');
  },
  navigateToEditPost: function navigateToEditPost(location) {
    return (0, _navigateToSection.navigateToForum)(location);
  },
  navigateToCreatePost: function navigateToCreatePost() {
    return (0, _navigateToSection.navigateToBlog)('/create-post');
  },
  navigateToMyDrafts: function navigateToMyDrafts(user) {
    return _wixSdkPolyfill2.default.getPublicAPI({ appDefinitionId: _applications.SANTA_MEMBERS_APP_ID }, function (api) {
      api.navigateToSection({
        appDefinitionId: _applications.BLOG_APP_ID,
        appPageId: 'member-drafts-page',
        viewedUser: (0, _lodash.get)(user, 'siteMemberId')
      }, console.error);
    }, console.error);
  }
};

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(2);

var _userPrivacyStatus = __webpack_require__(290);

var _noopLink = __webpack_require__(601);

var _noopLink2 = _interopRequireDefault(_noopLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forUserPrivacyType = function forUserPrivacyType(PublicUserComponent) {
  var PrivateUserComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _noopLink2.default;

  return function (props) {
    return (0, _lodash.get)(props, 'user.privacyStatus') === _userPrivacyStatus.USER_PRIVACY_STATUS_PRIVATE ? _react2.default.createElement(PrivateUserComponent, props) : _react2.default.createElement(PublicUserComponent, props);
  };
};

exports.default = forUserPrivacyType;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(2);

var _internalLink = __webpack_require__(126);

var _internalLink2 = _interopRequireDefault(_internalLink);

var _noopLink = __webpack_require__(601);

var _noopLink2 = _interopRequireDefault(_noopLink);

var _navigateToSection = __webpack_require__(421);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Link: _internalLink2.default,
  MembersLink: _noopLink2.default,
  ProfileLink: _noopLink2.default,
  FollowingLink: _noopLink2.default,
  FollowersLink: _noopLink2.default,
  SettingsLink: _noopLink2.default,
  NotificationsLink: _noopLink2.default,
  navigateToMembers: _lodash.noop,
  navigateToProfile: _lodash.noop,
  navigateToProfileSettings: _lodash.noop,
  navigateToNotifications: _lodash.noop,
  navigateToEditPost: function navigateToEditPost(location) {
    return (0, _navigateToSection.navigateToForum)(location);
  },
  navigateToCreatePost: function navigateToCreatePost() {
    return (0, _navigateToSection.navigateToBlog)('/create-post');
  },
  navigateToMyDrafts: _lodash.noop
};

/***/ }),
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLoaded = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _reactDom = __webpack_require__(14);

var _reactRedux = __webpack_require__(5);

var _applicationLoaded = __webpack_require__(1086);

var _appLifecycleService = __webpack_require__(170);

var appLifecycleService = _interopRequireWildcard(_appLifecycleService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BACKGROUND_IMG_REGEX = /^url\("(.+)"\)$/;

var AppLoaded = exports.AppLoaded = function (_Component) {
  _inherits(AppLoaded, _Component);

  function AppLoaded() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppLoaded);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppLoaded.__proto__ || Object.getPrototypeOf(AppLoaded)).call.apply(_ref, [this].concat(args))), _this), _this.handleImageLoad = function (event) {
      var images = _this.pendingImages;
      var index = images.indexOf(event.target);
      _this.pendingImages = [].concat(_toConsumableArray(images.slice(0, index)), _toConsumableArray(images.slice(index + 1, images.length)));
      _this.triggerAppLoadedIfNeeded();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppLoaded, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: 'componentWilReceiveProps',
    value: function componentWilReceiveProps(_ref2) {
      var key = _ref2.key;

      if (this.props.key !== key) {
        this.cleanUp();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref3) {
      var key = _ref3.key;

      if (this.props.key !== key) {
        this.init();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cleanUp();
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        // Ensures that masonry is rendered
        appLifecycleService.appLoadedBeforeImages({ logInSdk: true });
        var selector = _this2.props.selector;

        _this2.pendingImages = selector ? [].concat(_toConsumableArray(_this2.getImages(selector)), _toConsumableArray(_this2.getBackgroundImages(selector))) : [];
        _this2.pendingImages.forEach(function (image) {
          return image.addEventListener('load', _this2.handleImageLoad);
        });
        _this2.triggerAppLoadedIfNeeded();
      });
    }
  }, {
    key: 'cleanUp',
    value: function cleanUp() {
      var _this3 = this;

      clearTimeout(this.timeout);
      (this.pendingImages || []).forEach(function (image) {
        return image.removeEventListener('load', _this3.handleImageLoad);
      });
    }
  }, {
    key: 'getImages',
    value: function getImages(selector) {
      var _this4 = this;

      return (0, _lodash.map)(this.getParent().querySelectorAll(selector + ' img'), function (imageElement) {
        return _this4.createImage(imageElement.src);
      });
    }
  }, {
    key: 'getBackgroundImages',
    value: function getBackgroundImages(selector) {
      var _this5 = this;

      return (0, _lodash.chain)(this.getParent().querySelectorAll(selector + ' [role=img]')).filter(function (element) {
        return BACKGROUND_IMG_REGEX.test(element.style.backgroundImage);
      }).map(function (imageElement) {
        return _this5.createImage(BACKGROUND_IMG_REGEX.exec(imageElement.style.backgroundImage)[1]);
      }).value();
    }
  }, {
    key: 'createImage',
    value: function createImage(src) {
      var img = new Image();
      img.src = src;
      return img;
    }
  }, {
    key: 'getParent',
    value: function getParent() {
      var parent = this.props.parent;

      return parent ? (0, _reactDom.findDOMNode)(parent) : document;
    }
  }, {
    key: 'triggerAppLoadedIfNeeded',
    value: function triggerAppLoadedIfNeeded() {
      if (!this.pendingImages.length) {
        this.props.applicationLoaded();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return AppLoaded;
}(_react.Component);

AppLoaded.propTypes = {
  parent: _propTypes2.default.object,
  selector: _propTypes2.default.string,
  key: _propTypes2.default.any,
  applicationLoaded: _propTypes2.default.func
};

var mapDispatchToProps = {
  applicationLoaded: _applicationLoaded.applicationLoaded
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(AppLoaded);

/***/ }),
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _withTranslate = __webpack_require__(4);

var _withTranslate2 = _interopRequireDefault(_withTranslate);

var _iconButton = __webpack_require__(1181);

var _iconButton2 = _interopRequireDefault(_iconButton);

var _notificationIcon = __webpack_require__(1481);

var _notificationIcon2 = _interopRequireDefault(_notificationIcon);

var _notificationSelectors = __webpack_require__(1301);

var _notificationButton = __webpack_require__(1482);

var _notificationButton2 = _interopRequireDefault(_notificationButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NotificationButton = function NotificationButton(_ref) {
  var bubbleClassName = _ref.bubbleClassName,
      className = _ref.className,
      count = _ref.count,
      t = _ref.t,
      otherProps = _objectWithoutProperties(_ref, ['bubbleClassName', 'className', 'count', 't']);

  var bubbleCssClass = (0, _classnames2.default)(_notificationButton2.default.bubble, 'notification-button__bubble', bubbleClassName);

  return _react2.default.createElement(
    _iconButton2.default,
    _extends({
      className: (0, _classnames2.default)('notification-button', className),
      icon: _notificationIcon2.default,
      label: t('breadcrumbs.notifications'),
      'aria-label': t('breadcrumbs.notifications')
    }, (0, _lodash.omit)(otherProps, 'dispatch')),
    count ? _react2.default.createElement(
      'span',
      { className: bubbleCssClass, 'data-hook': 'notification-bubble' },
      count
    ) : null
  );
};

NotificationButton.propTypes = {
  count: _propTypes2.default.number.isRequired,
  bubbleClassName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  t: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    count: (0, _notificationSelectors.getCount)(state)
  };
};

exports.default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps), _withTranslate2.default)(NotificationButton);

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _iconButton = __webpack_require__(1480);

var _iconButton2 = _interopRequireDefault(_iconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconButton = function IconButton(_ref) {
  var Component = _ref.component,
      className = _ref.className,
      Icon = _ref.icon,
      iconClassName = _ref.iconClassName,
      label = _ref.label,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['component', 'className', 'icon', 'iconClassName', 'label', 'children']);

  return _react2.default.createElement(
    Component,
    _extends({ className: (0, _classnames2.default)(_iconButton2.default.button, className) }, otherProps),
    _react2.default.createElement(
      'span',
      { className: _iconButton2.default.wrapper },
      _react2.default.createElement(Icon, { className: iconClassName }),
      _react2.default.createElement(
        'span',
        { className: _iconButton2.default.label },
        label
      )
    ),
    children
  );
};

IconButton.propTypes = {
  component: _propTypes2.default.any,
  className: _propTypes2.default.string,
  icon: _propTypes2.default.func.isRequired,
  iconClassName: _propTypes2.default.string,
  label: _propTypes2.default.string,
  children: _propTypes2.default.node
};

IconButton.defaultProps = {
  component: 'button'
};

exports.default = IconButton;

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_1yNs7","wrapper":"_2d3ll","label":"_2bz7-","bubble":"zMtYa"};

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationIcon = function NotificationIcon(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "16", viewBox: "0 0 12 16" }, props),
    _react2.default.createElement("path", {
      id: "notifications_icon",
      "data-name": "notifications icon",
      d: "M843.692,250.454H842.71v-4.8a4.776,4.776,0,0,0-3.865-4.722,0.484,0.484,0,0,0,0-.077,0.848,0.848,0,1,0-1.7,0,0.409,0.409,0,0,0,0,.077,4.781,4.781,0,0,0-3.868,4.722v4.8h-0.982a0.317,0.317,0,0,0-.313.322v1.707a0.317,0.317,0,0,0,.313.322h11.38a0.318,0.318,0,0,0,.313-0.322v-1.707A0.312,0.312,0,0,0,843.692,250.454ZM837.947,256a1.983,1.983,0,0,0,1.826-2.112h-3.651A1.983,1.983,0,0,0,837.947,256Z",
      transform: "translate(-832 -240)"
    })
  );
};

exports.default = NotificationIcon;

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bubble":"_24wg3"};

/***/ }),
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */
/***/ (function(module, exports) {

module.exports = function (dataURL) {

    'use strict';

    if (!window || window.window !== window) {
        throw new Error('This module is only available in browser');
    }

    var Blob = window.Blob || window.MozBlob || window.WebKitBlob;
    if (!Blob) {
        throw new Error('Blob was not supported');
    }

    var dataURLPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;

    // parse the dataURL components as per RFC 2397
    var matches = dataURL.match(dataURLPattern);
    if (!matches) {
        throw new Error('invalid dataURI');
    }

    // default to text/plain;charset=utf-8
    var mediaType = matches[2]
        ? matches[1]
        : 'text/plain' + (matches[3] || ';charset=utf-8');

    var isBase64   = !!matches[4];
    var dataString = dataURL.slice(matches[0].length);
    var byteString = isBase64
        // convert base64 to raw binary data held in a string
        ? atob(dataString)
        // convert base64/URLEncoded data component to raw binary
        : decodeURIComponent(dataString);

    var array = [];
    for (var i = 0; i < byteString.length; i++) {
        array.push(byteString.charCodeAt(i));
    }

    return new Blob([new Uint8Array(array)], { type: mediaType });
};



/***/ }),
/* 1813 */
/***/ (function(module, exports) {

/**
 * @constructor
 */
function EncodingOptions () {

    /**
     * @type {Array<string>}
     */
    this.videoFormats = []; //'mp4', 'webm', 'ogv'

    /**
     * @type {boolean}
     */
    this.skipAudio = null;

    /**
     * @type {boolean}
     */
    this.extractAudio = null;

    /**
     * @type {string}
     */
    this.audioFormat = null; //'mp3', 'm4a', 'ogg'

    /**
     * @type {string}
     */
    this.imageFormat = null; //'jpg', 'png'
}

/**
 * @param {Array<string>} formats
 * @returns {EncodingOptions}
 */
EncodingOptions.prototype.setVideoFormats = function (formats) {
    this.videoFormats = formats;
    return this;
};

/**
 * @param {boolean} skipAudio
 * @returns {EncodingOptions}
 */
EncodingOptions.prototype.setSkipAudio = function (skipAudio) {
    this.skipAudio = skipAudio;
    return this;
};

/**
 * @param {boolean} extractAudio
 * @returns {EncodingOptions}
 */
EncodingOptions.prototype.setExtractAudio = function (extractAudio) {
    this.extractAudio = extractAudio;
    return this;
};

/**
 * @param {string} format
 * @returns {EncodingOptions}
 */
EncodingOptions.prototype.setAudioFormat = function (format) {
    this.audioFormat = format;
    return this;
};

/**
 * @param {string} format
 * @returns {EncodingOptions}
 */
EncodingOptions.prototype.setImageFormat = function (format) {
    this.imageFormat = format;
    return this;
};

/**
 * @returns {{}}
 */
EncodingOptions.prototype.toFormParams = function () {

    var params = {};

    if (this.videoFormats && this.videoFormats.length > 0) {

        if (!params.video) {
            params.video = {};
        }

        params.video.format = this.videoFormats;
    }

    if (this.skipAudio) {

        if (!params.video) {
            params.video = {};
        }

        params.video.skip_audio = this.skipAudio;
    }

    if (this.extractAudio) {

        if (!params.video) {
            params.video = {};
        }

        params.video.extract_audio = this.extractAudio;
    }

    if (this.audioFormat) {

        if (!params.audio) {
            params.audio = {};
        }

        params.audio.format = this.audioFormat;
    }

    if (this.imageFormat) {

        if (!params.image) {
            params.image = {};
        }

        params.image.format = this.imageFormat;
    }

    return {
        encoding_options: JSON.stringify({file_output: params})
    }
};

/**
 * @type {EncodingOptions}
 */
module.exports = EncodingOptions;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// commons.bundle.min.js